import { FontAwesomeIcon as Ne } from "@fortawesome/react-fontawesome";
import * as D from "react";
import y, { useCallback as Me, createContext as ln, useMemo as yn, createElement as K, useContext as Re, forwardRef as Ee, Children as io, isValidElement as La, cloneElement as df, Fragment as Pg, useEffect as _e, useRef as he, useState as ue, useLayoutEffect as gl, useReducer as P4, Component as oR, useDebugValue as aR, lazy as A4, Suspense as R4, PureComponent as sR } from "react";
import * as lR from "react-dom";
import Ag, { flushSync as pf, createPortal as hf } from "react-dom";
var cR = {
  prefix: "fas",
  iconName: "trash-can",
  icon: [448, 512, [61460, "trash-alt"], "f2ed", "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"]
}, Jae = {
  prefix: "fas",
  iconName: "message",
  icon: [512, 512, ["comment-alt"], "f27a", "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"]
}, uR = {
  prefix: "fas",
  iconName: "chevrons-left",
  icon: [512, 512, ["chevron-double-left"], "f323", "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192zm384-192l-192 192c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 470.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"]
}, fR = {
  prefix: "fas",
  iconName: "house-building",
  icon: [640, 512, [], "e1b1", "M368 0c-26.5 0-48 21.5-48 48V153.9l64 58.7V208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H413.2c1.9 6.8 2.8 13.9 2.8 21.1V288h16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H416V464c0 18-6 34.6-16 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368zM512 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V208zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16zM400 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V112zM0 277.1V464c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V277.1c0-13.5-5.6-26.3-15.6-35.4l-144-132c-18.4-16.8-46.5-16.8-64.9 0l-144 132C5.6 250.8 0 263.7 0 277.1zM144 296c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H168c-13.3 0-24-10.7-24-24V296z"]
}, dR = {
  prefix: "fas",
  iconName: "pencil",
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
}, pR = {
  prefix: "fas",
  iconName: "lightbulb",
  icon: [384, 512, [128161], "f0eb", "M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"]
}, hR = {
  prefix: "fas",
  iconName: "volume-low",
  icon: [448, 512, [128264, "volume-down"], "f027", "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM412.6 181.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"]
}, $4 = {
  prefix: "fas",
  iconName: "list",
  icon: [512, 512, ["list-squares"], "f03a", "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"]
}, mR = {
  prefix: "fas",
  iconName: "pen-to-square",
  icon: [512, 512, ["edit"], "f044", "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"]
}, gR = {
  prefix: "fas",
  iconName: "lightbulb-on",
  icon: [640, 512, [], "f672", "M69.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zM597.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zm-100.1 5.7c-19.8 27.1-39.7 54.4-49.2 86.2H240c-9.6-31.9-29.5-59.1-49.2-86.2l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80V416H400v16zM320 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80z"]
}, Wa = {
  prefix: "fas",
  iconName: "sparkles",
  icon: [512, 512, [10024], "f890", "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"]
}, O4 = {
  prefix: "fas",
  iconName: "arrow-left-to-line",
  icon: [448, 512, [8676, "arrow-to-left"], "f33e", "M0 96C0 78.3 14.3 64 32 64s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96zM137.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L237.3 224 416 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-178.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z"]
}, vR = {
  prefix: "fas",
  iconName: "wand-magic-sparkles",
  icon: [576, 512, ["magic-wand-sparkles"], "e2ca", "M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"]
}, M4 = {
  prefix: "fas",
  iconName: "user",
  icon: [448, 512, [128100, 62144], "f007", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"]
}, wR = {
  prefix: "fas",
  iconName: "chart-line-up",
  icon: [512, 512, [], "e0e5", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zM439 279c15.1 15.1 41 4.4 41-17V152c0-13.3-10.7-24-24-24H345.9c-21.4 0-32.1 25.9-17 41l32.4 32.4L304 258.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L208 253.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0l80-80L439 279z"]
}, Rg = {
  prefix: "fas",
  iconName: "paper-plane-top",
  icon: [512, 512, ["paper-plane-alt", "send"], "e20a", "M49.9 27.8C15.1 12.7-19.2 50.1-1.2 83.5L68.1 212.2c4.4 8.3 12.6 13.8 21.9 15c0 0 0 0 0 0l176 22c3.4 .4 6 3.3 6 6.7s-2.6 6.3-6 6.7l-176 22s0 0 0 0c-9.3 1.2-17.5 6.8-21.9 15L-1.2 428.5c-18 33.4 16.3 70.8 51.1 55.7L491.8 292.7c32.1-13.9 32.1-59.5 0-73.4L49.9 27.8z"]
}, yR = {
  prefix: "fas",
  iconName: "comment-smile",
  icon: [512, 512, [], "f4b4", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM192 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM150.5 270.1c9.9-8.8 25-8 33.9 1.9c17.6 19.7 43.1 32 71.6 32s53.9-12.3 71.6-32c8.8-9.9 24-10.7 33.9-1.9s10.7 24 1.9 33.9C337 333.4 298.6 352 256 352s-81-18.6-107.3-48c-8.8-9.9-8-25 1.9-33.9z"]
}, D4 = {
  prefix: "fas",
  iconName: "books",
  icon: [512, 512, [128218], "f5db", "M0 32C0 14.3 14.3 0 32 0H96c17.7 0 32 14.3 32 32V96H0V32zm0 96H128V384H0V128zM0 416H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416zM160 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V96H160V32zm0 96H288V384H160V128zm0 288H288v64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V416zm203.6-19.9L320 232.6V142.8l100.4-26.9 66 247.4L363.6 396.1zM412.2 85L320 109.6V11l36.9-9.9c16.9-4.6 34.4 5.5 38.9 22.6L412.2 85zM371.8 427l122.8-32.9 16.3 61.1c4.5 17-5.5 34.5-22.5 39.1l-61.4 16.5c-16.9 4.6-34.4-5.5-38.9-22.6L371.8 427z"]
}, bR = {
  prefix: "fas",
  iconName: "messages",
  icon: [640, 512, ["comments-alt"], "f4b6", "M64 0C28.7 0 0 28.7 0 64V256c0 35.3 28.7 64 64 64H96v48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 320H352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM352 352H256v32c0 35.3 28.7 64 64 64H437.3l81.1 60.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3V448h32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H448V256c0 53-43 96-96 96z"]
}, ese = {
  prefix: "fas",
  iconName: "user-pen",
  icon: [640, 512, ["user-edit"], "f4ff", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H322.8c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1H178.3zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"]
}, xR = {
  prefix: "fas",
  iconName: "volume",
  icon: [576, 512, [128265, "volume-medium"], "f6a8", "M333.1 34.8C344.6 40 352 51.4 352 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L163.8 352H96c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L298.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zm172 72.2c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C507.3 341.3 528 301.1 528 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C466.1 199.1 480 225.9 480 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C425.1 284.4 432 271 432 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"]
}, ER = xR, CR = {
  prefix: "fas",
  iconName: "arrow-up-right-and-arrow-down-left-from-center",
  icon: [512, 512, [], "e0a0", "M352 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L297.4 169.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V160c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H352zM214.6 297.4c-12.5-12.5-32.8-12.5-45.3 0L64 402.7V352c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H109.3L214.6 342.6c12.5-12.5 12.5-32.8 0-45.3z"]
}, SR = {
  prefix: "fas",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, _R = SR, TR = {
  prefix: "fas",
  iconName: "user-tie",
  icon: [448, 512, [], "f508", "M96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm94.5 200.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7H162.5c0 0 0 0 .1 0H168 280h5.5c0 0 0 0 .1 0H417.3c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2H224 204.3c-12.4 0-20.1 13.6-13.7 24.2z"]
}, kR = {
  prefix: "fas",
  iconName: "arrows-rotate",
  icon: [512, 512, [128472, "refresh", "sync"], "f021", "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H352c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V432c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"]
}, tse = {
  prefix: "fas",
  iconName: "comment-check",
  icon: [512, 512, [], "f4ac", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM369 193L241 321c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 159c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, PR = {
  prefix: "fas",
  iconName: "broom-wide",
  icon: [512, 512, [], "e5d1", "M502.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128-15.8-15.8c-15.2-15.2-38.5-18.4-57.3-8l-32.5 18L380.4 288.1l18-32.5c10.4-18.7 7.1-42.1-8-57.3l-15.8-15.8 128-128c12.5-12.5 12.5-32.8 0-45.3zM187.5 151.8L16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6l43.2 43.2c2.1 2.1 5.3 2.9 8.2 1.9l52.1-17.4c6.3-2.1 12.2 3.9 10.1 10.1l-17.4 52.1c-1 2.9-.2 6 1.9 8.2L214.7 502.7c6 6 14.1 9.3 22.6 9.3c11.6 0 22.3-6.3 27.9-16.4l95.1-171.1L187.5 151.8z"]
}, nse = {
  prefix: "fas",
  iconName: "question",
  icon: [320, 512, [10067, 10068, 61736], "3f", "M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
}, AR = {
  prefix: "fas",
  iconName: "arrow-up-right-from-square",
  icon: [512, 512, ["external-link"], "f08e", "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"]
}, RR = {
  prefix: "fas",
  iconName: "arrow-right",
  icon: [448, 512, [8594], "f061", "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"]
}, $R = {
  prefix: "fas",
  iconName: "circle",
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
}, OR = {
  prefix: "fas",
  iconName: "volume-high",
  icon: [640, 512, [128266, "volume-up"], "f028", "M533.6 32.5C598.5 85.2 640 165.8 640 256s-41.5 170.7-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"]
}, rse = {
  prefix: "fas",
  iconName: "eye",
  icon: [576, 512, [128065], "f06e", "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"]
}, MR = {
  prefix: "fas",
  iconName: "comment-dots",
  icon: [512, 512, [128172, 62075, "commenting"], "f4ad", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, ise = {
  prefix: "fas",
  iconName: "spinner-third",
  icon: [512, 512, [], "f3f4", "M224 32c0-17.7 14.3-32 32-32C397.4 0 512 114.6 512 256c0 46.6-12.5 90.4-34.3 128c-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c16.3-28.2 25.7-61 25.7-96c0-106-86-192-192-192c-17.7 0-32-14.3-32-32z"]
}, DR = {
  prefix: "fas",
  iconName: "arrow-left",
  icon: [448, 512, [8592], "f060", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"]
}, ose = {
  prefix: "fas",
  iconName: "waveform-lines",
  icon: [640, 512, ["waveform-path"], "f8f2", "M352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM544 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96zM256 128c0-17.7-14.3-32-32-32s-32 14.3-32 32V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V160zM160 224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V224zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm576 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
}, ase = {
  prefix: "fas",
  iconName: "house",
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"]
}, N4 = {
  prefix: "fas",
  iconName: "stop",
  icon: [384, 512, [9209], "f04d", "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
}, sse = {
  prefix: "fas",
  iconName: "hand-wave",
  icon: [512, 512, [], "e1a7", "M352.2 82.3L351 73.8c-3-21.1-19.6-37.7-40.7-40.7l-8.5-1.2c-8.7-1.2-14.8-9.4-13.6-18.1S297.5-1.1 306.3 .2l8.5 1.2c35.2 5 62.9 32.7 67.9 67.9l1.2 8.5c1.2 8.7-4.8 16.9-13.6 18.1s-16.9-4.8-18.1-13.6zM185.4 70.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192c3.3 3.3 9.4 1.1 9.4-3.7l0-77.7c0-22.1 17.9-40 40-40s40 17.9 40 40V312.3c0 60.2-27.9 116.9-75.5 153.7C385.7 505.3 321 515.7 263 498.7c-28.4-7.1-55.3-21.8-77.6-44.1l-4.9-4.9L73.4 342.6l-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l31.9 31.9 .1 .1L165.3 344c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L57.4 198.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L229.3 280c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L105.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L293.3 216c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L185.4 70.6zM13.7 352.2c8.7-1.3 16.9 4.8 18.1 13.6l1.2 8.5c3 21.1 19.6 37.7 40.7 40.7l8.5 1.2c8.7 1.2 14.8 9.4 13.6 18.1s-9.4 14.8-18.1 13.6l-8.5-1.2c-35.2-5-62.9-32.7-67.9-67.9L.2 370.3c-1.2-8.7 4.8-16.9 13.6-18.1z"]
}, lse = {
  prefix: "fas",
  iconName: "message-slash",
  icon: [640, 512, ["comment-alt-slash"], "f4a9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-82.3-64.5C565.1 393 576 373.8 576 352V64c0-35.3-28.7-64-64-64H128C104.4 0 83.8 12.7 72.7 31.7L38.8 5.1zM406.2 416L64 146.4V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416h32.8z"]
}, NR = {
  prefix: "fas",
  iconName: "bolt",
  icon: [448, 512, [9889, "zap"], "f0e7", "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"]
}, IR = {
  prefix: "fas",
  iconName: "thumbs-down",
  icon: [512, 512, [128078, 61576], "f165", "M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2H464c26.5 0 48-21.5 48-48c0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48H294.5c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7V192v48 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 384H96c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32C14.3 96 0 110.3 0 128V352c0 17.7 14.3 32 32 32z"]
}, LR = {
  prefix: "fas",
  iconName: "ellipsis",
  icon: [448, 512, ["ellipsis-h"], "f141", "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
}, FR = LR, I4 = {
  prefix: "fas",
  iconName: "xmark-large",
  icon: [448, 512, [], "e59b", "M393.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 256 438.6 425.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 301.3 54.6 470.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0L224 210.7 393.4 41.4z"]
}, cse = {
  prefix: "fas",
  iconName: "location-dot",
  icon: [384, 512, ["map-marker-alt"], "f3c5", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
}, use = {
  prefix: "fas",
  iconName: "droplet",
  icon: [384, 512, [128167, "tint"], "f043", "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"]
}, zR = {
  prefix: "fas",
  iconName: "link",
  icon: [640, 512, [128279, "chain"], "f0c1", "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"]
}, L4 = {
  prefix: "fas",
  iconName: "play",
  icon: [384, 512, [9654], "f04b", "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"]
}, VR = {
  prefix: "fas",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
}, $g = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, fse = {
  prefix: "fas",
  iconName: "list-check",
  icon: [512, 512, ["tasks"], "f0ae", "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
}, mf = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
}, Og = mf, dse = mf, pse = {
  prefix: "fas",
  iconName: "chevron-left",
  icon: [320, 512, [9001], "f053", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"]
}, hse = {
  prefix: "fas",
  iconName: "chevron-right",
  icon: [320, 512, [9002], "f054", "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"]
}, BR = {
  prefix: "fas",
  iconName: "rotate",
  icon: [512, 512, [128260, "sync-alt"], "f2f1", "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"]
}, HR = BR, F4 = {
  prefix: "fas",
  iconName: "arrow-right-to-line",
  icon: [448, 512, [8677, "arrow-to-right"], "f340", "M448 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96zM310.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l178.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"]
}, UR = {
  prefix: "fas",
  iconName: "volume-slash",
  icon: [640, 512, [128263], "f2e2", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.1 386.2C556.7 352 576 306.3 576 256c0-60.1-27.7-113.8-70.9-149c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C507.3 170.7 528 210.9 528 256c0 39.1-15.6 74.5-40.9 100.5L449 326.6c19-17.5 31-42.7 31-70.6c0-30.1-13.9-56.9-35.4-74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C425.1 227.6 432 241 432 256s-6.9 28.4-17.7 37.3c-1.3 1-2.4 2.2-3.4 3.4L352 250.6V64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L197.8 129.8 38.8 5.1zM352 373.3L82.9 161.3C53.8 167.4 32 193.1 32 224v64c0 35.3 28.7 64 64 64h67.8L298.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S352 460.6 352 448V373.3z"]
}, WR = {
  prefix: "fas",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
}, jR = {
  prefix: "fas",
  iconName: "triangle-exclamation",
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, lo = jR, qR = {
  prefix: "fas",
  iconName: "circle-xmark",
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
}, GR = qR, YR = {
  prefix: "fas",
  iconName: "thumbs-up",
  icon: [512, 512, [128077, 61575], "f164", "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2H464c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48H294.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V320 272 247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"]
}, KR = {
  prefix: "fas",
  iconName: "window-minimize",
  icon: [512, 512, [128469], "f2d1", "M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
}, XR = {
  prefix: "fas",
  iconName: "square-full",
  icon: [512, 512, [128997, 128998, 128999, 129e3, 129001, 129002, 129003, 11035, 11036], "f45c", "M0 0H512V512H0V0z"]
}, QR = {
  prefix: "fas",
  iconName: "face-smile-relaxed",
  icon: [512, 512, [], "e392", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm47.1-91.9c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
function de() {
  return de = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, de.apply(null, arguments);
}
function Oe(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function ZR(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function gf(...e) {
  return (t) => e.forEach(
    (n) => ZR(n, t)
  );
}
function Lt(...e) {
  return Me(gf(...e), e);
}
function ar(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = /* @__PURE__ */ ln(a), c = n.length;
    n = [
      ...n,
      a
    ];
    function f(d) {
      const { scope: h, children: m, ...v } = d, w = (h == null ? void 0 : h[e][c]) || s, b = yn(
        () => v,
        Object.values(v)
      );
      return /* @__PURE__ */ K(w.Provider, {
        value: b
      }, m);
    }
    function p(d, h) {
      const m = (h == null ? void 0 : h[e][c]) || s, v = Re(m);
      if (v)
        return v;
      if (a !== void 0)
        return a;
      throw new Error(`\`${d}\` must be used within \`${o}\``);
    }
    return f.displayName = o + "Provider", [
      f,
      p
    ];
  }
  const i = () => {
    const o = n.map((a) => /* @__PURE__ */ ln(a));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return yn(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return i.scopeName = e, [
    r,
    JR(i, ...t)
  ];
}
function JR(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (i) => ({
        useScope: i(),
        scopeName: i.scopeName
      })
    );
    return function(o) {
      const a = r.reduce((s, { useScope: c, scopeName: f }) => {
        const d = c(o)[`__scope${f}`];
        return {
          ...s,
          ...d
        };
      }, {});
      return yn(
        () => ({
          [`__scope${t.scopeName}`]: a
        }),
        [
          a
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
const Ti = /* @__PURE__ */ Ee((e, t) => {
  const { children: n, ...r } = e, i = io.toArray(n), o = i.find(e$);
  if (o) {
    const a = o.props.children, s = i.map((c) => c === o ? io.count(a) > 1 ? io.only(null) : /* @__PURE__ */ La(a) ? a.props.children : null : c);
    return /* @__PURE__ */ K(Wh, de({}, r, {
      ref: t
    }), /* @__PURE__ */ La(a) ? /* @__PURE__ */ df(a, void 0, s) : null);
  }
  return /* @__PURE__ */ K(Wh, de({}, r, {
    ref: t
  }), n);
});
Ti.displayName = "Slot";
const Wh = /* @__PURE__ */ Ee((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ La(n) ? /* @__PURE__ */ df(n, {
    ...t$(r, n.props),
    ref: t ? gf(t, n.ref) : n.ref
  }) : io.count(n) > 1 ? io.only(null) : null;
});
Wh.displayName = "SlotClone";
const z4 = ({ children: e }) => /* @__PURE__ */ K(Pg, null, e);
function e$(e) {
  return /* @__PURE__ */ La(e) && e.type === z4;
}
function t$(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = {
      ...i,
      ...o
    } : r === "className" && (n[r] = [
      i,
      o
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const n$ = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], st = n$.reduce((e, t) => {
  const n = /* @__PURE__ */ Ee((r, i) => {
    const { asChild: o, ...a } = r, s = o ? Ti : t;
    return _e(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ K(s, de({}, a, {
      ref: i
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function V4(e, t) {
  e && pf(
    () => e.dispatchEvent(t)
  );
}
function ri(e) {
  const t = he(e);
  return _e(() => {
    t.current = e;
  }), yn(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function r$(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ri(e);
  _e(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const jh = "dismissableLayer.update", i$ = "dismissableLayer.pointerDownOutside", o$ = "dismissableLayer.focusOutside";
let wy;
const a$ = /* @__PURE__ */ ln({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), vf = /* @__PURE__ */ Ee((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: i, onPointerDownOutside: o, onFocusOutside: a, onInteractOutside: s, onDismiss: c, ...f } = e, p = Re(a$), [d, h] = ue(null), m = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, v] = ue({}), w = Lt(
    t,
    (N) => h(N)
  ), b = Array.from(p.layers), [E] = [
    ...p.layersWithOutsidePointerEventsDisabled
  ].slice(-1), C = b.indexOf(E), S = d ? b.indexOf(d) : -1, _ = p.layersWithOutsidePointerEventsDisabled.size > 0, T = S >= C, P = s$((N) => {
    const B = N.target, L = [
      ...p.branches
    ].some(
      (j) => j.contains(B)
    );
    !T || L || (o == null || o(N), s == null || s(N), N.defaultPrevented || c == null || c());
  }, m), R = l$((N) => {
    const B = N.target;
    [
      ...p.branches
    ].some(
      (j) => j.contains(B)
    ) || (a == null || a(N), s == null || s(N), N.defaultPrevented || c == null || c());
  }, m);
  return r$((N) => {
    S === p.layers.size - 1 && (i == null || i(N), !N.defaultPrevented && c && (N.preventDefault(), c()));
  }, m), _e(() => {
    if (d)
      return r && (p.layersWithOutsidePointerEventsDisabled.size === 0 && (wy = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), p.layersWithOutsidePointerEventsDisabled.add(d)), p.layers.add(d), yy(), () => {
        r && p.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = wy);
      };
  }, [
    d,
    m,
    r,
    p
  ]), _e(() => () => {
    d && (p.layers.delete(d), p.layersWithOutsidePointerEventsDisabled.delete(d), yy());
  }, [
    d,
    p
  ]), _e(() => {
    const N = () => v({});
    return document.addEventListener(jh, N), () => document.removeEventListener(jh, N);
  }, []), /* @__PURE__ */ K(st.div, de({}, f, {
    ref: w,
    style: {
      pointerEvents: _ ? T ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Oe(e.onFocusCapture, R.onFocusCapture),
    onBlurCapture: Oe(e.onBlurCapture, R.onBlurCapture),
    onPointerDownCapture: Oe(e.onPointerDownCapture, P.onPointerDownCapture)
  }));
});
function s$(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ri(e), r = he(!1), i = he(() => {
  });
  return _e(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let f = function() {
          B4(i$, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = f, t.addEventListener("click", i.current, {
          once: !0
        })) : f();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function l$(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ri(e), r = he(!1);
  return _e(() => {
    const i = (o) => {
      o.target && !r.current && B4(o$, n, {
        originalEvent: o
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function yy() {
  const e = new CustomEvent(jh);
  document.dispatchEvent(e);
}
function B4(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && i.addEventListener(e, t, {
    once: !0
  }), r ? V4(i, o) : i.dispatchEvent(o);
}
let Dp = 0;
function Mg() {
  _e(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : by()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : by()), Dp++, () => {
      Dp === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), Dp--;
    };
  }, []);
}
function by() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const Np = "focusScope.autoFocusOnMount", Ip = "focusScope.autoFocusOnUnmount", xy = {
  bubbles: !1,
  cancelable: !0
}, Dg = /* @__PURE__ */ Ee((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: i, onUnmountAutoFocus: o, ...a } = e, [s, c] = ue(null), f = ri(i), p = ri(o), d = he(null), h = Lt(
    t,
    (w) => c(w)
  ), m = he({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  _e(() => {
    if (r) {
      let w = function(S) {
        if (m.paused || !s)
          return;
        const _ = S.target;
        s.contains(_) ? d.current = _ : Ki(d.current, {
          select: !0
        });
      }, b = function(S) {
        if (m.paused || !s)
          return;
        const _ = S.relatedTarget;
        _ !== null && (s.contains(_) || Ki(d.current, {
          select: !0
        }));
      }, E = function(S) {
        if (document.activeElement === document.body)
          for (const T of S)
            T.removedNodes.length > 0 && Ki(s);
      };
      document.addEventListener("focusin", w), document.addEventListener("focusout", b);
      const C = new MutationObserver(E);
      return s && C.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", w), document.removeEventListener("focusout", b), C.disconnect();
      };
    }
  }, [
    r,
    s,
    m.paused
  ]), _e(() => {
    if (s) {
      Cy.add(m);
      const w = document.activeElement;
      if (!s.contains(w)) {
        const E = new CustomEvent(Np, xy);
        s.addEventListener(Np, f), s.dispatchEvent(E), E.defaultPrevented || (c$(h$(H4(s)), {
          select: !0
        }), document.activeElement === w && Ki(s));
      }
      return () => {
        s.removeEventListener(Np, f), setTimeout(() => {
          const E = new CustomEvent(Ip, xy);
          s.addEventListener(Ip, p), s.dispatchEvent(E), E.defaultPrevented || Ki(w ?? document.body, {
            select: !0
          }), s.removeEventListener(Ip, p), Cy.remove(m);
        }, 0);
      };
    }
  }, [
    s,
    f,
    p,
    m
  ]);
  const v = Me((w) => {
    if (!n && !r || m.paused)
      return;
    const b = w.key === "Tab" && !w.altKey && !w.ctrlKey && !w.metaKey, E = document.activeElement;
    if (b && E) {
      const C = w.currentTarget, [S, _] = u$(C);
      S && _ ? !w.shiftKey && E === _ ? (w.preventDefault(), n && Ki(S, {
        select: !0
      })) : w.shiftKey && E === S && (w.preventDefault(), n && Ki(_, {
        select: !0
      })) : E === C && w.preventDefault();
    }
  }, [
    n,
    r,
    m.paused
  ]);
  return /* @__PURE__ */ K(st.div, de({
    tabIndex: -1
  }, a, {
    ref: h,
    onKeyDown: v
  }));
});
function c$(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Ki(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function u$(e) {
  const t = H4(e), n = Ey(t, e), r = Ey(t.reverse(), e);
  return [
    n,
    r
  ];
}
function H4(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Ey(e, t) {
  for (const n of e)
    if (!f$(n, {
      upTo: t
    }))
      return n;
}
function f$(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function d$(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ki(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && d$(e) && t && e.select();
  }
}
const Cy = p$();
function p$() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Sy(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Sy(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function Sy(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function h$(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const Vo = globalThis != null && globalThis.document ? gl : () => {
}, m$ = D["useId".toString()] || (() => {
});
let g$ = 0;
function zr(e) {
  const [t, n] = D.useState(m$());
  return Vo(() => {
    e || n(
      (r) => r ?? String(g$++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const v$ = ["top", "right", "bottom", "left"], oo = Math.min, er = Math.max, ku = Math.round, Ac = Math.floor, ti = (e) => ({
  x: e,
  y: e
}), w$ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, y$ = {
  start: "end",
  end: "start"
};
function qh(e, t, n) {
  return er(e, oo(t, n));
}
function ki(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Pi(e) {
  return e.split("-")[0];
}
function ja(e) {
  return e.split("-")[1];
}
function Ng(e) {
  return e === "x" ? "y" : "x";
}
function Ig(e) {
  return e === "y" ? "height" : "width";
}
function ao(e) {
  return ["top", "bottom"].includes(Pi(e)) ? "y" : "x";
}
function Lg(e) {
  return Ng(ao(e));
}
function b$(e, t, n) {
  n === void 0 && (n = !1);
  const r = ja(e), i = Lg(e), o = Ig(i);
  let a = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (a = Pu(a)), [a, Pu(a)];
}
function x$(e) {
  const t = Pu(e);
  return [Gh(e), t, Gh(t)];
}
function Gh(e) {
  return e.replace(/start|end/g, (t) => y$[t]);
}
function E$(e, t, n) {
  const r = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : r : t ? r : i;
    case "left":
    case "right":
      return t ? o : a;
    default:
      return [];
  }
}
function C$(e, t, n, r) {
  const i = ja(e);
  let o = E$(Pi(e), n === "start", r);
  return i && (o = o.map((a) => a + "-" + i), t && (o = o.concat(o.map(Gh)))), o;
}
function Pu(e) {
  return e.replace(/left|right|bottom|top/g, (t) => w$[t]);
}
function S$(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function U4(e) {
  return typeof e != "number" ? S$(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Au(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
function _y(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const o = ao(t), a = Lg(t), s = Ig(a), c = Pi(t), f = o === "y", p = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, h = r[s] / 2 - i[s] / 2;
  let m;
  switch (c) {
    case "top":
      m = {
        x: p,
        y: r.y - i.height
      };
      break;
    case "bottom":
      m = {
        x: p,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      m = {
        x: r.x - i.width,
        y: d
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  switch (ja(t)) {
    case "start":
      m[a] -= h * (n && f ? -1 : 1);
      break;
    case "end":
      m[a] += h * (n && f ? -1 : 1);
      break;
  }
  return m;
}
const _$ = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: a
  } = n, s = o.filter(Boolean), c = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let f = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: p,
    y: d
  } = _y(f, r, c), h = r, m = {}, v = 0;
  for (let w = 0; w < s.length; w++) {
    const {
      name: b,
      fn: E
    } = s[w], {
      x: C,
      y: S,
      data: _,
      reset: T
    } = await E({
      x: p,
      y: d,
      initialPlacement: r,
      placement: h,
      strategy: i,
      middlewareData: m,
      rects: f,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    p = C ?? p, d = S ?? d, m = {
      ...m,
      [b]: {
        ...m[b],
        ..._
      }
    }, T && v <= 50 && (v++, typeof T == "object" && (T.placement && (h = T.placement), T.rects && (f = T.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : T.rects), {
      x: p,
      y: d
    } = _y(f, h, c)), w = -1);
  }
  return {
    x: p,
    y: d,
    placement: h,
    strategy: i,
    middlewareData: m
  };
};
async function Ys(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: a,
    elements: s,
    strategy: c
  } = e, {
    boundary: f = "clippingAncestors",
    rootBoundary: p = "viewport",
    elementContext: d = "floating",
    altBoundary: h = !1,
    padding: m = 0
  } = ki(t, e), v = U4(m), b = s[h ? d === "floating" ? "reference" : "floating" : d], E = Au(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(b))) == null || n ? b : b.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating)),
    boundary: f,
    rootBoundary: p,
    strategy: c
  })), C = d === "floating" ? {
    x: r,
    y: i,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating)), _ = await (o.isElement == null ? void 0 : o.isElement(S)) ? await (o.getScale == null ? void 0 : o.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, T = Au(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: C,
    offsetParent: S,
    strategy: c
  }) : C);
  return {
    top: (E.top - T.top + v.top) / _.y,
    bottom: (T.bottom - E.bottom + v.bottom) / _.y,
    left: (E.left - T.left + v.left) / _.x,
    right: (T.right - E.right + v.right) / _.x
  };
}
const T$ = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: a,
      elements: s,
      middlewareData: c
    } = t, {
      element: f,
      padding: p = 0
    } = ki(e, t) || {};
    if (f == null)
      return {};
    const d = U4(p), h = {
      x: n,
      y: r
    }, m = Lg(i), v = Ig(m), w = await a.getDimensions(f), b = m === "y", E = b ? "top" : "left", C = b ? "bottom" : "right", S = b ? "clientHeight" : "clientWidth", _ = o.reference[v] + o.reference[m] - h[m] - o.floating[v], T = h[m] - o.reference[m], P = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(f));
    let R = P ? P[S] : 0;
    (!R || !await (a.isElement == null ? void 0 : a.isElement(P))) && (R = s.floating[S] || o.floating[v]);
    const N = _ / 2 - T / 2, B = R / 2 - w[v] / 2 - 1, L = oo(d[E], B), j = oo(d[C], B), I = L, z = R - w[v] - j, H = R / 2 - w[v] / 2 + N, G = qh(I, H, z), Y = !c.arrow && ja(i) != null && H !== G && o.reference[v] / 2 - (H < I ? L : j) - w[v] / 2 < 0, ne = Y ? H < I ? H - I : H - z : 0;
    return {
      [m]: h[m] + ne,
      data: {
        [m]: G,
        centerOffset: H - G - ne,
        ...Y && {
          alignmentOffset: ne
        }
      },
      reset: Y
    };
  }
}), k$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: o,
        rects: a,
        initialPlacement: s,
        platform: c,
        elements: f
      } = t, {
        mainAxis: p = !0,
        crossAxis: d = !0,
        fallbackPlacements: h,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: w = !0,
        ...b
      } = ki(e, t);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const E = Pi(i), C = ao(s), S = Pi(s) === s, _ = await (c.isRTL == null ? void 0 : c.isRTL(f.floating)), T = h || (S || !w ? [Pu(s)] : x$(s)), P = v !== "none";
      !h && P && T.push(...C$(s, w, v, _));
      const R = [s, ...T], N = await Ys(t, b), B = [];
      let L = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (p && B.push(N[E]), d) {
        const H = b$(i, a, _);
        B.push(N[H[0]], N[H[1]]);
      }
      if (L = [...L, {
        placement: i,
        overflows: B
      }], !B.every((H) => H <= 0)) {
        var j, I;
        const H = (((j = o.flip) == null ? void 0 : j.index) || 0) + 1, G = R[H];
        if (G)
          return {
            data: {
              index: H,
              overflows: L
            },
            reset: {
              placement: G
            }
          };
        let Y = (I = L.filter((ne) => ne.overflows[0] <= 0).sort((ne, J) => ne.overflows[1] - J.overflows[1])[0]) == null ? void 0 : I.placement;
        if (!Y)
          switch (m) {
            case "bestFit": {
              var z;
              const ne = (z = L.filter((J) => {
                if (P) {
                  const ee = ao(J.placement);
                  return ee === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ee === "y";
                }
                return !0;
              }).map((J) => [J.placement, J.overflows.filter((ee) => ee > 0).reduce((ee, A) => ee + A, 0)]).sort((J, ee) => J[1] - ee[1])[0]) == null ? void 0 : z[0];
              ne && (Y = ne);
              break;
            }
            case "initialPlacement":
              Y = s;
              break;
          }
        if (i !== Y)
          return {
            reset: {
              placement: Y
            }
          };
      }
      return {};
    }
  };
};
function Ty(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function ky(e) {
  return v$.some((t) => e[t] >= 0);
}
const P$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...i
      } = ki(e, t);
      switch (r) {
        case "referenceHidden": {
          const o = await Ys(t, {
            ...i,
            elementContext: "reference"
          }), a = Ty(o, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: ky(a)
            }
          };
        }
        case "escaped": {
          const o = await Ys(t, {
            ...i,
            altBoundary: !0
          }), a = Ty(o, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: ky(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function A$(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), a = Pi(n), s = ja(n), c = ao(n) === "y", f = ["left", "top"].includes(a) ? -1 : 1, p = o && c ? -1 : 1, d = ki(t, e);
  let {
    mainAxis: h,
    crossAxis: m,
    alignmentAxis: v
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof v == "number" && (m = s === "end" ? v * -1 : v), c ? {
    x: m * p,
    y: h * f
  } : {
    x: h * f,
    y: m * p
  };
}
const R$ = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: a,
        middlewareData: s
      } = t, c = await A$(t, e);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: i + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: a
        }
      };
    }
  };
}, $$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i
      } = t, {
        mainAxis: o = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (b) => {
            let {
              x: E,
              y: C
            } = b;
            return {
              x: E,
              y: C
            };
          }
        },
        ...c
      } = ki(e, t), f = {
        x: n,
        y: r
      }, p = await Ys(t, c), d = ao(Pi(i)), h = Ng(d);
      let m = f[h], v = f[d];
      if (o) {
        const b = h === "y" ? "top" : "left", E = h === "y" ? "bottom" : "right", C = m + p[b], S = m - p[E];
        m = qh(C, m, S);
      }
      if (a) {
        const b = d === "y" ? "top" : "left", E = d === "y" ? "bottom" : "right", C = v + p[b], S = v - p[E];
        v = qh(C, v, S);
      }
      const w = s.fn({
        ...t,
        [h]: m,
        [d]: v
      });
      return {
        ...w,
        data: {
          x: w.x - n,
          y: w.y - r,
          enabled: {
            [h]: o,
            [d]: a
          }
        }
      };
    }
  };
}, O$ = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: i,
        rects: o,
        middlewareData: a
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: f = !0
      } = ki(e, t), p = {
        x: n,
        y: r
      }, d = ao(i), h = Ng(d);
      let m = p[h], v = p[d];
      const w = ki(s, t), b = typeof w == "number" ? {
        mainAxis: w,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...w
      };
      if (c) {
        const S = h === "y" ? "height" : "width", _ = o.reference[h] - o.floating[S] + b.mainAxis, T = o.reference[h] + o.reference[S] - b.mainAxis;
        m < _ ? m = _ : m > T && (m = T);
      }
      if (f) {
        var E, C;
        const S = h === "y" ? "width" : "height", _ = ["top", "left"].includes(Pi(i)), T = o.reference[d] - o.floating[S] + (_ && ((E = a.offset) == null ? void 0 : E[d]) || 0) + (_ ? 0 : b.crossAxis), P = o.reference[d] + o.reference[S] + (_ ? 0 : ((C = a.offset) == null ? void 0 : C[d]) || 0) - (_ ? b.crossAxis : 0);
        v < T ? v = T : v > P && (v = P);
      }
      return {
        [h]: m,
        [d]: v
      };
    }
  };
}, M$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        rects: o,
        platform: a,
        elements: s
      } = t, {
        apply: c = () => {
        },
        ...f
      } = ki(e, t), p = await Ys(t, f), d = Pi(i), h = ja(i), m = ao(i) === "y", {
        width: v,
        height: w
      } = o.floating;
      let b, E;
      d === "top" || d === "bottom" ? (b = d, E = h === (await (a.isRTL == null ? void 0 : a.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (E = d, b = h === "end" ? "top" : "bottom");
      const C = w - p.top - p.bottom, S = v - p.left - p.right, _ = oo(w - p[b], C), T = oo(v - p[E], S), P = !t.middlewareData.shift;
      let R = _, N = T;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (N = S), (r = t.middlewareData.shift) != null && r.enabled.y && (R = C), P && !h) {
        const L = er(p.left, 0), j = er(p.right, 0), I = er(p.top, 0), z = er(p.bottom, 0);
        m ? N = v - 2 * (L !== 0 || j !== 0 ? L + j : er(p.left, p.right)) : R = w - 2 * (I !== 0 || z !== 0 ? I + z : er(p.top, p.bottom));
      }
      await c({
        ...t,
        availableWidth: N,
        availableHeight: R
      });
      const B = await a.getDimensions(s.floating);
      return v !== B.width || w !== B.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function wf() {
  return typeof window < "u";
}
function qa(e) {
  return W4(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function tr(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ai(e) {
  var t;
  return (t = (W4(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function W4(e) {
  return wf() ? e instanceof Node || e instanceof tr(e).Node : !1;
}
function Wr(e) {
  return wf() ? e instanceof Element || e instanceof tr(e).Element : !1;
}
function ii(e) {
  return wf() ? e instanceof HTMLElement || e instanceof tr(e).HTMLElement : !1;
}
function Py(e) {
  return !wf() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof tr(e).ShadowRoot;
}
function vl(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = jr(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function D$(e) {
  return ["table", "td", "th"].includes(qa(e));
}
function yf(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Fg(e) {
  const t = zg(), n = Wr(e) ? jr(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function N$(e) {
  let t = so(e);
  for (; ii(t) && !Fa(t); ) {
    if (Fg(t))
      return t;
    if (yf(t))
      return null;
    t = so(t);
  }
  return null;
}
function zg() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Fa(e) {
  return ["html", "body", "#document"].includes(qa(e));
}
function jr(e) {
  return tr(e).getComputedStyle(e);
}
function bf(e) {
  return Wr(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function so(e) {
  if (qa(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Py(e) && e.host || // Fallback.
    ai(e)
  );
  return Py(t) ? t.host : t;
}
function j4(e) {
  const t = so(e);
  return Fa(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ii(t) && vl(t) ? t : j4(t);
}
function Ks(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = j4(e), o = i === ((r = e.ownerDocument) == null ? void 0 : r.body), a = tr(i);
  if (o) {
    const s = Yh(a);
    return t.concat(a, a.visualViewport || [], vl(i) ? i : [], s && n ? Ks(s) : []);
  }
  return t.concat(i, Ks(i, [], n));
}
function Yh(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function q4(e) {
  const t = jr(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = ii(e), o = i ? e.offsetWidth : n, a = i ? e.offsetHeight : r, s = ku(n) !== o || ku(r) !== a;
  return s && (n = o, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function Vg(e) {
  return Wr(e) ? e : e.contextElement;
}
function Aa(e) {
  const t = Vg(e);
  if (!ii(t))
    return ti(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = q4(t);
  let a = (o ? ku(n.width) : n.width) / r, s = (o ? ku(n.height) : n.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const I$ = /* @__PURE__ */ ti(0);
function G4(e) {
  const t = tr(e);
  return !zg() || !t.visualViewport ? I$ : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function L$(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== tr(e) ? !1 : t;
}
function Bo(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), o = Vg(e);
  let a = ti(1);
  t && (r ? Wr(r) && (a = Aa(r)) : a = Aa(e));
  const s = L$(o, n, r) ? G4(o) : ti(0);
  let c = (i.left + s.x) / a.x, f = (i.top + s.y) / a.y, p = i.width / a.x, d = i.height / a.y;
  if (o) {
    const h = tr(o), m = r && Wr(r) ? tr(r) : r;
    let v = h, w = Yh(v);
    for (; w && r && m !== v; ) {
      const b = Aa(w), E = w.getBoundingClientRect(), C = jr(w), S = E.left + (w.clientLeft + parseFloat(C.paddingLeft)) * b.x, _ = E.top + (w.clientTop + parseFloat(C.paddingTop)) * b.y;
      c *= b.x, f *= b.y, p *= b.x, d *= b.y, c += S, f += _, v = tr(w), w = Yh(v);
    }
  }
  return Au({
    width: p,
    height: d,
    x: c,
    y: f
  });
}
function Bg(e, t) {
  const n = bf(e).scrollLeft;
  return t ? t.left + n : Bo(ai(e)).left + n;
}
function Y4(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), i = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Bg(e, r)
  )), o = r.top + t.scrollTop;
  return {
    x: i,
    y: o
  };
}
function F$(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const o = i === "fixed", a = ai(r), s = t ? yf(t.floating) : !1;
  if (r === a || s && o)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, f = ti(1);
  const p = ti(0), d = ii(r);
  if ((d || !d && !o) && ((qa(r) !== "body" || vl(a)) && (c = bf(r)), ii(r))) {
    const m = Bo(r);
    f = Aa(r), p.x = m.x + r.clientLeft, p.y = m.y + r.clientTop;
  }
  const h = a && !d && !o ? Y4(a, c, !0) : ti(0);
  return {
    width: n.width * f.x,
    height: n.height * f.y,
    x: n.x * f.x - c.scrollLeft * f.x + p.x + h.x,
    y: n.y * f.y - c.scrollTop * f.y + p.y + h.y
  };
}
function z$(e) {
  return Array.from(e.getClientRects());
}
function V$(e) {
  const t = ai(e), n = bf(e), r = e.ownerDocument.body, i = er(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = er(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + Bg(e);
  const s = -n.scrollTop;
  return jr(r).direction === "rtl" && (a += er(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: a,
    y: s
  };
}
function B$(e, t) {
  const n = tr(e), r = ai(e), i = n.visualViewport;
  let o = r.clientWidth, a = r.clientHeight, s = 0, c = 0;
  if (i) {
    o = i.width, a = i.height;
    const f = zg();
    (!f || f && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: o,
    height: a,
    x: s,
    y: c
  };
}
function H$(e, t) {
  const n = Bo(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, o = ii(e) ? Aa(e) : ti(1), a = e.clientWidth * o.x, s = e.clientHeight * o.y, c = i * o.x, f = r * o.y;
  return {
    width: a,
    height: s,
    x: c,
    y: f
  };
}
function Ay(e, t, n) {
  let r;
  if (t === "viewport")
    r = B$(e, n);
  else if (t === "document")
    r = V$(ai(e));
  else if (Wr(t))
    r = H$(t, n);
  else {
    const i = G4(e);
    r = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return Au(r);
}
function K4(e, t) {
  const n = so(e);
  return n === t || !Wr(n) || Fa(n) ? !1 : jr(n).position === "fixed" || K4(n, t);
}
function U$(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Ks(e, [], !1).filter((s) => Wr(s) && qa(s) !== "body"), i = null;
  const o = jr(e).position === "fixed";
  let a = o ? so(e) : e;
  for (; Wr(a) && !Fa(a); ) {
    const s = jr(a), c = Fg(a);
    !c && s.position === "fixed" && (i = null), (o ? !c && !i : !c && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || vl(a) && !c && K4(e, a)) ? r = r.filter((p) => p !== a) : i = s, a = so(a);
  }
  return t.set(e, r), r;
}
function W$(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const a = [...n === "clippingAncestors" ? yf(t) ? [] : U$(t, this._c) : [].concat(n), r], s = a[0], c = a.reduce((f, p) => {
    const d = Ay(t, p, i);
    return f.top = er(d.top, f.top), f.right = oo(d.right, f.right), f.bottom = oo(d.bottom, f.bottom), f.left = er(d.left, f.left), f;
  }, Ay(t, s, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function j$(e) {
  const {
    width: t,
    height: n
  } = q4(e);
  return {
    width: t,
    height: n
  };
}
function q$(e, t, n) {
  const r = ii(t), i = ai(t), o = n === "fixed", a = Bo(e, !0, o, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = ti(0);
  if (r || !r && !o)
    if ((qa(t) !== "body" || vl(i)) && (s = bf(t)), r) {
      const h = Bo(t, !0, o, t);
      c.x = h.x + t.clientLeft, c.y = h.y + t.clientTop;
    } else
      i && (c.x = Bg(i));
  const f = i && !r && !o ? Y4(i, s) : ti(0), p = a.left + s.scrollLeft - c.x - f.x, d = a.top + s.scrollTop - c.y - f.y;
  return {
    x: p,
    y: d,
    width: a.width,
    height: a.height
  };
}
function Lp(e) {
  return jr(e).position === "static";
}
function Ry(e, t) {
  if (!ii(e) || jr(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return ai(e) === n && (n = n.ownerDocument.body), n;
}
function X4(e, t) {
  const n = tr(e);
  if (yf(e))
    return n;
  if (!ii(e)) {
    let i = so(e);
    for (; i && !Fa(i); ) {
      if (Wr(i) && !Lp(i))
        return i;
      i = so(i);
    }
    return n;
  }
  let r = Ry(e, t);
  for (; r && D$(r) && Lp(r); )
    r = Ry(r, t);
  return r && Fa(r) && Lp(r) && !Fg(r) ? n : r || N$(e) || n;
}
const G$ = async function(e) {
  const t = this.getOffsetParent || X4, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: q$(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Y$(e) {
  return jr(e).direction === "rtl";
}
const K$ = {
  convertOffsetParentRelativeRectToViewportRelativeRect: F$,
  getDocumentElement: ai,
  getClippingRect: W$,
  getOffsetParent: X4,
  getElementRects: G$,
  getClientRects: z$,
  getDimensions: j$,
  getScale: Aa,
  isElement: Wr,
  isRTL: Y$
};
function Q4(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function X$(e, t) {
  let n = null, r;
  const i = ai(e);
  function o() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function a(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), o();
    const f = e.getBoundingClientRect(), {
      left: p,
      top: d,
      width: h,
      height: m
    } = f;
    if (s || t(), !h || !m)
      return;
    const v = Ac(d), w = Ac(i.clientWidth - (p + h)), b = Ac(i.clientHeight - (d + m)), E = Ac(p), S = {
      rootMargin: -v + "px " + -w + "px " + -b + "px " + -E + "px",
      threshold: er(0, oo(1, c)) || 1
    };
    let _ = !0;
    function T(P) {
      const R = P[0].intersectionRatio;
      if (R !== c) {
        if (!_)
          return a();
        R ? a(!1, R) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      R === 1 && !Q4(f, e.getBoundingClientRect()) && a(), _ = !1;
    }
    try {
      n = new IntersectionObserver(T, {
        ...S,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(T, S);
    }
    n.observe(e);
  }
  return a(!0), o;
}
function Q$(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, f = Vg(e), p = i || o ? [...f ? Ks(f) : [], ...Ks(t)] : [];
  p.forEach((E) => {
    i && E.addEventListener("scroll", n, {
      passive: !0
    }), o && E.addEventListener("resize", n);
  });
  const d = f && s ? X$(f, n) : null;
  let h = -1, m = null;
  a && (m = new ResizeObserver((E) => {
    let [C] = E;
    C && C.target === f && m && (m.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var S;
      (S = m) == null || S.observe(t);
    })), n();
  }), f && !c && m.observe(f), m.observe(t));
  let v, w = c ? Bo(e) : null;
  c && b();
  function b() {
    const E = Bo(e);
    w && !Q4(w, E) && n(), w = E, v = requestAnimationFrame(b);
  }
  return n(), () => {
    var E;
    p.forEach((C) => {
      i && C.removeEventListener("scroll", n), o && C.removeEventListener("resize", n);
    }), d == null || d(), (E = m) == null || E.disconnect(), m = null, c && cancelAnimationFrame(v);
  };
}
const Z$ = R$, J$ = $$, eO = k$, tO = M$, nO = P$, $y = T$, rO = O$, iO = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: K$,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return _$(e, t, {
    ...i,
    platform: o
  });
};
var uu = typeof document < "u" ? gl : _e;
function Ru(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Ru(e[r], t[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const o = i[r];
      if (!(o === "_owner" && e.$$typeof) && !Ru(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Z4(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Oy(e, t) {
  const n = Z4(e);
  return Math.round(t * n) / n;
}
function Fp(e) {
  const t = D.useRef(e);
  return uu(() => {
    t.current = e;
  }), t;
}
function oO(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: o,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: f
  } = e, [p, d] = D.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, m] = D.useState(r);
  Ru(h, r) || m(r);
  const [v, w] = D.useState(null), [b, E] = D.useState(null), C = D.useCallback((J) => {
    J !== P.current && (P.current = J, w(J));
  }, []), S = D.useCallback((J) => {
    J !== R.current && (R.current = J, E(J));
  }, []), _ = o || v, T = a || b, P = D.useRef(null), R = D.useRef(null), N = D.useRef(p), B = c != null, L = Fp(c), j = Fp(i), I = Fp(f), z = D.useCallback(() => {
    if (!P.current || !R.current)
      return;
    const J = {
      placement: t,
      strategy: n,
      middleware: h
    };
    j.current && (J.platform = j.current), iO(P.current, R.current, J).then((ee) => {
      const A = {
        ...ee,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: I.current !== !1
      };
      H.current && !Ru(N.current, A) && (N.current = A, lR.flushSync(() => {
        d(A);
      }));
    });
  }, [h, t, n, j, I]);
  uu(() => {
    f === !1 && N.current.isPositioned && (N.current.isPositioned = !1, d((J) => ({
      ...J,
      isPositioned: !1
    })));
  }, [f]);
  const H = D.useRef(!1);
  uu(() => (H.current = !0, () => {
    H.current = !1;
  }), []), uu(() => {
    if (_ && (P.current = _), T && (R.current = T), _ && T) {
      if (L.current)
        return L.current(_, T, z);
      z();
    }
  }, [_, T, z, L, B]);
  const G = D.useMemo(() => ({
    reference: P,
    floating: R,
    setReference: C,
    setFloating: S
  }), [C, S]), Y = D.useMemo(() => ({
    reference: _,
    floating: T
  }), [_, T]), ne = D.useMemo(() => {
    const J = {
      position: n,
      left: 0,
      top: 0
    };
    if (!Y.floating)
      return J;
    const ee = Oy(Y.floating, p.x), A = Oy(Y.floating, p.y);
    return s ? {
      ...J,
      transform: "translate(" + ee + "px, " + A + "px)",
      ...Z4(Y.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: ee,
      top: A
    };
  }, [n, s, Y.floating, p.x, p.y]);
  return D.useMemo(() => ({
    ...p,
    update: z,
    refs: G,
    elements: Y,
    floatingStyles: ne
  }), [p, z, G, Y, ne]);
}
const aO = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? $y({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? $y({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
}, sO = (e, t) => ({
  ...Z$(e),
  options: [e, t]
}), lO = (e, t) => ({
  ...J$(e),
  options: [e, t]
}), cO = (e, t) => ({
  ...rO(e),
  options: [e, t]
}), uO = (e, t) => ({
  ...eO(e),
  options: [e, t]
}), fO = (e, t) => ({
  ...tO(e),
  options: [e, t]
}), dO = (e, t) => ({
  ...nO(e),
  options: [e, t]
}), pO = (e, t) => ({
  ...aO(e),
  options: [e, t]
}), hO = /* @__PURE__ */ Ee((e, t) => {
  const { children: n, width: r = 10, height: i = 5, ...o } = e;
  return /* @__PURE__ */ K(st.svg, de({}, o, {
    ref: t,
    width: r,
    height: i,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), e.asChild ? n : /* @__PURE__ */ K("polygon", {
    points: "0,0 30,0 15,10"
  }));
}), mO = hO;
function J4(e) {
  const [t, n] = ue(void 0);
  return Vo(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const o = i[0];
        let a, s;
        if ("borderBoxSize" in o) {
          const c = o.borderBoxSize, f = Array.isArray(c) ? c[0] : c;
          a = f.inlineSize, s = f.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({
          width: a,
          height: s
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const ex = "Popper", [tx, Ga] = ar(ex), [gO, nx] = tx(ex), vO = (e) => {
  const { __scopePopper: t, children: n } = e, [r, i] = ue(null);
  return /* @__PURE__ */ K(gO, {
    scope: t,
    anchor: r,
    onAnchorChange: i
  }, n);
}, wO = "PopperAnchor", yO = /* @__PURE__ */ Ee((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...i } = e, o = nx(wO, n), a = he(null), s = Lt(t, a);
  return _e(() => {
    o.onAnchorChange((r == null ? void 0 : r.current) || a.current);
  }), r ? null : /* @__PURE__ */ K(st.div, de({}, i, {
    ref: s
  }));
}), rx = "PopperContent", [bO, xO] = tx(rx), EO = /* @__PURE__ */ Ee((e, t) => {
  var n, r, i, o, a, s, c, f;
  const { __scopePopper: p, side: d = "bottom", sideOffset: h = 0, align: m = "center", alignOffset: v = 0, arrowPadding: w = 0, avoidCollisions: b = !0, collisionBoundary: E = [], collisionPadding: C = 0, sticky: S = "partial", hideWhenDetached: _ = !1, updatePositionStrategy: T = "optimized", onPlaced: P, ...R } = e, N = nx(rx, p), [B, L] = ue(null), j = Lt(
    t,
    (Ue) => L(Ue)
  ), [I, z] = ue(null), H = J4(I), G = (n = H == null ? void 0 : H.width) !== null && n !== void 0 ? n : 0, Y = (r = H == null ? void 0 : H.height) !== null && r !== void 0 ? r : 0, ne = d + (m !== "center" ? "-" + m : ""), J = typeof C == "number" ? C : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...C
  }, ee = Array.isArray(E) ? E : [
    E
  ], A = ee.length > 0, X = {
    padding: J,
    boundary: ee.filter(TO),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: A
  }, { refs: fe, floatingStyles: M, placement: Z, isPositioned: ie, middlewareData: pe } = oO({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: ne,
    whileElementsMounted: (...Ue) => Q$(...Ue, {
      animationFrame: T === "always"
    }),
    elements: {
      reference: N.anchor
    },
    middleware: [
      sO({
        mainAxis: h + Y,
        alignmentAxis: v
      }),
      b && lO({
        mainAxis: !0,
        crossAxis: !1,
        limiter: S === "partial" ? cO() : void 0,
        ...X
      }),
      b && uO({
        ...X
      }),
      fO({
        ...X,
        apply: ({ elements: Ue, rects: bt, availableWidth: Et, availableHeight: xt }) => {
          const { width: Pt, height: Bt } = bt.reference, Nt = Ue.floating.style;
          Nt.setProperty("--radix-popper-available-width", `${Et}px`), Nt.setProperty("--radix-popper-available-height", `${xt}px`), Nt.setProperty("--radix-popper-anchor-width", `${Pt}px`), Nt.setProperty("--radix-popper-anchor-height", `${Bt}px`);
        }
      }),
      I && pO({
        element: I,
        padding: w
      }),
      kO({
        arrowWidth: G,
        arrowHeight: Y
      }),
      _ && dO({
        strategy: "referenceHidden",
        ...X
      })
    ]
  }), [Te, ke] = ix(Z), me = ri(P);
  Vo(() => {
    ie && (me == null || me());
  }, [
    ie,
    me
  ]);
  const Pe = (i = pe.arrow) === null || i === void 0 ? void 0 : i.x, ct = (o = pe.arrow) === null || o === void 0 ? void 0 : o.y, se = ((a = pe.arrow) === null || a === void 0 ? void 0 : a.centerOffset) !== 0, [Le, xe] = ue();
  return Vo(() => {
    B && xe(window.getComputedStyle(B).zIndex);
  }, [
    B
  ]), /* @__PURE__ */ K("div", {
    ref: fe.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...M,
      transform: ie ? M.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: Le,
      ["--radix-popper-transform-origin"]: [
        (s = pe.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (c = pe.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ K(bO, {
    scope: p,
    placedSide: Te,
    onArrowChange: z,
    arrowX: Pe,
    arrowY: ct,
    shouldHideArrow: se
  }, /* @__PURE__ */ K(st.div, de({
    "data-side": Te,
    "data-align": ke
  }, R, {
    ref: j,
    style: {
      ...R.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: ie ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (f = pe.hide) !== null && f !== void 0 && f.referenceHidden ? 0 : void 0
    }
  }))));
}), CO = "PopperArrow", SO = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, _O = /* @__PURE__ */ Ee(function(t, n) {
  const { __scopePopper: r, ...i } = t, o = xO(CO, r), a = SO[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ K("span", {
      ref: o.onArrowChange,
      style: {
        position: "absolute",
        left: o.arrowX,
        top: o.arrowY,
        [a]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[o.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[o.placedSide],
        visibility: o.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ K(mO, de({}, i, {
      ref: n,
      style: {
        ...i.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function TO(e) {
  return e !== null;
}
const kO = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, i, o, a;
    const { placement: s, rects: c, middlewareData: f } = t, d = ((n = f.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, h = d ? 0 : e.arrowWidth, m = d ? 0 : e.arrowHeight, [v, w] = ix(s), b = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[w], E = ((r = (i = f.arrow) === null || i === void 0 ? void 0 : i.x) !== null && r !== void 0 ? r : 0) + h / 2, C = ((o = (a = f.arrow) === null || a === void 0 ? void 0 : a.y) !== null && o !== void 0 ? o : 0) + m / 2;
    let S = "", _ = "";
    return v === "bottom" ? (S = d ? b : `${E}px`, _ = `${-m}px`) : v === "top" ? (S = d ? b : `${E}px`, _ = `${c.floating.height + m}px`) : v === "right" ? (S = `${-m}px`, _ = d ? b : `${C}px`) : v === "left" && (S = `${c.floating.width + m}px`, _ = d ? b : `${C}px`), {
      data: {
        x: S,
        y: _
      }
    };
  }
});
function ix(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const Hg = vO, xf = yO, Ug = EO, PO = _O, Ef = /* @__PURE__ */ Ee((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...i } = e;
  return r ? /* @__PURE__ */ Ag.createPortal(/* @__PURE__ */ K(st.div, de({}, i, {
    ref: t
  })), r) : null;
});
function AO(e, t) {
  return P4((n, r) => {
    const i = t[n][r];
    return i ?? n;
  }, e);
}
const $n = (e) => {
  const { present: t, children: n } = e, r = RO(t), i = typeof n == "function" ? n({
    present: r.isPresent
  }) : io.only(n), o = Lt(r.ref, i.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ df(i, {
    ref: o
  }) : null;
};
$n.displayName = "Presence";
function RO(e) {
  const [t, n] = ue(), r = he({}), i = he(e), o = he("none"), a = e ? "mounted" : "unmounted", [s, c] = AO(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return _e(() => {
    const f = Rc(r.current);
    o.current = s === "mounted" ? f : "none";
  }, [
    s
  ]), Vo(() => {
    const f = r.current, p = i.current;
    if (p !== e) {
      const h = o.current, m = Rc(f);
      e ? c("MOUNT") : m === "none" || (f == null ? void 0 : f.display) === "none" ? c("UNMOUNT") : c(p && h !== m ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [
    e,
    c
  ]), Vo(() => {
    if (t) {
      const f = (d) => {
        const m = Rc(r.current).includes(d.animationName);
        d.target === t && m && pf(
          () => c("ANIMATION_END")
        );
      }, p = (d) => {
        d.target === t && (o.current = Rc(r.current));
      };
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: Me((f) => {
      f && (r.current = getComputedStyle(f)), n(f);
    }, [])
  };
}
function Rc(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function si({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, i] = $O({
    defaultProp: t,
    onChange: n
  }), o = e !== void 0, a = o ? e : r, s = ri(n), c = Me((f) => {
    if (o) {
      const d = typeof f == "function" ? f(e) : f;
      d !== e && s(d);
    } else
      i(f);
  }, [
    o,
    e,
    i,
    s
  ]);
  return [
    a,
    c
  ];
}
function $O({ defaultProp: e, onChange: t }) {
  const n = ue(e), [r] = n, i = he(r), o = ri(t);
  return _e(() => {
    i.current !== r && (o(r), i.current = r);
  }, [
    r,
    i,
    o
  ]), n;
}
var OO = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, ga = /* @__PURE__ */ new WeakMap(), $c = /* @__PURE__ */ new WeakMap(), Oc = {}, zp = 0, ox = function(e) {
  return e && (e.host || ox(e.parentNode));
}, MO = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = ox(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, DO = function(e, t, n, r) {
  var i = MO(t, Array.isArray(e) ? e : [e]);
  Oc[n] || (Oc[n] = /* @__PURE__ */ new WeakMap());
  var o = Oc[n], a = [], s = /* @__PURE__ */ new Set(), c = new Set(i), f = function(d) {
    !d || s.has(d) || (s.add(d), f(d.parentNode));
  };
  i.forEach(f);
  var p = function(d) {
    !d || c.has(d) || Array.prototype.forEach.call(d.children, function(h) {
      if (s.has(h))
        p(h);
      else
        try {
          var m = h.getAttribute(r), v = m !== null && m !== "false", w = (ga.get(h) || 0) + 1, b = (o.get(h) || 0) + 1;
          ga.set(h, w), o.set(h, b), a.push(h), w === 1 && v && $c.set(h, !0), b === 1 && h.setAttribute(n, "true"), v || h.setAttribute(r, "true");
        } catch (E) {
          console.error("aria-hidden: cannot operate on ", h, E);
        }
    });
  };
  return p(t), s.clear(), zp++, function() {
    a.forEach(function(d) {
      var h = ga.get(d) - 1, m = o.get(d) - 1;
      ga.set(d, h), o.set(d, m), h || ($c.has(d) || d.removeAttribute(r), $c.delete(d)), m || d.removeAttribute(n);
    }), zp--, zp || (ga = /* @__PURE__ */ new WeakMap(), ga = /* @__PURE__ */ new WeakMap(), $c = /* @__PURE__ */ new WeakMap(), Oc = {});
  };
}, Wg = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), i = t || OO(e);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), DO(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, Kh = function(e, t) {
  return Kh = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r)
      Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, Kh(e, t);
};
function ax(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Kh(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var ve = function() {
  return ve = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, ve.apply(this, arguments);
};
function jn(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function NO(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n)
    return n.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function jt(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; )
      o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}
function yr(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = t.length, o; r < i; r++)
      (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var fu = "right-scroll-bar-position", du = "width-before-scroll-bar", IO = "with-scroll-bars-hidden", LO = "--removed-body-scroll-bar-size";
function Vp(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function FO(e, t) {
  var n = ue(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var zO = typeof window < "u" ? D.useLayoutEffect : D.useEffect, My = /* @__PURE__ */ new WeakMap();
function VO(e, t) {
  var n = FO(t || null, function(r) {
    return e.forEach(function(i) {
      return Vp(i, r);
    });
  });
  return zO(function() {
    var r = My.get(n);
    if (r) {
      var i = new Set(r), o = new Set(e), a = n.current;
      i.forEach(function(s) {
        o.has(s) || Vp(s, null);
      }), o.forEach(function(s) {
        i.has(s) || Vp(s, a);
      });
    }
    My.set(n, e);
  }, [e]), n;
}
function BO(e) {
  return e;
}
function HO(e, t) {
  t === void 0 && (t = BO);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(o) {
      var a = t(o, r);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(o);
      }
      n = {
        push: function(s) {
          return o(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(o), a = n;
      }
      var c = function() {
        var p = a;
        a = [], p.forEach(o);
      }, f = function() {
        return Promise.resolve().then(c);
      };
      f(), n = {
        push: function(p) {
          a.push(p), f();
        },
        filter: function(p) {
          return a = a.filter(p), n;
        }
      };
    }
  };
  return i;
}
function UO(e) {
  e === void 0 && (e = {});
  var t = HO(null);
  return t.options = ve({ async: !0, ssr: !1 }, e), t;
}
var sx = function(e) {
  var t = e.sideCar, n = jn(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return D.createElement(r, ve({}, n));
};
sx.isSideCarExport = !0;
function WO(e, t) {
  return e.useMedium(t), sx;
}
var lx = UO(), Bp = function() {
}, Cf = D.forwardRef(function(e, t) {
  var n = D.useRef(null), r = D.useState({
    onScrollCapture: Bp,
    onWheelCapture: Bp,
    onTouchMoveCapture: Bp
  }), i = r[0], o = r[1], a = e.forwardProps, s = e.children, c = e.className, f = e.removeScrollBar, p = e.enabled, d = e.shards, h = e.sideCar, m = e.noIsolation, v = e.inert, w = e.allowPinchZoom, b = e.as, E = b === void 0 ? "div" : b, C = jn(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), S = h, _ = VO([n, t]), T = ve(ve({}, C), i);
  return D.createElement(
    D.Fragment,
    null,
    p && D.createElement(S, { sideCar: lx, removeScrollBar: f, shards: d, noIsolation: m, inert: v, setCallbacks: o, allowPinchZoom: !!w, lockRef: n }),
    a ? D.cloneElement(D.Children.only(s), ve(ve({}, T), { ref: _ })) : D.createElement(E, ve({}, T, { className: c, ref: _ }), s)
  );
});
Cf.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Cf.classNames = {
  fullWidth: du,
  zeroRight: fu
};
var Dy, jO = function() {
  if (Dy)
    return Dy;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function qO() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = jO();
  return t && e.setAttribute("nonce", t), e;
}
function GO(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function YO(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var KO = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = qO()) && (GO(t, n), YO(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, XO = function() {
  var e = KO();
  return function(t, n) {
    D.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, cx = function() {
  var e = XO(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, QO = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Hp = function(e) {
  return parseInt(e || "", 10) || 0;
}, ZO = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Hp(n), Hp(r), Hp(i)];
}, JO = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return QO;
  var t = ZO(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, eM = cx(), Ra = "data-scroll-locked", tM = function(e, t, n, r) {
  var i = e.left, o = e.top, a = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(IO, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(Ra, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(fu, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(du, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(fu, " .").concat(fu, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(du, " .").concat(du, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Ra, `] {
    `).concat(LO, ": ").concat(s, `px;
  }
`);
}, Ny = function() {
  var e = parseInt(document.body.getAttribute(Ra) || "0", 10);
  return isFinite(e) ? e : 0;
}, nM = function() {
  D.useEffect(function() {
    return document.body.setAttribute(Ra, (Ny() + 1).toString()), function() {
      var e = Ny() - 1;
      e <= 0 ? document.body.removeAttribute(Ra) : document.body.setAttribute(Ra, e.toString());
    };
  }, []);
}, rM = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
  nM();
  var o = D.useMemo(function() {
    return JO(i);
  }, [i]);
  return D.createElement(eM, { styles: tM(o, !t, i, n ? "" : "!important") });
}, Xh = !1;
if (typeof window < "u")
  try {
    var Mc = Object.defineProperty({}, "passive", {
      get: function() {
        return Xh = !0, !0;
      }
    });
    window.addEventListener("test", Mc, Mc), window.removeEventListener("test", Mc, Mc);
  } catch {
    Xh = !1;
  }
var va = Xh ? { passive: !1 } : !1, iM = function(e) {
  return e.tagName === "TEXTAREA";
}, ux = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !iM(e) && n[t] === "visible")
  );
}, oM = function(e) {
  return ux(e, "overflowY");
}, aM = function(e) {
  return ux(e, "overflowX");
}, Iy = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = fx(e, n);
    if (r) {
      var i = dx(e, n), o = i[1], a = i[2];
      if (o > a)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, sM = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, lM = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, fx = function(e, t) {
  return e === "v" ? oM(t) : aM(t);
}, dx = function(e, t) {
  return e === "v" ? sM(t) : lM(t);
}, cM = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, uM = function(e, t, n, r, i) {
  var o = cM(e, window.getComputedStyle(t).direction), a = o * r, s = n.target, c = t.contains(s), f = !1, p = a > 0, d = 0, h = 0;
  do {
    var m = dx(e, s), v = m[0], w = m[1], b = m[2], E = w - b - o * v;
    (v || E) && fx(e, s) && (d += E, h += v), s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (p && (i && d === 0 || !i && a > d) || !p && (i && h === 0 || !i && -a > h)) && (f = !0), f;
}, Dc = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Ly = function(e) {
  return [e.deltaX, e.deltaY];
}, Fy = function(e) {
  return e && "current" in e ? e.current : e;
}, fM = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, dM = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, pM = 0, wa = [];
function hM(e) {
  var t = D.useRef([]), n = D.useRef([0, 0]), r = D.useRef(), i = D.useState(pM++)[0], o = D.useState(function() {
    return cx();
  })[0], a = D.useRef(e);
  D.useEffect(function() {
    a.current = e;
  }, [e]), D.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var w = yr([e.lockRef.current], (e.shards || []).map(Fy), !0).filter(Boolean);
      return w.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), w.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = D.useCallback(function(w, b) {
    if ("touches" in w && w.touches.length === 2)
      return !a.current.allowPinchZoom;
    var E = Dc(w), C = n.current, S = "deltaX" in w ? w.deltaX : C[0] - E[0], _ = "deltaY" in w ? w.deltaY : C[1] - E[1], T, P = w.target, R = Math.abs(S) > Math.abs(_) ? "h" : "v";
    if ("touches" in w && R === "h" && P.type === "range")
      return !1;
    var N = Iy(R, P);
    if (!N)
      return !0;
    if (N ? T = R : (T = R === "v" ? "h" : "v", N = Iy(R, P)), !N)
      return !1;
    if (!r.current && "changedTouches" in w && (S || _) && (r.current = T), !T)
      return !0;
    var B = r.current || T;
    return uM(B, b, w, B === "h" ? S : _, !0);
  }, []), c = D.useCallback(function(w) {
    var b = w;
    if (!(!wa.length || wa[wa.length - 1] !== o)) {
      var E = "deltaY" in b ? Ly(b) : Dc(b), C = t.current.filter(function(T) {
        return T.name === b.type && T.target === b.target && fM(T.delta, E);
      })[0];
      if (C && C.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!C) {
        var S = (a.current.shards || []).map(Fy).filter(Boolean).filter(function(T) {
          return T.contains(b.target);
        }), _ = S.length > 0 ? s(b, S[0]) : !a.current.noIsolation;
        _ && b.cancelable && b.preventDefault();
      }
    }
  }, []), f = D.useCallback(function(w, b, E, C) {
    var S = { name: w, delta: b, target: E, should: C };
    t.current.push(S), setTimeout(function() {
      t.current = t.current.filter(function(_) {
        return _ !== S;
      });
    }, 1);
  }, []), p = D.useCallback(function(w) {
    n.current = Dc(w), r.current = void 0;
  }, []), d = D.useCallback(function(w) {
    f(w.type, Ly(w), w.target, s(w, e.lockRef.current));
  }, []), h = D.useCallback(function(w) {
    f(w.type, Dc(w), w.target, s(w, e.lockRef.current));
  }, []);
  D.useEffect(function() {
    return wa.push(o), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", c, va), document.addEventListener("touchmove", c, va), document.addEventListener("touchstart", p, va), function() {
      wa = wa.filter(function(w) {
        return w !== o;
      }), document.removeEventListener("wheel", c, va), document.removeEventListener("touchmove", c, va), document.removeEventListener("touchstart", p, va);
    };
  }, []);
  var m = e.removeScrollBar, v = e.inert;
  return D.createElement(
    D.Fragment,
    null,
    v ? D.createElement(o, { styles: dM(i) }) : null,
    m ? D.createElement(rM, { gapMode: "margin" }) : null
  );
}
const mM = WO(lx, hM);
var px = D.forwardRef(function(e, t) {
  return D.createElement(Cf, ve({}, e, { ref: t, sideCar: mM }));
});
px.classNames = Cf.classNames;
const jg = px, hx = "Popover", [mx, mse] = ar(hx, [
  Ga
]), Sf = Ga(), [gM, co] = mx(hx), vM = (e) => {
  const { __scopePopover: t, children: n, open: r, defaultOpen: i, onOpenChange: o, modal: a = !1 } = e, s = Sf(t), c = he(null), [f, p] = ue(!1), [d = !1, h] = si({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ K(Hg, s, /* @__PURE__ */ K(gM, {
    scope: t,
    contentId: zr(),
    triggerRef: c,
    open: d,
    onOpenChange: h,
    onOpenToggle: Me(
      () => h(
        (m) => !m
      ),
      [
        h
      ]
    ),
    hasCustomAnchor: f,
    onCustomAnchorAdd: Me(
      () => p(!0),
      []
    ),
    onCustomAnchorRemove: Me(
      () => p(!1),
      []
    ),
    modal: a
  }, n));
}, wM = "PopoverAnchor", gse = /* @__PURE__ */ Ee((e, t) => {
  const { __scopePopover: n, ...r } = e, i = co(wM, n), o = Sf(n), { onCustomAnchorAdd: a, onCustomAnchorRemove: s } = i;
  return _e(() => (a(), () => s()), [
    a,
    s
  ]), /* @__PURE__ */ K(xf, de({}, o, r, {
    ref: t
  }));
}), yM = "PopoverTrigger", bM = /* @__PURE__ */ Ee((e, t) => {
  const { __scopePopover: n, ...r } = e, i = co(yM, n), o = Sf(n), a = Lt(t, i.triggerRef), s = /* @__PURE__ */ K(st.button, de({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": i.open,
    "aria-controls": i.contentId,
    "data-state": wx(i.open)
  }, r, {
    ref: a,
    onClick: Oe(e.onClick, i.onOpenToggle)
  }));
  return i.hasCustomAnchor ? s : /* @__PURE__ */ K(xf, de({
    asChild: !0
  }, o), s);
}), gx = "PopoverPortal", [xM, EM] = mx(gx, {
  forceMount: void 0
}), CM = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: i } = e, o = co(gx, t);
  return /* @__PURE__ */ K(xM, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ K($n, {
    present: n || o.open
  }, /* @__PURE__ */ K(Ef, {
    asChild: !0,
    container: i
  }, r)));
}, Xs = "PopoverContent", SM = /* @__PURE__ */ Ee((e, t) => {
  const n = EM(Xs, e.__scopePopover), { forceMount: r = n.forceMount, ...i } = e, o = co(Xs, e.__scopePopover);
  return /* @__PURE__ */ K($n, {
    present: r || o.open
  }, o.modal ? /* @__PURE__ */ K(_M, de({}, i, {
    ref: t
  })) : /* @__PURE__ */ K(TM, de({}, i, {
    ref: t
  })));
}), _M = /* @__PURE__ */ Ee((e, t) => {
  const n = co(Xs, e.__scopePopover), r = he(null), i = Lt(t, r), o = he(!1);
  return _e(() => {
    const a = r.current;
    if (a)
      return Wg(a);
  }, []), /* @__PURE__ */ K(jg, {
    as: Ti,
    allowPinchZoom: !0
  }, /* @__PURE__ */ K(vx, de({}, e, {
    ref: i,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: Oe(e.onCloseAutoFocus, (a) => {
      var s;
      a.preventDefault(), o.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: Oe(e.onPointerDownOutside, (a) => {
      const s = a.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, f = s.button === 2 || c;
      o.current = f;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: Oe(
      e.onFocusOutside,
      (a) => a.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), TM = /* @__PURE__ */ Ee((e, t) => {
  const n = co(Xs, e.__scopePopover), r = he(!1), i = he(!1);
  return /* @__PURE__ */ K(vx, de({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (o) => {
      var a;
      if ((a = e.onCloseAutoFocus) === null || a === void 0 || a.call(e, o), !o.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), o.preventDefault();
      }
      r.current = !1, i.current = !1;
    },
    onInteractOutside: (o) => {
      var a, s;
      (a = e.onInteractOutside) === null || a === void 0 || a.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
      const c = o.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
    }
  }));
}), vx = /* @__PURE__ */ Ee((e, t) => {
  const { __scopePopover: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, disableOutsidePointerEvents: a, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: f, onInteractOutside: p, ...d } = e, h = co(Xs, n), m = Sf(n);
  return Mg(), /* @__PURE__ */ K(Dg, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o
  }, /* @__PURE__ */ K(vf, {
    asChild: !0,
    disableOutsidePointerEvents: a,
    onInteractOutside: p,
    onEscapeKeyDown: s,
    onPointerDownOutside: c,
    onFocusOutside: f,
    onDismiss: () => h.onOpenChange(!1)
  }, /* @__PURE__ */ K(Ug, de({
    "data-state": wx(h.open),
    role: "dialog",
    id: h.contentId
  }, m, d, {
    ref: t,
    style: {
      ...d.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
}), kM = "PopoverClose", PM = /* @__PURE__ */ Ee((e, t) => {
  const { __scopePopover: n, ...r } = e, i = co(kM, n);
  return /* @__PURE__ */ K(st.button, de({
    type: "button"
  }, r, {
    ref: t,
    onClick: Oe(
      e.onClick,
      () => i.onOpenChange(!1)
    )
  }));
});
function wx(e) {
  return e ? "open" : "closed";
}
const yx = vM, bx = bM, xx = CM, qg = SM, AM = PM;
var zy = "production", Gg = typeof process > "u" || process.env === void 0 ? zy : process.env.NODE_ENV || zy, Ei = function(e) {
  return {
    isEnabled: function(t) {
      return e.some(function(n) {
        return !!t[n];
      });
    }
  };
}, Qs = {
  measureLayout: Ei(["layout", "layoutId", "drag"]),
  animation: Ei([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView"
  ]),
  exit: Ei(["exit"]),
  drag: Ei(["drag", "dragControls"]),
  focus: Ei(["whileFocus"]),
  hover: Ei(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: Ei(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: Ei([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  inView: Ei([
    "whileInView",
    "onViewportEnter",
    "onViewportLeave"
  ])
};
function RM(e) {
  for (var t in e)
    e[t] !== null && (t === "projectionNodeConstructor" ? Qs.projectionNodeConstructor = e[t] : Qs[t].Component = e[t]);
}
var wl = function() {
}, xr = function() {
};
process.env.NODE_ENV !== "production" && (wl = function(e, t) {
  !e && typeof console < "u" && console.warn(t);
}, xr = function(e, t) {
  if (!e)
    throw new Error(t);
});
var Ex = ln({ strict: !1 }), Cx = Object.keys(Qs), $M = Cx.length;
function OM(e, t, n) {
  var r = [], i = Re(Ex);
  if (!t)
    return null;
  Gg !== "production" && n && i.strict && xr(!1, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
  for (var o = 0; o < $M; o++) {
    var a = Cx[o], s = Qs[a], c = s.isEnabled, f = s.Component;
    c(e) && f && r.push(D.createElement(f, ve({ key: a }, e, { visualElement: t })));
  }
  return r;
}
var Yg = ln({
  transformPagePoint: function(e) {
    return e;
  },
  isStatic: !1,
  reducedMotion: "never"
}), _f = ln({});
function MM() {
  return Re(_f).visualElement;
}
var yl = ln(null), Ya = typeof document < "u", $u = Ya ? gl : _e, Qh = { current: null }, Sx = !1;
function DM() {
  if (Sx = !0, !!Ya)
    if (window.matchMedia) {
      var e = window.matchMedia("(prefers-reduced-motion)"), t = function() {
        return Qh.current = e.matches;
      };
      e.addListener(t), t();
    } else
      Qh.current = !1;
}
function NM() {
  !Sx && DM();
  var e = jt(ue(Qh.current), 1), t = e[0];
  return t;
}
function IM() {
  var e = NM(), t = Re(Yg).reducedMotion;
  return t === "never" ? !1 : t === "always" ? !0 : e;
}
function LM(e, t, n, r) {
  var i = Re(Ex), o = MM(), a = Re(yl), s = IM(), c = he(void 0);
  r || (r = i.renderer), !c.current && r && (c.current = r(e, {
    visualState: t,
    parent: o,
    props: n,
    presenceId: a == null ? void 0 : a.id,
    blockInitialAnimation: (a == null ? void 0 : a.initial) === !1,
    shouldReduceMotion: s
  }));
  var f = c.current;
  return $u(function() {
    f == null || f.syncRender();
  }), _e(function() {
    var p;
    (p = f == null ? void 0 : f.animationState) === null || p === void 0 || p.animateChanges();
  }), $u(function() {
    return function() {
      return f == null ? void 0 : f.notifyUnmount();
    };
  }, []), f;
}
function _a(e) {
  return typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function FM(e, t, n) {
  return Me(
    function(r) {
      var i;
      r && ((i = e.mount) === null || i === void 0 || i.call(e, r)), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : _a(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function _x(e) {
  return Array.isArray(e);
}
function Ir(e) {
  return typeof e == "string" || _x(e);
}
function zM(e) {
  var t = {};
  return e.forEachValue(function(n, r) {
    return t[r] = n.get();
  }), t;
}
function VM(e) {
  var t = {};
  return e.forEachValue(function(n, r) {
    return t[r] = n.getVelocity();
  }), t;
}
function Tx(e, t, n, r, i) {
  var o;
  return r === void 0 && (r = {}), i === void 0 && (i = {}), typeof t == "function" && (t = t(n ?? e.custom, r, i)), typeof t == "string" && (t = (o = e.variants) === null || o === void 0 ? void 0 : o[t]), typeof t == "function" && (t = t(n ?? e.custom, r, i)), t;
}
function Tf(e, t, n) {
  var r = e.getProps();
  return Tx(r, t, n ?? r.custom, zM(e), VM(e));
}
function kf(e) {
  var t;
  return typeof ((t = e.animate) === null || t === void 0 ? void 0 : t.start) == "function" || Ir(e.initial) || Ir(e.animate) || Ir(e.whileHover) || Ir(e.whileDrag) || Ir(e.whileTap) || Ir(e.whileFocus) || Ir(e.exit);
}
function kx(e) {
  return !!(kf(e) || e.variants);
}
function BM(e, t) {
  if (kf(e)) {
    var n = e.initial, r = e.animate;
    return {
      initial: n === !1 || Ir(n) ? n : void 0,
      animate: Ir(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function HM(e) {
  var t = BM(e, Re(_f)), n = t.initial, r = t.animate;
  return yn(function() {
    return { initial: n, animate: r };
  }, [Vy(n), Vy(r)]);
}
function Vy(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
function Ka(e) {
  var t = he(null);
  return t.current === null && (t.current = e()), t.current;
}
var Ls = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, UM = 1;
function WM() {
  return Ka(function() {
    if (Ls.hasEverUpdated)
      return UM++;
  });
}
var Kg = ln({}), Px = ln({});
function jM(e, t, n, r) {
  var i, o = t.layoutId, a = t.layout, s = t.drag, c = t.dragConstraints, f = t.layoutScroll, p = Re(Px);
  !r || !n || n != null && n.projection || (n.projection = new r(e, n.getLatestValues(), (i = n.parent) === null || i === void 0 ? void 0 : i.projection), n.projection.setOptions({
    layoutId: o,
    layout: a,
    alwaysMeasureLayout: !!s || c && _a(c),
    visualElement: n,
    scheduleRender: function() {
      return n.scheduleRender();
    },
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof a == "string" ? a : "both",
    initialPromotionConfig: p,
    layoutScroll: f
  }));
}
var qM = (
  /** @class */
  function(e) {
    ax(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.getSnapshotBeforeUpdate = function() {
      return this.updateProps(), null;
    }, t.prototype.componentDidUpdate = function() {
    }, t.prototype.updateProps = function() {
      var n = this.props, r = n.visualElement, i = n.props;
      r && r.setProps(i);
    }, t.prototype.render = function() {
      return this.props.children;
    }, t;
  }(y.Component)
);
function GM(e) {
  var t = e.preloadedFeatures, n = e.createVisualElement, r = e.projectionNodeConstructor, i = e.useRender, o = e.useVisualState, a = e.Component;
  t && RM(t);
  function s(c, f) {
    var p = YM(c);
    c = ve(ve({}, c), { layoutId: p });
    var d = Re(Yg), h = null, m = HM(c), v = d.isStatic ? void 0 : WM(), w = o(c, d.isStatic);
    return !d.isStatic && Ya && (m.visualElement = LM(a, w, ve(ve({}, d), c), n), jM(v, c, m.visualElement, r || Qs.projectionNodeConstructor), h = OM(c, m.visualElement, t)), D.createElement(
      qM,
      { visualElement: m.visualElement, props: ve(ve({}, d), c) },
      h,
      D.createElement(_f.Provider, { value: m }, i(a, c, v, FM(w, m.visualElement, f), w, d.isStatic, m.visualElement))
    );
  }
  return Ee(s);
}
function YM(e) {
  var t, n = e.layoutId, r = (t = Re(Kg)) === null || t === void 0 ? void 0 : t.id;
  return r && n !== void 0 ? r + "-" + n : n;
}
function KM(e) {
  function t(r, i) {
    return i === void 0 && (i = {}), GM(e(r, i));
  }
  if (typeof Proxy > "u")
    return t;
  var n = /* @__PURE__ */ new Map();
  return new Proxy(t, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: function(r, i) {
      return n.has(i) || n.set(i, t(i)), n.get(i);
    }
  });
}
var XM = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];
function Xg(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(XM.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
var Ou = {};
function QM(e) {
  Object.assign(Ou, e);
}
var Zh = ["", "X", "Y", "Z"], ZM = ["translate", "scale", "rotate", "skew"], Zs = ["transformPerspective", "x", "y", "z"];
ZM.forEach(function(e) {
  return Zh.forEach(function(t) {
    return Zs.push(e + t);
  });
});
function JM(e, t) {
  return Zs.indexOf(e) - Zs.indexOf(t);
}
var eD = new Set(Zs);
function bl(e) {
  return eD.has(e);
}
var tD = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function Ax(e) {
  return tD.has(e);
}
function Rx(e, t) {
  var n = t.layout, r = t.layoutId;
  return bl(e) || Ax(e) || (n || r !== void 0) && (!!Ou[e] || e === "opacity");
}
var Ai = function(e) {
  return !!(e !== null && typeof e == "object" && e.getVelocity);
}, nD = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function rD(e, t, n, r) {
  var i = e.transform, o = e.transformKeys, a = t.enableHardwareAcceleration, s = a === void 0 ? !0 : a, c = t.allowTransformNone, f = c === void 0 ? !0 : c, p = "";
  o.sort(JM);
  for (var d = !1, h = o.length, m = 0; m < h; m++) {
    var v = o[m];
    p += "".concat(nD[v] || v, "(").concat(i[v], ") "), v === "z" && (d = !0);
  }
  return !d && s ? p += "translateZ(0)" : p = p.trim(), r ? p = r(i, n ? "" : p) : f && n && (p = "none"), p;
}
function iD(e) {
  var t = e.originX, n = t === void 0 ? "50%" : t, r = e.originY, i = r === void 0 ? "50%" : r, o = e.originZ, a = o === void 0 ? 0 : o;
  return "".concat(n, " ").concat(i, " ").concat(a);
}
function $x(e) {
  return e.startsWith("--");
}
var oD = function(e, t) {
  return t && typeof e == "number" ? t.transform(e) : e;
};
const Ox = (e, t) => (n) => Math.max(Math.min(n, t), e), Fs = (e) => e % 1 ? Number(e.toFixed(5)) : e, Js = /(-)?([\d]*\.?[\d])+/g, Jh = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi, aD = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function xl(e) {
  return typeof e == "string";
}
const Yo = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, zs = Object.assign(Object.assign({}, Yo), { transform: Ox(0, 1) }), Nc = Object.assign(Object.assign({}, Yo), { default: 1 }), El = (e) => ({
  test: (t) => xl(t) && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), Xi = El("deg"), ni = El("%"), Be = El("px"), sD = El("vh"), lD = El("vw"), By = Object.assign(Object.assign({}, ni), { parse: (e) => ni.parse(e) / 100, transform: (e) => ni.transform(e * 100) }), Qg = (e, t) => (n) => !!(xl(n) && aD.test(n) && n.startsWith(e) || t && Object.prototype.hasOwnProperty.call(n, t)), Mx = (e, t, n) => (r) => {
  if (!xl(r))
    return r;
  const [i, o, a, s] = r.match(Js);
  return {
    [e]: parseFloat(i),
    [t]: parseFloat(o),
    [n]: parseFloat(a),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, Io = {
  test: Qg("hsl", "hue"),
  parse: Mx("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + ni.transform(Fs(t)) + ", " + ni.transform(Fs(n)) + ", " + Fs(zs.transform(r)) + ")"
}, cD = Ox(0, 255), Up = Object.assign(Object.assign({}, Yo), { transform: (e) => Math.round(cD(e)) }), to = {
  test: Qg("rgb", "red"),
  parse: Mx("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + Up.transform(e) + ", " + Up.transform(t) + ", " + Up.transform(n) + ", " + Fs(zs.transform(r)) + ")"
};
function uD(e) {
  let t = "", n = "", r = "", i = "";
  return e.length > 5 ? (t = e.substr(1, 2), n = e.substr(3, 2), r = e.substr(5, 2), i = e.substr(7, 2)) : (t = e.substr(1, 1), n = e.substr(2, 1), r = e.substr(3, 1), i = e.substr(4, 1), t += t, n += n, r += r, i += i), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const em = {
  test: Qg("#"),
  parse: uD,
  transform: to.transform
}, An = {
  test: (e) => to.test(e) || em.test(e) || Io.test(e),
  parse: (e) => to.test(e) ? to.parse(e) : Io.test(e) ? Io.parse(e) : em.parse(e),
  transform: (e) => xl(e) ? e : e.hasOwnProperty("red") ? to.transform(e) : Io.transform(e)
}, Dx = "${c}", Nx = "${n}";
function fD(e) {
  var t, n, r, i;
  return isNaN(e) && xl(e) && ((n = (t = e.match(Js)) === null || t === void 0 ? void 0 : t.length) !== null && n !== void 0 ? n : 0) + ((i = (r = e.match(Jh)) === null || r === void 0 ? void 0 : r.length) !== null && i !== void 0 ? i : 0) > 0;
}
function Ix(e) {
  typeof e == "number" && (e = `${e}`);
  const t = [];
  let n = 0;
  const r = e.match(Jh);
  r && (n = r.length, e = e.replace(Jh, Dx), t.push(...r.map(An.parse)));
  const i = e.match(Js);
  return i && (e = e.replace(Js, Nx), t.push(...i.map(Yo.parse))), { values: t, numColors: n, tokenised: e };
}
function Lx(e) {
  return Ix(e).values;
}
function Fx(e) {
  const { values: t, numColors: n, tokenised: r } = Ix(e), i = t.length;
  return (o) => {
    let a = r;
    for (let s = 0; s < i; s++)
      a = a.replace(s < n ? Dx : Nx, s < n ? An.transform(o[s]) : Fs(o[s]));
    return a;
  };
}
const dD = (e) => typeof e == "number" ? 0 : e;
function pD(e) {
  const t = Lx(e);
  return Fx(e)(t.map(dD));
}
const Ri = { test: fD, parse: Lx, createTransformer: Fx, getAnimatableNone: pD }, hD = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function mD(e) {
  let [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(Js) || [];
  if (!r)
    return e;
  const i = n.replace(r, "");
  let o = hD.has(t) ? 1 : 0;
  return r !== n && (o *= 100), t + "(" + o + i + ")";
}
const gD = /([a-z-]*)\(.*?\)/g, tm = Object.assign(Object.assign({}, Ri), { getAnimatableNone: (e) => {
  const t = e.match(gD);
  return t ? t.map(mD).join(" ") : e;
} });
var Hy = ve(ve({}, Yo), { transform: Math.round }), zx = {
  // Border props
  borderWidth: Be,
  borderTopWidth: Be,
  borderRightWidth: Be,
  borderBottomWidth: Be,
  borderLeftWidth: Be,
  borderRadius: Be,
  radius: Be,
  borderTopLeftRadius: Be,
  borderTopRightRadius: Be,
  borderBottomRightRadius: Be,
  borderBottomLeftRadius: Be,
  // Positioning props
  width: Be,
  maxWidth: Be,
  height: Be,
  maxHeight: Be,
  size: Be,
  top: Be,
  right: Be,
  bottom: Be,
  left: Be,
  // Spacing props
  padding: Be,
  paddingTop: Be,
  paddingRight: Be,
  paddingBottom: Be,
  paddingLeft: Be,
  margin: Be,
  marginTop: Be,
  marginRight: Be,
  marginBottom: Be,
  marginLeft: Be,
  // Transform props
  rotate: Xi,
  rotateX: Xi,
  rotateY: Xi,
  rotateZ: Xi,
  scale: Nc,
  scaleX: Nc,
  scaleY: Nc,
  scaleZ: Nc,
  skew: Xi,
  skewX: Xi,
  skewY: Xi,
  distance: Be,
  translateX: Be,
  translateY: Be,
  translateZ: Be,
  x: Be,
  y: Be,
  z: Be,
  perspective: Be,
  transformPerspective: Be,
  opacity: zs,
  originX: By,
  originY: By,
  originZ: Be,
  // Misc
  zIndex: Hy,
  // SVG
  fillOpacity: zs,
  strokeOpacity: zs,
  numOctaves: Hy
};
function Zg(e, t, n, r) {
  var i, o = e.style, a = e.vars, s = e.transform, c = e.transformKeys, f = e.transformOrigin;
  c.length = 0;
  var p = !1, d = !1, h = !0;
  for (var m in t) {
    var v = t[m];
    if ($x(m)) {
      a[m] = v;
      continue;
    }
    var w = zx[m], b = oD(v, w);
    if (bl(m)) {
      if (p = !0, s[m] = b, c.push(m), !h)
        continue;
      v !== ((i = w.default) !== null && i !== void 0 ? i : 0) && (h = !1);
    } else
      Ax(m) ? (f[m] = b, d = !0) : o[m] = b;
  }
  p ? o.transform = rD(e, n, h, r) : r ? o.transform = r({}, "") : !t.transform && o.transform && (o.transform = "none"), d && (o.transformOrigin = iD(f));
}
var Jg = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function Vx(e, t, n) {
  for (var r in t)
    !Ai(t[r]) && !Rx(r, n) && (e[r] = t[r]);
}
function vD(e, t, n) {
  var r = e.transformTemplate;
  return yn(function() {
    var i = Jg();
    Zg(i, t, { enableHardwareAcceleration: !n }, r);
    var o = i.vars, a = i.style;
    return ve(ve({}, o), a);
  }, [t]);
}
function wD(e, t, n) {
  var r = e.style || {}, i = {};
  return Vx(i, r, e), Object.assign(i, vD(e, t, n)), e.transformValues && (i = e.transformValues(i)), i;
}
function yD(e, t, n) {
  var r = {}, i = wD(e, t, n);
  return e.drag && e.dragListener !== !1 && (r.draggable = !1, i.userSelect = i.WebkitUserSelect = i.WebkitTouchCallout = "none", i.touchAction = e.drag === !0 ? "none" : "pan-".concat(e.drag === "x" ? "y" : "x")), r.style = i, r;
}
var bD = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "layoutDependency",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "dragSnapToOrigin",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover",
  "whileInView",
  "onViewportEnter",
  "onViewportLeave",
  "viewport",
  "layoutScroll"
]);
function Mu(e) {
  return bD.has(e);
}
var Bx = function(e) {
  return !Mu(e);
};
function xD(e) {
  e && (Bx = function(t) {
    return t.startsWith("on") ? !Mu(t) : e(t);
  });
}
try {
  xD(require("@emotion/is-prop-valid").default);
} catch {
}
function ED(e, t, n) {
  var r = {};
  for (var i in e)
    (Bx(i) || n === !0 && Mu(i) || !t && !Mu(i) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
  return r;
}
function Uy(e, t, n) {
  return typeof e == "string" ? e : Be.transform(t + n * e);
}
function CD(e, t, n) {
  var r = Uy(t, e.x, e.width), i = Uy(n, e.y, e.height);
  return "".concat(r, " ").concat(i);
}
var SD = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, _D = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function TD(e, t, n, r, i) {
  n === void 0 && (n = 1), r === void 0 && (r = 0), i === void 0 && (i = !0), e.pathLength = 1;
  var o = i ? SD : _D;
  e[o.offset] = Be.transform(-r);
  var a = Be.transform(t), s = Be.transform(n);
  e[o.array] = "".concat(a, " ").concat(s);
}
function e1(e, t, n, r) {
  var i = t.attrX, o = t.attrY, a = t.originX, s = t.originY, c = t.pathLength, f = t.pathSpacing, p = f === void 0 ? 1 : f, d = t.pathOffset, h = d === void 0 ? 0 : d, m = jn(t, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  Zg(e, m, n, r), e.attrs = e.style, e.style = {};
  var v = e.attrs, w = e.style, b = e.dimensions;
  v.transform && (b && (w.transform = v.transform), delete v.transform), b && (a !== void 0 || s !== void 0 || w.transform) && (w.transformOrigin = CD(b, a !== void 0 ? a : 0.5, s !== void 0 ? s : 0.5)), i !== void 0 && (v.x = i), o !== void 0 && (v.y = o), c !== void 0 && TD(v, c, p, h, !1);
}
var Hx = function() {
  return ve(ve({}, Jg()), { attrs: {} });
};
function kD(e, t) {
  var n = yn(function() {
    var i = Hx();
    return e1(i, t, { enableHardwareAcceleration: !1 }, e.transformTemplate), ve(ve({}, i.attrs), { style: ve({}, i.style) });
  }, [t]);
  if (e.style) {
    var r = {};
    Vx(r, e.style, e), n.style = ve(ve({}, r), n.style);
  }
  return n;
}
function PD(e) {
  e === void 0 && (e = !1);
  var t = function(n, r, i, o, a, s) {
    var c = a.latestValues, f = Xg(n) ? kD : yD, p = f(r, c, s), d = ED(r, typeof n == "string", e), h = ve(ve(ve({}, d), p), { ref: o });
    return i && (h["data-projection-id"] = i), K(n, h);
  };
  return t;
}
var AD = /([a-z])([A-Z])/g, RD = "$1-$2", Ux = function(e) {
  return e.replace(AD, RD).toLowerCase();
};
function Wx(e, t, n, r) {
  var i = t.style, o = t.vars;
  Object.assign(e.style, i, r && r.getProjectionStyles(n));
  for (var a in o)
    e.style.setProperty(a, o[a]);
}
var jx = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength"
]);
function qx(e, t, n, r) {
  Wx(e, t, void 0, r);
  for (var i in t.attrs)
    e.setAttribute(jx.has(i) ? i : Ux(i), t.attrs[i]);
}
function t1(e) {
  var t = e.style, n = {};
  for (var r in t)
    (Ai(t[r]) || Rx(r, e)) && (n[r] = t[r]);
  return n;
}
function Gx(e) {
  var t = t1(e);
  for (var n in e)
    if (Ai(e[n])) {
      var r = n === "x" || n === "y" ? "attr" + n.toUpperCase() : n;
      t[r] = e[n];
    }
  return t;
}
function n1(e) {
  return typeof e == "object" && typeof e.start == "function";
}
var el = function(e) {
  return Array.isArray(e);
}, $D = function(e) {
  return !!(e && typeof e == "object" && e.mix && e.toValue);
}, Yx = function(e) {
  return el(e) ? e[e.length - 1] || 0 : e;
};
function pu(e) {
  var t = Ai(e) ? e.get() : e;
  return $D(t) ? t.toValue() : t;
}
function Wy(e, t, n, r) {
  var i = e.scrapeMotionValuesFromProps, o = e.createRenderState, a = e.onMount, s = {
    latestValues: OD(t, n, r, i),
    renderState: o()
  };
  return a && (s.mount = function(c) {
    return a(t, c, s);
  }), s;
}
var Kx = function(e) {
  return function(t, n) {
    var r = Re(_f), i = Re(yl);
    return n ? Wy(e, t, r, i) : Ka(function() {
      return Wy(e, t, r, i);
    });
  };
};
function OD(e, t, n, r) {
  var i = {}, o = (n == null ? void 0 : n.initial) === !1, a = r(e);
  for (var s in a)
    i[s] = pu(a[s]);
  var c = e.initial, f = e.animate, p = kf(e), d = kx(e);
  t && d && !p && e.inherit !== !1 && (c ?? (c = t.initial), f ?? (f = t.animate));
  var h = o || c === !1, m = h ? f : c;
  if (m && typeof m != "boolean" && !n1(m)) {
    var v = Array.isArray(m) ? m : [m];
    v.forEach(function(w) {
      var b = Tx(e, w);
      if (b) {
        var E = b.transitionEnd;
        b.transition;
        var C = jn(b, ["transitionEnd", "transition"]);
        for (var S in C) {
          var _ = C[S];
          if (Array.isArray(_)) {
            var T = h ? _.length - 1 : 0;
            _ = _[T];
          }
          _ !== null && (i[S] = _);
        }
        for (var S in E)
          i[S] = E[S];
      }
    });
  }
  return i;
}
var MD = {
  useVisualState: Kx({
    scrapeMotionValuesFromProps: Gx,
    createRenderState: Hx,
    onMount: function(e, t, n) {
      var r = n.renderState, i = n.latestValues;
      try {
        r.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
      } catch {
        r.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      e1(r, i, { enableHardwareAcceleration: !1 }, e.transformTemplate), qx(t, r);
    }
  })
}, DD = {
  useVisualState: Kx({
    scrapeMotionValuesFromProps: t1,
    createRenderState: Jg
  })
};
function ND(e, t, n, r, i) {
  var o = t.forwardMotionProps, a = o === void 0 ? !1 : o, s = Xg(e) ? MD : DD;
  return ve(ve({}, s), { preloadedFeatures: n, useRender: PD(a), createVisualElement: r, projectionNodeConstructor: i, Component: e });
}
var $t;
(function(e) {
  e.Animate = "animate", e.Hover = "whileHover", e.Tap = "whileTap", e.Drag = "whileDrag", e.Focus = "whileFocus", e.InView = "whileInView", e.Exit = "exit";
})($t || ($t = {}));
function Pf(e, t, n, r) {
  return r === void 0 && (r = { passive: !0 }), e.addEventListener(t, n, r), function() {
    return e.removeEventListener(t, n);
  };
}
function nm(e, t, n, r) {
  _e(function() {
    var i = e.current;
    if (n && i)
      return Pf(i, t, n, r);
  }, [e, t, n, r]);
}
function ID(e) {
  var t = e.whileFocus, n = e.visualElement, r = function() {
    var o;
    (o = n.animationState) === null || o === void 0 || o.setActive($t.Focus, !0);
  }, i = function() {
    var o;
    (o = n.animationState) === null || o === void 0 || o.setActive($t.Focus, !1);
  };
  nm(n, "focus", t ? r : void 0), nm(n, "blur", t ? i : void 0);
}
function Xx(e) {
  return typeof PointerEvent < "u" && e instanceof PointerEvent ? e.pointerType === "mouse" : e instanceof MouseEvent;
}
function Qx(e) {
  var t = !!e.touches;
  return t;
}
function LD(e) {
  return function(t) {
    var n = t instanceof MouseEvent, r = !n || n && t.button === 0;
    r && e(t);
  };
}
var FD = { pageX: 0, pageY: 0 };
function zD(e, t) {
  t === void 0 && (t = "page");
  var n = e.touches[0] || e.changedTouches[0], r = n || FD;
  return {
    x: r[t + "X"],
    y: r[t + "Y"]
  };
}
function VD(e, t) {
  return t === void 0 && (t = "page"), {
    x: e[t + "X"],
    y: e[t + "Y"]
  };
}
function r1(e, t) {
  return t === void 0 && (t = "page"), {
    point: Qx(e) ? zD(e, t) : VD(e, t)
  };
}
var Zx = function(e, t) {
  t === void 0 && (t = !1);
  var n = function(r) {
    return e(r, r1(r));
  };
  return t ? LD(n) : n;
}, BD = function() {
  return Ya && window.onpointerdown === null;
}, HD = function() {
  return Ya && window.ontouchstart === null;
}, UD = function() {
  return Ya && window.onmousedown === null;
}, WD = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, jD = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function Jx(e) {
  return BD() ? e : HD() ? jD[e] : UD() ? WD[e] : e;
}
function $a(e, t, n, r) {
  return Pf(e, Jx(t), Zx(n, t === "pointerdown"), r);
}
function Du(e, t, n, r) {
  return nm(e, Jx(t), n && Zx(n, t === "pointerdown"), r);
}
function eE(e) {
  var t = null;
  return function() {
    var n = function() {
      t = null;
    };
    return t === null ? (t = e, n) : !1;
  };
}
var jy = eE("dragHorizontal"), qy = eE("dragVertical");
function tE(e) {
  var t = !1;
  if (e === "y")
    t = qy();
  else if (e === "x")
    t = jy();
  else {
    var n = jy(), r = qy();
    n && r ? t = function() {
      n(), r();
    } : (n && n(), r && r());
  }
  return t;
}
function nE() {
  var e = tE(!0);
  return e ? (e(), !1) : !0;
}
function Gy(e, t, n) {
  return function(r, i) {
    var o;
    !Xx(r) || nE() || ((o = e.animationState) === null || o === void 0 || o.setActive($t.Hover, t), n == null || n(r, i));
  };
}
function qD(e) {
  var t = e.onHoverStart, n = e.onHoverEnd, r = e.whileHover, i = e.visualElement;
  Du(i, "pointerenter", t || r ? Gy(i, !0, t) : void 0, { passive: !t }), Du(i, "pointerleave", n || r ? Gy(i, !1, n) : void 0, { passive: !n });
}
var rE = function(e, t) {
  return t ? e === t ? !0 : rE(e, t.parentElement) : !1;
};
function i1(e) {
  return _e(function() {
    return function() {
      return e();
    };
  }, []);
}
const Nu = (e, t, n) => Math.min(Math.max(n, e), t), Wp = 1e-3, GD = 0.01, Yy = 10, YD = 0.05, KD = 1;
function XD({ duration: e = 800, bounce: t = 0.25, velocity: n = 0, mass: r = 1 }) {
  let i, o;
  wl(e <= Yy * 1e3, "Spring duration must be 10 seconds or less");
  let a = 1 - t;
  a = Nu(YD, KD, a), e = Nu(GD, Yy, e / 1e3), a < 1 ? (i = (f) => {
    const p = f * a, d = p * e, h = p - n, m = rm(f, a), v = Math.exp(-d);
    return Wp - h / m * v;
  }, o = (f) => {
    const d = f * a * e, h = d * n + n, m = Math.pow(a, 2) * Math.pow(f, 2) * e, v = Math.exp(-d), w = rm(Math.pow(f, 2), a);
    return (-i(f) + Wp > 0 ? -1 : 1) * ((h - m) * v) / w;
  }) : (i = (f) => {
    const p = Math.exp(-f * e), d = (f - n) * e + 1;
    return -Wp + p * d;
  }, o = (f) => {
    const p = Math.exp(-f * e), d = (n - f) * (e * e);
    return p * d;
  });
  const s = 5 / e, c = ZD(i, o, s);
  if (e = e * 1e3, isNaN(c))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const f = Math.pow(c, 2) * r;
    return {
      stiffness: f,
      damping: a * 2 * Math.sqrt(r * f),
      duration: e
    };
  }
}
const QD = 12;
function ZD(e, t, n) {
  let r = n;
  for (let i = 1; i < QD; i++)
    r = r - e(r) / t(r);
  return r;
}
function rm(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const JD = ["duration", "bounce"], eN = ["stiffness", "damping", "mass"];
function Ky(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function tN(e) {
  let t = Object.assign({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: !1 }, e);
  if (!Ky(e, eN) && Ky(e, JD)) {
    const n = XD(e);
    t = Object.assign(Object.assign(Object.assign({}, t), n), { velocity: 0, mass: 1 }), t.isResolvedFromDuration = !0;
  }
  return t;
}
function o1(e) {
  var { from: t = 0, to: n = 1, restSpeed: r = 2, restDelta: i } = e, o = jn(e, ["from", "to", "restSpeed", "restDelta"]);
  const a = { done: !1, value: t };
  let { stiffness: s, damping: c, mass: f, velocity: p, duration: d, isResolvedFromDuration: h } = tN(o), m = Xy, v = Xy;
  function w() {
    const b = p ? -(p / 1e3) : 0, E = n - t, C = c / (2 * Math.sqrt(s * f)), S = Math.sqrt(s / f) / 1e3;
    if (i === void 0 && (i = Math.min(Math.abs(n - t) / 100, 0.4)), C < 1) {
      const _ = rm(S, C);
      m = (T) => {
        const P = Math.exp(-C * S * T);
        return n - P * ((b + C * S * E) / _ * Math.sin(_ * T) + E * Math.cos(_ * T));
      }, v = (T) => {
        const P = Math.exp(-C * S * T);
        return C * S * P * (Math.sin(_ * T) * (b + C * S * E) / _ + E * Math.cos(_ * T)) - P * (Math.cos(_ * T) * (b + C * S * E) - _ * E * Math.sin(_ * T));
      };
    } else if (C === 1)
      m = (_) => n - Math.exp(-S * _) * (E + (b + S * E) * _);
    else {
      const _ = S * Math.sqrt(C * C - 1);
      m = (T) => {
        const P = Math.exp(-C * S * T), R = Math.min(_ * T, 300);
        return n - P * ((b + C * S * E) * Math.sinh(R) + _ * E * Math.cosh(R)) / _;
      };
    }
  }
  return w(), {
    next: (b) => {
      const E = m(b);
      if (h)
        a.done = b >= d;
      else {
        const C = v(b) * 1e3, S = Math.abs(C) <= r, _ = Math.abs(n - E) <= i;
        a.done = S && _;
      }
      return a.value = a.done ? n : E, a;
    },
    flipTarget: () => {
      p = -p, [t, n] = [n, t], w();
    }
  };
}
o1.needsInterpolation = (e, t) => typeof e == "string" || typeof t == "string";
const Xy = (e) => 0, tl = (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
}, Wt = (e, t, n) => -n * e + n * t + e;
function jp(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function Qy({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let i = 0, o = 0, a = 0;
  if (!t)
    i = o = a = n;
  else {
    const s = n < 0.5 ? n * (1 + t) : n + t - n * t, c = 2 * n - s;
    i = jp(c, s, e + 1 / 3), o = jp(c, s, e), a = jp(c, s, e - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(o * 255),
    blue: Math.round(a * 255),
    alpha: r
  };
}
const nN = (e, t, n) => {
  const r = e * e, i = t * t;
  return Math.sqrt(Math.max(0, n * (i - r) + r));
}, rN = [em, to, Io], Zy = (e) => rN.find((t) => t.test(e)), Jy = (e) => `'${e}' is not an animatable color. Use the equivalent color code instead.`, iE = (e, t) => {
  let n = Zy(e), r = Zy(t);
  xr(!!n, Jy(e)), xr(!!r, Jy(t));
  let i = n.parse(e), o = r.parse(t);
  n === Io && (i = Qy(i), n = to), r === Io && (o = Qy(o), r = to);
  const a = Object.assign({}, i);
  return (s) => {
    for (const c in a)
      c !== "alpha" && (a[c] = nN(i[c], o[c], s));
    return a.alpha = Wt(i.alpha, o.alpha, s), n.transform(a);
  };
}, im = (e) => typeof e == "number", iN = (e, t) => (n) => t(e(n)), Af = (...e) => e.reduce(iN);
function oE(e, t) {
  return im(e) ? (n) => Wt(e, t, n) : An.test(e) ? iE(e, t) : sE(e, t);
}
const aE = (e, t) => {
  const n = [...e], r = n.length, i = e.map((o, a) => oE(o, t[a]));
  return (o) => {
    for (let a = 0; a < r; a++)
      n[a] = i[a](o);
    return n;
  };
}, oN = (e, t) => {
  const n = Object.assign(Object.assign({}, e), t), r = {};
  for (const i in n)
    e[i] !== void 0 && t[i] !== void 0 && (r[i] = oE(e[i], t[i]));
  return (i) => {
    for (const o in r)
      n[o] = r[o](i);
    return n;
  };
};
function eb(e) {
  const t = Ri.parse(e), n = t.length;
  let r = 0, i = 0, o = 0;
  for (let a = 0; a < n; a++)
    r || typeof t[a] == "number" ? r++ : t[a].hue !== void 0 ? o++ : i++;
  return { parsed: t, numNumbers: r, numRGB: i, numHSL: o };
}
const sE = (e, t) => {
  const n = Ri.createTransformer(t), r = eb(e), i = eb(t);
  return r.numHSL === i.numHSL && r.numRGB === i.numRGB && r.numNumbers >= i.numNumbers ? Af(aE(r.parsed, i.parsed), n) : (wl(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), (a) => `${a > 0 ? t : e}`);
}, aN = (e, t) => (n) => Wt(e, t, n);
function sN(e) {
  if (typeof e == "number")
    return aN;
  if (typeof e == "string")
    return An.test(e) ? iE : sE;
  if (Array.isArray(e))
    return aE;
  if (typeof e == "object")
    return oN;
}
function lN(e, t, n) {
  const r = [], i = n || sN(e[0]), o = e.length - 1;
  for (let a = 0; a < o; a++) {
    let s = i(e[a], e[a + 1]);
    if (t) {
      const c = Array.isArray(t) ? t[a] : t;
      s = Af(c, s);
    }
    r.push(s);
  }
  return r;
}
function cN([e, t], [n]) {
  return (r) => n(tl(e, t, r));
}
function uN(e, t) {
  const n = e.length, r = n - 1;
  return (i) => {
    let o = 0, a = !1;
    if (i <= e[0] ? a = !0 : i >= e[r] && (o = r - 1, a = !0), !a) {
      let c = 1;
      for (; c < n && !(e[c] > i || c === r); c++)
        ;
      o = c - 1;
    }
    const s = tl(e[o], e[o + 1], i);
    return t[o](s);
  };
}
function lE(e, t, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const o = e.length;
  xr(o === t.length, "Both input and output ranges must be the same length"), xr(!r || !Array.isArray(r) || r.length === o - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), e[0] > e[o - 1] && (e = [].concat(e), t = [].concat(t), e.reverse(), t.reverse());
  const a = lN(t, r, i), s = o === 2 ? cN(e, a) : uN(e, a);
  return n ? (c) => s(Nu(e[0], e[o - 1], c)) : s;
}
const Rf = (e) => (t) => 1 - e(1 - t), a1 = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, fN = (e) => (t) => Math.pow(t, e), cE = (e) => (t) => t * t * ((e + 1) * t - e), dN = (e) => {
  const t = cE(e);
  return (n) => (n *= 2) < 1 ? 0.5 * t(n) : 0.5 * (2 - Math.pow(2, -10 * (n - 1)));
}, uE = 1.525, pN = 4 / 11, hN = 8 / 11, mN = 9 / 10, s1 = (e) => e, l1 = fN(2), gN = Rf(l1), fE = a1(l1), dE = (e) => 1 - Math.sin(Math.acos(e)), c1 = Rf(dE), vN = a1(c1), u1 = cE(uE), wN = Rf(u1), yN = a1(u1), bN = dN(uE), xN = 4356 / 361, EN = 35442 / 1805, CN = 16061 / 1805, Iu = (e) => {
  if (e === 1 || e === 0)
    return e;
  const t = e * e;
  return e < pN ? 7.5625 * t : e < hN ? 9.075 * t - 9.9 * e + 3.4 : e < mN ? xN * t - EN * e + CN : 10.8 * e * e - 20.52 * e + 10.72;
}, SN = Rf(Iu), _N = (e) => e < 0.5 ? 0.5 * (1 - Iu(1 - e * 2)) : 0.5 * Iu(e * 2 - 1) + 0.5;
function TN(e, t) {
  return e.map(() => t || fE).splice(0, e.length - 1);
}
function kN(e) {
  const t = e.length;
  return e.map((n, r) => r !== 0 ? r / (t - 1) : 0);
}
function PN(e, t) {
  return e.map((n) => n * t);
}
function hu({ from: e = 0, to: t = 1, ease: n, offset: r, duration: i = 300 }) {
  const o = { done: !1, value: e }, a = Array.isArray(t) ? t : [e, t], s = PN(r && r.length === a.length ? r : kN(a), i);
  function c() {
    return lE(s, a, {
      ease: Array.isArray(n) ? n : TN(a, n)
    });
  }
  let f = c();
  return {
    next: (p) => (o.value = f(p), o.done = p >= i, o),
    flipTarget: () => {
      a.reverse(), f = c();
    }
  };
}
function AN({ velocity: e = 0, from: t = 0, power: n = 0.8, timeConstant: r = 350, restDelta: i = 0.5, modifyTarget: o }) {
  const a = { done: !1, value: t };
  let s = n * e;
  const c = t + s, f = o === void 0 ? c : o(c);
  return f !== c && (s = f - t), {
    next: (p) => {
      const d = -s * Math.exp(-p / r);
      return a.done = !(d > i || d < -i), a.value = a.done ? f : f + d, a;
    },
    flipTarget: () => {
    }
  };
}
const tb = { keyframes: hu, spring: o1, decay: AN };
function RN(e) {
  if (Array.isArray(e.to))
    return hu;
  if (tb[e.type])
    return tb[e.type];
  const t = new Set(Object.keys(e));
  return t.has("ease") || t.has("duration") && !t.has("dampingRatio") ? hu : t.has("dampingRatio") || t.has("stiffness") || t.has("mass") || t.has("damping") || t.has("restSpeed") || t.has("restDelta") ? o1 : hu;
}
const pE = 1 / 60 * 1e3, $N = typeof performance < "u" ? () => performance.now() : () => Date.now(), hE = typeof window < "u" ? (e) => window.requestAnimationFrame(e) : (e) => setTimeout(() => e($N()), pE);
function ON(e) {
  let t = [], n = [], r = 0, i = !1, o = !1;
  const a = /* @__PURE__ */ new WeakSet(), s = {
    schedule: (c, f = !1, p = !1) => {
      const d = p && i, h = d ? t : n;
      return f && a.add(c), h.indexOf(c) === -1 && (h.push(c), d && i && (r = t.length)), c;
    },
    cancel: (c) => {
      const f = n.indexOf(c);
      f !== -1 && n.splice(f, 1), a.delete(c);
    },
    process: (c) => {
      if (i) {
        o = !0;
        return;
      }
      if (i = !0, [t, n] = [n, t], n.length = 0, r = t.length, r)
        for (let f = 0; f < r; f++) {
          const p = t[f];
          p(c), a.has(p) && (s.schedule(p), e());
        }
      i = !1, o && (o = !1, s.process(c));
    }
  };
  return s;
}
const MN = 40;
let om = !0, nl = !1, am = !1;
const Oa = {
  delta: 0,
  timestamp: 0
}, Cl = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], $f = Cl.reduce((e, t) => (e[t] = ON(() => nl = !0), e), {}), Vr = Cl.reduce((e, t) => {
  const n = $f[t];
  return e[t] = (r, i = !1, o = !1) => (nl || NN(), n.schedule(r, i, o)), e;
}, {}), za = Cl.reduce((e, t) => (e[t] = $f[t].cancel, e), {}), qp = Cl.reduce((e, t) => (e[t] = () => $f[t].process(Oa), e), {}), DN = (e) => $f[e].process(Oa), mE = (e) => {
  nl = !1, Oa.delta = om ? pE : Math.max(Math.min(e - Oa.timestamp, MN), 1), Oa.timestamp = e, am = !0, Cl.forEach(DN), am = !1, nl && (om = !1, hE(mE));
}, NN = () => {
  nl = !0, om = !0, am || hE(mE);
}, Lu = () => Oa;
function gE(e, t, n = 0) {
  return e - t - n;
}
function IN(e, t, n = 0, r = !0) {
  return r ? gE(t + -e, t, n) : t - (e - t) + n;
}
function LN(e, t, n, r) {
  return r ? e >= t + n : e <= -n;
}
const FN = (e) => {
  const t = ({ delta: n }) => e(n);
  return {
    start: () => Vr.update(t, !0),
    stop: () => za.update(t)
  };
};
function vE(e) {
  var t, n, { from: r, autoplay: i = !0, driver: o = FN, elapsed: a = 0, repeat: s = 0, repeatType: c = "loop", repeatDelay: f = 0, onPlay: p, onStop: d, onComplete: h, onRepeat: m, onUpdate: v } = e, w = jn(e, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
  let { to: b } = w, E, C = 0, S = w.duration, _, T = !1, P = !0, R;
  const N = RN(w);
  !((n = (t = N).needsInterpolation) === null || n === void 0) && n.call(t, r, b) && (R = lE([0, 100], [r, b], {
    clamp: !1
  }), r = 0, b = 100);
  const B = N(Object.assign(Object.assign({}, w), { from: r, to: b }));
  function L() {
    C++, c === "reverse" ? (P = C % 2 === 0, a = IN(a, S, f, P)) : (a = gE(a, S, f), c === "mirror" && B.flipTarget()), T = !1, m && m();
  }
  function j() {
    E.stop(), h && h();
  }
  function I(H) {
    if (P || (H = -H), a += H, !T) {
      const G = B.next(Math.max(0, a));
      _ = G.value, R && (_ = R(_)), T = P ? G.done : a <= 0;
    }
    v == null || v(_), T && (C === 0 && (S ?? (S = a)), C < s ? LN(a, S, f, P) && L() : j());
  }
  function z() {
    p == null || p(), E = o(I), E.start();
  }
  return i && z(), {
    stop: () => {
      d == null || d(), E.stop();
    }
  };
}
function wE(e, t) {
  return t ? e * (1e3 / t) : 0;
}
function zN({ from: e = 0, velocity: t = 0, min: n, max: r, power: i = 0.8, timeConstant: o = 750, bounceStiffness: a = 500, bounceDamping: s = 10, restDelta: c = 1, modifyTarget: f, driver: p, onUpdate: d, onComplete: h, onStop: m }) {
  let v;
  function w(S) {
    return n !== void 0 && S < n || r !== void 0 && S > r;
  }
  function b(S) {
    return n === void 0 ? r : r === void 0 || Math.abs(n - S) < Math.abs(r - S) ? n : r;
  }
  function E(S) {
    v == null || v.stop(), v = vE(Object.assign(Object.assign({}, S), {
      driver: p,
      onUpdate: (_) => {
        var T;
        d == null || d(_), (T = S.onUpdate) === null || T === void 0 || T.call(S, _);
      },
      onComplete: h,
      onStop: m
    }));
  }
  function C(S) {
    E(Object.assign({ type: "spring", stiffness: a, damping: s, restDelta: c }, S));
  }
  if (w(e))
    C({ from: e, velocity: t, to: b(e) });
  else {
    let S = i * t + e;
    typeof f < "u" && (S = f(S));
    const _ = b(S), T = _ === n ? -1 : 1;
    let P, R;
    const N = (B) => {
      P = R, R = B, t = wE(B - P, Lu().delta), (T === 1 && B > _ || T === -1 && B < _) && C({ from: B, to: _, velocity: t });
    };
    E({
      type: "decay",
      from: e,
      velocity: t,
      timeConstant: o,
      power: i,
      restDelta: c,
      modifyTarget: f,
      onUpdate: w(S) ? N : void 0
    });
  }
  return {
    stop: () => v == null ? void 0 : v.stop()
  };
}
const sm = (e) => e.hasOwnProperty("x") && e.hasOwnProperty("y"), nb = (e) => sm(e) && e.hasOwnProperty("z"), Ic = (e, t) => Math.abs(e - t);
function yE(e, t) {
  if (im(e) && im(t))
    return Ic(e, t);
  if (sm(e) && sm(t)) {
    const n = Ic(e.x, t.x), r = Ic(e.y, t.y), i = nb(e) && nb(t) ? Ic(e.z, t.z) : 0;
    return Math.sqrt(Math.pow(n, 2) + Math.pow(r, 2) + Math.pow(i, 2));
  }
}
const bE = (e, t) => 1 - 3 * t + 3 * e, xE = (e, t) => 3 * t - 6 * e, EE = (e) => 3 * e, Fu = (e, t, n) => ((bE(t, n) * e + xE(t, n)) * e + EE(t)) * e, CE = (e, t, n) => 3 * bE(t, n) * e * e + 2 * xE(t, n) * e + EE(t), VN = 1e-7, BN = 10;
function HN(e, t, n, r, i) {
  let o, a, s = 0;
  do
    a = t + (n - t) / 2, o = Fu(a, r, i) - e, o > 0 ? n = a : t = a;
  while (Math.abs(o) > VN && ++s < BN);
  return a;
}
const UN = 8, WN = 1e-3;
function jN(e, t, n, r) {
  for (let i = 0; i < UN; ++i) {
    const o = CE(t, n, r);
    if (o === 0)
      return t;
    const a = Fu(t, n, r) - e;
    t -= a / o;
  }
  return t;
}
const mu = 11, Lc = 1 / (mu - 1);
function qN(e, t, n, r) {
  if (e === t && n === r)
    return s1;
  const i = new Float32Array(mu);
  for (let a = 0; a < mu; ++a)
    i[a] = Fu(a * Lc, e, n);
  function o(a) {
    let s = 0, c = 1;
    const f = mu - 1;
    for (; c !== f && i[c] <= a; ++c)
      s += Lc;
    --c;
    const p = (a - i[c]) / (i[c + 1] - i[c]), d = s + p * Lc, h = CE(d, e, n);
    return h >= WN ? jN(a, d, e, n) : h === 0 ? d : HN(a, s, s + Lc, e, n);
  }
  return (a) => a === 0 || a === 1 ? a : Fu(o(a), t, r);
}
function GN(e) {
  var t = e.onTap, n = e.onTapStart, r = e.onTapCancel, i = e.whileTap, o = e.visualElement, a = t || n || r || i, s = he(!1), c = he(null), f = {
    passive: !(n || t || r || v)
  };
  function p() {
    var w;
    (w = c.current) === null || w === void 0 || w.call(c), c.current = null;
  }
  function d() {
    var w;
    return p(), s.current = !1, (w = o.animationState) === null || w === void 0 || w.setActive($t.Tap, !1), !nE();
  }
  function h(w, b) {
    d() && (rE(o.getInstance(), w.target) ? t == null || t(w, b) : r == null || r(w, b));
  }
  function m(w, b) {
    d() && (r == null || r(w, b));
  }
  function v(w, b) {
    var E;
    p(), !s.current && (s.current = !0, c.current = Af($a(window, "pointerup", h, f), $a(window, "pointercancel", m, f)), (E = o.animationState) === null || E === void 0 || E.setActive($t.Tap, !0), n == null || n(w, b));
  }
  Du(o, "pointerdown", a ? v : void 0, f), i1(p);
}
var rb = /* @__PURE__ */ new Set();
function SE(e, t, n) {
  e || rb.has(t) || (console.warn(t), n && console.warn(n), rb.add(t));
}
var lm = /* @__PURE__ */ new WeakMap(), Gp = /* @__PURE__ */ new WeakMap(), YN = function(e) {
  var t;
  (t = lm.get(e.target)) === null || t === void 0 || t(e);
}, KN = function(e) {
  e.forEach(YN);
};
function XN(e) {
  var t = e.root, n = jn(e, ["root"]), r = t || document;
  Gp.has(r) || Gp.set(r, {});
  var i = Gp.get(r), o = JSON.stringify(n);
  return i[o] || (i[o] = new IntersectionObserver(KN, ve({ root: t }, n))), i[o];
}
function QN(e, t, n) {
  var r = XN(t);
  return lm.set(e, n), r.observe(e), function() {
    lm.delete(e), r.unobserve(e);
  };
}
function ZN(e) {
  var t = e.visualElement, n = e.whileInView, r = e.onViewportEnter, i = e.onViewportLeave, o = e.viewport, a = o === void 0 ? {} : o, s = he({
    hasEnteredView: !1,
    isInView: !1
  }), c = !!(n || r || i);
  a.once && s.current.hasEnteredView && (c = !1);
  var f = typeof IntersectionObserver > "u" ? tI : eI;
  f(c, s.current, t, a);
}
var JN = {
  some: 0,
  all: 1
};
function eI(e, t, n, r) {
  var i = r.root, o = r.margin, a = r.amount, s = a === void 0 ? "some" : a, c = r.once;
  _e(function() {
    if (e) {
      var f = {
        root: i == null ? void 0 : i.current,
        rootMargin: o,
        threshold: typeof s == "number" ? s : JN[s]
      }, p = function(d) {
        var h, m = d.isIntersecting;
        if (t.isInView !== m && (t.isInView = m, !(c && !m && t.hasEnteredView))) {
          m && (t.hasEnteredView = !0), (h = n.animationState) === null || h === void 0 || h.setActive($t.InView, m);
          var v = n.getProps(), w = m ? v.onViewportEnter : v.onViewportLeave;
          w == null || w(d);
        }
      };
      return QN(n.getInstance(), f, p);
    }
  }, [e, i, o, s]);
}
function tI(e, t, n, r) {
  var i = r.fallback, o = i === void 0 ? !0 : i;
  _e(function() {
    !e || !o || (Gg !== "production" && SE(!1, "IntersectionObserver not available on this device. whileInView animations will trigger on mount."), requestAnimationFrame(function() {
      var a;
      t.hasEnteredView = !0;
      var s = n.getProps().onViewportEnter;
      s == null || s(null), (a = n.animationState) === null || a === void 0 || a.setActive($t.InView, !0);
    }));
  }, [e]);
}
var no = function(e) {
  return function(t) {
    return e(t), null;
  };
}, nI = {
  inView: no(ZN),
  tap: no(GN),
  focus: no(ID),
  hover: no(qD)
}, rI = 0, iI = function() {
  return rI++;
}, _E = function() {
  return Ka(iI);
};
function TE() {
  var e = Re(yl);
  if (e === null)
    return [!0, null];
  var t = e.isPresent, n = e.onExitComplete, r = e.register, i = _E();
  _e(function() {
    return r(i);
  }, []);
  var o = function() {
    return n == null ? void 0 : n(i);
  };
  return !t && n ? [!1, o] : [!0];
}
function kE(e, t) {
  if (!Array.isArray(t))
    return !1;
  var n = t.length;
  if (n !== e.length)
    return !1;
  for (var r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
var zu = function(e) {
  return e * 1e3;
}, ib = {
  linear: s1,
  easeIn: l1,
  easeInOut: fE,
  easeOut: gN,
  circIn: dE,
  circInOut: vN,
  circOut: c1,
  backIn: u1,
  backInOut: yN,
  backOut: wN,
  anticipate: bN,
  bounceIn: SN,
  bounceInOut: _N,
  bounceOut: Iu
}, ob = function(e) {
  if (Array.isArray(e)) {
    xr(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var t = jt(e, 4), n = t[0], r = t[1], i = t[2], o = t[3];
    return qN(n, r, i, o);
  } else if (typeof e == "string")
    return xr(ib[e] !== void 0, "Invalid easing type '".concat(e, "'")), ib[e];
  return e;
}, oI = function(e) {
  return Array.isArray(e) && typeof e[0] != "number";
}, ab = function(e, t) {
  return e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
  Ri.test(t) && // And it contains numbers and/or colors
  !t.startsWith("url("));
}, To = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  };
}, Fc = function(e) {
  return {
    type: "spring",
    stiffness: 550,
    damping: e === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
}, Yp = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
}, aI = function(e) {
  return {
    type: "keyframes",
    duration: 0.8,
    values: e
  };
}, sb = {
  x: To,
  y: To,
  z: To,
  rotate: To,
  rotateX: To,
  rotateY: To,
  rotateZ: To,
  scaleX: Fc,
  scaleY: Fc,
  scale: Fc,
  opacity: Yp,
  backgroundColor: Yp,
  color: Yp,
  default: Fc
}, sI = function(e, t) {
  var n;
  return el(t) ? n = aI : n = sb[e] || sb.default, ve({ to: t }, n(t));
}, lI = ve(ve({}, zx), {
  // Color props
  color: An,
  backgroundColor: An,
  outlineColor: An,
  fill: An,
  stroke: An,
  // Border props
  borderColor: An,
  borderTopColor: An,
  borderRightColor: An,
  borderBottomColor: An,
  borderLeftColor: An,
  filter: tm,
  WebkitFilter: tm
}), f1 = function(e) {
  return lI[e];
};
function d1(e, t) {
  var n, r = f1(e);
  return r !== tm && (r = Ri), (n = r.getAnimatableNone) === null || n === void 0 ? void 0 : n.call(r, t);
}
function cI(e) {
  e.when, e.delay, e.delayChildren, e.staggerChildren, e.staggerDirection, e.repeat, e.repeatType, e.repeatDelay, e.from;
  var t = jn(e, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(t).length;
}
var lb = !1;
function uI(e) {
  var t = e.ease, n = e.times, r = e.yoyo, i = e.flip, o = e.loop, a = jn(e, ["ease", "times", "yoyo", "flip", "loop"]), s = ve({}, a);
  return n && (s.offset = n), a.duration && (s.duration = zu(a.duration)), a.repeatDelay && (s.repeatDelay = zu(a.repeatDelay)), t && (s.ease = oI(t) ? t.map(ob) : ob(t)), a.type === "tween" && (s.type = "keyframes"), (r || o || i) && (wl(!lb, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options."), lb = !0, r ? s.repeatType = "reverse" : o ? s.repeatType = "loop" : i && (s.repeatType = "mirror"), s.repeat = o || r || i || a.repeat), a.type !== "spring" && (s.type = "keyframes"), s;
}
function fI(e, t) {
  var n, r, i = p1(e, t) || {};
  return (r = (n = i.delay) !== null && n !== void 0 ? n : e.delay) !== null && r !== void 0 ? r : 0;
}
function dI(e) {
  return Array.isArray(e.to) && e.to[0] === null && (e.to = yr([], jt(e.to), !1), e.to[0] = e.from), e;
}
function pI(e, t, n) {
  var r;
  return Array.isArray(t.to) && ((r = e.duration) !== null && r !== void 0 || (e.duration = 0.8)), dI(t), cI(e) || (e = ve(ve({}, e), sI(n, t.to))), ve(ve({}, t), uI(e));
}
function hI(e, t, n, r, i) {
  var o, a = p1(r, e), s = (o = a.from) !== null && o !== void 0 ? o : t.get(), c = ab(e, n);
  s === "none" && c && typeof n == "string" ? s = d1(e, n) : cb(s) && typeof n == "string" ? s = ub(n) : !Array.isArray(n) && cb(n) && typeof s == "string" && (n = ub(s));
  var f = ab(e, s);
  wl(f === c, "You are trying to animate ".concat(e, ' from "').concat(s, '" to "').concat(n, '". ').concat(s, " is not an animatable value - to enable this animation set ").concat(s, " to a value animatable to ").concat(n, " via the `style` property."));
  function p() {
    var h = {
      from: s,
      to: n,
      velocity: t.getVelocity(),
      onComplete: i,
      onUpdate: function(m) {
        return t.set(m);
      }
    };
    return a.type === "inertia" || a.type === "decay" ? zN(ve(ve({}, h), a)) : vE(ve(ve({}, pI(a, h, e)), { onUpdate: function(m) {
      var v;
      h.onUpdate(m), (v = a.onUpdate) === null || v === void 0 || v.call(a, m);
    }, onComplete: function() {
      var m;
      h.onComplete(), (m = a.onComplete) === null || m === void 0 || m.call(a);
    } }));
  }
  function d() {
    var h, m, v = Yx(n);
    return t.set(v), i(), (h = a == null ? void 0 : a.onUpdate) === null || h === void 0 || h.call(a, v), (m = a == null ? void 0 : a.onComplete) === null || m === void 0 || m.call(a), { stop: function() {
    } };
  }
  return !f || !c || a.type === !1 ? d : p;
}
function cb(e) {
  return e === 0 || typeof e == "string" && parseFloat(e) === 0 && e.indexOf(" ") === -1;
}
function ub(e) {
  return typeof e == "number" ? 0 : d1("", e);
}
function p1(e, t) {
  return e[t] || e.default || e;
}
function h1(e, t, n, r) {
  return r === void 0 && (r = {}), t.start(function(i) {
    var o, a, s = hI(e, t, n, r, i), c = fI(r, e), f = function() {
      return a = s();
    };
    return c ? o = window.setTimeout(f, zu(c)) : f(), function() {
      clearTimeout(o), a == null || a.stop();
    };
  });
}
var mI = function(e) {
  return /^\-?\d*\.?\d+$/.test(e);
}, gI = function(e) {
  return /^0[^.\s]+$/.test(e);
};
function m1(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function g1(e, t) {
  var n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
var Vs = (
  /** @class */
  function() {
    function e() {
      this.subscriptions = [];
    }
    return e.prototype.add = function(t) {
      var n = this;
      return m1(this.subscriptions, t), function() {
        return g1(n.subscriptions, t);
      };
    }, e.prototype.notify = function(t, n, r) {
      var i = this.subscriptions.length;
      if (i)
        if (i === 1)
          this.subscriptions[0](t, n, r);
        else
          for (var o = 0; o < i; o++) {
            var a = this.subscriptions[o];
            a && a(t, n, r);
          }
    }, e.prototype.getSize = function() {
      return this.subscriptions.length;
    }, e.prototype.clear = function() {
      this.subscriptions.length = 0;
    }, e;
  }()
), vI = function(e) {
  return !isNaN(parseFloat(e));
}, wI = (
  /** @class */
  function() {
    function e(t) {
      var n = this;
      this.version = "6.5.1", this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new Vs(), this.velocityUpdateSubscribers = new Vs(), this.renderSubscribers = new Vs(), this.canTrackVelocity = !1, this.updateAndNotify = function(r, i) {
        i === void 0 && (i = !0), n.prev = n.current, n.current = r;
        var o = Lu(), a = o.delta, s = o.timestamp;
        n.lastUpdated !== s && (n.timeDelta = a, n.lastUpdated = s, Vr.postRender(n.scheduleVelocityCheck)), n.prev !== n.current && n.updateSubscribers.notify(n.current), n.velocityUpdateSubscribers.getSize() && n.velocityUpdateSubscribers.notify(n.getVelocity()), i && n.renderSubscribers.notify(n.current);
      }, this.scheduleVelocityCheck = function() {
        return Vr.postRender(n.velocityCheck);
      }, this.velocityCheck = function(r) {
        var i = r.timestamp;
        i !== n.lastUpdated && (n.prev = n.current, n.velocityUpdateSubscribers.notify(n.getVelocity()));
      }, this.hasAnimated = !1, this.prev = this.current = t, this.canTrackVelocity = vI(this.current);
    }
    return e.prototype.onChange = function(t) {
      return this.updateSubscribers.add(t);
    }, e.prototype.clearListeners = function() {
      this.updateSubscribers.clear();
    }, e.prototype.onRenderRequest = function(t) {
      return t(this.get()), this.renderSubscribers.add(t);
    }, e.prototype.attach = function(t) {
      this.passiveEffect = t;
    }, e.prototype.set = function(t, n) {
      n === void 0 && (n = !0), !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
    }, e.prototype.get = function() {
      return this.current;
    }, e.prototype.getPrevious = function() {
      return this.prev;
    }, e.prototype.getVelocity = function() {
      return this.canTrackVelocity ? (
        // These casts could be avoided if parseFloat would be typed better
        wE(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
      ) : 0;
    }, e.prototype.start = function(t) {
      var n = this;
      return this.stop(), new Promise(function(r) {
        n.hasAnimated = !0, n.stopAnimation = t(r);
      }).then(function() {
        return n.clearAnimation();
      });
    }, e.prototype.stop = function() {
      this.stopAnimation && this.stopAnimation(), this.clearAnimation();
    }, e.prototype.isAnimating = function() {
      return !!this.stopAnimation;
    }, e.prototype.clearAnimation = function() {
      this.stopAnimation = null;
    }, e.prototype.destroy = function() {
      this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
    }, e;
  }()
);
function Va(e) {
  return new wI(e);
}
var PE = function(e) {
  return function(t) {
    return t.test(e);
  };
}, yI = {
  test: function(e) {
    return e === "auto";
  },
  parse: function(e) {
    return e;
  }
}, AE = [Yo, Be, ni, Xi, lD, sD, yI], xs = function(e) {
  return AE.find(PE(e));
}, bI = yr(yr([], jt(AE), !1), [An, Ri], !1), xI = function(e) {
  return bI.find(PE(e));
};
function EI(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Va(n));
}
function CI(e, t) {
  var n = Tf(e, t), r = n ? e.makeTargetAnimatable(n, !1) : {}, i = r.transitionEnd, o = i === void 0 ? {} : i;
  r.transition;
  var a = jn(r, ["transitionEnd", "transition"]);
  a = ve(ve({}, a), o);
  for (var s in a) {
    var c = Yx(a[s]);
    EI(e, s, c);
  }
}
function SI(e, t, n) {
  var r, i, o, a, s = Object.keys(t).filter(function(m) {
    return !e.hasValue(m);
  }), c = s.length;
  if (c)
    for (var f = 0; f < c; f++) {
      var p = s[f], d = t[p], h = null;
      Array.isArray(d) && (h = d[0]), h === null && (h = (i = (r = n[p]) !== null && r !== void 0 ? r : e.readValue(p)) !== null && i !== void 0 ? i : t[p]), h != null && (typeof h == "string" && (mI(h) || gI(h)) ? h = parseFloat(h) : !xI(h) && Ri.test(d) && (h = d1(p, d)), e.addValue(p, Va(h)), (o = (a = n)[p]) !== null && o !== void 0 || (a[p] = h), e.setBaseTarget(p, h));
    }
}
function _I(e, t) {
  if (t) {
    var n = t[e] || t.default || t;
    return n.from;
  }
}
function TI(e, t, n) {
  var r, i, o = {};
  for (var a in e)
    o[a] = (r = _I(a, t)) !== null && r !== void 0 ? r : (i = n.getValue(a)) === null || i === void 0 ? void 0 : i.get();
  return o;
}
function kI(e, t, n) {
  n === void 0 && (n = {}), e.notifyAnimationStart(t);
  var r;
  if (Array.isArray(t)) {
    var i = t.map(function(a) {
      return cm(e, a, n);
    });
    r = Promise.all(i);
  } else if (typeof t == "string")
    r = cm(e, t, n);
  else {
    var o = typeof t == "function" ? Tf(e, t, n.custom) : t;
    r = RE(e, o, n);
  }
  return r.then(function() {
    return e.notifyAnimationComplete(t);
  });
}
function cm(e, t, n) {
  var r;
  n === void 0 && (n = {});
  var i = Tf(e, t, n.custom), o = (i || {}).transition, a = o === void 0 ? e.getDefaultTransition() || {} : o;
  n.transitionOverride && (a = n.transitionOverride);
  var s = i ? function() {
    return RE(e, i, n);
  } : function() {
    return Promise.resolve();
  }, c = !((r = e.variantChildren) === null || r === void 0) && r.size ? function(m) {
    m === void 0 && (m = 0);
    var v = a.delayChildren, w = v === void 0 ? 0 : v, b = a.staggerChildren, E = a.staggerDirection;
    return PI(e, t, w + m, b, E, n);
  } : function() {
    return Promise.resolve();
  }, f = a.when;
  if (f) {
    var p = jt(f === "beforeChildren" ? [s, c] : [c, s], 2), d = p[0], h = p[1];
    return d().then(h);
  } else
    return Promise.all([s(), c(n.delay)]);
}
function RE(e, t, n) {
  var r, i = n === void 0 ? {} : n, o = i.delay, a = o === void 0 ? 0 : o, s = i.transitionOverride, c = i.type, f = e.makeTargetAnimatable(t), p = f.transition, d = p === void 0 ? e.getDefaultTransition() : p, h = f.transitionEnd, m = jn(f, ["transition", "transitionEnd"]);
  s && (d = s);
  var v = [], w = c && ((r = e.animationState) === null || r === void 0 ? void 0 : r.getState()[c]);
  for (var b in m) {
    var E = e.getValue(b), C = m[b];
    if (!(!E || C === void 0 || w && RI(w, b))) {
      var S = ve({ delay: a }, d);
      e.shouldReduceMotion && bl(b) && (S = ve(ve({}, S), { type: !1, delay: 0 }));
      var _ = h1(b, E, C, S);
      v.push(_);
    }
  }
  return Promise.all(v).then(function() {
    h && CI(e, h);
  });
}
function PI(e, t, n, r, i, o) {
  n === void 0 && (n = 0), r === void 0 && (r = 0), i === void 0 && (i = 1);
  var a = [], s = (e.variantChildren.size - 1) * r, c = i === 1 ? function(f) {
    return f === void 0 && (f = 0), f * r;
  } : function(f) {
    return f === void 0 && (f = 0), s - f * r;
  };
  return Array.from(e.variantChildren).sort(AI).forEach(function(f, p) {
    a.push(cm(f, t, ve(ve({}, o), { delay: n + c(p) })).then(function() {
      return f.notifyAnimationComplete(t);
    }));
  }), Promise.all(a);
}
function AI(e, t) {
  return e.sortNodePosition(t);
}
function RI(e, t) {
  var n = e.protectedKeys, r = e.needsAnimating, i = n.hasOwnProperty(t) && r[t] !== !0;
  return r[t] = !1, i;
}
var v1 = [
  $t.Animate,
  $t.InView,
  $t.Focus,
  $t.Hover,
  $t.Tap,
  $t.Drag,
  $t.Exit
], $I = yr([], jt(v1), !1).reverse(), OI = v1.length;
function MI(e) {
  return function(t) {
    return Promise.all(t.map(function(n) {
      var r = n.animation, i = n.options;
      return kI(e, r, i);
    }));
  };
}
function DI(e) {
  var t = MI(e), n = II(), r = {}, i = !0, o = function(p, d) {
    var h = Tf(e, d);
    if (h) {
      h.transition;
      var m = h.transitionEnd, v = jn(h, ["transition", "transitionEnd"]);
      p = ve(ve(ve({}, p), v), m);
    }
    return p;
  };
  function a(p) {
    return r[p] !== void 0;
  }
  function s(p) {
    t = p(e);
  }
  function c(p, d) {
    for (var h, m = e.getProps(), v = e.getVariantContext(!0) || {}, w = [], b = /* @__PURE__ */ new Set(), E = {}, C = 1 / 0, S = function(R) {
      var N = $I[R], B = n[N], L = (h = m[N]) !== null && h !== void 0 ? h : v[N], j = Ir(L), I = N === d ? B.isActive : null;
      I === !1 && (C = R);
      var z = L === v[N] && L !== m[N] && j;
      if (z && i && e.manuallyAnimateOnMount && (z = !1), B.protectedKeys = ve({}, E), // If it isn't active and hasn't *just* been set as inactive
      !B.isActive && I === null || // If we didn't and don't have any defined prop for this animation type
      !L && !B.prevProp || // Or if the prop doesn't define an animation
      n1(L) || typeof L == "boolean")
        return "continue";
      var H = NI(B.prevProp, L), G = H || // If we're making this variant active, we want to always make it active
      N === d && B.isActive && !z && j || // If we removed a higher-priority variant (i is in reverse order)
      R > C && j, Y = Array.isArray(L) ? L : [L], ne = Y.reduce(o, {});
      I === !1 && (ne = {});
      var J = B.prevResolvedValues, ee = J === void 0 ? {} : J, A = ve(ve({}, ee), ne), X = function(ie) {
        G = !0, b.delete(ie), B.needsAnimating[ie] = !0;
      };
      for (var fe in A) {
        var M = ne[fe], Z = ee[fe];
        E.hasOwnProperty(fe) || (M !== Z ? el(M) && el(Z) ? !kE(M, Z) || H ? X(fe) : B.protectedKeys[fe] = !0 : M !== void 0 ? X(fe) : b.add(fe) : M !== void 0 && b.has(fe) ? X(fe) : B.protectedKeys[fe] = !0);
      }
      B.prevProp = L, B.prevResolvedValues = ne, B.isActive && (E = ve(ve({}, E), ne)), i && e.blockInitialAnimation && (G = !1), G && !z && w.push.apply(w, yr([], jt(Y.map(function(ie) {
        return {
          animation: ie,
          options: ve({ type: N }, p)
        };
      })), !1));
    }, _ = 0; _ < OI; _++)
      S(_);
    if (r = ve({}, E), b.size) {
      var T = {};
      b.forEach(function(R) {
        var N = e.getBaseTarget(R);
        N !== void 0 && (T[R] = N);
      }), w.push({ animation: T });
    }
    var P = !!w.length;
    return i && m.initial === !1 && !e.manuallyAnimateOnMount && (P = !1), i = !1, P ? t(w) : Promise.resolve();
  }
  function f(p, d, h) {
    var m;
    if (n[p].isActive === d)
      return Promise.resolve();
    (m = e.variantChildren) === null || m === void 0 || m.forEach(function(b) {
      var E;
      return (E = b.animationState) === null || E === void 0 ? void 0 : E.setActive(p, d);
    }), n[p].isActive = d;
    var v = c(h, p);
    for (var w in n)
      n[w].protectedKeys = {};
    return v;
  }
  return {
    isAnimated: a,
    animateChanges: c,
    setActive: f,
    setAnimateFunction: s,
    getState: function() {
      return n;
    }
  };
}
function NI(e, t) {
  return typeof t == "string" ? t !== e : _x(t) ? !kE(t, e) : !1;
}
function ko(e) {
  return e === void 0 && (e = !1), {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function II() {
  var e;
  return e = {}, e[$t.Animate] = ko(!0), e[$t.InView] = ko(), e[$t.Hover] = ko(), e[$t.Tap] = ko(), e[$t.Drag] = ko(), e[$t.Focus] = ko(), e[$t.Exit] = ko(), e;
}
var LI = {
  animation: no(function(e) {
    var t = e.visualElement, n = e.animate;
    t.animationState || (t.animationState = DI(t)), n1(n) && _e(function() {
      return n.subscribe(t);
    }, [n]);
  }),
  exit: no(function(e) {
    var t = e.custom, n = e.visualElement, r = jt(TE(), 2), i = r[0], o = r[1], a = Re(yl);
    _e(function() {
      var s, c;
      n.isPresent = i;
      var f = (s = n.animationState) === null || s === void 0 ? void 0 : s.setActive($t.Exit, !i, { custom: (c = a == null ? void 0 : a.custom) !== null && c !== void 0 ? c : t });
      !i && (f == null || f.then(o));
    }, [i]);
  })
}, $E = (
  /** @class */
  function() {
    function e(t, n, r) {
      var i = this, o = r === void 0 ? {} : r, a = o.transformPagePoint;
      if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function() {
        if (i.lastMoveEvent && i.lastMoveEventInfo) {
          var h = Xp(i.lastMoveEventInfo, i.history), m = i.startEvent !== null, v = yE(h.offset, { x: 0, y: 0 }) >= 3;
          if (!(!m && !v)) {
            var w = h.point, b = Lu().timestamp;
            i.history.push(ve(ve({}, w), { timestamp: b }));
            var E = i.handlers, C = E.onStart, S = E.onMove;
            m || (C && C(i.lastMoveEvent, h), i.startEvent = i.lastMoveEvent), S && S(i.lastMoveEvent, h);
          }
        }
      }, this.handlePointerMove = function(h, m) {
        if (i.lastMoveEvent = h, i.lastMoveEventInfo = Kp(m, i.transformPagePoint), Xx(h) && h.buttons === 0) {
          i.handlePointerUp(h, m);
          return;
        }
        Vr.update(i.updatePoint, !0);
      }, this.handlePointerUp = function(h, m) {
        i.end();
        var v = i.handlers, w = v.onEnd, b = v.onSessionEnd, E = Xp(Kp(m, i.transformPagePoint), i.history);
        i.startEvent && w && w(h, E), b && b(h, E);
      }, !(Qx(t) && t.touches.length > 1)) {
        this.handlers = n, this.transformPagePoint = a;
        var s = r1(t), c = Kp(s, this.transformPagePoint), f = c.point, p = Lu().timestamp;
        this.history = [ve(ve({}, f), { timestamp: p })];
        var d = n.onSessionStart;
        d && d(t, Xp(c, this.history)), this.removeListeners = Af($a(window, "pointermove", this.handlePointerMove), $a(window, "pointerup", this.handlePointerUp), $a(window, "pointercancel", this.handlePointerUp));
      }
    }
    return e.prototype.updateHandlers = function(t) {
      this.handlers = t;
    }, e.prototype.end = function() {
      this.removeListeners && this.removeListeners(), za.update(this.updatePoint);
    }, e;
  }()
);
function Kp(e, t) {
  return t ? { point: t(e.point) } : e;
}
function fb(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Xp(e, t) {
  var n = e.point;
  return {
    point: n,
    delta: fb(n, OE(t)),
    offset: fb(n, FI(t)),
    velocity: zI(t, 0.1)
  };
}
function FI(e) {
  return e[0];
}
function OE(e) {
  return e[e.length - 1];
}
function zI(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  for (var n = e.length - 1, r = null, i = OE(e); n >= 0 && (r = e[n], !(i.timestamp - r.timestamp > zu(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  var o = (i.timestamp - r.timestamp) / 1e3;
  if (o === 0)
    return { x: 0, y: 0 };
  var a = {
    x: (i.x - r.x) / o,
    y: (i.y - r.y) / o
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}
function $i(e) {
  return e.max - e.min;
}
function db(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 0.01), yE(e, t) < n;
}
function pb(e, t, n, r) {
  r === void 0 && (r = 0.5), e.origin = r, e.originPoint = Wt(t.min, t.max, e.origin), e.scale = $i(n) / $i(t), (db(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = Wt(n.min, n.max, e.origin) - e.originPoint, (db(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function Bs(e, t, n, r) {
  pb(e.x, t.x, n.x, r == null ? void 0 : r.originX), pb(e.y, t.y, n.y, r == null ? void 0 : r.originY);
}
function hb(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + $i(t);
}
function VI(e, t, n) {
  hb(e.x, t.x, n.x), hb(e.y, t.y, n.y);
}
function mb(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + $i(t);
}
function Hs(e, t, n) {
  mb(e.x, t.x, n.x), mb(e.y, t.y, n.y);
}
function BI(e, t, n) {
  var r = t.min, i = t.max;
  return r !== void 0 && e < r ? e = n ? Wt(r, e, n.min) : Math.max(e, r) : i !== void 0 && e > i && (e = n ? Wt(i, e, n.max) : Math.min(e, i)), e;
}
function gb(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function HI(e, t) {
  var n = t.top, r = t.left, i = t.bottom, o = t.right;
  return {
    x: gb(e.x, r, o),
    y: gb(e.y, n, i)
  };
}
function vb(e, t) {
  var n, r = t.min - e.min, i = t.max - e.max;
  return t.max - t.min < e.max - e.min && (n = jt([i, r], 2), r = n[0], i = n[1]), { min: r, max: i };
}
function UI(e, t) {
  return {
    x: vb(e.x, t.x),
    y: vb(e.y, t.y)
  };
}
function WI(e, t) {
  var n = 0.5, r = $i(e), i = $i(t);
  return i > r ? n = tl(t.min, t.max - r, e.min) : r > i && (n = tl(e.min, e.max - i, t.min)), Nu(0, 1, n);
}
function jI(e, t) {
  var n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
var um = 0.35;
function qI(e) {
  return e === void 0 && (e = um), e === !1 ? e = 0 : e === !0 && (e = um), {
    x: wb(e, "left", "right"),
    y: wb(e, "top", "bottom")
  };
}
function wb(e, t, n) {
  return {
    min: yb(e, t),
    max: yb(e, n)
  };
}
function yb(e, t) {
  var n;
  return typeof e == "number" ? e : (n = e[t]) !== null && n !== void 0 ? n : 0;
}
var bb = function() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
}, Us = function() {
  return {
    x: bb(),
    y: bb()
  };
}, xb = function() {
  return { min: 0, max: 0 };
}, vn = function() {
  return {
    x: xb(),
    y: xb()
  };
};
function Zr(e) {
  return [e("x"), e("y")];
}
function ME(e) {
  var t = e.top, n = e.left, r = e.right, i = e.bottom;
  return {
    x: { min: n, max: r },
    y: { min: t, max: i }
  };
}
function GI(e) {
  var t = e.x, n = e.y;
  return { top: n.min, right: t.max, bottom: n.max, left: t.min };
}
function YI(e, t) {
  if (!t)
    return e;
  var n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function Qp(e) {
  return e === void 0 || e === 1;
}
function DE(e) {
  var t = e.scale, n = e.scaleX, r = e.scaleY;
  return !Qp(t) || !Qp(n) || !Qp(r);
}
function Qi(e) {
  return DE(e) || Eb(e.x) || Eb(e.y) || e.z || e.rotate || e.rotateX || e.rotateY;
}
function Eb(e) {
  return e && e !== "0%";
}
function Vu(e, t, n) {
  var r = e - n, i = t * r;
  return n + i;
}
function Cb(e, t, n, r, i) {
  return i !== void 0 && (e = Vu(e, i, r)), Vu(e, n, r) + t;
}
function fm(e, t, n, r, i) {
  t === void 0 && (t = 0), n === void 0 && (n = 1), e.min = Cb(e.min, t, n, r, i), e.max = Cb(e.max, t, n, r, i);
}
function NE(e, t) {
  var n = t.x, r = t.y;
  fm(e.x, n.translate, n.scale, n.originPoint), fm(e.y, r.translate, r.scale, r.originPoint);
}
function KI(e, t, n, r) {
  var i, o;
  r === void 0 && (r = !1);
  var a = n.length;
  if (a) {
    t.x = t.y = 1;
    for (var s, c, f = 0; f < a; f++)
      s = n[f], c = s.projectionDelta, ((o = (i = s.instance) === null || i === void 0 ? void 0 : i.style) === null || o === void 0 ? void 0 : o.display) !== "contents" && (r && s.options.layoutScroll && s.scroll && s !== s.root && Ta(e, { x: -s.scroll.x, y: -s.scroll.y }), c && (t.x *= c.x.scale, t.y *= c.y.scale, NE(e, c)), r && Qi(s.latestValues) && Ta(e, s.latestValues));
  }
}
function Zi(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function Sb(e, t, n) {
  var r = jt(n, 3), i = r[0], o = r[1], a = r[2], s = t[a] !== void 0 ? t[a] : 0.5, c = Wt(e.min, e.max, s);
  fm(e, t[i], t[o], c, t.scale);
}
var XI = ["x", "scaleX", "originX"], QI = ["y", "scaleY", "originY"];
function Ta(e, t) {
  Sb(e.x, t, XI), Sb(e.y, t, QI);
}
function IE(e, t) {
  return ME(YI(e.getBoundingClientRect(), t));
}
function ZI(e, t, n) {
  var r = IE(e, n), i = t.scroll;
  return i && (Zi(r.x, i.x), Zi(r.y, i.y)), r;
}
var JI = /* @__PURE__ */ new WeakMap(), eL = (
  /** @class */
  function() {
    function e(t) {
      this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = vn(), this.visualElement = t;
    }
    return e.prototype.start = function(t, n) {
      var r = this, i = n === void 0 ? {} : n, o = i.snapToCursor, a = o === void 0 ? !1 : o;
      if (this.visualElement.isPresent !== !1) {
        var s = function(d) {
          r.stopAnimation(), a && r.snapToCursor(r1(d, "page").point);
        }, c = function(d, h) {
          var m, v = r.getProps(), w = v.drag, b = v.dragPropagation, E = v.onDragStart;
          w && !b && (r.openGlobalLock && r.openGlobalLock(), r.openGlobalLock = tE(w), !r.openGlobalLock) || (r.isDragging = !0, r.currentDirection = null, r.resolveConstraints(), r.visualElement.projection && (r.visualElement.projection.isAnimationBlocked = !0, r.visualElement.projection.target = void 0), Zr(function(C) {
            var S, _, T = r.getAxisMotionValue(C).get() || 0;
            if (ni.test(T)) {
              var P = (_ = (S = r.visualElement.projection) === null || S === void 0 ? void 0 : S.layout) === null || _ === void 0 ? void 0 : _.actual[C];
              if (P) {
                var R = $i(P);
                T = R * (parseFloat(T) / 100);
              }
            }
            r.originPoint[C] = T;
          }), E == null || E(d, h), (m = r.visualElement.animationState) === null || m === void 0 || m.setActive($t.Drag, !0));
        }, f = function(d, h) {
          var m = r.getProps(), v = m.dragPropagation, w = m.dragDirectionLock, b = m.onDirectionLock, E = m.onDrag;
          if (!(!v && !r.openGlobalLock)) {
            var C = h.offset;
            if (w && r.currentDirection === null) {
              r.currentDirection = tL(C), r.currentDirection !== null && (b == null || b(r.currentDirection));
              return;
            }
            r.updateAxis("x", h.point, C), r.updateAxis("y", h.point, C), r.visualElement.syncRender(), E == null || E(d, h);
          }
        }, p = function(d, h) {
          return r.stop(d, h);
        };
        this.panSession = new $E(t, {
          onSessionStart: s,
          onStart: c,
          onMove: f,
          onSessionEnd: p
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
      }
    }, e.prototype.stop = function(t, n) {
      var r = this.isDragging;
      if (this.cancel(), !!r) {
        var i = n.velocity;
        this.startAnimation(i);
        var o = this.getProps().onDragEnd;
        o == null || o(t, n);
      }
    }, e.prototype.cancel = function() {
      var t, n;
      this.isDragging = !1, this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !1), (t = this.panSession) === null || t === void 0 || t.end(), this.panSession = void 0;
      var r = this.getProps().dragPropagation;
      !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), (n = this.visualElement.animationState) === null || n === void 0 || n.setActive($t.Drag, !1);
    }, e.prototype.updateAxis = function(t, n, r) {
      var i = this.getProps().drag;
      if (!(!r || !zc(t, i, this.currentDirection))) {
        var o = this.getAxisMotionValue(t), a = this.originPoint[t] + r[t];
        this.constraints && this.constraints[t] && (a = BI(a, this.constraints[t], this.elastic[t])), o.set(a);
      }
    }, e.prototype.resolveConstraints = function() {
      var t = this, n = this.getProps(), r = n.dragConstraints, i = n.dragElastic, o = (this.visualElement.projection || {}).layout, a = this.constraints;
      r && _a(r) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : r && o ? this.constraints = HI(o.actual, r) : this.constraints = !1, this.elastic = qI(i), a !== this.constraints && o && this.constraints && !this.hasMutatedConstraints && Zr(function(s) {
        t.getAxisMotionValue(s) && (t.constraints[s] = jI(o.actual[s], t.constraints[s]));
      });
    }, e.prototype.resolveRefConstraints = function() {
      var t = this.getProps(), n = t.dragConstraints, r = t.onMeasureDragConstraints;
      if (!n || !_a(n))
        return !1;
      var i = n.current;
      xr(i !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
      var o = this.visualElement.projection;
      if (!o || !o.layout)
        return !1;
      var a = ZI(i, o.root, this.visualElement.getTransformPagePoint()), s = UI(o.layout.actual, a);
      if (r) {
        var c = r(GI(s));
        this.hasMutatedConstraints = !!c, c && (s = ME(c));
      }
      return s;
    }, e.prototype.startAnimation = function(t) {
      var n = this, r = this.getProps(), i = r.drag, o = r.dragMomentum, a = r.dragElastic, s = r.dragTransition, c = r.dragSnapToOrigin, f = r.onDragTransitionEnd, p = this.constraints || {}, d = Zr(function(h) {
        var m;
        if (zc(h, i, n.currentDirection)) {
          var v = (m = p == null ? void 0 : p[h]) !== null && m !== void 0 ? m : {};
          c && (v = { min: 0, max: 0 });
          var w = a ? 200 : 1e6, b = a ? 40 : 1e7, E = ve(ve({ type: "inertia", velocity: o ? t[h] : 0, bounceStiffness: w, bounceDamping: b, timeConstant: 750, restDelta: 1, restSpeed: 10 }, s), v);
          return n.startAxisValueAnimation(h, E);
        }
      });
      return Promise.all(d).then(f);
    }, e.prototype.startAxisValueAnimation = function(t, n) {
      var r = this.getAxisMotionValue(t);
      return h1(t, r, 0, n);
    }, e.prototype.stopAnimation = function() {
      var t = this;
      Zr(function(n) {
        return t.getAxisMotionValue(n).stop();
      });
    }, e.prototype.getAxisMotionValue = function(t) {
      var n, r, i = "_drag" + t.toUpperCase(), o = this.visualElement.getProps()[i];
      return o || this.visualElement.getValue(t, (r = (n = this.visualElement.getProps().initial) === null || n === void 0 ? void 0 : n[t]) !== null && r !== void 0 ? r : 0);
    }, e.prototype.snapToCursor = function(t) {
      var n = this;
      Zr(function(r) {
        var i = n.getProps().drag;
        if (zc(r, i, n.currentDirection)) {
          var o = n.visualElement.projection, a = n.getAxisMotionValue(r);
          if (o && o.layout) {
            var s = o.layout.actual[r], c = s.min, f = s.max;
            a.set(t[r] - Wt(c, f, 0.5));
          }
        }
      });
    }, e.prototype.scalePositionWithinConstraints = function() {
      var t = this, n, r = this.getProps(), i = r.drag, o = r.dragConstraints, a = this.visualElement.projection;
      if (!(!_a(o) || !a || !this.constraints)) {
        this.stopAnimation();
        var s = { x: 0, y: 0 };
        Zr(function(f) {
          var p = t.getAxisMotionValue(f);
          if (p) {
            var d = p.get();
            s[f] = WI({ min: d, max: d }, t.constraints[f]);
          }
        });
        var c = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = c ? c({}, "") : "none", (n = a.root) === null || n === void 0 || n.updateScroll(), a.updateLayout(), this.resolveConstraints(), Zr(function(f) {
          if (zc(f, i, null)) {
            var p = t.getAxisMotionValue(f), d = t.constraints[f], h = d.min, m = d.max;
            p.set(Wt(h, m, s[f]));
          }
        });
      }
    }, e.prototype.addListeners = function() {
      var t = this, n;
      JI.set(this.visualElement, this);
      var r = this.visualElement.getInstance(), i = $a(r, "pointerdown", function(f) {
        var p = t.getProps(), d = p.drag, h = p.dragListener, m = h === void 0 ? !0 : h;
        d && m && t.start(f);
      }), o = function() {
        var f = t.getProps().dragConstraints;
        _a(f) && (t.constraints = t.resolveRefConstraints());
      }, a = this.visualElement.projection, s = a.addEventListener("measure", o);
      a && !a.layout && ((n = a.root) === null || n === void 0 || n.updateScroll(), a.updateLayout()), o();
      var c = Pf(window, "resize", function() {
        return t.scalePositionWithinConstraints();
      });
      return a.addEventListener("didUpdate", function(f) {
        var p = f.delta, d = f.hasLayoutChanged;
        t.isDragging && d && (Zr(function(h) {
          var m = t.getAxisMotionValue(h);
          m && (t.originPoint[h] += p[h].translate, m.set(m.get() + p[h].translate));
        }), t.visualElement.syncRender());
      }), function() {
        c(), i(), s();
      };
    }, e.prototype.getProps = function() {
      var t = this.visualElement.getProps(), n = t.drag, r = n === void 0 ? !1 : n, i = t.dragDirectionLock, o = i === void 0 ? !1 : i, a = t.dragPropagation, s = a === void 0 ? !1 : a, c = t.dragConstraints, f = c === void 0 ? !1 : c, p = t.dragElastic, d = p === void 0 ? um : p, h = t.dragMomentum, m = h === void 0 ? !0 : h;
      return ve(ve({}, t), { drag: r, dragDirectionLock: o, dragPropagation: s, dragConstraints: f, dragElastic: d, dragMomentum: m });
    }, e;
  }()
);
function zc(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function tL(e, t) {
  t === void 0 && (t = 10);
  var n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
function nL(e) {
  var t = e.dragControls, n = e.visualElement, r = Ka(function() {
    return new eL(n);
  });
  _e(function() {
    return t && t.subscribe(r);
  }, [r, t]), _e(function() {
    return r.addListeners();
  }, [r]);
}
function rL(e) {
  var t = e.onPan, n = e.onPanStart, r = e.onPanEnd, i = e.onPanSessionStart, o = e.visualElement, a = t || n || r || i, s = he(null), c = Re(Yg).transformPagePoint, f = {
    onSessionStart: i,
    onStart: n,
    onMove: t,
    onEnd: function(d, h) {
      s.current = null, r && r(d, h);
    }
  };
  _e(function() {
    s.current !== null && s.current.updateHandlers(f);
  });
  function p(d) {
    s.current = new $E(d, f, {
      transformPagePoint: c
    });
  }
  Du(o, "pointerdown", a && p), i1(function() {
    return s.current && s.current.end();
  });
}
var iL = {
  pan: no(rL),
  drag: no(nL)
}, Vc = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "LayoutAnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function oL() {
  var e = Vc.map(function() {
    return new Vs();
  }), t = {}, n = {
    clearAllListeners: function() {
      return e.forEach(function(r) {
        return r.clear();
      });
    },
    updatePropListeners: function(r) {
      Vc.forEach(function(i) {
        var o, a = "on" + i, s = r[a];
        (o = t[i]) === null || o === void 0 || o.call(t), s && (t[i] = n[a](s));
      });
    }
  };
  return e.forEach(function(r, i) {
    n["on" + Vc[i]] = function(o) {
      return r.add(o);
    }, n["notify" + Vc[i]] = function() {
      for (var o = [], a = 0; a < arguments.length; a++)
        o[a] = arguments[a];
      return r.notify.apply(r, yr([], jt(o), !1));
    };
  }), n;
}
function aL(e, t, n) {
  var r;
  for (var i in t) {
    var o = t[i], a = n[i];
    if (Ai(o))
      e.addValue(i, o), process.env.NODE_ENV === "development" && SE(o.version === "6.5.1", "Attempting to mix Framer Motion versions ".concat(o.version, " with 6.5.1 may not work as expected."));
    else if (Ai(a))
      e.addValue(i, Va(o));
    else if (a !== o)
      if (e.hasValue(i)) {
        var s = e.getValue(i);
        !s.hasAnimated && s.set(o);
      } else
        e.addValue(i, Va((r = e.getStaticValue(i)) !== null && r !== void 0 ? r : o));
  }
  for (var i in n)
    t[i] === void 0 && e.removeValue(i);
  return t;
}
var LE = function(e) {
  var t = e.treeType, n = t === void 0 ? "" : t, r = e.build, i = e.getBaseTarget, o = e.makeTargetAnimatable, a = e.measureViewportBox, s = e.render, c = e.readValueFromInstance, f = e.removeValueFromRenderState, p = e.sortNodePosition, d = e.scrapeMotionValuesFromProps;
  return function(h, m) {
    var v = h.parent, w = h.props, b = h.presenceId, E = h.blockInitialAnimation, C = h.visualState, S = h.shouldReduceMotion;
    m === void 0 && (m = {});
    var _ = !1, T = C.latestValues, P = C.renderState, R, N = oL(), B = /* @__PURE__ */ new Map(), L = /* @__PURE__ */ new Map(), j = {}, I = ve({}, T), z;
    function H() {
      !R || !_ || (G(), s(R, P, w.style, M.projection));
    }
    function G() {
      r(M, P, T, m, w);
    }
    function Y() {
      N.notifyUpdate(T);
    }
    function ne(Z, ie) {
      var pe = ie.onChange(function(ke) {
        T[Z] = ke, w.onUpdate && Vr.update(Y, !1, !0);
      }), Te = ie.onRenderRequest(M.scheduleRender);
      L.set(Z, function() {
        pe(), Te();
      });
    }
    var J = d(w);
    for (var ee in J) {
      var A = J[ee];
      T[ee] !== void 0 && Ai(A) && A.set(T[ee], !1);
    }
    var X = kf(w), fe = kx(w), M = ve(ve({
      treeType: n,
      /**
       * This is a mirror of the internal instance prop, which keeps
       * VisualElement type-compatible with React's RefObject.
       */
      current: null,
      /**
       * The depth of this visual element within the visual element tree.
       */
      depth: v ? v.depth + 1 : 0,
      parent: v,
      children: /* @__PURE__ */ new Set(),
      /**
       *
       */
      presenceId: b,
      shouldReduceMotion: S,
      /**
       * If this component is part of the variant tree, it should track
       * any children that are also part of the tree. This is essentially
       * a shadow tree to simplify logic around how to stagger over children.
       */
      variantChildren: fe ? /* @__PURE__ */ new Set() : void 0,
      /**
       * Whether this instance is visible. This can be changed imperatively
       * by the projection tree, is analogous to CSS's visibility in that
       * hidden elements should take up layout, and needs enacting by the configured
       * render function.
       */
      isVisible: void 0,
      /**
       * Normally, if a component is controlled by a parent's variants, it can
       * rely on that ancestor to trigger animations further down the tree.
       * However, if a component is created after its parent is mounted, the parent
       * won't trigger that mount animation so the child needs to.
       *
       * TODO: This might be better replaced with a method isParentMounted
       */
      manuallyAnimateOnMount: !!(v != null && v.isMounted()),
      /**
       * This can be set by AnimatePresence to force components that mount
       * at the same time as it to mount as if they have initial={false} set.
       */
      blockInitialAnimation: E,
      /**
       * Determine whether this component has mounted yet. This is mostly used
       * by variant children to determine whether they need to trigger their
       * own animations on mount.
       */
      isMounted: function() {
        return !!R;
      },
      mount: function(Z) {
        _ = !0, R = M.current = Z, M.projection && M.projection.mount(Z), fe && v && !X && (z = v == null ? void 0 : v.addVariantChild(M)), B.forEach(function(ie, pe) {
          return ne(pe, ie);
        }), v == null || v.children.add(M), M.setProps(w);
      },
      /**
       *
       */
      unmount: function() {
        var Z;
        (Z = M.projection) === null || Z === void 0 || Z.unmount(), za.update(Y), za.render(H), L.forEach(function(ie) {
          return ie();
        }), z == null || z(), v == null || v.children.delete(M), N.clearAllListeners(), R = void 0, _ = !1;
      },
      /**
       * Add a child visual element to our set of children.
       */
      addVariantChild: function(Z) {
        var ie, pe = M.getClosestVariantNode();
        if (pe)
          return (ie = pe.variantChildren) === null || ie === void 0 || ie.add(Z), function() {
            return pe.variantChildren.delete(Z);
          };
      },
      sortNodePosition: function(Z) {
        return !p || n !== Z.treeType ? 0 : p(M.getInstance(), Z.getInstance());
      },
      /**
       * Returns the closest variant node in the tree starting from
       * this visual element.
       */
      getClosestVariantNode: function() {
        return fe ? M : v == null ? void 0 : v.getClosestVariantNode();
      },
      /**
       * Expose the latest layoutId prop.
       */
      getLayoutId: function() {
        return w.layoutId;
      },
      /**
       * Returns the current instance.
       */
      getInstance: function() {
        return R;
      },
      /**
       * Get/set the latest static values.
       */
      getStaticValue: function(Z) {
        return T[Z];
      },
      setStaticValue: function(Z, ie) {
        return T[Z] = ie;
      },
      /**
       * Returns the latest motion value state. Currently only used to take
       * a snapshot of the visual element - perhaps this can return the whole
       * visual state
       */
      getLatestValues: function() {
        return T;
      },
      /**
       * Set the visiblity of the visual element. If it's changed, schedule
       * a render to reflect these changes.
       */
      setVisibility: function(Z) {
        M.isVisible !== Z && (M.isVisible = Z, M.scheduleRender());
      },
      /**
       * Make a target animatable by Popmotion. For instance, if we're
       * trying to animate width from 100px to 100vw we need to measure 100vw
       * in pixels to determine what we really need to animate to. This is also
       * pluggable to support Framer's custom value types like Color,
       * and CSS variables.
       */
      makeTargetAnimatable: function(Z, ie) {
        return ie === void 0 && (ie = !0), o(M, Z, w, ie);
      },
      /**
       * Measure the current viewport box with or without transforms.
       * Only measures axis-aligned boxes, rotate and skew must be manually
       * removed with a re-render to work.
       */
      measureViewportBox: function() {
        return a(R, w);
      },
      // Motion values ========================
      /**
       * Add a motion value and bind it to this visual element.
       */
      addValue: function(Z, ie) {
        M.hasValue(Z) && M.removeValue(Z), B.set(Z, ie), T[Z] = ie.get(), ne(Z, ie);
      },
      /**
       * Remove a motion value and unbind any active subscriptions.
       */
      removeValue: function(Z) {
        var ie;
        B.delete(Z), (ie = L.get(Z)) === null || ie === void 0 || ie(), L.delete(Z), delete T[Z], f(Z, P);
      },
      /**
       * Check whether we have a motion value for this key
       */
      hasValue: function(Z) {
        return B.has(Z);
      },
      /**
       * Get a motion value for this key. If called with a default
       * value, we'll create one if none exists.
       */
      getValue: function(Z, ie) {
        var pe = B.get(Z);
        return pe === void 0 && ie !== void 0 && (pe = Va(ie), M.addValue(Z, pe)), pe;
      },
      /**
       * Iterate over our motion values.
       */
      forEachValue: function(Z) {
        return B.forEach(Z);
      },
      /**
       * If we're trying to animate to a previously unencountered value,
       * we need to check for it in our state and as a last resort read it
       * directly from the instance (which might have performance implications).
       */
      readValue: function(Z) {
        var ie;
        return (ie = T[Z]) !== null && ie !== void 0 ? ie : c(R, Z, m);
      },
      /**
       * Set the base target to later animate back to. This is currently
       * only hydrated on creation and when we first read a value.
       */
      setBaseTarget: function(Z, ie) {
        I[Z] = ie;
      },
      /**
       * Find the base target for a value thats been removed from all animation
       * props.
       */
      getBaseTarget: function(Z) {
        if (i) {
          var ie = i(w, Z);
          if (ie !== void 0 && !Ai(ie))
            return ie;
        }
        return I[Z];
      }
    }, N), {
      /**
       * Build the renderer state based on the latest visual state.
       */
      build: function() {
        return G(), P;
      },
      /**
       * Schedule a render on the next animation frame.
       */
      scheduleRender: function() {
        Vr.render(H, !1, !0);
      },
      /**
       * Synchronously fire render. It's prefered that we batch renders but
       * in many circumstances, like layout measurement, we need to run this
       * synchronously. However in those instances other measures should be taken
       * to batch reads/writes.
       */
      syncRender: H,
      /**
       * Update the provided props. Ensure any newly-added motion values are
       * added to our map, old ones removed, and listeners updated.
       */
      setProps: function(Z) {
        (Z.transformTemplate || w.transformTemplate) && M.scheduleRender(), w = Z, N.updatePropListeners(Z), j = aL(M, d(w), j);
      },
      getProps: function() {
        return w;
      },
      // Variants ==============================
      /**
       * Returns the variant definition with a given name.
       */
      getVariant: function(Z) {
        var ie;
        return (ie = w.variants) === null || ie === void 0 ? void 0 : ie[Z];
      },
      /**
       * Returns the defined default transition on this component.
       */
      getDefaultTransition: function() {
        return w.transition;
      },
      getTransformPagePoint: function() {
        return w.transformPagePoint;
      },
      /**
       * Used by child variant nodes to get the closest ancestor variant props.
       */
      getVariantContext: function(Z) {
        if (Z === void 0 && (Z = !1), Z)
          return v == null ? void 0 : v.getVariantContext();
        if (!X) {
          var ie = (v == null ? void 0 : v.getVariantContext()) || {};
          return w.initial !== void 0 && (ie.initial = w.initial), ie;
        }
        for (var pe = {}, Te = 0; Te < sL; Te++) {
          var ke = FE[Te], me = w[ke];
          (Ir(me) || me === !1) && (pe[ke] = me);
        }
        return pe;
      }
    });
    return M;
  };
}, FE = yr(["initial"], jt(v1), !1), sL = FE.length;
function dm(e) {
  return typeof e == "string" && e.startsWith("var(--");
}
var zE = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function lL(e) {
  var t = zE.exec(e);
  if (!t)
    return [,];
  var n = jt(t, 3), r = n[1], i = n[2];
  return [r, i];
}
var cL = 4;
function pm(e, t, n) {
  n === void 0 && (n = 1), xr(n <= cL, 'Max CSS variable fallback depth detected in property "'.concat(e, '". This may indicate a circular fallback dependency.'));
  var r = jt(lL(e), 2), i = r[0], o = r[1];
  if (i) {
    var a = window.getComputedStyle(t).getPropertyValue(i);
    return a ? a.trim() : dm(o) ? pm(o, t, n + 1) : o;
  }
}
function uL(e, t, n) {
  var r, i = jn(t, []), o = e.getInstance();
  if (!(o instanceof Element))
    return { target: i, transitionEnd: n };
  n && (n = ve({}, n)), e.forEachValue(function(f) {
    var p = f.get();
    if (dm(p)) {
      var d = pm(p, o);
      d && f.set(d);
    }
  });
  for (var a in i) {
    var s = i[a];
    if (dm(s)) {
      var c = pm(s, o);
      c && (i[a] = c, n && ((r = n[a]) !== null && r !== void 0 || (n[a] = s)));
    }
  }
  return { target: i, transitionEnd: n };
}
var fL = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), VE = function(e) {
  return fL.has(e);
}, dL = function(e) {
  return Object.keys(e).some(VE);
}, BE = function(e, t) {
  e.set(t, !1), e.set(t);
}, Bc = function(e) {
  return e === Yo || e === Be;
}, _b;
(function(e) {
  e.width = "width", e.height = "height", e.left = "left", e.right = "right", e.top = "top", e.bottom = "bottom";
})(_b || (_b = {}));
var Tb = function(e, t) {
  return parseFloat(e.split(", ")[t]);
}, kb = function(e, t) {
  return function(n, r) {
    var i = r.transform;
    if (i === "none" || !i)
      return 0;
    var o = i.match(/^matrix3d\((.+)\)$/);
    if (o)
      return Tb(o[1], t);
    var a = i.match(/^matrix\((.+)\)$/);
    return a ? Tb(a[1], e) : 0;
  };
}, pL = /* @__PURE__ */ new Set(["x", "y", "z"]), hL = Zs.filter(function(e) {
  return !pL.has(e);
});
function mL(e) {
  var t = [];
  return hL.forEach(function(n) {
    var r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t.length && e.syncRender(), t;
}
var Pb = {
  // Dimensions
  width: function(e, t) {
    var n = e.x, r = t.paddingLeft, i = r === void 0 ? "0" : r, o = t.paddingRight, a = o === void 0 ? "0" : o;
    return n.max - n.min - parseFloat(i) - parseFloat(a);
  },
  height: function(e, t) {
    var n = e.y, r = t.paddingTop, i = r === void 0 ? "0" : r, o = t.paddingBottom, a = o === void 0 ? "0" : o;
    return n.max - n.min - parseFloat(i) - parseFloat(a);
  },
  top: function(e, t) {
    var n = t.top;
    return parseFloat(n);
  },
  left: function(e, t) {
    var n = t.left;
    return parseFloat(n);
  },
  bottom: function(e, t) {
    var n = e.y, r = t.top;
    return parseFloat(r) + (n.max - n.min);
  },
  right: function(e, t) {
    var n = e.x, r = t.left;
    return parseFloat(r) + (n.max - n.min);
  },
  // Transform
  x: kb(4, 13),
  y: kb(5, 14)
}, gL = function(e, t, n) {
  var r = t.measureViewportBox(), i = t.getInstance(), o = getComputedStyle(i), a = o.display, s = {};
  a === "none" && t.setStaticValue("display", e.display || "block"), n.forEach(function(f) {
    s[f] = Pb[f](r, o);
  }), t.syncRender();
  var c = t.measureViewportBox();
  return n.forEach(function(f) {
    var p = t.getValue(f);
    BE(p, s[f]), e[f] = Pb[f](c, o);
  }), e;
}, vL = function(e, t, n, r) {
  n === void 0 && (n = {}), r === void 0 && (r = {}), t = ve({}, t), r = ve({}, r);
  var i = Object.keys(t).filter(VE), o = [], a = !1, s = [];
  if (i.forEach(function(p) {
    var d = e.getValue(p);
    if (e.hasValue(p)) {
      var h = n[p], m = xs(h), v = t[p], w;
      if (el(v)) {
        var b = v.length, E = v[0] === null ? 1 : 0;
        h = v[E], m = xs(h);
        for (var C = E; C < b; C++)
          w ? xr(xs(v[C]) === w, "All keyframes must be of the same type") : (w = xs(v[C]), xr(w === m || Bc(m) && Bc(w), "Keyframes must be of the same dimension as the current value"));
      } else
        w = xs(v);
      if (m !== w)
        if (Bc(m) && Bc(w)) {
          var S = d.get();
          typeof S == "string" && d.set(parseFloat(S)), typeof v == "string" ? t[p] = parseFloat(v) : Array.isArray(v) && w === Be && (t[p] = v.map(parseFloat));
        } else
          m != null && m.transform && (w != null && w.transform) && (h === 0 || v === 0) ? h === 0 ? d.set(w.transform(h)) : t[p] = m.transform(v) : (a || (o = mL(e), a = !0), s.push(p), r[p] = r[p] !== void 0 ? r[p] : t[p], BE(d, v));
    }
  }), s.length) {
    var c = s.indexOf("height") >= 0 ? window.pageYOffset : null, f = gL(t, e, s);
    return o.length && o.forEach(function(p) {
      var d = jt(p, 2), h = d[0], m = d[1];
      e.getValue(h).set(m);
    }), e.syncRender(), c !== null && window.scrollTo({ top: c }), { target: f, transitionEnd: r };
  } else
    return { target: t, transitionEnd: r };
};
function wL(e, t, n, r) {
  return dL(t) ? vL(e, t, n, r) : { target: t, transitionEnd: r };
}
var yL = function(e, t, n, r) {
  var i = uL(e, t, r);
  return t = i.target, r = i.transitionEnd, wL(e, t, n, r);
};
function bL(e) {
  return window.getComputedStyle(e);
}
var HE = {
  treeType: "dom",
  readValueFromInstance: function(e, t) {
    if (bl(t)) {
      var n = f1(t);
      return n && n.default || 0;
    } else {
      var r = bL(e);
      return ($x(t) ? r.getPropertyValue(t) : r[t]) || 0;
    }
  },
  sortNodePosition: function(e, t) {
    return e.compareDocumentPosition(t) & 2 ? 1 : -1;
  },
  getBaseTarget: function(e, t) {
    var n;
    return (n = e.style) === null || n === void 0 ? void 0 : n[t];
  },
  measureViewportBox: function(e, t) {
    var n = t.transformPagePoint;
    return IE(e, n);
  },
  /**
   * Reset the transform on the current Element. This is called as part
   * of a batched process across the entire layout tree. To remove this write
   * cycle it'd be interesting to see if it's possible to "undo" all the current
   * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
   * works
   */
  resetTransform: function(e, t, n) {
    var r = n.transformTemplate;
    t.style.transform = r ? r({}, "") : "none", e.scheduleRender();
  },
  restoreTransform: function(e, t) {
    e.style.transform = t.style.transform;
  },
  removeValueFromRenderState: function(e, t) {
    var n = t.vars, r = t.style;
    delete n[e], delete r[e];
  },
  /**
   * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
   * can be animated by Motion.
   */
  makeTargetAnimatable: function(e, t, n, r) {
    var i = n.transformValues;
    r === void 0 && (r = !0);
    var o = t.transition, a = t.transitionEnd, s = jn(t, ["transition", "transitionEnd"]), c = TI(s, o || {}, e);
    if (i && (a && (a = i(a)), s && (s = i(s)), c && (c = i(c))), r) {
      SI(e, s, c);
      var f = yL(e, s, c, a);
      a = f.transitionEnd, s = f.target;
    }
    return ve({ transition: o, transitionEnd: a }, s);
  },
  scrapeMotionValuesFromProps: t1,
  build: function(e, t, n, r, i) {
    e.isVisible !== void 0 && (t.style.visibility = e.isVisible ? "visible" : "hidden"), Zg(t, n, r, i.transformTemplate);
  },
  render: Wx
}, xL = LE(HE), EL = LE(ve(ve({}, HE), { getBaseTarget: function(e, t) {
  return e[t];
}, readValueFromInstance: function(e, t) {
  var n;
  return bl(t) ? ((n = f1(t)) === null || n === void 0 ? void 0 : n.default) || 0 : (t = jx.has(t) ? t : Ux(t), e.getAttribute(t));
}, scrapeMotionValuesFromProps: Gx, build: function(e, t, n, r, i) {
  e1(t, n, r, i.transformTemplate);
}, render: qx })), CL = function(e, t) {
  return Xg(e) ? EL(t, { enableHardwareAcceleration: !1 }) : xL(t, { enableHardwareAcceleration: !0 });
};
function Ab(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
var Es = {
  correct: function(e, t) {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (Be.test(e))
        e = parseFloat(e);
      else
        return e;
    var n = Ab(e, t.target.x), r = Ab(e, t.target.y);
    return "".concat(n, "% ").concat(r, "%");
  }
}, Rb = "_$css", SL = {
  correct: function(e, t) {
    var n = t.treeScale, r = t.projectionDelta, i = e, o = e.includes("var("), a = [];
    o && (e = e.replace(zE, function(w) {
      return a.push(w), Rb;
    }));
    var s = Ri.parse(e);
    if (s.length > 5)
      return i;
    var c = Ri.createTransformer(e), f = typeof s[0] != "number" ? 1 : 0, p = r.x.scale * n.x, d = r.y.scale * n.y;
    s[0 + f] /= p, s[1 + f] /= d;
    var h = Wt(p, d, 0.5);
    typeof s[2 + f] == "number" && (s[2 + f] /= h), typeof s[3 + f] == "number" && (s[3 + f] /= h);
    var m = c(s);
    if (o) {
      var v = 0;
      m = m.replace(Rb, function() {
        var w = a[v];
        return v++, w;
      });
    }
    return m;
  }
}, _L = (
  /** @class */
  function(e) {
    ax(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.componentDidMount = function() {
      var n = this, r = this.props, i = r.visualElement, o = r.layoutGroup, a = r.switchLayoutGroup, s = r.layoutId, c = i.projection;
      QM(kL), c && (o != null && o.group && o.group.add(c), a != null && a.register && s && a.register(c), c.root.didUpdate(), c.addEventListener("animationComplete", function() {
        n.safeToRemove();
      }), c.setOptions(ve(ve({}, c.options), { onExitComplete: function() {
        return n.safeToRemove();
      } }))), Ls.hasEverUpdated = !0;
    }, t.prototype.getSnapshotBeforeUpdate = function(n) {
      var r = this, i = this.props, o = i.layoutDependency, a = i.visualElement, s = i.drag, c = i.isPresent, f = a.projection;
      return f && (f.isPresent = c, s || n.layoutDependency !== o || o === void 0 ? f.willUpdate() : this.safeToRemove(), n.isPresent !== c && (c ? f.promote() : f.relegate() || Vr.postRender(function() {
        var p;
        !((p = f.getStack()) === null || p === void 0) && p.members.length || r.safeToRemove();
      }))), null;
    }, t.prototype.componentDidUpdate = function() {
      var n = this.props.visualElement.projection;
      n && (n.root.didUpdate(), !n.currentAnimation && n.isLead() && this.safeToRemove());
    }, t.prototype.componentWillUnmount = function() {
      var n = this.props, r = n.visualElement, i = n.layoutGroup, o = n.switchLayoutGroup, a = r.projection;
      a && (a.scheduleCheckAfterUnmount(), i != null && i.group && i.group.remove(a), o != null && o.deregister && o.deregister(a));
    }, t.prototype.safeToRemove = function() {
      var n = this.props.safeToRemove;
      n == null || n();
    }, t.prototype.render = function() {
      return null;
    }, t;
  }(y.Component)
);
function TL(e) {
  var t = jt(TE(), 2), n = t[0], r = t[1], i = Re(Kg);
  return y.createElement(_L, ve({}, e, { layoutGroup: i, switchLayoutGroup: Re(Px), isPresent: n, safeToRemove: r }));
}
var kL = {
  borderRadius: ve(ve({}, Es), { applyTo: [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ] }),
  borderTopLeftRadius: Es,
  borderTopRightRadius: Es,
  borderBottomLeftRadius: Es,
  borderBottomRightRadius: Es,
  boxShadow: SL
}, PL = {
  measureLayout: TL
};
function AL(e, t, n) {
  n === void 0 && (n = {});
  var r = Ai(e) ? e : Va(e);
  return h1("", r, t, n), {
    stop: function() {
      return r.stop();
    },
    isAnimating: function() {
      return r.isAnimating();
    }
  };
}
var UE = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], RL = UE.length, $b = function(e) {
  return typeof e == "string" ? parseFloat(e) : e;
}, Ob = function(e) {
  return typeof e == "number" || Be.test(e);
};
function $L(e, t, n, r, i, o) {
  var a, s, c, f;
  i ? (e.opacity = Wt(
    0,
    // (follow?.opacity as number) ?? 0,
    // TODO Reinstate this if only child
    (a = n.opacity) !== null && a !== void 0 ? a : 1,
    OL(r)
  ), e.opacityExit = Wt((s = t.opacity) !== null && s !== void 0 ? s : 1, 0, ML(r))) : o && (e.opacity = Wt((c = t.opacity) !== null && c !== void 0 ? c : 1, (f = n.opacity) !== null && f !== void 0 ? f : 1, r));
  for (var p = 0; p < RL; p++) {
    var d = "border".concat(UE[p], "Radius"), h = Mb(t, d), m = Mb(n, d);
    if (!(h === void 0 && m === void 0)) {
      h || (h = 0), m || (m = 0);
      var v = h === 0 || m === 0 || Ob(h) === Ob(m);
      v ? (e[d] = Math.max(Wt($b(h), $b(m), r), 0), (ni.test(m) || ni.test(h)) && (e[d] += "%")) : e[d] = m;
    }
  }
  (t.rotate || n.rotate) && (e.rotate = Wt(t.rotate || 0, n.rotate || 0, r));
}
function Mb(e, t) {
  var n;
  return (n = e[t]) !== null && n !== void 0 ? n : e.borderRadius;
}
var OL = WE(0, 0.5, c1), ML = WE(0.5, 0.95, s1);
function WE(e, t, n) {
  return function(r) {
    return r < e ? 0 : r > t ? 1 : n(tl(e, t, r));
  };
}
function Db(e, t) {
  e.min = t.min, e.max = t.max;
}
function Mr(e, t) {
  Db(e.x, t.x), Db(e.y, t.y);
}
function Nb(e, t, n, r, i) {
  return e -= t, e = Vu(e, 1 / n, r), i !== void 0 && (e = Vu(e, 1 / i, r)), e;
}
function DL(e, t, n, r, i, o, a) {
  if (t === void 0 && (t = 0), n === void 0 && (n = 1), r === void 0 && (r = 0.5), o === void 0 && (o = e), a === void 0 && (a = e), ni.test(t)) {
    t = parseFloat(t);
    var s = Wt(a.min, a.max, t / 100);
    t = s - a.min;
  }
  if (typeof t == "number") {
    var c = Wt(o.min, o.max, r);
    e === o && (c -= t), e.min = Nb(e.min, t, n, c, i), e.max = Nb(e.max, t, n, c, i);
  }
}
function Ib(e, t, n, r, i) {
  var o = jt(n, 3), a = o[0], s = o[1], c = o[2];
  DL(e, t[a], t[s], t[c], t.scale, r, i);
}
var NL = ["x", "scaleX", "originX"], IL = ["y", "scaleY", "originY"];
function Lb(e, t, n, r) {
  Ib(e.x, t, NL, n == null ? void 0 : n.x, r == null ? void 0 : r.x), Ib(e.y, t, IL, n == null ? void 0 : n.y, r == null ? void 0 : r.y);
}
function Fb(e) {
  return e.translate === 0 && e.scale === 1;
}
function jE(e) {
  return Fb(e.x) && Fb(e.y);
}
function qE(e, t) {
  return e.x.min === t.x.min && e.x.max === t.x.max && e.y.min === t.y.min && e.y.max === t.y.max;
}
var LL = (
  /** @class */
  function() {
    function e() {
      this.members = [];
    }
    return e.prototype.add = function(t) {
      m1(this.members, t), t.scheduleRender();
    }, e.prototype.remove = function(t) {
      if (g1(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
        var n = this.members[this.members.length - 1];
        n && this.promote(n);
      }
    }, e.prototype.relegate = function(t) {
      var n = this.members.findIndex(function(a) {
        return t === a;
      });
      if (n === 0)
        return !1;
      for (var r, i = n; i >= 0; i--) {
        var o = this.members[i];
        if (o.isPresent !== !1) {
          r = o;
          break;
        }
      }
      return r ? (this.promote(r), !0) : !1;
    }, e.prototype.promote = function(t, n) {
      var r, i = this.lead;
      if (t !== i && (this.prevLead = i, this.lead = t, t.show(), i)) {
        i.instance && i.scheduleRender(), t.scheduleRender(), t.resumeFrom = i, n && (t.resumeFrom.preserveOpacity = !0), i.snapshot && (t.snapshot = i.snapshot, t.snapshot.latestValues = i.animationValues || i.latestValues, t.snapshot.isShared = !0), !((r = t.root) === null || r === void 0) && r.isUpdating && (t.isLayoutDirty = !0);
        var o = t.options.crossfade;
        o === !1 && i.hide();
      }
    }, e.prototype.exitAnimationComplete = function() {
      this.members.forEach(function(t) {
        var n, r, i, o, a;
        (r = (n = t.options).onExitComplete) === null || r === void 0 || r.call(n), (a = (i = t.resumingFrom) === null || i === void 0 ? void 0 : (o = i.options).onExitComplete) === null || a === void 0 || a.call(o);
      });
    }, e.prototype.scheduleRender = function() {
      this.members.forEach(function(t) {
        t.instance && t.scheduleRender(!1);
      });
    }, e.prototype.removeLeadSnapshot = function() {
      this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
    }, e;
  }()
), FL = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function zb(e, t, n) {
  var r = e.x.translate / t.x, i = e.y.translate / t.y, o = "translate3d(".concat(r, "px, ").concat(i, "px, 0) ");
  if (o += "scale(".concat(1 / t.x, ", ").concat(1 / t.y, ") "), n) {
    var a = n.rotate, s = n.rotateX, c = n.rotateY;
    a && (o += "rotate(".concat(a, "deg) ")), s && (o += "rotateX(".concat(s, "deg) ")), c && (o += "rotateY(".concat(c, "deg) "));
  }
  var f = e.x.scale * t.x, p = e.y.scale * t.y;
  return o += "scale(".concat(f, ", ").concat(p, ")"), o === FL ? "none" : o;
}
var zL = function(e, t) {
  return e.depth - t.depth;
}, VL = (
  /** @class */
  function() {
    function e() {
      this.children = [], this.isDirty = !1;
    }
    return e.prototype.add = function(t) {
      m1(this.children, t), this.isDirty = !0;
    }, e.prototype.remove = function(t) {
      g1(this.children, t), this.isDirty = !0;
    }, e.prototype.forEach = function(t) {
      this.isDirty && this.children.sort(zL), this.isDirty = !1, this.children.forEach(t);
    }, e;
  }()
), Vb = 1e3;
function GE(e) {
  var t = e.attachResizeListener, n = e.defaultParent, r = e.measureScroll, i = e.checkIsScrollRoot, o = e.resetTransform;
  return (
    /** @class */
    function() {
      function a(s, c, f) {
        var p = this;
        c === void 0 && (c = {}), f === void 0 && (f = n == null ? void 0 : n()), this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.potentialNodes = /* @__PURE__ */ new Map(), this.checkUpdateFailed = function() {
          p.isUpdating && (p.isUpdating = !1, p.clearAllSnapshots());
        }, this.updateProjection = function() {
          p.nodes.forEach(qL), p.nodes.forEach(GL);
        }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.id = s, this.latestValues = c, this.root = f ? f.root || f : this, this.path = f ? yr(yr([], jt(f.path), !1), [f], !1) : [], this.parent = f, this.depth = f ? f.depth + 1 : 0, s && this.root.registerPotentialNode(s, this);
        for (var d = 0; d < this.path.length; d++)
          this.path[d].shouldResetTransform = !0;
        this.root === this && (this.nodes = new VL());
      }
      return a.prototype.addEventListener = function(s, c) {
        return this.eventHandlers.has(s) || this.eventHandlers.set(s, new Vs()), this.eventHandlers.get(s).add(c);
      }, a.prototype.notifyListeners = function(s) {
        for (var c = [], f = 1; f < arguments.length; f++)
          c[f - 1] = arguments[f];
        var p = this.eventHandlers.get(s);
        p == null || p.notify.apply(p, yr([], jt(c), !1));
      }, a.prototype.hasListeners = function(s) {
        return this.eventHandlers.has(s);
      }, a.prototype.registerPotentialNode = function(s, c) {
        this.potentialNodes.set(s, c);
      }, a.prototype.mount = function(s, c) {
        var f = this, p;
        if (c === void 0 && (c = !1), !this.instance) {
          this.isSVG = s instanceof SVGElement && s.tagName !== "svg", this.instance = s;
          var d = this.options, h = d.layoutId, m = d.layout, v = d.visualElement;
          if (v && !v.getInstance() && v.mount(s), this.root.nodes.add(this), (p = this.parent) === null || p === void 0 || p.children.add(this), this.id && this.root.potentialNodes.delete(this.id), c && (m || h) && (this.isLayoutDirty = !0), t) {
            var w, b = function() {
              return f.root.updateBlockedByResize = !1;
            };
            t(s, function() {
              f.root.updateBlockedByResize = !0, clearTimeout(w), w = window.setTimeout(b, 250), Ls.hasAnimatedSinceResize && (Ls.hasAnimatedSinceResize = !1, f.nodes.forEach(jL));
            });
          }
          h && this.root.registerSharedNode(h, this), this.options.animate !== !1 && v && (h || m) && this.addEventListener("didUpdate", function(E) {
            var C, S, _, T, P, R = E.delta, N = E.hasLayoutChanged, B = E.hasRelativeTargetChanged, L = E.layout;
            if (f.isTreeAnimationBlocked()) {
              f.target = void 0, f.relativeTarget = void 0;
              return;
            }
            var j = (S = (C = f.options.transition) !== null && C !== void 0 ? C : v.getDefaultTransition()) !== null && S !== void 0 ? S : ZL, I = v.getProps(), z = I.onLayoutAnimationStart, H = I.onLayoutAnimationComplete, G = !f.targetLayout || !qE(f.targetLayout, L) || B, Y = !N && B;
            if (!((_ = f.resumeFrom) === null || _ === void 0) && _.instance || Y || N && (G || !f.currentAnimation)) {
              f.resumeFrom && (f.resumingFrom = f.resumeFrom, f.resumingFrom.resumingFrom = void 0), f.setAnimationOrigin(R, Y);
              var ne = ve(ve({}, p1(j, "layout")), { onPlay: z, onComplete: H });
              v.shouldReduceMotion && (ne.delay = 0, ne.type = !1), f.startAnimation(ne);
            } else
              !N && f.animationProgress === 0 && f.finishAnimation(), f.isLead() && ((P = (T = f.options).onExitComplete) === null || P === void 0 || P.call(T));
            f.targetLayout = L;
          });
        }
      }, a.prototype.unmount = function() {
        var s, c;
        this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this), (s = this.getStack()) === null || s === void 0 || s.remove(this), (c = this.parent) === null || c === void 0 || c.children.delete(this), this.instance = void 0, za.preRender(this.updateProjection);
      }, a.prototype.blockUpdate = function() {
        this.updateManuallyBlocked = !0;
      }, a.prototype.unblockUpdate = function() {
        this.updateManuallyBlocked = !1;
      }, a.prototype.isUpdateBlocked = function() {
        return this.updateManuallyBlocked || this.updateBlockedByResize;
      }, a.prototype.isTreeAnimationBlocked = function() {
        var s;
        return this.isAnimationBlocked || ((s = this.parent) === null || s === void 0 ? void 0 : s.isTreeAnimationBlocked()) || !1;
      }, a.prototype.startUpdate = function() {
        var s;
        this.isUpdateBlocked() || (this.isUpdating = !0, (s = this.nodes) === null || s === void 0 || s.forEach(YL));
      }, a.prototype.willUpdate = function(s) {
        var c, f, p;
        if (s === void 0 && (s = !0), this.root.isUpdateBlocked()) {
          (f = (c = this.options).onExitComplete) === null || f === void 0 || f.call(c);
          return;
        }
        if (!this.root.isUpdating && this.root.startUpdate(), !this.isLayoutDirty) {
          this.isLayoutDirty = !0;
          for (var d = 0; d < this.path.length; d++) {
            var h = this.path[d];
            h.shouldResetTransform = !0, h.updateScroll();
          }
          var m = this.options, v = m.layoutId, w = m.layout;
          if (!(v === void 0 && !w)) {
            var b = (p = this.options.visualElement) === null || p === void 0 ? void 0 : p.getProps().transformTemplate;
            this.prevTransformTemplateValue = b == null ? void 0 : b(this.latestValues, ""), this.updateSnapshot(), s && this.notifyListeners("willUpdate");
          }
        }
      }, a.prototype.didUpdate = function() {
        var s = this.isUpdateBlocked();
        if (s) {
          this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Bb);
          return;
        }
        this.isUpdating && (this.isUpdating = !1, this.potentialNodes.size && (this.potentialNodes.forEach(JL), this.potentialNodes.clear()), this.nodes.forEach(WL), this.nodes.forEach(BL), this.nodes.forEach(HL), this.clearAllSnapshots(), qp.update(), qp.preRender(), qp.render());
      }, a.prototype.clearAllSnapshots = function() {
        this.nodes.forEach(UL), this.sharedNodes.forEach(KL);
      }, a.prototype.scheduleUpdateProjection = function() {
        Vr.preRender(this.updateProjection, !1, !0);
      }, a.prototype.scheduleCheckAfterUnmount = function() {
        var s = this;
        Vr.postRender(function() {
          s.isLayoutDirty ? s.root.didUpdate() : s.root.checkUpdateFailed();
        });
      }, a.prototype.updateSnapshot = function() {
        if (!(this.snapshot || !this.instance)) {
          var s = this.measure(), c = this.removeTransform(this.removeElementScroll(s));
          jb(c), this.snapshot = {
            measured: s,
            layout: c,
            latestValues: {}
          };
        }
      }, a.prototype.updateLayout = function() {
        var s;
        if (this.instance && (this.updateScroll(), !(!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))) {
          if (this.resumeFrom && !this.resumeFrom.instance)
            for (var c = 0; c < this.path.length; c++) {
              var f = this.path[c];
              f.updateScroll();
            }
          var p = this.measure();
          jb(p);
          var d = this.layout;
          this.layout = {
            measured: p,
            actual: this.removeElementScroll(p)
          }, this.layoutCorrected = vn(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.actual), (s = this.options.visualElement) === null || s === void 0 || s.notifyLayoutMeasure(this.layout.actual, d == null ? void 0 : d.actual);
        }
      }, a.prototype.updateScroll = function() {
        this.options.layoutScroll && this.instance && (this.isScrollRoot = i(this.instance), this.scroll = r(this.instance));
      }, a.prototype.resetTransform = function() {
        var s;
        if (o) {
          var c = this.isLayoutDirty || this.shouldResetTransform, f = this.projectionDelta && !jE(this.projectionDelta), p = (s = this.options.visualElement) === null || s === void 0 ? void 0 : s.getProps().transformTemplate, d = p == null ? void 0 : p(this.latestValues, ""), h = d !== this.prevTransformTemplateValue;
          c && (f || Qi(this.latestValues) || h) && (o(this.instance, d), this.shouldResetTransform = !1, this.scheduleRender());
        }
      }, a.prototype.measure = function() {
        var s = this.options.visualElement;
        if (!s)
          return vn();
        var c = s.measureViewportBox(), f = this.root.scroll;
        return f && (Zi(c.x, f.x), Zi(c.y, f.y)), c;
      }, a.prototype.removeElementScroll = function(s) {
        var c = vn();
        Mr(c, s);
        for (var f = 0; f < this.path.length; f++) {
          var p = this.path[f], d = p.scroll, h = p.options, m = p.isScrollRoot;
          if (p !== this.root && d && h.layoutScroll) {
            if (m) {
              Mr(c, s);
              var v = this.root.scroll;
              v && (Zi(c.x, -v.x), Zi(c.y, -v.y));
            }
            Zi(c.x, d.x), Zi(c.y, d.y);
          }
        }
        return c;
      }, a.prototype.applyTransform = function(s, c) {
        c === void 0 && (c = !1);
        var f = vn();
        Mr(f, s);
        for (var p = 0; p < this.path.length; p++) {
          var d = this.path[p];
          !c && d.options.layoutScroll && d.scroll && d !== d.root && Ta(f, {
            x: -d.scroll.x,
            y: -d.scroll.y
          }), Qi(d.latestValues) && Ta(f, d.latestValues);
        }
        return Qi(this.latestValues) && Ta(f, this.latestValues), f;
      }, a.prototype.removeTransform = function(s) {
        var c, f = vn();
        Mr(f, s);
        for (var p = 0; p < this.path.length; p++) {
          var d = this.path[p];
          if (d.instance && Qi(d.latestValues)) {
            DE(d.latestValues) && d.updateSnapshot();
            var h = vn(), m = d.measure();
            Mr(h, m), Lb(f, d.latestValues, (c = d.snapshot) === null || c === void 0 ? void 0 : c.layout, h);
          }
        }
        return Qi(this.latestValues) && Lb(f, this.latestValues), f;
      }, a.prototype.setTargetDelta = function(s) {
        this.targetDelta = s, this.root.scheduleUpdateProjection();
      }, a.prototype.setOptions = function(s) {
        var c;
        this.options = ve(ve(ve({}, this.options), s), { crossfade: (c = s.crossfade) !== null && c !== void 0 ? c : !0 });
      }, a.prototype.clearMeasurements = function() {
        this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
      }, a.prototype.resolveTargetDelta = function() {
        var s, c = this.options, f = c.layout, p = c.layoutId;
        !this.layout || !(f || p) || (!this.targetDelta && !this.relativeTarget && (this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && this.relativeParent.layout && (this.relativeTarget = vn(), this.relativeTargetOrigin = vn(), Hs(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual), Mr(this.relativeTarget, this.relativeTargetOrigin))), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = vn(), this.targetWithTransforms = vn()), this.relativeTarget && this.relativeTargetOrigin && (!((s = this.relativeParent) === null || s === void 0) && s.target) ? VI(this.target, this.relativeTarget, this.relativeParent.target) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.actual) : Mr(this.target, this.layout.actual), NE(this.target, this.targetDelta)) : Mr(this.target, this.layout.actual), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && !!this.relativeParent.resumingFrom == !!this.resumingFrom && !this.relativeParent.options.layoutScroll && this.relativeParent.target && (this.relativeTarget = vn(), this.relativeTargetOrigin = vn(), Hs(this.relativeTargetOrigin, this.target, this.relativeParent.target), Mr(this.relativeTarget, this.relativeTargetOrigin)))));
      }, a.prototype.getClosestProjectingParent = function() {
        if (!(!this.parent || Qi(this.parent.latestValues)))
          return (this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout ? this.parent : this.parent.getClosestProjectingParent();
      }, a.prototype.calcProjection = function() {
        var s, c = this.options, f = c.layout, p = c.layoutId;
        if (this.isTreeAnimating = !!(!((s = this.parent) === null || s === void 0) && s.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !(!this.layout || !(f || p))) {
          var d = this.getLead();
          Mr(this.layoutCorrected, this.layout.actual), KI(this.layoutCorrected, this.treeScale, this.path, !!this.resumingFrom || this !== d);
          var h = d.target;
          if (h) {
            this.projectionDelta || (this.projectionDelta = Us(), this.projectionDeltaWithTransform = Us());
            var m = this.treeScale.x, v = this.treeScale.y, w = this.projectionTransform;
            Bs(this.projectionDelta, this.layoutCorrected, h, this.latestValues), this.projectionTransform = zb(this.projectionDelta, this.treeScale), (this.projectionTransform !== w || this.treeScale.x !== m || this.treeScale.y !== v) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", h));
          }
        }
      }, a.prototype.hide = function() {
        this.isVisible = !1;
      }, a.prototype.show = function() {
        this.isVisible = !0;
      }, a.prototype.scheduleRender = function(s) {
        var c, f, p;
        s === void 0 && (s = !0), (f = (c = this.options).scheduleRender) === null || f === void 0 || f.call(c), s && ((p = this.getStack()) === null || p === void 0 || p.scheduleRender()), this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
      }, a.prototype.setAnimationOrigin = function(s, c) {
        var f = this, p;
        c === void 0 && (c = !1);
        var d = this.snapshot, h = (d == null ? void 0 : d.latestValues) || {}, m = ve({}, this.latestValues), v = Us();
        this.relativeTarget = this.relativeTargetOrigin = void 0, this.attemptToResolveRelativeTarget = !c;
        var w = vn(), b = d == null ? void 0 : d.isShared, E = (((p = this.getStack()) === null || p === void 0 ? void 0 : p.members.length) || 0) <= 1, C = !!(b && !E && this.options.crossfade === !0 && !this.path.some(QL));
        this.animationProgress = 0, this.mixTargetDelta = function(S) {
          var _, T = S / 1e3;
          Hb(v.x, s.x, T), Hb(v.y, s.y, T), f.setTargetDelta(v), f.relativeTarget && f.relativeTargetOrigin && f.layout && (!((_ = f.relativeParent) === null || _ === void 0) && _.layout) && (Hs(w, f.layout.actual, f.relativeParent.layout.actual), XL(f.relativeTarget, f.relativeTargetOrigin, w, T)), b && (f.animationValues = m, $L(m, h, f.latestValues, T, C, E)), f.root.scheduleUpdateProjection(), f.scheduleRender(), f.animationProgress = T;
        }, this.mixTargetDelta(0);
      }, a.prototype.startAnimation = function(s) {
        var c = this, f, p;
        this.notifyListeners("animationStart"), (f = this.currentAnimation) === null || f === void 0 || f.stop(), this.resumingFrom && ((p = this.resumingFrom.currentAnimation) === null || p === void 0 || p.stop()), this.pendingAnimation && (za.update(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Vr.update(function() {
          Ls.hasAnimatedSinceResize = !0, c.currentAnimation = AL(0, Vb, ve(ve({}, s), { onUpdate: function(d) {
            var h;
            c.mixTargetDelta(d), (h = s.onUpdate) === null || h === void 0 || h.call(s, d);
          }, onComplete: function() {
            var d;
            (d = s.onComplete) === null || d === void 0 || d.call(s), c.completeAnimation();
          } })), c.resumingFrom && (c.resumingFrom.currentAnimation = c.currentAnimation), c.pendingAnimation = void 0;
        });
      }, a.prototype.completeAnimation = function() {
        var s;
        this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0), (s = this.getStack()) === null || s === void 0 || s.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
      }, a.prototype.finishAnimation = function() {
        var s;
        this.currentAnimation && ((s = this.mixTargetDelta) === null || s === void 0 || s.call(this, Vb), this.currentAnimation.stop()), this.completeAnimation();
      }, a.prototype.applyTransformsToTarget = function() {
        var s = this.getLead(), c = s.targetWithTransforms, f = s.target, p = s.layout, d = s.latestValues;
        !c || !f || !p || (Mr(c, f), Ta(c, d), Bs(this.projectionDeltaWithTransform, this.layoutCorrected, c, d));
      }, a.prototype.registerSharedNode = function(s, c) {
        var f, p, d;
        this.sharedNodes.has(s) || this.sharedNodes.set(s, new LL());
        var h = this.sharedNodes.get(s);
        h.add(c), c.promote({
          transition: (f = c.options.initialPromotionConfig) === null || f === void 0 ? void 0 : f.transition,
          preserveFollowOpacity: (d = (p = c.options.initialPromotionConfig) === null || p === void 0 ? void 0 : p.shouldPreserveFollowOpacity) === null || d === void 0 ? void 0 : d.call(p, c)
        });
      }, a.prototype.isLead = function() {
        var s = this.getStack();
        return s ? s.lead === this : !0;
      }, a.prototype.getLead = function() {
        var s, c = this.options.layoutId;
        return c ? ((s = this.getStack()) === null || s === void 0 ? void 0 : s.lead) || this : this;
      }, a.prototype.getPrevLead = function() {
        var s, c = this.options.layoutId;
        return c ? (s = this.getStack()) === null || s === void 0 ? void 0 : s.prevLead : void 0;
      }, a.prototype.getStack = function() {
        var s = this.options.layoutId;
        if (s)
          return this.root.sharedNodes.get(s);
      }, a.prototype.promote = function(s) {
        var c = s === void 0 ? {} : s, f = c.needsReset, p = c.transition, d = c.preserveFollowOpacity, h = this.getStack();
        h && h.promote(this, d), f && (this.projectionDelta = void 0, this.needsReset = !0), p && this.setOptions({ transition: p });
      }, a.prototype.relegate = function() {
        var s = this.getStack();
        return s ? s.relegate(this) : !1;
      }, a.prototype.resetRotation = function() {
        var s = this.options.visualElement;
        if (s) {
          for (var c = !1, f = {}, p = 0; p < Zh.length; p++) {
            var d = Zh[p], h = "rotate" + d;
            s.getStaticValue(h) && (c = !0, f[h] = s.getStaticValue(h), s.setStaticValue(h, 0));
          }
          if (c) {
            s == null || s.syncRender();
            for (var h in f)
              s.setStaticValue(h, f[h]);
            s.scheduleRender();
          }
        }
      }, a.prototype.getProjectionStyles = function(s) {
        var c, f, p, d, h, m;
        s === void 0 && (s = {});
        var v = {};
        if (!this.instance || this.isSVG)
          return v;
        if (this.isVisible)
          v.visibility = "";
        else
          return { visibility: "hidden" };
        var w = (c = this.options.visualElement) === null || c === void 0 ? void 0 : c.getProps().transformTemplate;
        if (this.needsReset)
          return this.needsReset = !1, v.opacity = "", v.pointerEvents = pu(s.pointerEvents) || "", v.transform = w ? w(this.latestValues, "") : "none", v;
        var b = this.getLead();
        if (!this.projectionDelta || !this.layout || !b.target) {
          var E = {};
          return this.options.layoutId && (E.opacity = (f = this.latestValues.opacity) !== null && f !== void 0 ? f : 1, E.pointerEvents = pu(s.pointerEvents) || ""), this.hasProjected && !Qi(this.latestValues) && (E.transform = w ? w({}, "") : "none", this.hasProjected = !1), E;
        }
        var C = b.animationValues || b.latestValues;
        this.applyTransformsToTarget(), v.transform = zb(this.projectionDeltaWithTransform, this.treeScale, C), w && (v.transform = w(C, v.transform));
        var S = this.projectionDelta, _ = S.x, T = S.y;
        v.transformOrigin = "".concat(_.origin * 100, "% ").concat(T.origin * 100, "% 0"), b.animationValues ? v.opacity = b === this ? (d = (p = C.opacity) !== null && p !== void 0 ? p : this.latestValues.opacity) !== null && d !== void 0 ? d : 1 : this.preserveOpacity ? this.latestValues.opacity : C.opacityExit : v.opacity = b === this ? (h = C.opacity) !== null && h !== void 0 ? h : "" : (m = C.opacityExit) !== null && m !== void 0 ? m : 0;
        for (var P in Ou)
          if (C[P] !== void 0) {
            var R = Ou[P], N = R.correct, B = R.applyTo, L = N(C[P], b);
            if (B)
              for (var j = B.length, I = 0; I < j; I++)
                v[B[I]] = L;
            else
              v[P] = L;
          }
        return this.options.layoutId && (v.pointerEvents = b === this ? pu(s.pointerEvents) || "" : "none"), v;
      }, a.prototype.clearSnapshot = function() {
        this.resumeFrom = this.snapshot = void 0;
      }, a.prototype.resetTree = function() {
        this.root.nodes.forEach(function(s) {
          var c;
          return (c = s.currentAnimation) === null || c === void 0 ? void 0 : c.stop();
        }), this.root.nodes.forEach(Bb), this.root.sharedNodes.clear();
      }, a;
    }()
  );
}
function BL(e) {
  e.updateLayout();
}
function HL(e) {
  var t, n, r, i, o = (n = (t = e.resumeFrom) === null || t === void 0 ? void 0 : t.snapshot) !== null && n !== void 0 ? n : e.snapshot;
  if (e.isLead() && e.layout && o && e.hasListeners("didUpdate")) {
    var a = e.layout, s = a.actual, c = a.measured;
    e.options.animationType === "size" ? Zr(function(C) {
      var S = o.isShared ? o.measured[C] : o.layout[C], _ = $i(S);
      S.min = s[C].min, S.max = S.min + _;
    }) : e.options.animationType === "position" && Zr(function(C) {
      var S = o.isShared ? o.measured[C] : o.layout[C], _ = $i(s[C]);
      S.max = S.min + _;
    });
    var f = Us();
    Bs(f, s, o.layout);
    var p = Us();
    o.isShared ? Bs(p, e.applyTransform(c, !0), o.measured) : Bs(p, s, o.layout);
    var d = !jE(f), h = !1;
    if (!e.resumeFrom && (e.relativeParent = e.getClosestProjectingParent(), e.relativeParent && !e.relativeParent.resumeFrom)) {
      var m = e.relativeParent, v = m.snapshot, w = m.layout;
      if (v && w) {
        var b = vn();
        Hs(b, o.layout, v.layout);
        var E = vn();
        Hs(E, s, w.actual), qE(b, E) || (h = !0);
      }
    }
    e.notifyListeners("didUpdate", {
      layout: s,
      snapshot: o,
      delta: p,
      layoutDelta: f,
      hasLayoutChanged: d,
      hasRelativeTargetChanged: h
    });
  } else
    e.isLead() && ((i = (r = e.options).onExitComplete) === null || i === void 0 || i.call(r));
  e.options.transition = void 0;
}
function UL(e) {
  e.clearSnapshot();
}
function Bb(e) {
  e.clearMeasurements();
}
function WL(e) {
  var t = e.options.visualElement;
  t != null && t.getProps().onBeforeLayoutMeasure && t.notifyBeforeLayoutMeasure(), e.resetTransform();
}
function jL(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0;
}
function qL(e) {
  e.resolveTargetDelta();
}
function GL(e) {
  e.calcProjection();
}
function YL(e) {
  e.resetRotation();
}
function KL(e) {
  e.removeLeadSnapshot();
}
function Hb(e, t, n) {
  e.translate = Wt(t.translate, 0, n), e.scale = Wt(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function Ub(e, t, n, r) {
  e.min = Wt(t.min, n.min, r), e.max = Wt(t.max, n.max, r);
}
function XL(e, t, n, r) {
  Ub(e.x, t.x, n.x, r), Ub(e.y, t.y, n.y, r);
}
function QL(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
var ZL = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function JL(e, t) {
  for (var n = e.root, r = e.path.length - 1; r >= 0; r--)
    if (e.path[r].instance) {
      n = e.path[r];
      break;
    }
  var i = n && n !== e.root ? n.instance : document, o = i.querySelector('[data-projection-id="'.concat(t, '"]'));
  o && e.mount(o, !0);
}
function Wb(e) {
  e.min = Math.round(e.min), e.max = Math.round(e.max);
}
function jb(e) {
  Wb(e.x), Wb(e.y);
}
var eF = GE({
  attachResizeListener: function(e, t) {
    return Pf(e, "resize", t);
  },
  measureScroll: function() {
    return {
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    };
  },
  checkIsScrollRoot: function() {
    return !0;
  }
}), Zp = {
  current: void 0
}, tF = GE({
  measureScroll: function(e) {
    return {
      x: e.scrollLeft,
      y: e.scrollTop
    };
  },
  defaultParent: function() {
    if (!Zp.current) {
      var e = new eF(0, {});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), Zp.current = e;
    }
    return Zp.current;
  },
  resetTransform: function(e, t) {
    e.style.transform = t ?? "none";
  },
  checkIsScrollRoot: function(e) {
    return window.getComputedStyle(e).position === "fixed";
  }
}), nF = ve(ve(ve(ve({}, LI), nI), iL), PL), on = /* @__PURE__ */ KM(function(e, t) {
  return ND(e, t, nF, CL, tF);
});
function YE() {
  var e = he(!1);
  return $u(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), e;
}
function rF() {
  var e = YE(), t = jt(ue(0), 2), n = t[0], r = t[1], i = Me(function() {
    e.current && r(n + 1);
  }, [n]), o = Me(function() {
    return Vr.postRender(i);
  }, [i]);
  return [o, n];
}
var Jp = function(e) {
  var t = e.children, n = e.initial, r = e.isPresent, i = e.onExitComplete, o = e.custom, a = e.presenceAffectsLayout, s = Ka(iF), c = _E(), f = yn(
    function() {
      return {
        id: c,
        initial: n,
        isPresent: r,
        custom: o,
        onExitComplete: function(p) {
          var d, h;
          s.set(p, !0);
          try {
            for (var m = NO(s.values()), v = m.next(); !v.done; v = m.next()) {
              var w = v.value;
              if (!w)
                return;
            }
          } catch (b) {
            d = { error: b };
          } finally {
            try {
              v && !v.done && (h = m.return) && h.call(m);
            } finally {
              if (d)
                throw d.error;
            }
          }
          i == null || i();
        },
        register: function(p) {
          return s.set(p, !1), function() {
            return s.delete(p);
          };
        }
      };
    },
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    a ? void 0 : [r]
  );
  return yn(function() {
    s.forEach(function(p, d) {
      return s.set(d, !1);
    });
  }, [r]), D.useEffect(function() {
    !r && !s.size && (i == null || i());
  }, [r]), D.createElement(yl.Provider, { value: f }, t);
};
function iF() {
  return /* @__PURE__ */ new Map();
}
var Ea = function(e) {
  return e.key || "";
};
function oF(e, t) {
  e.forEach(function(n) {
    var r = Ea(n);
    t.set(r, n);
  });
}
function aF(e) {
  var t = [];
  return io.forEach(e, function(n) {
    La(n) && t.push(n);
  }), t;
}
var Br = function(e) {
  var t = e.children, n = e.custom, r = e.initial, i = r === void 0 ? !0 : r, o = e.onExitComplete, a = e.exitBeforeEnter, s = e.presenceAffectsLayout, c = s === void 0 ? !0 : s, f = jt(rF(), 1), p = f[0], d = Re(Kg).forceRender;
  d && (p = d);
  var h = YE(), m = aF(t), v = m, w = /* @__PURE__ */ new Set(), b = he(v), E = he(/* @__PURE__ */ new Map()).current, C = he(!0);
  if ($u(function() {
    C.current = !1, oF(m, E), b.current = v;
  }), i1(function() {
    C.current = !0, E.clear(), w.clear();
  }), C.current)
    return D.createElement(D.Fragment, null, v.map(function(N) {
      return D.createElement(Jp, { key: Ea(N), isPresent: !0, initial: i ? void 0 : !1, presenceAffectsLayout: c }, N);
    }));
  v = yr([], jt(v), !1);
  for (var S = b.current.map(Ea), _ = m.map(Ea), T = S.length, P = 0; P < T; P++) {
    var R = S[P];
    _.indexOf(R) === -1 && w.add(R);
  }
  return a && w.size && (v = []), w.forEach(function(N) {
    if (_.indexOf(N) === -1) {
      var B = E.get(N);
      if (B) {
        var L = S.indexOf(N), j = function() {
          E.delete(N), w.delete(N);
          var I = b.current.findIndex(function(z) {
            return z.key === N;
          });
          if (b.current.splice(I, 1), !w.size) {
            if (b.current = m, h.current === !1)
              return;
            p(), o && o();
          }
        };
        v.splice(L, 0, D.createElement(Jp, { key: Ea(B), isPresent: !1, onExitComplete: j, custom: n, presenceAffectsLayout: c }, B));
      }
    }
  }), v = v.map(function(N) {
    var B = N.key;
    return w.has(B) ? N : D.createElement(Jp, { key: Ea(N), isPresent: !0, presenceAffectsLayout: c }, N);
  }), Gg !== "production" && a && v.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour."), D.createElement(D.Fragment, null, w.size ? v : v.map(function(N) {
    return df(N);
  }));
}, sF = (
  /** @class */
  function() {
    function e() {
      this.componentControls = /* @__PURE__ */ new Set();
    }
    return e.prototype.subscribe = function(t) {
      var n = this;
      return this.componentControls.add(t), function() {
        return n.componentControls.delete(t);
      };
    }, e.prototype.start = function(t, n) {
      this.componentControls.forEach(function(r) {
        r.start(t.nativeEvent || t, n);
      });
    }, e;
  }()
), lF = function() {
  return new sF();
};
function cF() {
  return Ka(lF);
}
const uF = ln(null), eh = {
  didCatch: !1,
  error: null
};
class uo extends oR {
  constructor(t) {
    super(t), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = eh;
  }
  static getDerivedStateFromError(t) {
    return {
      didCatch: !0,
      error: t
    };
  }
  resetErrorBoundary() {
    const {
      error: t
    } = this.state;
    if (t !== null) {
      for (var n, r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
        o[a] = arguments[a];
      (n = (r = this.props).onReset) === null || n === void 0 || n.call(r, {
        args: o,
        reason: "imperative-api"
      }), this.setState(eh);
    }
  }
  componentDidCatch(t, n) {
    var r, i;
    (r = (i = this.props).onError) === null || r === void 0 || r.call(i, t, n);
  }
  componentDidUpdate(t, n) {
    const {
      didCatch: r
    } = this.state, {
      resetKeys: i
    } = this.props;
    if (r && n.error !== null && fF(t.resetKeys, i)) {
      var o, a;
      (o = (a = this.props).onReset) === null || o === void 0 || o.call(a, {
        next: i,
        prev: t.resetKeys,
        reason: "keys"
      }), this.setState(eh);
    }
  }
  render() {
    const {
      children: t,
      fallbackRender: n,
      FallbackComponent: r,
      fallback: i
    } = this.props, {
      didCatch: o,
      error: a
    } = this.state;
    let s = t;
    if (o) {
      const c = {
        error: a,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (La(i))
        s = i;
      else if (typeof n == "function")
        s = n(c);
      else if (r)
        s = K(r, c);
      else
        throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
    }
    return K(uF.Provider, {
      value: {
        didCatch: o,
        error: a,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, s);
  }
}
function fF() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e.length !== t.length || e.some((n, r) => !Object.is(n, t[r]));
}
function KE(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = KE(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function dF() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = KE(e)) && (r && (r += " "), r += t);
  return r;
}
const qb = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, Gb = dF, li = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null)
    return Gb(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: i, defaultVariants: o } = t, a = Object.keys(i).map((f) => {
    const p = n == null ? void 0 : n[f], d = o == null ? void 0 : o[f];
    if (p === null)
      return null;
    const h = qb(p) || qb(d);
    return i[f][h];
  }), s = n && Object.entries(n).reduce((f, p) => {
    let [d, h] = p;
    return h === void 0 || (f[d] = h), f;
  }, {}), c = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((f, p) => {
    let { class: d, className: h, ...m } = p;
    return Object.entries(m).every((v) => {
      let [w, b] = v;
      return Array.isArray(b) ? b.includes({
        ...o,
        ...s
      }[w]) : {
        ...o,
        ...s
      }[w] === b;
    }) ? [
      ...f,
      d,
      h
    ] : f;
  }, []);
  return Gb(e, a, c, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function XE(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = XE(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function rl() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = XE(e)) && (r && (r += " "), r += t);
  return r;
}
const pF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clsx: rl,
  default: rl
}, Symbol.toStringTag, { value: "Module" }));
function hF() {
  for (var e = 0, t, n, r = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = QE(t)) && (r && (r += " "), r += n);
  return r;
}
function QE(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", r = 0; r < e.length; r++)
    e[r] && (t = QE(e[r])) && (n && (n += " "), n += t);
  return n;
}
var w1 = "-";
function mF(e) {
  var t = vF(e), n = e.conflictingClassGroups, r = e.conflictingClassGroupModifiers, i = r === void 0 ? {} : r;
  function o(s) {
    var c = s.split(w1);
    return c[0] === "" && c.length !== 1 && c.shift(), ZE(c, t) || gF(s);
  }
  function a(s, c) {
    var f = n[s] || [];
    return c && i[s] ? [].concat(f, i[s]) : f;
  }
  return {
    getClassGroupId: o,
    getConflictingClassGroupIds: a
  };
}
function ZE(e, t) {
  var a;
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], r = t.nextPart.get(n), i = r ? ZE(e.slice(1), r) : void 0;
  if (i)
    return i;
  if (t.validators.length !== 0) {
    var o = e.join(w1);
    return (a = t.validators.find(function(s) {
      var c = s.validator;
      return c(o);
    })) == null ? void 0 : a.classGroupId;
  }
}
var Yb = /^\[(.+)\]$/;
function gF(e) {
  if (Yb.test(e)) {
    var t = Yb.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function vF(e) {
  var t = e.theme, n = e.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, i = yF(Object.entries(e.classGroups), n);
  return i.forEach(function(o) {
    var a = o[0], s = o[1];
    hm(s, r, a, t);
  }), r;
}
function hm(e, t, n, r) {
  e.forEach(function(i) {
    if (typeof i == "string") {
      var o = i === "" ? t : Kb(t, i);
      o.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (wF(i)) {
        hm(i(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(function(a) {
      var s = a[0], c = a[1];
      hm(c, Kb(t, s), n, r);
    });
  });
}
function Kb(e, t) {
  var n = e;
  return t.split(w1).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function wF(e) {
  return e.isThemeGetter;
}
function yF(e, t) {
  return t ? e.map(function(n) {
    var r = n[0], i = n[1], o = i.map(function(a) {
      return typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(function(s) {
        var c = s[0], f = s[1];
        return [t + c, f];
      })) : a;
    });
    return [r, o];
  }) : e;
}
function bF(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function i(o, a) {
    n.set(o, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(a) {
      var s = n.get(a);
      if (s !== void 0)
        return s;
      if ((s = r.get(a)) !== void 0)
        return i(a, s), s;
    },
    set: function(a, s) {
      n.has(a) ? n.set(a, s) : i(a, s);
    }
  };
}
var JE = "!";
function xF(e) {
  var t = e.separator || ":", n = t.length === 1, r = t[0], i = t.length;
  return function(a) {
    for (var s = [], c = 0, f = 0, p, d = 0; d < a.length; d++) {
      var h = a[d];
      if (c === 0) {
        if (h === r && (n || a.slice(d, d + i) === t)) {
          s.push(a.slice(f, d)), f = d + i;
          continue;
        }
        if (h === "/") {
          p = d;
          continue;
        }
      }
      h === "[" ? c++ : h === "]" && c--;
    }
    var m = s.length === 0 ? a : a.substring(f), v = m.startsWith(JE), w = v ? m.substring(1) : m, b = p && p > f ? p - f : void 0;
    return {
      modifiers: s,
      hasImportantModifier: v,
      baseClassName: w,
      maybePostfixModifierPosition: b
    };
  };
}
function EF(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(r) {
    var i = r[0] === "[";
    i ? (t.push.apply(t, n.sort().concat([r])), n = []) : n.push(r);
  }), t.push.apply(t, n.sort()), t;
}
function CF(e) {
  return {
    cache: bF(e.cacheSize),
    splitModifiers: xF(e),
    ...mF(e)
  };
}
var SF = /\s+/;
function _F(e, t) {
  var n = t.splitModifiers, r = t.getClassGroupId, i = t.getConflictingClassGroupIds, o = /* @__PURE__ */ new Set();
  return e.trim().split(SF).map(function(a) {
    var s = n(a), c = s.modifiers, f = s.hasImportantModifier, p = s.baseClassName, d = s.maybePostfixModifierPosition, h = r(d ? p.substring(0, d) : p), m = !!d;
    if (!h) {
      if (!d)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      if (h = r(p), !h)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      m = !1;
    }
    var v = EF(c).join(":"), w = f ? v + JE : v;
    return {
      isTailwindClass: !0,
      modifierId: w,
      classGroupId: h,
      originalClassName: a,
      hasPostfixModifier: m
    };
  }).reverse().filter(function(a) {
    if (!a.isTailwindClass)
      return !0;
    var s = a.modifierId, c = a.classGroupId, f = a.hasPostfixModifier, p = s + c;
    return o.has(p) ? !1 : (o.add(p), i(c, f).forEach(function(d) {
      return o.add(s + d);
    }), !0);
  }).reverse().map(function(a) {
    return a.originalClassName;
  }).join(" ");
}
function TF() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r, i, o, a = s;
  function s(f) {
    var p = t[0], d = t.slice(1), h = d.reduce(function(m, v) {
      return v(m);
    }, p());
    return r = CF(h), i = r.cache.get, o = r.cache.set, a = c, c(f);
  }
  function c(f) {
    var p = i(f);
    if (p)
      return p;
    var d = _F(f, r);
    return o(f, d), d;
  }
  return function() {
    return a(hF.apply(null, arguments));
  };
}
function Mt(e) {
  var t = function(r) {
    return r[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var e5 = /^\[(?:([a-z-]+):)?(.+)\]$/i, kF = /^\d+\/\d+$/, PF = /* @__PURE__ */ new Set(["px", "full", "screen"]), AF = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, RF = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, $F = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function Dr(e) {
  return Lo(e) || PF.has(e) || kF.test(e) || mm(e);
}
function mm(e) {
  return Ko(e, "length", LF);
}
function OF(e) {
  return Ko(e, "size", t5);
}
function MF(e) {
  return Ko(e, "position", t5);
}
function DF(e) {
  return Ko(e, "url", FF);
}
function Hc(e) {
  return Ko(e, "number", Lo);
}
function Lo(e) {
  return !Number.isNaN(Number(e));
}
function NF(e) {
  return e.endsWith("%") && Lo(e.slice(0, -1));
}
function Cs(e) {
  return Xb(e) || Ko(e, "number", Xb);
}
function nt(e) {
  return e5.test(e);
}
function Ss() {
  return !0;
}
function Wi(e) {
  return AF.test(e);
}
function IF(e) {
  return Ko(e, "", zF);
}
function Ko(e, t, n) {
  var r = e5.exec(e);
  return r ? r[1] ? r[1] === t : n(r[2]) : !1;
}
function LF(e) {
  return RF.test(e);
}
function t5() {
  return !1;
}
function FF(e) {
  return e.startsWith("url(");
}
function Xb(e) {
  return Number.isInteger(Number(e));
}
function zF(e) {
  return $F.test(e);
}
function VF() {
  var e = Mt("colors"), t = Mt("spacing"), n = Mt("blur"), r = Mt("brightness"), i = Mt("borderColor"), o = Mt("borderRadius"), a = Mt("borderSpacing"), s = Mt("borderWidth"), c = Mt("contrast"), f = Mt("grayscale"), p = Mt("hueRotate"), d = Mt("invert"), h = Mt("gap"), m = Mt("gradientColorStops"), v = Mt("gradientColorStopPositions"), w = Mt("inset"), b = Mt("margin"), E = Mt("opacity"), C = Mt("padding"), S = Mt("saturate"), _ = Mt("scale"), T = Mt("sepia"), P = Mt("skew"), R = Mt("space"), N = Mt("translate"), B = function() {
    return ["auto", "contain", "none"];
  }, L = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, j = function() {
    return ["auto", nt, t];
  }, I = function() {
    return [nt, t];
  }, z = function() {
    return ["", Dr];
  }, H = function() {
    return ["auto", Lo, nt];
  }, G = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, Y = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, ne = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, J = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, ee = function() {
    return ["", "0", nt];
  }, A = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, X = function() {
    return [Lo, Hc];
  }, fe = function() {
    return [Lo, nt];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [Ss],
      spacing: [Dr],
      blur: ["none", "", Wi, nt],
      brightness: X(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Wi, nt],
      borderSpacing: I(),
      borderWidth: z(),
      contrast: X(),
      grayscale: ee(),
      hueRotate: fe(),
      invert: ee(),
      gap: I(),
      gradientColorStops: [e],
      gradientColorStopPositions: [NF, mm],
      inset: j(),
      margin: j(),
      opacity: X(),
      padding: I(),
      saturate: X(),
      scale: X(),
      sepia: ee(),
      skew: fe(),
      space: I(),
      translate: I()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", nt]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Wi]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": A()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": A()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(G(), [nt])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: L()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": L()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": L()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: B()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": B()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": B()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [w]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [w]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [w]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [w]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [w]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [w]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [w]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [w]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [w]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Cs]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: j()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", nt]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ee()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ee()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Cs]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Ss]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Cs]
        }, nt]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": H()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": H()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Ss]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Cs]
        }, nt]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": H()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": H()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", nt]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", nt]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [h]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [h]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [h]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(J())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(J(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(J(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [C]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [C]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [C]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [C]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [C]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [C]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [C]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [C]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [C]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [b]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [b]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [b]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [b]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [b]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [b]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [b]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [b]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [b]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [R]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [R]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", nt, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", nt, Dr]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [Wi]
        }, Wi, nt]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [nt, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", nt, Dr]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [nt, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Wi, mm]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Hc]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Ss]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", nt]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Lo, Hc]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", nt, Dr]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", nt]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", nt]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [E]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [E]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(Y(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Dr]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", nt, Dr]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: I()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", nt]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", nt]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [E]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(G(), [MF])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", OF]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, DF]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [v]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [m]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [E]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(Y(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [E]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: Y()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(Y())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [nt, Dr]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Dr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: z()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [E]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Dr]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Wi, IF]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Ss]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [E]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": ne()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": ne()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Wi, nt]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [f]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [p]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [S]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [T]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [f]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [p]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [E]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [S]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [T]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", nt]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: fe()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", nt]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: fe()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", nt]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [_]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [_]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [_]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Cs, nt]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [N]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [N]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [P]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [P]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", nt]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", nt]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": I()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": I()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": I()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": I()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": I()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": I()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": I()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": I()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": I()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": I()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": I()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": I()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": I()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": I()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": I()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": I()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": I()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": I()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", nt]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Dr, Hc]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
const BF = TF(() => ({
  ...VF(),
  prefix: "ai-tw-"
}));
function le(...e) {
  return BF(rl(e));
}
function HF(e) {
  return e.endsWith("/") ? e.slice(0, -1) : e;
}
const UF = li(
  le(
    "ai-tw-inline-flex ai-tw-items-center ai-tw-justify-center ai-tw-rounded-full ai-tw-border-none ai-tw-bg-transparent ai-tw-bg-none ai-tw-transition-colors",
    "focus-visible:ai-tw-outline-none focus-visible:ai-tw-ring-2 focus-visible:ai-tw-ring-ring focus-visible:ai-tw-ring-offset-2",
    "ai-tw-cursor-pointer disabled:ai-tw-pointer-events-none"
  ),
  {
    variants: {
      background: {
        light: le(
          "ai-tw-text-foreground hover:ai-tw-bg-black/5 active:ai-tw-bg-black/30",
          "disabled:ai-tw-text-black/25"
        ),
        dark: le(
          "ai-tw-text-white hover:ai-tw-bg-white/10 active:ai-tw-bg-white/25",
          "disabled:ai-tw-text-white/25"
        )
      },
      size: {
        md: le("ai-tw-h-6 ai-tw-w-6 ai-tw-text-sm"),
        lg: le("ai-tw-h-8 ai-tw-w-8 ai-tw-text-base")
      }
    },
    defaultVariants: {
      background: "light",
      size: "md"
    }
  }
), y1 = D.forwardRef(
  ({ className: e, background: t, size: n, asChild: r = !1, ...i }, o) => {
    const a = r ? Ti : "button";
    return /* @__PURE__ */ D.createElement(
      a,
      {
        className: le(UF({ background: t, size: n, className: e })),
        ref: o,
        ...i
      }
    );
  }
);
y1.displayName = "Button";
var Ci = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function fo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function WF(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      if (this instanceof r) {
        var i = [null];
        i.push.apply(i, arguments);
        var o = Function.bind.apply(t, i);
        return new o();
      }
      return t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var gm = { exports: {} }, th = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qb;
function jF() {
  if (Qb)
    return th;
  Qb = 1;
  var e = y;
  function t(d, h) {
    return d === h && (d !== 0 || 1 / d === 1 / h) || d !== d && h !== h;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, i = e.useEffect, o = e.useLayoutEffect, a = e.useDebugValue;
  function s(d, h) {
    var m = h(), v = r({ inst: { value: m, getSnapshot: h } }), w = v[0].inst, b = v[1];
    return o(
      function() {
        w.value = m, w.getSnapshot = h, c(w) && b({ inst: w });
      },
      [d, m, h]
    ), i(
      function() {
        return c(w) && b({ inst: w }), d(function() {
          c(w) && b({ inst: w });
        });
      },
      [d]
    ), a(m), m;
  }
  function c(d) {
    var h = d.getSnapshot;
    d = d.value;
    try {
      var m = h();
      return !n(d, m);
    } catch {
      return !0;
    }
  }
  function f(d, h) {
    return h();
  }
  var p = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? f : s;
  return th.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : p, th;
}
var nh = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zb;
function qF() {
  return Zb || (Zb = 1, process.env.NODE_ENV !== "production" && function() {
    function e(m, v) {
      return m === v && (m !== 0 || 1 / m === 1 / v) || m !== m && v !== v;
    }
    function t(m, v) {
      p || i.startTransition === void 0 || (p = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var w = v();
      if (!d) {
        var b = v();
        o(w, b) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), d = !0);
      }
      b = a({
        inst: { value: w, getSnapshot: v }
      });
      var E = b[0].inst, C = b[1];
      return c(
        function() {
          E.value = w, E.getSnapshot = v, n(E) && C({ inst: E });
        },
        [m, w, v]
      ), s(
        function() {
          return n(E) && C({ inst: E }), m(function() {
            n(E) && C({ inst: E });
          });
        },
        [m]
      ), f(w), w;
    }
    function n(m) {
      var v = m.getSnapshot;
      m = m.value;
      try {
        var w = v();
        return !o(m, w);
      } catch {
        return !0;
      }
    }
    function r(m, v) {
      return v();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = y, o = typeof Object.is == "function" ? Object.is : e, a = i.useState, s = i.useEffect, c = i.useLayoutEffect, f = i.useDebugValue, p = !1, d = !1, h = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    nh.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : h, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), nh;
}
process.env.NODE_ENV === "production" ? gm.exports = jF() : gm.exports = qF();
var n5 = gm.exports;
const ro = () => {
}, rn = (
  /*#__NOINLINE__*/
  ro()
), gu = Object, Xe = (e) => e === rn, Fr = (e) => typeof e == "function", br = (e, t) => ({
  ...e,
  ...t
}), GF = (e) => Fr(e.then), Uc = /* @__PURE__ */ new WeakMap();
let YF = 0;
const il = (e) => {
  const t = typeof e, n = e && e.constructor, r = n == Date;
  let i, o;
  if (gu(e) === e && !r && n != RegExp) {
    if (i = Uc.get(e), i)
      return i;
    if (i = ++YF + "~", Uc.set(e, i), n == Array) {
      for (i = "@", o = 0; o < e.length; o++)
        i += il(e[o]) + ",";
      Uc.set(e, i);
    }
    if (n == gu) {
      i = "#";
      const a = gu.keys(e).sort();
      for (; !Xe(o = a.pop()); )
        Xe(e[o]) || (i += o + ":" + il(e[o]) + ",");
      Uc.set(e, i);
    }
  } else
    i = r ? e.toJSON() : t == "symbol" ? e.toString() : t == "string" ? JSON.stringify(e) : "" + e;
  return i;
}, Si = /* @__PURE__ */ new WeakMap(), rh = {}, Wc = {}, b1 = "undefined", Of = typeof window != b1, vm = typeof document != b1, KF = () => Of && typeof window.requestAnimationFrame != b1, Ji = (e, t) => {
  const n = Si.get(e);
  return [
    // Getter
    () => !Xe(t) && e.get(t) || rh,
    // Setter
    (r) => {
      if (!Xe(t)) {
        const i = e.get(t);
        t in Wc || (Wc[t] = i), n[5](t, br(i, r), i || rh);
      }
    },
    // Subscriber
    n[6],
    // Get server cache snapshot
    () => !Xe(t) && t in Wc ? Wc[t] : !Xe(t) && e.get(t) || rh
  ];
};
let wm = !0;
const XF = () => wm, [ym, bm] = Of && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  ro,
  ro
], QF = () => {
  const e = vm && document.visibilityState;
  return Xe(e) || e !== "hidden";
}, ZF = (e) => (vm && document.addEventListener("visibilitychange", e), ym("focus", e), () => {
  vm && document.removeEventListener("visibilitychange", e), bm("focus", e);
}), JF = (e) => {
  const t = () => {
    wm = !0, e();
  }, n = () => {
    wm = !1;
  };
  return ym("online", t), ym("offline", n), () => {
    bm("online", t), bm("offline", n);
  };
}, ez = {
  isOnline: XF,
  isVisible: QF
}, tz = {
  initFocus: ZF,
  initReconnect: JF
}, xm = !y.useId, ol = !Of || "Deno" in window, nz = (e) => KF() ? window.requestAnimationFrame(e) : setTimeout(e, 1), Fo = ol ? _e : gl, ih = typeof navigator < "u" && navigator.connection, Jb = !ol && ih && ([
  "slow-2g",
  "2g"
].includes(ih.effectiveType) || ih.saveData), Ho = (e) => {
  if (Fr(e))
    try {
      e = e();
    } catch {
      e = "";
    }
  const t = e;
  return e = typeof e == "string" ? e : (Array.isArray(e) ? e.length : e) ? il(e) : "", [
    e,
    t
  ];
};
let rz = 0;
const al = () => ++rz, r5 = 0, i5 = 1, o5 = 2, iz = 3;
var _s = {
  __proto__: null,
  ERROR_REVALIDATE_EVENT: iz,
  FOCUS_EVENT: r5,
  MUTATE_EVENT: o5,
  RECONNECT_EVENT: i5
};
async function a5(...e) {
  const [t, n, r, i] = e, o = br({
    populateCache: !0,
    throwOnError: !0
  }, typeof i == "boolean" ? {
    revalidate: i
  } : i || {});
  let a = o.populateCache;
  const s = o.rollbackOnError;
  let c = o.optimisticData;
  const f = o.revalidate !== !1, p = (m) => typeof s == "function" ? s(m) : s !== !1, d = o.throwOnError;
  if (Fr(n)) {
    const m = n, v = [], w = t.keys();
    for (const b of w)
      // Skip the special useSWRInfinite and useSWRSubscription keys.
      !/^\$(inf|sub)\$/.test(b) && m(t.get(b)._k) && v.push(b);
    return Promise.all(v.map(h));
  }
  return h(n);
  async function h(m) {
    const [v] = Ho(m);
    if (!v)
      return;
    const [w, b] = Ji(t, v), [E, C, S, _] = Si.get(t), T = E[v], P = () => f && (delete S[v], delete _[v], T && T[0]) ? T[0](o5).then(() => w().data) : w().data;
    if (e.length < 3)
      return P();
    let R = r, N;
    const B = al();
    C[v] = [
      B,
      0
    ];
    const L = !Xe(c), j = w(), I = j.data, z = j._c, H = Xe(z) ? I : z;
    if (L && (c = Fr(c) ? c(H, I) : c, b({
      data: c,
      _c: H
    })), Fr(R))
      try {
        R = R(H);
      } catch (Y) {
        N = Y;
      }
    if (R && GF(R))
      if (R = await R.catch((Y) => {
        N = Y;
      }), B !== C[v][0]) {
        if (N)
          throw N;
        return R;
      } else
        N && L && p(N) && (a = !0, R = H, b({
          data: R,
          _c: rn
        }));
    a && (N || (Fr(a) && (R = a(R, H)), b({
      data: R,
      error: rn,
      _c: rn
    }))), C[v][1] = al();
    const G = await P();
    if (b({
      _c: rn
    }), N) {
      if (d)
        throw N;
      return;
    }
    return a ? G : R;
  }
}
const e2 = (e, t) => {
  for (const n in e)
    e[n][0] && e[n][0](t);
}, s5 = (e, t) => {
  if (!Si.has(e)) {
    const n = br(tz, t), r = {}, i = a5.bind(rn, e);
    let o = ro;
    const a = {}, s = (p, d) => {
      const h = a[p] || [];
      return a[p] = h, h.push(d), () => h.splice(h.indexOf(d), 1);
    }, c = (p, d, h) => {
      e.set(p, d);
      const m = a[p];
      if (m)
        for (const v of m)
          v(d, h);
    }, f = () => {
      if (!Si.has(e) && (Si.set(e, [
        r,
        {},
        {},
        {},
        i,
        c,
        s
      ]), !ol)) {
        const p = n.initFocus(setTimeout.bind(rn, e2.bind(rn, r, r5))), d = n.initReconnect(setTimeout.bind(rn, e2.bind(rn, r, i5)));
        o = () => {
          p && p(), d && d(), Si.delete(e);
        };
      }
    };
    return f(), [
      e,
      i,
      f,
      o
    ];
  }
  return [
    e,
    Si.get(e)[4]
  ];
}, oz = (e, t, n, r, i) => {
  const o = n.errorRetryCount, a = i.retryCount, s = ~~((Math.random() + 0.5) * (1 << (a < 8 ? a : 8))) * n.errorRetryInterval;
  !Xe(o) && a > o || setTimeout(r, s, i);
}, az = (e, t) => il(e) == il(t), [x1, Em] = s5(/* @__PURE__ */ new Map()), l5 = br(
  {
    // events
    onLoadingSlow: ro,
    onSuccess: ro,
    onError: ro,
    onErrorRetry: oz,
    onDiscarded: ro,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: Jb ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: Jb ? 5e3 : 3e3,
    // providers
    compare: az,
    isPaused: () => !1,
    cache: x1,
    mutate: Em,
    fallback: {}
  },
  // use web preset by default
  ez
), c5 = (e, t) => {
  const n = br(e, t);
  if (t) {
    const { use: r, fallback: i } = e, { use: o, fallback: a } = t;
    r && o && (n.use = r.concat(o)), i && a && (n.fallback = br(i, a));
  }
  return n;
}, Cm = ln({}), sz = (e) => {
  const { value: t } = e, n = Re(Cm), r = Fr(t), i = yn(() => r ? t(n) : t, [
    r,
    n,
    t
  ]), o = yn(() => r ? i : c5(n, i), [
    r,
    n,
    i
  ]), a = i && i.provider, s = he(rn);
  a && !s.current && (s.current = s5(a(o.cache || x1), i));
  const c = s.current;
  return c && (o.cache = c[0], o.mutate = c[1]), Fo(() => {
    if (c)
      return c[2] && c[2](), c[3];
  }, []), K(Cm.Provider, br(e, {
    value: o
  }));
}, u5 = Of && window.__SWR_DEVTOOLS_USE__, lz = u5 ? window.__SWR_DEVTOOLS_USE__ : [], cz = () => {
  u5 && (window.__SWR_DEVTOOLS_REACT__ = y);
}, f5 = (e) => Fr(e[1]) ? [
  e[0],
  e[1],
  e[2] || {}
] : [
  e[0],
  null,
  (e[1] === null ? e[2] : e[1]) || {}
], E1 = () => br(l5, Re(Cm)), uz = (e) => (t, n, r) => e(t, n && ((...o) => {
  const [a] = Ho(t), [, , , s] = Si.get(x1), c = s[a];
  return Xe(c) ? n(...o) : (delete s[a], c);
}), r), fz = lz.concat(uz), dz = (e) => function(...n) {
  const r = E1(), [i, o, a] = f5(n), s = c5(r, a);
  let c = e;
  const { use: f } = s, p = (f || []).concat(fz);
  for (let d = p.length; d--; )
    c = p[d](c);
  return c(i, o || s.fetcher || null, s);
}, pz = (e) => {
  const t = ue({})[1], n = he(!1), r = he(e), i = he({
    data: !1,
    error: !1,
    isValidating: !1
  }), o = Me((a) => {
    let s = !1;
    const c = r.current;
    for (const f in a) {
      const p = f;
      c[p] !== a[p] && (c[p] = a[p], i.current[p] && (s = !0));
    }
    s && !n.current && (xm ? t({}) : y.startTransition(() => t({})));
  }, [
    t
  ]);
  return Fo(() => (n.current = !1, () => {
    n.current = !0;
  })), [
    r,
    i.current,
    o
  ];
}, hz = (e, t, n) => {
  const r = t[e] || (t[e] = []);
  return r.push(n), () => {
    const i = r.indexOf(n);
    i >= 0 && (r[i] = r[r.length - 1], r.pop());
  };
}, C1 = (e, t) => (...n) => {
  const [r, i, o] = f5(n), a = (o.use || []).concat(t);
  return e(r, i, {
    ...o,
    use: a
  });
};
cz();
const t2 = y.use || ((e) => {
  if (e.status === "pending")
    throw e;
  if (e.status === "fulfilled")
    return e.value;
  throw e.status === "rejected" ? e.reason : (e.status = "pending", e.then((t) => {
    e.status = "fulfilled", e.value = t;
  }, (t) => {
    e.status = "rejected", e.reason = t;
  }), e);
}), oh = {
  dedupe: !0
}, mz = (e, t, n) => {
  const { cache: r, compare: i, suspense: o, fallbackData: a, revalidateOnMount: s, revalidateIfStale: c, refreshInterval: f, refreshWhenHidden: p, refreshWhenOffline: d, keepPreviousData: h } = n, [m, v, w, b] = Si.get(r), [E, C] = Ho(e), S = he(!1), _ = he(!1), T = he(E), P = he(t), R = he(n), N = () => R.current, B = () => N().isVisible() && N().isOnline(), [L, j, I, z] = Ji(r, E), H = he({}).current, G = Xe(a) ? n.fallback[E] : a, Y = (se, Le) => {
    for (const xe in H) {
      const Ue = xe;
      if (Ue === "data") {
        if (!i(se[Ue], Le[Ue]) && (!Xe(se[Ue]) || !i(ie, Le[Ue])))
          return !1;
      } else if (Le[Ue] !== se[Ue])
        return !1;
    }
    return !0;
  }, ne = yn(() => {
    const se = (() => !E || !t ? !1 : Xe(s) ? N().isPaused() || o ? !1 : Xe(c) ? !0 : c : s)(), Le = (Pt) => {
      const Bt = br(Pt);
      return delete Bt._k, se ? {
        isValidating: !0,
        isLoading: !0,
        ...Bt
      } : Bt;
    }, xe = L(), Ue = z(), bt = Le(xe), Et = xe === Ue ? bt : Le(Ue);
    let xt = bt;
    return [
      () => {
        const Pt = Le(L());
        return Y(Pt, xt) ? (xt.data = Pt.data, xt.isLoading = Pt.isLoading, xt.isValidating = Pt.isValidating, xt.error = Pt.error, xt) : (xt = Pt, Pt);
      },
      () => Et
    ];
  }, [
    r,
    E
  ]), J = n5.useSyncExternalStore(Me(
    (se) => I(E, (Le, xe) => {
      Y(xe, Le) || se();
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      r,
      E
    ]
  ), ne[0], ne[1]), ee = !S.current, A = m[E] && m[E].length > 0, X = J.data, fe = Xe(X) ? G : X, M = J.error, Z = he(fe), ie = h ? Xe(X) ? Z.current : X : fe, pe = (() => A && !Xe(M) ? !1 : ee && !Xe(s) ? s : N().isPaused() ? !1 : o ? Xe(fe) ? !1 : c : Xe(fe) || c)(), Te = !!(E && t && ee && pe), ke = Xe(J.isValidating) ? Te : J.isValidating, me = Xe(J.isLoading) ? Te : J.isLoading, Pe = Me(
    async (se) => {
      const Le = P.current;
      if (!E || !Le || _.current || N().isPaused())
        return !1;
      let xe, Ue, bt = !0;
      const Et = se || {}, xt = !w[E] || !Et.dedupe, Pt = () => xm ? !_.current && E === T.current && S.current : E === T.current, Bt = {
        isValidating: !1,
        isLoading: !1
      }, Nt = () => {
        j(Bt);
      }, On = () => {
        const an = w[E];
        an && an[1] === Ue && delete w[E];
      }, _r = {
        isValidating: !0
      };
      Xe(L().data) && (_r.isLoading = !0);
      try {
        if (xt && (j(_r), n.loadingTimeout && Xe(L().data) && setTimeout(() => {
          bt && Pt() && N().onLoadingSlow(E, n);
        }, n.loadingTimeout), w[E] = [
          Le(C),
          al()
        ]), [xe, Ue] = w[E], xe = await xe, xt && setTimeout(On, n.dedupingInterval), !w[E] || w[E][1] !== Ue)
          return xt && Pt() && N().onDiscarded(E), !1;
        Bt.error = rn;
        const an = v[E];
        if (!Xe(an) && // case 1
        (Ue <= an[0] || // case 2
        Ue <= an[1] || // case 3
        an[1] === 0))
          return Nt(), xt && Pt() && N().onDiscarded(E), !1;
        const Kt = L().data;
        Bt.data = i(Kt, xe) ? Kt : xe, xt && Pt() && N().onSuccess(xe, E, n);
      } catch (an) {
        On();
        const Kt = N(), { shouldRetryOnError: Yr } = Kt;
        Kt.isPaused() || (Bt.error = an, xt && Pt() && (Kt.onError(an, E, Kt), (Yr === !0 || Fr(Yr) && Yr(an)) && B() && Kt.onErrorRetry(an, E, Kt, (te) => {
          const we = m[E];
          we && we[0] && we[0](_s.ERROR_REVALIDATE_EVENT, te);
        }, {
          retryCount: (Et.retryCount || 0) + 1,
          dedupe: !0
        })));
      }
      return bt = !1, Nt(), !0;
    },
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      E,
      r
    ]
  ), ct = Me(
    // Use callback to make sure `keyRef.current` returns latest result every time
    (...se) => a5(r, T.current, ...se),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (Fo(() => {
    P.current = t, R.current = n, Xe(X) || (Z.current = X);
  }), Fo(() => {
    if (!E)
      return;
    const se = Pe.bind(rn, oh);
    let Le = 0;
    const Ue = hz(E, m, (bt, Et = {}) => {
      if (bt == _s.FOCUS_EVENT) {
        const xt = Date.now();
        N().revalidateOnFocus && xt > Le && B() && (Le = xt + N().focusThrottleInterval, se());
      } else if (bt == _s.RECONNECT_EVENT)
        N().revalidateOnReconnect && B() && se();
      else {
        if (bt == _s.MUTATE_EVENT)
          return Pe();
        if (bt == _s.ERROR_REVALIDATE_EVENT)
          return Pe(Et);
      }
    });
    return _.current = !1, T.current = E, S.current = !0, j({
      _k: C
    }), pe && (Xe(fe) || ol ? se() : nz(se)), () => {
      _.current = !0, Ue();
    };
  }, [
    E
  ]), Fo(() => {
    let se;
    function Le() {
      const Ue = Fr(f) ? f(L().data) : f;
      Ue && se !== -1 && (se = setTimeout(xe, Ue));
    }
    function xe() {
      !L().error && (p || N().isVisible()) && (d || N().isOnline()) ? Pe(oh).then(Le) : Le();
    }
    return Le(), () => {
      se && (clearTimeout(se), se = -1);
    };
  }, [
    f,
    p,
    d,
    E
  ]), aR(ie), o && Xe(fe) && E) {
    if (!xm && ol)
      throw new Error("Fallback data is required when using suspense in SSR.");
    P.current = t, R.current = n, _.current = !1;
    const se = b[E];
    if (!Xe(se)) {
      const Le = ct(se);
      t2(Le);
    }
    if (Xe(M)) {
      const Le = Pe(oh);
      Xe(ie) || (Le.status = "fulfilled", Le.value = !0), t2(Le);
    } else
      throw M;
  }
  return {
    mutate: ct,
    get data() {
      return H.data = !0, ie;
    },
    get error() {
      return H.error = !0, M;
    },
    get isValidating() {
      return H.isValidating = !0, ke;
    },
    get isLoading() {
      return H.isLoading = !0, me;
    }
  };
}, S1 = gu.defineProperty(sz, "defaultValue", {
  value: l5
}), qr = dz(mz), gz = (e) => (t, n, r) => (r.revalidateOnFocus = !1, r.revalidateIfStale = !1, r.revalidateOnReconnect = !1, e(t, n, r)), Mf = C1(qr, gz);
class n2 extends Error {
  constructor(t, n, r) {
    const i = t.status || t.status === 0 ? t.status : "", o = t.statusText || "", a = `${i} ${o}`.trim(), s = a ? `status code ${a}` : "an unknown error";
    super(`Request failed with ${s}`), Object.defineProperty(this, "response", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "options", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = "HTTPError", this.response = t, this.request = n, this.options = r;
  }
}
class d5 extends Error {
  constructor(t) {
    super("Request timed out"), Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = "TimeoutError", this.request = t;
  }
}
const vu = (e) => e !== null && typeof e == "object", jc = (...e) => {
  for (const t of e)
    if ((!vu(t) || Array.isArray(t)) && typeof t < "u")
      throw new TypeError("The `options` argument must be an object");
  return _1({}, ...e);
}, p5 = (e = {}, t = {}) => {
  const n = new globalThis.Headers(e), r = t instanceof globalThis.Headers, i = new globalThis.Headers(t);
  for (const [o, a] of i.entries())
    r && a === "undefined" || a === void 0 ? n.delete(o) : n.set(o, a);
  return n;
}, _1 = (...e) => {
  let t = {}, n = {};
  for (const r of e)
    if (Array.isArray(r))
      Array.isArray(t) || (t = []), t = [...t, ...r];
    else if (vu(r)) {
      for (let [i, o] of Object.entries(r))
        vu(o) && i in t && (o = _1(t[i], o)), t = { ...t, [i]: o };
      vu(r.headers) && (n = p5(n, r.headers), t.headers = n);
    }
  return t;
}, vz = (() => {
  let e = !1, t = !1;
  const n = typeof globalThis.ReadableStream == "function", r = typeof globalThis.Request == "function";
  return n && r && (t = new globalThis.Request("https://a.com", {
    body: new globalThis.ReadableStream(),
    method: "POST",
    // @ts-expect-error - Types are outdated.
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type")), e && !t;
})(), wz = typeof globalThis.AbortController == "function", yz = typeof globalThis.ReadableStream == "function", bz = typeof globalThis.FormData == "function", h5 = ["get", "post", "put", "patch", "head", "delete"], xz = {
  json: "application/json",
  text: "text/*",
  formData: "multipart/form-data",
  arrayBuffer: "*/*",
  blob: "*/*"
}, ah = 2147483647, m5 = Symbol("stop"), Ez = (e) => h5.includes(e) ? e.toUpperCase() : e, Cz = ["get", "put", "head", "delete", "options", "trace"], Sz = [408, 413, 429, 500, 502, 503, 504], g5 = [413, 429, 503], r2 = {
  limit: 2,
  methods: Cz,
  statusCodes: Sz,
  afterStatusCodes: g5,
  maxRetryAfter: Number.POSITIVE_INFINITY,
  backoffLimit: Number.POSITIVE_INFINITY
}, _z = (e = {}) => {
  if (typeof e == "number")
    return {
      ...r2,
      limit: e
    };
  if (e.methods && !Array.isArray(e.methods))
    throw new Error("retry.methods must be an array");
  if (e.statusCodes && !Array.isArray(e.statusCodes))
    throw new Error("retry.statusCodes must be an array");
  return {
    ...r2,
    ...e,
    afterStatusCodes: g5
  };
};
async function Tz(e, t, n) {
  return new Promise((r, i) => {
    const o = setTimeout(() => {
      t && t.abort(), i(new d5(e));
    }, n.timeout);
    n.fetch(e).then(r).catch(i).then(() => {
      clearTimeout(o);
    });
  });
}
const kz = !!globalThis.DOMException;
function i2(e) {
  if (kz)
    return new DOMException((e == null ? void 0 : e.reason) ?? "The operation was aborted.", "AbortError");
  const t = new Error((e == null ? void 0 : e.reason) ?? "The operation was aborted.");
  return t.name = "AbortError", t;
}
async function Pz(e, { signal: t }) {
  return new Promise((n, r) => {
    if (t) {
      if (t.aborted) {
        r(i2(t));
        return;
      }
      t.addEventListener("abort", i, { once: !0 });
    }
    function i() {
      r(i2(t)), clearTimeout(o);
    }
    const o = setTimeout(() => {
      t == null || t.removeEventListener("abort", i), n();
    }, e);
  });
}
class Bu {
  // eslint-disable-next-line @typescript-eslint/promise-function-async
  static create(t, n) {
    const r = new Bu(t, n), i = async () => {
      if (r._options.timeout > ah)
        throw new RangeError(`The \`timeout\` option cannot be greater than ${ah}`);
      await Promise.resolve();
      let s = await r._fetch();
      for (const c of r._options.hooks.afterResponse) {
        const f = await c(r.request, r._options, r._decorateResponse(s.clone()));
        f instanceof globalThis.Response && (s = f);
      }
      if (r._decorateResponse(s), !s.ok && r._options.throwHttpErrors) {
        let c = new n2(s, r.request, r._options);
        for (const f of r._options.hooks.beforeError)
          c = await f(c);
        throw c;
      }
      if (r._options.onDownloadProgress) {
        if (typeof r._options.onDownloadProgress != "function")
          throw new TypeError("The `onDownloadProgress` option must be a function");
        if (!yz)
          throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
        return r._stream(s.clone(), r._options.onDownloadProgress);
      }
      return s;
    }, a = r._options.retry.methods.includes(r.request.method.toLowerCase()) ? r._retry(i) : i();
    for (const [s, c] of Object.entries(xz))
      a[s] = async () => {
        r.request.headers.set("accept", r.request.headers.get("accept") || c);
        const p = (await a).clone();
        if (s === "json") {
          if (p.status === 204 || (await p.clone().arrayBuffer()).byteLength === 0)
            return "";
          if (n.parseJson)
            return n.parseJson(await p.text());
        }
        return p[s]();
      };
    return a;
  }
  // eslint-disable-next-line complexity
  constructor(t, n = {}) {
    if (Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "abortController", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_retryCount", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "_input", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_options", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this._input = t, this._options = {
      // TODO: credentials can be removed when the spec change is implemented in all browsers. Context: https://www.chromestatus.com/feature/4539473312350208
      credentials: this._input.credentials || "same-origin",
      ...n,
      headers: p5(this._input.headers, n.headers),
      hooks: _1({
        beforeRequest: [],
        beforeRetry: [],
        beforeError: [],
        afterResponse: []
      }, n.hooks),
      method: Ez(n.method ?? this._input.method),
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      prefixUrl: String(n.prefixUrl || ""),
      retry: _z(n.retry),
      throwHttpErrors: n.throwHttpErrors !== !1,
      timeout: typeof n.timeout > "u" ? 1e4 : n.timeout,
      fetch: n.fetch ?? globalThis.fetch.bind(globalThis)
    }, typeof this._input != "string" && !(this._input instanceof URL || this._input instanceof globalThis.Request))
      throw new TypeError("`input` must be a string, URL, or Request");
    if (this._options.prefixUrl && typeof this._input == "string") {
      if (this._input.startsWith("/"))
        throw new Error("`input` must not begin with a slash when using `prefixUrl`");
      this._options.prefixUrl.endsWith("/") || (this._options.prefixUrl += "/"), this._input = this._options.prefixUrl + this._input;
    }
    if (wz) {
      if (this.abortController = new globalThis.AbortController(), this._options.signal) {
        const r = this._options.signal;
        this._options.signal.addEventListener("abort", () => {
          this.abortController.abort(r.reason);
        });
      }
      this._options.signal = this.abortController.signal;
    }
    if (vz && (this._options.duplex = "half"), this.request = new globalThis.Request(this._input, this._options), this._options.searchParams) {
      const i = "?" + (typeof this._options.searchParams == "string" ? this._options.searchParams.replace(/^\?/, "") : new URLSearchParams(this._options.searchParams).toString()), o = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, i);
      (bz && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers["content-type"]) && this.request.headers.delete("content-type"), this.request = new globalThis.Request(new globalThis.Request(o, { ...this.request }), this._options);
    }
    this._options.json !== void 0 && (this._options.body = JSON.stringify(this._options.json), this.request.headers.set("content-type", this._options.headers.get("content-type") ?? "application/json"), this.request = new globalThis.Request(this.request, { body: this._options.body }));
  }
  _calculateRetryDelay(t) {
    if (this._retryCount++, this._retryCount < this._options.retry.limit && !(t instanceof d5)) {
      if (t instanceof n2) {
        if (!this._options.retry.statusCodes.includes(t.response.status))
          return 0;
        const r = t.response.headers.get("Retry-After");
        if (r && this._options.retry.afterStatusCodes.includes(t.response.status)) {
          let i = Number(r);
          return Number.isNaN(i) ? i = Date.parse(r) - Date.now() : i *= 1e3, typeof this._options.retry.maxRetryAfter < "u" && i > this._options.retry.maxRetryAfter ? 0 : i;
        }
        if (t.response.status === 413)
          return 0;
      }
      const n = 0.3;
      return Math.min(this._options.retry.backoffLimit, n * 2 ** (this._retryCount - 1) * 1e3);
    }
    return 0;
  }
  _decorateResponse(t) {
    return this._options.parseJson && (t.json = async () => this._options.parseJson(await t.text())), t;
  }
  async _retry(t) {
    try {
      return await t();
    } catch (n) {
      const r = Math.min(this._calculateRetryDelay(n), ah);
      if (r !== 0 && this._retryCount > 0) {
        await Pz(r, { signal: this._options.signal });
        for (const i of this._options.hooks.beforeRetry)
          if (await i({
            request: this.request,
            options: this._options,
            error: n,
            retryCount: this._retryCount
          }) === m5)
            return;
        return this._retry(t);
      }
      throw n;
    }
  }
  async _fetch() {
    for (const t of this._options.hooks.beforeRequest) {
      const n = await t(this.request, this._options);
      if (n instanceof Request) {
        this.request = n;
        break;
      }
      if (n instanceof Response)
        return n;
    }
    return this._options.timeout === !1 ? this._options.fetch(this.request.clone()) : Tz(this.request.clone(), this.abortController, this._options);
  }
  /* istanbul ignore next */
  _stream(t, n) {
    const r = Number(t.headers.get("content-length")) || 0;
    let i = 0;
    return t.status === 204 ? (n && n({ percent: 1, totalBytes: r, transferredBytes: i }, new Uint8Array()), new globalThis.Response(null, {
      status: t.status,
      statusText: t.statusText,
      headers: t.headers
    })) : new globalThis.Response(new globalThis.ReadableStream({
      async start(o) {
        const a = t.body.getReader();
        n && n({ percent: 0, transferredBytes: 0, totalBytes: r }, new Uint8Array());
        async function s() {
          const { done: c, value: f } = await a.read();
          if (c) {
            o.close();
            return;
          }
          if (n) {
            i += f.byteLength;
            const p = r === 0 ? 0 : i / r;
            n({ percent: p, transferredBytes: i, totalBytes: r }, f);
          }
          o.enqueue(f), await s();
        }
        await s();
      }
    }), {
      status: t.status,
      statusText: t.statusText,
      headers: t.headers
    });
  }
}
/*! MIT License © Sindre Sorhus */
const Sm = (e) => {
  const t = (n, r) => Bu.create(n, jc(e, r));
  for (const n of h5)
    t[n] = (r, i) => Bu.create(r, jc(e, i, { method: n }));
  return t.create = (n) => Sm(jc(n)), t.extend = (n) => Sm(jc(e, n)), t.stop = m5, t;
}, Az = Sm(), v5 = Az, Rz = /* @__PURE__ */ Ee((e, t) => /* @__PURE__ */ K(st.span, de({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
}))), $z = Rz, [Df, vse] = ar("Tooltip", [
  Ga
]), Nf = Ga(), Oz = "TooltipProvider", Mz = 700, _m = "tooltip.open", [Dz, T1] = Df(Oz), Nz = (e) => {
  const { __scopeTooltip: t, delayDuration: n = Mz, skipDelayDuration: r = 300, disableHoverableContent: i = !1, children: o } = e, [a, s] = ue(!0), c = he(!1), f = he(0);
  return _e(() => {
    const p = f.current;
    return () => window.clearTimeout(p);
  }, []), /* @__PURE__ */ K(Dz, {
    scope: t,
    isOpenDelayed: a,
    delayDuration: n,
    onOpen: Me(() => {
      window.clearTimeout(f.current), s(!1);
    }, []),
    onClose: Me(() => {
      window.clearTimeout(f.current), f.current = window.setTimeout(
        () => s(!0),
        r
      );
    }, [
      r
    ]),
    isPointerInTransitRef: c,
    onPointerInTransitChange: Me((p) => {
      c.current = p;
    }, []),
    disableHoverableContent: i
  }, o);
}, k1 = "Tooltip", [Iz, Sl] = Df(k1), Lz = (e) => {
  const { __scopeTooltip: t, children: n, open: r, defaultOpen: i = !1, onOpenChange: o, disableHoverableContent: a, delayDuration: s } = e, c = T1(k1, e.__scopeTooltip), f = Nf(t), [p, d] = ue(null), h = zr(), m = he(0), v = a ?? c.disableHoverableContent, w = s ?? c.delayDuration, b = he(!1), [E = !1, C] = si({
    prop: r,
    defaultProp: i,
    onChange: (R) => {
      R ? (c.onOpen(), document.dispatchEvent(new CustomEvent(_m))) : c.onClose(), o == null || o(R);
    }
  }), S = yn(() => E ? b.current ? "delayed-open" : "instant-open" : "closed", [
    E
  ]), _ = Me(() => {
    window.clearTimeout(m.current), b.current = !1, C(!0);
  }, [
    C
  ]), T = Me(() => {
    window.clearTimeout(m.current), C(!1);
  }, [
    C
  ]), P = Me(() => {
    window.clearTimeout(m.current), m.current = window.setTimeout(() => {
      b.current = !0, C(!0);
    }, w);
  }, [
    w,
    C
  ]);
  return _e(() => () => window.clearTimeout(m.current), []), /* @__PURE__ */ K(Hg, f, /* @__PURE__ */ K(Iz, {
    scope: t,
    contentId: h,
    open: E,
    stateAttribute: S,
    trigger: p,
    onTriggerChange: d,
    onTriggerEnter: Me(() => {
      c.isOpenDelayed ? P() : _();
    }, [
      c.isOpenDelayed,
      P,
      _
    ]),
    onTriggerLeave: Me(() => {
      v ? T() : window.clearTimeout(m.current);
    }, [
      T,
      v
    ]),
    onOpen: _,
    onClose: T,
    disableHoverableContent: v
  }, n));
}, o2 = "TooltipTrigger", Fz = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeTooltip: n, ...r } = e, i = Sl(o2, n), o = T1(o2, n), a = Nf(n), s = he(null), c = Lt(t, s, i.onTriggerChange), f = he(!1), p = he(!1), d = Me(
    () => f.current = !1,
    []
  );
  return _e(() => () => document.removeEventListener("pointerup", d), [
    d
  ]), /* @__PURE__ */ K(xf, de({
    asChild: !0
  }, a), /* @__PURE__ */ K(st.button, de({
    // We purposefully avoid adding `type=button` here because tooltip triggers are also
    // commonly anchors and the anchor `type` attribute signifies MIME type.
    "aria-describedby": i.open ? i.contentId : void 0,
    "data-state": i.stateAttribute
  }, r, {
    ref: c,
    onPointerMove: Oe(e.onPointerMove, (h) => {
      h.pointerType !== "touch" && !p.current && !o.isPointerInTransitRef.current && (i.onTriggerEnter(), p.current = !0);
    }),
    onPointerLeave: Oe(e.onPointerLeave, () => {
      i.onTriggerLeave(), p.current = !1;
    }),
    onPointerDown: Oe(e.onPointerDown, () => {
      f.current = !0, document.addEventListener("pointerup", d, {
        once: !0
      });
    }),
    onFocus: Oe(e.onFocus, () => {
      f.current || i.onOpen();
    }),
    onBlur: Oe(e.onBlur, i.onClose),
    onClick: Oe(e.onClick, i.onClose)
  })));
}), w5 = "TooltipPortal", [zz, Vz] = Df(w5, {
  forceMount: void 0
}), Bz = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: i } = e, o = Sl(w5, t);
  return /* @__PURE__ */ K(zz, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ K($n, {
    present: n || o.open
  }, /* @__PURE__ */ K(Ef, {
    asChild: !0,
    container: i
  }, r)));
}, sl = "TooltipContent", Hz = /* @__PURE__ */ Ee((e, t) => {
  const n = Vz(sl, e.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...o } = e, a = Sl(sl, e.__scopeTooltip);
  return /* @__PURE__ */ K($n, {
    present: r || a.open
  }, a.disableHoverableContent ? /* @__PURE__ */ K(y5, de({
    side: i
  }, o, {
    ref: t
  })) : /* @__PURE__ */ K(Uz, de({
    side: i
  }, o, {
    ref: t
  })));
}), Uz = /* @__PURE__ */ Ee((e, t) => {
  const n = Sl(sl, e.__scopeTooltip), r = T1(sl, e.__scopeTooltip), i = he(null), o = Lt(t, i), [a, s] = ue(null), { trigger: c, onClose: f } = n, p = i.current, { onPointerInTransitChange: d } = r, h = Me(() => {
    s(null), d(!1);
  }, [
    d
  ]), m = Me((v, w) => {
    const b = v.currentTarget, E = {
      x: v.clientX,
      y: v.clientY
    }, C = Yz(E, b.getBoundingClientRect()), S = Kz(E, C), _ = Xz(w.getBoundingClientRect()), T = Zz([
      ...S,
      ..._
    ]);
    s(T), d(!0);
  }, [
    d
  ]);
  return _e(() => () => h(), [
    h
  ]), _e(() => {
    if (c && p) {
      const v = (b) => m(b, p), w = (b) => m(b, c);
      return c.addEventListener("pointerleave", v), p.addEventListener("pointerleave", w), () => {
        c.removeEventListener("pointerleave", v), p.removeEventListener("pointerleave", w);
      };
    }
  }, [
    c,
    p,
    m,
    h
  ]), _e(() => {
    if (a) {
      const v = (w) => {
        const b = w.target, E = {
          x: w.clientX,
          y: w.clientY
        }, C = (c == null ? void 0 : c.contains(b)) || (p == null ? void 0 : p.contains(b)), S = !Qz(E, a);
        C ? h() : S && (h(), f());
      };
      return document.addEventListener("pointermove", v), () => document.removeEventListener("pointermove", v);
    }
  }, [
    c,
    p,
    a,
    f,
    h
  ]), /* @__PURE__ */ K(y5, de({}, e, {
    ref: o
  }));
}), [Wz, jz] = Df(k1, {
  isInside: !1
}), y5 = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeTooltip: n, children: r, "aria-label": i, onEscapeKeyDown: o, onPointerDownOutside: a, ...s } = e, c = Sl(sl, n), f = Nf(n), { onClose: p } = c;
  return _e(() => (document.addEventListener(_m, p), () => document.removeEventListener(_m, p)), [
    p
  ]), _e(() => {
    if (c.trigger) {
      const d = (h) => {
        const m = h.target;
        m != null && m.contains(c.trigger) && p();
      };
      return window.addEventListener("scroll", d, {
        capture: !0
      }), () => window.removeEventListener("scroll", d, {
        capture: !0
      });
    }
  }, [
    c.trigger,
    p
  ]), /* @__PURE__ */ K(vf, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onEscapeKeyDown: o,
    onPointerDownOutside: a,
    onFocusOutside: (d) => d.preventDefault(),
    onDismiss: p
  }, /* @__PURE__ */ K(Ug, de({
    "data-state": c.stateAttribute
  }, f, s, {
    ref: t,
    style: {
      ...s.style,
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
      "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
      "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }), /* @__PURE__ */ K(z4, null, r), /* @__PURE__ */ K(Wz, {
    scope: n,
    isInside: !0
  }, /* @__PURE__ */ K($z, {
    id: c.contentId,
    role: "tooltip"
  }, i || r))));
}), qz = "TooltipArrow", Gz = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeTooltip: n, ...r } = e, i = Nf(n);
  return jz(qz, n).isInside ? null : /* @__PURE__ */ K(PO, de({}, i, r, {
    ref: t
  }));
});
function Yz(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), o = Math.abs(t.left - e.x);
  switch (Math.min(n, r, i, o)) {
    case o:
      return "left";
    case i:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Kz(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push({
        x: e.x - n,
        y: e.y + n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "bottom":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y - n
      });
      break;
    case "left":
      r.push({
        x: e.x + n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "right":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x - n,
        y: e.y + n
      });
      break;
  }
  return r;
}
function Xz(e) {
  const { top: t, right: n, bottom: r, left: i } = e;
  return [
    {
      x: i,
      y: t
    },
    {
      x: n,
      y: t
    },
    {
      x: n,
      y: r
    },
    {
      x: i,
      y: r
    }
  ];
}
function Qz(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let o = 0, a = t.length - 1; o < t.length; a = o++) {
    const s = t[o].x, c = t[o].y, f = t[a].x, p = t[a].y;
    c > r != p > r && n < (f - s) * (r - c) / (p - c) + s && (i = !i);
  }
  return i;
}
function Zz(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), Jz(t);
}
function Jz(e) {
  if (e.length <= 1)
    return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    for (; t.length >= 2; ) {
      const o = t[t.length - 1], a = t[t.length - 2];
      if ((o.x - a.x) * (i.y - a.y) >= (o.y - a.y) * (i.x - a.x))
        t.pop();
      else
        break;
    }
    t.push(i);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r];
    for (; n.length >= 2; ) {
      const o = n[n.length - 1], a = n[n.length - 2];
      if ((o.x - a.x) * (i.y - a.y) >= (o.y - a.y) * (i.x - a.x))
        n.pop();
      else
        break;
    }
    n.push(i);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
const eV = Nz, b5 = Lz, x5 = Fz, E5 = Bz, P1 = Hz, C5 = Gz, tV = eV, S5 = b5, _5 = x5, nV = E5, A1 = D.forwardRef(
  ({ className: e, children: t, sideOffset: n = 4, tooltipArrowClassName: r, ...i }, o) => /* @__PURE__ */ D.createElement(
    P1,
    {
      ref: o,
      sideOffset: n,
      className: le(
        "ai-tw-z-[1200] ai-tw-w-[400px] ai-tw-overflow-hidden ai-tw-rounded-sm ai-tw-bg-grey-60 ai-tw-px-2 ai-tw-py-1.5 ai-tw-text-white ai-tw-shadow-md ai-tw-animate-in ai-tw-fade-in-0 ai-tw-zoom-in-95 ai-tw-body-sm data-[state=closed]:ai-tw-animate-out data-[state=closed]:ai-tw-fade-out-0 data-[state=closed]:ai-tw-zoom-out-95 data-[side=bottom]:ai-tw-slide-in-from-top-2 data-[side=left]:ai-tw-slide-in-from-right-2 data-[side=right]:ai-tw-slide-in-from-left-2 data-[side=top]:ai-tw-slide-in-from-bottom-2",
        e
      ),
      ...i
    },
    t,
    /* @__PURE__ */ D.createElement(T5, { className: r })
  )
);
A1.displayName = P1.displayName;
const T5 = D.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ D.createElement(
  C5,
  {
    ref: n,
    className: le("ai-tw-fill-grey-60", e),
    ...t
  }
));
T5.displayName = C5.displayName;
const rV = ["ai-brivity", "ai-place"], iV = {
  theme: "ai-brivity",
  setTheme: () => null,
  apiUrl: void 0,
  token: ""
}, k5 = ln(iV), oV = "https://write-a-plumber.brivity.com";
typeof window < "u" && (window.localStorage.setItem("ai-components-version", "7.5.2"), window.localStorage.removeItem("writingAssistVersion"));
function wse({
  children: e,
  theme: t = "ai-brivity",
  apiUrl: n,
  token: r,
  fetchToken: i,
  swrConfigValue: o
}) {
  const [a, s] = ue(), {
    data: c,
    isLoading: f,
    error: p
  } = qr(i ? "token" : null, i || null), d = c || r;
  if (_e(() => {
    const m = window.document.documentElement;
    m.classList.remove(...rV), m.classList.add(a || t), m.id = "ai-tw-app";
  }, [t, a]), f && !r)
    return null;
  if (p && !r)
    return console.error("Error fetching token:", p), null;
  if (!d)
    return console.error("Token is undefined"), null;
  const h = {
    apiUrl: HF(n || oV),
    token: d,
    theme: t,
    setTheme: s
  };
  return /* @__PURE__ */ y.createElement(k5.Provider, { value: h }, /* @__PURE__ */ y.createElement(S1, { value: o }, /* @__PURE__ */ y.createElement(tV, { delayDuration: 400, skipDelayDuration: 200 }, e)));
}
const _l = () => {
  const e = Re(k5);
  if (e === void 0)
    throw new Error(
      "useAiComponentsContext must be used within a AiComponentsProvider"
    );
  return e;
};
function P5(e, t) {
  const n = t || "https://write-a-plumber.brivity.com";
  if (!n)
    throw new Error("Missing API URL");
  return new URL(`v1${e}`, n);
}
function xn() {
  const { apiUrl: e, token: t } = _l();
  if (!t)
    throw new Error("Missing API token");
  return Me(
    (r, i) => {
      const o = {
        timeout: 6e4,
        ...i,
        headers: {
          Authorization: `Bearer ${t}`,
          ...i == null ? void 0 : i.headers
        }
      };
      return v5(P5(r, e), o).json();
    },
    [e, t]
  );
}
function aV() {
  const { apiUrl: e, token: t } = _l();
  if (!t)
    throw new Error("Missing API token");
  return Me(
    async (r, i) => {
      const o = {
        timeout: 6e4,
        throwHttpErrors: !1,
        ...i,
        headers: {
          Authorization: `Bearer ${t}`,
          ...i == null ? void 0 : i.headers
        }
      };
      return await v5(P5(r, e), o);
    },
    [e, t]
  );
}
function sV() {
  const e = xn();
  return Mf(
    "/instruction-categories",
    (t) => e(t)
  );
}
function yse(e) {
  const t = xn();
  return Mf(e ? `/instructions?search=${e}` : null, () => t("/instructions", {
    searchParams: {
      search: e,
      limit: "8"
    }
  }));
}
const lV = li(
  "ai-tw-box-border ai-tw-inline-flex ai-tw-h-6 ai-tw-w-6 ai-tw-animate-spin ai-tw-rounded-full ai-tw-border-solid",
  {
    variants: {
      variant: {
        default: "ai-tw-border-stroke-primary-dark",
        ai: "ai-tw-border-stroke-ai-light",
        primary: "ai-tw-border-stroke-brand-light"
      },
      size: {
        small: "ai-tw-h-4 ai-tw-w-4 ai-tw-border-2",
        medium: "ai-tw-h-8 ai-tw-w-8 ai-tw-border-4",
        large: "ai-tw-h-10 ai-tw-w-10 ai-tw-border-[5px]"
      }
    }
  }
);
function bn({
  variant: e = "default",
  size: t = "medium",
  className: n
}) {
  return /* @__PURE__ */ y.createElement(
    "span",
    {
      "data-testid": "spinner",
      className: le(
        lV({ variant: e, size: t }),
        n,
        "ai-tw-border-b-transparent"
      )
    }
  );
}
function cV() {
  return /* @__PURE__ */ D.createElement("div", { className: le("ai-tw-grid ai-tw-h-[88px] ai-tw-place-items-center") }, /* @__PURE__ */ D.createElement(bn, { variant: "ai" }));
}
const If = Ee(({ children: e, className: t = "", ...n }, r) => /* @__PURE__ */ y.createElement(
  "button",
  {
    className: le(
      "ai-tw-border-solid ai-tw-bg-transparent ai-tw-bg-none",
      "ai-tw-grid ai-tw-h-7 ai-tw-w-7 ai-tw-place-items-center ai-tw-rounded-full",
      "ai-tw-shrink-0 ai-tw-border-2 ai-tw-border-transparent ai-tw-text-grey-60",
      "disabled:ai-tw-cursor-not-allowed disabled:ai-tw-opacity-50",
      "hover:enabled:ai-tw-cursor-pointer hover:enabled:ai-tw-border-purple-20",
      "focus:ai-tw-outline-purple-40 focus:enabled:ai-tw-cursor-pointer focus:enabled:ai-tw-border-purple-20",
      "active:enabled:ai-tw-bg-purple-50 active:enabled:ai-tw-text-white",
      "[&>svg]:ai-tw-h-4 [&>svg]:ai-tw-w-4",
      t
    ),
    ...n,
    ref: r
  },
  e
));
If.displayName = "ButtonInput";
const R1 = li(
  [
    "ai-tw-w-full ai-tw-rounded ai-tw-border ai-tw-border-stroke-primary-dark ai-tw-px-3 ai-tw-py-2 ai-tw-outline-none placeholder:ai-tw-text-grey-50",
    "ai-tw-outline-offset-0 ai-tw-body-md"
  ],
  {
    variants: {
      variant: {
        default: [
          "hover:ai-tw-border-stroke-brand-light focus:ai-tw-border-stroke-brand focus:ai-tw-outline-stroke-brand-lightest",
          "selection:ai-tw-bg-element-brand-lightest"
        ],
        error: [
          "ai-tw-border-stroke-critical hover:ai-tw-border-stroke-critical-dark focus:ai-tw-border-stroke-critical-dark focus:ai-tw-outline-stroke-critical-lightest",
          "selection:ai-tw-bg-element-critical-light"
        ],
        ai: [
          "hover:ai-tw-border-stroke-ai-light focus:ai-tw-border-stroke-ai focus:ai-tw-outline-stroke-ai-lightest",
          "selection:ai-tw-bg-element-ai-light"
        ]
      }
    }
  }
), A5 = Ee(
  ({ className: e = "", variant: t = "default", labelText: n, ...r }, i) => /* @__PURE__ */ y.createElement("div", { className: "ai-tw-preflight ai-tw-flex ai-tw-w-full ai-tw-flex-col ai-tw-gap-1.5" }, n && /* @__PURE__ */ y.createElement("label", { className: "ai-tw-font-semibold ai-tw-text-content-primary-light ai-tw-subtitle-md" }, n), /* @__PURE__ */ y.createElement(
    "input",
    {
      className: le(R1({ variant: t }), e),
      ...r,
      ref: i
    }
  ))
);
A5.displayName = "Input";
const Lf = Ee(
  ({
    containerClassName: e = "",
    className: t = "",
    labelText: n,
    variant: r = "default",
    ...i
  }, o) => /* @__PURE__ */ y.createElement(
    "div",
    {
      className: le(
        "ai-tw-preflight ai-tw-flex ai-tw-w-full ai-tw-flex-col ai-tw-gap-1.5",
        e
      )
    },
    n && /* @__PURE__ */ y.createElement("label", { className: "ai-tw-font-semibold ai-tw-text-content-primary-light ai-tw-subtitle-md" }, n),
    /* @__PURE__ */ y.createElement(
      "textarea",
      {
        className: rl(
          R1({ variant: r }),
          "ai-tw-bg-tinted-grey-50 ai-tw-resize-none focus:ai-tw-bg-white",
          t
        ),
        ...i,
        ref: o
      }
    )
  )
);
Lf.displayName = "TextArea";
const $1 = Ee(
  (e, t) => {
    const n = y.useRef(null);
    return _e(() => {
      const r = n.current, i = new MutationObserver(() => {
        r && (r.style.height = "0px", r.style.height = `${Math.min(r.scrollHeight, 120) + 2}px`);
      });
      return r && i.observe(r, { childList: !0 }), () => {
        i.disconnect();
      };
    }, [t]), /* @__PURE__ */ y.createElement(
      Lf,
      {
        ...e,
        ref: (r) => {
          n.current = r, typeof t == "function" ? t(r) : t && (t.current = r);
        }
      }
    );
  }
);
$1.displayName = "TextAreaAutoSize";
const R5 = ln(null);
function uV({
  children: e,
  value: t
}) {
  const [n, r] = y.useState("library");
  return /* @__PURE__ */ y.createElement(
    R5.Provider,
    {
      value: {
        ...t,
        source: n,
        setSource: r
      }
    },
    e
  );
}
function Ff() {
  const e = Re(R5);
  if (!e)
    throw new Error(
      "useMainContext must be used within a MainProvider component"
    );
  return e;
}
const fV = li(
  [
    "ai-tw-relative ai-tw-inline-grid ai-tw-h-min ai-tw-w-max ai-tw-place-items-center ai-tw-rounded-full ai-tw-border-solid ai-tw-uppercase"
  ],
  {
    variants: {
      variant: {
        primary: [
          "ai-tw-border-element-brand-alt ai-tw-bg-element-brand-alt ai-tw-text-white",
          "hover:enabled:ai-tw-border-element-brand-alt-dark hover:enabled:ai-tw-bg-element-brand-alt-dark",
          "active:enabled:ai-tw-border-element-brand-darkest active:enabled:ai-tw-bg-element-brand-darkest",
          "disabled:ai-tw-border-element-brand-alt-light disabled:ai-tw-bg-element-brand-alt-light disabled:ai-tw-text-white"
        ],
        secondary: [
          "ai-tw-border-element-brand-alt ai-tw-bg-transparent ai-tw-text-element-brand-alt ",
          "active:enabled:ai-tw-bg-element-brand-alt active:enabled:ai-tw-text-white",
          "disabled:ai-tw-border-stroke-brand-alt-disabled disabled:ai-tw-text-stroke-brand-alt-disabled"
        ],
        "secondary-alt": [
          "ai-tw-border-element-brand-alt ai-tw-bg-white ai-tw-text-element-brand-alt",
          "active:enabled:ai-tw-border-element-brand-darkest active:enabled:ai-tw-bg-element-brand-lightest active:enabled:ai-tw-text-element-brand-darkest",
          "disabled:ai-tw-border-stroke-brand-alt-disabled disabled:ai-tw-text-stroke-brand-alt-disabled"
        ],
        tertiary: [
          "ai-tw-border-element-primary-subtle ai-tw-bg-element-primary-subtle ai-tw-text-content-primary",
          "hover:enabled:ai-tw-border-element-primary-subtle-dark hover:enabled:ai-tw-bg-element-primary-subtle-dark",
          "active:enabled:ai-tw-border-element-primary-subtle-darkest active:enabled:ai-tw-bg-element-primary-subtle-darkest",
          "disabled:ai-tw-border-element-primary-subtle-light disabled:ai-tw-bg-element-primary-subtle-light disabled:ai-tw-text-content-primary-disabled"
        ],
        "transparent-primary": [
          "ai-tw-border-stroke-primary-lightest ai-tw-bg-transparent ai-tw-text-content-on-color",
          "hover:enabled:ai-tw-border-element-brand-alt hover:enabled:ai-tw-bg-element-brand-alt",
          "active:enabled:ai-tw-border-element-brand-alt-dark active:enabled:ai-tw-bg-element-brand-alt-dark",
          "disabled:ai-tw-border-stroke-primary-darkest disabled:ai-tw-text-stroke-primary-darkest"
        ],
        "transparent-secondary": [
          "ai-tw-border-stroke-primary-lightest ai-tw-bg-transparent ai-tw-text-content-on-color",
          "hover:enabled:ai-tw-bg-black/50",
          "active:enabled:ai-tw-bg-black/75",
          "disabled:ai-tw-border-stroke-primary-darkest disabled:ai-tw-text-stroke-primary-darkest"
        ],
        destructive: [
          "ai-tw-border-stroke-critical-dark ai-tw-bg-transparent ai-tw-text-stroke-critical-dark ai-tw-outline-stroke-critical-dark",
          "active:enabled:ai-tw-bg-stroke-critical-dark active:enabled:ai-tw-text-content-on-color",
          "disabled:ai-tw-border-stroke-critical-lightest disabled:ai-tw-text-stroke-critical-lightest"
        ],
        "ai-primary": [
          "ai-tw-border-element-ai ai-tw-bg-element-ai ai-tw-text-white",
          "hover:enabled:ai-tw-border-element-ai-dark hover:enabled:ai-tw-bg-element-ai-dark",
          "active:enabled:ai-tw-border-element-ai-darkest active:enabled:ai-tw-bg-element-ai-darkest",
          "disabled:ai-tw-border-element-ai-light disabled:ai-tw-bg-element-ai-light"
        ],
        "ai-secondary": [
          "ai-tw-border-element-ai ai-tw-bg-transparent ai-tw-text-element-ai",
          "active:enabled:ai-tw-bg-element-ai active:enabled:ai-tw-text-white",
          "disabled:ai-tw-border-element-ai-light disabled:ai-tw-text-element-ai-light"
        ]
      },
      size: {
        sm: [
          "ai-tw-border ai-tw-px-2 ai-tw-py-1 ai-tw-button-sm",
          "hover:enabled:ai-tw-border-2 hover:enabled:ai-tw-px-[7px] hover:enabled:ai-tw-py-[3px]"
        ],
        md: [
          "ai-tw-border-2 ai-tw-px-5 ai-tw-py-2 ai-tw-button-md hover:enabled:ai-tw-border-[3px] hover:enabled:ai-tw-px-[19px] hover:enabled:ai-tw-py-[7px]"
        ],
        icon: [
          "ai-tw-h-8 ai-tw-w-8 ai-tw-border-2",
          "ai-tw-button-md hover:enabled:ai-tw-border-[3px]"
        ],
        "icon-sm": [
          "ai-tw-h-6 ai-tw-w-6 ai-tw-border",
          "ai-tw-button-sm hover:enabled:ai-tw-border-2"
        ]
      },
      status: {
        default: "",
        loading: "ai-tw-relative",
        success: "ai-tw-relative"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "md",
      status: "default"
    }
  }
), dV = li("", {
  variants: {
    variant: {
      primary: "ai-tw-border-white",
      secondary: "ai-tw-border-element-brand-alt-light",
      "secondary-alt": "ai-tw-border-element-brand-alt-light",
      tertiary: "ai-tw-border-content-primary-disabled",
      "transparent-primary": "ai-tw-border-stroke-primary-darkest",
      "transparent-secondary": "ai-tw-border-stroke-primary-darkest",
      destructive: "ai-tw-border-stroke-critical-lightest",
      "ai-primary": "ai-tw-border-white",
      "ai-secondary": "ai-tw-border-element-ai-light"
    }
  }
}), Jt = D.forwardRef(
  ({
    className: e,
    contentClassName: t,
    variant: n = "primary",
    size: r = "md",
    status: i = "default",
    disabled: o,
    children: a,
    asChild: s = !1,
    ...c
  }, f) => {
    const p = s ? Ti : "button";
    return /* @__PURE__ */ D.createElement(
      p,
      {
        className: le(fV({ variant: n, size: r, status: i, className: e })),
        ref: f,
        disabled: i === "loading" || o,
        ...c
      },
      /* @__PURE__ */ D.createElement(
        "span",
        {
          className: le(
            t,
            i === "loading" && "ai-tw-opacity-50",
            i === "success" && "ai-tw-opacity-0"
          )
        },
        a
      ),
      /* @__PURE__ */ D.createElement("div", { className: "ai-tw-absolute ai-tw-inset-0 ai-tw-grid ai-tw-h-full ai-tw-w-full ai-tw-place-items-center" }, i === "loading" ? /* @__PURE__ */ D.createElement(bn, { className: dV({ variant: n }), size: "small" }) : i === "success" ? /* @__PURE__ */ D.createElement(
        Ne,
        {
          icon: WR,
          fixedWidth: !0,
          size: r != null && r.includes("sm") ? "1x" : "lg"
        }
      ) : null)
    );
  }
);
Jt.displayName = "Button";
const pV = [
  {
    option: "Clean Up",
    icon: PR
  },
  {
    option: "Rephrase",
    icon: HR
  },
  {
    option: "Make Shorter",
    icon: O4
  },
  {
    option: "Make Longer",
    icon: F4
  },
  {
    option: "Summarize",
    icon: $4
  }
];
function hV({
  activeElement: e,
  portalPosition: t,
  textPosition: n,
  handleImproveClick: r,
  textSelection: i
}) {
  const o = he(null), a = he(null), { tinyMceDocument: s } = Ff(), [c, f] = ue(!1), [p, d] = ue(null), [h, m] = ue(""), [v, w] = ue(null), b = Me(() => {
    var C, S;
    (C = document.getSelection()) == null || C.removeAllRanges(), (S = s == null ? void 0 : s.getSelection()) == null || S.removeAllRanges(), d(null), m(""), setTimeout(() => {
      f(!1);
    }, 50);
  }, [s]);
  if (_e(() => {
    function C(S) {
      S.key === "Escape" && b();
    }
    return document.addEventListener("keydown", C), s == null || s.addEventListener("keydown", C), () => {
      document.removeEventListener("keydown", C), s == null || s.removeEventListener("keydown", C);
    };
  }, [b, s]), _e(() => {
    const C = `improve-clone-${e == null ? void 0 : e.id}`, S = document.getElementById(C);
    if (!e || C === (S == null ? void 0 : S.dataset.id))
      return;
    S && S.remove();
    const _ = document.createElement("div");
    _.id = C, _.dataset.id = e.id, _.style.position = "absolute", _.style.left = `${(t == null ? void 0 : t.left) || 0}px`, _.style.top = `${(t == null ? void 0 : t.top) || 0 + window.scrollY}px`, document.body.appendChild(_), w(_);
  }, [e, t]), n && (n.left !== (p == null ? void 0 : p.left) || n.bottom !== (p == null ? void 0 : p.bottom)) && d(n), !v || !(p != null && p.left) || !(p != null && p.bottom) || !c && !n || !i)
    return null;
  function E(C) {
    C.key === "Enter" && C.currentTarget.value !== "" && (C.preventDefault(), r(C.currentTarget.value), b());
  }
  return hf(
    /* @__PURE__ */ y.createElement(
      on.div,
      {
        ref: o,
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        style: {
          left: p == null ? void 0 : p.left,
          top: (p == null ? void 0 : p.bottom) + 2 || 2
        },
        className: "ai-tw-preflight ai-tw-absolute ai-tw-z-[1250]"
      },
      c ? /* @__PURE__ */ y.createElement(
        on.div,
        {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          transition: { duration: 0.2 },
          className: "ai-tw-flex ai-tw-w-[340px] ai-tw-flex-col ai-tw-gap-2.5"
        },
        /* @__PURE__ */ y.createElement(
          Jt,
          {
            variant: "ai-primary",
            size: "icon",
            className: "ai-tw-absolute -ai-tw-right-7 -ai-tw-top-7",
            onClick: b
          },
          /* @__PURE__ */ y.createElement(Ne, { fixedWidth: !0, icon: Og })
        ),
        /* @__PURE__ */ y.createElement(
          $1,
          {
            autoFocus: !0,
            variant: "ai",
            className: le(
              "prompt-input",
              "ai-tw-h-[38px] ai-tw-w-full ai-tw-bg-white ai-tw-pr-10 ai-tw-shadow-purple"
            ),
            ref: a,
            placeholder: "Create from or edit selection...",
            value: h,
            onChange: (C) => m(C.currentTarget.value),
            onKeyDown: E
          }
        ),
        /* @__PURE__ */ y.createElement(
          If,
          {
            type: "button",
            disabled: !h,
            "aria-label": "send",
            className: "ai-tw-absolute ai-tw-right-3 ai-tw-top-1.5 ai-tw-h-6 ai-tw-w-6",
            onClick: () => {
              r(h), b();
            }
          },
          /* @__PURE__ */ y.createElement(Ne, { icon: Rg })
        ),
        /* @__PURE__ */ y.createElement("div", { className: "ai-tw-w-fit ai-tw-rounded ai-tw-bg-white ai-tw-shadow-purple" }, /* @__PURE__ */ y.createElement("span", { className: "ai-tw-ml-2 ai-tw-mt-1.5 ai-tw-text-[10px] ai-tw-font-semibold ai-tw-text-grey-50" }, "Edit or Review"), /* @__PURE__ */ y.createElement("ul", { className: "ai-tw-m-0 ai-tw-p-0" }, pV.map(({ option: C, icon: S }) => /* @__PURE__ */ y.createElement("li", { key: C, className: "ai-tw-list-none" }, /* @__PURE__ */ y.createElement(
          "button",
          {
            className: le(
              "ai-tw-flex ai-tw-cursor-pointer ai-tw-items-center ai-tw-gap-2",
              "ai-tw-w-full ai-tw-px-4 ai-tw-py-1",
              "hover:ai-tw-bg-tinted-grey-50 active:ai-tw-bg-tinted-grey-60"
            ),
            onClick: () => {
              r(C), b();
            }
          },
          /* @__PURE__ */ y.createElement(
            Ne,
            {
              className: "ai-tw-text-purple-60",
              fixedWidth: !0,
              icon: S
            }
          ),
          /* @__PURE__ */ y.createElement("span", null, C)
        )))))
      ) : /* @__PURE__ */ y.createElement(
        "button",
        {
          className: le(
            "ai-tw-bg-white ai-tw-px-2.5 ai-tw-py-1 ai-tw-font-semibold",
            "ai-tw-rounded-full ai-tw-border ai-tw-border-grey-30 ai-tw-shadow-purple",
            "ai-tw-flex ai-tw-cursor-pointer ai-tw-items-center ai-tw-gap-2 ai-tw-text-element-ai",
            "hover:ai-tw-bg-element-ai hover:ai-tw-text-white",
            "focus:ai-tw-bg-element-ai focus:ai-tw-text-white"
          ),
          onClick: (C) => {
            C.stopPropagation(), C.preventDefault(), f(!0);
          }
        },
        /* @__PURE__ */ y.createElement(Ne, { icon: vR }),
        /* @__PURE__ */ y.createElement("span", null, "Improve")
      )
    ),
    v
  );
}
const oi = /* @__PURE__ */ Object.create(null);
oi.open = "0";
oi.close = "1";
oi.ping = "2";
oi.pong = "3";
oi.message = "4";
oi.upgrade = "5";
oi.noop = "6";
const wu = /* @__PURE__ */ Object.create(null);
Object.keys(oi).forEach((e) => {
  wu[oi[e]] = e;
});
const Tm = { type: "error", data: "parser error" }, $5 = typeof Blob == "function" || typeof Blob < "u" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]", O5 = typeof ArrayBuffer == "function", M5 = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer, O1 = ({ type: e, data: t }, n, r) => $5 && t instanceof Blob ? n ? r(t) : a2(t, r) : O5 && (t instanceof ArrayBuffer || M5(t)) ? n ? r(t) : a2(new Blob([t]), r) : r(oi[e] + (t || "")), a2 = (e, t) => {
  const n = new FileReader();
  return n.onload = function() {
    const r = n.result.split(",")[1];
    t("b" + (r || ""));
  }, n.readAsDataURL(e);
};
function s2(e) {
  return e instanceof Uint8Array ? e : e instanceof ArrayBuffer ? new Uint8Array(e) : new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
}
let sh;
function mV(e, t) {
  if ($5 && e.data instanceof Blob)
    return e.data.arrayBuffer().then(s2).then(t);
  if (O5 && (e.data instanceof ArrayBuffer || M5(e.data)))
    return t(s2(e.data));
  O1(e, !1, (n) => {
    sh || (sh = new TextEncoder()), t(sh.encode(n));
  });
}
const l2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Is = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (let e = 0; e < l2.length; e++)
  Is[l2.charCodeAt(e)] = e;
const gV = (e) => {
  let t = e.length * 0.75, n = e.length, r, i = 0, o, a, s, c;
  e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
  const f = new ArrayBuffer(t), p = new Uint8Array(f);
  for (r = 0; r < n; r += 4)
    o = Is[e.charCodeAt(r)], a = Is[e.charCodeAt(r + 1)], s = Is[e.charCodeAt(r + 2)], c = Is[e.charCodeAt(r + 3)], p[i++] = o << 2 | a >> 4, p[i++] = (a & 15) << 4 | s >> 2, p[i++] = (s & 3) << 6 | c & 63;
  return f;
}, vV = typeof ArrayBuffer == "function", M1 = (e, t) => {
  if (typeof e != "string")
    return {
      type: "message",
      data: D5(e, t)
    };
  const n = e.charAt(0);
  return n === "b" ? {
    type: "message",
    data: wV(e.substring(1), t)
  } : wu[n] ? e.length > 1 ? {
    type: wu[n],
    data: e.substring(1)
  } : {
    type: wu[n]
  } : Tm;
}, wV = (e, t) => {
  if (vV) {
    const n = gV(e);
    return D5(n, t);
  } else
    return { base64: !0, data: e };
}, D5 = (e, t) => {
  switch (t) {
    case "blob":
      return e instanceof Blob ? e : new Blob([e]);
    case "arraybuffer":
    default:
      return e instanceof ArrayBuffer ? e : e.buffer;
  }
}, N5 = String.fromCharCode(30), yV = (e, t) => {
  const n = e.length, r = new Array(n);
  let i = 0;
  e.forEach((o, a) => {
    O1(o, !1, (s) => {
      r[a] = s, ++i === n && t(r.join(N5));
    });
  });
}, bV = (e, t) => {
  const n = e.split(N5), r = [];
  for (let i = 0; i < n.length; i++) {
    const o = M1(n[i], t);
    if (r.push(o), o.type === "error")
      break;
  }
  return r;
};
function xV() {
  return new TransformStream({
    transform(e, t) {
      mV(e, (n) => {
        const r = n.length;
        let i;
        if (r < 126)
          i = new Uint8Array(1), new DataView(i.buffer).setUint8(0, r);
        else if (r < 65536) {
          i = new Uint8Array(3);
          const o = new DataView(i.buffer);
          o.setUint8(0, 126), o.setUint16(1, r);
        } else {
          i = new Uint8Array(9);
          const o = new DataView(i.buffer);
          o.setUint8(0, 127), o.setBigUint64(1, BigInt(r));
        }
        e.data && typeof e.data != "string" && (i[0] |= 128), t.enqueue(i), t.enqueue(n);
      });
    }
  });
}
let lh;
function qc(e) {
  return e.reduce((t, n) => t + n.length, 0);
}
function Gc(e, t) {
  if (e[0].length === t)
    return e.shift();
  const n = new Uint8Array(t);
  let r = 0;
  for (let i = 0; i < t; i++)
    n[i] = e[0][r++], r === e[0].length && (e.shift(), r = 0);
  return e.length && r < e[0].length && (e[0] = e[0].slice(r)), n;
}
function EV(e, t) {
  lh || (lh = new TextDecoder());
  const n = [];
  let r = 0, i = -1, o = !1;
  return new TransformStream({
    transform(a, s) {
      for (n.push(a); ; ) {
        if (r === 0) {
          if (qc(n) < 1)
            break;
          const c = Gc(n, 1);
          o = (c[0] & 128) === 128, i = c[0] & 127, i < 126 ? r = 3 : i === 126 ? r = 1 : r = 2;
        } else if (r === 1) {
          if (qc(n) < 2)
            break;
          const c = Gc(n, 2);
          i = new DataView(c.buffer, c.byteOffset, c.length).getUint16(0), r = 3;
        } else if (r === 2) {
          if (qc(n) < 8)
            break;
          const c = Gc(n, 8), f = new DataView(c.buffer, c.byteOffset, c.length), p = f.getUint32(0);
          if (p > Math.pow(2, 53 - 32) - 1) {
            s.enqueue(Tm);
            break;
          }
          i = p * Math.pow(2, 32) + f.getUint32(4), r = 3;
        } else {
          if (qc(n) < i)
            break;
          const c = Gc(n, i);
          s.enqueue(M1(o ? c : lh.decode(c), t)), r = 0;
        }
        if (i === 0 || i > e) {
          s.enqueue(Tm);
          break;
        }
      }
    }
  });
}
const I5 = 4;
function Zt(e) {
  if (e)
    return CV(e);
}
function CV(e) {
  for (var t in Zt.prototype)
    e[t] = Zt.prototype[t];
  return e;
}
Zt.prototype.on = Zt.prototype.addEventListener = function(e, t) {
  return this._callbacks = this._callbacks || {}, (this._callbacks["$" + e] = this._callbacks["$" + e] || []).push(t), this;
};
Zt.prototype.once = function(e, t) {
  function n() {
    this.off(e, n), t.apply(this, arguments);
  }
  return n.fn = t, this.on(e, n), this;
};
Zt.prototype.off = Zt.prototype.removeListener = Zt.prototype.removeAllListeners = Zt.prototype.removeEventListener = function(e, t) {
  if (this._callbacks = this._callbacks || {}, arguments.length == 0)
    return this._callbacks = {}, this;
  var n = this._callbacks["$" + e];
  if (!n)
    return this;
  if (arguments.length == 1)
    return delete this._callbacks["$" + e], this;
  for (var r, i = 0; i < n.length; i++)
    if (r = n[i], r === t || r.fn === t) {
      n.splice(i, 1);
      break;
    }
  return n.length === 0 && delete this._callbacks["$" + e], this;
};
Zt.prototype.emit = function(e) {
  this._callbacks = this._callbacks || {};
  for (var t = new Array(arguments.length - 1), n = this._callbacks["$" + e], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  if (n) {
    n = n.slice(0);
    for (var r = 0, i = n.length; r < i; ++r)
      n[r].apply(this, t);
  }
  return this;
};
Zt.prototype.emitReserved = Zt.prototype.emit;
Zt.prototype.listeners = function(e) {
  return this._callbacks = this._callbacks || {}, this._callbacks["$" + e] || [];
};
Zt.prototype.hasListeners = function(e) {
  return !!this.listeners(e).length;
};
const vr = (() => typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")())();
function L5(e, ...t) {
  return t.reduce((n, r) => (e.hasOwnProperty(r) && (n[r] = e[r]), n), {});
}
const SV = vr.setTimeout, _V = vr.clearTimeout;
function zf(e, t) {
  t.useNativeTimers ? (e.setTimeoutFn = SV.bind(vr), e.clearTimeoutFn = _V.bind(vr)) : (e.setTimeoutFn = vr.setTimeout.bind(vr), e.clearTimeoutFn = vr.clearTimeout.bind(vr));
}
const TV = 1.33;
function kV(e) {
  return typeof e == "string" ? PV(e) : Math.ceil((e.byteLength || e.size) * TV);
}
function PV(e) {
  let t = 0, n = 0;
  for (let r = 0, i = e.length; r < i; r++)
    t = e.charCodeAt(r), t < 128 ? n += 1 : t < 2048 ? n += 2 : t < 55296 || t >= 57344 ? n += 3 : (r++, n += 4);
  return n;
}
function AV(e) {
  let t = "";
  for (let n in e)
    e.hasOwnProperty(n) && (t.length && (t += "&"), t += encodeURIComponent(n) + "=" + encodeURIComponent(e[n]));
  return t;
}
function RV(e) {
  let t = {}, n = e.split("&");
  for (let r = 0, i = n.length; r < i; r++) {
    let o = n[r].split("=");
    t[decodeURIComponent(o[0])] = decodeURIComponent(o[1]);
  }
  return t;
}
class $V extends Error {
  constructor(t, n, r) {
    super(t), this.description = n, this.context = r, this.type = "TransportError";
  }
}
class D1 extends Zt {
  /**
   * Transport abstract constructor.
   *
   * @param {Object} opts - options
   * @protected
   */
  constructor(t) {
    super(), this.writable = !1, zf(this, t), this.opts = t, this.query = t.query, this.socket = t.socket;
  }
  /**
   * Emits an error.
   *
   * @param {String} reason
   * @param description
   * @param context - the error context
   * @return {Transport} for chaining
   * @protected
   */
  onError(t, n, r) {
    return super.emitReserved("error", new $V(t, n, r)), this;
  }
  /**
   * Opens the transport.
   */
  open() {
    return this.readyState = "opening", this.doOpen(), this;
  }
  /**
   * Closes the transport.
   */
  close() {
    return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
  }
  /**
   * Sends multiple packets.
   *
   * @param {Array} packets
   */
  send(t) {
    this.readyState === "open" && this.write(t);
  }
  /**
   * Called upon open
   *
   * @protected
   */
  onOpen() {
    this.readyState = "open", this.writable = !0, super.emitReserved("open");
  }
  /**
   * Called with data.
   *
   * @param {String} data
   * @protected
   */
  onData(t) {
    const n = M1(t, this.socket.binaryType);
    this.onPacket(n);
  }
  /**
   * Called with a decoded packet.
   *
   * @protected
   */
  onPacket(t) {
    super.emitReserved("packet", t);
  }
  /**
   * Called upon close.
   *
   * @protected
   */
  onClose(t) {
    this.readyState = "closed", super.emitReserved("close", t);
  }
  /**
   * Pauses the transport, in order not to lose packets during an upgrade.
   *
   * @param onPause
   */
  pause(t) {
  }
  createUri(t, n = {}) {
    return t + "://" + this._hostname() + this._port() + this.opts.path + this._query(n);
  }
  _hostname() {
    const t = this.opts.hostname;
    return t.indexOf(":") === -1 ? t : "[" + t + "]";
  }
  _port() {
    return this.opts.port && (this.opts.secure && +(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80) ? ":" + this.opts.port : "";
  }
  _query(t) {
    const n = AV(t);
    return n.length ? "?" + n : "";
  }
}
const F5 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), km = 64, OV = {};
let c2 = 0, Yc = 0, u2;
function f2(e) {
  let t = "";
  do
    t = F5[e % km] + t, e = Math.floor(e / km);
  while (e > 0);
  return t;
}
function z5() {
  const e = f2(+/* @__PURE__ */ new Date());
  return e !== u2 ? (c2 = 0, u2 = e) : e + "." + f2(c2++);
}
for (; Yc < km; Yc++)
  OV[F5[Yc]] = Yc;
let V5 = !1;
try {
  V5 = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
} catch {
}
const MV = V5;
function B5(e) {
  const t = e.xdomain;
  try {
    if (typeof XMLHttpRequest < "u" && (!t || MV))
      return new XMLHttpRequest();
  } catch {
  }
  if (!t)
    try {
      return new vr[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch {
    }
}
function DV() {
}
const NV = function() {
  return new B5({
    xdomain: !1
  }).responseType != null;
}();
class IV extends D1 {
  /**
   * XHR Polling constructor.
   *
   * @param {Object} opts
   * @package
   */
  constructor(t) {
    if (super(t), this.polling = !1, typeof location < "u") {
      const r = location.protocol === "https:";
      let i = location.port;
      i || (i = r ? "443" : "80"), this.xd = typeof location < "u" && t.hostname !== location.hostname || i !== t.port;
    }
    const n = t && t.forceBase64;
    this.supportsBinary = NV && !n, this.opts.withCredentials && (this.cookieJar = void 0);
  }
  get name() {
    return "polling";
  }
  /**
   * Opens the socket (triggers polling). We write a PING message to determine
   * when the transport is open.
   *
   * @protected
   */
  doOpen() {
    this.poll();
  }
  /**
   * Pauses polling.
   *
   * @param {Function} onPause - callback upon buffers are flushed and transport is paused
   * @package
   */
  pause(t) {
    this.readyState = "pausing";
    const n = () => {
      this.readyState = "paused", t();
    };
    if (this.polling || !this.writable) {
      let r = 0;
      this.polling && (r++, this.once("pollComplete", function() {
        --r || n();
      })), this.writable || (r++, this.once("drain", function() {
        --r || n();
      }));
    } else
      n();
  }
  /**
   * Starts polling cycle.
   *
   * @private
   */
  poll() {
    this.polling = !0, this.doPoll(), this.emitReserved("poll");
  }
  /**
   * Overloads onData to detect payloads.
   *
   * @protected
   */
  onData(t) {
    const n = (r) => {
      if (this.readyState === "opening" && r.type === "open" && this.onOpen(), r.type === "close")
        return this.onClose({ description: "transport closed by the server" }), !1;
      this.onPacket(r);
    };
    bV(t, this.socket.binaryType).forEach(n), this.readyState !== "closed" && (this.polling = !1, this.emitReserved("pollComplete"), this.readyState === "open" && this.poll());
  }
  /**
   * For polling, send a close packet.
   *
   * @protected
   */
  doClose() {
    const t = () => {
      this.write([{ type: "close" }]);
    };
    this.readyState === "open" ? t() : this.once("open", t);
  }
  /**
   * Writes a packets payload.
   *
   * @param {Array} packets - data packets
   * @protected
   */
  write(t) {
    this.writable = !1, yV(t, (n) => {
      this.doWrite(n, () => {
        this.writable = !0, this.emitReserved("drain");
      });
    });
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const t = this.opts.secure ? "https" : "http", n = this.query || {};
    return this.opts.timestampRequests !== !1 && (n[this.opts.timestampParam] = z5()), !this.supportsBinary && !n.sid && (n.b64 = 1), this.createUri(t, n);
  }
  /**
   * Creates a request.
   *
   * @param {String} method
   * @private
   */
  request(t = {}) {
    return Object.assign(t, { xd: this.xd, cookieJar: this.cookieJar }, this.opts), new Ma(this.uri(), t);
  }
  /**
   * Sends data.
   *
   * @param {String} data to send.
   * @param {Function} called upon flush.
   * @private
   */
  doWrite(t, n) {
    const r = this.request({
      method: "POST",
      data: t
    });
    r.on("success", n), r.on("error", (i, o) => {
      this.onError("xhr post error", i, o);
    });
  }
  /**
   * Starts a poll cycle.
   *
   * @private
   */
  doPoll() {
    const t = this.request();
    t.on("data", this.onData.bind(this)), t.on("error", (n, r) => {
      this.onError("xhr poll error", n, r);
    }), this.pollXhr = t;
  }
}
let Ma = class yu extends Zt {
  /**
   * Request constructor
   *
   * @param {Object} options
   * @package
   */
  constructor(t, n) {
    super(), zf(this, n), this.opts = n, this.method = n.method || "GET", this.uri = t, this.data = n.data !== void 0 ? n.data : null, this.create();
  }
  /**
   * Creates the XHR object and sends the request.
   *
   * @private
   */
  create() {
    var t;
    const n = L5(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
    n.xdomain = !!this.opts.xd;
    const r = this.xhr = new B5(n);
    try {
      r.open(this.method, this.uri, !0);
      try {
        if (this.opts.extraHeaders) {
          r.setDisableHeaderCheck && r.setDisableHeaderCheck(!0);
          for (let i in this.opts.extraHeaders)
            this.opts.extraHeaders.hasOwnProperty(i) && r.setRequestHeader(i, this.opts.extraHeaders[i]);
        }
      } catch {
      }
      if (this.method === "POST")
        try {
          r.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch {
        }
      try {
        r.setRequestHeader("Accept", "*/*");
      } catch {
      }
      (t = this.opts.cookieJar) === null || t === void 0 || t.addCookies(r), "withCredentials" in r && (r.withCredentials = this.opts.withCredentials), this.opts.requestTimeout && (r.timeout = this.opts.requestTimeout), r.onreadystatechange = () => {
        var i;
        r.readyState === 3 && ((i = this.opts.cookieJar) === null || i === void 0 || i.parseCookies(r)), r.readyState === 4 && (r.status === 200 || r.status === 1223 ? this.onLoad() : this.setTimeoutFn(() => {
          this.onError(typeof r.status == "number" ? r.status : 0);
        }, 0));
      }, r.send(this.data);
    } catch (i) {
      this.setTimeoutFn(() => {
        this.onError(i);
      }, 0);
      return;
    }
    typeof document < "u" && (this.index = yu.requestsCount++, yu.requests[this.index] = this);
  }
  /**
   * Called upon error.
   *
   * @private
   */
  onError(t) {
    this.emitReserved("error", t, this.xhr), this.cleanup(!0);
  }
  /**
   * Cleans up house.
   *
   * @private
   */
  cleanup(t) {
    if (!(typeof this.xhr > "u" || this.xhr === null)) {
      if (this.xhr.onreadystatechange = DV, t)
        try {
          this.xhr.abort();
        } catch {
        }
      typeof document < "u" && delete yu.requests[this.index], this.xhr = null;
    }
  }
  /**
   * Called upon load.
   *
   * @private
   */
  onLoad() {
    const t = this.xhr.responseText;
    t !== null && (this.emitReserved("data", t), this.emitReserved("success"), this.cleanup());
  }
  /**
   * Aborts the request.
   *
   * @package
   */
  abort() {
    this.cleanup();
  }
};
Ma.requestsCount = 0;
Ma.requests = {};
if (typeof document < "u") {
  if (typeof attachEvent == "function")
    attachEvent("onunload", d2);
  else if (typeof addEventListener == "function") {
    const e = "onpagehide" in vr ? "pagehide" : "unload";
    addEventListener(e, d2, !1);
  }
}
function d2() {
  for (let e in Ma.requests)
    Ma.requests.hasOwnProperty(e) && Ma.requests[e].abort();
}
const N1 = (() => typeof Promise == "function" && typeof Promise.resolve == "function" ? (t) => Promise.resolve().then(t) : (t, n) => n(t, 0))(), Kc = vr.WebSocket || vr.MozWebSocket, p2 = !0, LV = "arraybuffer", h2 = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative";
class FV extends D1 {
  /**
   * WebSocket transport constructor.
   *
   * @param {Object} opts - connection options
   * @protected
   */
  constructor(t) {
    super(t), this.supportsBinary = !t.forceBase64;
  }
  get name() {
    return "websocket";
  }
  doOpen() {
    if (!this.check())
      return;
    const t = this.uri(), n = this.opts.protocols, r = h2 ? {} : L5(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
    this.opts.extraHeaders && (r.headers = this.opts.extraHeaders);
    try {
      this.ws = p2 && !h2 ? n ? new Kc(t, n) : new Kc(t) : new Kc(t, n, r);
    } catch (i) {
      return this.emitReserved("error", i);
    }
    this.ws.binaryType = this.socket.binaryType, this.addEventListeners();
  }
  /**
   * Adds event listeners to the socket
   *
   * @private
   */
  addEventListeners() {
    this.ws.onopen = () => {
      this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
    }, this.ws.onclose = (t) => this.onClose({
      description: "websocket connection closed",
      context: t
    }), this.ws.onmessage = (t) => this.onData(t.data), this.ws.onerror = (t) => this.onError("websocket error", t);
  }
  write(t) {
    this.writable = !1;
    for (let n = 0; n < t.length; n++) {
      const r = t[n], i = n === t.length - 1;
      O1(r, this.supportsBinary, (o) => {
        const a = {};
        try {
          p2 && this.ws.send(o);
        } catch {
        }
        i && N1(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    typeof this.ws < "u" && (this.ws.close(), this.ws = null);
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const t = this.opts.secure ? "wss" : "ws", n = this.query || {};
    return this.opts.timestampRequests && (n[this.opts.timestampParam] = z5()), this.supportsBinary || (n.b64 = 1), this.createUri(t, n);
  }
  /**
   * Feature detection for WebSocket.
   *
   * @return {Boolean} whether this transport is available.
   * @private
   */
  check() {
    return !!Kc;
  }
}
class zV extends D1 {
  get name() {
    return "webtransport";
  }
  doOpen() {
    typeof WebTransport == "function" && (this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]), this.transport.closed.then(() => {
      this.onClose();
    }).catch((t) => {
      this.onError("webtransport error", t);
    }), this.transport.ready.then(() => {
      this.transport.createBidirectionalStream().then((t) => {
        const n = EV(Number.MAX_SAFE_INTEGER, this.socket.binaryType), r = t.readable.pipeThrough(n).getReader(), i = xV();
        i.readable.pipeTo(t.writable), this.writer = i.writable.getWriter();
        const o = () => {
          r.read().then(({ done: s, value: c }) => {
            s || (this.onPacket(c), o());
          }).catch((s) => {
          });
        };
        o();
        const a = { type: "open" };
        this.query.sid && (a.data = `{"sid":"${this.query.sid}"}`), this.writer.write(a).then(() => this.onOpen());
      });
    }));
  }
  write(t) {
    this.writable = !1;
    for (let n = 0; n < t.length; n++) {
      const r = t[n], i = n === t.length - 1;
      this.writer.write(r).then(() => {
        i && N1(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    var t;
    (t = this.transport) === null || t === void 0 || t.close();
  }
}
const VV = {
  websocket: FV,
  webtransport: zV,
  polling: IV
}, BV = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, HV = [
  "source",
  "protocol",
  "authority",
  "userInfo",
  "user",
  "password",
  "host",
  "port",
  "relative",
  "path",
  "directory",
  "file",
  "query",
  "anchor"
];
function Pm(e) {
  if (e.length > 2e3)
    throw "URI too long";
  const t = e, n = e.indexOf("["), r = e.indexOf("]");
  n != -1 && r != -1 && (e = e.substring(0, n) + e.substring(n, r).replace(/:/g, ";") + e.substring(r, e.length));
  let i = BV.exec(e || ""), o = {}, a = 14;
  for (; a--; )
    o[HV[a]] = i[a] || "";
  return n != -1 && r != -1 && (o.source = t, o.host = o.host.substring(1, o.host.length - 1).replace(/;/g, ":"), o.authority = o.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), o.ipv6uri = !0), o.pathNames = UV(o, o.path), o.queryKey = WV(o, o.query), o;
}
function UV(e, t) {
  const n = /\/{2,9}/g, r = t.replace(n, "/").split("/");
  return (t.slice(0, 1) == "/" || t.length === 0) && r.splice(0, 1), t.slice(-1) == "/" && r.splice(r.length - 1, 1), r;
}
function WV(e, t) {
  const n = {};
  return t.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(r, i, o) {
    i && (n[i] = o);
  }), n;
}
let H5 = class Ca extends Zt {
  /**
   * Socket constructor.
   *
   * @param {String|Object} uri - uri or options
   * @param {Object} opts - options
   */
  constructor(t, n = {}) {
    super(), this.binaryType = LV, this.writeBuffer = [], t && typeof t == "object" && (n = t, t = null), t ? (t = Pm(t), n.hostname = t.host, n.secure = t.protocol === "https" || t.protocol === "wss", n.port = t.port, t.query && (n.query = t.query)) : n.host && (n.hostname = Pm(n.host).host), zf(this, n), this.secure = n.secure != null ? n.secure : typeof location < "u" && location.protocol === "https:", n.hostname && !n.port && (n.port = this.secure ? "443" : "80"), this.hostname = n.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = n.port || (typeof location < "u" && location.port ? location.port : this.secure ? "443" : "80"), this.transports = n.transports || [
      "polling",
      "websocket",
      "webtransport"
    ], this.writeBuffer = [], this.prevBufferLen = 0, this.opts = Object.assign({
      path: "/engine.io",
      agent: !1,
      withCredentials: !1,
      upgrade: !0,
      timestampParam: "t",
      rememberUpgrade: !1,
      addTrailingSlash: !0,
      rejectUnauthorized: !0,
      perMessageDeflate: {
        threshold: 1024
      },
      transportOptions: {},
      closeOnBeforeunload: !1
    }, n), this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : ""), typeof this.opts.query == "string" && (this.opts.query = RV(this.opts.query)), this.id = null, this.upgrades = null, this.pingInterval = null, this.pingTimeout = null, this.pingTimeoutTimer = null, typeof addEventListener == "function" && (this.opts.closeOnBeforeunload && (this.beforeunloadEventListener = () => {
      this.transport && (this.transport.removeAllListeners(), this.transport.close());
    }, addEventListener("beforeunload", this.beforeunloadEventListener, !1)), this.hostname !== "localhost" && (this.offlineEventListener = () => {
      this.onClose("transport close", {
        description: "network connection lost"
      });
    }, addEventListener("offline", this.offlineEventListener, !1))), this.open();
  }
  /**
   * Creates transport of the given type.
   *
   * @param {String} name - transport name
   * @return {Transport}
   * @private
   */
  createTransport(t) {
    const n = Object.assign({}, this.opts.query);
    n.EIO = I5, n.transport = t, this.id && (n.sid = this.id);
    const r = Object.assign({}, this.opts, {
      query: n,
      socket: this,
      hostname: this.hostname,
      secure: this.secure,
      port: this.port
    }, this.opts.transportOptions[t]);
    return new VV[t](r);
  }
  /**
   * Initializes transport to use and starts probe.
   *
   * @private
   */
  open() {
    let t;
    if (this.opts.rememberUpgrade && Ca.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1)
      t = "websocket";
    else if (this.transports.length === 0) {
      this.setTimeoutFn(() => {
        this.emitReserved("error", "No transports available");
      }, 0);
      return;
    } else
      t = this.transports[0];
    this.readyState = "opening";
    try {
      t = this.createTransport(t);
    } catch {
      this.transports.shift(), this.open();
      return;
    }
    t.open(), this.setTransport(t);
  }
  /**
   * Sets the current transport. Disables the existing one (if any).
   *
   * @private
   */
  setTransport(t) {
    this.transport && this.transport.removeAllListeners(), this.transport = t, t.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (n) => this.onClose("transport close", n));
  }
  /**
   * Probes a transport.
   *
   * @param {String} name - transport name
   * @private
   */
  probe(t) {
    let n = this.createTransport(t), r = !1;
    Ca.priorWebsocketSuccess = !1;
    const i = () => {
      r || (n.send([{ type: "ping", data: "probe" }]), n.once("packet", (d) => {
        if (!r)
          if (d.type === "pong" && d.data === "probe") {
            if (this.upgrading = !0, this.emitReserved("upgrading", n), !n)
              return;
            Ca.priorWebsocketSuccess = n.name === "websocket", this.transport.pause(() => {
              r || this.readyState !== "closed" && (p(), this.setTransport(n), n.send([{ type: "upgrade" }]), this.emitReserved("upgrade", n), n = null, this.upgrading = !1, this.flush());
            });
          } else {
            const h = new Error("probe error");
            h.transport = n.name, this.emitReserved("upgradeError", h);
          }
      }));
    };
    function o() {
      r || (r = !0, p(), n.close(), n = null);
    }
    const a = (d) => {
      const h = new Error("probe error: " + d);
      h.transport = n.name, o(), this.emitReserved("upgradeError", h);
    };
    function s() {
      a("transport closed");
    }
    function c() {
      a("socket closed");
    }
    function f(d) {
      n && d.name !== n.name && o();
    }
    const p = () => {
      n.removeListener("open", i), n.removeListener("error", a), n.removeListener("close", s), this.off("close", c), this.off("upgrading", f);
    };
    n.once("open", i), n.once("error", a), n.once("close", s), this.once("close", c), this.once("upgrading", f), this.upgrades.indexOf("webtransport") !== -1 && t !== "webtransport" ? this.setTimeoutFn(() => {
      r || n.open();
    }, 200) : n.open();
  }
  /**
   * Called when connection is deemed open.
   *
   * @private
   */
  onOpen() {
    if (this.readyState = "open", Ca.priorWebsocketSuccess = this.transport.name === "websocket", this.emitReserved("open"), this.flush(), this.readyState === "open" && this.opts.upgrade) {
      let t = 0;
      const n = this.upgrades.length;
      for (; t < n; t++)
        this.probe(this.upgrades[t]);
    }
  }
  /**
   * Handles a packet.
   *
   * @private
   */
  onPacket(t) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
      switch (this.emitReserved("packet", t), this.emitReserved("heartbeat"), this.resetPingTimeout(), t.type) {
        case "open":
          this.onHandshake(JSON.parse(t.data));
          break;
        case "ping":
          this.sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong");
          break;
        case "error":
          const n = new Error("server error");
          n.code = t.data, this.onError(n);
          break;
        case "message":
          this.emitReserved("data", t.data), this.emitReserved("message", t.data);
          break;
      }
  }
  /**
   * Called upon handshake completion.
   *
   * @param {Object} data - handshake obj
   * @private
   */
  onHandshake(t) {
    this.emitReserved("handshake", t), this.id = t.sid, this.transport.query.sid = t.sid, this.upgrades = this.filterUpgrades(t.upgrades), this.pingInterval = t.pingInterval, this.pingTimeout = t.pingTimeout, this.maxPayload = t.maxPayload, this.onOpen(), this.readyState !== "closed" && this.resetPingTimeout();
  }
  /**
   * Sets and resets ping timeout timer based on server pings.
   *
   * @private
   */
  resetPingTimeout() {
    this.clearTimeoutFn(this.pingTimeoutTimer), this.pingTimeoutTimer = this.setTimeoutFn(() => {
      this.onClose("ping timeout");
    }, this.pingInterval + this.pingTimeout), this.opts.autoUnref && this.pingTimeoutTimer.unref();
  }
  /**
   * Called on `drain` event
   *
   * @private
   */
  onDrain() {
    this.writeBuffer.splice(0, this.prevBufferLen), this.prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emitReserved("drain") : this.flush();
  }
  /**
   * Flush write buffers.
   *
   * @private
   */
  flush() {
    if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
      const t = this.getWritablePackets();
      this.transport.send(t), this.prevBufferLen = t.length, this.emitReserved("flush");
    }
  }
  /**
   * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
   * long-polling)
   *
   * @private
   */
  getWritablePackets() {
    if (!(this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1))
      return this.writeBuffer;
    let n = 1;
    for (let r = 0; r < this.writeBuffer.length; r++) {
      const i = this.writeBuffer[r].data;
      if (i && (n += kV(i)), r > 0 && n > this.maxPayload)
        return this.writeBuffer.slice(0, r);
      n += 2;
    }
    return this.writeBuffer;
  }
  /**
   * Sends a message.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} callback function.
   * @return {Socket} for chaining.
   */
  write(t, n, r) {
    return this.sendPacket("message", t, n, r), this;
  }
  send(t, n, r) {
    return this.sendPacket("message", t, n, r), this;
  }
  /**
   * Sends a packet.
   *
   * @param {String} type: packet type.
   * @param {String} data.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @private
   */
  sendPacket(t, n, r, i) {
    if (typeof n == "function" && (i = n, n = void 0), typeof r == "function" && (i = r, r = null), this.readyState === "closing" || this.readyState === "closed")
      return;
    r = r || {}, r.compress = r.compress !== !1;
    const o = {
      type: t,
      data: n,
      options: r
    };
    this.emitReserved("packetCreate", o), this.writeBuffer.push(o), i && this.once("flush", i), this.flush();
  }
  /**
   * Closes the connection.
   */
  close() {
    const t = () => {
      this.onClose("forced close"), this.transport.close();
    }, n = () => {
      this.off("upgrade", n), this.off("upgradeError", n), t();
    }, r = () => {
      this.once("upgrade", n), this.once("upgradeError", n);
    };
    return (this.readyState === "opening" || this.readyState === "open") && (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", () => {
      this.upgrading ? r() : t();
    }) : this.upgrading ? r() : t()), this;
  }
  /**
   * Called upon transport error
   *
   * @private
   */
  onError(t) {
    Ca.priorWebsocketSuccess = !1, this.emitReserved("error", t), this.onClose("transport error", t);
  }
  /**
   * Called upon transport close.
   *
   * @private
   */
  onClose(t, n) {
    (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") && (this.clearTimeoutFn(this.pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), typeof removeEventListener == "function" && (removeEventListener("beforeunload", this.beforeunloadEventListener, !1), removeEventListener("offline", this.offlineEventListener, !1)), this.readyState = "closed", this.id = null, this.emitReserved("close", t, n), this.writeBuffer = [], this.prevBufferLen = 0);
  }
  /**
   * Filters upgrades, returning only those matching client transports.
   *
   * @param {Array} upgrades - server upgrades
   * @private
   */
  filterUpgrades(t) {
    const n = [];
    let r = 0;
    const i = t.length;
    for (; r < i; r++)
      ~this.transports.indexOf(t[r]) && n.push(t[r]);
    return n;
  }
};
H5.protocol = I5;
function jV(e, t = "", n) {
  let r = e;
  n = n || typeof location < "u" && location, e == null && (e = n.protocol + "//" + n.host), typeof e == "string" && (e.charAt(0) === "/" && (e.charAt(1) === "/" ? e = n.protocol + e : e = n.host + e), /^(https?|wss?):\/\//.test(e) || (typeof n < "u" ? e = n.protocol + "//" + e : e = "https://" + e), r = Pm(e)), r.port || (/^(http|ws)$/.test(r.protocol) ? r.port = "80" : /^(http|ws)s$/.test(r.protocol) && (r.port = "443")), r.path = r.path || "/";
  const o = r.host.indexOf(":") !== -1 ? "[" + r.host + "]" : r.host;
  return r.id = r.protocol + "://" + o + ":" + r.port + t, r.href = r.protocol + "://" + o + (n && n.port === r.port ? "" : ":" + r.port), r;
}
const qV = typeof ArrayBuffer == "function", GV = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e.buffer instanceof ArrayBuffer, U5 = Object.prototype.toString, YV = typeof Blob == "function" || typeof Blob < "u" && U5.call(Blob) === "[object BlobConstructor]", KV = typeof File == "function" || typeof File < "u" && U5.call(File) === "[object FileConstructor]";
function I1(e) {
  return qV && (e instanceof ArrayBuffer || GV(e)) || YV && e instanceof Blob || KV && e instanceof File;
}
function bu(e, t) {
  if (!e || typeof e != "object")
    return !1;
  if (Array.isArray(e)) {
    for (let n = 0, r = e.length; n < r; n++)
      if (bu(e[n]))
        return !0;
    return !1;
  }
  if (I1(e))
    return !0;
  if (e.toJSON && typeof e.toJSON == "function" && arguments.length === 1)
    return bu(e.toJSON(), !0);
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && bu(e[n]))
      return !0;
  return !1;
}
function XV(e) {
  const t = [], n = e.data, r = e;
  return r.data = Am(n, t), r.attachments = t.length, { packet: r, buffers: t };
}
function Am(e, t) {
  if (!e)
    return e;
  if (I1(e)) {
    const n = { _placeholder: !0, num: t.length };
    return t.push(e), n;
  } else if (Array.isArray(e)) {
    const n = new Array(e.length);
    for (let r = 0; r < e.length; r++)
      n[r] = Am(e[r], t);
    return n;
  } else if (typeof e == "object" && !(e instanceof Date)) {
    const n = {};
    for (const r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (n[r] = Am(e[r], t));
    return n;
  }
  return e;
}
function QV(e, t) {
  return e.data = Rm(e.data, t), delete e.attachments, e;
}
function Rm(e, t) {
  if (!e)
    return e;
  if (e && e._placeholder === !0) {
    if (typeof e.num == "number" && e.num >= 0 && e.num < t.length)
      return t[e.num];
    throw new Error("illegal attachments");
  } else if (Array.isArray(e))
    for (let n = 0; n < e.length; n++)
      e[n] = Rm(e[n], t);
  else if (typeof e == "object")
    for (const n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (e[n] = Rm(e[n], t));
  return e;
}
const ZV = [
  "connect",
  "connect_error",
  "disconnect",
  "disconnecting",
  "newListener",
  "removeListener"
  // used by the Node.js EventEmitter
], JV = 5;
var at;
(function(e) {
  e[e.CONNECT = 0] = "CONNECT", e[e.DISCONNECT = 1] = "DISCONNECT", e[e.EVENT = 2] = "EVENT", e[e.ACK = 3] = "ACK", e[e.CONNECT_ERROR = 4] = "CONNECT_ERROR", e[e.BINARY_EVENT = 5] = "BINARY_EVENT", e[e.BINARY_ACK = 6] = "BINARY_ACK";
})(at || (at = {}));
class eB {
  /**
   * Encoder constructor
   *
   * @param {function} replacer - custom replacer to pass down to JSON.parse
   */
  constructor(t) {
    this.replacer = t;
  }
  /**
   * Encode a packet as a single string if non-binary, or as a
   * buffer sequence, depending on packet type.
   *
   * @param {Object} obj - packet object
   */
  encode(t) {
    return (t.type === at.EVENT || t.type === at.ACK) && bu(t) ? this.encodeAsBinary({
      type: t.type === at.EVENT ? at.BINARY_EVENT : at.BINARY_ACK,
      nsp: t.nsp,
      data: t.data,
      id: t.id
    }) : [this.encodeAsString(t)];
  }
  /**
   * Encode packet as string.
   */
  encodeAsString(t) {
    let n = "" + t.type;
    return (t.type === at.BINARY_EVENT || t.type === at.BINARY_ACK) && (n += t.attachments + "-"), t.nsp && t.nsp !== "/" && (n += t.nsp + ","), t.id != null && (n += t.id), t.data != null && (n += JSON.stringify(t.data, this.replacer)), n;
  }
  /**
   * Encode packet as 'buffer sequence' by removing blobs, and
   * deconstructing packet into object with placeholders and
   * a list of buffers.
   */
  encodeAsBinary(t) {
    const n = XV(t), r = this.encodeAsString(n.packet), i = n.buffers;
    return i.unshift(r), i;
  }
}
function m2(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
class L1 extends Zt {
  /**
   * Decoder constructor
   *
   * @param {function} reviver - custom reviver to pass down to JSON.stringify
   */
  constructor(t) {
    super(), this.reviver = t;
  }
  /**
   * Decodes an encoded packet string into packet JSON.
   *
   * @param {String} obj - encoded packet
   */
  add(t) {
    let n;
    if (typeof t == "string") {
      if (this.reconstructor)
        throw new Error("got plaintext data when reconstructing a packet");
      n = this.decodeString(t);
      const r = n.type === at.BINARY_EVENT;
      r || n.type === at.BINARY_ACK ? (n.type = r ? at.EVENT : at.ACK, this.reconstructor = new tB(n), n.attachments === 0 && super.emitReserved("decoded", n)) : super.emitReserved("decoded", n);
    } else if (I1(t) || t.base64)
      if (this.reconstructor)
        n = this.reconstructor.takeBinaryData(t), n && (this.reconstructor = null, super.emitReserved("decoded", n));
      else
        throw new Error("got binary data when not reconstructing a packet");
    else
      throw new Error("Unknown type: " + t);
  }
  /**
   * Decode a packet String (JSON data)
   *
   * @param {String} str
   * @return {Object} packet
   */
  decodeString(t) {
    let n = 0;
    const r = {
      type: Number(t.charAt(0))
    };
    if (at[r.type] === void 0)
      throw new Error("unknown packet type " + r.type);
    if (r.type === at.BINARY_EVENT || r.type === at.BINARY_ACK) {
      const o = n + 1;
      for (; t.charAt(++n) !== "-" && n != t.length; )
        ;
      const a = t.substring(o, n);
      if (a != Number(a) || t.charAt(n) !== "-")
        throw new Error("Illegal attachments");
      r.attachments = Number(a);
    }
    if (t.charAt(n + 1) === "/") {
      const o = n + 1;
      for (; ++n && !(t.charAt(n) === "," || n === t.length); )
        ;
      r.nsp = t.substring(o, n);
    } else
      r.nsp = "/";
    const i = t.charAt(n + 1);
    if (i !== "" && Number(i) == i) {
      const o = n + 1;
      for (; ++n; ) {
        const a = t.charAt(n);
        if (a == null || Number(a) != a) {
          --n;
          break;
        }
        if (n === t.length)
          break;
      }
      r.id = Number(t.substring(o, n + 1));
    }
    if (t.charAt(++n)) {
      const o = this.tryParse(t.substr(n));
      if (L1.isPayloadValid(r.type, o))
        r.data = o;
      else
        throw new Error("invalid payload");
    }
    return r;
  }
  tryParse(t) {
    try {
      return JSON.parse(t, this.reviver);
    } catch {
      return !1;
    }
  }
  static isPayloadValid(t, n) {
    switch (t) {
      case at.CONNECT:
        return m2(n);
      case at.DISCONNECT:
        return n === void 0;
      case at.CONNECT_ERROR:
        return typeof n == "string" || m2(n);
      case at.EVENT:
      case at.BINARY_EVENT:
        return Array.isArray(n) && (typeof n[0] == "number" || typeof n[0] == "string" && ZV.indexOf(n[0]) === -1);
      case at.ACK:
      case at.BINARY_ACK:
        return Array.isArray(n);
    }
  }
  /**
   * Deallocates a parser's resources
   */
  destroy() {
    this.reconstructor && (this.reconstructor.finishedReconstruction(), this.reconstructor = null);
  }
}
class tB {
  constructor(t) {
    this.packet = t, this.buffers = [], this.reconPack = t;
  }
  /**
   * Method to be called when binary data received from connection
   * after a BINARY_EVENT packet.
   *
   * @param {Buffer | ArrayBuffer} binData - the raw binary data received
   * @return {null | Object} returns null if more binary data is expected or
   *   a reconstructed packet object if all buffers have been received.
   */
  takeBinaryData(t) {
    if (this.buffers.push(t), this.buffers.length === this.reconPack.attachments) {
      const n = QV(this.reconPack, this.buffers);
      return this.finishedReconstruction(), n;
    }
    return null;
  }
  /**
   * Cleans up binary packet reconstruction variables.
   */
  finishedReconstruction() {
    this.reconPack = null, this.buffers = [];
  }
}
const nB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Decoder: L1,
  Encoder: eB,
  get PacketType() {
    return at;
  },
  protocol: JV
}, Symbol.toStringTag, { value: "Module" }));
function Lr(e, t, n) {
  return e.on(t, n), function() {
    e.off(t, n);
  };
}
const rB = Object.freeze({
  connect: 1,
  connect_error: 1,
  disconnect: 1,
  disconnecting: 1,
  // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
  newListener: 1,
  removeListener: 1
});
class W5 extends Zt {
  /**
   * `Socket` constructor.
   */
  constructor(t, n, r) {
    super(), this.connected = !1, this.recovered = !1, this.receiveBuffer = [], this.sendBuffer = [], this._queue = [], this._queueSeq = 0, this.ids = 0, this.acks = {}, this.flags = {}, this.io = t, this.nsp = n, r && r.auth && (this.auth = r.auth), this._opts = Object.assign({}, r), this.io._autoConnect && this.open();
  }
  /**
   * Whether the socket is currently disconnected
   *
   * @example
   * const socket = io();
   *
   * socket.on("connect", () => {
   *   console.log(socket.disconnected); // false
   * });
   *
   * socket.on("disconnect", () => {
   *   console.log(socket.disconnected); // true
   * });
   */
  get disconnected() {
    return !this.connected;
  }
  /**
   * Subscribe to open, close and packet events
   *
   * @private
   */
  subEvents() {
    if (this.subs)
      return;
    const t = this.io;
    this.subs = [
      Lr(t, "open", this.onopen.bind(this)),
      Lr(t, "packet", this.onpacket.bind(this)),
      Lr(t, "error", this.onerror.bind(this)),
      Lr(t, "close", this.onclose.bind(this))
    ];
  }
  /**
   * Whether the Socket will try to reconnect when its Manager connects or reconnects.
   *
   * @example
   * const socket = io();
   *
   * console.log(socket.active); // true
   *
   * socket.on("disconnect", (reason) => {
   *   if (reason === "io server disconnect") {
   *     // the disconnection was initiated by the server, you need to manually reconnect
   *     console.log(socket.active); // false
   *   }
   *   // else the socket will automatically try to reconnect
   *   console.log(socket.active); // true
   * });
   */
  get active() {
    return !!this.subs;
  }
  /**
   * "Opens" the socket.
   *
   * @example
   * const socket = io({
   *   autoConnect: false
   * });
   *
   * socket.connect();
   */
  connect() {
    return this.connected ? this : (this.subEvents(), this.io._reconnecting || this.io.open(), this.io._readyState === "open" && this.onopen(), this);
  }
  /**
   * Alias for {@link connect()}.
   */
  open() {
    return this.connect();
  }
  /**
   * Sends a `message` event.
   *
   * This method mimics the WebSocket.send() method.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
   *
   * @example
   * socket.send("hello");
   *
   * // this is equivalent to
   * socket.emit("message", "hello");
   *
   * @return self
   */
  send(...t) {
    return t.unshift("message"), this.emit.apply(this, t), this;
  }
  /**
   * Override `emit`.
   * If the event is in `events`, it's emitted normally.
   *
   * @example
   * socket.emit("hello", "world");
   *
   * // all serializable datastructures are supported (no need to call JSON.stringify)
   * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
   *
   * // with an acknowledgement from the server
   * socket.emit("hello", "world", (val) => {
   *   // ...
   * });
   *
   * @return self
   */
  emit(t, ...n) {
    if (rB.hasOwnProperty(t))
      throw new Error('"' + t.toString() + '" is a reserved event name');
    if (n.unshift(t), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile)
      return this._addToQueue(n), this;
    const r = {
      type: at.EVENT,
      data: n
    };
    if (r.options = {}, r.options.compress = this.flags.compress !== !1, typeof n[n.length - 1] == "function") {
      const a = this.ids++, s = n.pop();
      this._registerAckCallback(a, s), r.id = a;
    }
    const i = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
    return this.flags.volatile && (!i || !this.connected) || (this.connected ? (this.notifyOutgoingListeners(r), this.packet(r)) : this.sendBuffer.push(r)), this.flags = {}, this;
  }
  /**
   * @private
   */
  _registerAckCallback(t, n) {
    var r;
    const i = (r = this.flags.timeout) !== null && r !== void 0 ? r : this._opts.ackTimeout;
    if (i === void 0) {
      this.acks[t] = n;
      return;
    }
    const o = this.io.setTimeoutFn(() => {
      delete this.acks[t];
      for (let a = 0; a < this.sendBuffer.length; a++)
        this.sendBuffer[a].id === t && this.sendBuffer.splice(a, 1);
      n.call(this, new Error("operation has timed out"));
    }, i);
    this.acks[t] = (...a) => {
      this.io.clearTimeoutFn(o), n.apply(this, [null, ...a]);
    };
  }
  /**
   * Emits an event and waits for an acknowledgement
   *
   * @example
   * // without timeout
   * const response = await socket.emitWithAck("hello", "world");
   *
   * // with a specific timeout
   * try {
   *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
   * } catch (err) {
   *   // the server did not acknowledge the event in the given delay
   * }
   *
   * @return a Promise that will be fulfilled when the server acknowledges the event
   */
  emitWithAck(t, ...n) {
    const r = this.flags.timeout !== void 0 || this._opts.ackTimeout !== void 0;
    return new Promise((i, o) => {
      n.push((a, s) => r ? a ? o(a) : i(s) : i(a)), this.emit(t, ...n);
    });
  }
  /**
   * Add the packet to the queue.
   * @param args
   * @private
   */
  _addToQueue(t) {
    let n;
    typeof t[t.length - 1] == "function" && (n = t.pop());
    const r = {
      id: this._queueSeq++,
      tryCount: 0,
      pending: !1,
      args: t,
      flags: Object.assign({ fromQueue: !0 }, this.flags)
    };
    t.push((i, ...o) => r !== this._queue[0] ? void 0 : (i !== null ? r.tryCount > this._opts.retries && (this._queue.shift(), n && n(i)) : (this._queue.shift(), n && n(null, ...o)), r.pending = !1, this._drainQueue())), this._queue.push(r), this._drainQueue();
  }
  /**
   * Send the first packet of the queue, and wait for an acknowledgement from the server.
   * @param force - whether to resend a packet that has not been acknowledged yet
   *
   * @private
   */
  _drainQueue(t = !1) {
    if (!this.connected || this._queue.length === 0)
      return;
    const n = this._queue[0];
    n.pending && !t || (n.pending = !0, n.tryCount++, this.flags = n.flags, this.emit.apply(this, n.args));
  }
  /**
   * Sends a packet.
   *
   * @param packet
   * @private
   */
  packet(t) {
    t.nsp = this.nsp, this.io._packet(t);
  }
  /**
   * Called upon engine `open`.
   *
   * @private
   */
  onopen() {
    typeof this.auth == "function" ? this.auth((t) => {
      this._sendConnectPacket(t);
    }) : this._sendConnectPacket(this.auth);
  }
  /**
   * Sends a CONNECT packet to initiate the Socket.IO session.
   *
   * @param data
   * @private
   */
  _sendConnectPacket(t) {
    this.packet({
      type: at.CONNECT,
      data: this._pid ? Object.assign({ pid: this._pid, offset: this._lastOffset }, t) : t
    });
  }
  /**
   * Called upon engine or manager `error`.
   *
   * @param err
   * @private
   */
  onerror(t) {
    this.connected || this.emitReserved("connect_error", t);
  }
  /**
   * Called upon engine `close`.
   *
   * @param reason
   * @param description
   * @private
   */
  onclose(t, n) {
    this.connected = !1, delete this.id, this.emitReserved("disconnect", t, n);
  }
  /**
   * Called with socket packet.
   *
   * @param packet
   * @private
   */
  onpacket(t) {
    if (t.nsp === this.nsp)
      switch (t.type) {
        case at.CONNECT:
          t.data && t.data.sid ? this.onconnect(t.data.sid, t.data.pid) : this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
          break;
        case at.EVENT:
        case at.BINARY_EVENT:
          this.onevent(t);
          break;
        case at.ACK:
        case at.BINARY_ACK:
          this.onack(t);
          break;
        case at.DISCONNECT:
          this.ondisconnect();
          break;
        case at.CONNECT_ERROR:
          this.destroy();
          const r = new Error(t.data.message);
          r.data = t.data.data, this.emitReserved("connect_error", r);
          break;
      }
  }
  /**
   * Called upon a server event.
   *
   * @param packet
   * @private
   */
  onevent(t) {
    const n = t.data || [];
    t.id != null && n.push(this.ack(t.id)), this.connected ? this.emitEvent(n) : this.receiveBuffer.push(Object.freeze(n));
  }
  emitEvent(t) {
    if (this._anyListeners && this._anyListeners.length) {
      const n = this._anyListeners.slice();
      for (const r of n)
        r.apply(this, t);
    }
    super.emit.apply(this, t), this._pid && t.length && typeof t[t.length - 1] == "string" && (this._lastOffset = t[t.length - 1]);
  }
  /**
   * Produces an ack callback to emit with an event.
   *
   * @private
   */
  ack(t) {
    const n = this;
    let r = !1;
    return function(...i) {
      r || (r = !0, n.packet({
        type: at.ACK,
        id: t,
        data: i
      }));
    };
  }
  /**
   * Called upon a server acknowlegement.
   *
   * @param packet
   * @private
   */
  onack(t) {
    const n = this.acks[t.id];
    typeof n == "function" && (n.apply(this, t.data), delete this.acks[t.id]);
  }
  /**
   * Called upon server connect.
   *
   * @private
   */
  onconnect(t, n) {
    this.id = t, this.recovered = n && this._pid === n, this._pid = n, this.connected = !0, this.emitBuffered(), this.emitReserved("connect"), this._drainQueue(!0);
  }
  /**
   * Emit buffered events (received and emitted).
   *
   * @private
   */
  emitBuffered() {
    this.receiveBuffer.forEach((t) => this.emitEvent(t)), this.receiveBuffer = [], this.sendBuffer.forEach((t) => {
      this.notifyOutgoingListeners(t), this.packet(t);
    }), this.sendBuffer = [];
  }
  /**
   * Called upon server disconnect.
   *
   * @private
   */
  ondisconnect() {
    this.destroy(), this.onclose("io server disconnect");
  }
  /**
   * Called upon forced client/server side disconnections,
   * this method ensures the manager stops tracking us and
   * that reconnections don't get triggered for this.
   *
   * @private
   */
  destroy() {
    this.subs && (this.subs.forEach((t) => t()), this.subs = void 0), this.io._destroy(this);
  }
  /**
   * Disconnects the socket manually. In that case, the socket will not try to reconnect.
   *
   * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
   *
   * @example
   * const socket = io();
   *
   * socket.on("disconnect", (reason) => {
   *   // console.log(reason); prints "io client disconnect"
   * });
   *
   * socket.disconnect();
   *
   * @return self
   */
  disconnect() {
    return this.connected && this.packet({ type: at.DISCONNECT }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
  }
  /**
   * Alias for {@link disconnect()}.
   *
   * @return self
   */
  close() {
    return this.disconnect();
  }
  /**
   * Sets the compress flag.
   *
   * @example
   * socket.compress(false).emit("hello");
   *
   * @param compress - if `true`, compresses the sending data
   * @return self
   */
  compress(t) {
    return this.flags.compress = t, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
   * ready to send messages.
   *
   * @example
   * socket.volatile.emit("hello"); // the server may or may not receive it
   *
   * @returns self
   */
  get volatile() {
    return this.flags.volatile = !0, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
   * given number of milliseconds have elapsed without an acknowledgement from the server:
   *
   * @example
   * socket.timeout(5000).emit("my-event", (err) => {
   *   if (err) {
   *     // the server did not acknowledge the event in the given delay
   *   }
   * });
   *
   * @returns self
   */
  timeout(t) {
    return this.flags.timeout = t, this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * @example
   * socket.onAny((event, ...args) => {
   *   console.log(`got ${event}`);
   * });
   *
   * @param listener
   */
  onAny(t) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.push(t), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * @example
   * socket.prependAny((event, ...args) => {
   *   console.log(`got event ${event}`);
   * });
   *
   * @param listener
   */
  prependAny(t) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(t), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`got event ${event}`);
   * }
   *
   * socket.onAny(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAny(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAny();
   *
   * @param listener
   */
  offAny(t) {
    if (!this._anyListeners)
      return this;
    if (t) {
      const n = this._anyListeners;
      for (let r = 0; r < n.length; r++)
        if (t === n[r])
          return n.splice(r, 1), this;
    } else
      this._anyListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAny() {
    return this._anyListeners || [];
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.onAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  onAnyOutgoing(t) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(t), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.prependAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  prependAnyOutgoing(t) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(t), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`sent event ${event}`);
   * }
   *
   * socket.onAnyOutgoing(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAnyOutgoing(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAnyOutgoing();
   *
   * @param [listener] - the catch-all listener (optional)
   */
  offAnyOutgoing(t) {
    if (!this._anyOutgoingListeners)
      return this;
    if (t) {
      const n = this._anyOutgoingListeners;
      for (let r = 0; r < n.length; r++)
        if (t === n[r])
          return n.splice(r, 1), this;
    } else
      this._anyOutgoingListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAnyOutgoing() {
    return this._anyOutgoingListeners || [];
  }
  /**
   * Notify the listeners for each packet sent
   *
   * @param packet
   *
   * @private
   */
  notifyOutgoingListeners(t) {
    if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
      const n = this._anyOutgoingListeners.slice();
      for (const r of n)
        r.apply(this, t.data);
    }
  }
}
function Xa(e) {
  e = e || {}, this.ms = e.min || 100, this.max = e.max || 1e4, this.factor = e.factor || 2, this.jitter = e.jitter > 0 && e.jitter <= 1 ? e.jitter : 0, this.attempts = 0;
}
Xa.prototype.duration = function() {
  var e = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var t = Math.random(), n = Math.floor(t * this.jitter * e);
    e = Math.floor(t * 10) & 1 ? e + n : e - n;
  }
  return Math.min(e, this.max) | 0;
};
Xa.prototype.reset = function() {
  this.attempts = 0;
};
Xa.prototype.setMin = function(e) {
  this.ms = e;
};
Xa.prototype.setMax = function(e) {
  this.max = e;
};
Xa.prototype.setJitter = function(e) {
  this.jitter = e;
};
class $m extends Zt {
  constructor(t, n) {
    var r;
    super(), this.nsps = {}, this.subs = [], t && typeof t == "object" && (n = t, t = void 0), n = n || {}, n.path = n.path || "/socket.io", this.opts = n, zf(this, n), this.reconnection(n.reconnection !== !1), this.reconnectionAttempts(n.reconnectionAttempts || 1 / 0), this.reconnectionDelay(n.reconnectionDelay || 1e3), this.reconnectionDelayMax(n.reconnectionDelayMax || 5e3), this.randomizationFactor((r = n.randomizationFactor) !== null && r !== void 0 ? r : 0.5), this.backoff = new Xa({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    }), this.timeout(n.timeout == null ? 2e4 : n.timeout), this._readyState = "closed", this.uri = t;
    const i = n.parser || nB;
    this.encoder = new i.Encoder(), this.decoder = new i.Decoder(), this._autoConnect = n.autoConnect !== !1, this._autoConnect && this.open();
  }
  reconnection(t) {
    return arguments.length ? (this._reconnection = !!t, this) : this._reconnection;
  }
  reconnectionAttempts(t) {
    return t === void 0 ? this._reconnectionAttempts : (this._reconnectionAttempts = t, this);
  }
  reconnectionDelay(t) {
    var n;
    return t === void 0 ? this._reconnectionDelay : (this._reconnectionDelay = t, (n = this.backoff) === null || n === void 0 || n.setMin(t), this);
  }
  randomizationFactor(t) {
    var n;
    return t === void 0 ? this._randomizationFactor : (this._randomizationFactor = t, (n = this.backoff) === null || n === void 0 || n.setJitter(t), this);
  }
  reconnectionDelayMax(t) {
    var n;
    return t === void 0 ? this._reconnectionDelayMax : (this._reconnectionDelayMax = t, (n = this.backoff) === null || n === void 0 || n.setMax(t), this);
  }
  timeout(t) {
    return arguments.length ? (this._timeout = t, this) : this._timeout;
  }
  /**
   * Starts trying to reconnect if reconnection is enabled and we have not
   * started reconnecting yet
   *
   * @private
   */
  maybeReconnectOnOpen() {
    !this._reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
  }
  /**
   * Sets the current transport `socket`.
   *
   * @param {Function} fn - optional, callback
   * @return self
   * @public
   */
  open(t) {
    if (~this._readyState.indexOf("open"))
      return this;
    this.engine = new H5(this.uri, this.opts);
    const n = this.engine, r = this;
    this._readyState = "opening", this.skipReconnect = !1;
    const i = Lr(n, "open", function() {
      r.onopen(), t && t();
    }), o = (s) => {
      this.cleanup(), this._readyState = "closed", this.emitReserved("error", s), t ? t(s) : this.maybeReconnectOnOpen();
    }, a = Lr(n, "error", o);
    if (this._timeout !== !1) {
      const s = this._timeout, c = this.setTimeoutFn(() => {
        i(), o(new Error("timeout")), n.close();
      }, s);
      this.opts.autoUnref && c.unref(), this.subs.push(() => {
        this.clearTimeoutFn(c);
      });
    }
    return this.subs.push(i), this.subs.push(a), this;
  }
  /**
   * Alias for open()
   *
   * @return self
   * @public
   */
  connect(t) {
    return this.open(t);
  }
  /**
   * Called upon transport open.
   *
   * @private
   */
  onopen() {
    this.cleanup(), this._readyState = "open", this.emitReserved("open");
    const t = this.engine;
    this.subs.push(Lr(t, "ping", this.onping.bind(this)), Lr(t, "data", this.ondata.bind(this)), Lr(t, "error", this.onerror.bind(this)), Lr(t, "close", this.onclose.bind(this)), Lr(this.decoder, "decoded", this.ondecoded.bind(this)));
  }
  /**
   * Called upon a ping.
   *
   * @private
   */
  onping() {
    this.emitReserved("ping");
  }
  /**
   * Called with data.
   *
   * @private
   */
  ondata(t) {
    try {
      this.decoder.add(t);
    } catch (n) {
      this.onclose("parse error", n);
    }
  }
  /**
   * Called when parser fully decodes a packet.
   *
   * @private
   */
  ondecoded(t) {
    N1(() => {
      this.emitReserved("packet", t);
    }, this.setTimeoutFn);
  }
  /**
   * Called upon socket error.
   *
   * @private
   */
  onerror(t) {
    this.emitReserved("error", t);
  }
  /**
   * Creates a new socket for the given `nsp`.
   *
   * @return {Socket}
   * @public
   */
  socket(t, n) {
    let r = this.nsps[t];
    return r ? this._autoConnect && !r.active && r.connect() : (r = new W5(this, t, n), this.nsps[t] = r), r;
  }
  /**
   * Called upon a socket close.
   *
   * @param socket
   * @private
   */
  _destroy(t) {
    const n = Object.keys(this.nsps);
    for (const r of n)
      if (this.nsps[r].active)
        return;
    this._close();
  }
  /**
   * Writes a packet.
   *
   * @param packet
   * @private
   */
  _packet(t) {
    const n = this.encoder.encode(t);
    for (let r = 0; r < n.length; r++)
      this.engine.write(n[r], t.options);
  }
  /**
   * Clean up transport subscriptions and packet buffer.
   *
   * @private
   */
  cleanup() {
    this.subs.forEach((t) => t()), this.subs.length = 0, this.decoder.destroy();
  }
  /**
   * Close the current socket.
   *
   * @private
   */
  _close() {
    this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close"), this.engine && this.engine.close();
  }
  /**
   * Alias for close()
   *
   * @private
   */
  disconnect() {
    return this._close();
  }
  /**
   * Called upon engine close.
   *
   * @private
   */
  onclose(t, n) {
    this.cleanup(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", t, n), this._reconnection && !this.skipReconnect && this.reconnect();
  }
  /**
   * Attempt a reconnection.
   *
   * @private
   */
  reconnect() {
    if (this._reconnecting || this.skipReconnect)
      return this;
    const t = this;
    if (this.backoff.attempts >= this._reconnectionAttempts)
      this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;
    else {
      const n = this.backoff.duration();
      this._reconnecting = !0;
      const r = this.setTimeoutFn(() => {
        t.skipReconnect || (this.emitReserved("reconnect_attempt", t.backoff.attempts), !t.skipReconnect && t.open((i) => {
          i ? (t._reconnecting = !1, t.reconnect(), this.emitReserved("reconnect_error", i)) : t.onreconnect();
        }));
      }, n);
      this.opts.autoUnref && r.unref(), this.subs.push(() => {
        this.clearTimeoutFn(r);
      });
    }
  }
  /**
   * Called upon successful reconnect.
   *
   * @private
   */
  onreconnect() {
    const t = this.backoff.attempts;
    this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", t);
  }
}
const Ts = {};
function Ws(e, t) {
  typeof e == "object" && (t = e, e = void 0), t = t || {};
  const n = jV(e, t.path || "/socket.io"), r = n.source, i = n.id, o = n.path, a = Ts[i] && o in Ts[i].nsps, s = t.forceNew || t["force new connection"] || t.multiplex === !1 || a;
  let c;
  return s ? c = new $m(r, t) : (Ts[i] || (Ts[i] = new $m(r, t)), c = Ts[i]), n.query && !t.query && (t.query = n.queryKey), c.socket(n.path, t);
}
Object.assign(Ws, {
  Manager: $m,
  Socket: W5,
  io: Ws,
  connect: Ws
});
let Xc;
const iB = new Uint8Array(16);
function oB() {
  if (!Xc && (Xc = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Xc))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Xc(iB);
}
const pn = [];
for (let e = 0; e < 256; ++e)
  pn.push((e + 256).toString(16).slice(1));
function aB(e, t = 0) {
  return (pn[e[t + 0]] + pn[e[t + 1]] + pn[e[t + 2]] + pn[e[t + 3]] + "-" + pn[e[t + 4]] + pn[e[t + 5]] + "-" + pn[e[t + 6]] + pn[e[t + 7]] + "-" + pn[e[t + 8]] + pn[e[t + 9]] + "-" + pn[e[t + 10]] + pn[e[t + 11]] + pn[e[t + 12]] + pn[e[t + 13]] + pn[e[t + 14]] + pn[e[t + 15]]).toLowerCase();
}
const sB = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), g2 = {
  randomUUID: sB
};
function j5(e, t, n) {
  if (g2.randomUUID && !t && !e)
    return g2.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || oB)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
    n = n || 0;
    for (let i = 0; i < 16; ++i)
      t[n + i] = r[i];
    return t;
  }
  return aB(r);
}
const q5 = y.createContext(null);
function lB({
  children: e
}) {
  const [t, n] = y.useState([]);
  return /* @__PURE__ */ y.createElement(
    q5.Provider,
    {
      value: {
        generations: t,
        setGenerations: n
      }
    },
    e
  );
}
function cB() {
  const e = Re(q5);
  if (!e)
    throw new Error(
      "useGenerationsContext must be used within a GenerationsProvider component"
    );
  return e;
}
function uB({
  setActiveSocket: e
}) {
  const { mutate: t } = E1(), { apiUrl: n, token: r } = _l(), [i, o] = ue(null), [a, s] = ue(!1), [c, f] = ue(!1), { contactUuid: p, context: d, messageType: h } = Ff(), { generations: m, setGenerations: v } = cB(), w = [...m].sort((C, S) => (C.createdAt ?? 0) - (S.createdAt ?? 0)).flatMap((C) => [
    {
      from: "human",
      timestamp: C.createdAt || 0,
      text: C.instruction
    },
    {
      from: "ai",
      timestamp: C.createdAt || 0,
      text: C.generation
    }
  ]), b = Me(
    ({
      id: C,
      newData: S,
      prompt: _,
      isStreaming: T = !0,
      createdAt: P = Date.now()
    }) => {
      v((R) => R.find((B) => (B == null ? void 0 : B._id) === C) ? R.map((B) => B._id === C ? {
        ...B,
        generation: `${B.generation}${S || ""}`
      } : B) : [{
        _id: C,
        instruction: _,
        generation: S || "",
        isStreaming: T,
        createdAt: P
      }, ...R]);
    },
    [v]
  ), E = Me(
    async (C) => {
      o(null);
      try {
        let S = !0, _ = C.messageType || h;
        C.improveText && (_ = "Improve"), h === "ListingDescription" && !C.messageType && (_ = "Generic"), s(!0);
        const T = j5(), R = `${n || "https://write-a-plumber.brivity.com"}/v1/generations/stream`, N = Ws(R, {
          auth: { token: r },
          timeout: 1e4,
          requestTimeout: 1e4,
          reconnectionAttempts: 3,
          withCredentials: !0,
          transports: ["websocket"]
        });
        N.on("connect", () => {
          e(N), N.emit("payload", {
            ...C,
            context: d,
            leadId: p,
            messageType: _,
            transcript: w
          });
        }), N.on("data", (B) => {
          S && (f(!0), s(!1), S = !1), b({
            id: T,
            prompt: C.userInstruction,
            newData: B
          });
        }), N.on("generation", (B) => {
          f(!1), e(null), v((L) => L.findIndex((j) => j._id === T) === -1 ? [{
            ...B,
            _id: T,
            isStreaming: !1,
            createdAt: Date.now()
          }, ...L] : L.map((j) => j._id === T ? {
            ...j,
            ...B,
            isStreaming: !1
          } : j)), t("/auth/current-user");
        }), N.on("error", (B) => {
          throw N.disconnect(), B;
        }), N.on("disconnect", () => {
          f(!1), s(!1), e(null);
        });
      } catch (S) {
        S instanceof Error ? o(S) : o(new Error("An unknown error occurred"));
      }
    },
    [
      n,
      t,
      v,
      e,
      r,
      b,
      p,
      h,
      w,
      d
    ]
  );
  return {
    generationError: i,
    setGenerationError: o,
    isLoading: a,
    isStreaming: c,
    streamGeneration: E
  };
}
const G5 = Ee(
  ({ isOpen: e, className: t, ...n }, r) => /* @__PURE__ */ y.createElement(
    "button",
    {
      className: le([
        "ai-tw-inline-flex ai-tw-h-fit ai-tw-w-fit ai-tw-items-center ai-tw-gap-1 ai-tw-rounded-full ai-tw-border ai-tw-border-purple-50 ai-tw-px-2 ai-tw-py-1",
        "ai-tw-uppercase ai-tw-button-sm",
        "active:ai-tw-bg-purple-50 active:ai-tw-text-white",
        "hover:ai-tw-outline hover:ai-tw-outline-1 hover:ai-tw-outline-purple-50",
        "disabled:ai-tw-pointer-events-none disabled:ai-tw-opacity-50",
        e ? "ai-tw-bg-purple-50 ai-tw-text-white ai-tw-outline ai-tw-outline-1 ai-tw-outline-purple-50" : "ai-tw-bg-transparent ai-tw-text-purple-50",
        t
      ]),
      ...n,
      ref: r
    },
    /* @__PURE__ */ y.createElement(Ne, { icon: Wa }),
    /* @__PURE__ */ y.createElement("span", null, "AI: Help Me Write")
  )
);
G5.displayName = "TriggerButton";
var Y5 = Symbol.for("immer-nothing"), v2 = Symbol.for("immer-draftable"), ir = Symbol.for("immer-state"), fB = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function Un(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const n = fB[e], r = typeof n == "function" ? n.apply(null, t) : n;
    throw new Error(`[Immer] ${r}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var Ba = Object.getPrototypeOf;
function Ha(e) {
  return !!e && !!e[ir];
}
function Uo(e) {
  var t;
  return e ? K5(e) || Array.isArray(e) || !!e[v2] || !!((t = e.constructor) != null && t[v2]) || Bf(e) || Hf(e) : !1;
}
var dB = Object.prototype.constructor.toString();
function K5(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = Ba(e);
  if (t === null)
    return !0;
  const n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return n === Object ? !0 : typeof n == "function" && Function.toString.call(n) === dB;
}
function Hu(e, t) {
  Vf(e) === 0 ? Reflect.ownKeys(e).forEach((n) => {
    t(n, e[n], e);
  }) : e.forEach((n, r) => t(r, n, e));
}
function Vf(e) {
  const t = e[ir];
  return t ? t.type_ : Array.isArray(e) ? 1 : Bf(e) ? 2 : Hf(e) ? 3 : 0;
}
function Om(e, t) {
  return Vf(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function X5(e, t, n) {
  const r = Vf(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function pB(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function Bf(e) {
  return e instanceof Map;
}
function Hf(e) {
  return e instanceof Set;
}
function $o(e) {
  return e.copy_ || e.base_;
}
function Mm(e, t) {
  if (Bf(e))
    return new Map(e);
  if (Hf(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const n = K5(e);
  if (t === !0 || t === "class_only" && !n) {
    const r = Object.getOwnPropertyDescriptors(e);
    delete r[ir];
    let i = Reflect.ownKeys(r);
    for (let o = 0; o < i.length; o++) {
      const a = i[o], s = r[a];
      s.writable === !1 && (s.writable = !0, s.configurable = !0), (s.get || s.set) && (r[a] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: s.enumerable,
        value: e[a]
      });
    }
    return Object.create(Ba(e), r);
  } else {
    const r = Ba(e);
    if (r !== null && n)
      return { ...e };
    const i = Object.create(r);
    return Object.assign(i, e);
  }
}
function ll(e, t = !1) {
  return Uf(e) || Ha(e) || !Uo(e) || (Vf(e) > 1 && (e.set = e.add = e.clear = e.delete = hB), Object.freeze(e), t && Object.entries(e).forEach(([n, r]) => ll(r, !0))), e;
}
function hB() {
  Un(2);
}
function Uf(e) {
  return Object.isFrozen(e);
}
var mB = {};
function Wo(e) {
  const t = mB[e];
  return t || Un(0, e), t;
}
var cl;
function Q5() {
  return cl;
}
function gB(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function w2(e, t) {
  t && (Wo("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function Dm(e) {
  Nm(e), e.drafts_.forEach(vB), e.drafts_ = null;
}
function Nm(e) {
  e === cl && (cl = e.parent_);
}
function y2(e) {
  return cl = gB(cl, e);
}
function vB(e) {
  const t = e[ir];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function b2(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const n = t.drafts_[0];
  return e !== void 0 && e !== n ? (n[ir].modified_ && (Dm(t), Un(4)), Uo(e) && (e = Uu(t, e), t.parent_ || Wu(t, e)), t.patches_ && Wo("Patches").generateReplacementPatches_(
    n[ir].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = Uu(t, n, []), Dm(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== Y5 ? e : void 0;
}
function Uu(e, t, n) {
  if (Uf(t))
    return t;
  const r = t[ir];
  if (!r)
    return Hu(
      t,
      (i, o) => x2(e, r, t, i, o, n)
    ), t;
  if (r.scope_ !== e)
    return t;
  if (!r.modified_)
    return Wu(e, r.base_, !0), r.base_;
  if (!r.finalized_) {
    r.finalized_ = !0, r.scope_.unfinalizedDrafts_--;
    const i = r.copy_;
    let o = i, a = !1;
    r.type_ === 3 && (o = new Set(i), i.clear(), a = !0), Hu(
      o,
      (s, c) => x2(e, r, i, s, c, n, a)
    ), Wu(e, i, !1), n && e.patches_ && Wo("Patches").generatePatches_(
      r,
      n,
      e.patches_,
      e.inversePatches_
    );
  }
  return r.copy_;
}
function x2(e, t, n, r, i, o, a) {
  if (process.env.NODE_ENV !== "production" && i === n && Un(5), Ha(i)) {
    const s = o && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !Om(t.assigned_, r) ? o.concat(r) : void 0, c = Uu(e, i, s);
    if (X5(n, r, c), Ha(c))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else
    a && n.add(i);
  if (Uo(i) && !Uf(i)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    Uu(e, i), (!t || !t.scope_.parent_) && typeof r != "symbol" && Object.prototype.propertyIsEnumerable.call(n, r) && Wu(e, i);
  }
}
function Wu(e, t, n = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && ll(t, n);
}
function wB(e, t) {
  const n = Array.isArray(e), r = {
    type_: n ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : Q5(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let i = r, o = F1;
  n && (i = [r], o = ul);
  const { revoke: a, proxy: s } = Proxy.revocable(i, o);
  return r.draft_ = s, r.revoke_ = a, s;
}
var F1 = {
  get(e, t) {
    if (t === ir)
      return e;
    const n = $o(e);
    if (!Om(n, t))
      return yB(e, n, t);
    const r = n[t];
    return e.finalized_ || !Uo(r) ? r : r === ch(e.base_, t) ? (uh(e), e.copy_[t] = Lm(r, e)) : r;
  },
  has(e, t) {
    return t in $o(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys($o(e));
  },
  set(e, t, n) {
    const r = Z5($o(e), t);
    if (r != null && r.set)
      return r.set.call(e.draft_, n), !0;
    if (!e.modified_) {
      const i = ch($o(e), t), o = i == null ? void 0 : i[ir];
      if (o && o.base_ === n)
        return e.copy_[t] = n, e.assigned_[t] = !1, !0;
      if (pB(n, i) && (n !== void 0 || Om(e.base_, t)))
        return !0;
      uh(e), Im(e);
    }
    return e.copy_[t] === n && // special case: handle new props with value 'undefined'
    (n !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(n) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = n, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return ch(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, uh(e), Im(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const n = $o(e), r = Reflect.getOwnPropertyDescriptor(n, t);
    return r && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: r.enumerable,
      value: n[t]
    };
  },
  defineProperty() {
    Un(11);
  },
  getPrototypeOf(e) {
    return Ba(e.base_);
  },
  setPrototypeOf() {
    Un(12);
  }
}, ul = {};
Hu(F1, (e, t) => {
  ul[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
ul.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && Un(13), ul.set.call(this, e, t, void 0);
};
ul.set = function(e, t, n) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && Un(14), F1.set.call(this, e[0], t, n, e[0]);
};
function ch(e, t) {
  const n = e[ir];
  return (n ? $o(n) : e)[t];
}
function yB(e, t, n) {
  var i;
  const r = Z5(t, n);
  return r ? "value" in r ? r.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (i = r.get) == null ? void 0 : i.call(e.draft_)
  ) : void 0;
}
function Z5(e, t) {
  if (!(t in e))
    return;
  let n = Ba(e);
  for (; n; ) {
    const r = Object.getOwnPropertyDescriptor(n, t);
    if (r)
      return r;
    n = Ba(n);
  }
}
function Im(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && Im(e.parent_));
}
function uh(e) {
  e.copy_ || (e.copy_ = Mm(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var bB = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, n, r) => {
      if (typeof t == "function" && typeof n != "function") {
        const o = n;
        n = t;
        const a = this;
        return function(c = o, ...f) {
          return a.produce(c, (p) => n.call(this, p, ...f));
        };
      }
      typeof n != "function" && Un(6), r !== void 0 && typeof r != "function" && Un(7);
      let i;
      if (Uo(t)) {
        const o = y2(this), a = Lm(t, void 0);
        let s = !0;
        try {
          i = n(a), s = !1;
        } finally {
          s ? Dm(o) : Nm(o);
        }
        return w2(o, r), b2(i, o);
      } else if (!t || typeof t != "object") {
        if (i = n(t), i === void 0 && (i = t), i === Y5 && (i = void 0), this.autoFreeze_ && ll(i, !0), r) {
          const o = [], a = [];
          Wo("Patches").generateReplacementPatches_(t, i, o, a), r(o, a);
        }
        return i;
      } else
        Un(1, t);
    }, this.produceWithPatches = (t, n) => {
      if (typeof t == "function")
        return (a, ...s) => this.produceWithPatches(a, (c) => t(c, ...s));
      let r, i;
      return [this.produce(t, n, (a, s) => {
        r = a, i = s;
      }), r, i];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    Uo(e) || Un(8), Ha(e) && (e = xB(e));
    const t = y2(this), n = Lm(e, void 0);
    return n[ir].isManual_ = !0, Nm(t), n;
  }
  finishDraft(e, t) {
    const n = e && e[ir];
    (!n || !n.isManual_) && Un(9);
    const { scope_: r } = n;
    return w2(r, t), b2(void 0, r);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let n;
    for (n = t.length - 1; n >= 0; n--) {
      const i = t[n];
      if (i.path.length === 0 && i.op === "replace") {
        e = i.value;
        break;
      }
    }
    n > -1 && (t = t.slice(n + 1));
    const r = Wo("Patches").applyPatches_;
    return Ha(e) ? r(e, t) : this.produce(
      e,
      (i) => r(i, t)
    );
  }
};
function Lm(e, t) {
  const n = Bf(e) ? Wo("MapSet").proxyMap_(e, t) : Hf(e) ? Wo("MapSet").proxySet_(e, t) : wB(e, t);
  return (t ? t.scope_ : Q5()).drafts_.push(n), n;
}
function xB(e) {
  return Ha(e) || Un(10, e), J5(e);
}
function J5(e) {
  if (!Uo(e) || Uf(e))
    return e;
  const t = e[ir];
  let n;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, n = Mm(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    n = Mm(e, !0);
  return Hu(n, (r, i) => {
    X5(n, r, J5(i));
  }), t && (t.finalized_ = !1), n;
}
var or = new bB(), e6 = or.produce;
or.produceWithPatches.bind(
  or
);
or.setAutoFreeze.bind(or);
or.setUseStrictShallowCopy.bind(or);
or.applyPatches.bind(or);
or.createDraft.bind(or);
or.finishDraft.bind(or);
function EB(e) {
  var t = ue(function() {
    return ll(typeof e == "function" ? e() : e, !0);
  }), n = t[1];
  return [t[0], Me(function(r) {
    n(typeof r == "function" ? e6(r) : ll(r));
  }, [])];
}
function E2(e, t, n) {
  var r = yn(function() {
    return e6(e);
  }, [e]);
  return P4(r, t, n);
}
const t6 = y.createContext(null);
function CB({
  children: e
}) {
  const [t, n] = y.useState(0), [r, i] = EB(
    []
  ), [o, a] = y.useState(null);
  function s(p) {
    a(p), i(
      p != null && p.fields ? p.fields.map((d) => ({
        ...d,
        inputValue: ""
      })) : []
    );
  }
  const c = Me(
    (p, d) => {
      i((h) => {
        h[t].inputValue = p, d && (h[t].data = d);
      });
    },
    [t, i]
  ), f = () => {
    n(0), i([]), a(null);
  };
  return /* @__PURE__ */ y.createElement(
    t6.Provider,
    {
      value: {
        clearFields: f,
        currentField: t,
        setCurrentField: n,
        fieldInputValues: r,
        setCurrentFieldValue: c,
        selectedInstruction: o,
        setInstruction: s
      }
    },
    e
  );
}
function SB() {
  const e = Re(t6);
  if (!e)
    throw new Error(
      "useInstructionsContext must be used within a InstructionsProvider component"
    );
  return e;
}
const n6 = y.createContext(
  null
);
function _B({
  children: e
}) {
  const [t, n] = y.useState("");
  return /* @__PURE__ */ y.createElement(
    n6.Provider,
    {
      value: {
        userPrompt: t,
        setUserPrompt: n
      }
    },
    e
  );
}
function TB() {
  const e = Re(n6);
  if (!e)
    throw new Error(
      "useUserPromptContext must be used within a UserPromptProvider component"
    );
  return e;
}
function kB() {
  const [e, t] = ue(null), [n, r] = ue(null), [i, o] = ue(""), [a, s] = ue(null), { textareaId: c, tinyMceDocument: f } = Ff(), [p, d] = ue("");
  return _e(() => {
    (i == null ? void 0 : i.length) > 0 && d(i);
  }, [i]), _e(() => {
    if (f)
      return;
    function h() {
      const m = document.getSelection(), v = m == null ? void 0 : m.toString().trim();
      if (v && v.length < 10) {
        o(""), s(null);
        return;
      }
      const w = document.activeElement;
      if (w.classList.contains("prompt-input") || w.id !== c)
        return;
      w.isSameNode(e) || (t(w), r(w.getBoundingClientRect()));
      const b = PB(w);
      s(b), o(v ?? "");
    }
    return document.addEventListener("selectionchange", h), () => {
      document.removeEventListener("selectionchange", h);
    };
  }, [e, c, f]), _e(() => {
    if (!f)
      return;
    function h() {
      var S, _;
      if (!f)
        return;
      const m = f.getSelection(), v = m == null ? void 0 : m.toString().trim();
      if (v && (v == null ? void 0 : v.length) < 10) {
        o(""), s(null);
        return;
      }
      const w = (S = f.defaultView) == null ? void 0 : S.frameElement, b = w == null ? void 0 : w.getBoundingClientRect();
      (_ = f.activeElement) != null && _.isSameNode(e) || (t(f.activeElement), r(b ?? null));
      const E = m == null ? void 0 : m.getRangeAt(0), C = E == null ? void 0 : E.getBoundingClientRect();
      s(C ?? null), o(v ?? "");
    }
    return f.addEventListener("selectionchange", h), () => {
      f.removeEventListener(
        "selectionchange",
        h
      );
    };
  }, [f, e]), {
    activeElement: e,
    portalPosition: n,
    textSelection: i,
    lastNonEmptySelection: p,
    textPosition: a,
    setTextPosition: s
  };
}
function PB(e) {
  let t = 0, n = 0, r = "";
  if (e instanceof HTMLTextAreaElement)
    t = e.selectionStart, n = e.selectionEnd, r = e.value;
  else {
    const T = document.getSelection();
    t = (T == null ? void 0 : T.anchorOffset) ?? 0, n = (T == null ? void 0 : T.focusOffset) ?? 0, r = e.textContent ?? "";
  }
  const { width: i, height: o } = e.getBoundingClientRect();
  let a = "white-space:pre-wrap";
  const s = [
    "direction",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-variant",
    "font-weight",
    "font-style",
    "letter-spacing",
    "line-height",
    "text-align",
    "text-indent",
    "text-transform",
    "word-wrap",
    "word-spacing"
  ], c = _("padding-top"), f = _("padding-left"), p = _("padding-right");
  let d = c;
  d += _("border-top-width");
  let h = f;
  h += _("border-left-width");
  for (let T = 0; T < s.length; T++) {
    const P = s[T];
    a += P + ":" + S(P) + ";";
  }
  const m = r.length, v = document.createElement("div");
  t > 0 && C(0, t);
  const w = C(t, n);
  m > n && C(n, m), v.style.cssText = a, v.style.position = "fixed", v.style.top = d + "px", v.style.left = h + "px", v.style.width = i - f - p + "px", v.style.height = o + "px", document.body.appendChild(v);
  let b = w.getBoundingClientRect().bottom;
  const E = w.getBoundingClientRect().left;
  return b > v.offsetTop + v.offsetHeight && (b = v.offsetTop + v.offsetHeight), document.body.removeChild(v), {
    ...w.getBoundingClientRect(),
    left: E,
    bottom: b
  };
  function C(T, P) {
    const R = document.createElement("span");
    return R.style.cssText = a, R.textContent = r.substring(T, P), v.appendChild(R), R;
  }
  function S(T) {
    var R;
    return (R = document.defaultView) == null ? void 0 : R.getComputedStyle(e, null).getPropertyValue(T);
  }
  function _(T) {
    var R;
    const P = (R = document.defaultView) == null ? void 0 : R.getComputedStyle(e, null).getPropertyValue(T);
    return parseFloat(P || "0");
  }
}
const AB = A4(() => import("./Content-7d497238.js"));
function RB() {
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-w-max ai-tw-items-center ai-tw-gap-2 ai-tw-px-1 ai-tw-py-0.5 ai-tw-text-destructive" }, /* @__PURE__ */ y.createElement(Ne, { icon: lo }), /* @__PURE__ */ y.createElement("span", null, "Error loading AI"));
}
function bse({
  align: e = "end",
  contactUuid: t,
  context: n,
  messageType: r = "SMS",
  mlsIds: i = [],
  onInsertClick: o,
  side: a = "bottom",
  textareaId: s,
  tinyMceDocument: c
}) {
  return /* @__PURE__ */ y.createElement(uo, { fallback: /* @__PURE__ */ y.createElement(RB, null) }, /* @__PURE__ */ y.createElement(
    uV,
    {
      value: {
        contactUuid: t,
        context: n,
        messageType: r,
        mlsIds: i,
        textareaId: s,
        tinyMceDocument: c
      }
    },
    /* @__PURE__ */ y.createElement(CB, null, /* @__PURE__ */ y.createElement(_B, null, /* @__PURE__ */ y.createElement(lB, null, /* @__PURE__ */ y.createElement(
      OB,
      {
        align: e,
        side: a,
        onInsertClick: o
      }
    ))))
  ));
}
const $B = y.createContext(null);
function OB({
  align: e,
  side: t,
  onInsertClick: n
}) {
  const r = y.useRef(document.body), i = y.useRef(null), [o, a] = ue(null), [s, c] = ue(!1), [f, p] = ue(!1), { fieldInputValues: d, selectedInstruction: h, setInstruction: m } = SB(), { setSource: v, messageType: w } = Ff(), { data: b } = sV(), { setUserPrompt: E } = TB(), {
    activeElement: C,
    portalPosition: S,
    textSelection: _,
    lastNonEmptySelection: T,
    textPosition: P,
    setTextPosition: R
  } = kB();
  function N(J) {
    f || p(!0), v("improve"), H({
      improveText: T,
      userInstruction: J
    });
  }
  const {
    generationError: B,
    setGenerationError: L,
    isLoading: j,
    isStreaming: I,
    streamGeneration: z
  } = uB({ setActiveSocket: a });
  async function H(J) {
    let ee = J.userInstruction;
    if ((d == null ? void 0 : d.length) > 0) {
      const A = d.map(
        (X) => `${X.placeholder} ${X.inputValue}`
      );
      ee = `${h == null ? void 0 : h.value}: ${A.join(
        " - "
      )}`;
    }
    c(!1), E(""), m(null), R(null), await z({
      ...J,
      userInstruction: ee,
      fields: d,
      messageType: h == null ? void 0 : h.messageType
    });
  }
  const G = cF();
  function Y(J) {
    G.start(J);
  }
  function ne() {
    if (b != null && b.length && w === "ListingDescription") {
      const J = b.map((ee) => ee.instructions).flat().find(
        (ee) => ee.value === "Write a listing description"
      );
      m(J ?? null);
    }
  }
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-preflight" }, /* @__PURE__ */ y.createElement(
    hV,
    {
      activeElement: C,
      portalPosition: S,
      textPosition: P,
      textSelection: _,
      handleImproveClick: N
    }
  ), /* @__PURE__ */ y.createElement(
    yx,
    {
      open: f,
      onOpenChange: () => {
        p((J) => !J), v("library"), ne();
      }
    },
    /* @__PURE__ */ y.createElement(bx, { asChild: !0 }, /* @__PURE__ */ y.createElement(G5, { isOpen: f })),
    /* @__PURE__ */ y.createElement(xx, null, /* @__PURE__ */ y.createElement(
      qg,
      {
        className: "ai-tw-preflight",
        asChild: !0,
        sideOffset: 8,
        align: e,
        side: t,
        onInteractOutside: (J) => J.preventDefault(),
        onOpenAutoFocus: (J) => {
          J.preventDefault(), i.current && i.current.focus();
        }
      },
      /* @__PURE__ */ y.createElement(
        on.div,
        {
          drag: !0,
          dragControls: G,
          dragListener: !1,
          dragConstraints: r,
          dragMomentum: !1,
          className: le(
            "ai-tw-z-[5000] ai-tw-h-[400px] ai-tw-w-[520px] ai-tw-overflow-hidden ai-tw-rounded-xl ai-tw-bg-background ai-tw-text-sm ai-tw-text-foreground",
            "ai-tw-animate-in ai-tw-fade-in-0 data-[side=bottom]:ai-tw-slide-in-from-top-4 data-[side=top]:ai-tw-slide-in-from-bottom-4",
            "ai-tw-shadow-purple"
          )
        },
        /* @__PURE__ */ y.createElement(R4, { fallback: /* @__PURE__ */ y.createElement(cV, null) }, /* @__PURE__ */ y.createElement(
          $B.Provider,
          {
            value: {
              addGeneration: H,
              promptInputRef: i,
              generationError: B,
              setGenerationError: L,
              isStreaming: I,
              isStreamLoading: j,
              streamGeneration: z
            }
          },
          /* @__PURE__ */ y.createElement(
            AB,
            {
              activeSocket: o,
              isLibraryOpen: s,
              onInsertClick: n,
              setIsLibraryOpen: c,
              startDrag: Y
            }
          )
        )),
        /* @__PURE__ */ y.createElement(AM, { asChild: !0 }, /* @__PURE__ */ y.createElement(
          y1,
          {
            className: "ai-tw-absolute ai-tw-right-3 ai-tw-top-3 focus-visible:ai-tw-ring-stroke-ai-light",
            onClick: () => R(null)
          },
          /* @__PURE__ */ y.createElement(Ne, { icon: Og })
        ))
      )
    ))
  ));
}
function C2({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ D.createElement(
    "div",
    {
      className: le(
        "ai-tw-h-5 ai-tw-w-full ai-tw-animate-pulse ai-tw-rounded-md ai-tw-bg-muted",
        e
      ),
      ...t
    }
  );
}
const MB = A4(() => import("./AiSummaryContent-633c9ee8.js"));
function xse({
  leadPersonUuid: e,
  variant: t = "stand-alone",
  allowAddAI: n = !0
}) {
  return /* @__PURE__ */ y.createElement(uo, { fallback: /* @__PURE__ */ y.createElement(DB, null) }, /* @__PURE__ */ y.createElement("div", { className: "ai-tw-preflight" }, /* @__PURE__ */ y.createElement(R4, { fallback: /* @__PURE__ */ y.createElement(NB, null) }, /* @__PURE__ */ y.createElement(
    MB,
    {
      leadPersonUuid: e,
      variant: t,
      allowAddAI: n
    }
  ))));
}
function DB() {
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-w-max ai-tw-items-center ai-tw-gap-2 ai-tw-p-1 ai-tw-text-stroke-critical-dark" }, /* @__PURE__ */ y.createElement(Ne, { icon: lo }), /* @__PURE__ */ y.createElement("span", null, "Error Loading AI Summary"));
}
function NB() {
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-flex-wrap ai-tw-items-center ai-tw-justify-between ai-tw-gap-3 ai-tw-border-b ai-tw-border-t-2 ai-tw-border-stroke-primary ai-tw-bg-white ai-tw-px-6 ai-tw-py-2" }, /* @__PURE__ */ y.createElement(C2, { className: "ai-tw-h-7 ai-tw-w-40" }), /* @__PURE__ */ y.createElement(C2, { className: "ai-tw-h-7 ai-tw-w-60" }));
}
const IB = li(
  ["ai-tw-border-none ai-tw-bg-transparent ai-tw-bg-none ai-tw-uppercase"],
  {
    variants: {
      variant: {
        ai: [
          "ai-tw-text-purple-50",
          "hover:enabled:ai-tw-text-purple-60 active:enabled:ai-tw-text-purple-70",
          "disabled:ai-tw-text-purple-30"
        ],
        destructive: [
          "ai-tw-text-stroke-critical-dark",
          "hover:enabled:ai-tw-text-content-critical-dark active:enabled:ai-tw-text-content-critical-dark",
          "disabled:ai-tw-text-stroke-critical-lightest"
        ],
        "destructive-grey": [
          "ai-tw-text-content-primary-light",
          "hover:enabled:ai-tw-text-content-critical-dark active:enabled:ai-tw-text-content-critical-dark",
          "disabled:ai-tw-text-content-primary-disabled"
        ],
        primary: [
          "ai-tw-text-content-brand",
          "hover:ai-tw-text-content-brand-dark active:ai-tw-text-content-brand-dark",
          "disabled:ai-tw-text-content-brand-disabled"
        ],
        "on-color": [
          "ai-tw-text-content-on-color",
          "hover:ai-tw-text-content-on-color active:ai-tw-text-content-on-color",
          "disabled:ai-tw-text-content-on-color"
        ]
      },
      size: {
        md: "ai-tw-text-sm ai-tw-button-md",
        sm: "ai-tw-text-xs ai-tw-button-sm"
      }
    }
  }
), ju = Ee(
  ({ children: e, className: t = "", variant: n = "primary", size: r = "md", ...i }, o) => /* @__PURE__ */ y.createElement(
    "button",
    {
      className: le(IB({ variant: n, size: r }), t),
      ...i,
      ref: o
    },
    e
  )
);
ju.displayName = "ButtonText";
const r6 = "Dialog", [i6, Ese] = ar(r6), [LB, Gr] = i6(r6), FB = (e) => {
  const { __scopeDialog: t, children: n, open: r, defaultOpen: i, onOpenChange: o, modal: a = !0 } = e, s = he(null), c = he(null), [f = !1, p] = si({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ K(LB, {
    scope: t,
    triggerRef: s,
    contentRef: c,
    contentId: zr(),
    titleId: zr(),
    descriptionId: zr(),
    open: f,
    onOpenChange: p,
    onOpenToggle: Me(
      () => p(
        (d) => !d
      ),
      [
        p
      ]
    ),
    modal: a
  }, n);
}, zB = "DialogTrigger", VB = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeDialog: n, ...r } = e, i = Gr(zB, n), o = Lt(t, i.triggerRef);
  return /* @__PURE__ */ K(st.button, de({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": i.open,
    "aria-controls": i.contentId,
    "data-state": z1(i.open)
  }, r, {
    ref: o,
    onClick: Oe(e.onClick, i.onOpenToggle)
  }));
}), o6 = "DialogPortal", [BB, a6] = i6(o6, {
  forceMount: void 0
}), HB = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: i } = e, o = Gr(o6, t);
  return /* @__PURE__ */ K(BB, {
    scope: t,
    forceMount: n
  }, io.map(
    r,
    (a) => /* @__PURE__ */ K($n, {
      present: n || o.open
    }, /* @__PURE__ */ K(Ef, {
      asChild: !0,
      container: i
    }, a))
  ));
}, Fm = "DialogOverlay", UB = /* @__PURE__ */ Ee((e, t) => {
  const n = a6(Fm, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = Gr(Fm, e.__scopeDialog);
  return o.modal ? /* @__PURE__ */ K($n, {
    present: r || o.open
  }, /* @__PURE__ */ K(WB, de({}, i, {
    ref: t
  }))) : null;
}), WB = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeDialog: n, ...r } = e, i = Gr(Fm, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ K(jg, {
      as: Ti,
      allowPinchZoom: !0,
      shards: [
        i.contentRef
      ]
    }, /* @__PURE__ */ K(st.div, de({
      "data-state": z1(i.open)
    }, r, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), fl = "DialogContent", jB = /* @__PURE__ */ Ee((e, t) => {
  const n = a6(fl, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = Gr(fl, e.__scopeDialog);
  return /* @__PURE__ */ K($n, {
    present: r || o.open
  }, o.modal ? /* @__PURE__ */ K(qB, de({}, i, {
    ref: t
  })) : /* @__PURE__ */ K(GB, de({}, i, {
    ref: t
  })));
}), qB = /* @__PURE__ */ Ee((e, t) => {
  const n = Gr(fl, e.__scopeDialog), r = he(null), i = Lt(t, n.contentRef, r);
  return _e(() => {
    const o = r.current;
    if (o)
      return Wg(o);
  }, []), /* @__PURE__ */ K(s6, de({}, e, {
    ref: i,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: Oe(e.onCloseAutoFocus, (o) => {
      var a;
      o.preventDefault(), (a = n.triggerRef.current) === null || a === void 0 || a.focus();
    }),
    onPointerDownOutside: Oe(e.onPointerDownOutside, (o) => {
      const a = o.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
      (a.button === 2 || s) && o.preventDefault();
    }),
    onFocusOutside: Oe(
      e.onFocusOutside,
      (o) => o.preventDefault()
    )
  }));
}), GB = /* @__PURE__ */ Ee((e, t) => {
  const n = Gr(fl, e.__scopeDialog), r = he(!1), i = he(!1);
  return /* @__PURE__ */ K(s6, de({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (o) => {
      var a;
      if ((a = e.onCloseAutoFocus) === null || a === void 0 || a.call(e, o), !o.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), o.preventDefault();
      }
      r.current = !1, i.current = !1;
    },
    onInteractOutside: (o) => {
      var a, s;
      (a = e.onInteractOutside) === null || a === void 0 || a.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
      const c = o.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
    }
  }));
}), s6 = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, ...a } = e, s = Gr(fl, n), c = he(null), f = Lt(t, c);
  return Mg(), /* @__PURE__ */ K(Pg, null, /* @__PURE__ */ K(Dg, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o
  }, /* @__PURE__ */ K(vf, de({
    role: "dialog",
    id: s.contentId,
    "aria-describedby": s.descriptionId,
    "aria-labelledby": s.titleId,
    "data-state": z1(s.open)
  }, a, {
    ref: f,
    onDismiss: () => s.onOpenChange(!1)
  }))), !1);
}), YB = "DialogTitle", KB = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeDialog: n, ...r } = e, i = Gr(YB, n);
  return /* @__PURE__ */ K(st.h2, de({
    id: i.titleId
  }, r, {
    ref: t
  }));
}), XB = "DialogDescription", QB = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeDialog: n, ...r } = e, i = Gr(XB, n);
  return /* @__PURE__ */ K(st.p, de({
    id: i.descriptionId
  }, r, {
    ref: t
  }));
}), ZB = "DialogClose", JB = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeDialog: n, ...r } = e, i = Gr(ZB, n);
  return /* @__PURE__ */ K(st.button, de({
    type: "button"
  }, r, {
    ref: t,
    onClick: Oe(
      e.onClick,
      () => i.onOpenChange(!1)
    )
  }));
});
function z1(e) {
  return e ? "open" : "closed";
}
const l6 = FB, eH = VB, tH = HB, V1 = UB, B1 = jB, H1 = KB, U1 = QB, c6 = JB, W1 = l6, Cse = eH, nH = tH, zm = c6, u6 = D.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ D.createElement(
  V1,
  {
    ref: n,
    className: le(
      "ai-tw- ai-tw-fixed ai-tw-inset-0 ai-tw-z-[1200] ai-tw-bg-black/40 data-[state=open]:ai-tw-animate-in data-[state=closed]:ai-tw-animate-out data-[state=closed]:ai-tw-fade-out-0 data-[state=open]:ai-tw-fade-in-0",
      e
    ),
    ...t
  }
));
u6.displayName = V1.displayName;
const Wf = D.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ D.createElement(nH, null, /* @__PURE__ */ D.createElement(u6, null), /* @__PURE__ */ D.createElement(
  B1,
  {
    ref: r,
    className: le(
      "ai-tw-preflight",
      "ai-tw-fixed ai-tw-left-[50%] ai-tw-top-[50%] ai-tw-z-[1200] ai-tw-grid ai-tw-max-h-screen ai-tw-w-screen ai-tw-max-w-xl ai-tw-translate-x-[-50%] ai-tw-translate-y-[-50%] ai-tw-gap-4 ai-tw-overflow-auto ai-tw-rounded-lg ai-tw-bg-background ai-tw-p-8 ai-tw-text-foreground ai-tw-shadow-modal ai-tw-duration-200 data-[state=open]:ai-tw-animate-in data-[state=closed]:ai-tw-animate-out data-[state=closed]:ai-tw-fade-out-0 data-[state=open]:ai-tw-fade-in-0 data-[state=closed]:ai-tw-zoom-out-95 data-[state=open]:ai-tw-zoom-in-95 data-[state=closed]:ai-tw-slide-out-to-left-1/2 data-[state=closed]:ai-tw-slide-out-to-top-[48%] data-[state=open]:ai-tw-slide-in-from-left-1/2 data-[state=open]:ai-tw-slide-in-from-top-[48%]",
      e
    ),
    ...n
  },
  t,
  /* @__PURE__ */ D.createElement(
    c6,
    {
      asChild: !0,
      className: "ai-tw-absolute ai-tw-right-8 ai-tw-top-8 disabled:ai-tw-pointer-events-none data-[state=open]:ai-tw-bg-accent data-[state=open]:ai-tw-text-muted-foreground"
    },
    /* @__PURE__ */ D.createElement(Jt, { size: "icon", variant: "tertiary" }, /* @__PURE__ */ D.createElement(Ne, { icon: Og }), /* @__PURE__ */ D.createElement("span", { className: "ai-tw-sr-only" }, "Close"))
  )
)));
Wf.displayName = B1.displayName;
const j1 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ D.createElement(
  "div",
  {
    className: le(
      "ai-tw-flex ai-tw-flex-col ai-tw-space-y-1.5 ai-tw-text-center sm:ai-tw-text-left",
      e
    ),
    ...t
  }
);
j1.displayName = "DialogHeader";
const rH = ({
  className: e,
  ...t
}) => /* @__PURE__ */ D.createElement(
  "div",
  {
    className: le(
      "ai-tw-flex ai-tw-flex-col-reverse sm:ai-tw-flex-row sm:ai-tw-justify-between sm:ai-tw-space-x-2",
      e
    ),
    ...t
  }
);
rH.displayName = "DialogFooter";
const q1 = D.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ D.createElement(
  H1,
  {
    ref: n,
    className: le("ai-tw-text-content-primary ai-tw-heading-1", e),
    ...t
  }
));
q1.displayName = H1.displayName;
const iH = D.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ D.createElement(
  U1,
  {
    ref: n,
    className: le("ai-tw-text-muted-foreground ai-tw-subtitle-md", e),
    ...t
  }
));
iH.displayName = U1.displayName;
const oH = ({
  open: e,
  setOpen: t,
  handleDelete: n
}) => /* @__PURE__ */ y.createElement(W1, { open: e, onOpenChange: t }, /* @__PURE__ */ y.createElement(Wf, { className: "ai-tw-gap-8" }, /* @__PURE__ */ y.createElement(j1, null, /* @__PURE__ */ y.createElement(q1, null, "Delete Recording")), /* @__PURE__ */ y.createElement("p", null, "Are you sure you want to delete this recording?", /* @__PURE__ */ y.createElement("br", null), " It will delete the recording, transcript, and summary."), /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-justify-between" }, /* @__PURE__ */ y.createElement(zm, { asChild: !0 }, /* @__PURE__ */ y.createElement(Jt, { variant: "tertiary" }, "Cancel")), /* @__PURE__ */ y.createElement(zm, { asChild: !0 }, /* @__PURE__ */ y.createElement(Jt, { onClick: n, variant: "destructive" }, "Yes, Delete")))));
function G1(e) {
  const t = e + "CollectionProvider", [n, r] = ar(t), [i, o] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), a = (m) => {
    const { scope: v, children: w } = m, b = y.useRef(null), E = y.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ y.createElement(i, {
      scope: v,
      itemMap: E,
      collectionRef: b
    }, w);
  }, s = e + "CollectionSlot", c = /* @__PURE__ */ y.forwardRef((m, v) => {
    const { scope: w, children: b } = m, E = o(s, w), C = Lt(v, E.collectionRef);
    return /* @__PURE__ */ y.createElement(Ti, {
      ref: C
    }, b);
  }), f = e + "CollectionItemSlot", p = "data-radix-collection-item", d = /* @__PURE__ */ y.forwardRef((m, v) => {
    const { scope: w, children: b, ...E } = m, C = y.useRef(null), S = Lt(v, C), _ = o(f, w);
    return y.useEffect(() => (_.itemMap.set(C, {
      ref: C,
      ...E
    }), () => void _.itemMap.delete(C))), /* @__PURE__ */ y.createElement(Ti, {
      [p]: "",
      ref: S
    }, b);
  });
  function h(m) {
    const v = o(e + "CollectionConsumer", m);
    return y.useCallback(() => {
      const b = v.collectionRef.current;
      if (!b)
        return [];
      const E = Array.from(b.querySelectorAll(`[${p}]`));
      return Array.from(v.itemMap.values()).sort(
        (_, T) => E.indexOf(_.ref.current) - E.indexOf(T.ref.current)
      );
    }, [
      v.collectionRef,
      v.itemMap
    ]);
  }
  return [
    {
      Provider: a,
      Slot: c,
      ItemSlot: d
    },
    h,
    r
  ];
}
const aH = /* @__PURE__ */ ln(void 0);
function Tl(e) {
  const t = Re(aH);
  return e || t || "ltr";
}
const fh = "rovingFocusGroup.onEntryFocus", sH = {
  bubbles: !1,
  cancelable: !0
}, Y1 = "RovingFocusGroup", [Vm, f6, lH] = G1(Y1), [cH, Qa] = ar(Y1, [
  lH
]), [uH, fH] = cH(Y1), dH = /* @__PURE__ */ Ee((e, t) => /* @__PURE__ */ K(Vm.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ K(Vm.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ K(pH, de({}, e, {
  ref: t
}))))), pH = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeRovingFocusGroup: n, orientation: r, loop: i = !1, dir: o, currentTabStopId: a, defaultCurrentTabStopId: s, onCurrentTabStopIdChange: c, onEntryFocus: f, ...p } = e, d = he(null), h = Lt(t, d), m = Tl(o), [v = null, w] = si({
    prop: a,
    defaultProp: s,
    onChange: c
  }), [b, E] = ue(!1), C = ri(f), S = f6(n), _ = he(!1), [T, P] = ue(0);
  return _e(() => {
    const R = d.current;
    if (R)
      return R.addEventListener(fh, C), () => R.removeEventListener(fh, C);
  }, [
    C
  ]), /* @__PURE__ */ K(uH, {
    scope: n,
    orientation: r,
    dir: m,
    loop: i,
    currentTabStopId: v,
    onItemFocus: Me(
      (R) => w(R),
      [
        w
      ]
    ),
    onItemShiftTab: Me(
      () => E(!0),
      []
    ),
    onFocusableItemAdd: Me(
      () => P(
        (R) => R + 1
      ),
      []
    ),
    onFocusableItemRemove: Me(
      () => P(
        (R) => R - 1
      ),
      []
    )
  }, /* @__PURE__ */ K(st.div, de({
    tabIndex: b || T === 0 ? -1 : 0,
    "data-orientation": r
  }, p, {
    ref: h,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: Oe(e.onMouseDown, () => {
      _.current = !0;
    }),
    onFocus: Oe(e.onFocus, (R) => {
      const N = !_.current;
      if (R.target === R.currentTarget && N && !b) {
        const B = new CustomEvent(fh, sH);
        if (R.currentTarget.dispatchEvent(B), !B.defaultPrevented) {
          const L = S().filter(
            (G) => G.focusable
          ), j = L.find(
            (G) => G.active
          ), I = L.find(
            (G) => G.id === v
          ), H = [
            j,
            I,
            ...L
          ].filter(Boolean).map(
            (G) => G.ref.current
          );
          d6(H);
        }
      }
      _.current = !1;
    }),
    onBlur: Oe(
      e.onBlur,
      () => E(!1)
    )
  })));
}), hH = "RovingFocusGroupItem", mH = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeRovingFocusGroup: n, focusable: r = !0, active: i = !1, tabStopId: o, ...a } = e, s = zr(), c = o || s, f = fH(hH, n), p = f.currentTabStopId === c, d = f6(n), { onFocusableItemAdd: h, onFocusableItemRemove: m } = f;
  return _e(() => {
    if (r)
      return h(), () => m();
  }, [
    r,
    h,
    m
  ]), /* @__PURE__ */ K(Vm.ItemSlot, {
    scope: n,
    id: c,
    focusable: r,
    active: i
  }, /* @__PURE__ */ K(st.span, de({
    tabIndex: p ? 0 : -1,
    "data-orientation": f.orientation
  }, a, {
    ref: t,
    onMouseDown: Oe(e.onMouseDown, (v) => {
      r ? f.onItemFocus(c) : v.preventDefault();
    }),
    onFocus: Oe(
      e.onFocus,
      () => f.onItemFocus(c)
    ),
    onKeyDown: Oe(e.onKeyDown, (v) => {
      if (v.key === "Tab" && v.shiftKey) {
        f.onItemShiftTab();
        return;
      }
      if (v.target !== v.currentTarget)
        return;
      const w = wH(v, f.orientation, f.dir);
      if (w !== void 0) {
        v.preventDefault();
        let E = d().filter(
          (C) => C.focusable
        ).map(
          (C) => C.ref.current
        );
        if (w === "last")
          E.reverse();
        else if (w === "prev" || w === "next") {
          w === "prev" && E.reverse();
          const C = E.indexOf(v.currentTarget);
          E = f.loop ? yH(E, C + 1) : E.slice(C + 1);
        }
        setTimeout(
          () => d6(E)
        );
      }
    })
  })));
}), gH = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function vH(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function wH(e, t, n) {
  const r = vH(e.key, n);
  if (!(t === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(r)) && !(t === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(r)))
    return gH[r];
}
function d6(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function yH(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
const K1 = dH, X1 = mH;
function bH(e) {
  const t = he({
    value: e,
    previous: e
  });
  return yn(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
const p6 = "Radio", [xH, h6] = ar(p6), [EH, CH] = xH(p6), SH = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeRadio: n, name: r, checked: i = !1, required: o, disabled: a, value: s = "on", onCheck: c, ...f } = e, [p, d] = ue(null), h = Lt(
    t,
    (w) => d(w)
  ), m = he(!1), v = p ? !!p.closest("form") : !0;
  return /* @__PURE__ */ K(EH, {
    scope: n,
    checked: i,
    disabled: a
  }, /* @__PURE__ */ K(st.button, de({
    type: "button",
    role: "radio",
    "aria-checked": i,
    "data-state": m6(i),
    "data-disabled": a ? "" : void 0,
    disabled: a,
    value: s
  }, f, {
    ref: h,
    onClick: Oe(e.onClick, (w) => {
      i || c == null || c(), v && (m.current = w.isPropagationStopped(), m.current || w.stopPropagation());
    })
  })), v && /* @__PURE__ */ K(kH, {
    control: p,
    bubbles: !m.current,
    name: r,
    value: s,
    checked: i,
    required: o,
    disabled: a,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), _H = "RadioIndicator", TH = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeRadio: n, forceMount: r, ...i } = e, o = CH(_H, n);
  return /* @__PURE__ */ K($n, {
    present: r || o.checked
  }, /* @__PURE__ */ K(st.span, de({
    "data-state": m6(o.checked),
    "data-disabled": o.disabled ? "" : void 0
  }, i, {
    ref: t
  })));
}), kH = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...i } = e, o = he(null), a = bH(n), s = J4(t);
  return _e(() => {
    const c = o.current, f = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(f, "checked").set;
    if (a !== n && d) {
      const h = new Event("click", {
        bubbles: r
      });
      d.call(c, n), c.dispatchEvent(h);
    }
  }, [
    a,
    n,
    r
  ]), /* @__PURE__ */ K("input", de({
    type: "radio",
    "aria-hidden": !0,
    defaultChecked: n
  }, i, {
    tabIndex: -1,
    ref: o,
    style: {
      ...e.style,
      ...s,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function m6(e) {
  return e ? "checked" : "unchecked";
}
const PH = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], g6 = "RadioGroup", [AH, Sse] = ar(g6, [
  Qa,
  h6
]), v6 = Qa(), w6 = h6(), [RH, $H] = AH(g6), OH = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeRadioGroup: n, name: r, defaultValue: i, value: o, required: a = !1, disabled: s = !1, orientation: c, dir: f, loop: p = !0, onValueChange: d, ...h } = e, m = v6(n), v = Tl(f), [w, b] = si({
    prop: o,
    defaultProp: i,
    onChange: d
  });
  return /* @__PURE__ */ K(RH, {
    scope: n,
    name: r,
    required: a,
    disabled: s,
    value: w,
    onValueChange: b
  }, /* @__PURE__ */ K(K1, de({
    asChild: !0
  }, m, {
    orientation: c,
    dir: v,
    loop: p
  }), /* @__PURE__ */ K(st.div, de({
    role: "radiogroup",
    "aria-required": a,
    "aria-orientation": c,
    "data-disabled": s ? "" : void 0,
    dir: v
  }, h, {
    ref: t
  }))));
}), MH = "RadioGroupItem", DH = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeRadioGroup: n, disabled: r, ...i } = e, o = $H(MH, n), a = o.disabled || r, s = v6(n), c = w6(n), f = he(null), p = Lt(t, f), d = o.value === i.value, h = he(!1);
  return _e(() => {
    const m = (w) => {
      PH.includes(w.key) && (h.current = !0);
    }, v = () => h.current = !1;
    return document.addEventListener("keydown", m), document.addEventListener("keyup", v), () => {
      document.removeEventListener("keydown", m), document.removeEventListener("keyup", v);
    };
  }, []), /* @__PURE__ */ K(X1, de({
    asChild: !0
  }, s, {
    focusable: !a,
    active: d
  }), /* @__PURE__ */ K(SH, de({
    disabled: a,
    required: o.required,
    checked: d
  }, c, i, {
    name: o.name,
    ref: p,
    onCheck: () => o.onValueChange(i.value),
    onKeyDown: Oe((m) => {
      m.key === "Enter" && m.preventDefault();
    }),
    onFocus: Oe(i.onFocus, () => {
      var m;
      h.current && ((m = f.current) === null || m === void 0 || m.click());
    })
  })));
}), NH = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeRadioGroup: n, ...r } = e, i = w6(n);
  return /* @__PURE__ */ K(TH, de({}, i, r, {
    ref: t
  }));
}), Q1 = OH, qu = DH, IH = NH, S2 = li(
  [
    "ai-tw-grid ai-tw-cursor-pointer ai-tw-place-items-center",
    "ai-tw-rounded-lg ai-tw-border ai-tw-border-grey-20 ai-tw-p-4",
    "disabled:ai-tw-opacity-40"
  ],
  {
    variants: {
      value: {
        positive: [
          "data-[state=checked]:ai-tw-bg-element-success-light data-[state=checked]:ai-tw-text-element-success",
          "hover:enabled:ai-tw-border-element-success focus:enabled:ai-tw-border-element-success"
        ],
        negative: [
          "data-[state=checked]:ai-tw-bg-element-critical-light data-[state=checked]:ai-tw-text-element-critical",
          "hover:enabled:ai-tw-border-element-critical focus:enabled:ai-tw-border-element-critical"
        ]
      }
    }
  }
);
function y6({
  className: e,
  onValueChange: t,
  ...n
}) {
  const [r, i] = D.useState("");
  return /* @__PURE__ */ D.createElement("div", { className: "ai-tw-preflight ai-tw-grid ai-tw-gap-2" }, /* @__PURE__ */ D.createElement(
    Q1,
    {
      name: "result",
      className: le(e, "ai-tw-grid ai-tw-grid-cols-2 ai-tw-gap-3"),
      onInvalid: (o) => {
        o.preventDefault(), i("Please select an option");
      },
      onValueChange: (o) => {
        o && i(""), t && t(o);
      },
      ...n
    },
    /* @__PURE__ */ D.createElement(
      qu,
      {
        className: le(S2({ value: "negative" })),
        value: "negative"
      },
      /* @__PURE__ */ D.createElement(Ne, { className: "ai-tw-h-5", icon: IR })
    ),
    /* @__PURE__ */ D.createElement(
      qu,
      {
        className: le(S2({ value: "positive" })),
        value: "positive"
      },
      /* @__PURE__ */ D.createElement(Ne, { className: "ai-tw-h-5", icon: YR })
    )
  ), !!r && /* @__PURE__ */ D.createElement("p", { className: "ai-tw-text-sm ai-tw-text-red-50" }, r));
}
const LH = () => (e, t, n = {}) => {
  const { mutate: r } = E1(), i = he(e), o = he(t), a = he(n), s = he(0), [c, f, p] = pz({
    data: rn,
    error: rn,
    isMutating: !1
  }), d = c.current, h = Me(
    async (v, w) => {
      const [b, E] = Ho(i.current);
      if (!o.current)
        throw new Error("Can’t trigger the mutation: missing fetcher.");
      if (!b)
        throw new Error("Can’t trigger the mutation: missing key.");
      const C = br(br({
        populateCache: !1,
        throwOnError: !0
      }, a.current), w), S = al();
      s.current = S, p({
        isMutating: !0
      });
      try {
        const _ = await r(
          b,
          o.current(E, {
            arg: v
          }),
          // We must throw the error here so we can catch and update the states.
          br(C, {
            throwOnError: !0
          })
        );
        return s.current <= S && (p({
          data: _,
          isMutating: !1,
          error: void 0
        }), C.onSuccess == null || C.onSuccess(_, b, C)), _;
      } catch (_) {
        if (s.current <= S && (p({
          error: _,
          isMutating: !1
        }), C.onError == null || C.onError(_, b, C), C.throwOnError))
          throw _;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), m = Me(() => {
    s.current = al(), p({
      data: rn,
      error: rn,
      isMutating: !1
    });
  }, []);
  return Fo(() => {
    i.current = e, o.current = t, a.current = n;
  }), {
    trigger: h,
    reset: m,
    get data() {
      return f.data = !0, d.data;
    },
    get error() {
      return f.error = !0, d.error;
    },
    get isMutating() {
      return f.isMutating = !0, d.isMutating;
    }
  };
}, jf = C1(qr, LH);
function FH(e) {
  const t = xn(), n = e ? `/transcription/${e}` : null;
  return Mf(
    n,
    (r) => t(r, {
      timeout: 10 * 1e3
    }),
    {
      errorRetryCount: 1
    }
  );
}
function zH(e) {
  const t = xn(), n = `/transcription/${e}`;
  return Me(() => t(n, {
    method: "DELETE"
  }), [t, n]);
}
function VH(e) {
  const t = xn(), n = `/transcription/${e}/feedback`;
  async function r(i, {
    arg: o
  }) {
    const { result: a, feedbackFor: s, comment: c, runId: f } = o;
    if (!["positive", "negative"].includes(a))
      throw new Error('Feedback must be "positive" or "negative"');
    if (!["summary", "transcription"].includes(s))
      throw new Error('Feedback for must be "summary" or "transcription"');
    return await new Promise((p) => setTimeout(p, 1e3)), o.feedbackFor === "summary" ? t(n, {
      method: "POST",
      json: {
        summary: {
          result: a,
          comment: c,
          runId: f
        }
      }
    }) : t(n, {
      method: "POST",
      json: {
        transcription: {
          result: a,
          comment: c
        }
      }
    });
  }
  return jf(n, r, {});
}
const BH = /* @__PURE__ */ Ee((e, t) => /* @__PURE__ */ K(st.label, de({}, e, {
  ref: t,
  onMouseDown: (n) => {
    var r;
    (r = e.onMouseDown) === null || r === void 0 || r.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault();
  }
}))), b6 = BH, HH = li(
  "ai-tw-leading-none peer-disabled:ai-tw-cursor-not-allowed peer-disabled:ai-tw-opacity-70"
), Bm = D.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ D.createElement(
  b6,
  {
    ref: n,
    className: le(HH(), "ai-tw-body-md", e),
    ...t
  }
));
Bm.displayName = b6.displayName;
var UH = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const WH = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), qf = (e, t) => {
  const n = Ee(
    ({ color: r = "currentColor", size: i = 24, strokeWidth: o = 2, absoluteStrokeWidth: a, children: s, ...c }, f) => K(
      "svg",
      {
        ref: f,
        ...UH,
        width: i,
        height: i,
        stroke: r,
        strokeWidth: a ? Number(o) * 24 / Number(i) : o,
        className: `lucide lucide-${WH(e)}`,
        ...c
      },
      [
        ...t.map(([p, d]) => K(p, d)),
        ...(Array.isArray(s) ? s : [s]) || []
      ]
    )
  );
  return n.displayName = `${e}`, n;
}, jH = qf("Check", [
  ["polyline", { points: "20 6 9 17 4 12", key: "10jjfj" }]
]), qH = qf("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]), x6 = qf("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]), GH = qf("Option", [
  ["path", { d: "M3 3h6l6 18h6", key: "ph9rgk" }],
  ["path", { d: "M14 3h7", key: "16f0ms" }]
]), E6 = D.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ D.createElement(
  Q1,
  {
    className: le("ai-tw-grid ai-tw-gap-2", e),
    ...t,
    ref: n
  }
));
E6.displayName = Q1.displayName;
const Hm = D.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ D.createElement(
  qu,
  {
    ref: n,
    className: le(
      "ai-tw-aspect-square ai-tw-h-4 ai-tw-w-4 ai-tw-rounded-full ai-tw-border ai-tw-border-primary ai-tw-text-primary ai-tw-ring-offset-background focus:ai-tw-outline-none focus-visible:ai-tw-ring-2 focus-visible:ai-tw-ring-ring focus-visible:ai-tw-ring-offset-2 disabled:ai-tw-cursor-not-allowed disabled:ai-tw-opacity-50",
      e
    ),
    ...t
  },
  /* @__PURE__ */ D.createElement(IH, { className: "ai-tw-flex ai-tw-items-center ai-tw-justify-center" }, /* @__PURE__ */ D.createElement(x6, { className: "ai-tw-h-2.5 ai-tw-w-2.5 ai-tw-fill-current ai-tw-text-current" }))
));
Hm.displayName = qu.displayName;
const YH = ({
  callSID: e,
  open: t,
  setOpen: n,
  runId: r
}) => {
  const [i, o] = ue(), [a, s] = ue(!1), {
    trigger: c,
    error: f,
    isMutating: p
  } = VH(e);
  return /* @__PURE__ */ y.createElement(W1, { open: t, onOpenChange: n }, /* @__PURE__ */ y.createElement(Wf, { className: "ai-tw-max-w-xl ai-tw-gap-6" }, /* @__PURE__ */ y.createElement(j1, null, /* @__PURE__ */ y.createElement(q1, null, "Provide Feedback")), /* @__PURE__ */ y.createElement("p", null, "Tell us about your experience with call recording and transcription."), /* @__PURE__ */ y.createElement(
    "form",
    {
      onSubmit: (d) => {
        d.preventDefault();
        const h = d.target, m = new FormData(h);
        c({
          result: m.get("result"),
          feedbackFor: m.get("feedbackFor"),
          comment: m.get("comment"),
          runId: r
        }).then(() => {
          s(!0), setTimeout(() => {
            n(!1), s(!1);
          }, 1500);
        }).catch((v) => {
          console.error(v);
        });
      },
      className: "ai-tw-grid ai-tw-gap-6",
      action: ""
    },
    /* @__PURE__ */ y.createElement(
      y6,
      {
        name: "result",
        required: !0,
        onValueChange: o
      }
    ),
    /* @__PURE__ */ y.createElement(KH, null),
    /* @__PURE__ */ y.createElement(
      Lf,
      {
        rows: 3,
        name: "comment",
        labelText: i === "positive" ? "What went well?" : "What can be improved?"
      }
    ),
    f && /* @__PURE__ */ y.createElement("p", { className: "ai-tw-text-sm ai-tw-text-red-50" }, /* @__PURE__ */ y.createElement(
      Ne,
      {
        icon: lo,
        className: "ai-tw-mr-2"
      }
    ), "Error submitting feedback. Please try again."),
    a && /* @__PURE__ */ y.createElement("p", { className: "ai-tw-text-sm ai-tw-text-green-50" }, /* @__PURE__ */ y.createElement(Ne, { icon: _R, className: "ai-tw-mr-2" }), "Feedback submitted successfully."),
    /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-justify-between" }, /* @__PURE__ */ y.createElement(zm, { asChild: !0 }, /* @__PURE__ */ y.createElement(Jt, { variant: "tertiary" }, "Cancel")), /* @__PURE__ */ y.createElement(
      Jt,
      {
        type: "submit",
        variant: "primary",
        status: p ? "loading" : a ? "success" : "default"
      },
      "Submit"
    ))
  )));
};
function KH() {
  const [e, t] = ue("");
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-grid ai-tw-gap-2" }, /* @__PURE__ */ y.createElement("label", { className: "ai-tw-font-semibold ai-tw-text-content-primary-light ai-tw-subtitle-md" }, "What are you submitting feedback for?", /* @__PURE__ */ y.createElement("span", { className: "ai-tw-ml-1 ai-tw-text-destructive" }, "*")), /* @__PURE__ */ y.createElement(
    E6,
    {
      onInvalid: (n) => {
        n.preventDefault(), t("Please select an option");
      },
      onValueChange: (n) => {
        n && t("");
      },
      required: !0,
      name: "feedbackFor"
    },
    /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-2" }, /* @__PURE__ */ y.createElement(Hm, { id: "for-transcription", value: "transcription" }), /* @__PURE__ */ y.createElement(Bm, { htmlFor: "for-transcription" }, "Transcript")),
    /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-2" }, /* @__PURE__ */ y.createElement(Hm, { id: "for-summary", value: "summary" }), /* @__PURE__ */ y.createElement(Bm, { htmlFor: "for-summary" }, "Summary"))
  ), !!e && /* @__PURE__ */ y.createElement("p", { className: "ai-tw-text-sm ai-tw-text-red-50" }, e));
}
const Um = [
  "Enter",
  " "
], XH = [
  "ArrowDown",
  "PageUp",
  "Home"
], C6 = [
  "ArrowUp",
  "PageDown",
  "End"
], QH = [
  ...XH,
  ...C6
], ZH = {
  ltr: [
    ...Um,
    "ArrowRight"
  ],
  rtl: [
    ...Um,
    "ArrowLeft"
  ]
}, JH = {
  ltr: [
    "ArrowLeft"
  ],
  rtl: [
    "ArrowRight"
  ]
}, Gf = "Menu", [dl, eU, tU] = G1(Gf), [Xo, S6] = ar(Gf, [
  tU,
  Ga,
  Qa
]), Z1 = Ga(), _6 = Qa(), [nU, Qo] = Xo(Gf), [rU, kl] = Xo(Gf), iU = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: i, onOpenChange: o, modal: a = !0 } = e, s = Z1(t), [c, f] = ue(null), p = he(!1), d = ri(o), h = Tl(i);
  return _e(() => {
    const m = () => {
      p.current = !0, document.addEventListener("pointerdown", v, {
        capture: !0,
        once: !0
      }), document.addEventListener("pointermove", v, {
        capture: !0,
        once: !0
      });
    }, v = () => p.current = !1;
    return document.addEventListener("keydown", m, {
      capture: !0
    }), () => {
      document.removeEventListener("keydown", m, {
        capture: !0
      }), document.removeEventListener("pointerdown", v, {
        capture: !0
      }), document.removeEventListener("pointermove", v, {
        capture: !0
      });
    };
  }, []), /* @__PURE__ */ K(Hg, s, /* @__PURE__ */ K(nU, {
    scope: t,
    open: n,
    onOpenChange: d,
    content: c,
    onContentChange: f
  }, /* @__PURE__ */ K(rU, {
    scope: t,
    onClose: Me(
      () => d(!1),
      [
        d
      ]
    ),
    isUsingKeyboardRef: p,
    dir: h,
    modal: a
  }, r)));
}, T6 = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeMenu: n, ...r } = e, i = Z1(n);
  return /* @__PURE__ */ K(xf, de({}, i, r, {
    ref: t
  }));
}), k6 = "MenuPortal", [oU, P6] = Xo(k6, {
  forceMount: void 0
}), aU = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: i } = e, o = Qo(k6, t);
  return /* @__PURE__ */ K(oU, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ K($n, {
    present: n || o.open
  }, /* @__PURE__ */ K(Ef, {
    asChild: !0,
    container: i
  }, r)));
}, Hr = "MenuContent", [sU, J1] = Xo(Hr), lU = /* @__PURE__ */ Ee((e, t) => {
  const n = P6(Hr, e.__scopeMenu), { forceMount: r = n.forceMount, ...i } = e, o = Qo(Hr, e.__scopeMenu), a = kl(Hr, e.__scopeMenu);
  return /* @__PURE__ */ K(dl.Provider, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ K($n, {
    present: r || o.open
  }, /* @__PURE__ */ K(dl.Slot, {
    scope: e.__scopeMenu
  }, a.modal ? /* @__PURE__ */ K(cU, de({}, i, {
    ref: t
  })) : /* @__PURE__ */ K(uU, de({}, i, {
    ref: t
  })))));
}), cU = /* @__PURE__ */ Ee((e, t) => {
  const n = Qo(Hr, e.__scopeMenu), r = he(null), i = Lt(t, r);
  return _e(() => {
    const o = r.current;
    if (o)
      return Wg(o);
  }, []), /* @__PURE__ */ K(ev, de({}, e, {
    ref: i,
    trapFocus: n.open,
    disableOutsidePointerEvents: n.open,
    disableOutsideScroll: !0,
    onFocusOutside: Oe(
      e.onFocusOutside,
      (o) => o.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    ),
    onDismiss: () => n.onOpenChange(!1)
  }));
}), uU = /* @__PURE__ */ Ee((e, t) => {
  const n = Qo(Hr, e.__scopeMenu);
  return /* @__PURE__ */ K(ev, de({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    onDismiss: () => n.onOpenChange(!1)
  }));
}), ev = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeMenu: n, loop: r = !1, trapFocus: i, onOpenAutoFocus: o, onCloseAutoFocus: a, disableOutsidePointerEvents: s, onEntryFocus: c, onEscapeKeyDown: f, onPointerDownOutside: p, onFocusOutside: d, onInteractOutside: h, onDismiss: m, disableOutsideScroll: v, ...w } = e, b = Qo(Hr, n), E = kl(Hr, n), C = Z1(n), S = _6(n), _ = eU(n), [T, P] = ue(null), R = he(null), N = Lt(t, R, b.onContentChange), B = he(0), L = he(""), j = he(0), I = he(null), z = he("right"), H = he(0), G = v ? jg : Pg, Y = v ? {
    as: Ti,
    allowPinchZoom: !0
  } : void 0, ne = (ee) => {
    var A, X;
    const fe = L.current + ee, M = _().filter(
      (me) => !me.disabled
    ), Z = document.activeElement, ie = (A = M.find(
      (me) => me.ref.current === Z
    )) === null || A === void 0 ? void 0 : A.textValue, pe = M.map(
      (me) => me.textValue
    ), Te = TU(pe, fe, ie), ke = (X = M.find(
      (me) => me.textValue === Te
    )) === null || X === void 0 ? void 0 : X.ref.current;
    (function me(Pe) {
      L.current = Pe, window.clearTimeout(B.current), Pe !== "" && (B.current = window.setTimeout(
        () => me(""),
        1e3
      ));
    })(fe), ke && setTimeout(
      () => ke.focus()
    );
  };
  _e(() => () => window.clearTimeout(B.current), []), Mg();
  const J = Me((ee) => {
    var A, X;
    return z.current === ((A = I.current) === null || A === void 0 ? void 0 : A.side) && PU(ee, (X = I.current) === null || X === void 0 ? void 0 : X.area);
  }, []);
  return /* @__PURE__ */ K(sU, {
    scope: n,
    searchRef: L,
    onItemEnter: Me((ee) => {
      J(ee) && ee.preventDefault();
    }, [
      J
    ]),
    onItemLeave: Me((ee) => {
      var A;
      J(ee) || ((A = R.current) === null || A === void 0 || A.focus(), P(null));
    }, [
      J
    ]),
    onTriggerLeave: Me((ee) => {
      J(ee) && ee.preventDefault();
    }, [
      J
    ]),
    pointerGraceTimerRef: j,
    onPointerGraceIntentChange: Me((ee) => {
      I.current = ee;
    }, [])
  }, /* @__PURE__ */ K(G, Y, /* @__PURE__ */ K(Dg, {
    asChild: !0,
    trapped: i,
    onMountAutoFocus: Oe(o, (ee) => {
      var A;
      ee.preventDefault(), (A = R.current) === null || A === void 0 || A.focus();
    }),
    onUnmountAutoFocus: a
  }, /* @__PURE__ */ K(vf, {
    asChild: !0,
    disableOutsidePointerEvents: s,
    onEscapeKeyDown: f,
    onPointerDownOutside: p,
    onFocusOutside: d,
    onInteractOutside: h,
    onDismiss: m
  }, /* @__PURE__ */ K(K1, de({
    asChild: !0
  }, S, {
    dir: E.dir,
    orientation: "vertical",
    loop: r,
    currentTabStopId: T,
    onCurrentTabStopIdChange: P,
    onEntryFocus: Oe(c, (ee) => {
      E.isUsingKeyboardRef.current || ee.preventDefault();
    })
  }), /* @__PURE__ */ K(Ug, de({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": M6(b.open),
    "data-radix-menu-content": "",
    dir: E.dir
  }, C, w, {
    ref: N,
    style: {
      outline: "none",
      ...w.style
    },
    onKeyDown: Oe(w.onKeyDown, (ee) => {
      const X = ee.target.closest("[data-radix-menu-content]") === ee.currentTarget, fe = ee.ctrlKey || ee.altKey || ee.metaKey, M = ee.key.length === 1;
      X && (ee.key === "Tab" && ee.preventDefault(), !fe && M && ne(ee.key));
      const Z = R.current;
      if (ee.target !== Z || !QH.includes(ee.key))
        return;
      ee.preventDefault();
      const pe = _().filter(
        (Te) => !Te.disabled
      ).map(
        (Te) => Te.ref.current
      );
      C6.includes(ee.key) && pe.reverse(), SU(pe);
    }),
    onBlur: Oe(e.onBlur, (ee) => {
      ee.currentTarget.contains(ee.target) || (window.clearTimeout(B.current), L.current = "");
    }),
    onPointerMove: Oe(e.onPointerMove, pl((ee) => {
      const A = ee.target, X = H.current !== ee.clientX;
      if (ee.currentTarget.contains(A) && X) {
        const fe = ee.clientX > H.current ? "right" : "left";
        z.current = fe, H.current = ee.clientX;
      }
    }))
  })))))));
}), fU = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeMenu: n, ...r } = e;
  return /* @__PURE__ */ K(st.div, de({}, r, {
    ref: t
  }));
}), Wm = "MenuItem", _2 = "menu.itemSelect", tv = /* @__PURE__ */ Ee((e, t) => {
  const { disabled: n = !1, onSelect: r, ...i } = e, o = he(null), a = kl(Wm, e.__scopeMenu), s = J1(Wm, e.__scopeMenu), c = Lt(t, o), f = he(!1), p = () => {
    const d = o.current;
    if (!n && d) {
      const h = new CustomEvent(_2, {
        bubbles: !0,
        cancelable: !0
      });
      d.addEventListener(
        _2,
        (m) => r == null ? void 0 : r(m),
        {
          once: !0
        }
      ), V4(d, h), h.defaultPrevented ? f.current = !1 : a.onClose();
    }
  };
  return /* @__PURE__ */ K(A6, de({}, i, {
    ref: c,
    disabled: n,
    onClick: Oe(e.onClick, p),
    onPointerDown: (d) => {
      var h;
      (h = e.onPointerDown) === null || h === void 0 || h.call(e, d), f.current = !0;
    },
    onPointerUp: Oe(e.onPointerUp, (d) => {
      var h;
      f.current || (h = d.currentTarget) === null || h === void 0 || h.click();
    }),
    onKeyDown: Oe(e.onKeyDown, (d) => {
      const h = s.searchRef.current !== "";
      n || h && d.key === " " || Um.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
    })
  }));
}), A6 = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeMenu: n, disabled: r = !1, textValue: i, ...o } = e, a = J1(Wm, n), s = _6(n), c = he(null), f = Lt(t, c), [p, d] = ue(!1), [h, m] = ue("");
  return _e(() => {
    const v = c.current;
    if (v) {
      var w;
      m(((w = v.textContent) !== null && w !== void 0 ? w : "").trim());
    }
  }, [
    o.children
  ]), /* @__PURE__ */ K(dl.ItemSlot, {
    scope: n,
    disabled: r,
    textValue: i ?? h
  }, /* @__PURE__ */ K(X1, de({
    asChild: !0
  }, s, {
    focusable: !r
  }), /* @__PURE__ */ K(st.div, de({
    role: "menuitem",
    "data-highlighted": p ? "" : void 0,
    "aria-disabled": r || void 0,
    "data-disabled": r ? "" : void 0
  }, o, {
    ref: f,
    onPointerMove: Oe(e.onPointerMove, pl((v) => {
      r ? a.onItemLeave(v) : (a.onItemEnter(v), v.defaultPrevented || v.currentTarget.focus());
    })),
    onPointerLeave: Oe(e.onPointerLeave, pl(
      (v) => a.onItemLeave(v)
    )),
    onFocus: Oe(
      e.onFocus,
      () => d(!0)
    ),
    onBlur: Oe(
      e.onBlur,
      () => d(!1)
    )
  }))));
}), dU = /* @__PURE__ */ Ee((e, t) => {
  const { checked: n = !1, onCheckedChange: r, ...i } = e;
  return /* @__PURE__ */ K($6, {
    scope: e.__scopeMenu,
    checked: n
  }, /* @__PURE__ */ K(tv, de({
    role: "menuitemcheckbox",
    "aria-checked": Gu(n) ? "mixed" : n
  }, i, {
    ref: t,
    "data-state": nv(n),
    onSelect: Oe(
      i.onSelect,
      () => r == null ? void 0 : r(Gu(n) ? !0 : !n),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), pU = "MenuRadioGroup", [_se, hU] = Xo(pU, {
  value: void 0,
  onValueChange: () => {
  }
}), mU = "MenuRadioItem", gU = /* @__PURE__ */ Ee((e, t) => {
  const { value: n, ...r } = e, i = hU(mU, e.__scopeMenu), o = n === i.value;
  return /* @__PURE__ */ K($6, {
    scope: e.__scopeMenu,
    checked: o
  }, /* @__PURE__ */ K(tv, de({
    role: "menuitemradio",
    "aria-checked": o
  }, r, {
    ref: t,
    "data-state": nv(o),
    onSelect: Oe(r.onSelect, () => {
      var a;
      return (a = i.onValueChange) === null || a === void 0 ? void 0 : a.call(i, n);
    }, {
      checkForDefaultPrevented: !1
    })
  })));
}), R6 = "MenuItemIndicator", [$6, vU] = Xo(R6, {
  checked: !1
}), wU = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeMenu: n, forceMount: r, ...i } = e, o = vU(R6, n);
  return /* @__PURE__ */ K($n, {
    present: r || Gu(o.checked) || o.checked === !0
  }, /* @__PURE__ */ K(st.span, de({}, i, {
    ref: t,
    "data-state": nv(o.checked)
  })));
}), yU = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeMenu: n, ...r } = e;
  return /* @__PURE__ */ K(st.div, de({
    role: "separator",
    "aria-orientation": "horizontal"
  }, r, {
    ref: t
  }));
}), bU = "MenuSub", [Tse, O6] = Xo(bU), Qc = "MenuSubTrigger", xU = /* @__PURE__ */ Ee((e, t) => {
  const n = Qo(Qc, e.__scopeMenu), r = kl(Qc, e.__scopeMenu), i = O6(Qc, e.__scopeMenu), o = J1(Qc, e.__scopeMenu), a = he(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: c } = o, f = {
    __scopeMenu: e.__scopeMenu
  }, p = Me(() => {
    a.current && window.clearTimeout(a.current), a.current = null;
  }, []);
  return _e(
    () => p,
    [
      p
    ]
  ), _e(() => {
    const d = s.current;
    return () => {
      window.clearTimeout(d), c(null);
    };
  }, [
    s,
    c
  ]), /* @__PURE__ */ K(T6, de({
    asChild: !0
  }, f), /* @__PURE__ */ K(A6, de({
    id: i.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": n.open,
    "aria-controls": i.contentId,
    "data-state": M6(n.open)
  }, e, {
    ref: gf(t, i.onTriggerChange),
    onClick: (d) => {
      var h;
      (h = e.onClick) === null || h === void 0 || h.call(e, d), !(e.disabled || d.defaultPrevented) && (d.currentTarget.focus(), n.open || n.onOpenChange(!0));
    },
    onPointerMove: Oe(e.onPointerMove, pl((d) => {
      o.onItemEnter(d), !d.defaultPrevented && !e.disabled && !n.open && !a.current && (o.onPointerGraceIntentChange(null), a.current = window.setTimeout(() => {
        n.onOpenChange(!0), p();
      }, 100));
    })),
    onPointerLeave: Oe(e.onPointerLeave, pl((d) => {
      var h;
      p();
      const m = (h = n.content) === null || h === void 0 ? void 0 : h.getBoundingClientRect();
      if (m) {
        var v;
        const w = (v = n.content) === null || v === void 0 ? void 0 : v.dataset.side, b = w === "right", E = b ? -5 : 5, C = m[b ? "left" : "right"], S = m[b ? "right" : "left"];
        o.onPointerGraceIntentChange({
          area: [
            // consistently within polygon bounds
            {
              x: d.clientX + E,
              y: d.clientY
            },
            {
              x: C,
              y: m.top
            },
            {
              x: S,
              y: m.top
            },
            {
              x: S,
              y: m.bottom
            },
            {
              x: C,
              y: m.bottom
            }
          ],
          side: w
        }), window.clearTimeout(s.current), s.current = window.setTimeout(
          () => o.onPointerGraceIntentChange(null),
          300
        );
      } else {
        if (o.onTriggerLeave(d), d.defaultPrevented)
          return;
        o.onPointerGraceIntentChange(null);
      }
    })),
    onKeyDown: Oe(e.onKeyDown, (d) => {
      const h = o.searchRef.current !== "";
      if (!(e.disabled || h && d.key === " ") && ZH[r.dir].includes(d.key)) {
        var m;
        n.onOpenChange(!0), (m = n.content) === null || m === void 0 || m.focus(), d.preventDefault();
      }
    })
  })));
}), EU = "MenuSubContent", CU = /* @__PURE__ */ Ee((e, t) => {
  const n = P6(Hr, e.__scopeMenu), { forceMount: r = n.forceMount, ...i } = e, o = Qo(Hr, e.__scopeMenu), a = kl(Hr, e.__scopeMenu), s = O6(EU, e.__scopeMenu), c = he(null), f = Lt(t, c);
  return /* @__PURE__ */ K(dl.Provider, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ K($n, {
    present: r || o.open
  }, /* @__PURE__ */ K(dl.Slot, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ K(ev, de({
    id: s.contentId,
    "aria-labelledby": s.triggerId
  }, i, {
    ref: f,
    align: "start",
    side: a.dir === "rtl" ? "left" : "right",
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    trapFocus: !1,
    onOpenAutoFocus: (p) => {
      var d;
      a.isUsingKeyboardRef.current && ((d = c.current) === null || d === void 0 || d.focus()), p.preventDefault();
    },
    onCloseAutoFocus: (p) => p.preventDefault(),
    onFocusOutside: Oe(e.onFocusOutside, (p) => {
      p.target !== s.trigger && o.onOpenChange(!1);
    }),
    onEscapeKeyDown: Oe(e.onEscapeKeyDown, (p) => {
      a.onClose(), p.preventDefault();
    }),
    onKeyDown: Oe(e.onKeyDown, (p) => {
      const d = p.currentTarget.contains(p.target), h = JH[a.dir].includes(p.key);
      if (d && h) {
        var m;
        o.onOpenChange(!1), (m = s.trigger) === null || m === void 0 || m.focus(), p.preventDefault();
      }
    })
  })))));
});
function M6(e) {
  return e ? "open" : "closed";
}
function Gu(e) {
  return e === "indeterminate";
}
function nv(e) {
  return Gu(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function SU(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function _U(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
function TU(e, t, n) {
  const i = t.length > 1 && Array.from(t).every(
    (f) => f === t[0]
  ) ? t[0] : t, o = n ? e.indexOf(n) : -1;
  let a = _U(e, Math.max(o, 0));
  i.length === 1 && (a = a.filter(
    (f) => f !== n
  ));
  const c = a.find(
    (f) => f.toLowerCase().startsWith(i.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function kU(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let o = 0, a = t.length - 1; o < t.length; a = o++) {
    const s = t[o].x, c = t[o].y, f = t[a].x, p = t[a].y;
    c > r != p > r && n < (f - s) * (r - c) / (p - c) + s && (i = !i);
  }
  return i;
}
function PU(e, t) {
  if (!t)
    return !1;
  const n = {
    x: e.clientX,
    y: e.clientY
  };
  return kU(n, t);
}
function pl(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
const AU = iU, RU = T6, $U = aU, OU = lU, MU = fU, DU = tv, NU = dU, IU = gU, LU = wU, FU = yU, zU = xU, VU = CU, D6 = "DropdownMenu", [BU, kse] = ar(D6, [
  S6
]), Er = S6(), [HU, N6] = BU(D6), UU = (e) => {
  const { __scopeDropdownMenu: t, children: n, dir: r, open: i, defaultOpen: o, onOpenChange: a, modal: s = !0 } = e, c = Er(t), f = he(null), [p = !1, d] = si({
    prop: i,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ K(HU, {
    scope: t,
    triggerId: zr(),
    triggerRef: f,
    contentId: zr(),
    open: p,
    onOpenChange: d,
    onOpenToggle: Me(
      () => d(
        (h) => !h
      ),
      [
        d
      ]
    ),
    modal: s
  }, /* @__PURE__ */ K(AU, de({}, c, {
    open: p,
    onOpenChange: d,
    dir: r,
    modal: s
  }), n));
}, WU = "DropdownMenuTrigger", jU = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeDropdownMenu: n, disabled: r = !1, ...i } = e, o = N6(WU, n), a = Er(n);
  return /* @__PURE__ */ K(RU, de({
    asChild: !0
  }, a), /* @__PURE__ */ K(st.button, de({
    type: "button",
    id: o.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": o.open,
    "aria-controls": o.open ? o.contentId : void 0,
    "data-state": o.open ? "open" : "closed",
    "data-disabled": r ? "" : void 0,
    disabled: r
  }, i, {
    ref: gf(t, o.triggerRef),
    onPointerDown: Oe(e.onPointerDown, (s) => {
      !r && s.button === 0 && s.ctrlKey === !1 && (o.onOpenToggle(), o.open || s.preventDefault());
    }),
    onKeyDown: Oe(e.onKeyDown, (s) => {
      r || ([
        "Enter",
        " "
      ].includes(s.key) && o.onOpenToggle(), s.key === "ArrowDown" && o.onOpenChange(!0), [
        "Enter",
        " ",
        "ArrowDown"
      ].includes(s.key) && s.preventDefault());
    })
  })));
}), qU = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = Er(t);
  return /* @__PURE__ */ K($U, de({}, r, n));
}, GU = "DropdownMenuContent", YU = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = N6(GU, n), o = Er(n), a = he(!1);
  return /* @__PURE__ */ K(OU, de({
    id: i.contentId,
    "aria-labelledby": i.triggerId
  }, o, r, {
    ref: t,
    onCloseAutoFocus: Oe(e.onCloseAutoFocus, (s) => {
      var c;
      a.current || (c = i.triggerRef.current) === null || c === void 0 || c.focus(), a.current = !1, s.preventDefault();
    }),
    onInteractOutside: Oe(e.onInteractOutside, (s) => {
      const c = s.detail.originalEvent, f = c.button === 0 && c.ctrlKey === !0, p = c.button === 2 || f;
      (!i.modal || p) && (a.current = !0);
    }),
    style: {
      ...e.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), KU = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Er(n);
  return /* @__PURE__ */ K(MU, de({}, i, r, {
    ref: t
  }));
}), XU = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Er(n);
  return /* @__PURE__ */ K(DU, de({}, i, r, {
    ref: t
  }));
}), QU = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Er(n);
  return /* @__PURE__ */ K(NU, de({}, i, r, {
    ref: t
  }));
}), ZU = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Er(n);
  return /* @__PURE__ */ K(IU, de({}, i, r, {
    ref: t
  }));
}), JU = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Er(n);
  return /* @__PURE__ */ K(LU, de({}, i, r, {
    ref: t
  }));
}), eW = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Er(n);
  return /* @__PURE__ */ K(FU, de({}, i, r, {
    ref: t
  }));
}), tW = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Er(n);
  return /* @__PURE__ */ K(zU, de({}, i, r, {
    ref: t
  }));
}), nW = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Er(n);
  return /* @__PURE__ */ K(VU, de({}, i, r, {
    ref: t,
    style: {
      ...e.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), rW = UU, iW = jU, oW = qU, I6 = YU, L6 = KU, F6 = XU, z6 = QU, V6 = ZU, B6 = JU, H6 = eW, U6 = tW, W6 = nW, aW = rW, sW = iW, lW = D.forwardRef(({ className: e, inset: t, children: n, ...r }, i) => /* @__PURE__ */ D.createElement(
  U6,
  {
    ref: i,
    className: le(
      "ai-tw-flex ai-tw-cursor-default ai-tw-select-none ai-tw-items-center ai-tw-rounded-sm ai-tw-px-2 ai-tw-py-1.5 ai-tw-text-sm ai-tw-outline-none focus:ai-tw-bg-accent data-[state=open]:ai-tw-bg-accent",
      t && "ai-tw-pl-8",
      e
    ),
    ...r
  },
  n,
  /* @__PURE__ */ D.createElement(qH, { className: "ai-tw-ml-auto ai-tw-h-4 ai-tw-w-4" })
));
lW.displayName = U6.displayName;
const cW = D.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ D.createElement(
  W6,
  {
    ref: n,
    className: le(
      "ai-tw-z-[1200] ai-tw-min-w-[8rem] ai-tw-overflow-hidden ai-tw-rounded-md ai-tw-bg-popover ai-tw-p-1 ai-tw-text-popover-foreground ai-tw-shadow-dropdown data-[state=open]:ai-tw-animate-in data-[state=closed]:ai-tw-animate-out data-[state=closed]:ai-tw-fade-out-0 data-[state=open]:ai-tw-fade-in-0 data-[state=closed]:ai-tw-zoom-out-95 data-[state=open]:ai-tw-zoom-in-95 data-[side=bottom]:ai-tw-slide-in-from-top-2 data-[side=left]:ai-tw-slide-in-from-right-2 data-[side=right]:ai-tw-slide-in-from-left-2 data-[side=top]:ai-tw-slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
cW.displayName = W6.displayName;
const j6 = D.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ D.createElement(oW, null, /* @__PURE__ */ D.createElement(
  I6,
  {
    ref: r,
    sideOffset: t,
    className: le(
      "ai-tw-z-[1200] ai-tw-min-w-[8rem] ai-tw-overflow-hidden ai-tw-rounded-md ai-tw-bg-popover ai-tw-p-1 ai-tw-text-popover-foreground ai-tw-shadow-dropdown data-[state=open]:ai-tw-animate-in data-[state=closed]:ai-tw-animate-out data-[state=closed]:ai-tw-fade-out-0 data-[state=open]:ai-tw-fade-in-0 data-[state=closed]:ai-tw-zoom-out-95 data-[state=open]:ai-tw-zoom-in-95 data-[side=bottom]:ai-tw-slide-in-from-top-2 data-[side=left]:ai-tw-slide-in-from-right-2 data-[side=right]:ai-tw-slide-in-from-left-2 data-[side=top]:ai-tw-slide-in-from-bottom-2",
      e
    ),
    ...n
  }
)));
j6.displayName = I6.displayName;
const jm = D.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ D.createElement(
  F6,
  {
    ref: r,
    className: le(
      "ai-tw-relative ai-tw-flex ai-tw-cursor-pointer ai-tw-select-none ai-tw-items-center ai-tw-rounded-sm ai-tw-px-2 ai-tw-py-1.5 ai-tw-text-sm ai-tw-outline-none ai-tw-transition-colors focus:ai-tw-bg-accent focus:ai-tw-text-accent-foreground active:ai-tw-bg-element-primary-alt-dark data-[disabled]:ai-tw-pointer-events-none data-[disabled]:ai-tw-opacity-50",
      t && "ai-tw-pl-8",
      e
    ),
    ...n
  }
));
jm.displayName = F6.displayName;
const uW = D.forwardRef(({ className: e, children: t, checked: n, ...r }, i) => /* @__PURE__ */ D.createElement(
  z6,
  {
    ref: i,
    className: le(
      "ai-tw-relative ai-tw-flex ai-tw-cursor-pointer ai-tw-select-none ai-tw-items-center ai-tw-rounded-sm ai-tw-py-1.5 ai-tw-pl-8 ai-tw-pr-2 ai-tw-text-sm ai-tw-outline-none ai-tw-transition-colors focus:ai-tw-bg-accent focus:ai-tw-text-accent-foreground active:ai-tw-bg-element-primary-alt-dark data-[disabled]:ai-tw-pointer-events-none data-[state=checked]:ai-tw-font-bold data-[disabled]:ai-tw-opacity-50",
      e
    ),
    checked: n,
    ...r
  },
  /* @__PURE__ */ D.createElement("span", { className: "ai-tw-absolute ai-tw-left-2 ai-tw-flex ai-tw-h-3.5 ai-tw-w-3.5 ai-tw-items-center ai-tw-justify-center" }, /* @__PURE__ */ D.createElement(B6, null, /* @__PURE__ */ D.createElement(jH, { className: "ai-tw-h-4 ai-tw-w-4" }))),
  t
));
uW.displayName = z6.displayName;
const fW = D.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ D.createElement(
  V6,
  {
    ref: r,
    className: le(
      "ai-tw-relative ai-tw-flex ai-tw-cursor-pointer ai-tw-select-none ai-tw-items-center ai-tw-rounded-sm ai-tw-py-1.5 ai-tw-pl-8 ai-tw-pr-2 ai-tw-text-sm ai-tw-outline-none ai-tw-transition-colors focus:ai-tw-bg-accent focus:ai-tw-text-accent-foreground active:ai-tw-bg-element-primary-alt-dark data-[disabled]:ai-tw-pointer-events-none data-[state=checked]:ai-tw-font-bold data-[disabled]:ai-tw-opacity-50",
      e
    ),
    ...n
  },
  /* @__PURE__ */ D.createElement("span", { className: "ai-tw-absolute ai-tw-left-2 ai-tw-flex ai-tw-h-3.5 ai-tw-w-3.5 ai-tw-items-center ai-tw-justify-center" }, /* @__PURE__ */ D.createElement(B6, null, /* @__PURE__ */ D.createElement(x6, { className: "ai-tw-h-2 ai-tw-w-2 ai-tw-fill-current" }))),
  t
));
fW.displayName = V6.displayName;
const dW = D.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ D.createElement(
  L6,
  {
    ref: r,
    className: le(
      "ai-tw-px-2 ai-tw-py-1.5 ai-tw-text-sm ai-tw-font-semibold",
      t && "ai-tw-pl-8",
      e
    ),
    ...n
  }
));
dW.displayName = L6.displayName;
const pW = D.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ D.createElement(
  H6,
  {
    ref: n,
    className: le(
      "ai-tw--mx-1 ai-tw-my-1 ai-tw-h-px ai-tw-bg-muted",
      e
    ),
    ...t
  }
));
pW.displayName = H6.displayName;
function T2({
  openDeleteModal: e,
  openFeedbackModal: t
}) {
  return /* @__PURE__ */ D.createElement(aW, { modal: !1 }, /* @__PURE__ */ D.createElement(sW, { asChild: !0 }, /* @__PURE__ */ D.createElement(
    Jt,
    {
      "aria-label": "Customize Options",
      className: "ai-tw-shrink-0",
      variant: "tertiary",
      size: "icon"
    },
    /* @__PURE__ */ D.createElement(Ne, { icon: FR })
  )), /* @__PURE__ */ D.createElement(j6, { align: "end" }, /* @__PURE__ */ D.createElement(
    jm,
    {
      className: "ai-tw-flex ai-tw-gap-2",
      onSelect: t
    },
    /* @__PURE__ */ D.createElement(Ne, { icon: yR, className: "ai-tw-w-4" }),
    "Provide Feedback"
  ), /* @__PURE__ */ D.createElement(
    jm,
    {
      className: "ai-tw-flex ai-tw-gap-2",
      onSelect: e
    },
    /* @__PURE__ */ D.createElement(Ne, { icon: cR, className: "ai-tw-w-4" }),
    "Delete"
  )));
}
const qm = (e) => {
  if (e === 1 / 0 || isNaN(e) || e == null)
    return null;
  if (e <= 0)
    return "00:00";
  const t = new Date(e * 1e3).toISOString();
  return t.slice(11, 13) === "00" ? t.slice(14, 19) : t.slice(11, 19);
}, hW = ({
  transcript: e,
  onClickTime: t
}) => e ? e.length === 0 ? /* @__PURE__ */ y.createElement("p", null, "No transcript available.") : /* @__PURE__ */ y.createElement("div", null, e.map((n, r) => {
  const i = n.startTimeMS / 1e3;
  return /* @__PURE__ */ y.createElement(
    "div",
    {
      key: r,
      onClick: () => t(i),
      className: le(
        "ai-tw-mb-2.5 ai-tw-flex ai-tw-cursor-pointer ai-tw-body-md hover:ai-tw-text-stroke-brand-alt",
        n.who === "CUSTOMER" ? "ai-tw-text-grey-50" : "ai-tw-text-grey-60"
      )
    },
    /* @__PURE__ */ y.createElement("span", { className: "ai-tw-mr-5" }, qm(i)),
    n.message
  );
})) : /* @__PURE__ */ y.createElement(eo, null, /* @__PURE__ */ y.createElement("p", null, "Your transcript is on the way"), /* @__PURE__ */ y.createElement(bn, { size: "small" }));
function q6({
  children: e,
  root: t,
  callback: n,
  rootMargin: r,
  threshold: i,
  ...o
}) {
  const a = he(null);
  return _e(() => {
    const s = a.current;
    if (!s)
      return;
    const c = new IntersectionObserver(
      (f) => {
        for (const p of f)
          n(p.isIntersecting);
      },
      {
        root: t || null,
        rootMargin: r,
        threshold: i
      }
    );
    return c.observe(s), () => {
      c.disconnect();
    };
  }, [t, n, r, i]), /* @__PURE__ */ y.createElement("div", { ref: a, ...o }, e);
}
function mW({ onClick: e, isPlaying: t, isLoading: n }) {
  return /* @__PURE__ */ y.createElement(
    Jt,
    {
      className: "ai-tw-shrink-0",
      onClick: e,
      variant: "tertiary",
      size: "icon",
      status: n ? "loading" : "default"
    },
    t ? /* @__PURE__ */ y.createElement(Ne, { fixedWidth: !0, icon: N4 }) : /* @__PURE__ */ y.createElement(Ne, { fixedWidth: !0, icon: L4, transform: "right-1" })
  );
}
const gW = "_range_sv2gd_1", vW = {
  range: gW
}, wW = ({
  audioRef: e,
  duration: t,
  timeProgress: n,
  setTimeProgress: r
}) => {
  const i = n / t * 100;
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-w-full ai-tw-items-center ai-tw-gap-4" }, /* @__PURE__ */ y.createElement("span", { className: "ai-tw-min-w-fit ai-tw-body-sm" }, /* @__PURE__ */ y.createElement(yW, { timeProgress: n, duration: t })), /* @__PURE__ */ y.createElement(
    "input",
    {
      style: {
        background: `linear-gradient(to right, hsl(var(--ai-grey-60)) ${i}%, hsl(var(--ai-grey-20)) ${i}%)`
      },
      className: le(vW.range),
      type: "range",
      min: 0,
      max: t,
      onChange: (o) => {
        r(o.target.valueAsNumber), e.current && (e.current.currentTime = o.target.valueAsNumber);
      },
      value: n
    }
  ));
};
function yW({
  timeProgress: e,
  duration: t
}) {
  const n = qm(e), r = qm(t);
  return n === null && r === null ? null : n === null ? `--- / ${r}` : r === null ? `${n}` : `${n} / ${r}`;
}
const bW = yx, rv = bx, iv = D.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ D.createElement(xx, null, /* @__PURE__ */ D.createElement(
  qg,
  {
    ref: r,
    sideOffset: t,
    className: le(
      "ai-tw-z-[1200] ai-tw-w-72 ai-tw-rounded-md ai-tw-bg-popover ai-tw-p-4 ai-tw-text-popover-foreground ai-tw-shadow-dropdown ai-tw-outline-none data-[state=open]:ai-tw-animate-in data-[state=closed]:ai-tw-animate-out data-[state=closed]:ai-tw-fade-out-0 data-[state=open]:ai-tw-fade-in-0 data-[state=closed]:ai-tw-zoom-out-95 data-[state=open]:ai-tw-zoom-in-95 data-[side=bottom]:ai-tw-slide-in-from-top-2 data-[side=left]:ai-tw-slide-in-from-right-2 data-[side=right]:ai-tw-slide-in-from-left-2 data-[side=top]:ai-tw-slide-in-from-bottom-2",
      e
    ),
    ...n
  }
)));
iv.displayName = qg.displayName;
function G6(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function ka(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function xW(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Y6(...e) {
  return (t) => e.forEach((n) => xW(n, t));
}
function jo(...e) {
  return D.useCallback(Y6(...e), e);
}
var Gm = { exports: {} }, ks = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var k2;
function EW() {
  if (k2)
    return ks;
  k2 = 1;
  var e = y, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, c, f) {
    var p, d = {}, h = null, m = null;
    f !== void 0 && (h = "" + f), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (m = c.ref);
    for (p in c)
      r.call(c, p) && !o.hasOwnProperty(p) && (d[p] = c[p]);
    if (s && s.defaultProps)
      for (p in c = s.defaultProps, c)
        d[p] === void 0 && (d[p] = c[p]);
    return { $$typeof: t, type: s, key: h, ref: m, props: d, _owner: i.current };
  }
  return ks.Fragment = n, ks.jsx = a, ks.jsxs = a, ks;
}
var Ps = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var P2;
function CW() {
  return P2 || (P2 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = y, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), v = Symbol.iterator, w = "@@iterator";
    function b(V) {
      if (V === null || typeof V != "object")
        return null;
      var ge = v && V[v] || V[w];
      return typeof ge == "function" ? ge : null;
    }
    var E = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(V) {
      {
        for (var ge = arguments.length, Ce = new Array(ge > 1 ? ge - 1 : 0), He = 1; He < ge; He++)
          Ce[He - 1] = arguments[He];
        S("error", V, Ce);
      }
    }
    function S(V, ge, Ce) {
      {
        var He = E.ReactDebugCurrentFrame, ut = He.getStackAddendum();
        ut !== "" && (ge += "%s", Ce = Ce.concat([ut]));
        var dt = Ce.map(function(et) {
          return String(et);
        });
        dt.unshift("Warning: " + ge), Function.prototype.apply.call(console[V], console, dt);
      }
    }
    var _ = !1, T = !1, P = !1, R = !1, N = !1, B;
    B = Symbol.for("react.module.reference");
    function L(V) {
      return !!(typeof V == "string" || typeof V == "function" || V === r || V === o || N || V === i || V === f || V === p || R || V === m || _ || T || P || typeof V == "object" && V !== null && (V.$$typeof === h || V.$$typeof === d || V.$$typeof === a || V.$$typeof === s || V.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      V.$$typeof === B || V.getModuleId !== void 0));
    }
    function j(V, ge, Ce) {
      var He = V.displayName;
      if (He)
        return He;
      var ut = ge.displayName || ge.name || "";
      return ut !== "" ? Ce + "(" + ut + ")" : Ce;
    }
    function I(V) {
      return V.displayName || "Context";
    }
    function z(V) {
      if (V == null)
        return null;
      if (typeof V.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof V == "function")
        return V.displayName || V.name || null;
      if (typeof V == "string")
        return V;
      switch (V) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case f:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof V == "object")
        switch (V.$$typeof) {
          case s:
            var ge = V;
            return I(ge) + ".Consumer";
          case a:
            var Ce = V;
            return I(Ce._context) + ".Provider";
          case c:
            return j(V, V.render, "ForwardRef");
          case d:
            var He = V.displayName || null;
            return He !== null ? He : z(V.type) || "Memo";
          case h: {
            var ut = V, dt = ut._payload, et = ut._init;
            try {
              return z(et(dt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, G = 0, Y, ne, J, ee, A, X, fe;
    function M() {
    }
    M.__reactDisabledLog = !0;
    function Z() {
      {
        if (G === 0) {
          Y = console.log, ne = console.info, J = console.warn, ee = console.error, A = console.group, X = console.groupCollapsed, fe = console.groupEnd;
          var V = {
            configurable: !0,
            enumerable: !0,
            value: M,
            writable: !0
          };
          Object.defineProperties(console, {
            info: V,
            log: V,
            warn: V,
            error: V,
            group: V,
            groupCollapsed: V,
            groupEnd: V
          });
        }
        G++;
      }
    }
    function ie() {
      {
        if (G--, G === 0) {
          var V = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, V, {
              value: Y
            }),
            info: H({}, V, {
              value: ne
            }),
            warn: H({}, V, {
              value: J
            }),
            error: H({}, V, {
              value: ee
            }),
            group: H({}, V, {
              value: A
            }),
            groupCollapsed: H({}, V, {
              value: X
            }),
            groupEnd: H({}, V, {
              value: fe
            })
          });
        }
        G < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var pe = E.ReactCurrentDispatcher, Te;
    function ke(V, ge, Ce) {
      {
        if (Te === void 0)
          try {
            throw Error();
          } catch (ut) {
            var He = ut.stack.trim().match(/\n( *(at )?)/);
            Te = He && He[1] || "";
          }
        return `
` + Te + V;
      }
    }
    var me = !1, Pe;
    {
      var ct = typeof WeakMap == "function" ? WeakMap : Map;
      Pe = new ct();
    }
    function se(V, ge) {
      if (!V || me)
        return "";
      {
        var Ce = Pe.get(V);
        if (Ce !== void 0)
          return Ce;
      }
      var He;
      me = !0;
      var ut = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var dt;
      dt = pe.current, pe.current = null, Z();
      try {
        if (ge) {
          var et = function() {
            throw Error();
          };
          if (Object.defineProperty(et.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(et, []);
            } catch (Nn) {
              He = Nn;
            }
            Reflect.construct(V, [], et);
          } else {
            try {
              et.call();
            } catch (Nn) {
              He = Nn;
            }
            V.call(et.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Nn) {
            He = Nn;
          }
          V();
        }
      } catch (Nn) {
        if (Nn && He && typeof Nn.stack == "string") {
          for (var Qe = Nn.stack.split(`
`), un = He.stack.split(`
`), Ft = Qe.length - 1, Ht = un.length - 1; Ft >= 1 && Ht >= 0 && Qe[Ft] !== un[Ht]; )
            Ht--;
          for (; Ft >= 1 && Ht >= 0; Ft--, Ht--)
            if (Qe[Ft] !== un[Ht]) {
              if (Ft !== 1 || Ht !== 1)
                do
                  if (Ft--, Ht--, Ht < 0 || Qe[Ft] !== un[Ht]) {
                    var Dn = `
` + Qe[Ft].replace(" at new ", " at ");
                    return V.displayName && Dn.includes("<anonymous>") && (Dn = Dn.replace("<anonymous>", V.displayName)), typeof V == "function" && Pe.set(V, Dn), Dn;
                  }
                while (Ft >= 1 && Ht >= 0);
              break;
            }
        }
      } finally {
        me = !1, pe.current = dt, ie(), Error.prepareStackTrace = ut;
      }
      var Pr = V ? V.displayName || V.name : "", Hl = Pr ? ke(Pr) : "";
      return typeof V == "function" && Pe.set(V, Hl), Hl;
    }
    function Le(V, ge, Ce) {
      return se(V, !1);
    }
    function xe(V) {
      var ge = V.prototype;
      return !!(ge && ge.isReactComponent);
    }
    function Ue(V, ge, Ce) {
      if (V == null)
        return "";
      if (typeof V == "function")
        return se(V, xe(V));
      if (typeof V == "string")
        return ke(V);
      switch (V) {
        case f:
          return ke("Suspense");
        case p:
          return ke("SuspenseList");
      }
      if (typeof V == "object")
        switch (V.$$typeof) {
          case c:
            return Le(V.render);
          case d:
            return Ue(V.type, ge, Ce);
          case h: {
            var He = V, ut = He._payload, dt = He._init;
            try {
              return Ue(dt(ut), ge, Ce);
            } catch {
            }
          }
        }
      return "";
    }
    var bt = Object.prototype.hasOwnProperty, Et = {}, xt = E.ReactDebugCurrentFrame;
    function Pt(V) {
      if (V) {
        var ge = V._owner, Ce = Ue(V.type, V._source, ge ? ge.type : null);
        xt.setExtraStackFrame(Ce);
      } else
        xt.setExtraStackFrame(null);
    }
    function Bt(V, ge, Ce, He, ut) {
      {
        var dt = Function.call.bind(bt);
        for (var et in V)
          if (dt(V, et)) {
            var Qe = void 0;
            try {
              if (typeof V[et] != "function") {
                var un = Error((He || "React class") + ": " + Ce + " type `" + et + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof V[et] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw un.name = "Invariant Violation", un;
              }
              Qe = V[et](ge, et, He, Ce, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ft) {
              Qe = Ft;
            }
            Qe && !(Qe instanceof Error) && (Pt(ut), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", He || "React class", Ce, et, typeof Qe), Pt(null)), Qe instanceof Error && !(Qe.message in Et) && (Et[Qe.message] = !0, Pt(ut), C("Failed %s type: %s", Ce, Qe.message), Pt(null));
          }
      }
    }
    var Nt = Array.isArray;
    function On(V) {
      return Nt(V);
    }
    function _r(V) {
      {
        var ge = typeof Symbol == "function" && Symbol.toStringTag, Ce = ge && V[Symbol.toStringTag] || V.constructor.name || "Object";
        return Ce;
      }
    }
    function an(V) {
      try {
        return Kt(V), !1;
      } catch {
        return !0;
      }
    }
    function Kt(V) {
      return "" + V;
    }
    function Yr(V) {
      if (an(V))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", _r(V)), Kt(V);
    }
    var te = E.ReactCurrentOwner, we = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, De, rt, it;
    it = {};
    function cn(V) {
      if (bt.call(V, "ref")) {
        var ge = Object.getOwnPropertyDescriptor(V, "ref").get;
        if (ge && ge.isReactWarning)
          return !1;
      }
      return V.ref !== void 0;
    }
    function Mn(V) {
      if (bt.call(V, "key")) {
        var ge = Object.getOwnPropertyDescriptor(V, "key").get;
        if (ge && ge.isReactWarning)
          return !1;
      }
      return V.key !== void 0;
    }
    function En(V, ge) {
      if (typeof V.ref == "string" && te.current && ge && te.current.stateNode !== ge) {
        var Ce = z(te.current.type);
        it[Ce] || (C('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', z(te.current.type), V.ref), it[Ce] = !0);
      }
    }
    function Tr(V, ge) {
      {
        var Ce = function() {
          De || (De = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ge));
        };
        Ce.isReactWarning = !0, Object.defineProperty(V, "key", {
          get: Ce,
          configurable: !0
        });
      }
    }
    function kr(V, ge) {
      {
        var Ce = function() {
          rt || (rt = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ge));
        };
        Ce.isReactWarning = !0, Object.defineProperty(V, "ref", {
          get: Ce,
          configurable: !0
        });
      }
    }
    var Ct = function(V, ge, Ce, He, ut, dt, et) {
      var Qe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: V,
        key: ge,
        ref: Ce,
        props: et,
        // Record the component responsible for creating this element.
        _owner: dt
      };
      return Qe._store = {}, Object.defineProperty(Qe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Qe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: He
      }), Object.defineProperty(Qe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ut
      }), Object.freeze && (Object.freeze(Qe.props), Object.freeze(Qe)), Qe;
    };
    function go(V, ge, Ce, He, ut) {
      {
        var dt, et = {}, Qe = null, un = null;
        Ce !== void 0 && (Yr(Ce), Qe = "" + Ce), Mn(ge) && (Yr(ge.key), Qe = "" + ge.key), cn(ge) && (un = ge.ref, En(ge, ut));
        for (dt in ge)
          bt.call(ge, dt) && !we.hasOwnProperty(dt) && (et[dt] = ge[dt]);
        if (V && V.defaultProps) {
          var Ft = V.defaultProps;
          for (dt in Ft)
            et[dt] === void 0 && (et[dt] = Ft[dt]);
        }
        if (Qe || un) {
          var Ht = typeof V == "function" ? V.displayName || V.name || "Unknown" : V;
          Qe && Tr(et, Ht), un && kr(et, Ht);
        }
        return Ct(V, Qe, un, ut, He, te.current, et);
      }
    }
    var Cn = E.ReactCurrentOwner, Nl = E.ReactDebugCurrentFrame;
    function di(V) {
      if (V) {
        var ge = V._owner, Ce = Ue(V.type, V._source, ge ? ge.type : null);
        Nl.setExtraStackFrame(Ce);
      } else
        Nl.setExtraStackFrame(null);
    }
    var ta;
    ta = !1;
    function rs(V) {
      return typeof V == "object" && V !== null && V.$$typeof === t;
    }
    function Il() {
      {
        if (Cn.current) {
          var V = z(Cn.current.type);
          if (V)
            return `

Check the render method of \`` + V + "`.";
        }
        return "";
      }
    }
    function yd(V) {
      {
        if (V !== void 0) {
          var ge = V.fileName.replace(/^.*[\\\/]/, ""), Ce = V.lineNumber;
          return `

Check your code at ` + ge + ":" + Ce + ".";
        }
        return "";
      }
    }
    var Ll = {};
    function Fl(V) {
      {
        var ge = Il();
        if (!ge) {
          var Ce = typeof V == "string" ? V : V.displayName || V.name;
          Ce && (ge = `

Check the top-level render call using <` + Ce + ">.");
        }
        return ge;
      }
    }
    function zl(V, ge) {
      {
        if (!V._store || V._store.validated || V.key != null)
          return;
        V._store.validated = !0;
        var Ce = Fl(ge);
        if (Ll[Ce])
          return;
        Ll[Ce] = !0;
        var He = "";
        V && V._owner && V._owner !== Cn.current && (He = " It was passed a child from " + z(V._owner.type) + "."), di(V), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Ce, He), di(null);
      }
    }
    function Vl(V, ge) {
      {
        if (typeof V != "object")
          return;
        if (On(V))
          for (var Ce = 0; Ce < V.length; Ce++) {
            var He = V[Ce];
            rs(He) && zl(He, ge);
          }
        else if (rs(V))
          V._store && (V._store.validated = !0);
        else if (V) {
          var ut = b(V);
          if (typeof ut == "function" && ut !== V.entries)
            for (var dt = ut.call(V), et; !(et = dt.next()).done; )
              rs(et.value) && zl(et.value, ge);
        }
      }
    }
    function bd(V) {
      {
        var ge = V.type;
        if (ge == null || typeof ge == "string")
          return;
        var Ce;
        if (typeof ge == "function")
          Ce = ge.propTypes;
        else if (typeof ge == "object" && (ge.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ge.$$typeof === d))
          Ce = ge.propTypes;
        else
          return;
        if (Ce) {
          var He = z(ge);
          Bt(Ce, V.props, "prop", He, V);
        } else if (ge.PropTypes !== void 0 && !ta) {
          ta = !0;
          var ut = z(ge);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ut || "Unknown");
        }
        typeof ge.getDefaultProps == "function" && !ge.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function is(V) {
      {
        for (var ge = Object.keys(V.props), Ce = 0; Ce < ge.length; Ce++) {
          var He = ge[Ce];
          if (He !== "children" && He !== "key") {
            di(V), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", He), di(null);
            break;
          }
        }
        V.ref !== null && (di(V), C("Invalid attribute `ref` supplied to `React.Fragment`."), di(null));
      }
    }
    function Bl(V, ge, Ce, He, ut, dt) {
      {
        var et = L(V);
        if (!et) {
          var Qe = "";
          (V === void 0 || typeof V == "object" && V !== null && Object.keys(V).length === 0) && (Qe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var un = yd(ut);
          un ? Qe += un : Qe += Il();
          var Ft;
          V === null ? Ft = "null" : On(V) ? Ft = "array" : V !== void 0 && V.$$typeof === t ? (Ft = "<" + (z(V.type) || "Unknown") + " />", Qe = " Did you accidentally export a JSX literal instead of a component?") : Ft = typeof V, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ft, Qe);
        }
        var Ht = go(V, ge, Ce, ut, dt);
        if (Ht == null)
          return Ht;
        if (et) {
          var Dn = ge.children;
          if (Dn !== void 0)
            if (He)
              if (On(Dn)) {
                for (var Pr = 0; Pr < Dn.length; Pr++)
                  Vl(Dn[Pr], V);
                Object.freeze && Object.freeze(Dn);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Vl(Dn, V);
        }
        return V === r ? is(Ht) : bd(Ht), Ht;
      }
    }
    function os(V, ge, Ce) {
      return Bl(V, ge, Ce, !0);
    }
    function xd(V, ge, Ce) {
      return Bl(V, ge, Ce, !1);
    }
    var Ed = xd, Cd = os;
    Ps.Fragment = r, Ps.jsx = Ed, Ps.jsxs = Cd;
  }()), Ps;
}
process.env.NODE_ENV === "production" ? Gm.exports = EW() : Gm.exports = CW();
var _t = Gm.exports;
function SW(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = D.createContext(a), c = n.length;
    n = [...n, a];
    const f = (d) => {
      var E;
      const { scope: h, children: m, ...v } = d, w = ((E = h == null ? void 0 : h[e]) == null ? void 0 : E[c]) || s, b = D.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ _t.jsx(w.Provider, { value: b, children: m });
    };
    f.displayName = o + "Provider";
    function p(d, h) {
      var w;
      const m = ((w = h == null ? void 0 : h[e]) == null ? void 0 : w[c]) || s, v = D.useContext(m);
      if (v)
        return v;
      if (a !== void 0)
        return a;
      throw new Error(`\`${d}\` must be used within \`${o}\``);
    }
    return [f, p];
  }
  const i = () => {
    const o = n.map((a) => D.createContext(a));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return D.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return i.scopeName = e, [r, _W(i, ...t)];
}
function _W(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: c, scopeName: f }) => {
        const d = c(o)[`__scope${f}`];
        return { ...s, ...d };
      }, {});
      return D.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function K6(e) {
  const t = D.useRef(e);
  return D.useEffect(() => {
    t.current = e;
  }), D.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function TW({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, i] = kW({ defaultProp: t, onChange: n }), o = e !== void 0, a = o ? e : r, s = K6(n), c = D.useCallback(
    (f) => {
      if (o) {
        const d = typeof f == "function" ? f(e) : f;
        d !== e && s(d);
      } else
        i(f);
    },
    [o, e, i, s]
  );
  return [a, c];
}
function kW({
  defaultProp: e,
  onChange: t
}) {
  const n = D.useState(e), [r] = n, i = D.useRef(r), o = K6(t);
  return D.useEffect(() => {
    i.current !== r && (o(r), i.current = r);
  }, [r, i, o]), n;
}
var PW = D.createContext(void 0);
function AW(e) {
  const t = D.useContext(PW);
  return e || t || "ltr";
}
function RW(e) {
  const t = D.useRef({ value: e, previous: e });
  return D.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var $W = globalThis != null && globalThis.document ? D.useLayoutEffect : () => {
};
function OW(e) {
  const [t, n] = D.useState(void 0);
  return $W(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const o = i[0];
        let a, s;
        if ("borderBoxSize" in o) {
          const c = o.borderBoxSize, f = Array.isArray(c) ? c[0] : c;
          a = f.inlineSize, s = f.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({ width: a, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Yu = D.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = D.Children.toArray(n), o = i.find(DW);
  if (o) {
    const a = o.props.children, s = i.map((c) => c === o ? D.Children.count(a) > 1 ? D.Children.only(null) : D.isValidElement(a) ? a.props.children : null : c);
    return /* @__PURE__ */ _t.jsx(Ym, { ...r, ref: t, children: D.isValidElement(a) ? D.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ _t.jsx(Ym, { ...r, ref: t, children: n });
});
Yu.displayName = "Slot";
var Ym = D.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (D.isValidElement(n)) {
    const i = IW(n);
    return D.cloneElement(n, {
      ...NW(r, n.props),
      // @ts-ignore
      ref: t ? Y6(t, i) : i
    });
  }
  return D.Children.count(n) > 1 ? D.Children.only(null) : null;
});
Ym.displayName = "SlotClone";
var MW = ({ children: e }) => /* @__PURE__ */ _t.jsx(_t.Fragment, { children: e });
function DW(e) {
  return D.isValidElement(e) && e.type === MW;
}
function NW(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function IW(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var LW = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Yf = LW.reduce((e, t) => {
  const n = D.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? Yu : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ _t.jsx(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function FW(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = D.createContext(a), c = n.length;
    n = [...n, a];
    function f(d) {
      const { scope: h, children: m, ...v } = d, w = (h == null ? void 0 : h[e][c]) || s, b = D.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ _t.jsx(w.Provider, { value: b, children: m });
    }
    function p(d, h) {
      const m = (h == null ? void 0 : h[e][c]) || s, v = D.useContext(m);
      if (v)
        return v;
      if (a !== void 0)
        return a;
      throw new Error(`\`${d}\` must be used within \`${o}\``);
    }
    return f.displayName = o + "Provider", [f, p];
  }
  const i = () => {
    const o = n.map((a) => D.createContext(a));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return D.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return i.scopeName = e, [r, zW(i, ...t)];
}
function zW(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: c, scopeName: f }) => {
        const d = c(o)[`__scope${f}`];
        return { ...s, ...d };
      }, {});
      return D.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function VW(e) {
  const t = e + "CollectionProvider", [n, r] = FW(t), [i, o] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (m) => {
    const { scope: v, children: w } = m, b = y.useRef(null), E = y.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ _t.jsx(i, { scope: v, itemMap: E, collectionRef: b, children: w });
  };
  a.displayName = t;
  const s = e + "CollectionSlot", c = y.forwardRef(
    (m, v) => {
      const { scope: w, children: b } = m, E = o(s, w), C = jo(v, E.collectionRef);
      return /* @__PURE__ */ _t.jsx(Yu, { ref: C, children: b });
    }
  );
  c.displayName = s;
  const f = e + "CollectionItemSlot", p = "data-radix-collection-item", d = y.forwardRef(
    (m, v) => {
      const { scope: w, children: b, ...E } = m, C = y.useRef(null), S = jo(v, C), _ = o(f, w);
      return y.useEffect(() => (_.itemMap.set(C, { ref: C, ...E }), () => void _.itemMap.delete(C))), /* @__PURE__ */ _t.jsx(Yu, { [p]: "", ref: S, children: b });
    }
  );
  d.displayName = f;
  function h(m) {
    const v = o(e + "CollectionConsumer", m);
    return y.useCallback(() => {
      const b = v.collectionRef.current;
      if (!b)
        return [];
      const E = Array.from(b.querySelectorAll(`[${p}]`));
      return Array.from(v.itemMap.values()).sort(
        (_, T) => E.indexOf(_.ref.current) - E.indexOf(T.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: a, Slot: c, ItemSlot: d },
    h,
    r
  ];
}
var X6 = ["PageUp", "PageDown"], Q6 = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Z6 = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, Za = "Slider", [Km, BW, HW] = VW(Za), [J6, Pse] = SW(Za, [
  HW
]), [UW, Kf] = J6(Za), eC = D.forwardRef(
  (e, t) => {
    const {
      name: n,
      min: r = 0,
      max: i = 100,
      step: o = 1,
      orientation: a = "horizontal",
      disabled: s = !1,
      minStepsBetweenThumbs: c = 0,
      defaultValue: f = [r],
      value: p,
      onValueChange: d = () => {
      },
      onValueCommit: h = () => {
      },
      inverted: m = !1,
      form: v,
      ...w
    } = e, b = D.useRef(/* @__PURE__ */ new Set()), E = D.useRef(0), S = a === "horizontal" ? WW : jW, [_ = [], T] = TW({
      prop: p,
      defaultProp: f,
      onChange: (j) => {
        var z;
        (z = [...b.current][E.current]) == null || z.focus(), d(j);
      }
    }), P = D.useRef(_);
    function R(j) {
      const I = XW(_, j);
      L(j, I);
    }
    function N(j) {
      L(j, E.current);
    }
    function B() {
      const j = P.current[E.current];
      _[E.current] !== j && h(_);
    }
    function L(j, I, { commit: z } = { commit: !1 }) {
      const H = ej(o), G = tj(Math.round((j - r) / o) * o + r, H), Y = G6(G, [r, i]);
      T((ne = []) => {
        const J = YW(ne, Y, I);
        if (JW(J, c * o)) {
          E.current = J.indexOf(Y);
          const ee = String(J) !== String(ne);
          return ee && z && h(J), ee ? J : ne;
        } else
          return ne;
      });
    }
    return /* @__PURE__ */ _t.jsx(
      UW,
      {
        scope: e.__scopeSlider,
        name: n,
        disabled: s,
        min: r,
        max: i,
        valueIndexToChangeRef: E,
        thumbs: b.current,
        values: _,
        orientation: a,
        form: v,
        children: /* @__PURE__ */ _t.jsx(Km.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ _t.jsx(Km.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ _t.jsx(
          S,
          {
            "aria-disabled": s,
            "data-disabled": s ? "" : void 0,
            ...w,
            ref: t,
            onPointerDown: ka(w.onPointerDown, () => {
              s || (P.current = _);
            }),
            min: r,
            max: i,
            inverted: m,
            onSlideStart: s ? void 0 : R,
            onSlideMove: s ? void 0 : N,
            onSlideEnd: s ? void 0 : B,
            onHomeKeyDown: () => !s && L(r, 0, { commit: !0 }),
            onEndKeyDown: () => !s && L(i, _.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: j, direction: I }) => {
              if (!s) {
                const G = X6.includes(j.key) || j.shiftKey && Q6.includes(j.key) ? 10 : 1, Y = E.current, ne = _[Y], J = o * G * I;
                L(ne + J, Y, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
eC.displayName = Za;
var [tC, nC] = J6(Za, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), WW = D.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: r,
      dir: i,
      inverted: o,
      onSlideStart: a,
      onSlideMove: s,
      onSlideEnd: c,
      onStepKeyDown: f,
      ...p
    } = e, [d, h] = D.useState(null), m = jo(t, (S) => h(S)), v = D.useRef(), w = AW(i), b = w === "ltr", E = b && !o || !b && o;
    function C(S) {
      const _ = v.current || d.getBoundingClientRect(), T = [0, _.width], R = ov(T, E ? [n, r] : [r, n]);
      return v.current = _, R(S - _.left);
    }
    return /* @__PURE__ */ _t.jsx(
      tC,
      {
        scope: e.__scopeSlider,
        startEdge: E ? "left" : "right",
        endEdge: E ? "right" : "left",
        direction: E ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ _t.jsx(
          rC,
          {
            dir: w,
            "data-orientation": "horizontal",
            ...p,
            ref: m,
            style: {
              ...p.style,
              ["--radix-slider-thumb-transform"]: "translateX(-50%)"
            },
            onSlideStart: (S) => {
              const _ = C(S.clientX);
              a == null || a(_);
            },
            onSlideMove: (S) => {
              const _ = C(S.clientX);
              s == null || s(_);
            },
            onSlideEnd: () => {
              v.current = void 0, c == null || c();
            },
            onStepKeyDown: (S) => {
              const T = Z6[E ? "from-left" : "from-right"].includes(S.key);
              f == null || f({ event: S, direction: T ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), jW = D.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: r,
      inverted: i,
      onSlideStart: o,
      onSlideMove: a,
      onSlideEnd: s,
      onStepKeyDown: c,
      ...f
    } = e, p = D.useRef(null), d = jo(t, p), h = D.useRef(), m = !i;
    function v(w) {
      const b = h.current || p.current.getBoundingClientRect(), E = [0, b.height], S = ov(E, m ? [r, n] : [n, r]);
      return h.current = b, S(w - b.top);
    }
    return /* @__PURE__ */ _t.jsx(
      tC,
      {
        scope: e.__scopeSlider,
        startEdge: m ? "bottom" : "top",
        endEdge: m ? "top" : "bottom",
        size: "height",
        direction: m ? 1 : -1,
        children: /* @__PURE__ */ _t.jsx(
          rC,
          {
            "data-orientation": "vertical",
            ...f,
            ref: d,
            style: {
              ...f.style,
              ["--radix-slider-thumb-transform"]: "translateY(50%)"
            },
            onSlideStart: (w) => {
              const b = v(w.clientY);
              o == null || o(b);
            },
            onSlideMove: (w) => {
              const b = v(w.clientY);
              a == null || a(b);
            },
            onSlideEnd: () => {
              h.current = void 0, s == null || s();
            },
            onStepKeyDown: (w) => {
              const E = Z6[m ? "from-bottom" : "from-top"].includes(w.key);
              c == null || c({ event: w, direction: E ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), rC = D.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: n,
      onSlideStart: r,
      onSlideMove: i,
      onSlideEnd: o,
      onHomeKeyDown: a,
      onEndKeyDown: s,
      onStepKeyDown: c,
      ...f
    } = e, p = Kf(Za, n);
    return /* @__PURE__ */ _t.jsx(
      Yf.span,
      {
        ...f,
        ref: t,
        onKeyDown: ka(e.onKeyDown, (d) => {
          d.key === "Home" ? (a(d), d.preventDefault()) : d.key === "End" ? (s(d), d.preventDefault()) : X6.concat(Q6).includes(d.key) && (c(d), d.preventDefault());
        }),
        onPointerDown: ka(e.onPointerDown, (d) => {
          const h = d.target;
          h.setPointerCapture(d.pointerId), d.preventDefault(), p.thumbs.has(h) ? h.focus() : r(d);
        }),
        onPointerMove: ka(e.onPointerMove, (d) => {
          d.target.hasPointerCapture(d.pointerId) && i(d);
        }),
        onPointerUp: ka(e.onPointerUp, (d) => {
          const h = d.target;
          h.hasPointerCapture(d.pointerId) && (h.releasePointerCapture(d.pointerId), o(d));
        })
      }
    );
  }
), iC = "SliderTrack", oC = D.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...r } = e, i = Kf(iC, n);
    return /* @__PURE__ */ _t.jsx(
      Yf.span,
      {
        "data-disabled": i.disabled ? "" : void 0,
        "data-orientation": i.orientation,
        ...r,
        ref: t
      }
    );
  }
);
oC.displayName = iC;
var Xm = "SliderRange", aC = D.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...r } = e, i = Kf(Xm, n), o = nC(Xm, n), a = D.useRef(null), s = jo(t, a), c = i.values.length, f = i.values.map(
      (h) => lC(h, i.min, i.max)
    ), p = c > 1 ? Math.min(...f) : 0, d = 100 - Math.max(...f);
    return /* @__PURE__ */ _t.jsx(
      Yf.span,
      {
        "data-orientation": i.orientation,
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: s,
        style: {
          ...e.style,
          [o.startEdge]: p + "%",
          [o.endEdge]: d + "%"
        }
      }
    );
  }
);
aC.displayName = Xm;
var Qm = "SliderThumb", sC = D.forwardRef(
  (e, t) => {
    const n = BW(e.__scopeSlider), [r, i] = D.useState(null), o = jo(t, (s) => i(s)), a = D.useMemo(
      () => r ? n().findIndex((s) => s.ref.current === r) : -1,
      [n, r]
    );
    return /* @__PURE__ */ _t.jsx(qW, { ...e, ref: o, index: a });
  }
), qW = D.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, index: r, name: i, ...o } = e, a = Kf(Qm, n), s = nC(Qm, n), [c, f] = D.useState(null), p = jo(t, (C) => f(C)), d = c ? a.form || !!c.closest("form") : !0, h = OW(c), m = a.values[r], v = m === void 0 ? 0 : lC(m, a.min, a.max), w = KW(r, a.values.length), b = h == null ? void 0 : h[s.size], E = b ? QW(b, v, s.direction) : 0;
    return D.useEffect(() => {
      if (c)
        return a.thumbs.add(c), () => {
          a.thumbs.delete(c);
        };
    }, [c, a.thumbs]), /* @__PURE__ */ _t.jsxs(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [s.startEdge]: `calc(${v}% + ${E}px)`
        },
        children: [
          /* @__PURE__ */ _t.jsx(Km.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ _t.jsx(
            Yf.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || w,
              "aria-valuemin": a.min,
              "aria-valuenow": m,
              "aria-valuemax": a.max,
              "aria-orientation": a.orientation,
              "data-orientation": a.orientation,
              "data-disabled": a.disabled ? "" : void 0,
              tabIndex: a.disabled ? void 0 : 0,
              ...o,
              ref: p,
              style: m === void 0 ? { display: "none" } : e.style,
              onFocus: ka(e.onFocus, () => {
                a.valueIndexToChangeRef.current = r;
              })
            }
          ) }),
          d && /* @__PURE__ */ _t.jsx(
            GW,
            {
              name: i ?? (a.name ? a.name + (a.values.length > 1 ? "[]" : "") : void 0),
              form: a.form,
              value: m
            },
            r
          )
        ]
      }
    );
  }
);
sC.displayName = Qm;
var GW = (e) => {
  const { value: t, ...n } = e, r = D.useRef(null), i = RW(t);
  return D.useEffect(() => {
    const o = r.current, a = window.HTMLInputElement.prototype, c = Object.getOwnPropertyDescriptor(a, "value").set;
    if (i !== t && c) {
      const f = new Event("input", { bubbles: !0 });
      c.call(o, t), o.dispatchEvent(f);
    }
  }, [i, t]), /* @__PURE__ */ _t.jsx("input", { style: { display: "none" }, ...n, ref: r, defaultValue: t });
};
function YW(e = [], t, n) {
  const r = [...e];
  return r[n] = t, r.sort((i, o) => i - o);
}
function lC(e, t, n) {
  const o = 100 / (n - t) * (e - t);
  return G6(o, [0, 100]);
}
function KW(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function XW(e, t) {
  if (e.length === 1)
    return 0;
  const n = e.map((i) => Math.abs(i - t)), r = Math.min(...n);
  return n.indexOf(r);
}
function QW(e, t, n) {
  const r = e / 2, o = ov([0, 50], [0, r]);
  return (r - o(t) * n) * n;
}
function ZW(e) {
  return e.slice(0, -1).map((t, n) => e[n + 1] - t);
}
function JW(e, t) {
  if (t > 0) {
    const n = ZW(e);
    return Math.min(...n) >= t;
  }
  return !0;
}
function ov(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1])
      return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function ej(e) {
  return (String(e).split(".")[1] || "").length;
}
function tj(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
var cC = eC, nj = oC, rj = aC, ij = sC;
const uC = D.forwardRef(({ className: e, variant: t = "neutral", ...n }, r) => {
  var i;
  return /* @__PURE__ */ D.createElement(
    cC,
    {
      ref: r,
      className: le(
        "ai-tw-relative ai-tw-flex ai-tw-w-full ai-tw-touch-none ai-tw-select-none ai-tw-items-center",
        "data-[orientation='horizontal']:ai-tw-h-1.5 data-[orientation='horizontal']:ai-tw-w-full data-[orientation='horizontal']:ai-tw-items-center",
        "data-[orientation='vertical']:ai-tw-h-full data-[orientation='vertical']:ai-tw-w-1.5 data-[orientation='vertical']:ai-tw-justify-center",
        n.disabled && "ai-tw-pointer-events-none ai-tw-opacity-50",
        e
      ),
      ...n
    },
    /* @__PURE__ */ D.createElement(
      nj,
      {
        className: le(
          "ai-tw-relative ai-tw-grow ai-tw-overflow-hidden ai-tw-rounded-full ",
          t === "brand" && "ai-tw-bg-element-brand-light",
          t === "neutral" && "ai-tw-bg-element-primary-subtle-dark",
          "data-[orientation='horizontal']:ai-tw-h-1.5 data-[orientation='horizontal']:ai-tw-w-full",
          "data-[orientation='vertical']:ai-tw-h-full data-[orientation='vertical']:ai-tw-w-1.5"
        )
      },
      /* @__PURE__ */ D.createElement(
        rj,
        {
          className: le(
            "ai-tw-absolute",
            t === "brand" && "ai-tw-bg-element-brand-dark",
            t === "neutral" && "ai-tw-bg-element-primary-bold",
            "data-[orientation='horizontal']:ai-tw-h-full",
            "data-[orientation='vertical']:ai-tw-w-full"
          )
        }
      )
    ),
    (i = n.defaultValue || n.value) == null ? void 0 : i.map((o, a) => /* @__PURE__ */ D.createElement(
      ij,
      {
        key: `thumb-${a}`,
        className: le(
          "ai-tw-block ai-tw-h-3 ai-tw-w-3 ai-tw-rounded-full ai-tw-border-2 ai-tw-border-solid ai-tw-bg-background ai-tw-ring-offset-background ai-tw-transition-colors focus-visible:ai-tw-outline-none focus-visible:ai-tw-ring-2 focus-visible:ai-tw-ring-ring focus-visible:ai-tw-ring-offset-2 disabled:ai-tw-pointer-events-none disabled:ai-tw-opacity-50",
          t === "brand" && "ai-tw-border-element-brand-dark",
          t === "neutral" && "ai-tw-border-element-primary-bold"
        )
      }
    ))
  );
});
uC.displayName = cC.displayName;
function oj(e) {
  return e === 0 ? UR : e <= 33 ? hR : e <= 66 ? ER : OR;
}
const aj = ({ volume: e, onChangeVolume: t }) => {
  const n = oj(e);
  return /* @__PURE__ */ y.createElement(bW, { modal: !1 }, /* @__PURE__ */ y.createElement(rv, null, /* @__PURE__ */ y.createElement("span", { className: "ai-tw-p-2", "aria-label": "Volume Controls" }, /* @__PURE__ */ y.createElement(Ne, { fixedWidth: !0, icon: n }))), /* @__PURE__ */ y.createElement(iv, { side: "top", className: "ai-tw-h-28 ai-tw-w-fit" }, /* @__PURE__ */ y.createElement(
    uC,
    {
      value: [e],
      onValueChange: ([r]) => t(r),
      orientation: "vertical",
      step: 5
    }
  )));
}, sj = ({
  audioRef: e,
  duration: t,
  isPlaying: n,
  setIsPlaying: r,
  setTimeProgress: i,
  timeProgress: o
}) => {
  var h;
  const [a, s] = ue(60), [c, f] = ue(!1);
  if (!((h = e.current) != null && h.src))
    return null;
  const p = (m) => {
    s(m), e.current && (e.current.volume = m / 100);
  }, d = () => {
    var v;
    !n ? (v = e.current) != null && v.currentSrc ? e.current.play() : f(!0) : e.current && e.current.pause(), r((w) => !w);
  };
  return /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement(
    mW,
    {
      isPlaying: n,
      isLoading: c,
      onClick: d
    }
  ), /* @__PURE__ */ y.createElement(
    wW,
    {
      audioRef: e,
      duration: t,
      timeProgress: o,
      setTimeProgress: i
    }
  ), /* @__PURE__ */ y.createElement(aj, { volume: a, onChangeVolume: p }));
};
function av({
  isPlaying: e,
  setIsPlaying: t,
  ...n
}) {
  const [r, i] = ue(0), [o, a] = ue(0), s = he(null), { onTimeUpdate: c, onEnded: f, onLoadedMetadata: p, ...d } = n;
  return /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement(
    "audio",
    {
      crossOrigin: "anonymous",
      preload: "metadata",
      ref: s,
      onTimeUpdate: (h) => {
        a(h.currentTarget.currentTime), h.currentTarget.duration && i(h.currentTarget.duration), n.onTimeUpdate && n.onTimeUpdate(h);
      },
      onEnded: (h) => {
        t(!1), n.onEnded && n.onEnded(h);
      },
      onLoadedMetadata: (h) => {
        const m = h.currentTarget.duration;
        m === 1 / 0 && s.current ? (s.current.currentTime = 1e101, setTimeout(() => {
          s.current && (s.current.currentTime = 0);
        }, 500)) : i(m), n.onLoadedMetadata && n.onLoadedMetadata(h);
      },
      ...d
    }
  ), /* @__PURE__ */ y.createElement(
    sj,
    {
      audioRef: s,
      duration: r,
      isPlaying: e,
      setIsPlaying: t,
      setTimeProgress: a,
      timeProgress: o
    }
  ));
}
const fC = D.forwardRef(
  ({ className: e, withFade: t, children: n, onScroll: r, ...i }, o) => {
    const a = D.useRef(null);
    D.useImperativeHandle(
      o,
      () => a.current
    );
    const [s, c] = D.useState(!1);
    D.useEffect(() => {
      if (a.current && t) {
        const p = new ResizeObserver(() => {
          if (!a.current)
            return;
          const { scrollTop: d, scrollHeight: h, clientHeight: m } = a.current;
          c(d + m >= h);
        });
        return p.observe(a.current), () => p.disconnect();
      }
    }, [t]);
    function f(p) {
      if (t) {
        const { scrollTop: d, scrollHeight: h, clientHeight: m } = p.currentTarget;
        c(d + m >= h);
      }
      r == null || r(p);
    }
    return /* @__PURE__ */ D.createElement("div", { className: "ai-tw-relative ai-tw-overflow-hidden" }, /* @__PURE__ */ D.createElement(
      "div",
      {
        ref: a,
        className: le("ai-tw-overflow-auto", e),
        onScroll: f,
        ...i
      },
      n
    ), /* @__PURE__ */ D.createElement(
      "div",
      {
        className: le(
          !t || s ? "ai-tw-opacity-0" : "ai-tw-opacity-100",
          "ai-tw-pointer-events-none ai-tw-absolute ai-tw-bottom-0 ai-tw-h-8 ai-tw-w-full ai-tw-bg-gradient-to-b ai-tw-from-transparent ai-tw-to-white"
        )
      }
    ));
  }
);
fC.displayName = "ScrollArea";
const dC = "Tabs", [lj, Ase] = ar(dC, [
  Qa
]), pC = Qa(), [cj, sv] = lj(dC), uj = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeTabs: n, value: r, onValueChange: i, defaultValue: o, orientation: a = "horizontal", dir: s, activationMode: c = "automatic", ...f } = e, p = Tl(s), [d, h] = si({
    prop: r,
    onChange: i,
    defaultProp: o
  });
  return /* @__PURE__ */ K(cj, {
    scope: n,
    baseId: zr(),
    value: d,
    onValueChange: h,
    orientation: a,
    dir: p,
    activationMode: c
  }, /* @__PURE__ */ K(st.div, de({
    dir: p,
    "data-orientation": a
  }, f, {
    ref: t
  })));
}), fj = "TabsList", dj = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeTabs: n, loop: r = !0, ...i } = e, o = sv(fj, n), a = pC(n);
  return /* @__PURE__ */ K(K1, de({
    asChild: !0
  }, a, {
    orientation: o.orientation,
    dir: o.dir,
    loop: r
  }), /* @__PURE__ */ K(st.div, de({
    role: "tablist",
    "aria-orientation": o.orientation
  }, i, {
    ref: t
  })));
}), pj = "TabsTrigger", hj = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeTabs: n, value: r, disabled: i = !1, ...o } = e, a = sv(pj, n), s = pC(n), c = hC(a.baseId, r), f = mC(a.baseId, r), p = r === a.value;
  return /* @__PURE__ */ K(X1, de({
    asChild: !0
  }, s, {
    focusable: !i,
    active: p
  }), /* @__PURE__ */ K(st.button, de({
    type: "button",
    role: "tab",
    "aria-selected": p,
    "aria-controls": f,
    "data-state": p ? "active" : "inactive",
    "data-disabled": i ? "" : void 0,
    disabled: i,
    id: c
  }, o, {
    ref: t,
    onMouseDown: Oe(e.onMouseDown, (d) => {
      !i && d.button === 0 && d.ctrlKey === !1 ? a.onValueChange(r) : d.preventDefault();
    }),
    onKeyDown: Oe(e.onKeyDown, (d) => {
      [
        " ",
        "Enter"
      ].includes(d.key) && a.onValueChange(r);
    }),
    onFocus: Oe(e.onFocus, () => {
      const d = a.activationMode !== "manual";
      !p && !i && d && a.onValueChange(r);
    })
  })));
}), mj = "TabsContent", gj = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeTabs: n, value: r, forceMount: i, children: o, ...a } = e, s = sv(mj, n), c = hC(s.baseId, r), f = mC(s.baseId, r), p = r === s.value, d = he(p);
  return _e(() => {
    const h = requestAnimationFrame(
      () => d.current = !1
    );
    return () => cancelAnimationFrame(h);
  }, []), /* @__PURE__ */ K(
    $n,
    {
      present: i || p
    },
    ({ present: h }) => /* @__PURE__ */ K(st.div, de({
      "data-state": p ? "active" : "inactive",
      "data-orientation": s.orientation,
      role: "tabpanel",
      "aria-labelledby": c,
      hidden: !h,
      id: f,
      tabIndex: 0
    }, a, {
      ref: t,
      style: {
        ...e.style,
        animationDuration: d.current ? "0s" : void 0
      }
    }), h && o)
  );
});
function hC(e, t) {
  return `${e}-trigger-${t}`;
}
function mC(e, t) {
  return `${e}-content-${t}`;
}
const lv = uj, Xf = dj, Qf = hj, Zf = gj;
var Ku = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Ku.exports;
(function(e, t) {
  (function() {
    var n, r = "4.17.21", i = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", s = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", f = 500, p = "__lodash_placeholder__", d = 1, h = 2, m = 4, v = 1, w = 2, b = 1, E = 2, C = 4, S = 8, _ = 16, T = 32, P = 64, R = 128, N = 256, B = 512, L = 30, j = "...", I = 800, z = 16, H = 1, G = 2, Y = 3, ne = 1 / 0, J = 9007199254740991, ee = 17976931348623157e292, A = 0 / 0, X = 4294967295, fe = X - 1, M = X >>> 1, Z = [
      ["ary", R],
      ["bind", b],
      ["bindKey", E],
      ["curry", S],
      ["curryRight", _],
      ["flip", B],
      ["partial", T],
      ["partialRight", P],
      ["rearg", N]
    ], ie = "[object Arguments]", pe = "[object Array]", Te = "[object AsyncFunction]", ke = "[object Boolean]", me = "[object Date]", Pe = "[object DOMException]", ct = "[object Error]", se = "[object Function]", Le = "[object GeneratorFunction]", xe = "[object Map]", Ue = "[object Number]", bt = "[object Null]", Et = "[object Object]", xt = "[object Promise]", Pt = "[object Proxy]", Bt = "[object RegExp]", Nt = "[object Set]", On = "[object String]", _r = "[object Symbol]", an = "[object Undefined]", Kt = "[object WeakMap]", Yr = "[object WeakSet]", te = "[object ArrayBuffer]", we = "[object DataView]", De = "[object Float32Array]", rt = "[object Float64Array]", it = "[object Int8Array]", cn = "[object Int16Array]", Mn = "[object Int32Array]", En = "[object Uint8Array]", Tr = "[object Uint8ClampedArray]", kr = "[object Uint16Array]", Ct = "[object Uint32Array]", go = /\b__p \+= '';/g, Cn = /\b(__p \+=) '' \+/g, Nl = /(__e\(.*?\)|\b__t\)) \+\n'';/g, di = /&(?:amp|lt|gt|quot|#39);/g, ta = /[&<>"']/g, rs = RegExp(di.source), Il = RegExp(ta.source), yd = /<%-([\s\S]+?)%>/g, Ll = /<%([\s\S]+?)%>/g, Fl = /<%=([\s\S]+?)%>/g, zl = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Vl = /^\w*$/, bd = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, is = /[\\^$.*+?()[\]{}|]/g, Bl = RegExp(is.source), os = /^\s+/, xd = /\s/, Ed = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Cd = /\{\n\/\* \[wrapped with (.+)\] \*/, V = /,? & /, ge = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Ce = /[()=,{}\[\]\/\s]/, He = /\\(\\)?/g, ut = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, dt = /\w*$/, et = /^[-+]0x[0-9a-f]+$/i, Qe = /^0b[01]+$/i, un = /^\[object .+?Constructor\]$/, Ft = /^0o[0-7]+$/i, Ht = /^(?:0|[1-9]\d*)$/, Dn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Pr = /($^)/, Hl = /['\n\r\u2028\u2029\\]/g, Nn = "\\ud800-\\udfff", Z8 = "\\u0300-\\u036f", J8 = "\\ufe20-\\ufe2f", e7 = "\\u20d0-\\u20ff", Gv = Z8 + J8 + e7, Yv = "\\u2700-\\u27bf", Kv = "a-z\\xdf-\\xf6\\xf8-\\xff", t7 = "\\xac\\xb1\\xd7\\xf7", n7 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", r7 = "\\u2000-\\u206f", i7 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Xv = "A-Z\\xc0-\\xd6\\xd8-\\xde", Qv = "\\ufe0e\\ufe0f", Zv = t7 + n7 + r7 + i7, Sd = "['’]", o7 = "[" + Nn + "]", Jv = "[" + Zv + "]", Ul = "[" + Gv + "]", e0 = "\\d+", a7 = "[" + Yv + "]", t0 = "[" + Kv + "]", n0 = "[^" + Nn + Zv + e0 + Yv + Kv + Xv + "]", _d = "\\ud83c[\\udffb-\\udfff]", s7 = "(?:" + Ul + "|" + _d + ")", r0 = "[^" + Nn + "]", Td = "(?:\\ud83c[\\udde6-\\uddff]){2}", kd = "[\\ud800-\\udbff][\\udc00-\\udfff]", na = "[" + Xv + "]", i0 = "\\u200d", o0 = "(?:" + t0 + "|" + n0 + ")", l7 = "(?:" + na + "|" + n0 + ")", a0 = "(?:" + Sd + "(?:d|ll|m|re|s|t|ve))?", s0 = "(?:" + Sd + "(?:D|LL|M|RE|S|T|VE))?", l0 = s7 + "?", c0 = "[" + Qv + "]?", c7 = "(?:" + i0 + "(?:" + [r0, Td, kd].join("|") + ")" + c0 + l0 + ")*", u7 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", f7 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", u0 = c0 + l0 + c7, d7 = "(?:" + [a7, Td, kd].join("|") + ")" + u0, p7 = "(?:" + [r0 + Ul + "?", Ul, Td, kd, o7].join("|") + ")", h7 = RegExp(Sd, "g"), m7 = RegExp(Ul, "g"), Pd = RegExp(_d + "(?=" + _d + ")|" + p7 + u0, "g"), g7 = RegExp([
      na + "?" + t0 + "+" + a0 + "(?=" + [Jv, na, "$"].join("|") + ")",
      l7 + "+" + s0 + "(?=" + [Jv, na + o0, "$"].join("|") + ")",
      na + "?" + o0 + "+" + a0,
      na + "+" + s0,
      f7,
      u7,
      e0,
      d7
    ].join("|"), "g"), v7 = RegExp("[" + i0 + Nn + Gv + Qv + "]"), w7 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, y7 = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], b7 = -1, Ot = {};
    Ot[De] = Ot[rt] = Ot[it] = Ot[cn] = Ot[Mn] = Ot[En] = Ot[Tr] = Ot[kr] = Ot[Ct] = !0, Ot[ie] = Ot[pe] = Ot[te] = Ot[ke] = Ot[we] = Ot[me] = Ot[ct] = Ot[se] = Ot[xe] = Ot[Ue] = Ot[Et] = Ot[Bt] = Ot[Nt] = Ot[On] = Ot[Kt] = !1;
    var At = {};
    At[ie] = At[pe] = At[te] = At[we] = At[ke] = At[me] = At[De] = At[rt] = At[it] = At[cn] = At[Mn] = At[xe] = At[Ue] = At[Et] = At[Bt] = At[Nt] = At[On] = At[_r] = At[En] = At[Tr] = At[kr] = At[Ct] = !0, At[ct] = At[se] = At[Kt] = !1;
    var x7 = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, E7 = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, C7 = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, S7 = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, _7 = parseFloat, T7 = parseInt, f0 = typeof Ci == "object" && Ci && Ci.Object === Object && Ci, k7 = typeof self == "object" && self && self.Object === Object && self, fn = f0 || k7 || Function("return this")(), Ad = t && !t.nodeType && t, vo = Ad && !0 && e && !e.nodeType && e, d0 = vo && vo.exports === Ad, Rd = d0 && f0.process, sr = function() {
      try {
        var W = vo && vo.require && vo.require("util").types;
        return W || Rd && Rd.binding && Rd.binding("util");
      } catch {
      }
    }(), p0 = sr && sr.isArrayBuffer, h0 = sr && sr.isDate, m0 = sr && sr.isMap, g0 = sr && sr.isRegExp, v0 = sr && sr.isSet, w0 = sr && sr.isTypedArray;
    function qn(W, re, Q) {
      switch (Q.length) {
        case 0:
          return W.call(re);
        case 1:
          return W.call(re, Q[0]);
        case 2:
          return W.call(re, Q[0], Q[1]);
        case 3:
          return W.call(re, Q[0], Q[1], Q[2]);
      }
      return W.apply(re, Q);
    }
    function P7(W, re, Q, Ae) {
      for (var We = -1, ft = W == null ? 0 : W.length; ++We < ft; ) {
        var en = W[We];
        re(Ae, en, Q(en), W);
      }
      return Ae;
    }
    function lr(W, re) {
      for (var Q = -1, Ae = W == null ? 0 : W.length; ++Q < Ae && re(W[Q], Q, W) !== !1; )
        ;
      return W;
    }
    function A7(W, re) {
      for (var Q = W == null ? 0 : W.length; Q-- && re(W[Q], Q, W) !== !1; )
        ;
      return W;
    }
    function y0(W, re) {
      for (var Q = -1, Ae = W == null ? 0 : W.length; ++Q < Ae; )
        if (!re(W[Q], Q, W))
          return !1;
      return !0;
    }
    function Ni(W, re) {
      for (var Q = -1, Ae = W == null ? 0 : W.length, We = 0, ft = []; ++Q < Ae; ) {
        var en = W[Q];
        re(en, Q, W) && (ft[We++] = en);
      }
      return ft;
    }
    function Wl(W, re) {
      var Q = W == null ? 0 : W.length;
      return !!Q && ra(W, re, 0) > -1;
    }
    function $d(W, re, Q) {
      for (var Ae = -1, We = W == null ? 0 : W.length; ++Ae < We; )
        if (Q(re, W[Ae]))
          return !0;
      return !1;
    }
    function It(W, re) {
      for (var Q = -1, Ae = W == null ? 0 : W.length, We = Array(Ae); ++Q < Ae; )
        We[Q] = re(W[Q], Q, W);
      return We;
    }
    function Ii(W, re) {
      for (var Q = -1, Ae = re.length, We = W.length; ++Q < Ae; )
        W[We + Q] = re[Q];
      return W;
    }
    function Od(W, re, Q, Ae) {
      var We = -1, ft = W == null ? 0 : W.length;
      for (Ae && ft && (Q = W[++We]); ++We < ft; )
        Q = re(Q, W[We], We, W);
      return Q;
    }
    function R7(W, re, Q, Ae) {
      var We = W == null ? 0 : W.length;
      for (Ae && We && (Q = W[--We]); We--; )
        Q = re(Q, W[We], We, W);
      return Q;
    }
    function Md(W, re) {
      for (var Q = -1, Ae = W == null ? 0 : W.length; ++Q < Ae; )
        if (re(W[Q], Q, W))
          return !0;
      return !1;
    }
    var $7 = Dd("length");
    function O7(W) {
      return W.split("");
    }
    function M7(W) {
      return W.match(ge) || [];
    }
    function b0(W, re, Q) {
      var Ae;
      return Q(W, function(We, ft, en) {
        if (re(We, ft, en))
          return Ae = ft, !1;
      }), Ae;
    }
    function jl(W, re, Q, Ae) {
      for (var We = W.length, ft = Q + (Ae ? 1 : -1); Ae ? ft-- : ++ft < We; )
        if (re(W[ft], ft, W))
          return ft;
      return -1;
    }
    function ra(W, re, Q) {
      return re === re ? j7(W, re, Q) : jl(W, x0, Q);
    }
    function D7(W, re, Q, Ae) {
      for (var We = Q - 1, ft = W.length; ++We < ft; )
        if (Ae(W[We], re))
          return We;
      return -1;
    }
    function x0(W) {
      return W !== W;
    }
    function E0(W, re) {
      var Q = W == null ? 0 : W.length;
      return Q ? Id(W, re) / Q : A;
    }
    function Dd(W) {
      return function(re) {
        return re == null ? n : re[W];
      };
    }
    function Nd(W) {
      return function(re) {
        return W == null ? n : W[re];
      };
    }
    function C0(W, re, Q, Ae, We) {
      return We(W, function(ft, en, St) {
        Q = Ae ? (Ae = !1, ft) : re(Q, ft, en, St);
      }), Q;
    }
    function N7(W, re) {
      var Q = W.length;
      for (W.sort(re); Q--; )
        W[Q] = W[Q].value;
      return W;
    }
    function Id(W, re) {
      for (var Q, Ae = -1, We = W.length; ++Ae < We; ) {
        var ft = re(W[Ae]);
        ft !== n && (Q = Q === n ? ft : Q + ft);
      }
      return Q;
    }
    function Ld(W, re) {
      for (var Q = -1, Ae = Array(W); ++Q < W; )
        Ae[Q] = re(Q);
      return Ae;
    }
    function I7(W, re) {
      return It(re, function(Q) {
        return [Q, W[Q]];
      });
    }
    function S0(W) {
      return W && W.slice(0, P0(W) + 1).replace(os, "");
    }
    function Gn(W) {
      return function(re) {
        return W(re);
      };
    }
    function Fd(W, re) {
      return It(re, function(Q) {
        return W[Q];
      });
    }
    function as(W, re) {
      return W.has(re);
    }
    function _0(W, re) {
      for (var Q = -1, Ae = W.length; ++Q < Ae && ra(re, W[Q], 0) > -1; )
        ;
      return Q;
    }
    function T0(W, re) {
      for (var Q = W.length; Q-- && ra(re, W[Q], 0) > -1; )
        ;
      return Q;
    }
    function L7(W, re) {
      for (var Q = W.length, Ae = 0; Q--; )
        W[Q] === re && ++Ae;
      return Ae;
    }
    var F7 = Nd(x7), z7 = Nd(E7);
    function V7(W) {
      return "\\" + S7[W];
    }
    function B7(W, re) {
      return W == null ? n : W[re];
    }
    function ia(W) {
      return v7.test(W);
    }
    function H7(W) {
      return w7.test(W);
    }
    function U7(W) {
      for (var re, Q = []; !(re = W.next()).done; )
        Q.push(re.value);
      return Q;
    }
    function zd(W) {
      var re = -1, Q = Array(W.size);
      return W.forEach(function(Ae, We) {
        Q[++re] = [We, Ae];
      }), Q;
    }
    function k0(W, re) {
      return function(Q) {
        return W(re(Q));
      };
    }
    function Li(W, re) {
      for (var Q = -1, Ae = W.length, We = 0, ft = []; ++Q < Ae; ) {
        var en = W[Q];
        (en === re || en === p) && (W[Q] = p, ft[We++] = Q);
      }
      return ft;
    }
    function ql(W) {
      var re = -1, Q = Array(W.size);
      return W.forEach(function(Ae) {
        Q[++re] = Ae;
      }), Q;
    }
    function W7(W) {
      var re = -1, Q = Array(W.size);
      return W.forEach(function(Ae) {
        Q[++re] = [Ae, Ae];
      }), Q;
    }
    function j7(W, re, Q) {
      for (var Ae = Q - 1, We = W.length; ++Ae < We; )
        if (W[Ae] === re)
          return Ae;
      return -1;
    }
    function q7(W, re, Q) {
      for (var Ae = Q + 1; Ae--; )
        if (W[Ae] === re)
          return Ae;
      return Ae;
    }
    function oa(W) {
      return ia(W) ? Y7(W) : $7(W);
    }
    function Ar(W) {
      return ia(W) ? K7(W) : O7(W);
    }
    function P0(W) {
      for (var re = W.length; re-- && xd.test(W.charAt(re)); )
        ;
      return re;
    }
    var G7 = Nd(C7);
    function Y7(W) {
      for (var re = Pd.lastIndex = 0; Pd.test(W); )
        ++re;
      return re;
    }
    function K7(W) {
      return W.match(Pd) || [];
    }
    function X7(W) {
      return W.match(g7) || [];
    }
    var Q7 = function W(re) {
      re = re == null ? fn : aa.defaults(fn.Object(), re, aa.pick(fn, y7));
      var Q = re.Array, Ae = re.Date, We = re.Error, ft = re.Function, en = re.Math, St = re.Object, Vd = re.RegExp, Z7 = re.String, cr = re.TypeError, Gl = Q.prototype, J7 = ft.prototype, sa = St.prototype, Yl = re["__core-js_shared__"], Kl = J7.toString, wt = sa.hasOwnProperty, e_ = 0, A0 = function() {
        var l = /[^.]+$/.exec(Yl && Yl.keys && Yl.keys.IE_PROTO || "");
        return l ? "Symbol(src)_1." + l : "";
      }(), Xl = sa.toString, t_ = Kl.call(St), n_ = fn._, r_ = Vd(
        "^" + Kl.call(wt).replace(is, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Ql = d0 ? re.Buffer : n, Fi = re.Symbol, Zl = re.Uint8Array, R0 = Ql ? Ql.allocUnsafe : n, Jl = k0(St.getPrototypeOf, St), $0 = St.create, O0 = sa.propertyIsEnumerable, ec = Gl.splice, M0 = Fi ? Fi.isConcatSpreadable : n, ss = Fi ? Fi.iterator : n, wo = Fi ? Fi.toStringTag : n, tc = function() {
        try {
          var l = Co(St, "defineProperty");
          return l({}, "", {}), l;
        } catch {
        }
      }(), i_ = re.clearTimeout !== fn.clearTimeout && re.clearTimeout, o_ = Ae && Ae.now !== fn.Date.now && Ae.now, a_ = re.setTimeout !== fn.setTimeout && re.setTimeout, nc = en.ceil, rc = en.floor, Bd = St.getOwnPropertySymbols, s_ = Ql ? Ql.isBuffer : n, D0 = re.isFinite, l_ = Gl.join, c_ = k0(St.keys, St), tn = en.max, hn = en.min, u_ = Ae.now, f_ = re.parseInt, N0 = en.random, d_ = Gl.reverse, Hd = Co(re, "DataView"), ls = Co(re, "Map"), Ud = Co(re, "Promise"), la = Co(re, "Set"), cs = Co(re, "WeakMap"), us = Co(St, "create"), ic = cs && new cs(), ca = {}, p_ = So(Hd), h_ = So(ls), m_ = So(Ud), g_ = So(la), v_ = So(cs), oc = Fi ? Fi.prototype : n, fs = oc ? oc.valueOf : n, I0 = oc ? oc.toString : n;
      function $(l) {
        if (Ut(l) && !je(l) && !(l instanceof tt)) {
          if (l instanceof ur)
            return l;
          if (wt.call(l, "__wrapped__"))
            return Lw(l);
        }
        return new ur(l);
      }
      var ua = function() {
        function l() {
        }
        return function(u) {
          if (!zt(u))
            return {};
          if ($0)
            return $0(u);
          l.prototype = u;
          var g = new l();
          return l.prototype = n, g;
        };
      }();
      function ac() {
      }
      function ur(l, u) {
        this.__wrapped__ = l, this.__actions__ = [], this.__chain__ = !!u, this.__index__ = 0, this.__values__ = n;
      }
      $.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: yd,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Ll,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Fl,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: $
        }
      }, $.prototype = ac.prototype, $.prototype.constructor = $, ur.prototype = ua(ac.prototype), ur.prototype.constructor = ur;
      function tt(l) {
        this.__wrapped__ = l, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = X, this.__views__ = [];
      }
      function w_() {
        var l = new tt(this.__wrapped__);
        return l.__actions__ = In(this.__actions__), l.__dir__ = this.__dir__, l.__filtered__ = this.__filtered__, l.__iteratees__ = In(this.__iteratees__), l.__takeCount__ = this.__takeCount__, l.__views__ = In(this.__views__), l;
      }
      function y_() {
        if (this.__filtered__) {
          var l = new tt(this);
          l.__dir__ = -1, l.__filtered__ = !0;
        } else
          l = this.clone(), l.__dir__ *= -1;
        return l;
      }
      function b_() {
        var l = this.__wrapped__.value(), u = this.__dir__, g = je(l), x = u < 0, k = g ? l.length : 0, O = OT(0, k, this.__views__), F = O.start, U = O.end, q = U - F, oe = x ? U : F - 1, ae = this.__iteratees__, ce = ae.length, Se = 0, $e = hn(q, this.__takeCount__);
        if (!g || !x && k == q && $e == q)
          return aw(l, this.__actions__);
        var ze = [];
        e:
          for (; q-- && Se < $e; ) {
            oe += u;
            for (var Ye = -1, Ve = l[oe]; ++Ye < ce; ) {
              var Ze = ae[Ye], ot = Ze.iteratee, Xn = Ze.type, Tn = ot(Ve);
              if (Xn == G)
                Ve = Tn;
              else if (!Tn) {
                if (Xn == H)
                  continue e;
                break e;
              }
            }
            ze[Se++] = Ve;
          }
        return ze;
      }
      tt.prototype = ua(ac.prototype), tt.prototype.constructor = tt;
      function yo(l) {
        var u = -1, g = l == null ? 0 : l.length;
        for (this.clear(); ++u < g; ) {
          var x = l[u];
          this.set(x[0], x[1]);
        }
      }
      function x_() {
        this.__data__ = us ? us(null) : {}, this.size = 0;
      }
      function E_(l) {
        var u = this.has(l) && delete this.__data__[l];
        return this.size -= u ? 1 : 0, u;
      }
      function C_(l) {
        var u = this.__data__;
        if (us) {
          var g = u[l];
          return g === c ? n : g;
        }
        return wt.call(u, l) ? u[l] : n;
      }
      function S_(l) {
        var u = this.__data__;
        return us ? u[l] !== n : wt.call(u, l);
      }
      function __(l, u) {
        var g = this.__data__;
        return this.size += this.has(l) ? 0 : 1, g[l] = us && u === n ? c : u, this;
      }
      yo.prototype.clear = x_, yo.prototype.delete = E_, yo.prototype.get = C_, yo.prototype.has = S_, yo.prototype.set = __;
      function pi(l) {
        var u = -1, g = l == null ? 0 : l.length;
        for (this.clear(); ++u < g; ) {
          var x = l[u];
          this.set(x[0], x[1]);
        }
      }
      function T_() {
        this.__data__ = [], this.size = 0;
      }
      function k_(l) {
        var u = this.__data__, g = sc(u, l);
        if (g < 0)
          return !1;
        var x = u.length - 1;
        return g == x ? u.pop() : ec.call(u, g, 1), --this.size, !0;
      }
      function P_(l) {
        var u = this.__data__, g = sc(u, l);
        return g < 0 ? n : u[g][1];
      }
      function A_(l) {
        return sc(this.__data__, l) > -1;
      }
      function R_(l, u) {
        var g = this.__data__, x = sc(g, l);
        return x < 0 ? (++this.size, g.push([l, u])) : g[x][1] = u, this;
      }
      pi.prototype.clear = T_, pi.prototype.delete = k_, pi.prototype.get = P_, pi.prototype.has = A_, pi.prototype.set = R_;
      function hi(l) {
        var u = -1, g = l == null ? 0 : l.length;
        for (this.clear(); ++u < g; ) {
          var x = l[u];
          this.set(x[0], x[1]);
        }
      }
      function $_() {
        this.size = 0, this.__data__ = {
          hash: new yo(),
          map: new (ls || pi)(),
          string: new yo()
        };
      }
      function O_(l) {
        var u = yc(this, l).delete(l);
        return this.size -= u ? 1 : 0, u;
      }
      function M_(l) {
        return yc(this, l).get(l);
      }
      function D_(l) {
        return yc(this, l).has(l);
      }
      function N_(l, u) {
        var g = yc(this, l), x = g.size;
        return g.set(l, u), this.size += g.size == x ? 0 : 1, this;
      }
      hi.prototype.clear = $_, hi.prototype.delete = O_, hi.prototype.get = M_, hi.prototype.has = D_, hi.prototype.set = N_;
      function bo(l) {
        var u = -1, g = l == null ? 0 : l.length;
        for (this.__data__ = new hi(); ++u < g; )
          this.add(l[u]);
      }
      function I_(l) {
        return this.__data__.set(l, c), this;
      }
      function L_(l) {
        return this.__data__.has(l);
      }
      bo.prototype.add = bo.prototype.push = I_, bo.prototype.has = L_;
      function Rr(l) {
        var u = this.__data__ = new pi(l);
        this.size = u.size;
      }
      function F_() {
        this.__data__ = new pi(), this.size = 0;
      }
      function z_(l) {
        var u = this.__data__, g = u.delete(l);
        return this.size = u.size, g;
      }
      function V_(l) {
        return this.__data__.get(l);
      }
      function B_(l) {
        return this.__data__.has(l);
      }
      function H_(l, u) {
        var g = this.__data__;
        if (g instanceof pi) {
          var x = g.__data__;
          if (!ls || x.length < i - 1)
            return x.push([l, u]), this.size = ++g.size, this;
          g = this.__data__ = new hi(x);
        }
        return g.set(l, u), this.size = g.size, this;
      }
      Rr.prototype.clear = F_, Rr.prototype.delete = z_, Rr.prototype.get = V_, Rr.prototype.has = B_, Rr.prototype.set = H_;
      function L0(l, u) {
        var g = je(l), x = !g && _o(l), k = !g && !x && Ui(l), O = !g && !x && !k && ha(l), F = g || x || k || O, U = F ? Ld(l.length, Z7) : [], q = U.length;
        for (var oe in l)
          (u || wt.call(l, oe)) && !(F && // Safari 9 has enumerable `arguments.length` in strict mode.
          (oe == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          k && (oe == "offset" || oe == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          O && (oe == "buffer" || oe == "byteLength" || oe == "byteOffset") || // Skip index properties.
          wi(oe, q))) && U.push(oe);
        return U;
      }
      function F0(l) {
        var u = l.length;
        return u ? l[ep(0, u - 1)] : n;
      }
      function U_(l, u) {
        return bc(In(l), xo(u, 0, l.length));
      }
      function W_(l) {
        return bc(In(l));
      }
      function Wd(l, u, g) {
        (g !== n && !$r(l[u], g) || g === n && !(u in l)) && mi(l, u, g);
      }
      function ds(l, u, g) {
        var x = l[u];
        (!(wt.call(l, u) && $r(x, g)) || g === n && !(u in l)) && mi(l, u, g);
      }
      function sc(l, u) {
        for (var g = l.length; g--; )
          if ($r(l[g][0], u))
            return g;
        return -1;
      }
      function j_(l, u, g, x) {
        return zi(l, function(k, O, F) {
          u(x, k, g(k), F);
        }), x;
      }
      function z0(l, u) {
        return l && Xr(u, sn(u), l);
      }
      function q_(l, u) {
        return l && Xr(u, Fn(u), l);
      }
      function mi(l, u, g) {
        u == "__proto__" && tc ? tc(l, u, {
          configurable: !0,
          enumerable: !0,
          value: g,
          writable: !0
        }) : l[u] = g;
      }
      function jd(l, u) {
        for (var g = -1, x = u.length, k = Q(x), O = l == null; ++g < x; )
          k[g] = O ? n : _p(l, u[g]);
        return k;
      }
      function xo(l, u, g) {
        return l === l && (g !== n && (l = l <= g ? l : g), u !== n && (l = l >= u ? l : u)), l;
      }
      function fr(l, u, g, x, k, O) {
        var F, U = u & d, q = u & h, oe = u & m;
        if (g && (F = k ? g(l, x, k, O) : g(l)), F !== n)
          return F;
        if (!zt(l))
          return l;
        var ae = je(l);
        if (ae) {
          if (F = DT(l), !U)
            return In(l, F);
        } else {
          var ce = mn(l), Se = ce == se || ce == Le;
          if (Ui(l))
            return cw(l, U);
          if (ce == Et || ce == ie || Se && !k) {
            if (F = q || Se ? {} : Pw(l), !U)
              return q ? CT(l, q_(F, l)) : ET(l, z0(F, l));
          } else {
            if (!At[ce])
              return k ? l : {};
            F = NT(l, ce, U);
          }
        }
        O || (O = new Rr());
        var $e = O.get(l);
        if ($e)
          return $e;
        O.set(l, F), ry(l) ? l.forEach(function(Ve) {
          F.add(fr(Ve, u, g, Ve, l, O));
        }) : ty(l) && l.forEach(function(Ve, Ze) {
          F.set(Ze, fr(Ve, u, g, Ze, l, O));
        });
        var ze = oe ? q ? fp : up : q ? Fn : sn, Ye = ae ? n : ze(l);
        return lr(Ye || l, function(Ve, Ze) {
          Ye && (Ze = Ve, Ve = l[Ze]), ds(F, Ze, fr(Ve, u, g, Ze, l, O));
        }), F;
      }
      function G_(l) {
        var u = sn(l);
        return function(g) {
          return V0(g, l, u);
        };
      }
      function V0(l, u, g) {
        var x = g.length;
        if (l == null)
          return !x;
        for (l = St(l); x--; ) {
          var k = g[x], O = u[k], F = l[k];
          if (F === n && !(k in l) || !O(F))
            return !1;
        }
        return !0;
      }
      function B0(l, u, g) {
        if (typeof l != "function")
          throw new cr(a);
        return ys(function() {
          l.apply(n, g);
        }, u);
      }
      function ps(l, u, g, x) {
        var k = -1, O = Wl, F = !0, U = l.length, q = [], oe = u.length;
        if (!U)
          return q;
        g && (u = It(u, Gn(g))), x ? (O = $d, F = !1) : u.length >= i && (O = as, F = !1, u = new bo(u));
        e:
          for (; ++k < U; ) {
            var ae = l[k], ce = g == null ? ae : g(ae);
            if (ae = x || ae !== 0 ? ae : 0, F && ce === ce) {
              for (var Se = oe; Se--; )
                if (u[Se] === ce)
                  continue e;
              q.push(ae);
            } else
              O(u, ce, x) || q.push(ae);
          }
        return q;
      }
      var zi = hw(Kr), H0 = hw(Gd, !0);
      function Y_(l, u) {
        var g = !0;
        return zi(l, function(x, k, O) {
          return g = !!u(x, k, O), g;
        }), g;
      }
      function lc(l, u, g) {
        for (var x = -1, k = l.length; ++x < k; ) {
          var O = l[x], F = u(O);
          if (F != null && (U === n ? F === F && !Kn(F) : g(F, U)))
            var U = F, q = O;
        }
        return q;
      }
      function K_(l, u, g, x) {
        var k = l.length;
        for (g = Ge(g), g < 0 && (g = -g > k ? 0 : k + g), x = x === n || x > k ? k : Ge(x), x < 0 && (x += k), x = g > x ? 0 : oy(x); g < x; )
          l[g++] = u;
        return l;
      }
      function U0(l, u) {
        var g = [];
        return zi(l, function(x, k, O) {
          u(x, k, O) && g.push(x);
        }), g;
      }
      function dn(l, u, g, x, k) {
        var O = -1, F = l.length;
        for (g || (g = LT), k || (k = []); ++O < F; ) {
          var U = l[O];
          u > 0 && g(U) ? u > 1 ? dn(U, u - 1, g, x, k) : Ii(k, U) : x || (k[k.length] = U);
        }
        return k;
      }
      var qd = mw(), W0 = mw(!0);
      function Kr(l, u) {
        return l && qd(l, u, sn);
      }
      function Gd(l, u) {
        return l && W0(l, u, sn);
      }
      function cc(l, u) {
        return Ni(u, function(g) {
          return yi(l[g]);
        });
      }
      function Eo(l, u) {
        u = Bi(u, l);
        for (var g = 0, x = u.length; l != null && g < x; )
          l = l[Qr(u[g++])];
        return g && g == x ? l : n;
      }
      function j0(l, u, g) {
        var x = u(l);
        return je(l) ? x : Ii(x, g(l));
      }
      function Sn(l) {
        return l == null ? l === n ? an : bt : wo && wo in St(l) ? $T(l) : WT(l);
      }
      function Yd(l, u) {
        return l > u;
      }
      function X_(l, u) {
        return l != null && wt.call(l, u);
      }
      function Q_(l, u) {
        return l != null && u in St(l);
      }
      function Z_(l, u, g) {
        return l >= hn(u, g) && l < tn(u, g);
      }
      function Kd(l, u, g) {
        for (var x = g ? $d : Wl, k = l[0].length, O = l.length, F = O, U = Q(O), q = 1 / 0, oe = []; F--; ) {
          var ae = l[F];
          F && u && (ae = It(ae, Gn(u))), q = hn(ae.length, q), U[F] = !g && (u || k >= 120 && ae.length >= 120) ? new bo(F && ae) : n;
        }
        ae = l[0];
        var ce = -1, Se = U[0];
        e:
          for (; ++ce < k && oe.length < q; ) {
            var $e = ae[ce], ze = u ? u($e) : $e;
            if ($e = g || $e !== 0 ? $e : 0, !(Se ? as(Se, ze) : x(oe, ze, g))) {
              for (F = O; --F; ) {
                var Ye = U[F];
                if (!(Ye ? as(Ye, ze) : x(l[F], ze, g)))
                  continue e;
              }
              Se && Se.push(ze), oe.push($e);
            }
          }
        return oe;
      }
      function J_(l, u, g, x) {
        return Kr(l, function(k, O, F) {
          u(x, g(k), O, F);
        }), x;
      }
      function hs(l, u, g) {
        u = Bi(u, l), l = Ow(l, u);
        var x = l == null ? l : l[Qr(pr(u))];
        return x == null ? n : qn(x, l, g);
      }
      function q0(l) {
        return Ut(l) && Sn(l) == ie;
      }
      function eT(l) {
        return Ut(l) && Sn(l) == te;
      }
      function tT(l) {
        return Ut(l) && Sn(l) == me;
      }
      function ms(l, u, g, x, k) {
        return l === u ? !0 : l == null || u == null || !Ut(l) && !Ut(u) ? l !== l && u !== u : nT(l, u, g, x, ms, k);
      }
      function nT(l, u, g, x, k, O) {
        var F = je(l), U = je(u), q = F ? pe : mn(l), oe = U ? pe : mn(u);
        q = q == ie ? Et : q, oe = oe == ie ? Et : oe;
        var ae = q == Et, ce = oe == Et, Se = q == oe;
        if (Se && Ui(l)) {
          if (!Ui(u))
            return !1;
          F = !0, ae = !1;
        }
        if (Se && !ae)
          return O || (O = new Rr()), F || ha(l) ? _w(l, u, g, x, k, O) : AT(l, u, q, g, x, k, O);
        if (!(g & v)) {
          var $e = ae && wt.call(l, "__wrapped__"), ze = ce && wt.call(u, "__wrapped__");
          if ($e || ze) {
            var Ye = $e ? l.value() : l, Ve = ze ? u.value() : u;
            return O || (O = new Rr()), k(Ye, Ve, g, x, O);
          }
        }
        return Se ? (O || (O = new Rr()), RT(l, u, g, x, k, O)) : !1;
      }
      function rT(l) {
        return Ut(l) && mn(l) == xe;
      }
      function Xd(l, u, g, x) {
        var k = g.length, O = k, F = !x;
        if (l == null)
          return !O;
        for (l = St(l); k--; ) {
          var U = g[k];
          if (F && U[2] ? U[1] !== l[U[0]] : !(U[0] in l))
            return !1;
        }
        for (; ++k < O; ) {
          U = g[k];
          var q = U[0], oe = l[q], ae = U[1];
          if (F && U[2]) {
            if (oe === n && !(q in l))
              return !1;
          } else {
            var ce = new Rr();
            if (x)
              var Se = x(oe, ae, q, l, u, ce);
            if (!(Se === n ? ms(ae, oe, v | w, x, ce) : Se))
              return !1;
          }
        }
        return !0;
      }
      function G0(l) {
        if (!zt(l) || zT(l))
          return !1;
        var u = yi(l) ? r_ : un;
        return u.test(So(l));
      }
      function iT(l) {
        return Ut(l) && Sn(l) == Bt;
      }
      function oT(l) {
        return Ut(l) && mn(l) == Nt;
      }
      function aT(l) {
        return Ut(l) && Tc(l.length) && !!Ot[Sn(l)];
      }
      function Y0(l) {
        return typeof l == "function" ? l : l == null ? zn : typeof l == "object" ? je(l) ? Q0(l[0], l[1]) : X0(l) : gy(l);
      }
      function Qd(l) {
        if (!ws(l))
          return c_(l);
        var u = [];
        for (var g in St(l))
          wt.call(l, g) && g != "constructor" && u.push(g);
        return u;
      }
      function sT(l) {
        if (!zt(l))
          return UT(l);
        var u = ws(l), g = [];
        for (var x in l)
          x == "constructor" && (u || !wt.call(l, x)) || g.push(x);
        return g;
      }
      function Zd(l, u) {
        return l < u;
      }
      function K0(l, u) {
        var g = -1, x = Ln(l) ? Q(l.length) : [];
        return zi(l, function(k, O, F) {
          x[++g] = u(k, O, F);
        }), x;
      }
      function X0(l) {
        var u = pp(l);
        return u.length == 1 && u[0][2] ? Rw(u[0][0], u[0][1]) : function(g) {
          return g === l || Xd(g, l, u);
        };
      }
      function Q0(l, u) {
        return mp(l) && Aw(u) ? Rw(Qr(l), u) : function(g) {
          var x = _p(g, l);
          return x === n && x === u ? Tp(g, l) : ms(u, x, v | w);
        };
      }
      function uc(l, u, g, x, k) {
        l !== u && qd(u, function(O, F) {
          if (k || (k = new Rr()), zt(O))
            lT(l, u, F, g, uc, x, k);
          else {
            var U = x ? x(vp(l, F), O, F + "", l, u, k) : n;
            U === n && (U = O), Wd(l, F, U);
          }
        }, Fn);
      }
      function lT(l, u, g, x, k, O, F) {
        var U = vp(l, g), q = vp(u, g), oe = F.get(q);
        if (oe) {
          Wd(l, g, oe);
          return;
        }
        var ae = O ? O(U, q, g + "", l, u, F) : n, ce = ae === n;
        if (ce) {
          var Se = je(q), $e = !Se && Ui(q), ze = !Se && !$e && ha(q);
          ae = q, Se || $e || ze ? je(U) ? ae = U : Gt(U) ? ae = In(U) : $e ? (ce = !1, ae = cw(q, !0)) : ze ? (ce = !1, ae = uw(q, !0)) : ae = [] : bs(q) || _o(q) ? (ae = U, _o(U) ? ae = ay(U) : (!zt(U) || yi(U)) && (ae = Pw(q))) : ce = !1;
        }
        ce && (F.set(q, ae), k(ae, q, x, O, F), F.delete(q)), Wd(l, g, ae);
      }
      function Z0(l, u) {
        var g = l.length;
        if (g)
          return u += u < 0 ? g : 0, wi(u, g) ? l[u] : n;
      }
      function J0(l, u, g) {
        u.length ? u = It(u, function(O) {
          return je(O) ? function(F) {
            return Eo(F, O.length === 1 ? O[0] : O);
          } : O;
        }) : u = [zn];
        var x = -1;
        u = It(u, Gn(Fe()));
        var k = K0(l, function(O, F, U) {
          var q = It(u, function(oe) {
            return oe(O);
          });
          return { criteria: q, index: ++x, value: O };
        });
        return N7(k, function(O, F) {
          return xT(O, F, g);
        });
      }
      function cT(l, u) {
        return ew(l, u, function(g, x) {
          return Tp(l, x);
        });
      }
      function ew(l, u, g) {
        for (var x = -1, k = u.length, O = {}; ++x < k; ) {
          var F = u[x], U = Eo(l, F);
          g(U, F) && gs(O, Bi(F, l), U);
        }
        return O;
      }
      function uT(l) {
        return function(u) {
          return Eo(u, l);
        };
      }
      function Jd(l, u, g, x) {
        var k = x ? D7 : ra, O = -1, F = u.length, U = l;
        for (l === u && (u = In(u)), g && (U = It(l, Gn(g))); ++O < F; )
          for (var q = 0, oe = u[O], ae = g ? g(oe) : oe; (q = k(U, ae, q, x)) > -1; )
            U !== l && ec.call(U, q, 1), ec.call(l, q, 1);
        return l;
      }
      function tw(l, u) {
        for (var g = l ? u.length : 0, x = g - 1; g--; ) {
          var k = u[g];
          if (g == x || k !== O) {
            var O = k;
            wi(k) ? ec.call(l, k, 1) : rp(l, k);
          }
        }
        return l;
      }
      function ep(l, u) {
        return l + rc(N0() * (u - l + 1));
      }
      function fT(l, u, g, x) {
        for (var k = -1, O = tn(nc((u - l) / (g || 1)), 0), F = Q(O); O--; )
          F[x ? O : ++k] = l, l += g;
        return F;
      }
      function tp(l, u) {
        var g = "";
        if (!l || u < 1 || u > J)
          return g;
        do
          u % 2 && (g += l), u = rc(u / 2), u && (l += l);
        while (u);
        return g;
      }
      function Ke(l, u) {
        return wp($w(l, u, zn), l + "");
      }
      function dT(l) {
        return F0(ma(l));
      }
      function pT(l, u) {
        var g = ma(l);
        return bc(g, xo(u, 0, g.length));
      }
      function gs(l, u, g, x) {
        if (!zt(l))
          return l;
        u = Bi(u, l);
        for (var k = -1, O = u.length, F = O - 1, U = l; U != null && ++k < O; ) {
          var q = Qr(u[k]), oe = g;
          if (q === "__proto__" || q === "constructor" || q === "prototype")
            return l;
          if (k != F) {
            var ae = U[q];
            oe = x ? x(ae, q, U) : n, oe === n && (oe = zt(ae) ? ae : wi(u[k + 1]) ? [] : {});
          }
          ds(U, q, oe), U = U[q];
        }
        return l;
      }
      var nw = ic ? function(l, u) {
        return ic.set(l, u), l;
      } : zn, hT = tc ? function(l, u) {
        return tc(l, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Pp(u),
          writable: !0
        });
      } : zn;
      function mT(l) {
        return bc(ma(l));
      }
      function dr(l, u, g) {
        var x = -1, k = l.length;
        u < 0 && (u = -u > k ? 0 : k + u), g = g > k ? k : g, g < 0 && (g += k), k = u > g ? 0 : g - u >>> 0, u >>>= 0;
        for (var O = Q(k); ++x < k; )
          O[x] = l[x + u];
        return O;
      }
      function gT(l, u) {
        var g;
        return zi(l, function(x, k, O) {
          return g = u(x, k, O), !g;
        }), !!g;
      }
      function fc(l, u, g) {
        var x = 0, k = l == null ? x : l.length;
        if (typeof u == "number" && u === u && k <= M) {
          for (; x < k; ) {
            var O = x + k >>> 1, F = l[O];
            F !== null && !Kn(F) && (g ? F <= u : F < u) ? x = O + 1 : k = O;
          }
          return k;
        }
        return np(l, u, zn, g);
      }
      function np(l, u, g, x) {
        var k = 0, O = l == null ? 0 : l.length;
        if (O === 0)
          return 0;
        u = g(u);
        for (var F = u !== u, U = u === null, q = Kn(u), oe = u === n; k < O; ) {
          var ae = rc((k + O) / 2), ce = g(l[ae]), Se = ce !== n, $e = ce === null, ze = ce === ce, Ye = Kn(ce);
          if (F)
            var Ve = x || ze;
          else
            oe ? Ve = ze && (x || Se) : U ? Ve = ze && Se && (x || !$e) : q ? Ve = ze && Se && !$e && (x || !Ye) : $e || Ye ? Ve = !1 : Ve = x ? ce <= u : ce < u;
          Ve ? k = ae + 1 : O = ae;
        }
        return hn(O, fe);
      }
      function rw(l, u) {
        for (var g = -1, x = l.length, k = 0, O = []; ++g < x; ) {
          var F = l[g], U = u ? u(F) : F;
          if (!g || !$r(U, q)) {
            var q = U;
            O[k++] = F === 0 ? 0 : F;
          }
        }
        return O;
      }
      function iw(l) {
        return typeof l == "number" ? l : Kn(l) ? A : +l;
      }
      function Yn(l) {
        if (typeof l == "string")
          return l;
        if (je(l))
          return It(l, Yn) + "";
        if (Kn(l))
          return I0 ? I0.call(l) : "";
        var u = l + "";
        return u == "0" && 1 / l == -ne ? "-0" : u;
      }
      function Vi(l, u, g) {
        var x = -1, k = Wl, O = l.length, F = !0, U = [], q = U;
        if (g)
          F = !1, k = $d;
        else if (O >= i) {
          var oe = u ? null : kT(l);
          if (oe)
            return ql(oe);
          F = !1, k = as, q = new bo();
        } else
          q = u ? [] : U;
        e:
          for (; ++x < O; ) {
            var ae = l[x], ce = u ? u(ae) : ae;
            if (ae = g || ae !== 0 ? ae : 0, F && ce === ce) {
              for (var Se = q.length; Se--; )
                if (q[Se] === ce)
                  continue e;
              u && q.push(ce), U.push(ae);
            } else
              k(q, ce, g) || (q !== U && q.push(ce), U.push(ae));
          }
        return U;
      }
      function rp(l, u) {
        return u = Bi(u, l), l = Ow(l, u), l == null || delete l[Qr(pr(u))];
      }
      function ow(l, u, g, x) {
        return gs(l, u, g(Eo(l, u)), x);
      }
      function dc(l, u, g, x) {
        for (var k = l.length, O = x ? k : -1; (x ? O-- : ++O < k) && u(l[O], O, l); )
          ;
        return g ? dr(l, x ? 0 : O, x ? O + 1 : k) : dr(l, x ? O + 1 : 0, x ? k : O);
      }
      function aw(l, u) {
        var g = l;
        return g instanceof tt && (g = g.value()), Od(u, function(x, k) {
          return k.func.apply(k.thisArg, Ii([x], k.args));
        }, g);
      }
      function ip(l, u, g) {
        var x = l.length;
        if (x < 2)
          return x ? Vi(l[0]) : [];
        for (var k = -1, O = Q(x); ++k < x; )
          for (var F = l[k], U = -1; ++U < x; )
            U != k && (O[k] = ps(O[k] || F, l[U], u, g));
        return Vi(dn(O, 1), u, g);
      }
      function sw(l, u, g) {
        for (var x = -1, k = l.length, O = u.length, F = {}; ++x < k; ) {
          var U = x < O ? u[x] : n;
          g(F, l[x], U);
        }
        return F;
      }
      function op(l) {
        return Gt(l) ? l : [];
      }
      function ap(l) {
        return typeof l == "function" ? l : zn;
      }
      function Bi(l, u) {
        return je(l) ? l : mp(l, u) ? [l] : Iw(pt(l));
      }
      var vT = Ke;
      function Hi(l, u, g) {
        var x = l.length;
        return g = g === n ? x : g, !u && g >= x ? l : dr(l, u, g);
      }
      var lw = i_ || function(l) {
        return fn.clearTimeout(l);
      };
      function cw(l, u) {
        if (u)
          return l.slice();
        var g = l.length, x = R0 ? R0(g) : new l.constructor(g);
        return l.copy(x), x;
      }
      function sp(l) {
        var u = new l.constructor(l.byteLength);
        return new Zl(u).set(new Zl(l)), u;
      }
      function wT(l, u) {
        var g = u ? sp(l.buffer) : l.buffer;
        return new l.constructor(g, l.byteOffset, l.byteLength);
      }
      function yT(l) {
        var u = new l.constructor(l.source, dt.exec(l));
        return u.lastIndex = l.lastIndex, u;
      }
      function bT(l) {
        return fs ? St(fs.call(l)) : {};
      }
      function uw(l, u) {
        var g = u ? sp(l.buffer) : l.buffer;
        return new l.constructor(g, l.byteOffset, l.length);
      }
      function fw(l, u) {
        if (l !== u) {
          var g = l !== n, x = l === null, k = l === l, O = Kn(l), F = u !== n, U = u === null, q = u === u, oe = Kn(u);
          if (!U && !oe && !O && l > u || O && F && q && !U && !oe || x && F && q || !g && q || !k)
            return 1;
          if (!x && !O && !oe && l < u || oe && g && k && !x && !O || U && g && k || !F && k || !q)
            return -1;
        }
        return 0;
      }
      function xT(l, u, g) {
        for (var x = -1, k = l.criteria, O = u.criteria, F = k.length, U = g.length; ++x < F; ) {
          var q = fw(k[x], O[x]);
          if (q) {
            if (x >= U)
              return q;
            var oe = g[x];
            return q * (oe == "desc" ? -1 : 1);
          }
        }
        return l.index - u.index;
      }
      function dw(l, u, g, x) {
        for (var k = -1, O = l.length, F = g.length, U = -1, q = u.length, oe = tn(O - F, 0), ae = Q(q + oe), ce = !x; ++U < q; )
          ae[U] = u[U];
        for (; ++k < F; )
          (ce || k < O) && (ae[g[k]] = l[k]);
        for (; oe--; )
          ae[U++] = l[k++];
        return ae;
      }
      function pw(l, u, g, x) {
        for (var k = -1, O = l.length, F = -1, U = g.length, q = -1, oe = u.length, ae = tn(O - U, 0), ce = Q(ae + oe), Se = !x; ++k < ae; )
          ce[k] = l[k];
        for (var $e = k; ++q < oe; )
          ce[$e + q] = u[q];
        for (; ++F < U; )
          (Se || k < O) && (ce[$e + g[F]] = l[k++]);
        return ce;
      }
      function In(l, u) {
        var g = -1, x = l.length;
        for (u || (u = Q(x)); ++g < x; )
          u[g] = l[g];
        return u;
      }
      function Xr(l, u, g, x) {
        var k = !g;
        g || (g = {});
        for (var O = -1, F = u.length; ++O < F; ) {
          var U = u[O], q = x ? x(g[U], l[U], U, g, l) : n;
          q === n && (q = l[U]), k ? mi(g, U, q) : ds(g, U, q);
        }
        return g;
      }
      function ET(l, u) {
        return Xr(l, hp(l), u);
      }
      function CT(l, u) {
        return Xr(l, Tw(l), u);
      }
      function pc(l, u) {
        return function(g, x) {
          var k = je(g) ? P7 : j_, O = u ? u() : {};
          return k(g, l, Fe(x, 2), O);
        };
      }
      function fa(l) {
        return Ke(function(u, g) {
          var x = -1, k = g.length, O = k > 1 ? g[k - 1] : n, F = k > 2 ? g[2] : n;
          for (O = l.length > 3 && typeof O == "function" ? (k--, O) : n, F && _n(g[0], g[1], F) && (O = k < 3 ? n : O, k = 1), u = St(u); ++x < k; ) {
            var U = g[x];
            U && l(u, U, x, O);
          }
          return u;
        });
      }
      function hw(l, u) {
        return function(g, x) {
          if (g == null)
            return g;
          if (!Ln(g))
            return l(g, x);
          for (var k = g.length, O = u ? k : -1, F = St(g); (u ? O-- : ++O < k) && x(F[O], O, F) !== !1; )
            ;
          return g;
        };
      }
      function mw(l) {
        return function(u, g, x) {
          for (var k = -1, O = St(u), F = x(u), U = F.length; U--; ) {
            var q = F[l ? U : ++k];
            if (g(O[q], q, O) === !1)
              break;
          }
          return u;
        };
      }
      function ST(l, u, g) {
        var x = u & b, k = vs(l);
        function O() {
          var F = this && this !== fn && this instanceof O ? k : l;
          return F.apply(x ? g : this, arguments);
        }
        return O;
      }
      function gw(l) {
        return function(u) {
          u = pt(u);
          var g = ia(u) ? Ar(u) : n, x = g ? g[0] : u.charAt(0), k = g ? Hi(g, 1).join("") : u.slice(1);
          return x[l]() + k;
        };
      }
      function da(l) {
        return function(u) {
          return Od(hy(py(u).replace(h7, "")), l, "");
        };
      }
      function vs(l) {
        return function() {
          var u = arguments;
          switch (u.length) {
            case 0:
              return new l();
            case 1:
              return new l(u[0]);
            case 2:
              return new l(u[0], u[1]);
            case 3:
              return new l(u[0], u[1], u[2]);
            case 4:
              return new l(u[0], u[1], u[2], u[3]);
            case 5:
              return new l(u[0], u[1], u[2], u[3], u[4]);
            case 6:
              return new l(u[0], u[1], u[2], u[3], u[4], u[5]);
            case 7:
              return new l(u[0], u[1], u[2], u[3], u[4], u[5], u[6]);
          }
          var g = ua(l.prototype), x = l.apply(g, u);
          return zt(x) ? x : g;
        };
      }
      function _T(l, u, g) {
        var x = vs(l);
        function k() {
          for (var O = arguments.length, F = Q(O), U = O, q = pa(k); U--; )
            F[U] = arguments[U];
          var oe = O < 3 && F[0] !== q && F[O - 1] !== q ? [] : Li(F, q);
          if (O -= oe.length, O < g)
            return xw(
              l,
              u,
              hc,
              k.placeholder,
              n,
              F,
              oe,
              n,
              n,
              g - O
            );
          var ae = this && this !== fn && this instanceof k ? x : l;
          return qn(ae, this, F);
        }
        return k;
      }
      function vw(l) {
        return function(u, g, x) {
          var k = St(u);
          if (!Ln(u)) {
            var O = Fe(g, 3);
            u = sn(u), g = function(U) {
              return O(k[U], U, k);
            };
          }
          var F = l(u, g, x);
          return F > -1 ? k[O ? u[F] : F] : n;
        };
      }
      function ww(l) {
        return vi(function(u) {
          var g = u.length, x = g, k = ur.prototype.thru;
          for (l && u.reverse(); x--; ) {
            var O = u[x];
            if (typeof O != "function")
              throw new cr(a);
            if (k && !F && wc(O) == "wrapper")
              var F = new ur([], !0);
          }
          for (x = F ? x : g; ++x < g; ) {
            O = u[x];
            var U = wc(O), q = U == "wrapper" ? dp(O) : n;
            q && gp(q[0]) && q[1] == (R | S | T | N) && !q[4].length && q[9] == 1 ? F = F[wc(q[0])].apply(F, q[3]) : F = O.length == 1 && gp(O) ? F[U]() : F.thru(O);
          }
          return function() {
            var oe = arguments, ae = oe[0];
            if (F && oe.length == 1 && je(ae))
              return F.plant(ae).value();
            for (var ce = 0, Se = g ? u[ce].apply(this, oe) : ae; ++ce < g; )
              Se = u[ce].call(this, Se);
            return Se;
          };
        });
      }
      function hc(l, u, g, x, k, O, F, U, q, oe) {
        var ae = u & R, ce = u & b, Se = u & E, $e = u & (S | _), ze = u & B, Ye = Se ? n : vs(l);
        function Ve() {
          for (var Ze = arguments.length, ot = Q(Ze), Xn = Ze; Xn--; )
            ot[Xn] = arguments[Xn];
          if ($e)
            var Tn = pa(Ve), Qn = L7(ot, Tn);
          if (x && (ot = dw(ot, x, k, $e)), O && (ot = pw(ot, O, F, $e)), Ze -= Qn, $e && Ze < oe) {
            var Yt = Li(ot, Tn);
            return xw(
              l,
              u,
              hc,
              Ve.placeholder,
              g,
              ot,
              Yt,
              U,
              q,
              oe - Ze
            );
          }
          var Or = ce ? g : this, xi = Se ? Or[l] : l;
          return Ze = ot.length, U ? ot = jT(ot, U) : ze && Ze > 1 && ot.reverse(), ae && q < Ze && (ot.length = q), this && this !== fn && this instanceof Ve && (xi = Ye || vs(xi)), xi.apply(Or, ot);
        }
        return Ve;
      }
      function yw(l, u) {
        return function(g, x) {
          return J_(g, l, u(x), {});
        };
      }
      function mc(l, u) {
        return function(g, x) {
          var k;
          if (g === n && x === n)
            return u;
          if (g !== n && (k = g), x !== n) {
            if (k === n)
              return x;
            typeof g == "string" || typeof x == "string" ? (g = Yn(g), x = Yn(x)) : (g = iw(g), x = iw(x)), k = l(g, x);
          }
          return k;
        };
      }
      function lp(l) {
        return vi(function(u) {
          return u = It(u, Gn(Fe())), Ke(function(g) {
            var x = this;
            return l(u, function(k) {
              return qn(k, x, g);
            });
          });
        });
      }
      function gc(l, u) {
        u = u === n ? " " : Yn(u);
        var g = u.length;
        if (g < 2)
          return g ? tp(u, l) : u;
        var x = tp(u, nc(l / oa(u)));
        return ia(u) ? Hi(Ar(x), 0, l).join("") : x.slice(0, l);
      }
      function TT(l, u, g, x) {
        var k = u & b, O = vs(l);
        function F() {
          for (var U = -1, q = arguments.length, oe = -1, ae = x.length, ce = Q(ae + q), Se = this && this !== fn && this instanceof F ? O : l; ++oe < ae; )
            ce[oe] = x[oe];
          for (; q--; )
            ce[oe++] = arguments[++U];
          return qn(Se, k ? g : this, ce);
        }
        return F;
      }
      function bw(l) {
        return function(u, g, x) {
          return x && typeof x != "number" && _n(u, g, x) && (g = x = n), u = bi(u), g === n ? (g = u, u = 0) : g = bi(g), x = x === n ? u < g ? 1 : -1 : bi(x), fT(u, g, x, l);
        };
      }
      function vc(l) {
        return function(u, g) {
          return typeof u == "string" && typeof g == "string" || (u = hr(u), g = hr(g)), l(u, g);
        };
      }
      function xw(l, u, g, x, k, O, F, U, q, oe) {
        var ae = u & S, ce = ae ? F : n, Se = ae ? n : F, $e = ae ? O : n, ze = ae ? n : O;
        u |= ae ? T : P, u &= ~(ae ? P : T), u & C || (u &= ~(b | E));
        var Ye = [
          l,
          u,
          k,
          $e,
          ce,
          ze,
          Se,
          U,
          q,
          oe
        ], Ve = g.apply(n, Ye);
        return gp(l) && Mw(Ve, Ye), Ve.placeholder = x, Dw(Ve, l, u);
      }
      function cp(l) {
        var u = en[l];
        return function(g, x) {
          if (g = hr(g), x = x == null ? 0 : hn(Ge(x), 292), x && D0(g)) {
            var k = (pt(g) + "e").split("e"), O = u(k[0] + "e" + (+k[1] + x));
            return k = (pt(O) + "e").split("e"), +(k[0] + "e" + (+k[1] - x));
          }
          return u(g);
        };
      }
      var kT = la && 1 / ql(new la([, -0]))[1] == ne ? function(l) {
        return new la(l);
      } : $p;
      function Ew(l) {
        return function(u) {
          var g = mn(u);
          return g == xe ? zd(u) : g == Nt ? W7(u) : I7(u, l(u));
        };
      }
      function gi(l, u, g, x, k, O, F, U) {
        var q = u & E;
        if (!q && typeof l != "function")
          throw new cr(a);
        var oe = x ? x.length : 0;
        if (oe || (u &= ~(T | P), x = k = n), F = F === n ? F : tn(Ge(F), 0), U = U === n ? U : Ge(U), oe -= k ? k.length : 0, u & P) {
          var ae = x, ce = k;
          x = k = n;
        }
        var Se = q ? n : dp(l), $e = [
          l,
          u,
          g,
          x,
          k,
          ae,
          ce,
          O,
          F,
          U
        ];
        if (Se && HT($e, Se), l = $e[0], u = $e[1], g = $e[2], x = $e[3], k = $e[4], U = $e[9] = $e[9] === n ? q ? 0 : l.length : tn($e[9] - oe, 0), !U && u & (S | _) && (u &= ~(S | _)), !u || u == b)
          var ze = ST(l, u, g);
        else
          u == S || u == _ ? ze = _T(l, u, U) : (u == T || u == (b | T)) && !k.length ? ze = TT(l, u, g, x) : ze = hc.apply(n, $e);
        var Ye = Se ? nw : Mw;
        return Dw(Ye(ze, $e), l, u);
      }
      function Cw(l, u, g, x) {
        return l === n || $r(l, sa[g]) && !wt.call(x, g) ? u : l;
      }
      function Sw(l, u, g, x, k, O) {
        return zt(l) && zt(u) && (O.set(u, l), uc(l, u, n, Sw, O), O.delete(u)), l;
      }
      function PT(l) {
        return bs(l) ? n : l;
      }
      function _w(l, u, g, x, k, O) {
        var F = g & v, U = l.length, q = u.length;
        if (U != q && !(F && q > U))
          return !1;
        var oe = O.get(l), ae = O.get(u);
        if (oe && ae)
          return oe == u && ae == l;
        var ce = -1, Se = !0, $e = g & w ? new bo() : n;
        for (O.set(l, u), O.set(u, l); ++ce < U; ) {
          var ze = l[ce], Ye = u[ce];
          if (x)
            var Ve = F ? x(Ye, ze, ce, u, l, O) : x(ze, Ye, ce, l, u, O);
          if (Ve !== n) {
            if (Ve)
              continue;
            Se = !1;
            break;
          }
          if ($e) {
            if (!Md(u, function(Ze, ot) {
              if (!as($e, ot) && (ze === Ze || k(ze, Ze, g, x, O)))
                return $e.push(ot);
            })) {
              Se = !1;
              break;
            }
          } else if (!(ze === Ye || k(ze, Ye, g, x, O))) {
            Se = !1;
            break;
          }
        }
        return O.delete(l), O.delete(u), Se;
      }
      function AT(l, u, g, x, k, O, F) {
        switch (g) {
          case we:
            if (l.byteLength != u.byteLength || l.byteOffset != u.byteOffset)
              return !1;
            l = l.buffer, u = u.buffer;
          case te:
            return !(l.byteLength != u.byteLength || !O(new Zl(l), new Zl(u)));
          case ke:
          case me:
          case Ue:
            return $r(+l, +u);
          case ct:
            return l.name == u.name && l.message == u.message;
          case Bt:
          case On:
            return l == u + "";
          case xe:
            var U = zd;
          case Nt:
            var q = x & v;
            if (U || (U = ql), l.size != u.size && !q)
              return !1;
            var oe = F.get(l);
            if (oe)
              return oe == u;
            x |= w, F.set(l, u);
            var ae = _w(U(l), U(u), x, k, O, F);
            return F.delete(l), ae;
          case _r:
            if (fs)
              return fs.call(l) == fs.call(u);
        }
        return !1;
      }
      function RT(l, u, g, x, k, O) {
        var F = g & v, U = up(l), q = U.length, oe = up(u), ae = oe.length;
        if (q != ae && !F)
          return !1;
        for (var ce = q; ce--; ) {
          var Se = U[ce];
          if (!(F ? Se in u : wt.call(u, Se)))
            return !1;
        }
        var $e = O.get(l), ze = O.get(u);
        if ($e && ze)
          return $e == u && ze == l;
        var Ye = !0;
        O.set(l, u), O.set(u, l);
        for (var Ve = F; ++ce < q; ) {
          Se = U[ce];
          var Ze = l[Se], ot = u[Se];
          if (x)
            var Xn = F ? x(ot, Ze, Se, u, l, O) : x(Ze, ot, Se, l, u, O);
          if (!(Xn === n ? Ze === ot || k(Ze, ot, g, x, O) : Xn)) {
            Ye = !1;
            break;
          }
          Ve || (Ve = Se == "constructor");
        }
        if (Ye && !Ve) {
          var Tn = l.constructor, Qn = u.constructor;
          Tn != Qn && "constructor" in l && "constructor" in u && !(typeof Tn == "function" && Tn instanceof Tn && typeof Qn == "function" && Qn instanceof Qn) && (Ye = !1);
        }
        return O.delete(l), O.delete(u), Ye;
      }
      function vi(l) {
        return wp($w(l, n, Vw), l + "");
      }
      function up(l) {
        return j0(l, sn, hp);
      }
      function fp(l) {
        return j0(l, Fn, Tw);
      }
      var dp = ic ? function(l) {
        return ic.get(l);
      } : $p;
      function wc(l) {
        for (var u = l.name + "", g = ca[u], x = wt.call(ca, u) ? g.length : 0; x--; ) {
          var k = g[x], O = k.func;
          if (O == null || O == l)
            return k.name;
        }
        return u;
      }
      function pa(l) {
        var u = wt.call($, "placeholder") ? $ : l;
        return u.placeholder;
      }
      function Fe() {
        var l = $.iteratee || Ap;
        return l = l === Ap ? Y0 : l, arguments.length ? l(arguments[0], arguments[1]) : l;
      }
      function yc(l, u) {
        var g = l.__data__;
        return FT(u) ? g[typeof u == "string" ? "string" : "hash"] : g.map;
      }
      function pp(l) {
        for (var u = sn(l), g = u.length; g--; ) {
          var x = u[g], k = l[x];
          u[g] = [x, k, Aw(k)];
        }
        return u;
      }
      function Co(l, u) {
        var g = B7(l, u);
        return G0(g) ? g : n;
      }
      function $T(l) {
        var u = wt.call(l, wo), g = l[wo];
        try {
          l[wo] = n;
          var x = !0;
        } catch {
        }
        var k = Xl.call(l);
        return x && (u ? l[wo] = g : delete l[wo]), k;
      }
      var hp = Bd ? function(l) {
        return l == null ? [] : (l = St(l), Ni(Bd(l), function(u) {
          return O0.call(l, u);
        }));
      } : Op, Tw = Bd ? function(l) {
        for (var u = []; l; )
          Ii(u, hp(l)), l = Jl(l);
        return u;
      } : Op, mn = Sn;
      (Hd && mn(new Hd(new ArrayBuffer(1))) != we || ls && mn(new ls()) != xe || Ud && mn(Ud.resolve()) != xt || la && mn(new la()) != Nt || cs && mn(new cs()) != Kt) && (mn = function(l) {
        var u = Sn(l), g = u == Et ? l.constructor : n, x = g ? So(g) : "";
        if (x)
          switch (x) {
            case p_:
              return we;
            case h_:
              return xe;
            case m_:
              return xt;
            case g_:
              return Nt;
            case v_:
              return Kt;
          }
        return u;
      });
      function OT(l, u, g) {
        for (var x = -1, k = g.length; ++x < k; ) {
          var O = g[x], F = O.size;
          switch (O.type) {
            case "drop":
              l += F;
              break;
            case "dropRight":
              u -= F;
              break;
            case "take":
              u = hn(u, l + F);
              break;
            case "takeRight":
              l = tn(l, u - F);
              break;
          }
        }
        return { start: l, end: u };
      }
      function MT(l) {
        var u = l.match(Cd);
        return u ? u[1].split(V) : [];
      }
      function kw(l, u, g) {
        u = Bi(u, l);
        for (var x = -1, k = u.length, O = !1; ++x < k; ) {
          var F = Qr(u[x]);
          if (!(O = l != null && g(l, F)))
            break;
          l = l[F];
        }
        return O || ++x != k ? O : (k = l == null ? 0 : l.length, !!k && Tc(k) && wi(F, k) && (je(l) || _o(l)));
      }
      function DT(l) {
        var u = l.length, g = new l.constructor(u);
        return u && typeof l[0] == "string" && wt.call(l, "index") && (g.index = l.index, g.input = l.input), g;
      }
      function Pw(l) {
        return typeof l.constructor == "function" && !ws(l) ? ua(Jl(l)) : {};
      }
      function NT(l, u, g) {
        var x = l.constructor;
        switch (u) {
          case te:
            return sp(l);
          case ke:
          case me:
            return new x(+l);
          case we:
            return wT(l, g);
          case De:
          case rt:
          case it:
          case cn:
          case Mn:
          case En:
          case Tr:
          case kr:
          case Ct:
            return uw(l, g);
          case xe:
            return new x();
          case Ue:
          case On:
            return new x(l);
          case Bt:
            return yT(l);
          case Nt:
            return new x();
          case _r:
            return bT(l);
        }
      }
      function IT(l, u) {
        var g = u.length;
        if (!g)
          return l;
        var x = g - 1;
        return u[x] = (g > 1 ? "& " : "") + u[x], u = u.join(g > 2 ? ", " : " "), l.replace(Ed, `{
/* [wrapped with ` + u + `] */
`);
      }
      function LT(l) {
        return je(l) || _o(l) || !!(M0 && l && l[M0]);
      }
      function wi(l, u) {
        var g = typeof l;
        return u = u ?? J, !!u && (g == "number" || g != "symbol" && Ht.test(l)) && l > -1 && l % 1 == 0 && l < u;
      }
      function _n(l, u, g) {
        if (!zt(g))
          return !1;
        var x = typeof u;
        return (x == "number" ? Ln(g) && wi(u, g.length) : x == "string" && u in g) ? $r(g[u], l) : !1;
      }
      function mp(l, u) {
        if (je(l))
          return !1;
        var g = typeof l;
        return g == "number" || g == "symbol" || g == "boolean" || l == null || Kn(l) ? !0 : Vl.test(l) || !zl.test(l) || u != null && l in St(u);
      }
      function FT(l) {
        var u = typeof l;
        return u == "string" || u == "number" || u == "symbol" || u == "boolean" ? l !== "__proto__" : l === null;
      }
      function gp(l) {
        var u = wc(l), g = $[u];
        if (typeof g != "function" || !(u in tt.prototype))
          return !1;
        if (l === g)
          return !0;
        var x = dp(g);
        return !!x && l === x[0];
      }
      function zT(l) {
        return !!A0 && A0 in l;
      }
      var VT = Yl ? yi : Mp;
      function ws(l) {
        var u = l && l.constructor, g = typeof u == "function" && u.prototype || sa;
        return l === g;
      }
      function Aw(l) {
        return l === l && !zt(l);
      }
      function Rw(l, u) {
        return function(g) {
          return g == null ? !1 : g[l] === u && (u !== n || l in St(g));
        };
      }
      function BT(l) {
        var u = Sc(l, function(x) {
          return g.size === f && g.clear(), x;
        }), g = u.cache;
        return u;
      }
      function HT(l, u) {
        var g = l[1], x = u[1], k = g | x, O = k < (b | E | R), F = x == R && g == S || x == R && g == N && l[7].length <= u[8] || x == (R | N) && u[7].length <= u[8] && g == S;
        if (!(O || F))
          return l;
        x & b && (l[2] = u[2], k |= g & b ? 0 : C);
        var U = u[3];
        if (U) {
          var q = l[3];
          l[3] = q ? dw(q, U, u[4]) : U, l[4] = q ? Li(l[3], p) : u[4];
        }
        return U = u[5], U && (q = l[5], l[5] = q ? pw(q, U, u[6]) : U, l[6] = q ? Li(l[5], p) : u[6]), U = u[7], U && (l[7] = U), x & R && (l[8] = l[8] == null ? u[8] : hn(l[8], u[8])), l[9] == null && (l[9] = u[9]), l[0] = u[0], l[1] = k, l;
      }
      function UT(l) {
        var u = [];
        if (l != null)
          for (var g in St(l))
            u.push(g);
        return u;
      }
      function WT(l) {
        return Xl.call(l);
      }
      function $w(l, u, g) {
        return u = tn(u === n ? l.length - 1 : u, 0), function() {
          for (var x = arguments, k = -1, O = tn(x.length - u, 0), F = Q(O); ++k < O; )
            F[k] = x[u + k];
          k = -1;
          for (var U = Q(u + 1); ++k < u; )
            U[k] = x[k];
          return U[u] = g(F), qn(l, this, U);
        };
      }
      function Ow(l, u) {
        return u.length < 2 ? l : Eo(l, dr(u, 0, -1));
      }
      function jT(l, u) {
        for (var g = l.length, x = hn(u.length, g), k = In(l); x--; ) {
          var O = u[x];
          l[x] = wi(O, g) ? k[O] : n;
        }
        return l;
      }
      function vp(l, u) {
        if (!(u === "constructor" && typeof l[u] == "function") && u != "__proto__")
          return l[u];
      }
      var Mw = Nw(nw), ys = a_ || function(l, u) {
        return fn.setTimeout(l, u);
      }, wp = Nw(hT);
      function Dw(l, u, g) {
        var x = u + "";
        return wp(l, IT(x, qT(MT(x), g)));
      }
      function Nw(l) {
        var u = 0, g = 0;
        return function() {
          var x = u_(), k = z - (x - g);
          if (g = x, k > 0) {
            if (++u >= I)
              return arguments[0];
          } else
            u = 0;
          return l.apply(n, arguments);
        };
      }
      function bc(l, u) {
        var g = -1, x = l.length, k = x - 1;
        for (u = u === n ? x : u; ++g < u; ) {
          var O = ep(g, k), F = l[O];
          l[O] = l[g], l[g] = F;
        }
        return l.length = u, l;
      }
      var Iw = BT(function(l) {
        var u = [];
        return l.charCodeAt(0) === 46 && u.push(""), l.replace(bd, function(g, x, k, O) {
          u.push(k ? O.replace(He, "$1") : x || g);
        }), u;
      });
      function Qr(l) {
        if (typeof l == "string" || Kn(l))
          return l;
        var u = l + "";
        return u == "0" && 1 / l == -ne ? "-0" : u;
      }
      function So(l) {
        if (l != null) {
          try {
            return Kl.call(l);
          } catch {
          }
          try {
            return l + "";
          } catch {
          }
        }
        return "";
      }
      function qT(l, u) {
        return lr(Z, function(g) {
          var x = "_." + g[0];
          u & g[1] && !Wl(l, x) && l.push(x);
        }), l.sort();
      }
      function Lw(l) {
        if (l instanceof tt)
          return l.clone();
        var u = new ur(l.__wrapped__, l.__chain__);
        return u.__actions__ = In(l.__actions__), u.__index__ = l.__index__, u.__values__ = l.__values__, u;
      }
      function GT(l, u, g) {
        (g ? _n(l, u, g) : u === n) ? u = 1 : u = tn(Ge(u), 0);
        var x = l == null ? 0 : l.length;
        if (!x || u < 1)
          return [];
        for (var k = 0, O = 0, F = Q(nc(x / u)); k < x; )
          F[O++] = dr(l, k, k += u);
        return F;
      }
      function YT(l) {
        for (var u = -1, g = l == null ? 0 : l.length, x = 0, k = []; ++u < g; ) {
          var O = l[u];
          O && (k[x++] = O);
        }
        return k;
      }
      function KT() {
        var l = arguments.length;
        if (!l)
          return [];
        for (var u = Q(l - 1), g = arguments[0], x = l; x--; )
          u[x - 1] = arguments[x];
        return Ii(je(g) ? In(g) : [g], dn(u, 1));
      }
      var XT = Ke(function(l, u) {
        return Gt(l) ? ps(l, dn(u, 1, Gt, !0)) : [];
      }), QT = Ke(function(l, u) {
        var g = pr(u);
        return Gt(g) && (g = n), Gt(l) ? ps(l, dn(u, 1, Gt, !0), Fe(g, 2)) : [];
      }), ZT = Ke(function(l, u) {
        var g = pr(u);
        return Gt(g) && (g = n), Gt(l) ? ps(l, dn(u, 1, Gt, !0), n, g) : [];
      });
      function JT(l, u, g) {
        var x = l == null ? 0 : l.length;
        return x ? (u = g || u === n ? 1 : Ge(u), dr(l, u < 0 ? 0 : u, x)) : [];
      }
      function ek(l, u, g) {
        var x = l == null ? 0 : l.length;
        return x ? (u = g || u === n ? 1 : Ge(u), u = x - u, dr(l, 0, u < 0 ? 0 : u)) : [];
      }
      function tk(l, u) {
        return l && l.length ? dc(l, Fe(u, 3), !0, !0) : [];
      }
      function nk(l, u) {
        return l && l.length ? dc(l, Fe(u, 3), !0) : [];
      }
      function rk(l, u, g, x) {
        var k = l == null ? 0 : l.length;
        return k ? (g && typeof g != "number" && _n(l, u, g) && (g = 0, x = k), K_(l, u, g, x)) : [];
      }
      function Fw(l, u, g) {
        var x = l == null ? 0 : l.length;
        if (!x)
          return -1;
        var k = g == null ? 0 : Ge(g);
        return k < 0 && (k = tn(x + k, 0)), jl(l, Fe(u, 3), k);
      }
      function zw(l, u, g) {
        var x = l == null ? 0 : l.length;
        if (!x)
          return -1;
        var k = x - 1;
        return g !== n && (k = Ge(g), k = g < 0 ? tn(x + k, 0) : hn(k, x - 1)), jl(l, Fe(u, 3), k, !0);
      }
      function Vw(l) {
        var u = l == null ? 0 : l.length;
        return u ? dn(l, 1) : [];
      }
      function ik(l) {
        var u = l == null ? 0 : l.length;
        return u ? dn(l, ne) : [];
      }
      function ok(l, u) {
        var g = l == null ? 0 : l.length;
        return g ? (u = u === n ? 1 : Ge(u), dn(l, u)) : [];
      }
      function ak(l) {
        for (var u = -1, g = l == null ? 0 : l.length, x = {}; ++u < g; ) {
          var k = l[u];
          x[k[0]] = k[1];
        }
        return x;
      }
      function Bw(l) {
        return l && l.length ? l[0] : n;
      }
      function sk(l, u, g) {
        var x = l == null ? 0 : l.length;
        if (!x)
          return -1;
        var k = g == null ? 0 : Ge(g);
        return k < 0 && (k = tn(x + k, 0)), ra(l, u, k);
      }
      function lk(l) {
        var u = l == null ? 0 : l.length;
        return u ? dr(l, 0, -1) : [];
      }
      var ck = Ke(function(l) {
        var u = It(l, op);
        return u.length && u[0] === l[0] ? Kd(u) : [];
      }), uk = Ke(function(l) {
        var u = pr(l), g = It(l, op);
        return u === pr(g) ? u = n : g.pop(), g.length && g[0] === l[0] ? Kd(g, Fe(u, 2)) : [];
      }), fk = Ke(function(l) {
        var u = pr(l), g = It(l, op);
        return u = typeof u == "function" ? u : n, u && g.pop(), g.length && g[0] === l[0] ? Kd(g, n, u) : [];
      });
      function dk(l, u) {
        return l == null ? "" : l_.call(l, u);
      }
      function pr(l) {
        var u = l == null ? 0 : l.length;
        return u ? l[u - 1] : n;
      }
      function pk(l, u, g) {
        var x = l == null ? 0 : l.length;
        if (!x)
          return -1;
        var k = x;
        return g !== n && (k = Ge(g), k = k < 0 ? tn(x + k, 0) : hn(k, x - 1)), u === u ? q7(l, u, k) : jl(l, x0, k, !0);
      }
      function hk(l, u) {
        return l && l.length ? Z0(l, Ge(u)) : n;
      }
      var mk = Ke(Hw);
      function Hw(l, u) {
        return l && l.length && u && u.length ? Jd(l, u) : l;
      }
      function gk(l, u, g) {
        return l && l.length && u && u.length ? Jd(l, u, Fe(g, 2)) : l;
      }
      function vk(l, u, g) {
        return l && l.length && u && u.length ? Jd(l, u, n, g) : l;
      }
      var wk = vi(function(l, u) {
        var g = l == null ? 0 : l.length, x = jd(l, u);
        return tw(l, It(u, function(k) {
          return wi(k, g) ? +k : k;
        }).sort(fw)), x;
      });
      function yk(l, u) {
        var g = [];
        if (!(l && l.length))
          return g;
        var x = -1, k = [], O = l.length;
        for (u = Fe(u, 3); ++x < O; ) {
          var F = l[x];
          u(F, x, l) && (g.push(F), k.push(x));
        }
        return tw(l, k), g;
      }
      function yp(l) {
        return l == null ? l : d_.call(l);
      }
      function bk(l, u, g) {
        var x = l == null ? 0 : l.length;
        return x ? (g && typeof g != "number" && _n(l, u, g) ? (u = 0, g = x) : (u = u == null ? 0 : Ge(u), g = g === n ? x : Ge(g)), dr(l, u, g)) : [];
      }
      function xk(l, u) {
        return fc(l, u);
      }
      function Ek(l, u, g) {
        return np(l, u, Fe(g, 2));
      }
      function Ck(l, u) {
        var g = l == null ? 0 : l.length;
        if (g) {
          var x = fc(l, u);
          if (x < g && $r(l[x], u))
            return x;
        }
        return -1;
      }
      function Sk(l, u) {
        return fc(l, u, !0);
      }
      function _k(l, u, g) {
        return np(l, u, Fe(g, 2), !0);
      }
      function Tk(l, u) {
        var g = l == null ? 0 : l.length;
        if (g) {
          var x = fc(l, u, !0) - 1;
          if ($r(l[x], u))
            return x;
        }
        return -1;
      }
      function kk(l) {
        return l && l.length ? rw(l) : [];
      }
      function Pk(l, u) {
        return l && l.length ? rw(l, Fe(u, 2)) : [];
      }
      function Ak(l) {
        var u = l == null ? 0 : l.length;
        return u ? dr(l, 1, u) : [];
      }
      function Rk(l, u, g) {
        return l && l.length ? (u = g || u === n ? 1 : Ge(u), dr(l, 0, u < 0 ? 0 : u)) : [];
      }
      function $k(l, u, g) {
        var x = l == null ? 0 : l.length;
        return x ? (u = g || u === n ? 1 : Ge(u), u = x - u, dr(l, u < 0 ? 0 : u, x)) : [];
      }
      function Ok(l, u) {
        return l && l.length ? dc(l, Fe(u, 3), !1, !0) : [];
      }
      function Mk(l, u) {
        return l && l.length ? dc(l, Fe(u, 3)) : [];
      }
      var Dk = Ke(function(l) {
        return Vi(dn(l, 1, Gt, !0));
      }), Nk = Ke(function(l) {
        var u = pr(l);
        return Gt(u) && (u = n), Vi(dn(l, 1, Gt, !0), Fe(u, 2));
      }), Ik = Ke(function(l) {
        var u = pr(l);
        return u = typeof u == "function" ? u : n, Vi(dn(l, 1, Gt, !0), n, u);
      });
      function Lk(l) {
        return l && l.length ? Vi(l) : [];
      }
      function Fk(l, u) {
        return l && l.length ? Vi(l, Fe(u, 2)) : [];
      }
      function zk(l, u) {
        return u = typeof u == "function" ? u : n, l && l.length ? Vi(l, n, u) : [];
      }
      function bp(l) {
        if (!(l && l.length))
          return [];
        var u = 0;
        return l = Ni(l, function(g) {
          if (Gt(g))
            return u = tn(g.length, u), !0;
        }), Ld(u, function(g) {
          return It(l, Dd(g));
        });
      }
      function Uw(l, u) {
        if (!(l && l.length))
          return [];
        var g = bp(l);
        return u == null ? g : It(g, function(x) {
          return qn(u, n, x);
        });
      }
      var Vk = Ke(function(l, u) {
        return Gt(l) ? ps(l, u) : [];
      }), Bk = Ke(function(l) {
        return ip(Ni(l, Gt));
      }), Hk = Ke(function(l) {
        var u = pr(l);
        return Gt(u) && (u = n), ip(Ni(l, Gt), Fe(u, 2));
      }), Uk = Ke(function(l) {
        var u = pr(l);
        return u = typeof u == "function" ? u : n, ip(Ni(l, Gt), n, u);
      }), Wk = Ke(bp);
      function jk(l, u) {
        return sw(l || [], u || [], ds);
      }
      function qk(l, u) {
        return sw(l || [], u || [], gs);
      }
      var Gk = Ke(function(l) {
        var u = l.length, g = u > 1 ? l[u - 1] : n;
        return g = typeof g == "function" ? (l.pop(), g) : n, Uw(l, g);
      });
      function Ww(l) {
        var u = $(l);
        return u.__chain__ = !0, u;
      }
      function Yk(l, u) {
        return u(l), l;
      }
      function xc(l, u) {
        return u(l);
      }
      var Kk = vi(function(l) {
        var u = l.length, g = u ? l[0] : 0, x = this.__wrapped__, k = function(O) {
          return jd(O, l);
        };
        return u > 1 || this.__actions__.length || !(x instanceof tt) || !wi(g) ? this.thru(k) : (x = x.slice(g, +g + (u ? 1 : 0)), x.__actions__.push({
          func: xc,
          args: [k],
          thisArg: n
        }), new ur(x, this.__chain__).thru(function(O) {
          return u && !O.length && O.push(n), O;
        }));
      });
      function Xk() {
        return Ww(this);
      }
      function Qk() {
        return new ur(this.value(), this.__chain__);
      }
      function Zk() {
        this.__values__ === n && (this.__values__ = iy(this.value()));
        var l = this.__index__ >= this.__values__.length, u = l ? n : this.__values__[this.__index__++];
        return { done: l, value: u };
      }
      function Jk() {
        return this;
      }
      function eP(l) {
        for (var u, g = this; g instanceof ac; ) {
          var x = Lw(g);
          x.__index__ = 0, x.__values__ = n, u ? k.__wrapped__ = x : u = x;
          var k = x;
          g = g.__wrapped__;
        }
        return k.__wrapped__ = l, u;
      }
      function tP() {
        var l = this.__wrapped__;
        if (l instanceof tt) {
          var u = l;
          return this.__actions__.length && (u = new tt(this)), u = u.reverse(), u.__actions__.push({
            func: xc,
            args: [yp],
            thisArg: n
          }), new ur(u, this.__chain__);
        }
        return this.thru(yp);
      }
      function nP() {
        return aw(this.__wrapped__, this.__actions__);
      }
      var rP = pc(function(l, u, g) {
        wt.call(l, g) ? ++l[g] : mi(l, g, 1);
      });
      function iP(l, u, g) {
        var x = je(l) ? y0 : Y_;
        return g && _n(l, u, g) && (u = n), x(l, Fe(u, 3));
      }
      function oP(l, u) {
        var g = je(l) ? Ni : U0;
        return g(l, Fe(u, 3));
      }
      var aP = vw(Fw), sP = vw(zw);
      function lP(l, u) {
        return dn(Ec(l, u), 1);
      }
      function cP(l, u) {
        return dn(Ec(l, u), ne);
      }
      function uP(l, u, g) {
        return g = g === n ? 1 : Ge(g), dn(Ec(l, u), g);
      }
      function jw(l, u) {
        var g = je(l) ? lr : zi;
        return g(l, Fe(u, 3));
      }
      function qw(l, u) {
        var g = je(l) ? A7 : H0;
        return g(l, Fe(u, 3));
      }
      var fP = pc(function(l, u, g) {
        wt.call(l, g) ? l[g].push(u) : mi(l, g, [u]);
      });
      function dP(l, u, g, x) {
        l = Ln(l) ? l : ma(l), g = g && !x ? Ge(g) : 0;
        var k = l.length;
        return g < 0 && (g = tn(k + g, 0)), kc(l) ? g <= k && l.indexOf(u, g) > -1 : !!k && ra(l, u, g) > -1;
      }
      var pP = Ke(function(l, u, g) {
        var x = -1, k = typeof u == "function", O = Ln(l) ? Q(l.length) : [];
        return zi(l, function(F) {
          O[++x] = k ? qn(u, F, g) : hs(F, u, g);
        }), O;
      }), hP = pc(function(l, u, g) {
        mi(l, g, u);
      });
      function Ec(l, u) {
        var g = je(l) ? It : K0;
        return g(l, Fe(u, 3));
      }
      function mP(l, u, g, x) {
        return l == null ? [] : (je(u) || (u = u == null ? [] : [u]), g = x ? n : g, je(g) || (g = g == null ? [] : [g]), J0(l, u, g));
      }
      var gP = pc(function(l, u, g) {
        l[g ? 0 : 1].push(u);
      }, function() {
        return [[], []];
      });
      function vP(l, u, g) {
        var x = je(l) ? Od : C0, k = arguments.length < 3;
        return x(l, Fe(u, 4), g, k, zi);
      }
      function wP(l, u, g) {
        var x = je(l) ? R7 : C0, k = arguments.length < 3;
        return x(l, Fe(u, 4), g, k, H0);
      }
      function yP(l, u) {
        var g = je(l) ? Ni : U0;
        return g(l, _c(Fe(u, 3)));
      }
      function bP(l) {
        var u = je(l) ? F0 : dT;
        return u(l);
      }
      function xP(l, u, g) {
        (g ? _n(l, u, g) : u === n) ? u = 1 : u = Ge(u);
        var x = je(l) ? U_ : pT;
        return x(l, u);
      }
      function EP(l) {
        var u = je(l) ? W_ : mT;
        return u(l);
      }
      function CP(l) {
        if (l == null)
          return 0;
        if (Ln(l))
          return kc(l) ? oa(l) : l.length;
        var u = mn(l);
        return u == xe || u == Nt ? l.size : Qd(l).length;
      }
      function SP(l, u, g) {
        var x = je(l) ? Md : gT;
        return g && _n(l, u, g) && (u = n), x(l, Fe(u, 3));
      }
      var _P = Ke(function(l, u) {
        if (l == null)
          return [];
        var g = u.length;
        return g > 1 && _n(l, u[0], u[1]) ? u = [] : g > 2 && _n(u[0], u[1], u[2]) && (u = [u[0]]), J0(l, dn(u, 1), []);
      }), Cc = o_ || function() {
        return fn.Date.now();
      };
      function TP(l, u) {
        if (typeof u != "function")
          throw new cr(a);
        return l = Ge(l), function() {
          if (--l < 1)
            return u.apply(this, arguments);
        };
      }
      function Gw(l, u, g) {
        return u = g ? n : u, u = l && u == null ? l.length : u, gi(l, R, n, n, n, n, u);
      }
      function Yw(l, u) {
        var g;
        if (typeof u != "function")
          throw new cr(a);
        return l = Ge(l), function() {
          return --l > 0 && (g = u.apply(this, arguments)), l <= 1 && (u = n), g;
        };
      }
      var xp = Ke(function(l, u, g) {
        var x = b;
        if (g.length) {
          var k = Li(g, pa(xp));
          x |= T;
        }
        return gi(l, x, u, g, k);
      }), Kw = Ke(function(l, u, g) {
        var x = b | E;
        if (g.length) {
          var k = Li(g, pa(Kw));
          x |= T;
        }
        return gi(u, x, l, g, k);
      });
      function Xw(l, u, g) {
        u = g ? n : u;
        var x = gi(l, S, n, n, n, n, n, u);
        return x.placeholder = Xw.placeholder, x;
      }
      function Qw(l, u, g) {
        u = g ? n : u;
        var x = gi(l, _, n, n, n, n, n, u);
        return x.placeholder = Qw.placeholder, x;
      }
      function Zw(l, u, g) {
        var x, k, O, F, U, q, oe = 0, ae = !1, ce = !1, Se = !0;
        if (typeof l != "function")
          throw new cr(a);
        u = hr(u) || 0, zt(g) && (ae = !!g.leading, ce = "maxWait" in g, O = ce ? tn(hr(g.maxWait) || 0, u) : O, Se = "trailing" in g ? !!g.trailing : Se);
        function $e(Yt) {
          var Or = x, xi = k;
          return x = k = n, oe = Yt, F = l.apply(xi, Or), F;
        }
        function ze(Yt) {
          return oe = Yt, U = ys(Ze, u), ae ? $e(Yt) : F;
        }
        function Ye(Yt) {
          var Or = Yt - q, xi = Yt - oe, vy = u - Or;
          return ce ? hn(vy, O - xi) : vy;
        }
        function Ve(Yt) {
          var Or = Yt - q, xi = Yt - oe;
          return q === n || Or >= u || Or < 0 || ce && xi >= O;
        }
        function Ze() {
          var Yt = Cc();
          if (Ve(Yt))
            return ot(Yt);
          U = ys(Ze, Ye(Yt));
        }
        function ot(Yt) {
          return U = n, Se && x ? $e(Yt) : (x = k = n, F);
        }
        function Xn() {
          U !== n && lw(U), oe = 0, x = q = k = U = n;
        }
        function Tn() {
          return U === n ? F : ot(Cc());
        }
        function Qn() {
          var Yt = Cc(), Or = Ve(Yt);
          if (x = arguments, k = this, q = Yt, Or) {
            if (U === n)
              return ze(q);
            if (ce)
              return lw(U), U = ys(Ze, u), $e(q);
          }
          return U === n && (U = ys(Ze, u)), F;
        }
        return Qn.cancel = Xn, Qn.flush = Tn, Qn;
      }
      var kP = Ke(function(l, u) {
        return B0(l, 1, u);
      }), PP = Ke(function(l, u, g) {
        return B0(l, hr(u) || 0, g);
      });
      function AP(l) {
        return gi(l, B);
      }
      function Sc(l, u) {
        if (typeof l != "function" || u != null && typeof u != "function")
          throw new cr(a);
        var g = function() {
          var x = arguments, k = u ? u.apply(this, x) : x[0], O = g.cache;
          if (O.has(k))
            return O.get(k);
          var F = l.apply(this, x);
          return g.cache = O.set(k, F) || O, F;
        };
        return g.cache = new (Sc.Cache || hi)(), g;
      }
      Sc.Cache = hi;
      function _c(l) {
        if (typeof l != "function")
          throw new cr(a);
        return function() {
          var u = arguments;
          switch (u.length) {
            case 0:
              return !l.call(this);
            case 1:
              return !l.call(this, u[0]);
            case 2:
              return !l.call(this, u[0], u[1]);
            case 3:
              return !l.call(this, u[0], u[1], u[2]);
          }
          return !l.apply(this, u);
        };
      }
      function RP(l) {
        return Yw(2, l);
      }
      var $P = vT(function(l, u) {
        u = u.length == 1 && je(u[0]) ? It(u[0], Gn(Fe())) : It(dn(u, 1), Gn(Fe()));
        var g = u.length;
        return Ke(function(x) {
          for (var k = -1, O = hn(x.length, g); ++k < O; )
            x[k] = u[k].call(this, x[k]);
          return qn(l, this, x);
        });
      }), Ep = Ke(function(l, u) {
        var g = Li(u, pa(Ep));
        return gi(l, T, n, u, g);
      }), Jw = Ke(function(l, u) {
        var g = Li(u, pa(Jw));
        return gi(l, P, n, u, g);
      }), OP = vi(function(l, u) {
        return gi(l, N, n, n, n, u);
      });
      function MP(l, u) {
        if (typeof l != "function")
          throw new cr(a);
        return u = u === n ? u : Ge(u), Ke(l, u);
      }
      function DP(l, u) {
        if (typeof l != "function")
          throw new cr(a);
        return u = u == null ? 0 : tn(Ge(u), 0), Ke(function(g) {
          var x = g[u], k = Hi(g, 0, u);
          return x && Ii(k, x), qn(l, this, k);
        });
      }
      function NP(l, u, g) {
        var x = !0, k = !0;
        if (typeof l != "function")
          throw new cr(a);
        return zt(g) && (x = "leading" in g ? !!g.leading : x, k = "trailing" in g ? !!g.trailing : k), Zw(l, u, {
          leading: x,
          maxWait: u,
          trailing: k
        });
      }
      function IP(l) {
        return Gw(l, 1);
      }
      function LP(l, u) {
        return Ep(ap(u), l);
      }
      function FP() {
        if (!arguments.length)
          return [];
        var l = arguments[0];
        return je(l) ? l : [l];
      }
      function zP(l) {
        return fr(l, m);
      }
      function VP(l, u) {
        return u = typeof u == "function" ? u : n, fr(l, m, u);
      }
      function BP(l) {
        return fr(l, d | m);
      }
      function HP(l, u) {
        return u = typeof u == "function" ? u : n, fr(l, d | m, u);
      }
      function UP(l, u) {
        return u == null || V0(l, u, sn(u));
      }
      function $r(l, u) {
        return l === u || l !== l && u !== u;
      }
      var WP = vc(Yd), jP = vc(function(l, u) {
        return l >= u;
      }), _o = q0(function() {
        return arguments;
      }()) ? q0 : function(l) {
        return Ut(l) && wt.call(l, "callee") && !O0.call(l, "callee");
      }, je = Q.isArray, qP = p0 ? Gn(p0) : eT;
      function Ln(l) {
        return l != null && Tc(l.length) && !yi(l);
      }
      function Gt(l) {
        return Ut(l) && Ln(l);
      }
      function GP(l) {
        return l === !0 || l === !1 || Ut(l) && Sn(l) == ke;
      }
      var Ui = s_ || Mp, YP = h0 ? Gn(h0) : tT;
      function KP(l) {
        return Ut(l) && l.nodeType === 1 && !bs(l);
      }
      function XP(l) {
        if (l == null)
          return !0;
        if (Ln(l) && (je(l) || typeof l == "string" || typeof l.splice == "function" || Ui(l) || ha(l) || _o(l)))
          return !l.length;
        var u = mn(l);
        if (u == xe || u == Nt)
          return !l.size;
        if (ws(l))
          return !Qd(l).length;
        for (var g in l)
          if (wt.call(l, g))
            return !1;
        return !0;
      }
      function QP(l, u) {
        return ms(l, u);
      }
      function ZP(l, u, g) {
        g = typeof g == "function" ? g : n;
        var x = g ? g(l, u) : n;
        return x === n ? ms(l, u, n, g) : !!x;
      }
      function Cp(l) {
        if (!Ut(l))
          return !1;
        var u = Sn(l);
        return u == ct || u == Pe || typeof l.message == "string" && typeof l.name == "string" && !bs(l);
      }
      function JP(l) {
        return typeof l == "number" && D0(l);
      }
      function yi(l) {
        if (!zt(l))
          return !1;
        var u = Sn(l);
        return u == se || u == Le || u == Te || u == Pt;
      }
      function ey(l) {
        return typeof l == "number" && l == Ge(l);
      }
      function Tc(l) {
        return typeof l == "number" && l > -1 && l % 1 == 0 && l <= J;
      }
      function zt(l) {
        var u = typeof l;
        return l != null && (u == "object" || u == "function");
      }
      function Ut(l) {
        return l != null && typeof l == "object";
      }
      var ty = m0 ? Gn(m0) : rT;
      function eA(l, u) {
        return l === u || Xd(l, u, pp(u));
      }
      function tA(l, u, g) {
        return g = typeof g == "function" ? g : n, Xd(l, u, pp(u), g);
      }
      function nA(l) {
        return ny(l) && l != +l;
      }
      function rA(l) {
        if (VT(l))
          throw new We(o);
        return G0(l);
      }
      function iA(l) {
        return l === null;
      }
      function oA(l) {
        return l == null;
      }
      function ny(l) {
        return typeof l == "number" || Ut(l) && Sn(l) == Ue;
      }
      function bs(l) {
        if (!Ut(l) || Sn(l) != Et)
          return !1;
        var u = Jl(l);
        if (u === null)
          return !0;
        var g = wt.call(u, "constructor") && u.constructor;
        return typeof g == "function" && g instanceof g && Kl.call(g) == t_;
      }
      var Sp = g0 ? Gn(g0) : iT;
      function aA(l) {
        return ey(l) && l >= -J && l <= J;
      }
      var ry = v0 ? Gn(v0) : oT;
      function kc(l) {
        return typeof l == "string" || !je(l) && Ut(l) && Sn(l) == On;
      }
      function Kn(l) {
        return typeof l == "symbol" || Ut(l) && Sn(l) == _r;
      }
      var ha = w0 ? Gn(w0) : aT;
      function sA(l) {
        return l === n;
      }
      function lA(l) {
        return Ut(l) && mn(l) == Kt;
      }
      function cA(l) {
        return Ut(l) && Sn(l) == Yr;
      }
      var uA = vc(Zd), fA = vc(function(l, u) {
        return l <= u;
      });
      function iy(l) {
        if (!l)
          return [];
        if (Ln(l))
          return kc(l) ? Ar(l) : In(l);
        if (ss && l[ss])
          return U7(l[ss]());
        var u = mn(l), g = u == xe ? zd : u == Nt ? ql : ma;
        return g(l);
      }
      function bi(l) {
        if (!l)
          return l === 0 ? l : 0;
        if (l = hr(l), l === ne || l === -ne) {
          var u = l < 0 ? -1 : 1;
          return u * ee;
        }
        return l === l ? l : 0;
      }
      function Ge(l) {
        var u = bi(l), g = u % 1;
        return u === u ? g ? u - g : u : 0;
      }
      function oy(l) {
        return l ? xo(Ge(l), 0, X) : 0;
      }
      function hr(l) {
        if (typeof l == "number")
          return l;
        if (Kn(l))
          return A;
        if (zt(l)) {
          var u = typeof l.valueOf == "function" ? l.valueOf() : l;
          l = zt(u) ? u + "" : u;
        }
        if (typeof l != "string")
          return l === 0 ? l : +l;
        l = S0(l);
        var g = Qe.test(l);
        return g || Ft.test(l) ? T7(l.slice(2), g ? 2 : 8) : et.test(l) ? A : +l;
      }
      function ay(l) {
        return Xr(l, Fn(l));
      }
      function dA(l) {
        return l ? xo(Ge(l), -J, J) : l === 0 ? l : 0;
      }
      function pt(l) {
        return l == null ? "" : Yn(l);
      }
      var pA = fa(function(l, u) {
        if (ws(u) || Ln(u)) {
          Xr(u, sn(u), l);
          return;
        }
        for (var g in u)
          wt.call(u, g) && ds(l, g, u[g]);
      }), sy = fa(function(l, u) {
        Xr(u, Fn(u), l);
      }), Pc = fa(function(l, u, g, x) {
        Xr(u, Fn(u), l, x);
      }), hA = fa(function(l, u, g, x) {
        Xr(u, sn(u), l, x);
      }), mA = vi(jd);
      function gA(l, u) {
        var g = ua(l);
        return u == null ? g : z0(g, u);
      }
      var vA = Ke(function(l, u) {
        l = St(l);
        var g = -1, x = u.length, k = x > 2 ? u[2] : n;
        for (k && _n(u[0], u[1], k) && (x = 1); ++g < x; )
          for (var O = u[g], F = Fn(O), U = -1, q = F.length; ++U < q; ) {
            var oe = F[U], ae = l[oe];
            (ae === n || $r(ae, sa[oe]) && !wt.call(l, oe)) && (l[oe] = O[oe]);
          }
        return l;
      }), wA = Ke(function(l) {
        return l.push(n, Sw), qn(ly, n, l);
      });
      function yA(l, u) {
        return b0(l, Fe(u, 3), Kr);
      }
      function bA(l, u) {
        return b0(l, Fe(u, 3), Gd);
      }
      function xA(l, u) {
        return l == null ? l : qd(l, Fe(u, 3), Fn);
      }
      function EA(l, u) {
        return l == null ? l : W0(l, Fe(u, 3), Fn);
      }
      function CA(l, u) {
        return l && Kr(l, Fe(u, 3));
      }
      function SA(l, u) {
        return l && Gd(l, Fe(u, 3));
      }
      function _A(l) {
        return l == null ? [] : cc(l, sn(l));
      }
      function TA(l) {
        return l == null ? [] : cc(l, Fn(l));
      }
      function _p(l, u, g) {
        var x = l == null ? n : Eo(l, u);
        return x === n ? g : x;
      }
      function kA(l, u) {
        return l != null && kw(l, u, X_);
      }
      function Tp(l, u) {
        return l != null && kw(l, u, Q_);
      }
      var PA = yw(function(l, u, g) {
        u != null && typeof u.toString != "function" && (u = Xl.call(u)), l[u] = g;
      }, Pp(zn)), AA = yw(function(l, u, g) {
        u != null && typeof u.toString != "function" && (u = Xl.call(u)), wt.call(l, u) ? l[u].push(g) : l[u] = [g];
      }, Fe), RA = Ke(hs);
      function sn(l) {
        return Ln(l) ? L0(l) : Qd(l);
      }
      function Fn(l) {
        return Ln(l) ? L0(l, !0) : sT(l);
      }
      function $A(l, u) {
        var g = {};
        return u = Fe(u, 3), Kr(l, function(x, k, O) {
          mi(g, u(x, k, O), x);
        }), g;
      }
      function OA(l, u) {
        var g = {};
        return u = Fe(u, 3), Kr(l, function(x, k, O) {
          mi(g, k, u(x, k, O));
        }), g;
      }
      var MA = fa(function(l, u, g) {
        uc(l, u, g);
      }), ly = fa(function(l, u, g, x) {
        uc(l, u, g, x);
      }), DA = vi(function(l, u) {
        var g = {};
        if (l == null)
          return g;
        var x = !1;
        u = It(u, function(O) {
          return O = Bi(O, l), x || (x = O.length > 1), O;
        }), Xr(l, fp(l), g), x && (g = fr(g, d | h | m, PT));
        for (var k = u.length; k--; )
          rp(g, u[k]);
        return g;
      });
      function NA(l, u) {
        return cy(l, _c(Fe(u)));
      }
      var IA = vi(function(l, u) {
        return l == null ? {} : cT(l, u);
      });
      function cy(l, u) {
        if (l == null)
          return {};
        var g = It(fp(l), function(x) {
          return [x];
        });
        return u = Fe(u), ew(l, g, function(x, k) {
          return u(x, k[0]);
        });
      }
      function LA(l, u, g) {
        u = Bi(u, l);
        var x = -1, k = u.length;
        for (k || (k = 1, l = n); ++x < k; ) {
          var O = l == null ? n : l[Qr(u[x])];
          O === n && (x = k, O = g), l = yi(O) ? O.call(l) : O;
        }
        return l;
      }
      function FA(l, u, g) {
        return l == null ? l : gs(l, u, g);
      }
      function zA(l, u, g, x) {
        return x = typeof x == "function" ? x : n, l == null ? l : gs(l, u, g, x);
      }
      var uy = Ew(sn), fy = Ew(Fn);
      function VA(l, u, g) {
        var x = je(l), k = x || Ui(l) || ha(l);
        if (u = Fe(u, 4), g == null) {
          var O = l && l.constructor;
          k ? g = x ? new O() : [] : zt(l) ? g = yi(O) ? ua(Jl(l)) : {} : g = {};
        }
        return (k ? lr : Kr)(l, function(F, U, q) {
          return u(g, F, U, q);
        }), g;
      }
      function BA(l, u) {
        return l == null ? !0 : rp(l, u);
      }
      function HA(l, u, g) {
        return l == null ? l : ow(l, u, ap(g));
      }
      function UA(l, u, g, x) {
        return x = typeof x == "function" ? x : n, l == null ? l : ow(l, u, ap(g), x);
      }
      function ma(l) {
        return l == null ? [] : Fd(l, sn(l));
      }
      function WA(l) {
        return l == null ? [] : Fd(l, Fn(l));
      }
      function jA(l, u, g) {
        return g === n && (g = u, u = n), g !== n && (g = hr(g), g = g === g ? g : 0), u !== n && (u = hr(u), u = u === u ? u : 0), xo(hr(l), u, g);
      }
      function qA(l, u, g) {
        return u = bi(u), g === n ? (g = u, u = 0) : g = bi(g), l = hr(l), Z_(l, u, g);
      }
      function GA(l, u, g) {
        if (g && typeof g != "boolean" && _n(l, u, g) && (u = g = n), g === n && (typeof u == "boolean" ? (g = u, u = n) : typeof l == "boolean" && (g = l, l = n)), l === n && u === n ? (l = 0, u = 1) : (l = bi(l), u === n ? (u = l, l = 0) : u = bi(u)), l > u) {
          var x = l;
          l = u, u = x;
        }
        if (g || l % 1 || u % 1) {
          var k = N0();
          return hn(l + k * (u - l + _7("1e-" + ((k + "").length - 1))), u);
        }
        return ep(l, u);
      }
      var YA = da(function(l, u, g) {
        return u = u.toLowerCase(), l + (g ? dy(u) : u);
      });
      function dy(l) {
        return kp(pt(l).toLowerCase());
      }
      function py(l) {
        return l = pt(l), l && l.replace(Dn, F7).replace(m7, "");
      }
      function KA(l, u, g) {
        l = pt(l), u = Yn(u);
        var x = l.length;
        g = g === n ? x : xo(Ge(g), 0, x);
        var k = g;
        return g -= u.length, g >= 0 && l.slice(g, k) == u;
      }
      function XA(l) {
        return l = pt(l), l && Il.test(l) ? l.replace(ta, z7) : l;
      }
      function QA(l) {
        return l = pt(l), l && Bl.test(l) ? l.replace(is, "\\$&") : l;
      }
      var ZA = da(function(l, u, g) {
        return l + (g ? "-" : "") + u.toLowerCase();
      }), JA = da(function(l, u, g) {
        return l + (g ? " " : "") + u.toLowerCase();
      }), e9 = gw("toLowerCase");
      function t9(l, u, g) {
        l = pt(l), u = Ge(u);
        var x = u ? oa(l) : 0;
        if (!u || x >= u)
          return l;
        var k = (u - x) / 2;
        return gc(rc(k), g) + l + gc(nc(k), g);
      }
      function n9(l, u, g) {
        l = pt(l), u = Ge(u);
        var x = u ? oa(l) : 0;
        return u && x < u ? l + gc(u - x, g) : l;
      }
      function r9(l, u, g) {
        l = pt(l), u = Ge(u);
        var x = u ? oa(l) : 0;
        return u && x < u ? gc(u - x, g) + l : l;
      }
      function i9(l, u, g) {
        return g || u == null ? u = 0 : u && (u = +u), f_(pt(l).replace(os, ""), u || 0);
      }
      function o9(l, u, g) {
        return (g ? _n(l, u, g) : u === n) ? u = 1 : u = Ge(u), tp(pt(l), u);
      }
      function a9() {
        var l = arguments, u = pt(l[0]);
        return l.length < 3 ? u : u.replace(l[1], l[2]);
      }
      var s9 = da(function(l, u, g) {
        return l + (g ? "_" : "") + u.toLowerCase();
      });
      function l9(l, u, g) {
        return g && typeof g != "number" && _n(l, u, g) && (u = g = n), g = g === n ? X : g >>> 0, g ? (l = pt(l), l && (typeof u == "string" || u != null && !Sp(u)) && (u = Yn(u), !u && ia(l)) ? Hi(Ar(l), 0, g) : l.split(u, g)) : [];
      }
      var c9 = da(function(l, u, g) {
        return l + (g ? " " : "") + kp(u);
      });
      function u9(l, u, g) {
        return l = pt(l), g = g == null ? 0 : xo(Ge(g), 0, l.length), u = Yn(u), l.slice(g, g + u.length) == u;
      }
      function f9(l, u, g) {
        var x = $.templateSettings;
        g && _n(l, u, g) && (u = n), l = pt(l), u = Pc({}, u, x, Cw);
        var k = Pc({}, u.imports, x.imports, Cw), O = sn(k), F = Fd(k, O), U, q, oe = 0, ae = u.interpolate || Pr, ce = "__p += '", Se = Vd(
          (u.escape || Pr).source + "|" + ae.source + "|" + (ae === Fl ? ut : Pr).source + "|" + (u.evaluate || Pr).source + "|$",
          "g"
        ), $e = "//# sourceURL=" + (wt.call(u, "sourceURL") ? (u.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++b7 + "]") + `
`;
        l.replace(Se, function(Ve, Ze, ot, Xn, Tn, Qn) {
          return ot || (ot = Xn), ce += l.slice(oe, Qn).replace(Hl, V7), Ze && (U = !0, ce += `' +
__e(` + Ze + `) +
'`), Tn && (q = !0, ce += `';
` + Tn + `;
__p += '`), ot && (ce += `' +
((__t = (` + ot + `)) == null ? '' : __t) +
'`), oe = Qn + Ve.length, Ve;
        }), ce += `';
`;
        var ze = wt.call(u, "variable") && u.variable;
        if (!ze)
          ce = `with (obj) {
` + ce + `
}
`;
        else if (Ce.test(ze))
          throw new We(s);
        ce = (q ? ce.replace(go, "") : ce).replace(Cn, "$1").replace(Nl, "$1;"), ce = "function(" + (ze || "obj") + `) {
` + (ze ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (U ? ", __e = _.escape" : "") + (q ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ce + `return __p
}`;
        var Ye = my(function() {
          return ft(O, $e + "return " + ce).apply(n, F);
        });
        if (Ye.source = ce, Cp(Ye))
          throw Ye;
        return Ye;
      }
      function d9(l) {
        return pt(l).toLowerCase();
      }
      function p9(l) {
        return pt(l).toUpperCase();
      }
      function h9(l, u, g) {
        if (l = pt(l), l && (g || u === n))
          return S0(l);
        if (!l || !(u = Yn(u)))
          return l;
        var x = Ar(l), k = Ar(u), O = _0(x, k), F = T0(x, k) + 1;
        return Hi(x, O, F).join("");
      }
      function m9(l, u, g) {
        if (l = pt(l), l && (g || u === n))
          return l.slice(0, P0(l) + 1);
        if (!l || !(u = Yn(u)))
          return l;
        var x = Ar(l), k = T0(x, Ar(u)) + 1;
        return Hi(x, 0, k).join("");
      }
      function g9(l, u, g) {
        if (l = pt(l), l && (g || u === n))
          return l.replace(os, "");
        if (!l || !(u = Yn(u)))
          return l;
        var x = Ar(l), k = _0(x, Ar(u));
        return Hi(x, k).join("");
      }
      function v9(l, u) {
        var g = L, x = j;
        if (zt(u)) {
          var k = "separator" in u ? u.separator : k;
          g = "length" in u ? Ge(u.length) : g, x = "omission" in u ? Yn(u.omission) : x;
        }
        l = pt(l);
        var O = l.length;
        if (ia(l)) {
          var F = Ar(l);
          O = F.length;
        }
        if (g >= O)
          return l;
        var U = g - oa(x);
        if (U < 1)
          return x;
        var q = F ? Hi(F, 0, U).join("") : l.slice(0, U);
        if (k === n)
          return q + x;
        if (F && (U += q.length - U), Sp(k)) {
          if (l.slice(U).search(k)) {
            var oe, ae = q;
            for (k.global || (k = Vd(k.source, pt(dt.exec(k)) + "g")), k.lastIndex = 0; oe = k.exec(ae); )
              var ce = oe.index;
            q = q.slice(0, ce === n ? U : ce);
          }
        } else if (l.indexOf(Yn(k), U) != U) {
          var Se = q.lastIndexOf(k);
          Se > -1 && (q = q.slice(0, Se));
        }
        return q + x;
      }
      function w9(l) {
        return l = pt(l), l && rs.test(l) ? l.replace(di, G7) : l;
      }
      var y9 = da(function(l, u, g) {
        return l + (g ? " " : "") + u.toUpperCase();
      }), kp = gw("toUpperCase");
      function hy(l, u, g) {
        return l = pt(l), u = g ? n : u, u === n ? H7(l) ? X7(l) : M7(l) : l.match(u) || [];
      }
      var my = Ke(function(l, u) {
        try {
          return qn(l, n, u);
        } catch (g) {
          return Cp(g) ? g : new We(g);
        }
      }), b9 = vi(function(l, u) {
        return lr(u, function(g) {
          g = Qr(g), mi(l, g, xp(l[g], l));
        }), l;
      });
      function x9(l) {
        var u = l == null ? 0 : l.length, g = Fe();
        return l = u ? It(l, function(x) {
          if (typeof x[1] != "function")
            throw new cr(a);
          return [g(x[0]), x[1]];
        }) : [], Ke(function(x) {
          for (var k = -1; ++k < u; ) {
            var O = l[k];
            if (qn(O[0], this, x))
              return qn(O[1], this, x);
          }
        });
      }
      function E9(l) {
        return G_(fr(l, d));
      }
      function Pp(l) {
        return function() {
          return l;
        };
      }
      function C9(l, u) {
        return l == null || l !== l ? u : l;
      }
      var S9 = ww(), _9 = ww(!0);
      function zn(l) {
        return l;
      }
      function Ap(l) {
        return Y0(typeof l == "function" ? l : fr(l, d));
      }
      function T9(l) {
        return X0(fr(l, d));
      }
      function k9(l, u) {
        return Q0(l, fr(u, d));
      }
      var P9 = Ke(function(l, u) {
        return function(g) {
          return hs(g, l, u);
        };
      }), A9 = Ke(function(l, u) {
        return function(g) {
          return hs(l, g, u);
        };
      });
      function Rp(l, u, g) {
        var x = sn(u), k = cc(u, x);
        g == null && !(zt(u) && (k.length || !x.length)) && (g = u, u = l, l = this, k = cc(u, sn(u)));
        var O = !(zt(g) && "chain" in g) || !!g.chain, F = yi(l);
        return lr(k, function(U) {
          var q = u[U];
          l[U] = q, F && (l.prototype[U] = function() {
            var oe = this.__chain__;
            if (O || oe) {
              var ae = l(this.__wrapped__), ce = ae.__actions__ = In(this.__actions__);
              return ce.push({ func: q, args: arguments, thisArg: l }), ae.__chain__ = oe, ae;
            }
            return q.apply(l, Ii([this.value()], arguments));
          });
        }), l;
      }
      function R9() {
        return fn._ === this && (fn._ = n_), this;
      }
      function $p() {
      }
      function $9(l) {
        return l = Ge(l), Ke(function(u) {
          return Z0(u, l);
        });
      }
      var O9 = lp(It), M9 = lp(y0), D9 = lp(Md);
      function gy(l) {
        return mp(l) ? Dd(Qr(l)) : uT(l);
      }
      function N9(l) {
        return function(u) {
          return l == null ? n : Eo(l, u);
        };
      }
      var I9 = bw(), L9 = bw(!0);
      function Op() {
        return [];
      }
      function Mp() {
        return !1;
      }
      function F9() {
        return {};
      }
      function z9() {
        return "";
      }
      function V9() {
        return !0;
      }
      function B9(l, u) {
        if (l = Ge(l), l < 1 || l > J)
          return [];
        var g = X, x = hn(l, X);
        u = Fe(u), l -= X;
        for (var k = Ld(x, u); ++g < l; )
          u(g);
        return k;
      }
      function H9(l) {
        return je(l) ? It(l, Qr) : Kn(l) ? [l] : In(Iw(pt(l)));
      }
      function U9(l) {
        var u = ++e_;
        return pt(l) + u;
      }
      var W9 = mc(function(l, u) {
        return l + u;
      }, 0), j9 = cp("ceil"), q9 = mc(function(l, u) {
        return l / u;
      }, 1), G9 = cp("floor");
      function Y9(l) {
        return l && l.length ? lc(l, zn, Yd) : n;
      }
      function K9(l, u) {
        return l && l.length ? lc(l, Fe(u, 2), Yd) : n;
      }
      function X9(l) {
        return E0(l, zn);
      }
      function Q9(l, u) {
        return E0(l, Fe(u, 2));
      }
      function Z9(l) {
        return l && l.length ? lc(l, zn, Zd) : n;
      }
      function J9(l, u) {
        return l && l.length ? lc(l, Fe(u, 2), Zd) : n;
      }
      var eR = mc(function(l, u) {
        return l * u;
      }, 1), tR = cp("round"), nR = mc(function(l, u) {
        return l - u;
      }, 0);
      function rR(l) {
        return l && l.length ? Id(l, zn) : 0;
      }
      function iR(l, u) {
        return l && l.length ? Id(l, Fe(u, 2)) : 0;
      }
      return $.after = TP, $.ary = Gw, $.assign = pA, $.assignIn = sy, $.assignInWith = Pc, $.assignWith = hA, $.at = mA, $.before = Yw, $.bind = xp, $.bindAll = b9, $.bindKey = Kw, $.castArray = FP, $.chain = Ww, $.chunk = GT, $.compact = YT, $.concat = KT, $.cond = x9, $.conforms = E9, $.constant = Pp, $.countBy = rP, $.create = gA, $.curry = Xw, $.curryRight = Qw, $.debounce = Zw, $.defaults = vA, $.defaultsDeep = wA, $.defer = kP, $.delay = PP, $.difference = XT, $.differenceBy = QT, $.differenceWith = ZT, $.drop = JT, $.dropRight = ek, $.dropRightWhile = tk, $.dropWhile = nk, $.fill = rk, $.filter = oP, $.flatMap = lP, $.flatMapDeep = cP, $.flatMapDepth = uP, $.flatten = Vw, $.flattenDeep = ik, $.flattenDepth = ok, $.flip = AP, $.flow = S9, $.flowRight = _9, $.fromPairs = ak, $.functions = _A, $.functionsIn = TA, $.groupBy = fP, $.initial = lk, $.intersection = ck, $.intersectionBy = uk, $.intersectionWith = fk, $.invert = PA, $.invertBy = AA, $.invokeMap = pP, $.iteratee = Ap, $.keyBy = hP, $.keys = sn, $.keysIn = Fn, $.map = Ec, $.mapKeys = $A, $.mapValues = OA, $.matches = T9, $.matchesProperty = k9, $.memoize = Sc, $.merge = MA, $.mergeWith = ly, $.method = P9, $.methodOf = A9, $.mixin = Rp, $.negate = _c, $.nthArg = $9, $.omit = DA, $.omitBy = NA, $.once = RP, $.orderBy = mP, $.over = O9, $.overArgs = $P, $.overEvery = M9, $.overSome = D9, $.partial = Ep, $.partialRight = Jw, $.partition = gP, $.pick = IA, $.pickBy = cy, $.property = gy, $.propertyOf = N9, $.pull = mk, $.pullAll = Hw, $.pullAllBy = gk, $.pullAllWith = vk, $.pullAt = wk, $.range = I9, $.rangeRight = L9, $.rearg = OP, $.reject = yP, $.remove = yk, $.rest = MP, $.reverse = yp, $.sampleSize = xP, $.set = FA, $.setWith = zA, $.shuffle = EP, $.slice = bk, $.sortBy = _P, $.sortedUniq = kk, $.sortedUniqBy = Pk, $.split = l9, $.spread = DP, $.tail = Ak, $.take = Rk, $.takeRight = $k, $.takeRightWhile = Ok, $.takeWhile = Mk, $.tap = Yk, $.throttle = NP, $.thru = xc, $.toArray = iy, $.toPairs = uy, $.toPairsIn = fy, $.toPath = H9, $.toPlainObject = ay, $.transform = VA, $.unary = IP, $.union = Dk, $.unionBy = Nk, $.unionWith = Ik, $.uniq = Lk, $.uniqBy = Fk, $.uniqWith = zk, $.unset = BA, $.unzip = bp, $.unzipWith = Uw, $.update = HA, $.updateWith = UA, $.values = ma, $.valuesIn = WA, $.without = Vk, $.words = hy, $.wrap = LP, $.xor = Bk, $.xorBy = Hk, $.xorWith = Uk, $.zip = Wk, $.zipObject = jk, $.zipObjectDeep = qk, $.zipWith = Gk, $.entries = uy, $.entriesIn = fy, $.extend = sy, $.extendWith = Pc, Rp($, $), $.add = W9, $.attempt = my, $.camelCase = YA, $.capitalize = dy, $.ceil = j9, $.clamp = jA, $.clone = zP, $.cloneDeep = BP, $.cloneDeepWith = HP, $.cloneWith = VP, $.conformsTo = UP, $.deburr = py, $.defaultTo = C9, $.divide = q9, $.endsWith = KA, $.eq = $r, $.escape = XA, $.escapeRegExp = QA, $.every = iP, $.find = aP, $.findIndex = Fw, $.findKey = yA, $.findLast = sP, $.findLastIndex = zw, $.findLastKey = bA, $.floor = G9, $.forEach = jw, $.forEachRight = qw, $.forIn = xA, $.forInRight = EA, $.forOwn = CA, $.forOwnRight = SA, $.get = _p, $.gt = WP, $.gte = jP, $.has = kA, $.hasIn = Tp, $.head = Bw, $.identity = zn, $.includes = dP, $.indexOf = sk, $.inRange = qA, $.invoke = RA, $.isArguments = _o, $.isArray = je, $.isArrayBuffer = qP, $.isArrayLike = Ln, $.isArrayLikeObject = Gt, $.isBoolean = GP, $.isBuffer = Ui, $.isDate = YP, $.isElement = KP, $.isEmpty = XP, $.isEqual = QP, $.isEqualWith = ZP, $.isError = Cp, $.isFinite = JP, $.isFunction = yi, $.isInteger = ey, $.isLength = Tc, $.isMap = ty, $.isMatch = eA, $.isMatchWith = tA, $.isNaN = nA, $.isNative = rA, $.isNil = oA, $.isNull = iA, $.isNumber = ny, $.isObject = zt, $.isObjectLike = Ut, $.isPlainObject = bs, $.isRegExp = Sp, $.isSafeInteger = aA, $.isSet = ry, $.isString = kc, $.isSymbol = Kn, $.isTypedArray = ha, $.isUndefined = sA, $.isWeakMap = lA, $.isWeakSet = cA, $.join = dk, $.kebabCase = ZA, $.last = pr, $.lastIndexOf = pk, $.lowerCase = JA, $.lowerFirst = e9, $.lt = uA, $.lte = fA, $.max = Y9, $.maxBy = K9, $.mean = X9, $.meanBy = Q9, $.min = Z9, $.minBy = J9, $.stubArray = Op, $.stubFalse = Mp, $.stubObject = F9, $.stubString = z9, $.stubTrue = V9, $.multiply = eR, $.nth = hk, $.noConflict = R9, $.noop = $p, $.now = Cc, $.pad = t9, $.padEnd = n9, $.padStart = r9, $.parseInt = i9, $.random = GA, $.reduce = vP, $.reduceRight = wP, $.repeat = o9, $.replace = a9, $.result = LA, $.round = tR, $.runInContext = W, $.sample = bP, $.size = CP, $.snakeCase = s9, $.some = SP, $.sortedIndex = xk, $.sortedIndexBy = Ek, $.sortedIndexOf = Ck, $.sortedLastIndex = Sk, $.sortedLastIndexBy = _k, $.sortedLastIndexOf = Tk, $.startCase = c9, $.startsWith = u9, $.subtract = nR, $.sum = rR, $.sumBy = iR, $.template = f9, $.times = B9, $.toFinite = bi, $.toInteger = Ge, $.toLength = oy, $.toLower = d9, $.toNumber = hr, $.toSafeInteger = dA, $.toString = pt, $.toUpper = p9, $.trim = h9, $.trimEnd = m9, $.trimStart = g9, $.truncate = v9, $.unescape = w9, $.uniqueId = U9, $.upperCase = y9, $.upperFirst = kp, $.each = jw, $.eachRight = qw, $.first = Bw, Rp($, function() {
        var l = {};
        return Kr($, function(u, g) {
          wt.call($.prototype, g) || (l[g] = u);
        }), l;
      }(), { chain: !1 }), $.VERSION = r, lr(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(l) {
        $[l].placeholder = $;
      }), lr(["drop", "take"], function(l, u) {
        tt.prototype[l] = function(g) {
          g = g === n ? 1 : tn(Ge(g), 0);
          var x = this.__filtered__ && !u ? new tt(this) : this.clone();
          return x.__filtered__ ? x.__takeCount__ = hn(g, x.__takeCount__) : x.__views__.push({
            size: hn(g, X),
            type: l + (x.__dir__ < 0 ? "Right" : "")
          }), x;
        }, tt.prototype[l + "Right"] = function(g) {
          return this.reverse()[l](g).reverse();
        };
      }), lr(["filter", "map", "takeWhile"], function(l, u) {
        var g = u + 1, x = g == H || g == Y;
        tt.prototype[l] = function(k) {
          var O = this.clone();
          return O.__iteratees__.push({
            iteratee: Fe(k, 3),
            type: g
          }), O.__filtered__ = O.__filtered__ || x, O;
        };
      }), lr(["head", "last"], function(l, u) {
        var g = "take" + (u ? "Right" : "");
        tt.prototype[l] = function() {
          return this[g](1).value()[0];
        };
      }), lr(["initial", "tail"], function(l, u) {
        var g = "drop" + (u ? "" : "Right");
        tt.prototype[l] = function() {
          return this.__filtered__ ? new tt(this) : this[g](1);
        };
      }), tt.prototype.compact = function() {
        return this.filter(zn);
      }, tt.prototype.find = function(l) {
        return this.filter(l).head();
      }, tt.prototype.findLast = function(l) {
        return this.reverse().find(l);
      }, tt.prototype.invokeMap = Ke(function(l, u) {
        return typeof l == "function" ? new tt(this) : this.map(function(g) {
          return hs(g, l, u);
        });
      }), tt.prototype.reject = function(l) {
        return this.filter(_c(Fe(l)));
      }, tt.prototype.slice = function(l, u) {
        l = Ge(l);
        var g = this;
        return g.__filtered__ && (l > 0 || u < 0) ? new tt(g) : (l < 0 ? g = g.takeRight(-l) : l && (g = g.drop(l)), u !== n && (u = Ge(u), g = u < 0 ? g.dropRight(-u) : g.take(u - l)), g);
      }, tt.prototype.takeRightWhile = function(l) {
        return this.reverse().takeWhile(l).reverse();
      }, tt.prototype.toArray = function() {
        return this.take(X);
      }, Kr(tt.prototype, function(l, u) {
        var g = /^(?:filter|find|map|reject)|While$/.test(u), x = /^(?:head|last)$/.test(u), k = $[x ? "take" + (u == "last" ? "Right" : "") : u], O = x || /^find/.test(u);
        k && ($.prototype[u] = function() {
          var F = this.__wrapped__, U = x ? [1] : arguments, q = F instanceof tt, oe = U[0], ae = q || je(F), ce = function(Ze) {
            var ot = k.apply($, Ii([Ze], U));
            return x && Se ? ot[0] : ot;
          };
          ae && g && typeof oe == "function" && oe.length != 1 && (q = ae = !1);
          var Se = this.__chain__, $e = !!this.__actions__.length, ze = O && !Se, Ye = q && !$e;
          if (!O && ae) {
            F = Ye ? F : new tt(this);
            var Ve = l.apply(F, U);
            return Ve.__actions__.push({ func: xc, args: [ce], thisArg: n }), new ur(Ve, Se);
          }
          return ze && Ye ? l.apply(this, U) : (Ve = this.thru(ce), ze ? x ? Ve.value()[0] : Ve.value() : Ve);
        });
      }), lr(["pop", "push", "shift", "sort", "splice", "unshift"], function(l) {
        var u = Gl[l], g = /^(?:push|sort|unshift)$/.test(l) ? "tap" : "thru", x = /^(?:pop|shift)$/.test(l);
        $.prototype[l] = function() {
          var k = arguments;
          if (x && !this.__chain__) {
            var O = this.value();
            return u.apply(je(O) ? O : [], k);
          }
          return this[g](function(F) {
            return u.apply(je(F) ? F : [], k);
          });
        };
      }), Kr(tt.prototype, function(l, u) {
        var g = $[u];
        if (g) {
          var x = g.name + "";
          wt.call(ca, x) || (ca[x] = []), ca[x].push({ name: u, func: g });
        }
      }), ca[hc(n, E).name] = [{
        name: "wrapper",
        func: n
      }], tt.prototype.clone = w_, tt.prototype.reverse = y_, tt.prototype.value = b_, $.prototype.at = Kk, $.prototype.chain = Xk, $.prototype.commit = Qk, $.prototype.next = Zk, $.prototype.plant = eP, $.prototype.reverse = tP, $.prototype.toJSON = $.prototype.valueOf = $.prototype.value = nP, $.prototype.first = $.prototype.head, ss && ($.prototype[ss] = Jk), $;
    }, aa = Q7();
    vo ? ((vo.exports = aa)._ = aa, Ad._ = aa) : fn._ = aa;
  }).call(Ci);
})(Ku, Ku.exports);
var vj = Ku.exports;
const wj = li(
  "ai-tw-cursor-pointer ai-tw-border-none ai-tw-bg-transparent ai-tw-outline-none data-[state=active]:ai-tw-text-element-brand",
  {
    variants: {
      size: {
        sm: "ai-tw-px-3 ai-tw-py-1.5 ai-tw-subtitle-sm",
        md: "ai-tw-px-4 ai-tw-py-2 ai-tw-subtitle-md"
      }
    }
  }
), gC = D.forwardRef(({ values: e, value: t, size: n = "sm", className: r, ...i }, o) => {
  var d;
  const a = ((d = e.find((h) => h.value === t)) == null ? void 0 : d.value) || e[0].value, [s, c] = D.useState({
    left: 0,
    width: 0
  }), [f, p] = D.useState(
    e.map(() => null)
  );
  return D.useLayoutEffect(() => {
    const h = e.findIndex((v) => v.value === a), m = f[h];
    m && requestAnimationFrame(() => {
      const v = e.slice(0, h).reduce((b, E, C) => {
        var _;
        const S = ((_ = f[C]) == null ? void 0 : _.getBoundingClientRect().width) ?? 0;
        return b + S;
      }, 0), { width: w } = m.getBoundingClientRect();
      v === s.left && w === s.width || c({ left: v, width: w });
    });
  }, [e, a, f, s]), /* @__PURE__ */ D.createElement(
    Xf,
    {
      className: le(
        "ai-tw-relative ai-tw-w-max",
        "ai-tw-rounded-full ai-tw-border ai-tw-border-grey-20 ai-tw-text-content-primary-light",
        r
      ),
      ref: o,
      ...i
    },
    /* @__PURE__ */ D.createElement(
      on.div,
      {
        animate: s,
        transition: { ease: "easeInOut", duration: 0.2 },
        className: le(
          "ai-tw-pointer-events-none ai-tw-absolute ai-tw-h-full ",
          "ai-tw-rounded-full ai-tw-border-2 ai-tw-border-element-brand"
        )
      }
    ),
    e.map((h, m) => /* @__PURE__ */ D.createElement(
      Qf,
      {
        key: h.value + m,
        ref: (v) => {
          if (v && f[m] !== v) {
            if (f.length !== e.length) {
              p(e.map((w, b) => b === m ? v : null));
              return;
            }
            p((w) => w.map((b, E) => E === m ? v : b));
          }
        },
        className: wj({ size: n }),
        value: h.value
      },
      h.display || vj.startCase(h.value)
    ))
  );
});
gC.displayName = "TabTriggers";
const yj = lv, bj = D.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ D.createElement(
  Xf,
  {
    ref: n,
    className: le(
      "ai-tw-inline-flex ai-tw-h-10 ai-tw-items-center ai-tw-justify-center ai-tw-rounded-md ai-tw-bg-muted ai-tw-p-1 ai-tw-text-muted-foreground",
      e
    ),
    ...t
  }
));
bj.displayName = Xf.displayName;
const xj = D.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ D.createElement(
  Qf,
  {
    ref: n,
    className: le(
      "ai-tw-inline-flex ai-tw-items-center ai-tw-justify-center ai-tw-whitespace-nowrap ai-tw-rounded-sm ai-tw-px-3 ai-tw-py-1.5 ai-tw-text-sm ai-tw-font-medium ai-tw-ring-offset-background ai-tw-transition-all focus-visible:ai-tw-outline-none focus-visible:ai-tw-ring-2 focus-visible:ai-tw-ring-ring focus-visible:ai-tw-ring-offset-2 disabled:ai-tw-pointer-events-none disabled:ai-tw-opacity-50 data-[state=active]:ai-tw-bg-background data-[state=active]:ai-tw-text-foreground data-[state=active]:ai-tw-shadow-sm",
      e
    ),
    ...t
  }
));
xj.displayName = Qf.displayName;
const Zm = D.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ D.createElement(
  Zf,
  {
    ref: n,
    className: le(
      "ai-tw-ring-offset-background focus-visible:ai-tw-outline-none focus-visible:ai-tw-ring-2 focus-visible:ai-tw-ring-ring",
      e
    ),
    ...t
  }
));
Zm.displayName = Zf.displayName;
function Ej(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
const Cj = ({
  audioInfo: e,
  deleteError: t,
  setShowDeleteModal: n,
  setShowFeedbackModal: r
}) => {
  var R;
  const { token: i } = _l();
  if (!i)
    throw new Error("Missing user token for transcript component");
  const { hideAudio: o, hideSummary: a, hideTranscript: s } = Re(cv) || {}, [c, f] = ue(a), [p, d] = ue(
    a ? "transcript" : "summary"
  );
  a !== c && (f(a), d(a ? "transcript" : "summary"));
  const h = he(null), m = he(null), [v, w] = ue(""), [b, E] = ue(!1), [C, S] = ue(0);
  gl(() => {
    m.current && S(m.current.getBoundingClientRect().height);
  }, [m]);
  const _ = () => n(!0), T = () => r(!0), P = [];
  return a || P.push({
    value: "summary",
    display: s ? "AI Call Summary" : "AI Summary"
  }), s || P.push({
    value: "transcript",
    display: a ? "Call Transcript" : "Transcript"
  }), /* @__PURE__ */ y.createElement(
    q6,
    {
      callback: (N) => {
        !v && N && e.audioUrl && w(`${e.audioUrl}/${i}`);
      },
      root: document,
      rootMargin: "200px 0px",
      className: "ai-tw-preflight ai-tw-relative ai-tw-z-[2] ai-tw-overflow-hidden ai-tw-rounded-xl ai-tw-border ai-tw-border-grey-20 ai-tw-bg-white ai-tw-text-grey-60"
    },
    /* @__PURE__ */ y.createElement(yj, { value: p, onValueChange: d }, /* @__PURE__ */ y.createElement("div", { className: "ai-tw-grid ai-tw-gap-4 ai-tw-border-b ai-tw-border-grey-20 ai-tw-p-6" }, o || !v ? null : /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-4" }, /* @__PURE__ */ y.createElement(
      av,
      {
        src: v,
        isPlaying: b,
        setIsPlaying: E
      }
    ), /* @__PURE__ */ y.createElement(
      T2,
      {
        openDeleteModal: _,
        openFeedbackModal: T
      }
    )), a && s ? null : /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-justify-between" }, /* @__PURE__ */ y.createElement(gC, { values: P, value: p }), o ? /* @__PURE__ */ y.createElement(
      T2,
      {
        openDeleteModal: _,
        openFeedbackModal: T
      }
    ) : null), t ? /* @__PURE__ */ y.createElement("span", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-2 ai-tw-text-destructive" }, /* @__PURE__ */ y.createElement(Ne, { icon: lo }), t) : null), a && s ? null : /* @__PURE__ */ y.createElement(
      fC,
      {
        key: p,
        withFade: !0,
        style: { height: Ej(C + 52, 160, 400) },
        className: "ai-tw-overflow-auto ai-tw-px-6 ai-tw-py-3"
      },
      a ? null : /* @__PURE__ */ y.createElement(
        Zm,
        {
          className: "ai-tw-grid ai-tw-gap-4 ai-tw-body-md",
          ref: m,
          value: "summary",
          id: "summary"
        },
        (R = e.actionItems) != null && R.length ? /* @__PURE__ */ y.createElement("div", { className: "ai-tw-grid ai-tw-gap-1" }, /* @__PURE__ */ y.createElement("span", { className: "ai-tw-subtitle-md" }, "Action Items"), /* @__PURE__ */ y.createElement("ol", { className: "ai-tw-list-inside ai-tw-list-decimal" }, e.actionItems.map((N, B) => /* @__PURE__ */ y.createElement("li", { key: B }, N)))) : null,
        /* @__PURE__ */ y.createElement("div", { className: "ai-tw-grid ai-tw-gap-1" }, /* @__PURE__ */ y.createElement("span", { className: "ai-tw-subtitle-md" }, "Call Summary"), /* @__PURE__ */ y.createElement("p", { className: "ai-tw-whitespace-pre-wrap" }, e.summary || "No summary available."))
      ),
      s ? null : /* @__PURE__ */ y.createElement(Zm, { value: "transcript", id: "transcript" }, /* @__PURE__ */ y.createElement(
        hW,
        {
          onClickTime: (N) => {
            h.current && (E(!0), h.current.currentTime = +N, h.current.play());
          },
          transcript: e.transcription
        }
      ))
    ))
  );
};
function Sj() {
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-w-max ai-tw-items-center ai-tw-gap-2 ai-tw-p-1 ai-tw-text-stroke-critical-dark" }, /* @__PURE__ */ y.createElement(Ne, { icon: lo }), /* @__PURE__ */ y.createElement("span", null, "Error Loading Transcript"));
}
const _j = ({
  deletedAt: e,
  deletedBy: t
}) => {
  const n = e ? new Date(e).toLocaleDateString() : "";
  let r = `Audio recording, transcript, and call summary deleted on ${n}.`;
  return t && (r = `Audio recording, transcript, and call summary deleted${t.first_name ? ` by ${t.first_name}${t.last_name ? ` ${t.last_name}` : ""}` : ""} on ${n}`), /* @__PURE__ */ y.createElement("p", { className: "ai-tw-text-grey-50" }, r);
}, cv = ln(null), Rse = (e) => /* @__PURE__ */ y.createElement(uo, { fallback: /* @__PURE__ */ y.createElement(Sj, null) }, /* @__PURE__ */ y.createElement(S1, null, /* @__PURE__ */ y.createElement(cv.Provider, { value: e }, /* @__PURE__ */ y.createElement(Tj, null)))), Tj = () => {
  const [e, t] = ue(!1), [n, r] = ue(!1), { callSID: i, hideAudio: o, hideSummary: a, hideTranscript: s } = Re(cv) || {}, {
    data: c,
    mutate: f,
    error: p,
    isLoading: d
  } = FH(i), [h, m] = ue(null), v = zH(i);
  function w() {
    f(v, {
      optimisticData: {
        ...c,
        deletedAt: Date.now(),
        deletedBy: void 0
      },
      rollbackOnError: !0
    }).catch(() => {
      m(
        "Failed to delete transcription. Please try again or contact support."
      ), setTimeout(() => {
        m(null);
      }, 5e3);
    });
  }
  return o && a && s ? null : d ? /* @__PURE__ */ y.createElement(eo, null, /* @__PURE__ */ y.createElement("p", null, "Loading"), /* @__PURE__ */ y.createElement(bn, { size: "small" })) : p ? /* @__PURE__ */ y.createElement(eo, null, /* @__PURE__ */ y.createElement("p", null, "There was an error getting the transcript for this call. Please contact support if the issue persists.")) : c != null && c.deletedAt ? /* @__PURE__ */ y.createElement(
    _j,
    {
      deletedAt: c.deletedAt,
      deletedBy: c.deletedBy
    }
  ) : (c == null ? void 0 : c.status) === "too_short" ? /* @__PURE__ */ y.createElement(eo, null, /* @__PURE__ */ y.createElement("p", null, "This call was not long enough to generate a transcription.")) : (c == null ? void 0 : c.status) === "processing" || (c == null ? void 0 : c.status) === "pending" ? /* @__PURE__ */ y.createElement(eo, null, /* @__PURE__ */ y.createElement("p", null, "Audio recording and transcription for this call are on the way."), /* @__PURE__ */ y.createElement(bn, { size: "small" })) : (c == null ? void 0 : c.status) === "errored" ? /* @__PURE__ */ y.createElement(eo, null, /* @__PURE__ */ y.createElement("p", null, "There was an error processing the audio transcription for this call. Please contact support if this issue persists.")) : c ? /* @__PURE__ */ y.createElement("div", { className: "ai-tw-preflight" }, /* @__PURE__ */ y.createElement(
    Cj,
    {
      audioInfo: c,
      deleteError: h,
      setShowDeleteModal: t,
      setShowFeedbackModal: r
    }
  ), /* @__PURE__ */ y.createElement(
    oH,
    {
      handleDelete: w,
      open: e,
      setOpen: t
    }
  ), /* @__PURE__ */ y.createElement(
    YH,
    {
      open: n,
      setOpen: r,
      callSID: i,
      runId: c == null ? void 0 : c.summaryRunId
    }
  )) : null;
};
function eo({ className: e, ...t }) {
  return /* @__PURE__ */ y.createElement(
    "div",
    {
      className: le(
        "ai-tw-preflight",
        "ai-tw-grid ai-tw-place-items-center ai-tw-gap-2 ai-tw-border ai-tw-border-grey-20 ai-tw-p-5 ai-tw-text-grey-50",
        e
      ),
      ...t
    }
  );
}
function $se(e) {
  const [t, n] = ue(!1);
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-preflight ai-tw-flex ai-tw-items-center ai-tw-gap-4" }, /* @__PURE__ */ y.createElement(
    av,
    {
      isPlaying: t,
      setIsPlaying: n,
      ...e
    }
  ));
}
function kj(e) {
  const t = aV(), n = e ? `/voicemails/${e}` : null;
  return Mf(
    n,
    async (r) => {
      const i = await t(r, {
        timeout: 1e4
      });
      if (!i.ok && i.status !== 404)
        throw Error("error occurred while fetching voicemail");
      return await i.json();
    },
    {
      errorRetryCount: 1
    }
  );
}
const Pj = ({ audioInfo: e }) => {
  const { status: t, transcription: n } = e;
  return t === "too_short" ? /* @__PURE__ */ y.createElement("p", { className: "ai-tw-italic" }, "This call was not long enough to generate a transcription.") : t === "errored" ? /* @__PURE__ */ y.createElement("p", { className: "ai-tw-italic" }, "There was an error processing the voicemail transcription for this call. Please contact support if this issue persists.") : n ? /* @__PURE__ */ y.createElement("p", null, n) : /* @__PURE__ */ y.createElement("p", { className: "ai-tw-italic" }, "No speech detected in this voicemail.");
};
function Aj() {
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-w-max ai-tw-items-center ai-tw-gap-2 ai-tw-p-1 ai-tw-text-stroke-critical-dark" }, /* @__PURE__ */ y.createElement(Ne, { icon: lo }), /* @__PURE__ */ y.createElement("span", null, "Error Loading Voicemail"));
}
const Ose = ({ callSID: e, audioUrl: t }) => /* @__PURE__ */ y.createElement(uo, { fallback: /* @__PURE__ */ y.createElement(Aj, null) }, /* @__PURE__ */ y.createElement(S1, null, /* @__PURE__ */ y.createElement(Rj, { callSID: e, audioUrl: t }))), Rj = ({ callSID: e, audioUrl: t }) => {
  const {
    data: n,
    error: r,
    isLoading: i
  } = kj(e), [o, a] = ue(!1);
  return i ? /* @__PURE__ */ y.createElement(eo, null, /* @__PURE__ */ y.createElement("p", null, "Loading"), /* @__PURE__ */ y.createElement(bn, { size: "small" })) : r ? /* @__PURE__ */ y.createElement("p", null, "There was an error getting the transcript for this call. Please contact support if the issue persists.") : (n == null ? void 0 : n.status) === "processing" ? /* @__PURE__ */ y.createElement(eo, null, /* @__PURE__ */ y.createElement("p", null, "voicemail recording and transcription for this call are on the way."), /* @__PURE__ */ y.createElement(bn, { size: "small" })) : /* @__PURE__ */ y.createElement("div", { className: "ai-tw-rounded-xl ai-tw-border ai-tw-border-grey-20" }, /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-4 ai-tw-border-b ai-tw-border-grey-20 ai-tw-p-6" }, n != null && n.audioUrl || t ? /* @__PURE__ */ y.createElement(
    av,
    {
      src: (n == null ? void 0 : n.audioUrl) || t,
      isPlaying: o,
      setIsPlaying: a
    }
  ) : /* @__PURE__ */ y.createElement("div", null, "Voicemail audio could not be found")), n ? /* @__PURE__ */ y.createElement("div", { className: "ai-tw-max-h-28 ai-tw-overflow-y-auto ai-tw-p-6 ai-tw-text-grey-60 ai-tw-body-md" }, /* @__PURE__ */ y.createElement(Pj, { audioInfo: n })) : null);
};
function $j(e) {
  return e === "transparent-secondary" ? e : !e || ["primary", "tertiary", "ai-primary"].includes(e) ? "contained" : "transparent";
}
const Oj = li("", {
  variants: {
    variant: {
      contained: "ai-tw-border-l-white hover:!ai-tw-border-l hover:!ai-tw-border-l-white hover:!ai-tw-pl-2 hover:!ai-tw-pr-[7px]",
      transparent: "active:ai-tw-border-l-transparent",
      "transparent-secondary": ""
    }
  }
});
function Mj({
  variant: e,
  onClick: t,
  onContextMenuButtonClick: n,
  children: r,
  renderContextMenuButton: i
}) {
  const o = /* @__PURE__ */ D.createElement(
    Jt,
    {
      variant: e,
      size: "sm",
      className: le(
        "ai-tw-h-auto ai-tw-rounded-l-none ai-tw-border-l-transparent hover:ai-tw-border-l-[unset]",
        Oj({
          variant: $j(e)
        })
      ),
      onClick: n
    },
    /* @__PURE__ */ D.createElement(Ne, { icon: $g, className: "ai-tw-mr-1" })
  );
  return /* @__PURE__ */ D.createElement("div", { className: "ai-tw-flex ai-tw-items-stretch" }, /* @__PURE__ */ D.createElement(
    Jt,
    {
      variant: e,
      size: "sm",
      className: "ai-tw-rounded-r-none",
      contentClassName: "ai-tw-flex ai-tw-items-center",
      onClick: t
    },
    r
  ), i ? i(o) : o);
}
function Mse(e) {
  return /* @__PURE__ */ y.createElement(
    iv,
    {
      className: "ai-tw-bg-transparent ai-tw-p-0 ai-tw-shadow-none",
      ...e
    }
  );
}
function Dse({
  onClick: e,
  label: t = "AI: Help Me Write"
}) {
  return /* @__PURE__ */ y.createElement(
    Mj,
    {
      variant: "ai-secondary",
      onClick: e,
      renderContextMenuButton: (n) => /* @__PURE__ */ y.createElement(rv, { asChild: !0 }, n)
    },
    /* @__PURE__ */ y.createElement(Ne, { icon: Wa, className: "ai-tw-mr-1" }),
    t
  );
}
function Nse({
  label: e = "AI: Help Me Write"
}) {
  return /* @__PURE__ */ y.createElement(rv, { asChild: !0 }, /* @__PURE__ */ y.createElement(
    Jt,
    {
      variant: "ai-secondary",
      size: "sm",
      contentClassName: "ai-tw-flex ai-tw-items-center"
    },
    /* @__PURE__ */ y.createElement(Ne, { icon: Wa, className: "ai-tw-mr-1" }),
    e,
    /* @__PURE__ */ y.createElement(Ne, { icon: $g, className: "ai-tw-ml-2" })
  ));
}
function As({ icon: e }) {
  return /* @__PURE__ */ D.createElement(Ne, { className: "ai-tw-w-4 ai-tw-py-1", icon: e, fixedWidth: !0 });
}
function Ise({
  className: e,
  onSelect: t,
  buildItems: n = (r) => r
}) {
  return /* @__PURE__ */ D.createElement(
    "div",
    {
      role: "menu",
      className: le(
        "ai-tw-ml-auto ai-tw-min-w-[140px] ai-tw-rounded ai-tw-bg-white ai-tw-py-1 ai-tw-shadow-purple",
        e
      )
    },
    /* @__PURE__ */ D.createElement("p", { className: "ai-tw-mb-1 ai-tw-mt-0 ai-tw-px-2 ai-tw-py-1 ai-tw-text-xs ai-tw-font-semibold ai-tw-text-grey-50" }, "Edit or Review"),
    n([
      {
        title: "Rephrase",
        icon: /* @__PURE__ */ D.createElement(As, { icon: kR })
      },
      {
        title: "Make Shorter",
        icon: /* @__PURE__ */ D.createElement(As, { icon: O4 })
      },
      {
        title: "Make Longer",
        icon: /* @__PURE__ */ D.createElement(As, { icon: F4 })
      },
      { title: "Formalize", icon: /* @__PURE__ */ D.createElement(As, { icon: TR }) },
      {
        title: "Relax Tone",
        icon: /* @__PURE__ */ D.createElement(As, { icon: QR })
      }
    ]).map(({ title: r, icon: i }) => /* @__PURE__ */ D.createElement(
      "div",
      {
        key: r,
        role: "menuitem",
        className: "ai-tw-flex ai-tw-cursor-pointer ai-tw-items-center ai-tw-gap-2 ai-tw-px-2 ai-tw-py-1 ai-tw-text-purple-60 hover:ai-tw-bg-grey-10 active:ai-tw-bg-grey-20",
        onClick: () => t == null ? void 0 : t(r)
      },
      i,
      /* @__PURE__ */ D.createElement("span", { className: "ai-tw-text-grey-60 ai-tw-body-md" }, r)
    ))
  );
}
const Dj = y.forwardRef(({ placeholder: e, variant: t, onConfirm: n, onChange: r }, i) => {
  const [o, a] = ue("");
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-relative" }, /* @__PURE__ */ y.createElement(
    A5,
    {
      ref: i,
      className: "ai-tw-pr-8 ai-tw-shadow-md ai-tw-shadow-purple-10",
      placeholder: e || "What would you like to write?",
      variant: t || "ai",
      onChange: (s) => {
        a(s.target.value), r == null || r(s);
      },
      onKeyDown: (s) => s.code === "Enter" && o && n(o)
    }
  ), /* @__PURE__ */ y.createElement(
    If,
    {
      disabled: !o,
      onClick: () => o && n(o),
      className: "ai-tw-absolute ai-tw-right-1 ai-tw-top-1/2 -ai-tw-translate-y-1/2"
    },
    /* @__PURE__ */ y.createElement(Ne, { icon: Rg })
  ));
});
Dj.displayName = "HelpMeWriteRecruiterPromptInput";
function Lse({
  className: e,
  title: t,
  onGenerate: n,
  onDismiss: r
}) {
  return /* @__PURE__ */ y.createElement(
    "div",
    {
      className: le(
        "ai-tw-flex ai-tw-items-center ai-tw-justify-between ai-tw-rounded-lg ai-tw-bg-element-ai-light ai-tw-px-4 ai-tw-py-3 ai-tw-leading-5 ai-tw-body-md",
        e
      )
    },
    /* @__PURE__ */ y.createElement("p", { className: "ai-tw-pr-4 ai-tw-text-content-ai-dark" }, t),
    /* @__PURE__ */ y.createElement("div", { className: "ai-tw-min-w-max" }, /* @__PURE__ */ y.createElement(
      ju,
      {
        variant: "ai",
        className: "ai-tw-mr-2",
        size: "sm",
        onClick: r
      },
      "Dismiss"
    ), /* @__PURE__ */ y.createElement(
      Jt,
      {
        variant: "ai-secondary",
        size: "sm",
        contentClassName: "ai-tw-flex ai-tw-items-center",
        onClick: n
      },
      /* @__PURE__ */ y.createElement(Ne, { icon: Wa, className: "ai-tw-mr-1" }),
      "Generate"
    ))
  );
}
function vC(e) {
  return { all: e = e || /* @__PURE__ */ new Map(), on: function(t, n) {
    var r = e.get(t);
    r ? r.push(n) : e.set(t, [n]);
  }, off: function(t, n) {
    var r = e.get(t);
    r && (n ? r.splice(r.indexOf(n) >>> 0, 1) : e.set(t, []));
  }, emit: function(t, n) {
    var r = e.get(t);
    r && r.slice().map(function(i) {
      i(n);
    }), (r = e.get("*")) && r.slice().map(function(i) {
      i(t, n);
    });
  } };
}
const uv = vC();
function Nj() {
  uv.emit("ask-place-closed");
}
function Ij(e) {
  uv.on("ask-place-closed", e);
}
function Zc() {
  uv.all.clear();
}
function Jm(e) {
  const t = he(e);
  return _e(() => {
    t.current = e;
  }, [e]), t;
}
function Lj({
  notifyCitationReceived: e,
  notifyCitationMetadataReceived: t,
  notifyErrorMessageReceived: n,
  notifyFollowUpQuestionsReceived: r,
  notifyGenerationStarted: i,
  notifyGenerationTokenReceived: o,
  notifyGenerationReceived: a,
  notifySourceReceived: s,
  notifySourceMetadataReceived: c,
  notForProduction_accountEmail: f,
  leadUuid: p
}) {
  const { apiUrl: d, token: h } = _l(), v = `${d || "https://write-a-plumber.brivity.com"}/v1/rag-chat/generations/stream`, [w, b] = ue(null), E = Jm(w);
  function C() {
    const P = Ws(v, {
      auth: { token: h },
      timeout: 1e4,
      requestTimeout: 1e4,
      reconnectionAttempts: 3,
      withCredentials: !0,
      transports: ["websocket"]
    });
    return b(P), P;
  }
  function S(P) {
    i == null || i(), Ij(T), P.on("data", (R) => {
      o(R);
    }), P.on("sources", (R) => {
      s(R);
    }), P.on("citations", (R) => {
      e(R);
    }), P.on("generation", ({ chatId: R }) => {
      a({ chatId: R }), Zc();
    }), P.on("follow-up-questions", (R) => {
      r(R);
    }), P.on("source-metadata", (R) => {
      c(R);
    }), P.on("citation-metadata", (R) => {
      t(R);
    }), P.on("stopped", () => {
      P.disconnect(), Zc();
    }), P.on("error-message", (R) => {
      n(R);
    }), P.on("error", (R) => {
      P.disconnect(), console.error(R, "error occurred"), Zc();
    }), P.on("disconnect", () => {
      P.disconnect(), P.removeAllListeners(), b(null), Zc();
    });
  }
  function _({ socket: P, question: R, selectedChat: N }) {
    if (!P)
      return;
    const B = {
      message: R,
      chatId: N,
      leadUuid: p,
      notForProduction_accountEmail: f,
      duplicateVideoCitationsV2: !0
    };
    P.emit("payload", B);
  }
  function T() {
    E.current && E.current.emit("stop");
  }
  return {
    isGenerationInProgress: !!w,
    createSocket: C,
    startListening: S,
    sendPayload: _,
    stopGenerating: T
  };
}
function Fj(e) {
  return e.timestamp;
}
function zj(e) {
  return e.sourceID;
}
function Vj(e) {
  return e.sourceTimestamp;
}
function Bj(e) {
  return e.split("__")[1];
}
function Hj(e) {
  return e.split("__")[1];
}
function Uj(e) {
  return e.startsWith("rag-chat-video");
}
function Wj(e) {
  return e.startsWith("rag-chat-video--duplicate");
}
function dh(e) {
  return e.startsWith("v2-rag-chat-video--duplicate");
}
function A2(e) {
  const t = document.createElement("textarea");
  t.innerHTML = e;
  const n = t.value;
  return t.remove(), n;
}
const jj = "/rag-chat/chats";
function Xu(e) {
  return `${jj}/${e}`;
}
function Jf({
  chatId: e,
  enabled: t = !0
}) {
  const n = xn();
  function r(i) {
    return i ? n(Xu(i)) : null;
  }
  return {
    swr: qr(
      t && e ? Xu(e) : null,
      () => r(e)
    ),
    fetchChatById: r
  };
}
function qj(e) {
  return e.sort((t, n) => t.timestamp - n.timestamp);
}
function Gj(e) {
  return e == null ? void 0 : e.sources;
}
function Yj(e) {
  return e == null ? void 0 : e.followUpQuestions;
}
function Kj(e) {
  return e.metadata;
}
function wC(e) {
  return "_id" in e;
}
function Xj(e) {
  return wC(e) ? e._id : null;
}
function Qj(e) {
  return wC(e) ? e.chatId : null;
}
function Zj(e, t) {
  var n;
  return (n = e == null ? void 0 : e.source_metadata) == null ? void 0 : n[t];
}
function yC(e, t) {
  var n;
  return (n = e == null ? void 0 : e.citation_metadata) == null ? void 0 : n[t];
}
function Jj(e) {
  return e == null ? void 0 : e.message;
}
function eq(e) {
  return e.from;
}
function tq() {
  return {
    followUpQuestions: [],
    from: "ai",
    message: "",
    metadata: {
      source_metadata: {},
      citation_metadata: {}
    },
    sources: {}
  };
}
function eg(e) {
  return e.contentID;
}
function fv(e) {
  return e.contentTitle;
}
function dv(e) {
  return e.contentURL;
}
function pv(e) {
  return e.contentModifiedAt;
}
function ed(e) {
  return e.contentSource;
}
function Ua(e) {
  return "contentSource" in e;
}
function bC(e) {
  return e.type;
}
function nq(e) {
  return e == null ? void 0 : e.transcript;
}
function rq(e, t) {
  return e.slice(0, t);
}
function xC(e, t) {
  const n = Zj(e, t);
  if (n != null && n.timestamp)
    return Fj(n);
}
function iq(e, t) {
  const n = yC(
    e,
    t
  );
  return n ? zj(n) : null;
}
function oq(e, t) {
  const n = yC(
    e,
    t
  );
  return n ? Vj(n) : void 0;
}
function aq(e, t) {
  return e.transcript.find((n) => n._id === t);
}
function EC(e) {
  return e == null ? void 0 : e.message;
}
function R2(e, t) {
  return Object.values(e).find((n) => A2(dv(n)) === A2(t));
}
function CC(e, t) {
  return e[t];
}
const sq = "$inf$", lq = (e) => Ho(e ? e(0, null) : null)[0], ph = Promise.resolve(), cq = (e) => (t, n, r) => {
  const i = he(!1), { cache: o, initialSize: a = 1, revalidateAll: s = !1, persistSize: c = !1, revalidateFirstPage: f = !0, revalidateOnMount: p = !1, parallel: d = !1 } = r;
  let h;
  try {
    h = lq(t), h && (h = sq + h);
  } catch {
  }
  const [m, v, w] = Ji(o, h), b = Me(() => Xe(m()._l) ? a : m()._l, [
    o,
    h,
    a
  ]);
  n5.useSyncExternalStore(Me(
    (R) => h ? w(h, () => {
      R();
    }) : () => {
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      o,
      h
    ]
  ), b, b);
  const E = Me(() => {
    const R = m()._l;
    return Xe(R) ? a : R;
  }, [
    h,
    a
  ]), C = he(E());
  Fo(() => {
    if (!i.current) {
      i.current = !0;
      return;
    }
    h && v({
      _l: c ? C.current : E()
    });
  }, [
    h,
    o
  ]);
  const S = p && !i.current, _ = e(h, async (R) => {
    const N = m()._i, B = [], L = E(), [j] = Ji(o, R), I = j().data, z = [];
    let H = null;
    for (let G = 0; G < L; ++G) {
      const [Y, ne] = Ho(t(G, d ? null : H));
      if (!Y)
        break;
      const [J, ee] = Ji(o, Y);
      let A = J().data;
      const X = s || N || Xe(A) || f && !G && !Xe(I) || S || I && !Xe(I[G]) && !r.compare(I[G], A);
      if (n && X) {
        const fe = async () => {
          A = await n(ne), ee({
            data: A,
            _k: ne
          }), B[G] = A;
        };
        d ? z.push(fe) : await fe();
      } else
        B[G] = A;
      d || (H = A);
    }
    return d && await Promise.all(z.map((G) => G())), v({
      _i: rn
    }), B;
  }, r), T = Me(
    // eslint-disable-next-line func-names
    function(R, N) {
      const B = typeof N == "boolean" ? {
        revalidate: N
      } : N || {}, L = B.revalidate !== !1;
      return h ? (L && (Xe(R) ? v({
        _i: !0
      }) : v({
        _i: !1
      })), arguments.length ? _.mutate(R, {
        ...B,
        revalidate: L
      }) : _.mutate()) : ph;
    },
    // swr.mutate is always the same reference
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      h,
      o
    ]
  ), P = Me(
    (R) => {
      if (!h)
        return ph;
      const [, N] = Ji(o, h);
      let B;
      if (Fr(R) ? B = R(E()) : typeof R == "number" && (B = R), typeof B != "number")
        return ph;
      N({
        _l: B
      }), C.current = B;
      const L = [], [j] = Ji(o, h);
      let I = null;
      for (let z = 0; z < B; ++z) {
        const [H] = Ho(t(z, I)), [G] = Ji(o, H), Y = H ? G().data : rn;
        if (Xe(Y))
          return T(j().data);
        L.push(Y), I = Y;
      }
      return T(L);
    },
    // exclude getKey from the dependencies, which isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      h,
      o,
      T,
      E
    ]
  );
  return {
    size: E(),
    setSize: P,
    mutate: T,
    get data() {
      return _.data;
    },
    get error() {
      return _.error;
    },
    get isValidating() {
      return _.isValidating;
    },
    get isLoading() {
      return _.isLoading;
    }
  };
}, uq = C1(qr, cq), fq = 50, dq = "/rag-chat/chats";
function pq(e, t) {
  if (t && !t.hasMore)
    return null;
  const n = new URLSearchParams({
    page: String(e + 1),
    limit: String(fq)
  });
  return `${dq}?${n}`;
}
function Pl() {
  const e = xn();
  return uq(pq, e, {
    onErrorRetry: (t) => {
      t.status;
    }
  });
}
function SC(e) {
  return e == null ? void 0 : e.chats;
}
function _C(e) {
  return e == null ? void 0 : e._id;
}
function TC(e) {
  return e == null ? void 0 : e.title;
}
function hq(e) {
  return e == null ? void 0 : e.createdAt;
}
function mq(e = [], t) {
  return e == null ? void 0 : e.find((n) => n._id === t);
}
function gq(e, t) {
  return e == null ? void 0 : e.filter((n) => n._id !== t);
}
function vq(e = [], t) {
  return e.map((n) => ({
    chats: gq(n.chats, t),
    hasMore: n.hasMore
  }));
}
function hv() {
  return { chats: [], hasMore: !1 };
}
function kC(e) {
  return e.reduce(
    (t, n) => ({
      ...t,
      chats: [...t.chats, ...n.chats]
    }),
    hv()
  );
}
function wq(e) {
  var t;
  return (t = e[e.length - 1]) == null ? void 0 : t.hasMore;
}
function yq() {
}
var bq = yq;
const gr = /* @__PURE__ */ fo(bq), PC = {
  activeNavigationItem: void 0,
  startingQuestions: {
    activeCategory: void 0
  }
};
function xq(e, t) {
  switch (t.type) {
    case "setActiveNavigationItem": {
      e.activeNavigationItem = t.payload, t.payload || (e.startingQuestions.activeCategory = void 0);
      break;
    }
    case "setActiveStartingQuestionsCategory": {
      e.startingQuestions.activeCategory = t.payload;
      break;
    }
  }
}
function Eq(e) {
  return !!e.activeNavigationItem;
}
function AC(e) {
  return e.activeNavigationItem;
}
function Cq(e) {
  return e.startingQuestions.activeCategory;
}
const RC = {
  generation: null,
  selectedChat: null,
  selectedChatForDeletion: null,
  selectedChatMessageForFeedback: null,
  userInput: ""
};
function Sq(e, t) {
  switch (t.type) {
    case "askQuestion": {
      e.userInput = t.question, e.generation = null;
      break;
    }
    case "citationMetadataReceived": {
      const n = Po(e);
      n.metadata.citation_metadata[t.metadata.citationID] = t.metadata, e.generation = n;
      break;
    }
    case "citationReceived": {
      const n = Po(e);
      n.message = `${n.message} ${t.citation}`, e.generation = n;
      break;
    }
    case "cleanOptimisticChatState": {
      e.generation = null, e.userInput = "";
      break;
    }
    case "createChat": {
      e.selectedChat = null;
      break;
    }
    case "errorMessageReceived": {
      const n = Po(e);
      n.errors = n.errors ? [...n.errors, t.message] : [t.message], e.generation = n;
      break;
    }
    case "followUpQuestionsReceived": {
      const n = Po(e);
      n.followUpQuestions = t.questions;
      break;
    }
    case "generationTokenReceived": {
      const n = Po(e);
      n.message = `${n.message}${t.word.chunk}`, e.generation = n;
      break;
    }
    case "selectChat": {
      e.selectedChat = t.chatId;
      break;
    }
    case "selectChatForDeletion": {
      e.selectedChatForDeletion = t.chatId;
      break;
    }
    case "selectChatMessageForFeedback": {
      e.selectedChatMessageForFeedback = t.messageId;
      break;
    }
    case "sourceReceived": {
      const n = Po(e);
      n.sources[t.source.contentID] = t.source, e.generation = n;
      break;
    }
    case "sourceMetadataReceived": {
      const n = Po(e);
      n.metadata.source_metadata[t.metadata.sourceId] = t.metadata, e.generation = n;
      break;
    }
    case "unselectChatForDeletion": {
      e.selectedChatForDeletion = null;
      break;
    }
    case "unselectChatMessageForFeedback": {
      e.selectedChatMessageForFeedback = null;
      break;
    }
    case "videoStarted": {
      e.isVideoPlaying = !0;
      break;
    }
    case "videoStopped": {
      e.isVideoPlaying = !1;
      break;
    }
  }
}
function Al(e) {
  return e.selectedChat;
}
function Mi(e) {
  return e.generation;
}
function _q(e) {
  const t = Mi(e);
  return t == null ? void 0 : t.followUpQuestions;
}
function Tq(e) {
  const t = Mi(e);
  return t == null ? void 0 : t.message;
}
function kq(e) {
  const t = Mi(e);
  return t == null ? void 0 : t.sources;
}
function Pq(e) {
  return e.userInput;
}
function Aq(e) {
  const t = Mi(e);
  return t == null ? void 0 : t.metadata;
}
function $C(e) {
  const t = Mi(e);
  return t == null ? void 0 : t.errors;
}
function Po(e) {
  const t = Mi(e);
  return t || tq();
}
function Rq(e) {
  return e.isVideoPlaying;
}
function OC(e) {
  return e.selectedChatForDeletion;
}
function MC(e) {
  return e.selectedChatMessageForFeedback;
}
const DC = {
  askPlaceSize: "midsize",
  chatState: RC,
  isGenerationInProgress: !1,
  isReleaseNotesOpen: !1,
  isStreamingAutoScrollEnabled: !1,
  navigationState: PC,
  allowStreamingAutoScroll: gr,
  askQuestion: gr,
  chatDispatch: gr,
  disableStreamingAutoScroll: gr,
  navigationDispatch: gr,
  selectChat: gr,
  setAskPlaceSize: gr,
  setIsReleaseNotesOpen: gr,
  stopGenerating: gr,
  onMinimize: gr,
  createNewChat: gr
}, kt = ln(
  DC
);
function NC(e) {
  e != null && e.current && (e.current.scrollTop = e.current.scrollHeight);
}
const $q = -12, Oq = 12, js = 450, Mq = 350, Dq = 600, IC = 600, mv = "prevent_dragging", Nq = `#${mv}`;
function hh(e) {
  e = e || Oq;
  const t = window.localStorage.getItem("askPlaceHeight"), n = t ? Number(t) : xu();
  return e > 0 ? e : window.innerHeight - e - n;
}
function mh(e) {
  e = e || $q;
  const t = window.localStorage.getItem("askPlaceWidth"), n = t ? Number(t) : js;
  return e > 0 ? e : document.documentElement.clientWidth + e - n;
}
function xu() {
  return Math.max(IC, Math.round(window.innerHeight * 0.75));
}
const Ja = ln(null);
function LC({
  children: e,
  defaultX: t,
  defaultY: n
}) {
  const r = window.localStorage.getItem("askPlaceX"), i = r ? Number(r) : mh(t), [o, a] = ue(i), s = window.localStorage.getItem("askPlaceY"), c = s ? Number(s) : hh(n), [f, p] = ue(c), d = Number(window.localStorage.getItem("askPlaceWidth")) || js, [h, m] = ue(d), v = Number(window.localStorage.getItem("askPlaceHeight")) || xu(), [w, b] = ue(v), [E, C] = ue(!1), [S, _] = ue(!1), T = Me(() => {
    window.localStorage.removeItem("askPlaceX"), window.localStorage.removeItem("askPlaceY"), window.localStorage.removeItem("askPlaceWidth"), window.localStorage.removeItem("askPlaceHeight"), a(mh(t)), p(hh(n)), m(js), b(xu()), C(!1);
  }, [t, n]);
  return _e(() => {
    (o !== mh(t) || f !== hh(n) || h !== js || w !== xu()) && C(!0);
  }, [o, f, h, w, t, n]), /* @__PURE__ */ y.createElement(
    Ja.Provider,
    {
      value: {
        x: o,
        y: f,
        width: h,
        height: w,
        hasDimensionsChanged: E,
        isResizing: S,
        setX: a,
        setY: p,
        setWidth: m,
        setHeight: b,
        resetDimensions: T,
        setIsResizing: _
      }
    },
    e
  );
}
const gv = vC();
function $2() {
  gv.emit("video-stopped");
}
function Iq(e) {
  gv.on("video-stopped", e);
}
function Lq() {
  gv.all.clear();
}
const Fq = "/rag-chat/chats";
function zq({ chatId: e }) {
  const t = xn(), { isLoading: n, mutate: r } = Pl(), i = `${Fq}/${e}`;
  async function o(a) {
    n || !e || (r(
      (s) => vq(s, e),
      !1
    ), await t(a, { method: "DELETE" }), r());
  }
  return jf(i, o);
}
const td = "Ask Gabbi", vv = "Untitled Chat";
function FC({
  children: e,
  className: t,
  onClick: n
}) {
  return /* @__PURE__ */ y.createElement(
    on.div,
    {
      initial: { opacity: 0 },
      animate: { opacity: 1, transition: { duration: 0.2 } },
      exit: { opacity: 0 },
      className: le(
        "ai-tw-absolute ai-tw-inset-0 ai-tw-cursor-pointer ai-tw-rounded-lg ai-tw-bg-black/25",
        t
      ),
      onClick: n
    },
    e
  );
}
function Vq({
  children: e,
  title: t,
  confirmText: n = "Confirm",
  open: r,
  onCancel: i,
  onConfirm: o
}) {
  function a(s) {
    switch (s.key) {
      case "Enter":
        s.preventDefault(), o && o();
        break;
      case "Escape":
        i && i();
        break;
    }
  }
  return /* @__PURE__ */ y.createElement(l6, { open: r }, /* @__PURE__ */ y.createElement(V1, null, /* @__PURE__ */ y.createElement(FC, null, /* @__PURE__ */ y.createElement(
    B1,
    {
      onPointerDownOutside: i,
      onKeyDown: a,
      className: "ai-tw-absolute ai-tw-left-1/2 ai-tw-top-1/2 ai-tw-z-20 ai-tw-max-w-[300px] -ai-tw-translate-x-1/2 -ai-tw-translate-y-1/2 ai-tw-rounded-lg ai-tw-bg-white ai-tw-p-4"
    },
    /* @__PURE__ */ y.createElement(H1, { className: "ai-tw-text-content-primary ai-tw-subtitle-md" }, t),
    /* @__PURE__ */ y.createElement(U1, { className: "ai-tw-mt-5 ai-tw-text-content-primary-light ai-tw-body-md" }, e),
    /* @__PURE__ */ y.createElement("div", { className: "ai-tw-mt-5 ai-tw-flex ai-tw-justify-between" }, /* @__PURE__ */ y.createElement(Jt, { variant: "tertiary", size: "sm", onClick: i }, "Cancel"), /* @__PURE__ */ y.createElement(Jt, { variant: "destructive", size: "sm", onClick: o }, n))
  ))));
}
function Bq({
  chatTitle: e
}) {
  return /* @__PURE__ */ y.createElement("span", null, "This will delete the chat", " ", /* @__PURE__ */ y.createElement("span", { className: "ai-tw-font-bold" }, e || vv));
}
function Hq() {
  const { chatState: e, chatDispatch: t, selectChat: n, stopGenerating: r } = Re(kt), i = OC(e), { data: o, isLoading: a } = Pl(), s = o ? kC(o) : hv(), c = SC(s), f = Al(e), { trigger: p } = zq({
    chatId: i
  });
  function d() {
    f || (r(), t({ type: "cleanOptimisticChatState" })), f === i && n(null), p(), t({ type: "unselectChatForDeletion" });
  }
  if (a)
    return null;
  const h = mq(c, i);
  return h ? /* @__PURE__ */ y.createElement(
    Vq,
    {
      title: "Delete chat?",
      open: !!i,
      onCancel: () => t({ type: "unselectChatForDeletion" }),
      onConfirm: d
    },
    /* @__PURE__ */ y.createElement(Bq, { chatTitle: h.title })
  ) : null;
}
function Uq(e) {
  const t = e ? `/rag-chat/chat-messages/${e}/feedback` : null, n = xn();
  function r(i, { arg: o }) {
    return n(i, {
      json: o.json,
      method: "PUT"
    });
  }
  return jf(t, r);
}
function Wq(e, t = !0) {
  const n = xn(), r = `/rag-chat/chat-messages/${e}/feedback`;
  function i() {
    return n(r);
  }
  return qr(t && e ? r : null, i, {
    onErrorRetry: (o) => {
      o.status;
    }
  });
}
const O2 = {
  positive: "What did you like about this generation?",
  negative: "What can be improved?",
  default: "Additional feedback"
}, jq = "Error submitting feedback. Please try again.";
function qq({
  actionsContainerClassName: e,
  errorText: t,
  feedbackRadioProps: n,
  formClassName: r,
  isSubmitButtonDisabled: i,
  submitButtonProps: o,
  textAreaProps: a,
  onSubmit: s
}) {
  const [c, f] = ue(), p = t || c, d = n != null && n.value ? O2[n == null ? void 0 : n.value] : O2.default;
  async function h(m) {
    m.preventDefault(), m.stopPropagation();
    try {
      const v = new FormData(m.currentTarget), w = Object.fromEntries(v.entries());
      if (!w.result) {
        f("Rating is required."), setTimeout(() => f(null), 2e3);
        return;
      }
      await s(w);
    } catch (v) {
      console.error(v), f(jq), setTimeout(() => f(null), 2e3);
    }
  }
  return /* @__PURE__ */ y.createElement(
    "form",
    {
      className: le(
        "ai-tw-grid ai-tw-grow ai-tw-grid-rows-[auto_auto_1fr_auto] ai-tw-gap-3",
        r
      ),
      onSubmit: h
    },
    /* @__PURE__ */ y.createElement("h3", { className: "ai-tw-heading-3" }, "Provide Feedback"),
    /* @__PURE__ */ y.createElement(y6, { ...n }),
    /* @__PURE__ */ y.createElement(
      Lf,
      {
        name: "message",
        labelText: d,
        rows: 7,
        ...a,
        containerClassName: le(
          "ai-tw-flex ai-tw-flex-col",
          a == null ? void 0 : a.containerClassName
        ),
        className: le("ai-tw-grow", a == null ? void 0 : a.className)
      }
    ),
    /* @__PURE__ */ y.createElement(
      "div",
      {
        className: le(
          "ai-tw-flex ai-tw-items-center ai-tw-justify-end ai-tw-gap-3",
          e
        )
      },
      p ? /* @__PURE__ */ y.createElement("p", { className: "ai-tw-text-xs ai-tw-text-red-50" }, /* @__PURE__ */ y.createElement(Ne, { icon: lo }), /* @__PURE__ */ y.createElement("span", null, p)) : null,
      /* @__PURE__ */ y.createElement(
        Jt,
        {
          variant: "ai-primary",
          disabled: i,
          ...o
        },
        "Submit"
      )
    )
  );
}
function Gq({
  isOpen: e,
  onClose: t,
  className: n,
  children: r,
  ...i
}) {
  return /* @__PURE__ */ y.createElement(Br, null, e ? /* @__PURE__ */ y.createElement(
    on.div,
    {
      initial: { opacity: 0, scale: 0, transformOrigin: "top left" },
      animate: { opacity: 1, scale: 1 },
      exit: { opacity: 0, scale: 0 },
      transition: { duration: 0.2 },
      className: le(
        "ai-tw-absolute ai-tw-left-0 ai-tw-top-0 ai-tw-z-20",
        "ai-tw-flex ai-tw-h-full ai-tw-w-full ai-tw-flex-col ai-tw-gap-3 ai-tw-bg-white ai-tw-p-3",
        n
      ),
      ...i
    },
    /* @__PURE__ */ y.createElement(y1, { "aria-label": "back", onClick: t }, /* @__PURE__ */ y.createElement(Ne, { icon: DR })),
    r
  ) : null);
}
function Yq({
  isOpen: e,
  onClose: t
}) {
  const { chatState: n } = Re(kt), r = MC(n), [i, o] = ue(null), [a, s] = ue(), [c, f] = ue(), { data: p, isValidating: d } = Wq(
    r,
    !!r
  ), { trigger: h, isMutating: m } = Uq(r);
  async function v(T) {
    r && (f("loading"), await h(
      { json: T },
      {
        onError: b
      }
    ), o(T), f("success"), setTimeout(() => {
      f(void 0), w();
    }, 2e3));
  }
  function w() {
    s(null), o(null), t();
  }
  function b(T) {
    console.error(T), s(
      "Unknown error occurred while submitting feedback. Please try again or contact the support team."
    ), setTimeout(() => {
      s(null);
    }, 5e3);
  }
  const E = d || m || !!c, C = {
    className: "ai-tw-mt-5",
    disabled: E,
    value: p == null ? void 0 : p.result,
    onValueChange: (T) => {
      const P = { result: T };
      h(
        {
          json: i ? {
            ...i,
            ...P
          } : P
        },
        {
          onError: b
        }
      );
    }
  }, S = {
    disabled: E,
    status: c
  }, _ = {
    containerClassName: "ai-tw-mt-5",
    variant: "ai",
    defaultValue: p == null ? void 0 : p.message
  };
  return /* @__PURE__ */ y.createElement(
    Gq,
    {
      isOpen: e,
      onClose: w,
      className: "ai-tw-p-8"
    },
    /* @__PURE__ */ y.createElement(
      qq,
      {
        actionsContainerClassName: "ai-tw-mt-6",
        errorText: a,
        formClassName: "ai-tw-gap-0",
        feedbackRadioProps: C,
        submitButtonProps: S,
        textAreaProps: _,
        onSubmit: v
      }
    )
  );
}
function M2({
  children: e,
  className: t,
  onClick: n,
  disabled: r
}) {
  return /* @__PURE__ */ y.createElement(
    If,
    {
      "aria-label": "stop",
      type: "button",
      className: le(
        "ai-tw-group ai-tw-h-7 ai-tw-w-7 ai-tw-text-white active:!ai-tw-bg-transparent",
        t
      ),
      onClick: n,
      disabled: r
    },
    e
  );
}
function D2({ isIconActive: e, icon: t }) {
  return /* @__PURE__ */ y.createElement(
    Ne,
    {
      icon: t,
      mask: XR,
      className: le("ai-tw-bg-content-primary-lightest ai-tw-bg-none", {
        "ai-tw-bg-gradient-to-r ai-tw-from-purple-40 ai-tw-to-purple-20": e
      })
    }
  );
}
function zC({
  onFocus: e,
  onBlur: t,
  onSubmit: n
}) {
  const [r, i] = ue(""), [o, a] = ue(!1);
  function s() {
    i("");
  }
  function c() {
    f(r), s(), n == null || n();
  }
  const { askQuestion: f, stopGenerating: p, isGenerationInProgress: d } = Re(kt);
  function h(w) {
    if (w.key === "Enter" && !w.shiftKey && r) {
      if (d) {
        w.preventDefault();
        return;
      }
      c(), w.preventDefault();
    }
  }
  function m(w) {
    e == null || e(w), a(!0);
  }
  function v(w) {
    t == null || t(w), a(!1);
  }
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-relative ai-tw-flex" }, /* @__PURE__ */ y.createElement(
    $1,
    {
      variant: "ai",
      className: le(
        "ai-tw-h-10 ai-tw-border !ai-tw-border-purple-40 !ai-tw-bg-white focus:ai-tw-text-content-primary",
        d ? "ai-tw-pr-16" : "ai-tw-pr-10"
      ),
      placeholder: td,
      value: r,
      onChange: (w) => i(w.target.value),
      onKeyDown: h,
      onFocus: m,
      onBlur: v
    }
  ), d ? /* @__PURE__ */ y.createElement("div", { className: "ai-tw-absolute ai-tw-bottom-1.5 ai-tw-right-3 ai-tw-flex ai-tw-items-center" }, /* @__PURE__ */ y.createElement(bn, { size: "small", variant: "ai", className: "ai-tw-mr-1" }), /* @__PURE__ */ y.createElement(M2, { onClick: p }, /* @__PURE__ */ y.createElement(D2, { icon: N4, isIconActive: !0 }))) : /* @__PURE__ */ y.createElement(
    M2,
    {
      className: "ai-tw-absolute ai-tw-bottom-1.5 ai-tw-right-3",
      onClick: c,
      disabled: !r
    },
    /* @__PURE__ */ y.createElement(
      D2,
      {
        icon: Rg,
        isIconActive: o
      }
    )
  ));
}
var Fse = {
  prefix: "far",
  iconName: "message",
  icon: [512, 512, ["comment-alt"], "f27a", "M160 368c26.5 0 48 21.5 48 48v16l72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16h96zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V474.7v-6.4V468v-4V416H112 64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L208 492z"]
}, zse = {
  prefix: "far",
  iconName: "comments",
  icon: [640, 512, [128490, 61670], "f086", "M88.2 309.1c9.8-18.3 6.8-40.8-7.5-55.8C59.4 230.9 48 204 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128s-63.8 128-160 128c-13.1 0-25.8-1.3-37.8-3.6c-10.4-2-21.2-.6-30.7 4.2c-4.1 2.1-8.3 4.1-12.6 6c-16 7.2-32.9 13.5-49.9 18c2.8-4.6 5.4-9.1 7.9-13.6c1.1-1.9 2.2-3.9 3.2-5.9zM0 176c0 41.8 17.2 80.1 45.9 110.3c-.9 1.7-1.9 3.5-2.8 5.1c-10.3 18.4-22.3 36.5-36.6 52.1c-6.6 7-8.3 17.2-4.6 25.9C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.8-2.2 9.6-4.5 14.2-6.8c15.1 3 30.9 4.5 47.1 4.5c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176zM432 480c16.2 0 31.9-1.6 47.1-4.5c4.6 2.3 9.4 4.6 14.2 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.8 2-19-4.6-25.9c-14.2-15.6-26.2-33.7-36.6-52.1c-.9-1.7-1.9-3.4-2.8-5.1C622.8 384.1 640 345.8 640 304c0-94.4-87.9-171.5-198.2-175.8c4.1 15.2 6.2 31.2 6.2 47.8l0 .6c87.2 6.7 144 67.5 144 127.4c0 28-11.4 54.9-32.7 77.2c-14.3 15-17.3 37.6-7.5 55.8c1.1 2 2.2 4 3.2 5.9c2.5 4.5 5.2 9 7.9 13.6c-17-4.5-33.9-10.7-49.9-18c-4.3-1.9-8.5-3.9-12.6-6c-9.5-4.8-20.3-6.2-30.7-4.2c-12.1 2.4-24.7 3.6-37.8 3.6c-61.7 0-110-26.5-136.8-62.3c-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480z"]
}, Vse = {
  prefix: "far",
  iconName: "octagon-minus",
  icon: [512, 512, ["minus-octagon"], "f308", "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17v129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7h129c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17v-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7h-129zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
}, Kq = {
  prefix: "far",
  iconName: "bullhorn",
  icon: [512, 512, [128226, 128363], "f0a1", "M432 73.9L421.3 84.6C364.5 141.4 288.1 174 208 175.9v.1V304v0 .1c80.1 1.9 156.5 34.5 213.3 91.3L432 406.1V73.9zM160 128h40.7c70 0 137.2-27.8 186.7-77.3l38-38C445.5-7.5 480 6.8 480 35.3V179.6c18.6 8.8 32 32.5 32 60.4s-13.4 51.6-32 60.4V444.7c0 28.5-34.5 42.8-54.6 22.6l-38-38c-47.8-47.8-112-75.4-179.4-77.2V456c0 30.9-25.1 56-56 56H120c-30.9 0-56-25.1-56-56l0-104c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h96zM112 352V456c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V352H112zM64 176c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16l0 0h48 48V176l-96 0z"]
}, VC = {
  prefix: "far",
  iconName: "clock-three",
  icon: [512, 512, [], "e356", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 13.3 10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
}, Bse = {
  prefix: "far",
  iconName: "circle-stop",
  icon: [512, 512, [62094, "stop-circle"], "f28d", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-96H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"]
}, Xq = {
  prefix: "far",
  iconName: "square-arrow-down-left",
  icon: [448, 512, [], "e261", "M64 432c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zm288-48c13.3 0 24-10.7 24-24s-10.7-24-24-24H193.9L329 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V344c0 13.3 10.7 24 24 24H288z"]
}, Hse = {
  prefix: "far",
  iconName: "clock-eight",
  icon: [512, 512, [], "e345", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120V256c0 8-4 15.5-10.7 20l-96 64c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3L232 243.2V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
}, Use = {
  prefix: "far",
  iconName: "shirt",
  icon: [640, 512, [128085, "t-shirt", "tshirt"], "f553", "M233.7 33.1l-23.5 4.6 0 0 23.5-4.6zm172.7 0l-23.5-4.6v0l23.5 4.6zm71.9 13.2l15.4-18.4 0 0L478.3 46.3zM604.5 151.4L619.8 133v0l-15.4 18.4zm3.6 45.7L590 181.3v0l18.1 15.8zm-56 64l18.1 15.8-18.1-15.8zm-44.6 3.5L492.2 283v0l15.4-18.4zM456 221.7l15.4-18.4c-7.2-6-17.1-7.2-25.5-3.3s-13.8 12.4-13.8 21.7h24zm-272 0h24c0-9.3-5.4-17.8-13.8-21.7s-18.4-2.7-25.5 3.3L184 221.7zm-51.5 42.9L147.9 283h0l-15.4-18.4zm-44.6-3.5L69.9 276.9l18.1-15.8zm-56-64L50 181.3l0 0L31.9 197.1zm-7.8-23.6L.2 171.6l23.9 1.9zm11.4-22.1L20.1 133l0 0 15.4 18.4zM161.7 46.3l15.4 18.4L161.7 46.3zm95.5-17.8C254.3 13.6 241.3 0 223.2 0V48c-7.8 0-12.2-5.7-13.1-10.3l47.1-9.3zM320 80c-31.1 0-57-22.2-62.8-51.5l-47.1 9.3C220.2 89.2 265.6 128 320 128V80zm62.8-51.5C377 57.8 351.1 80 320 80v48c54.4 0 99.8-38.8 109.9-90.3l-47.1-9.3zM416.8 0c-18.2 0-31.1 13.6-34 28.5l47.1 9.3C429 42.3 424.6 48 416.8 48V0zm76.8 27.8C472.1 9.8 444.9 0 416.8 0V48c16.8 0 33.2 5.9 46.1 16.7l30.7-36.9zM619.8 133L493.7 27.8 462.9 64.7 589.1 169.9 619.8 133zm20 38.6c-1.2-15-8.4-29-20-38.6l-30.7 36.9c1.7 1.4 2.7 3.4 2.9 5.5l47.9-3.8zm-13.7 41.3c9.9-11.4 14.9-26.2 13.7-41.3L592 175.4c.2 2.1-.5 4.3-2 5.9l36.1 31.6zm-56 64l56-64L590 181.3l-56 64 36.1 31.6zm-78 6.1c23.4 19.5 58 16.7 78-6.1L534 245.3c-2.9 3.3-7.8 3.7-11.1 .9L492.2 283zm-51.5-42.9L492.2 283l30.7-36.9-51.5-42.9-30.7 36.9zM432 221.7V448h48V221.7H432zM432 448c0 8.8-7.2 16-16 16v48c35.3 0 64-28.7 64-64H432zm-16 16H224v48H416V464zm-192 0c-8.8 0-16-7.2-16-16H160c0 35.3 28.7 64 64 64V464zm-16-16V221.7H160V448h48zM147.9 283l51.5-42.9-30.7-36.9-51.5 42.9L147.9 283zm-78-6.1c20 22.9 54.6 25.6 78 6.1l-30.7-36.9c-3.3 2.8-8.3 2.4-11.1-.9L69.9 276.9zm-56-64l56 64L106 245.3l-56-64L13.9 212.9zM.2 171.6c-1.2 15 3.7 29.9 13.7 41.3L50 181.3c-1.4-1.6-2.1-3.7-2-5.9L.2 171.6zm20-38.6c-11.6 9.7-18.8 23.6-20 38.6L48 175.4c.2-2.1 1.2-4.1 2.9-5.5L20.1 133zM146.3 27.8L20.1 133l30.7 36.9L177.1 64.7 146.3 27.8zM223.2 0c-28.1 0-55.3 9.8-76.8 27.8l30.7 36.9C190 53.9 206.3 48 223.2 48V0z"]
}, Qq = {
  prefix: "far",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V248c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v64H216zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
}, Wse = Qq, jse = {
  prefix: "far",
  iconName: "droplet-slash",
  icon: [640, 512, ["tint-slash"], "f5c7", "M320 464c37.9 0 72.4-14.6 98.1-38.6l38 30C421.4 490.3 373.2 512 320 512c-106 0-192-86-192-192c0-27.7 12-62.9 29.8-99.6l38.7 30.5c-1.2 2.7-2.4 5.4-3.6 8c-11.9 27.6-17 48.2-17 61.1c0 79.5 64.5 144 144 144zm185.2-93.3l125.6 98.4c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L205.8 136c34.9-54.7 72-103 88.9-124.3C300.6 4.2 309.5 0 319.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C381.8 57.7 512 228.8 512 320c0 17.5-2.4 34.6-6.8 50.7zm-42.3-33.1c.7-5.8 1.1-11.6 1.1-17.6c0-13-5.1-33.5-17-61.1c-11.5-26.6-27.6-55.8-45.5-84.7c-29-46.8-61-90.2-81.5-117c-19.3 25.1-48.7 65-76.3 108.5L462.9 337.5zM224 312c0-11.9 8.7-21.8 20.1-23.7l27.9 21.9c0 .6 .1 1.2 .1 1.7c0 30.9 25.1 56 56 56c13.3 0 24 10.7 24 24s-10.7 24-24 24c-57.4 0-104-46.6-104-104z"]
}, qse = {
  prefix: "far",
  iconName: "face-meh",
  icon: [512, 512, [128528, "meh"], "f11a", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
}, Gse = {
  prefix: "far",
  iconName: "message-slash",
  icon: [640, 512, ["comment-alt-slash"], "f4a9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-82.3-64.5C565.1 393 576 373.8 576 352V64c0-35.3-28.7-64-64-64H128C104.4 0 83.8 12.7 72.7 31.7L38.8 5.1zm73.3 57.4c.7-8.1 7.6-14.5 15.9-14.5H512c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H501.8L112.1 62.5zM406.2 416l-54.4-42.9c-2.5 1.3-4.9 2.8-7.2 4.5L272 432V416c0-26.5-21.5-48-48-48H128c-8.8 0-16-7.2-16-16V184.2L64 146.4V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L266.7 496l5.1-3.8 .2-.2 101.3-76h32.8z"]
}, Zq = {
  prefix: "far",
  iconName: "thumbs-down",
  icon: [512, 512, [128078, 61576], "f165", "M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16H286.5c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8H384c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32z"]
}, Yse = {
  prefix: "far",
  iconName: "droplet",
  icon: [384, 512, [128167, "tint"], "f043", "M192 464c-79.5 0-144-64.5-144-144c0-13 5.1-33.5 17-61.1c11.5-26.6 27.6-55.8 45.5-84.7c29-46.8 61-90.2 81.5-117c20.5 26.7 52.6 70.2 81.5 117c17.9 28.9 34 58 45.5 84.7c11.9 27.6 17 48.2 17 61.1c0 79.5-64.5 144-144 144zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm144-8c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 57.4 46.6 104 104 104c13.3 0 24-10.7 24-24s-10.7-24-24-24c-30.9 0-56-25.1-56-56z"]
}, Jq = {
  prefix: "far",
  iconName: "copy",
  icon: [448, 512, [], "f0c5", "M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z"]
}, Kse = {
  prefix: "far",
  iconName: "briefcase",
  icon: [512, 512, [128188], "f0b1", "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96h64c35.3 0 64 28.7 64 64V280 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V280 160c0-35.3 28.7-64 64-64h64zM48 304V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V304H320v16c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V304H48zm144-48H320 464V160c0-8.8-7.2-16-16-16H360 152 64c-8.8 0-16 7.2-16 16v96H192z"]
};
function Zo({
  children: e,
  className: t,
  contentClassName: n,
  icon: r,
  onClick: i
}) {
  return /* @__PURE__ */ y.createElement(
    "button",
    {
      className: le(
        "ai-tw-flex ai-tw-min-h-[32px] ai-tw-items-center ai-tw-rounded-lg ai-tw-p-3 ai-tw-text-content-primary ai-tw-body-sm hover:ai-tw-bg-element-primary-subtle-dark active:ai-tw-bg-element-primary-subtle-dark",
        t
      ),
      onClick: i
    },
    r ? /* @__PURE__ */ y.createElement(Ne, { icon: r }) : null,
    e ? /* @__PURE__ */ y.createElement("span", { className: le("ai-tw-ml-2", n) }, e) : null
  );
}
function BC({ className: e }) {
  const { navigationState: t, navigationDispatch: n } = Re(kt), { width: r } = Re(Ja) || {}, i = AC(t), o = [
    ["previous-chats", "Previous Chats", VC],
    ["prompt-library", "Prompt Library", D4]
  ];
  return /* @__PURE__ */ y.createElement("nav", { className: e }, /* @__PURE__ */ y.createElement("ul", { className: "ai-tw-flex ai-tw-gap-x-4 ai-tw-overflow-x-auto" }, o.map(([a, s, c]) => /* @__PURE__ */ y.createElement("li", { key: a, className: "ai-tw-shrink-0" }, /* @__PURE__ */ y.createElement(
    Zo,
    {
      className: le({
        "ai-tw-bg-element-primary-subtle-dark": i === a
      }),
      contentClassName: "ai-tw-ml-0",
      onClick: () => {
        if (i === a) {
          n({
            type: "setActiveNavigationItem",
            payload: void 0
          });
          return;
        }
        n({
          type: "setActiveNavigationItem",
          payload: a
        });
      },
      icon: c
    },
    /* @__PURE__ */ y.createElement(Br, null, r && r < js ? null : /* @__PURE__ */ y.createElement(
      on.span,
      {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        className: "ai-tw-ml-2"
      },
      s
    ))
  )))));
}
const { VITE_COPILOT_TERMS_AND_CONDITIONS_URL: eG } = { VITE_API_URL: "https://write-a-plumber.brivity.com", VITE_COPILOT_TERMS_AND_CONDITIONS_URL: "https://www.brivity.com/brivity-terms-of-service", VITE_COPILOT_VIDEO_ASPECT_RATIO: "16:9", VITE_VIMEO_API_BASE_URL: "https://vimeo.com/api", VITE_OUR_PLACE_URL: "https://our.place.com", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
function tG({
  className: e
}) {
  return /* @__PURE__ */ y.createElement(
    "span",
    {
      className: le(
        "ai-tw-inline-block ai-tw-text-content-primary-light ai-tw-body-sm",
        e
      )
    },
    "AI-generated content may be inaccurate.",
    /* @__PURE__ */ y.createElement(
      "a",
      {
        href: eG,
        target: "_blank",
        rel: "noreferrer",
        className: "ai-tw-ml-1 ai-tw-underline"
      },
      "See Terms"
    )
  );
}
function nG() {
  const [e, t] = ue(!1);
  function n() {
    t(!0);
  }
  function r() {
    t(!1);
  }
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-px-3 ai-tw-pb-4 ai-tw-pt-1" }, /* @__PURE__ */ y.createElement(
    "div",
    {
      className: rl(
        "ai-tw-rounded-lg ai-tw-bg-tinted-grey-50 ai-tw-p-3 ai-tw-pb-2 ai-tw-transition-shadow ai-tw-relative",
        {
          "ai-tw-shadow-purple-10 ai-tw-shadow-dropdown": e
        }
      )
    },
    /* @__PURE__ */ y.createElement(
      zC,
      {
        onFocus: n,
        onBlur: r
      }
    ),
    /* @__PURE__ */ y.createElement(BC, { className: "ai-tw-mt-1.5" })
  ), /* @__PURE__ */ y.createElement(tG, { className: "ai-tw-mt-2" }));
}
function Jc(e) {
  return /* @__PURE__ */ y.createElement(
    Zo,
    {
      ...e,
      className: le(
        "ai-tw-flex ai-tw-min-w-[32px] ai-tw-justify-center ai-tw-p-2",
        e.className
      )
    }
  );
}
function wv() {
  const { resetDimensions: e } = Re(Ja) || {}, {
    onMinimize: t,
    askPlaceSize: n,
    setAskPlaceSize: r,
    createNewChat: i,
    chatState: o
  } = Re(kt), a = Al(o), {
    swr: { data: s }
  } = Jf({
    chatId: a,
    enabled: !!a
  }), c = _C(s), f = TC(s);
  return /* @__PURE__ */ y.createElement(
    "header",
    {
      onDoubleClick: () => {
        n === "midsize" && e && e();
      },
      className: le(
        "ai-tw-flex ai-tw-items-center ai-tw-justify-between ai-tw-border-b ai-tw-border-stroke-primary ai-tw-bg-container-primary ai-tw-px-2.5 ai-tw-py-2 ai-tw-text-content-primary ai-tw-body-sm",
        {
          "ai-tw-cursor-move": n !== "maximized"
        }
      )
    },
    c ? /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-overflow-hidden" }, n === "minimized" ? null : /* @__PURE__ */ y.createElement("div", { className: "ai-tw-mr-2 ai-tw-border-r ai-tw-border-stroke-primary" }, /* @__PURE__ */ y.createElement(
      Zo,
      {
        icon: mR,
        onClick: i,
        className: "ai-tw-mr-2 !ai-tw-body-md"
      }
    )), /* @__PURE__ */ y.createElement("p", { className: "ai-tw-truncate", title: f }, f || vv)) : /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-px-2 ai-tw-subtitle-sm" }, /* @__PURE__ */ y.createElement(Ne, { icon: gR, className: "ai-tw-mr-2" }), /* @__PURE__ */ y.createElement("p", { className: "ai-tw-uppercase ai-tw-tracking-[.18em]" }, td)),
    /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-gap-x-2" }, n !== "maximized" ? /* @__PURE__ */ y.createElement(
      Jc,
      {
        onClick: () => r("maximized"),
        icon: AR
      }
    ) : null, n !== "midsize" ? /* @__PURE__ */ y.createElement(
      Jc,
      {
        className: le({
          "!ai-tw-body-md": n === "maximized"
        }),
        onClick: () => {
          r("midsize");
        },
        icon: n === "maximized" ? Xq : CR
      }
    ) : null, n !== "minimized" ? /* @__PURE__ */ y.createElement(
      Jc,
      {
        onClick: () => r("minimized"),
        icon: KR
      }
    ) : null, /* @__PURE__ */ y.createElement(Jc, { onClick: t, icon: I4 }))
  );
}
const nd = "ask_place_navigation_modal_backdrop_container";
function rG() {
  const e = document.getElementById(
    nd
  ), { navigationDispatch: t } = Re(kt);
  function n() {
    t({
      type: "setActiveNavigationItem",
      payload: void 0
    });
  }
  return e ? hf(/* @__PURE__ */ y.createElement(FC, { onClick: n }), e) : null;
}
function N2({
  children: e,
  icon: t,
  title: n,
  onClose: r,
  className: i
}) {
  return /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-flex-initial ai-tw-justify-between ai-tw-pb-2" }, /* @__PURE__ */ y.createElement("p", { className: "ai-tw-flex ai-tw-items-center ai-tw-text-content-primary ai-tw-subtitle-md" }, /* @__PURE__ */ y.createElement(Ne, { icon: t, className: "ai-tw-mr-1.5 ai-tw-body-sm" }), /* @__PURE__ */ y.createElement("span", null, n)), /* @__PURE__ */ y.createElement(
    "button",
    {
      className: "ai-tw-text-content-primary ai-tw-body-md",
      onClick: r
    },
    /* @__PURE__ */ y.createElement(Ne, { icon: $g })
  )), /* @__PURE__ */ y.createElement(
    on.div,
    {
      className: le("ai-tw-flex-initial ai-tw-overflow-y-auto", i),
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 }
    },
    e
  ));
}
function Qu(e) {
  "@babel/helpers - typeof";
  return Qu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Qu(e);
}
function Oi(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Vt(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Wn(e) {
  Vt(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Qu(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function iG(e, t) {
  Vt(2, arguments);
  var n = Wn(e), r = Oi(t);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function oG(e, t) {
  Vt(2, arguments);
  var n = Wn(e).getTime(), r = Oi(t);
  return new Date(n + r);
}
var aG = {};
function rd() {
  return aG;
}
function tg(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function Zu(e) {
  Vt(1, arguments);
  var t = Wn(e);
  return t.setHours(0, 0, 0, 0), t;
}
var sG = 864e5;
function lG(e, t) {
  Vt(2, arguments);
  var n = Zu(e), r = Zu(t), i = n.getTime() - tg(n), o = r.getTime() - tg(r);
  return Math.round((i - o) / sG);
}
function HC(e, t) {
  Vt(2, arguments);
  var n = Zu(e), r = Zu(t);
  return n.getTime() === r.getTime();
}
function cG(e) {
  return Vt(1, arguments), e instanceof Date || Qu(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function uG(e) {
  if (Vt(1, arguments), !cG(e) && typeof e != "number")
    return !1;
  var t = Wn(e);
  return !isNaN(Number(t));
}
function I2(e, t) {
  var n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function fG(e, t) {
  Vt(2, arguments);
  var n = Wn(e), r = Wn(t), i = I2(n, r), o = Math.abs(lG(n, r));
  n.setDate(n.getDate() - i * o);
  var a = +(I2(n, r) === -i), s = i * (o - a);
  return s === 0 ? 0 : s;
}
function dG(e, t) {
  Vt(2, arguments);
  var n = Oi(t);
  return oG(e, -n);
}
var pG = 864e5;
function hG(e) {
  Vt(1, arguments);
  var t = Wn(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), i = n - r;
  return Math.floor(i / pG) + 1;
}
function Ju(e) {
  Vt(1, arguments);
  var t = 1, n = Wn(e), r = n.getUTCDay(), i = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - i), n.setUTCHours(0, 0, 0, 0), n;
}
function UC(e) {
  Vt(1, arguments);
  var t = Wn(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var i = Ju(r), o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(n, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var a = Ju(o);
  return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= a.getTime() ? n : n - 1;
}
function mG(e) {
  Vt(1, arguments);
  var t = UC(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = Ju(n);
  return r;
}
var gG = 6048e5;
function vG(e) {
  Vt(1, arguments);
  var t = Wn(e), n = Ju(t).getTime() - mG(t).getTime();
  return Math.round(n / gG) + 1;
}
function ef(e, t) {
  var n, r, i, o, a, s, c, f;
  Vt(1, arguments);
  var p = rd(), d = Oi((n = (r = (i = (o = t == null ? void 0 : t.weekStartsOn) !== null && o !== void 0 ? o : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : p.weekStartsOn) !== null && r !== void 0 ? r : (c = p.locale) === null || c === void 0 || (f = c.options) === null || f === void 0 ? void 0 : f.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = Wn(e), m = h.getUTCDay(), v = (m < d ? 7 : 0) + m - d;
  return h.setUTCDate(h.getUTCDate() - v), h.setUTCHours(0, 0, 0, 0), h;
}
function WC(e, t) {
  var n, r, i, o, a, s, c, f;
  Vt(1, arguments);
  var p = Wn(e), d = p.getUTCFullYear(), h = rd(), m = Oi((n = (r = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : h.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = h.locale) === null || c === void 0 || (f = c.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(m >= 1 && m <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(d + 1, 0, m), v.setUTCHours(0, 0, 0, 0);
  var w = ef(v, t), b = /* @__PURE__ */ new Date(0);
  b.setUTCFullYear(d, 0, m), b.setUTCHours(0, 0, 0, 0);
  var E = ef(b, t);
  return p.getTime() >= w.getTime() ? d + 1 : p.getTime() >= E.getTime() ? d : d - 1;
}
function wG(e, t) {
  var n, r, i, o, a, s, c, f;
  Vt(1, arguments);
  var p = rd(), d = Oi((n = (r = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : p.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = p.locale) === null || c === void 0 || (f = c.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), h = WC(e, t), m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(h, 0, d), m.setUTCHours(0, 0, 0, 0);
  var v = ef(m, t);
  return v;
}
var yG = 6048e5;
function bG(e, t) {
  Vt(1, arguments);
  var n = Wn(e), r = ef(n, t).getTime() - wG(n, t).getTime();
  return Math.round(r / yG) + 1;
}
function yt(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var xG = {
  // Year
  y: function(t, n) {
    var r = t.getUTCFullYear(), i = r > 0 ? r : 1 - r;
    return yt(n === "yy" ? i % 100 : i, n.length);
  },
  // Month
  M: function(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : yt(r + 1, 2);
  },
  // Day of the month
  d: function(t, n) {
    return yt(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, n) {
    return yt(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(t, n) {
    return yt(t.getUTCHours(), n.length);
  },
  // Minute
  m: function(t, n) {
    return yt(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function(t, n) {
    return yt(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(t, n) {
    var r = n.length, i = t.getUTCMilliseconds(), o = Math.floor(i * Math.pow(10, r - 3));
    return yt(o, n.length);
  }
};
const ji = xG;
var ya = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, EG = {
  // Era
  G: function(t, n, r) {
    var i = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(i, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(i, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, n, r) {
    if (n === "yo") {
      var i = t.getUTCFullYear(), o = i > 0 ? i : 1 - i;
      return r.ordinalNumber(o, {
        unit: "year"
      });
    }
    return ji.y(t, n);
  },
  // Local week-numbering year
  Y: function(t, n, r, i) {
    var o = WC(t, i), a = o > 0 ? o : 1 - o;
    if (n === "YY") {
      var s = a % 100;
      return yt(s, 2);
    }
    return n === "Yo" ? r.ordinalNumber(a, {
      unit: "year"
    }) : yt(a, n.length);
  },
  // ISO week-numbering year
  R: function(t, n) {
    var r = UC(t);
    return yt(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, n) {
    var r = t.getUTCFullYear();
    return yt(r, n.length);
  },
  // Quarter
  Q: function(t, n, r) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(i);
      case "QQ":
        return yt(i, 2);
      case "Qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, n, r) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(i);
      case "qq":
        return yt(i, 2);
      case "qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, n, r) {
    var i = t.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return ji.M(t, n);
      case "Mo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(i, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, n, r) {
    var i = t.getUTCMonth();
    switch (n) {
      case "L":
        return String(i + 1);
      case "LL":
        return yt(i + 1, 2);
      case "Lo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(i, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, n, r, i) {
    var o = bG(t, i);
    return n === "wo" ? r.ordinalNumber(o, {
      unit: "week"
    }) : yt(o, n.length);
  },
  // ISO week of year
  I: function(t, n, r) {
    var i = vG(t);
    return n === "Io" ? r.ordinalNumber(i, {
      unit: "week"
    }) : yt(i, n.length);
  },
  // Day of the month
  d: function(t, n, r) {
    return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : ji.d(t, n);
  },
  // Day of year
  D: function(t, n, r) {
    var i = hG(t);
    return n === "Do" ? r.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : yt(i, n.length);
  },
  // Day of week
  E: function(t, n, r) {
    var i = t.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, n, r, i) {
    var o = t.getUTCDay(), a = (o - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(a);
      case "ee":
        return yt(a, 2);
      case "eo":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "eee":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, n, r, i) {
    var o = t.getUTCDay(), a = (o - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(a);
      case "cc":
        return yt(a, n.length);
      case "co":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "ccc":
        return r.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, n, r) {
    var i = t.getUTCDay(), o = i === 0 ? 7 : i;
    switch (n) {
      case "i":
        return String(o);
      case "ii":
        return yt(o, n.length);
      case "io":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "iii":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, n, r) {
    var i = t.getUTCHours(), o = i / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, n, r) {
    var i = t.getUTCHours(), o;
    switch (i === 12 ? o = ya.noon : i === 0 ? o = ya.midnight : o = i / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, n, r) {
    var i = t.getUTCHours(), o;
    switch (i >= 17 ? o = ya.evening : i >= 12 ? o = ya.afternoon : i >= 4 ? o = ya.morning : o = ya.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, n, r) {
    if (n === "ho") {
      var i = t.getUTCHours() % 12;
      return i === 0 && (i = 12), r.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return ji.h(t, n);
  },
  // Hour [0-23]
  H: function(t, n, r) {
    return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : ji.H(t, n);
  },
  // Hour [0-11]
  K: function(t, n, r) {
    var i = t.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : yt(i, n.length);
  },
  // Hour [1-24]
  k: function(t, n, r) {
    var i = t.getUTCHours();
    return i === 0 && (i = 24), n === "ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : yt(i, n.length);
  },
  // Minute
  m: function(t, n, r) {
    return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : ji.m(t, n);
  },
  // Second
  s: function(t, n, r) {
    return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : ji.s(t, n);
  },
  // Fraction of second
  S: function(t, n) {
    return ji.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, r, i) {
    var o = i._originalDate || t, a = o.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (n) {
      case "X":
        return F2(a);
      case "XXXX":
      case "XX":
        return Oo(a);
      case "XXXXX":
      case "XXX":
      default:
        return Oo(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, r, i) {
    var o = i._originalDate || t, a = o.getTimezoneOffset();
    switch (n) {
      case "x":
        return F2(a);
      case "xxxx":
      case "xx":
        return Oo(a);
      case "xxxxx":
      case "xxx":
      default:
        return Oo(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, r, i) {
    var o = i._originalDate || t, a = o.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + L2(a, ":");
      case "OOOO":
      default:
        return "GMT" + Oo(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, r, i) {
    var o = i._originalDate || t, a = o.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + L2(a, ":");
      case "zzzz":
      default:
        return "GMT" + Oo(a, ":");
    }
  },
  // Seconds timestamp
  t: function(t, n, r, i) {
    var o = i._originalDate || t, a = Math.floor(o.getTime() / 1e3);
    return yt(a, n.length);
  },
  // Milliseconds timestamp
  T: function(t, n, r, i) {
    var o = i._originalDate || t, a = o.getTime();
    return yt(a, n.length);
  }
};
function L2(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.floor(r / 60), o = r % 60;
  if (o === 0)
    return n + String(i);
  var a = t || "";
  return n + String(i) + a + yt(o, 2);
}
function F2(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + yt(Math.abs(e) / 60, 2);
  }
  return Oo(e, t);
}
function Oo(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", i = Math.abs(e), o = yt(Math.floor(i / 60), 2), a = yt(i % 60, 2);
  return r + o + n + a;
}
const CG = EG;
var z2 = function(t, n) {
  switch (t) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, jC = function(t, n) {
  switch (t) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, SG = function(t, n) {
  var r = t.match(/(P+)(p+)?/) || [], i = r[1], o = r[2];
  if (!o)
    return z2(t, n);
  var a;
  switch (i) {
    case "P":
      a = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      a = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      a = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      a = n.dateTime({
        width: "full"
      });
      break;
  }
  return a.replace("{{date}}", z2(i, n)).replace("{{time}}", jC(o, n));
}, _G = {
  p: jC,
  P: SG
};
const TG = _G;
var kG = ["D", "DD"], PG = ["YY", "YYYY"];
function AG(e) {
  return kG.indexOf(e) !== -1;
}
function RG(e) {
  return PG.indexOf(e) !== -1;
}
function V2(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var $G = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, OG = function(t, n, r) {
  var i, o = $G[t];
  return typeof o == "string" ? i = o : n === 1 ? i = o.one : i = o.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + i : i + " ago" : i;
};
const MG = OG;
function gh(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var DG = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, NG = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, IG = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, LG = {
  date: gh({
    formats: DG,
    defaultWidth: "full"
  }),
  time: gh({
    formats: NG,
    defaultWidth: "full"
  }),
  dateTime: gh({
    formats: IG,
    defaultWidth: "full"
  })
};
const FG = LG;
var zG = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, VG = function(t, n, r, i) {
  return zG[t];
};
const BG = VG;
function Rs(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", i;
    if (r === "formatting" && e.formattingValues) {
      var o = e.defaultFormattingWidth || e.defaultWidth, a = n != null && n.width ? String(n.width) : o;
      i = e.formattingValues[a] || e.formattingValues[o];
    } else {
      var s = e.defaultWidth, c = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[c] || e.values[s];
    }
    var f = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[f];
  };
}
var HG = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, UG = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, WG = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, jG = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, qG = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, GG = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, YG = function(t, n) {
  var r = Number(t), i = r % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, KG = {
  ordinalNumber: YG,
  era: Rs({
    values: HG,
    defaultWidth: "wide"
  }),
  quarter: Rs({
    values: UG,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: Rs({
    values: WG,
    defaultWidth: "wide"
  }),
  day: Rs({
    values: jG,
    defaultWidth: "wide"
  }),
  dayPeriod: Rs({
    values: qG,
    defaultWidth: "wide",
    formattingValues: GG,
    defaultFormattingWidth: "wide"
  })
};
const XG = KG;
function $s(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = t.match(i);
    if (!o)
      return null;
    var a = o[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? ZG(s, function(d) {
      return d.test(a);
    }) : QG(s, function(d) {
      return d.test(a);
    }), f;
    f = e.valueCallback ? e.valueCallback(c) : c, f = n.valueCallback ? n.valueCallback(f) : f;
    var p = t.slice(a.length);
    return {
      value: f,
      rest: p
    };
  };
}
function QG(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function ZG(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function JG(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r)
      return null;
    var i = r[0], o = t.match(e.parsePattern);
    if (!o)
      return null;
    var a = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    var s = t.slice(i.length);
    return {
      value: a,
      rest: s
    };
  };
}
var eY = /^(\d+)(th|st|nd|rd)?/i, tY = /\d+/i, nY = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, rY = {
  any: [/^b/i, /^(a|c)/i]
}, iY = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, oY = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, aY = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, sY = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, lY = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, cY = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, uY = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, fY = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, dY = {
  ordinalNumber: JG({
    matchPattern: eY,
    parsePattern: tY,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: $s({
    matchPatterns: nY,
    defaultMatchWidth: "wide",
    parsePatterns: rY,
    defaultParseWidth: "any"
  }),
  quarter: $s({
    matchPatterns: iY,
    defaultMatchWidth: "wide",
    parsePatterns: oY,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: $s({
    matchPatterns: aY,
    defaultMatchWidth: "wide",
    parsePatterns: sY,
    defaultParseWidth: "any"
  }),
  day: $s({
    matchPatterns: lY,
    defaultMatchWidth: "wide",
    parsePatterns: cY,
    defaultParseWidth: "any"
  }),
  dayPeriod: $s({
    matchPatterns: uY,
    defaultMatchWidth: "any",
    parsePatterns: fY,
    defaultParseWidth: "any"
  })
};
const pY = dY;
var hY = {
  code: "en-US",
  formatDistance: MG,
  formatLong: FG,
  formatRelative: BG,
  localize: XG,
  match: pY,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const mY = hY;
var gY = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, vY = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, wY = /^'([^]*?)'?$/, yY = /''/g, bY = /[a-zA-Z]/;
function xY(e, t, n) {
  var r, i, o, a, s, c, f, p, d, h, m, v, w, b, E, C, S, _;
  Vt(2, arguments);
  var T = String(t), P = rd(), R = (r = (i = n == null ? void 0 : n.locale) !== null && i !== void 0 ? i : P.locale) !== null && r !== void 0 ? r : mY, N = Oi((o = (a = (s = (c = n == null ? void 0 : n.firstWeekContainsDate) !== null && c !== void 0 ? c : n == null || (f = n.locale) === null || f === void 0 || (p = f.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && s !== void 0 ? s : P.firstWeekContainsDate) !== null && a !== void 0 ? a : (d = P.locale) === null || d === void 0 || (h = d.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(N >= 1 && N <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var B = Oi((m = (v = (w = (b = n == null ? void 0 : n.weekStartsOn) !== null && b !== void 0 ? b : n == null || (E = n.locale) === null || E === void 0 || (C = E.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && w !== void 0 ? w : P.weekStartsOn) !== null && v !== void 0 ? v : (S = P.locale) === null || S === void 0 || (_ = S.options) === null || _ === void 0 ? void 0 : _.weekStartsOn) !== null && m !== void 0 ? m : 0);
  if (!(B >= 0 && B <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!R.localize)
    throw new RangeError("locale must contain localize property");
  if (!R.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var L = Wn(e);
  if (!uG(L))
    throw new RangeError("Invalid time value");
  var j = tg(L), I = dG(L, j), z = {
    firstWeekContainsDate: N,
    weekStartsOn: B,
    locale: R,
    _originalDate: L
  }, H = T.match(vY).map(function(G) {
    var Y = G[0];
    if (Y === "p" || Y === "P") {
      var ne = TG[Y];
      return ne(G, R.formatLong);
    }
    return G;
  }).join("").match(gY).map(function(G) {
    if (G === "''")
      return "'";
    var Y = G[0];
    if (Y === "'")
      return EY(G);
    var ne = CG[Y];
    if (ne)
      return !(n != null && n.useAdditionalWeekYearTokens) && RG(G) && V2(G, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && AG(G) && V2(G, t, String(e)), ne(I, G, R.localize, z);
    if (Y.match(bY))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + Y + "`");
    return G;
  }).join("");
  return H;
}
function EY(e) {
  var t = e.match(wY);
  return t ? t[1].replace(yY, "'") : e;
}
function CY(e) {
  return Vt(1, arguments), HC(e, Date.now());
}
function SY(e, t) {
  Vt(2, arguments);
  var n = Oi(t);
  return iG(e, -n);
}
function _Y(e) {
  return Vt(1, arguments), HC(e, SY(Date.now(), 1));
}
function id(e) {
  try {
    return xY(new Date(e), "MM/dd/yyyy");
  } catch {
    return "";
  }
}
function TY(e) {
  if (!e)
    return "";
  const t = /* @__PURE__ */ new Date(), n = new Date(e);
  if (CY(n))
    return "Today";
  if (_Y(n))
    return "1 day ago";
  const r = fG(t, n);
  return r <= 7 ? `${r} days ago` : id(e);
}
function kY({
  scrollThresholdRef: e,
  enabled: t = !0,
  rootMargin: n,
  rootRef: r,
  onReachedThreshold: i
}) {
  _e(() => {
    if (!e.current || !t)
      return;
    const o = new IntersectionObserver(
      (a) => {
        a.forEach((s) => {
          s.isIntersecting && i(o);
        });
      },
      {
        root: r == null ? void 0 : r.current,
        rootMargin: n
      }
    );
    return o.observe(e.current), () => {
      o.disconnect();
    };
  }, [e, i, r, n, t]);
}
function PY({
  children: e,
  className: t
}) {
  const {
    data: n,
    isValidating: r,
    isLoading: i,
    setSize: o
  } = Pl(), a = r || i, s = y.useRef(null), c = y.useRef(null), f = n ? wq(n) : !1;
  return kY({
    scrollThresholdRef: s,
    enabled: f,
    rootMargin: "0px 0px 100px 0px",
    rootRef: c,
    onReachedThreshold: () => {
      a || o((p) => p + 1);
    }
  }), /* @__PURE__ */ y.createElement(
    "ul",
    {
      className: le(
        "ai-tw-flex ai-tw-flex-1 ai-tw-flex-col ai-tw-gap-y-1 ai-tw-overflow-auto",
        t
      ),
      ref: c
    },
    e,
    /* @__PURE__ */ y.createElement("li", { ref: s }),
    a && /* @__PURE__ */ y.createElement("li", { className: "ai-tw-my-2 ai-tw-flex ai-tw-items-center ai-tw-justify-center" }, /* @__PURE__ */ y.createElement(bn, { size: "small" }))
  );
}
function AY({
  title: e,
  date: t,
  isSelected: n,
  onSelectChat: r,
  onDeleteChat: i
}) {
  return /* @__PURE__ */ y.createElement("div", { tabIndex: 0, className: "ai-tw-group/container ai-tw-relative" }, /* @__PURE__ */ y.createElement(
    "button",
    {
      onClick: r,
      className: le(
        "ai-tw-flex ai-tw-w-full ai-tw-items-center ai-tw-rounded-lg ai-tw-border ai-tw-border-stroke-primary ai-tw-bg-container-primary ai-tw-px-3 ai-tw-py-2 ai-tw-text-left ai-tw-text-content-primary ai-tw-body-sm hover:ai-tw-border-stroke-primary-darkest",
        {
          "ai-tw-border-stroke-primary-darkest ai-tw-cursor-default": n
        }
      )
    },
    /* @__PURE__ */ y.createElement("span", { className: "ai-tw-grow ai-tw-pr-4" }, e || vv),
    /* @__PURE__ */ y.createElement("span", { className: "ai-tw-flex-initial ai-tw-shrink-0 ai-tw-text-[11px] ai-tw-text-content-primary-light group-focus-within/container:ai-tw-invisible group-hover/container:ai-tw-invisible" }, t)
  ), /* @__PURE__ */ y.createElement(
    Zo,
    {
      icon: mf,
      onClick: (o) => {
        o.stopPropagation(), i();
      },
      className: "ai-tw-group ai-tw-invisible ai-tw-absolute ai-tw-right-1.5 ai-tw-top-1/2 -ai-tw-translate-y-1/2 ai-tw-p-1.5 group-focus-within/container:ai-tw-visible group-hover/container:ai-tw-visible"
    }
  ));
}
function RY() {
  const { data: e } = Pl(), t = e ? kC(e) : hv(), { chatState: n, selectChat: r, chatDispatch: i, navigationDispatch: o } = Re(kt), a = Al(n), s = SC(t);
  function c(f) {
    i({
      type: "selectChatForDeletion",
      chatId: f
    });
  }
  return /* @__PURE__ */ y.createElement(PY, null, s && s.map((f) => {
    const p = _C(f), d = TC(f), h = hq(f);
    return /* @__PURE__ */ y.createElement("li", { key: p }, /* @__PURE__ */ y.createElement(
      AY,
      {
        title: d,
        date: TY(h),
        isSelected: p === a,
        onSelectChat: () => {
          p && r(p), o({
            type: "setActiveNavigationItem",
            payload: void 0
          });
        },
        onDeleteChat: () => p && c(p)
      }
    ));
  }));
}
const qC = "Collapsible", [$Y, GC] = ar(qC), [OY, yv] = $Y(qC), MY = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeCollapsible: n, open: r, defaultOpen: i, disabled: o, onOpenChange: a, ...s } = e, [c = !1, f] = si({
    prop: r,
    defaultProp: i,
    onChange: a
  });
  return /* @__PURE__ */ K(OY, {
    scope: n,
    disabled: o,
    contentId: zr(),
    open: c,
    onOpenToggle: Me(
      () => f(
        (p) => !p
      ),
      [
        f
      ]
    )
  }, /* @__PURE__ */ K(st.div, de({
    "data-state": bv(c),
    "data-disabled": o ? "" : void 0
  }, s, {
    ref: t
  })));
}), DY = "CollapsibleTrigger", NY = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeCollapsible: n, ...r } = e, i = yv(DY, n);
  return /* @__PURE__ */ K(st.button, de({
    type: "button",
    "aria-controls": i.contentId,
    "aria-expanded": i.open || !1,
    "data-state": bv(i.open),
    "data-disabled": i.disabled ? "" : void 0,
    disabled: i.disabled
  }, r, {
    ref: t,
    onClick: Oe(e.onClick, i.onOpenToggle)
  }));
}), YC = "CollapsibleContent", IY = /* @__PURE__ */ Ee((e, t) => {
  const { forceMount: n, ...r } = e, i = yv(YC, e.__scopeCollapsible);
  return /* @__PURE__ */ K(
    $n,
    {
      present: n || i.open
    },
    ({ present: o }) => /* @__PURE__ */ K(LY, de({}, r, {
      ref: t,
      present: o
    }))
  );
}), LY = /* @__PURE__ */ Ee((e, t) => {
  const { __scopeCollapsible: n, present: r, children: i, ...o } = e, a = yv(YC, n), [s, c] = ue(r), f = he(null), p = Lt(t, f), d = he(0), h = d.current, m = he(0), v = m.current, w = a.open || s, b = he(w), E = he();
  return _e(() => {
    const C = requestAnimationFrame(
      () => b.current = !1
    );
    return () => cancelAnimationFrame(C);
  }, []), Vo(() => {
    const C = f.current;
    if (C) {
      E.current = E.current || {
        transitionDuration: C.style.transitionDuration,
        animationName: C.style.animationName
      }, C.style.transitionDuration = "0s", C.style.animationName = "none";
      const S = C.getBoundingClientRect();
      d.current = S.height, m.current = S.width, b.current || (C.style.transitionDuration = E.current.transitionDuration, C.style.animationName = E.current.animationName), c(r);
    }
  }, [
    a.open,
    r
  ]), /* @__PURE__ */ K(st.div, de({
    "data-state": bv(a.open),
    "data-disabled": a.disabled ? "" : void 0,
    id: a.contentId,
    hidden: !w
  }, o, {
    ref: p,
    style: {
      ["--radix-collapsible-content-height"]: h ? `${h}px` : void 0,
      ["--radix-collapsible-content-width"]: v ? `${v}px` : void 0,
      ...e.style
    }
  }), w && i);
});
function bv(e) {
  return e ? "open" : "closed";
}
const FY = MY, zY = NY, VY = IY, po = "Accordion", BY = [
  "Home",
  "End",
  "ArrowDown",
  "ArrowUp",
  "ArrowLeft",
  "ArrowRight"
], [xv, HY, UY] = G1(po), [od, Xse] = ar(po, [
  UY,
  GC
]), Ev = GC(), KC = /* @__PURE__ */ y.forwardRef((e, t) => {
  const { type: n, ...r } = e, i = r, o = r;
  return /* @__PURE__ */ y.createElement(xv.Provider, {
    scope: e.__scopeAccordion
  }, n === "multiple" ? /* @__PURE__ */ y.createElement(GY, de({}, o, {
    ref: t
  })) : /* @__PURE__ */ y.createElement(qY, de({}, i, {
    ref: t
  })));
});
KC.propTypes = {
  type(e) {
    const t = e.value || e.defaultValue;
    return e.type && ![
      "single",
      "multiple"
    ].includes(e.type) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.") : e.type === "multiple" && typeof t == "string" ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.") : e.type === "single" && Array.isArray(t) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.") : null;
  }
};
const [XC, WY] = od(po), [QC, jY] = od(po, {
  collapsible: !1
}), qY = /* @__PURE__ */ y.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: i = () => {
  }, collapsible: o = !1, ...a } = e, [s, c] = si({
    prop: n,
    defaultProp: r,
    onChange: i
  });
  return /* @__PURE__ */ y.createElement(XC, {
    scope: e.__scopeAccordion,
    value: s ? [
      s
    ] : [],
    onItemOpen: c,
    onItemClose: y.useCallback(
      () => o && c(""),
      [
        o,
        c
      ]
    )
  }, /* @__PURE__ */ y.createElement(QC, {
    scope: e.__scopeAccordion,
    collapsible: o
  }, /* @__PURE__ */ y.createElement(ZC, de({}, a, {
    ref: t
  }))));
}), GY = /* @__PURE__ */ y.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: i = () => {
  }, ...o } = e, [a = [], s] = si({
    prop: n,
    defaultProp: r,
    onChange: i
  }), c = y.useCallback(
    (p) => s(
      (d = []) => [
        ...d,
        p
      ]
    ),
    [
      s
    ]
  ), f = y.useCallback(
    (p) => s(
      (d = []) => d.filter(
        (h) => h !== p
      )
    ),
    [
      s
    ]
  );
  return /* @__PURE__ */ y.createElement(XC, {
    scope: e.__scopeAccordion,
    value: a,
    onItemOpen: c,
    onItemClose: f
  }, /* @__PURE__ */ y.createElement(QC, {
    scope: e.__scopeAccordion,
    collapsible: !0
  }, /* @__PURE__ */ y.createElement(ZC, de({}, o, {
    ref: t
  }))));
}), [YY, ad] = od(po), ZC = /* @__PURE__ */ y.forwardRef((e, t) => {
  const { __scopeAccordion: n, disabled: r, dir: i, orientation: o = "vertical", ...a } = e, s = y.useRef(null), c = Lt(s, t), f = HY(n), d = Tl(i) === "ltr", h = Oe(e.onKeyDown, (m) => {
    var v;
    if (!BY.includes(m.key))
      return;
    const w = m.target, b = f().filter((B) => {
      var L;
      return !((L = B.ref.current) !== null && L !== void 0 && L.disabled);
    }), E = b.findIndex(
      (B) => B.ref.current === w
    ), C = b.length;
    if (E === -1)
      return;
    m.preventDefault();
    let S = E;
    const _ = 0, T = C - 1, P = () => {
      S = E + 1, S > T && (S = _);
    }, R = () => {
      S = E - 1, S < _ && (S = T);
    };
    switch (m.key) {
      case "Home":
        S = _;
        break;
      case "End":
        S = T;
        break;
      case "ArrowRight":
        o === "horizontal" && (d ? P() : R());
        break;
      case "ArrowDown":
        o === "vertical" && P();
        break;
      case "ArrowLeft":
        o === "horizontal" && (d ? R() : P());
        break;
      case "ArrowUp":
        o === "vertical" && R();
        break;
    }
    const N = S % C;
    (v = b[N].ref.current) === null || v === void 0 || v.focus();
  });
  return /* @__PURE__ */ y.createElement(YY, {
    scope: n,
    disabled: r,
    direction: i,
    orientation: o
  }, /* @__PURE__ */ y.createElement(xv.Slot, {
    scope: n
  }, /* @__PURE__ */ y.createElement(st.div, de({}, a, {
    "data-orientation": o,
    ref: c,
    onKeyDown: r ? void 0 : h
  }))));
}), ng = "AccordionItem", [KY, Cv] = od(ng), XY = /* @__PURE__ */ y.forwardRef((e, t) => {
  const { __scopeAccordion: n, value: r, ...i } = e, o = ad(ng, n), a = WY(ng, n), s = Ev(n), c = zr(), f = r && a.value.includes(r) || !1, p = o.disabled || e.disabled;
  return /* @__PURE__ */ y.createElement(KY, {
    scope: n,
    open: f,
    disabled: p,
    triggerId: c
  }, /* @__PURE__ */ y.createElement(FY, de({
    "data-orientation": o.orientation,
    "data-state": JC(f)
  }, s, i, {
    ref: t,
    disabled: p,
    open: f,
    onOpenChange: (d) => {
      d ? a.onItemOpen(r) : a.onItemClose(r);
    }
  })));
}), QY = "AccordionHeader", ZY = /* @__PURE__ */ y.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...r } = e, i = ad(po, n), o = Cv(QY, n);
  return /* @__PURE__ */ y.createElement(st.h3, de({
    "data-orientation": i.orientation,
    "data-state": JC(o.open),
    "data-disabled": o.disabled ? "" : void 0
  }, r, {
    ref: t
  }));
}), B2 = "AccordionTrigger", JY = /* @__PURE__ */ y.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...r } = e, i = ad(po, n), o = Cv(B2, n), a = jY(B2, n), s = Ev(n);
  return /* @__PURE__ */ y.createElement(xv.ItemSlot, {
    scope: n
  }, /* @__PURE__ */ y.createElement(zY, de({
    "aria-disabled": o.open && !a.collapsible || void 0,
    "data-orientation": i.orientation,
    id: o.triggerId
  }, s, r, {
    ref: t
  })));
}), eK = "AccordionContent", tK = /* @__PURE__ */ y.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...r } = e, i = ad(po, n), o = Cv(eK, n), a = Ev(n);
  return /* @__PURE__ */ y.createElement(VY, de({
    role: "region",
    "aria-labelledby": o.triggerId,
    "data-orientation": i.orientation
  }, a, r, {
    ref: t,
    style: {
      ["--radix-accordion-content-height"]: "var(--radix-collapsible-content-height)",
      ["--radix-accordion-content-width"]: "var(--radix-collapsible-content-width)",
      ...e.style
    }
  }));
});
function JC(e) {
  return e ? "open" : "closed";
}
const nK = KC, rK = XY, iK = ZY, oK = JY, aK = tK, sK = "/rag-chat/categories";
function H2() {
  return sK;
}
function eS() {
  const e = xn();
  function t() {
    return e(H2());
  }
  return qr(H2(), t);
}
function tS(e) {
  return e.categories;
}
function U2(e) {
  return e.id;
}
function tf(e) {
  return e.title;
}
function nS(e) {
  return e.startingQuestions;
}
const lK = "/rag-chat/starting-questions";
function cK(e) {
  const t = new URLSearchParams();
  return e && t.set("search", e), `${lK}?${t}`;
}
function uK({
  search: e
}) {
  const t = xn(), n = cK(e);
  function r() {
    return t(n);
  }
  return qr(n, () => e ? r() : Promise.resolve({
    startingQuestions: []
  }));
}
function fK(e) {
  return e.startingQuestions;
}
function rS({
  question: e
}) {
  const { askQuestion: t, navigationDispatch: n, isGenerationInProgress: r } = Re(kt);
  function i() {
    n({
      type: "setActiveNavigationItem",
      payload: void 0
    }), t(e);
  }
  return /* @__PURE__ */ y.createElement(S5, null, /* @__PURE__ */ y.createElement(_5, { asChild: !0 }, /* @__PURE__ */ y.createElement(
    "button",
    {
      disabled: r,
      className: le(
        "ai-tw-rounded-lg ai-tw-border ai-tw-border-stroke-primary ai-tw-bg-container-primary ai-tw-px-3 ai-tw-py-2 ai-tw-text-left disabled:ai-tw-opacity-70",
        {
          "hover:ai-tw-border-stroke-primary-darkest": !r
        }
      ),
      onClick: i
    },
    /* @__PURE__ */ y.createElement("p", { className: "ai-tw-text-content-primary ai-tw-body-sm" }, e)
  )), r ? /* @__PURE__ */ y.createElement(A1, null, "Please wait while ", td, " completes the generation.") : null);
}
function W2({
  children: e
}) {
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-absolute ai-tw-right-3 ai-tw-top-1/2 -ai-tw-translate-y-1/2 ai-tw-text-sm ai-tw-text-content-primary-light" }, e);
}
const iS = Ee(
  ({ variant: e, className: t, onClear: n, ...r }, i) => /* @__PURE__ */ y.createElement("div", { className: "ai-tw-preflight ai-tw-relative ai-tw-flex" }, /* @__PURE__ */ y.createElement(
    "input",
    {
      className: le(R1({ variant: e }), "ai-tw-pr-8", t),
      ...r,
      ref: i
    }
  ), r.value ? null : /* @__PURE__ */ y.createElement(W2, null, /* @__PURE__ */ y.createElement(Ne, { icon: VR })), r.value ? /* @__PURE__ */ y.createElement(W2, null, /* @__PURE__ */ y.createElement("button", { onClick: n }, /* @__PURE__ */ y.createElement(Ne, { icon: mf }))) : null)
);
iS.displayName = "ClearableInput";
function dK(e, t) {
  const [n, r] = ue(e);
  return _e(() => {
    const i = setTimeout(() => r(e), t || 500);
    return () => {
      clearTimeout(i);
    };
  }, [e, t]), n;
}
function pK({
  isLoading: e,
  startingQuestions: t
}) {
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-flex-col ai-tw-gap-y-1" }, !e && (t != null && t.length) ? t.map((n) => /* @__PURE__ */ y.createElement(
    rS,
    {
      key: n,
      question: n
    }
  )) : null, !e && !(t != null && t.length) ? /* @__PURE__ */ y.createElement("p", { className: "ai-tw-text-sm" }, "No results found for your search.") : null, e ? /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-justify-center ai-tw-py-2" }, /* @__PURE__ */ y.createElement(bn, { size: "small" })) : null);
}
function hK({
  className: e
}) {
  const { navigationState: t } = Re(kt), [n, r] = ue(""), i = dK(n, 500), { data: o, isLoading: a } = eS(), {
    data: s,
    isLoading: c
  } = uK({ search: i }), f = s ? fK(s) : [], p = Cq(t);
  if (a)
    return /* @__PURE__ */ y.createElement(bn, { size: "small" });
  const d = o ? tS(o) : [];
  return /* @__PURE__ */ y.createElement(
    nK,
    {
      defaultValue: [p],
      className: le("ai-tw-grid ai-tw-w-full ai-tw-gap-2", e),
      type: "multiple"
    },
    /* @__PURE__ */ y.createElement(
      iS,
      {
        variant: "default",
        placeholder: "Search Prompts",
        value: n,
        onChange: (h) => r(h.target.value),
        onClear: () => r("")
      }
    ),
    i ? /* @__PURE__ */ y.createElement(
      pK,
      {
        isLoading: c,
        startingQuestions: f
      }
    ) : null,
    !i && !d.length ? /* @__PURE__ */ y.createElement("p", { className: "ai-tw-text-content-primary ai-tw-body-sm" }, "Sorry, no prompts are available at the moment, please try again later.") : null,
    !i && d.length ? d.map((h) => {
      const m = tf(h);
      return /* @__PURE__ */ y.createElement(rK, { key: m, value: m }, /* @__PURE__ */ y.createElement(iK, { className: "ai-tw-group ai-tw-subtitle-md data-[state=open]:ai-tw-mb-2" }, /* @__PURE__ */ y.createElement(oK, { className: "ai-tw-flex ai-tw-w-full ai-tw-items-center ai-tw-gap-2 ai-tw-rounded ai-tw-text-content-primary hover:ai-tw-cursor-pointer focus:ai-tw-cursor-pointer focus:ai-tw-outline focus:ai-tw-outline-1 focus:ai-tw-outline-grey-30" }, /* @__PURE__ */ y.createElement(
        Ne,
        {
          className: "ai-tw-transition-transform group-data-[state=open]:ai-tw-rotate-90",
          icon: L4,
          size: "xs"
        }
      ), /* @__PURE__ */ y.createElement("span", null, tf(h)))), /* @__PURE__ */ y.createElement(aK, { asChild: !0 }, /* @__PURE__ */ y.createElement(
        on.div,
        {
          className: "ai-tw-grid ai-tw-gap-1 ai-tw-p-1",
          initial: { y: -5, opacity: 0 },
          animate: { y: 0, opacity: 1 }
        },
        nS(h).map(
          (v) => /* @__PURE__ */ y.createElement(
            rS,
            {
              key: v,
              question: v
            }
          )
        )
      )));
    }) : null
  );
}
function oS(e) {
  const [t, n] = ue(e);
  return _e(() => () => {
    n(e);
  }, [e]), t;
}
function j2({ children: e, value: t, className: n }) {
  return /* @__PURE__ */ y.createElement(
    Zf,
    {
      value: t,
      className: le(
        "ai-tw-flex ai-tw-min-h-0 ai-tw-flex-initial ai-tw-flex-col",
        n
      )
    },
    e
  );
}
function mK() {
  const { navigationState: e, navigationDispatch: t } = Re(kt), n = AC(e), r = oS(n);
  function i() {
    t({
      type: "setActiveNavigationItem",
      payload: void 0
    });
  }
  return /* @__PURE__ */ y.createElement(
    lv,
    {
      value: n || r,
      className: "ai-tw-flex ai-tw-min-h-0 ai-tw-flex-initial ai-tw-flex-col"
    },
    /* @__PURE__ */ y.createElement(j2, { value: "prompt-library" }, /* @__PURE__ */ y.createElement(
      N2,
      {
        title: "Prompt Library",
        icon: D4,
        onClose: i
      },
      /* @__PURE__ */ y.createElement(hK, null)
    )),
    /* @__PURE__ */ y.createElement(j2, { value: "previous-chats" }, /* @__PURE__ */ y.createElement(
      N2,
      {
        title: "Previous Chats",
        icon: VC,
        onClose: i,
        className: "ai-tw-flex ai-tw-flex-col"
      },
      /* @__PURE__ */ y.createElement(RY, null)
    ))
  );
}
function gK({
  className: e
}) {
  const { navigationDispatch: t } = Re(kt);
  function n() {
    t({
      type: "setActiveNavigationItem",
      payload: void 0
    });
  }
  return /* @__PURE__ */ y.createElement(
    "div",
    {
      className: le(
        "ai-tw-absolute ai-tw-flex ai-tw-cursor-pointer ai-tw-flex-col ai-tw-justify-end",
        e
      ),
      onClick: n
    },
    /* @__PURE__ */ y.createElement(
      on.div,
      {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        className: "ai-tw-flex ai-tw-min-h-0 ai-tw-flex-initial ai-tw-cursor-auto ai-tw-flex-col ai-tw-rounded-lg ai-tw-bg-tinted-grey-50",
        onClick: (r) => r.stopPropagation()
      },
      /* @__PURE__ */ y.createElement(
        on.div,
        {
          initial: { opacity: 0, y: 10 },
          animate: { opacity: 1, y: 0 },
          exit: { opacity: 0, y: 10 },
          className: "ai-tw-flex ai-tw-min-h-0 ai-tw-flex-initial ai-tw-flex-col ai-tw-px-6 ai-tw-pb-2 ai-tw-pt-8"
        },
        /* @__PURE__ */ y.createElement(mK, null)
      ),
      /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex-initial ai-tw-border-t-2 ai-tw-border-white ai-tw-px-3 ai-tw-pb-2 ai-tw-pt-3" }, /* @__PURE__ */ y.createElement(BC, null)),
      /* @__PURE__ */ y.createElement(rG, null)
    )
  );
}
function vK(e) {
  return `/rag-chat/leads/${e}/details`;
}
function wK({ personUuid: e }) {
  const t = xn(), n = e ? vK(e) : null;
  async function r(i) {
    return t(i);
  }
  return qr(n, r);
}
function yK(e) {
  return [e.first_name, e.last_name].filter(Boolean).join(" ");
}
const bK = "/rag-chat/release-notes";
function q2() {
  return `${bK}`;
}
function sd() {
  const e = xn();
  function t() {
    return e(q2());
  }
  return qr(q2(), () => t());
}
function ld(e) {
  return e.releaseNotes;
}
function rg(e) {
  return e._id;
}
function aS(e) {
  return e.title;
}
function sS(e) {
  return e.createdAt;
}
function xK(e) {
  return e.tags;
}
function EK(e) {
  return e.markdown;
}
const lS = "ai-components-ask-place-updates-banner-closed-ts";
function CK(e) {
  if (!e)
    return !1;
  const t = window.localStorage.getItem(lS);
  return !t || !Number(t) ? !0 : e > Number(t);
}
function SK() {
  const [e, t] = ue(!1), {
    data: n,
    isLoading: r,
    error: i
  } = sd(), o = r || i || !n ? null : ld(n), a = o ? o[0] : null, s = a ? sS(a) : null;
  if (_e(() => {
    s && t(CK(s));
  }, [s]), i)
    return {
      isVisible: !1,
      onClose: gr
    };
  function c() {
    window.localStorage.setItem(lS, Date.now().toString()), t(!1);
  }
  return {
    isVisible: e,
    onClose: c
  };
}
function nf({
  children: e,
  className: t,
  hidden: n = {},
  visible: r = {},
  exit: i = {}
}) {
  return /* @__PURE__ */ y.createElement(
    on.div,
    {
      className: t,
      initial: "hidden",
      animate: "visible",
      exit: "exit",
      variants: {
        hidden: { opacity: 0, ...n },
        visible: { opacity: 1, ...r },
        exit: i
      },
      transition: { duration: 0.35 }
    },
    e
  );
}
function _K(e) {
  return `/rag-chat/leads/${e}/starting-questions`;
}
function TK({
  personUuid: e
}) {
  const t = xn(), n = e ? _K(e) : null;
  async function r(i) {
    return t(i);
  }
  return qr(
    n,
    r
  );
}
function kK(e) {
  return e.startingQuestions;
}
function ig({
  children: e,
  className: t,
  onClick: n
}) {
  return /* @__PURE__ */ y.createElement(
    "button",
    {
      onClick: n,
      className: le(
        "ai-tw-flex ai-tw-w-full ai-tw-items-center ai-tw-rounded-sm ai-tw-border-b ai-tw-border-grey-20 ai-tw-px-4 ai-tw-py-3 ai-tw-text-content-primary hover:ai-tw-bg-element-primary-subtle",
        t
      )
    },
    e
  );
}
function PK({
  onMoreCategoriesClick: e
}) {
  const { askQuestion: t, leadUuid: n } = Re(kt), {
    data: r,
    isLoading: i,
    error: o
  } = TK({
    personUuid: n
  }), a = r ? kK(r) : void 0;
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-min-h-0 ai-tw-flex-col ai-tw-items-center" }, i ? /* @__PURE__ */ y.createElement(bn, { size: "small" }) : null, o ? /* @__PURE__ */ y.createElement("p", { className: "ai-tw-text-content-primary ai-tw-body-sm" }, "Something went wrong while fetching the lead questions. Please try again later.") : null, a ? /* @__PURE__ */ y.createElement("ul", { className: "ai-tw-overflow-y-auto ai-tw-px-10" }, a.map((s) => /* @__PURE__ */ y.createElement("li", { key: s }, /* @__PURE__ */ y.createElement(
    ig,
    {
      onClick: () => t(s)
    },
    /* @__PURE__ */ y.createElement(
      Ne,
      {
        icon: M4,
        className: "ai-tw-mr-2 ai-tw-body-sm"
      }
    ),
    /* @__PURE__ */ y.createElement("p", { className: "ai-tw-text-left ai-tw-body-md" }, "“", s, "”")
  )))) : null, i ? null : /* @__PURE__ */ y.createElement(
    "button",
    {
      className: "ai-tw-mt-9 ai-tw-text-content-brand ai-tw-body-sm",
      onClick: e
    },
    "More Categories"
  ));
}
function Sv({
  height: e = 12,
  pathClassName: t,
  width: n = 62
}) {
  return /* @__PURE__ */ y.createElement(
    "svg",
    {
      width: n,
      height: e,
      viewBox: "0 0 62 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ y.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.98016 0.0996094C8.20082 0.0996094 9.65378 1.15928 10.5761 2.47484L8.93074 3.39711C8.59475 2.92665 8.15123 2.54326 7.63711 2.27887C7.12298 2.01449 6.55313 1.87677 5.97501 1.87717C3.72 1.87717 2.04548 3.59462 2.04548 5.99905C2.04548 8.40348 3.72515 10.1295 5.98016 10.1295C6.97407 10.1184 7.9314 9.75296 8.67999 9.09905V7.32664H5.27944V5.56797H10.6791V9.83927C10.0891 10.4991 9.36418 11.0246 8.55352 11.3802C7.74285 11.7357 6.86528 11.9131 5.98016 11.9002C2.68266 11.9071 0 9.56619 0 5.9939C0 2.4216 2.68266 0.0996094 5.98016 0.0996094ZM19.3763 0.288522L14.9007 11.6838H17.1728L20.6335 2.30137L22.6292 7.74225H20.4618L19.8074 9.49749H23.2835L24.077 11.6838H26.3492L21.8735 0.288522H19.3763ZM31.0138 0.286771V11.6838H36.7707C38.9072 11.6838 40.0871 10.3682 40.0871 8.60781C40.0871 7.20809 39.0944 5.99386 37.8819 5.80665C38.9416 5.5851 39.8638 4.62677 39.8638 3.1927C39.8638 1.58688 38.7028 0.286771 36.6179 0.286771H31.0138ZM36.2074 5.00289H33.0129V2.04716H36.2074C37.2327 2.04716 37.8132 2.6809 37.8132 3.53447C37.8132 4.38804 37.2379 5.00289 36.2074 5.00289ZM36.2933 9.9251H33.0129V6.76327H36.2933C37.4371 6.76327 38.0365 7.47601 38.0365 8.33474C38.0365 9.32571 37.3873 9.9251 36.2933 9.9251ZM45.5124 11.6838V0.286771H51.1164C53.2014 0.286771 54.3624 1.58688 54.3624 3.1927C54.3624 4.62677 53.4401 5.5851 52.3805 5.80665C53.593 5.99386 54.5839 7.20809 54.5839 8.60781C54.5839 10.3682 53.4058 11.6838 51.2693 11.6838H45.5124ZM47.5115 5.00289H50.7059C51.7364 5.00289 52.3118 4.38804 52.3118 3.53447C52.3118 2.6809 51.7313 2.04716 50.7059 2.04716H47.5115V5.00289ZM47.5115 9.9251H50.7918C51.8858 9.9251 52.535 9.32571 52.535 8.33474C52.535 7.47601 51.9356 6.76327 50.7918 6.76327H47.5115V9.9251ZM59.9923 0.286771V11.6838H62V0.286771H59.9923Z",
        fill: "black",
        className: t
      }
    )
  );
}
function AK() {
  return /* @__PURE__ */ y.createElement(
    "svg",
    {
      width: "10",
      height: "13",
      viewBox: "0 0 10 13",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ y.createElement(
      "path",
      {
        d: "M5.6624 0.753906H0.5V12.7539H2.56222V2.60762H5.3824C6.54333 2.60762 7.39005 3.36017 7.39005 4.51706C7.38319 5.66676 6.54333 6.42646 5.37564 6.42646H4.5564L3.89233 8.27316H5.6624C8.10699 8.27316 9.5 6.54486 9.5 4.51706C9.5 2.48207 8.12747 0.753906 5.6624 0.753906Z",
        fill: "currentColor"
      }
    )
  );
}
function RK({
  categoryId: e
}) {
  let t = pR;
  switch (e) {
    case "3584e4c1":
      t = NR;
      break;
    case "9cb3e57a":
      t = fR;
      break;
    case "b78f52d3":
      t = bR;
      break;
  }
  return e === "637cf278" ? /* @__PURE__ */ y.createElement(AK, null) : /* @__PURE__ */ y.createElement(Ne, { icon: t, className: "ai-tw-body-sm" });
}
const _v = Ee(
  ({ active: e, children: t, className: n, label: r, icon: i, ...o }, a) => /* @__PURE__ */ y.createElement(
    "button",
    {
      ref: a,
      className: le(
        "ai-tw-inline-flex ai-tw-w-max ai-tw-items-center ai-tw-gap-1.5 ai-tw-rounded-full ai-tw-border ai-tw-border-stroke-primary-dark ai-tw-bg-white ai-tw-px-4 ai-tw-py-1 ai-tw-text-content-primary",
        {
          "ai-tw-border-element-primary-bold ai-tw-bg-element-primary-bold ai-tw-text-white ai-tw-cursor-default": e,
          "hover:ai-tw-border-element-primary-subtle hover:ai-tw-bg-element-primary-subtle": !e
        },
        n
      ),
      ...o
    },
    i || null,
    r ? /* @__PURE__ */ y.createElement("p", { className: "ai-tw-body-md" }, r) : t
  )
);
_v.displayName = "HelperPill";
const $K = 6, G2 = 4;
function OK({
  className: e
}) {
  const { askQuestion: t, navigationDispatch: n } = Re(kt), { data: r, isLoading: i } = eS(), [o, a] = ue();
  if (i)
    return /* @__PURE__ */ y.createElement(bn, { size: "small", className: "ai-tw-mx-auto" });
  const s = r ? tS(r) : [];
  return s[0] ? /* @__PURE__ */ y.createElement(
    lv,
    {
      className: le("ai-tw-flex ai-tw-flex-col", e),
      value: o,
      onValueChange: (c) => a(c)
    },
    /* @__PURE__ */ y.createElement(Xf, { className: "ai-tw-mx-auto ai-tw-flex ai-tw-w-fit ai-tw-flex-initial ai-tw-flex-wrap ai-tw-justify-center ai-tw-gap-x-1 ai-tw-gap-y-2" }, s.slice(0, $K).map((c) => {
      const f = U2(c), p = tf(c);
      return /* @__PURE__ */ y.createElement(Qf, { key: f, value: f, asChild: !0 }, /* @__PURE__ */ y.createElement(
        _v,
        {
          key: f,
          label: p,
          icon: /* @__PURE__ */ y.createElement(RK, { categoryId: f }),
          active: o === f,
          className: "ai-tw-mr-1"
        }
      ));
    })),
    o && /* @__PURE__ */ y.createElement("div", { className: "ai-tw-mt-4 ai-tw-flex-1 ai-tw-overflow-y-auto ai-tw-px-10" }, s.map((c) => {
      const f = U2(c), p = nS(c);
      return /* @__PURE__ */ y.createElement(Zf, { key: f, value: f }, /* @__PURE__ */ y.createElement(Br, null, /* @__PURE__ */ y.createElement(
        on.ul,
        {
          initial: { opacity: 0, y: -5 },
          animate: { opacity: 1, y: 0 },
          exit: { opacity: 0, y: -5 },
          transition: { duration: 0.2 }
        },
        p.slice(0, G2).map((d) => /* @__PURE__ */ y.createElement("li", { key: d }, /* @__PURE__ */ y.createElement(
          ig,
          {
            onClick: () => t(d)
          },
          /* @__PURE__ */ y.createElement(
            Ne,
            {
              icon: dR,
              className: "ai-tw-mr-2 ai-tw-body-sm"
            }
          ),
          /* @__PURE__ */ y.createElement("p", { className: "ai-tw-text-left ai-tw-body-md" }, "“", d, "”")
        ))),
        p.length > G2 ? /* @__PURE__ */ y.createElement("li", null, /* @__PURE__ */ y.createElement(
          ig,
          {
            onClick: () => {
              n({
                type: "setActiveNavigationItem",
                payload: "prompt-library"
              }), n({
                type: "setActiveStartingQuestionsCategory",
                payload: tf(c)
              });
            },
            className: "ai-tw-text-content-brand"
          },
          /* @__PURE__ */ y.createElement(
            Ne,
            {
              icon: RR,
              className: "ai-tw-mr-2 ai-tw-body-sm"
            }
          ),
          /* @__PURE__ */ y.createElement("p", { className: "ai-tw-body-md" }, "More Prompts")
        )) : null
      )));
    }))
  ) : null;
}
function MK() {
  const { setIsReleaseNotesOpen: e } = Re(kt), { data: t } = sd(), n = t ? ld(t) : [];
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-min-h-0 ai-tw-flex-col" }, /* @__PURE__ */ y.createElement(OK, { className: "ai-tw-min-h-0 ai-tw-flex-initial" }), n != null && n.length ? /* @__PURE__ */ y.createElement(
    "button",
    {
      onClick: () => e(!0),
      className: "ai-tw-mt-8 ai-tw-text-content-brand ai-tw-body-sm"
    },
    "What’s New with Gabbi?"
  ) : null);
}
function DK({
  className: e,
  onClose: t,
  onLearnMore: n
}) {
  const { data: r, isLoading: i } = sd(), o = i || !r ? null : ld(r);
  if (!(o != null && o.length))
    return null;
  const a = o[0];
  return /* @__PURE__ */ y.createElement(
    on.div,
    {
      initial: { opacity: 0, y: -10 },
      animate: { opacity: 1, y: 0 },
      exit: { opacity: 0, y: -10 },
      transition: { duration: 0.2 },
      role: "button",
      onClick: () => n && n(rg(a)),
      className: le(
        "ai-tw-flex ai-tw-cursor-pointer ai-tw-items-start ai-tw-rounded-lg ai-tw-bg-gradient-to-r ai-tw-from-[hsla(260,60%,47%,0.8)] ai-tw-to-[hsla(260,66%,73%,0.8)] ai-tw-p-2 hover:ai-tw-from-[hsla(260,60%,47%,1)] hover:ai-tw-to-[hsla(260,66%,73%,1)]",
        e
      )
    },
    /* @__PURE__ */ y.createElement("span", { className: "ai-tw-mr-2.5 ai-tw-inline-block ai-tw-rounded-lg ai-tw-bg-gradient-to-r ai-tw-from-content-on-color/75 ai-tw-to-content-on-color/30 ai-tw-p-2.5 ai-tw-text-content-on-color" }, /* @__PURE__ */ y.createElement(Ne, { icon: Kq })),
    /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex-1" }, /* @__PURE__ */ y.createElement("p", { className: "ai-tw-text-content-on-color ai-tw-subtitle-sm" }, "Latest Updates"), /* @__PURE__ */ y.createElement("p", { className: "ai-tw-line-clamp-2 ai-tw-text-content-on-color ai-tw-body-md" }, aS(a)), /* @__PURE__ */ y.createElement(ju, { className: "ai-tw-mt-2", variant: "on-color", size: "sm" }, "Learn More")),
    /* @__PURE__ */ y.createElement(
      ju,
      {
        className: "hover:ai-tw-text-content-ai-dark",
        size: "sm",
        variant: "on-color",
        onClick: (s) => {
          s.stopPropagation(), t == null || t();
        }
      },
      /* @__PURE__ */ y.createElement(Ne, { icon: I4 })
    )
  );
}
function NK({
  setSelectedReleaseNoteId: e
}) {
  const { isVisible: t, onClose: n } = SK(), { leadUuid: r, setIsReleaseNotesOpen: i } = Re(kt), { data: o, isLoading: a } = wK(
    {
      personUuid: r
    }
  ), [s, c] = ue("loading");
  _e(() => {
    a || s !== "loading" || c(o ? "lead-questions" : "starting-questions");
  }, [s, o, a]);
  function f() {
    c("starting-questions");
  }
  const p = o ? yK(o) : void 0;
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-mx-auto ai-tw-flex ai-tw-h-full ai-tw-min-h-0 ai-tw-min-w-full ai-tw-flex-1 ai-tw-grow ai-tw-flex-col ai-tw-items-center ai-tw-px-3 ai-tw-py-2" }, /* @__PURE__ */ y.createElement(Br, null, t ? /* @__PURE__ */ y.createElement(
    DK,
    {
      className: "ai-tw-mx-2 ai-tw-w-full",
      onLearnMore: (d) => {
        i(!0), n(), e(d);
      },
      onClose: n
    }
  ) : null), s === "loading" ? /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-h-full ai-tw-flex-col ai-tw-items-center ai-tw-justify-center" }, /* @__PURE__ */ y.createElement(bn, { size: "small" })) : null, s !== "loading" ? /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-flex-col ai-tw-items-center ai-tw-pt-4" }, /* @__PURE__ */ y.createElement("div", { className: "ai-tw-mb-2" }, /* @__PURE__ */ y.createElement(Sv, { width: 79, height: 15 })), /* @__PURE__ */ y.createElement("p", { className: "ai-tw-mb-4 ai-tw-flex-initial ai-tw-text-center ai-tw-text-content-primary ai-tw-subtitle-md" }, "What would you like help with?"), p ? /* @__PURE__ */ y.createElement(
    _v,
    {
      active: s === "lead-questions",
      className: "ai-tw-mb-8",
      icon: /* @__PURE__ */ y.createElement(Ne, { icon: M4 }),
      label: `Ask about ${p}`,
      onClick: () => c("lead-questions")
    }
  ) : null) : null, /* @__PURE__ */ y.createElement(Br, null, s === "lead-questions" && p ? /* @__PURE__ */ y.createElement(
    nf,
    {
      hidden: { y: 10 },
      visible: { y: 0 },
      exit: { display: "none" },
      className: "ai-tw-flex ai-tw-min-h-0 ai-tw-flex-col"
    },
    /* @__PURE__ */ y.createElement(
      PK,
      {
        leadFullName: p,
        onMoreCategoriesClick: f
      }
    )
  ) : null), /* @__PURE__ */ y.createElement(Br, null, s === "starting-questions" ? /* @__PURE__ */ y.createElement(
    nf,
    {
      hidden: { y: -10 },
      visible: { y: 0 },
      exit: { display: "none" },
      className: "ai-tw-flex ai-tw-min-h-0 ai-tw-flex-col"
    },
    /* @__PURE__ */ y.createElement(MK, null)
  ) : null));
}
const Rl = ln(null);
function IK(e) {
  if (!e)
    return 0;
  const [t, n, r] = e.split(":").map(Number);
  return t * 3600 + n * 60 + r;
}
function cS(e, t) {
  return t ? `${e}#t=${t}` : e;
}
function uS({
  href: e,
  node: t,
  sourceID: n,
  src: r,
  timestamp: i
}) {
  const o = i ? `at timestamp ${i}` : "";
  return /* @__PURE__ */ y.createElement(
    $v,
    {
      className: "ai-tw-inline-block ai-tw-whitespace-nowrap ai-tw-no-underline",
      node: t,
      id: r,
      href: e
    },
    "[",
    n,
    ": watch from ",
    o,
    "]."
  );
}
function LK({
  node: e,
  sourceID: t,
  src: n
}) {
  const { metadata: r } = Re(Rl) || {}, i = xC(r, t), o = cS(n, i);
  return /* @__PURE__ */ y.createElement(
    uS,
    {
      node: e,
      sourceID: t,
      src: n,
      timestamp: i,
      href: o
    }
  );
}
function FK(e) {
  if (!e)
    return 0;
  const [t, n, r] = e.split(":").map(Number);
  return t * 3600 + n * 60 + r;
}
function zK(e, t) {
  if (!t)
    return e;
  const n = new URL(e);
  return n.searchParams.set("t", FK(t).toString()), n.toString();
}
function VK({
  sourceContentSource: e,
  src: t,
  timestamp: n
}) {
  switch (e) {
    case "Brivity":
    case "Our Place":
      return cS(t, n);
    case "YouTube":
      return zK(t, n);
  }
}
function BK({
  node: e,
  citationID: t,
  src: n
}) {
  const { metadata: r, sources: i } = Re(Rl) || {}, o = oq(
    r,
    t
  ), a = iq(r, t), s = i && a ? CC(i, a) : void 0, c = s ? ed(s) : null, f = c ? VK({
    sourceContentSource: c,
    src: n,
    timestamp: o
  }) : void 0;
  return f ? /* @__PURE__ */ y.createElement(
    uS,
    {
      node: e,
      sourceID: a,
      src: n,
      timestamp: o,
      href: f
    }
  ) : null;
}
function HK() {
  const e = 1.7777777777777777;
  try {
    const [t, n] = "16:9".split(":").map(Number);
    return isNaN(t) || isNaN(n) || n === 0 ? e : t / n;
  } catch {
    return e;
  }
}
function og(e) {
  switch (e) {
    case "Brivity":
      return "BRIVITY KNOWLEDGE CENTER";
    case "Our Place":
      return "OUR PLACE";
    default:
      return e;
  }
}
var ag = { exports: {} }, eu = { exports: {} }, ht = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Y2;
function UK() {
  if (Y2)
    return ht;
  Y2 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, w = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
  function S(T) {
    if (typeof T == "object" && T !== null) {
      var P = T.$$typeof;
      switch (P) {
        case t:
          switch (T = T.type, T) {
            case c:
            case f:
            case r:
            case o:
            case i:
            case d:
              return T;
            default:
              switch (T = T && T.$$typeof, T) {
                case s:
                case p:
                case v:
                case m:
                case a:
                  return T;
                default:
                  return P;
              }
          }
        case n:
          return P;
      }
    }
  }
  function _(T) {
    return S(T) === f;
  }
  return ht.AsyncMode = c, ht.ConcurrentMode = f, ht.ContextConsumer = s, ht.ContextProvider = a, ht.Element = t, ht.ForwardRef = p, ht.Fragment = r, ht.Lazy = v, ht.Memo = m, ht.Portal = n, ht.Profiler = o, ht.StrictMode = i, ht.Suspense = d, ht.isAsyncMode = function(T) {
    return _(T) || S(T) === c;
  }, ht.isConcurrentMode = _, ht.isContextConsumer = function(T) {
    return S(T) === s;
  }, ht.isContextProvider = function(T) {
    return S(T) === a;
  }, ht.isElement = function(T) {
    return typeof T == "object" && T !== null && T.$$typeof === t;
  }, ht.isForwardRef = function(T) {
    return S(T) === p;
  }, ht.isFragment = function(T) {
    return S(T) === r;
  }, ht.isLazy = function(T) {
    return S(T) === v;
  }, ht.isMemo = function(T) {
    return S(T) === m;
  }, ht.isPortal = function(T) {
    return S(T) === n;
  }, ht.isProfiler = function(T) {
    return S(T) === o;
  }, ht.isStrictMode = function(T) {
    return S(T) === i;
  }, ht.isSuspense = function(T) {
    return S(T) === d;
  }, ht.isValidElementType = function(T) {
    return typeof T == "string" || typeof T == "function" || T === r || T === f || T === o || T === i || T === d || T === h || typeof T == "object" && T !== null && (T.$$typeof === v || T.$$typeof === m || T.$$typeof === a || T.$$typeof === s || T.$$typeof === p || T.$$typeof === b || T.$$typeof === E || T.$$typeof === C || T.$$typeof === w);
  }, ht.typeOf = S, ht;
}
var mt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var K2;
function WK() {
  return K2 || (K2 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, w = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
    function S(se) {
      return typeof se == "string" || typeof se == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      se === r || se === f || se === o || se === i || se === d || se === h || typeof se == "object" && se !== null && (se.$$typeof === v || se.$$typeof === m || se.$$typeof === a || se.$$typeof === s || se.$$typeof === p || se.$$typeof === b || se.$$typeof === E || se.$$typeof === C || se.$$typeof === w);
    }
    function _(se) {
      if (typeof se == "object" && se !== null) {
        var Le = se.$$typeof;
        switch (Le) {
          case t:
            var xe = se.type;
            switch (xe) {
              case c:
              case f:
              case r:
              case o:
              case i:
              case d:
                return xe;
              default:
                var Ue = xe && xe.$$typeof;
                switch (Ue) {
                  case s:
                  case p:
                  case v:
                  case m:
                  case a:
                    return Ue;
                  default:
                    return Le;
                }
            }
          case n:
            return Le;
        }
      }
    }
    var T = c, P = f, R = s, N = a, B = t, L = p, j = r, I = v, z = m, H = n, G = o, Y = i, ne = d, J = !1;
    function ee(se) {
      return J || (J = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), A(se) || _(se) === c;
    }
    function A(se) {
      return _(se) === f;
    }
    function X(se) {
      return _(se) === s;
    }
    function fe(se) {
      return _(se) === a;
    }
    function M(se) {
      return typeof se == "object" && se !== null && se.$$typeof === t;
    }
    function Z(se) {
      return _(se) === p;
    }
    function ie(se) {
      return _(se) === r;
    }
    function pe(se) {
      return _(se) === v;
    }
    function Te(se) {
      return _(se) === m;
    }
    function ke(se) {
      return _(se) === n;
    }
    function me(se) {
      return _(se) === o;
    }
    function Pe(se) {
      return _(se) === i;
    }
    function ct(se) {
      return _(se) === d;
    }
    mt.AsyncMode = T, mt.ConcurrentMode = P, mt.ContextConsumer = R, mt.ContextProvider = N, mt.Element = B, mt.ForwardRef = L, mt.Fragment = j, mt.Lazy = I, mt.Memo = z, mt.Portal = H, mt.Profiler = G, mt.StrictMode = Y, mt.Suspense = ne, mt.isAsyncMode = ee, mt.isConcurrentMode = A, mt.isContextConsumer = X, mt.isContextProvider = fe, mt.isElement = M, mt.isForwardRef = Z, mt.isFragment = ie, mt.isLazy = pe, mt.isMemo = Te, mt.isPortal = ke, mt.isProfiler = me, mt.isStrictMode = Pe, mt.isSuspense = ct, mt.isValidElementType = S, mt.typeOf = _;
  }()), mt;
}
var X2;
function fS() {
  return X2 || (X2 = 1, process.env.NODE_ENV === "production" ? eu.exports = UK() : eu.exports = WK()), eu.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var vh, Q2;
function jK() {
  if (Q2)
    return vh;
  Q2 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(a).map(function(p) {
        return a[p];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var f = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(p) {
        f[p] = p;
      }), Object.keys(Object.assign({}, f)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return vh = i() ? Object.assign : function(o, a) {
    for (var s, c = r(o), f, p = 1; p < arguments.length; p++) {
      s = Object(arguments[p]);
      for (var d in s)
        t.call(s, d) && (c[d] = s[d]);
      if (e) {
        f = e(s);
        for (var h = 0; h < f.length; h++)
          n.call(s, f[h]) && (c[f[h]] = s[f[h]]);
      }
    }
    return c;
  }, vh;
}
var wh, Z2;
function Tv() {
  if (Z2)
    return wh;
  Z2 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return wh = e, wh;
}
var yh, J2;
function dS() {
  return J2 || (J2 = 1, yh = Function.call.bind(Object.prototype.hasOwnProperty)), yh;
}
var bh, e3;
function qK() {
  if (e3)
    return bh;
  e3 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Tv(), n = {}, r = dS();
    e = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, s, c, f) {
    if (process.env.NODE_ENV !== "production") {
      for (var p in o)
        if (r(o, p)) {
          var d;
          try {
            if (typeof o[p] != "function") {
              var h = Error(
                (c || "React class") + ": " + s + " type `" + p + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[p] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            d = o[p](a, p, c, s, null, t);
          } catch (v) {
            d = v;
          }
          if (d && !(d instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + p + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var m = f ? f() : "";
            e(
              "Failed " + s + " type: " + d.message + (m ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, bh = i, bh;
}
var xh, t3;
function GK() {
  if (t3)
    return xh;
  t3 = 1;
  var e = fS(), t = jK(), n = Tv(), r = dS(), i = qK(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return xh = function(s, c) {
    var f = typeof Symbol == "function" && Symbol.iterator, p = "@@iterator";
    function d(A) {
      var X = A && (f && A[f] || A[p]);
      if (typeof X == "function")
        return X;
    }
    var h = "<<anonymous>>", m = {
      array: E("array"),
      bigint: E("bigint"),
      bool: E("boolean"),
      func: E("function"),
      number: E("number"),
      object: E("object"),
      string: E("string"),
      symbol: E("symbol"),
      any: C(),
      arrayOf: S,
      element: _(),
      elementType: T(),
      instanceOf: P,
      node: L(),
      objectOf: N,
      oneOf: R,
      oneOfType: B,
      shape: I,
      exact: z
    };
    function v(A, X) {
      return A === X ? A !== 0 || 1 / A === 1 / X : A !== A && X !== X;
    }
    function w(A, X) {
      this.message = A, this.data = X && typeof X == "object" ? X : {}, this.stack = "";
    }
    w.prototype = Error.prototype;
    function b(A) {
      if (process.env.NODE_ENV !== "production")
        var X = {}, fe = 0;
      function M(ie, pe, Te, ke, me, Pe, ct) {
        if (ke = ke || h, Pe = Pe || Te, ct !== n) {
          if (c) {
            var se = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw se.name = "Invariant Violation", se;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Le = ke + ":" + Te;
            !X[Le] && // Avoid spamming the console because they are often not actionable except for lib authors
            fe < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + Pe + "` prop on `" + ke + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), X[Le] = !0, fe++);
          }
        }
        return pe[Te] == null ? ie ? pe[Te] === null ? new w("The " + me + " `" + Pe + "` is marked as required " + ("in `" + ke + "`, but its value is `null`.")) : new w("The " + me + " `" + Pe + "` is marked as required in " + ("`" + ke + "`, but its value is `undefined`.")) : null : A(pe, Te, ke, me, Pe);
      }
      var Z = M.bind(null, !1);
      return Z.isRequired = M.bind(null, !0), Z;
    }
    function E(A) {
      function X(fe, M, Z, ie, pe, Te) {
        var ke = fe[M], me = Y(ke);
        if (me !== A) {
          var Pe = ne(ke);
          return new w(
            "Invalid " + ie + " `" + pe + "` of type " + ("`" + Pe + "` supplied to `" + Z + "`, expected ") + ("`" + A + "`."),
            { expectedType: A }
          );
        }
        return null;
      }
      return b(X);
    }
    function C() {
      return b(a);
    }
    function S(A) {
      function X(fe, M, Z, ie, pe) {
        if (typeof A != "function")
          return new w("Property `" + pe + "` of component `" + Z + "` has invalid PropType notation inside arrayOf.");
        var Te = fe[M];
        if (!Array.isArray(Te)) {
          var ke = Y(Te);
          return new w("Invalid " + ie + " `" + pe + "` of type " + ("`" + ke + "` supplied to `" + Z + "`, expected an array."));
        }
        for (var me = 0; me < Te.length; me++) {
          var Pe = A(Te, me, Z, ie, pe + "[" + me + "]", n);
          if (Pe instanceof Error)
            return Pe;
        }
        return null;
      }
      return b(X);
    }
    function _() {
      function A(X, fe, M, Z, ie) {
        var pe = X[fe];
        if (!s(pe)) {
          var Te = Y(pe);
          return new w("Invalid " + Z + " `" + ie + "` of type " + ("`" + Te + "` supplied to `" + M + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(A);
    }
    function T() {
      function A(X, fe, M, Z, ie) {
        var pe = X[fe];
        if (!e.isValidElementType(pe)) {
          var Te = Y(pe);
          return new w("Invalid " + Z + " `" + ie + "` of type " + ("`" + Te + "` supplied to `" + M + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(A);
    }
    function P(A) {
      function X(fe, M, Z, ie, pe) {
        if (!(fe[M] instanceof A)) {
          var Te = A.name || h, ke = ee(fe[M]);
          return new w("Invalid " + ie + " `" + pe + "` of type " + ("`" + ke + "` supplied to `" + Z + "`, expected ") + ("instance of `" + Te + "`."));
        }
        return null;
      }
      return b(X);
    }
    function R(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function X(fe, M, Z, ie, pe) {
        for (var Te = fe[M], ke = 0; ke < A.length; ke++)
          if (v(Te, A[ke]))
            return null;
        var me = JSON.stringify(A, function(ct, se) {
          var Le = ne(se);
          return Le === "symbol" ? String(se) : se;
        });
        return new w("Invalid " + ie + " `" + pe + "` of value `" + String(Te) + "` " + ("supplied to `" + Z + "`, expected one of " + me + "."));
      }
      return b(X);
    }
    function N(A) {
      function X(fe, M, Z, ie, pe) {
        if (typeof A != "function")
          return new w("Property `" + pe + "` of component `" + Z + "` has invalid PropType notation inside objectOf.");
        var Te = fe[M], ke = Y(Te);
        if (ke !== "object")
          return new w("Invalid " + ie + " `" + pe + "` of type " + ("`" + ke + "` supplied to `" + Z + "`, expected an object."));
        for (var me in Te)
          if (r(Te, me)) {
            var Pe = A(Te, me, Z, ie, pe + "." + me, n);
            if (Pe instanceof Error)
              return Pe;
          }
        return null;
      }
      return b(X);
    }
    function B(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var X = 0; X < A.length; X++) {
        var fe = A[X];
        if (typeof fe != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + J(fe) + " at index " + X + "."
          ), a;
      }
      function M(Z, ie, pe, Te, ke) {
        for (var me = [], Pe = 0; Pe < A.length; Pe++) {
          var ct = A[Pe], se = ct(Z, ie, pe, Te, ke, n);
          if (se == null)
            return null;
          se.data && r(se.data, "expectedType") && me.push(se.data.expectedType);
        }
        var Le = me.length > 0 ? ", expected one of type [" + me.join(", ") + "]" : "";
        return new w("Invalid " + Te + " `" + ke + "` supplied to " + ("`" + pe + "`" + Le + "."));
      }
      return b(M);
    }
    function L() {
      function A(X, fe, M, Z, ie) {
        return H(X[fe]) ? null : new w("Invalid " + Z + " `" + ie + "` supplied to " + ("`" + M + "`, expected a ReactNode."));
      }
      return b(A);
    }
    function j(A, X, fe, M, Z) {
      return new w(
        (A || "React class") + ": " + X + " type `" + fe + "." + M + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Z + "`."
      );
    }
    function I(A) {
      function X(fe, M, Z, ie, pe) {
        var Te = fe[M], ke = Y(Te);
        if (ke !== "object")
          return new w("Invalid " + ie + " `" + pe + "` of type `" + ke + "` " + ("supplied to `" + Z + "`, expected `object`."));
        for (var me in A) {
          var Pe = A[me];
          if (typeof Pe != "function")
            return j(Z, ie, pe, me, ne(Pe));
          var ct = Pe(Te, me, Z, ie, pe + "." + me, n);
          if (ct)
            return ct;
        }
        return null;
      }
      return b(X);
    }
    function z(A) {
      function X(fe, M, Z, ie, pe) {
        var Te = fe[M], ke = Y(Te);
        if (ke !== "object")
          return new w("Invalid " + ie + " `" + pe + "` of type `" + ke + "` " + ("supplied to `" + Z + "`, expected `object`."));
        var me = t({}, fe[M], A);
        for (var Pe in me) {
          var ct = A[Pe];
          if (r(A, Pe) && typeof ct != "function")
            return j(Z, ie, pe, Pe, ne(ct));
          if (!ct)
            return new w(
              "Invalid " + ie + " `" + pe + "` key `" + Pe + "` supplied to `" + Z + "`.\nBad object: " + JSON.stringify(fe[M], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(A), null, "  ")
            );
          var se = ct(Te, Pe, Z, ie, pe + "." + Pe, n);
          if (se)
            return se;
        }
        return null;
      }
      return b(X);
    }
    function H(A) {
      switch (typeof A) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !A;
        case "object":
          if (Array.isArray(A))
            return A.every(H);
          if (A === null || s(A))
            return !0;
          var X = d(A);
          if (X) {
            var fe = X.call(A), M;
            if (X !== A.entries) {
              for (; !(M = fe.next()).done; )
                if (!H(M.value))
                  return !1;
            } else
              for (; !(M = fe.next()).done; ) {
                var Z = M.value;
                if (Z && !H(Z[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function G(A, X) {
      return A === "symbol" ? !0 : X ? X["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && X instanceof Symbol : !1;
    }
    function Y(A) {
      var X = typeof A;
      return Array.isArray(A) ? "array" : A instanceof RegExp ? "object" : G(X, A) ? "symbol" : X;
    }
    function ne(A) {
      if (typeof A > "u" || A === null)
        return "" + A;
      var X = Y(A);
      if (X === "object") {
        if (A instanceof Date)
          return "date";
        if (A instanceof RegExp)
          return "regexp";
      }
      return X;
    }
    function J(A) {
      var X = ne(A);
      switch (X) {
        case "array":
        case "object":
          return "an " + X;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + X;
        default:
          return X;
      }
    }
    function ee(A) {
      return !A.constructor || !A.constructor.name ? h : A.constructor.name;
    }
    return m.checkPropTypes = i, m.resetWarningCache = i.resetWarningCache, m.PropTypes = m, m;
  }, xh;
}
var Eh, n3;
function YK() {
  if (n3)
    return Eh;
  n3 = 1;
  var e = Tv();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Eh = function() {
    function r(a, s, c, f, p, d) {
      if (d !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, Eh;
}
if (process.env.NODE_ENV !== "production") {
  var KK = fS(), XK = !0;
  ag.exports = GK()(KK.isElement, XK);
} else
  ag.exports = YK()();
var kv = ag.exports;
const ye = /* @__PURE__ */ fo(kv);
/*! @vimeo/player v2.26.0 | (c) 2025 Vimeo | MIT License | https://github.com/vimeo/player.js */
function r3(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function i3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? r3(Object(n), !0).forEach(function(r) {
      Eu(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r3(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function kn() {
  kn = function() {
    return e;
  };
  var e = {}, t = Object.prototype, n = t.hasOwnProperty, r = Object.defineProperty || function(I, z, H) {
    I[z] = H.value;
  }, i = typeof Symbol == "function" ? Symbol : {}, o = i.iterator || "@@iterator", a = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
  function c(I, z, H) {
    return Object.defineProperty(I, z, {
      value: H,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), I[z];
  }
  try {
    c({}, "");
  } catch {
    c = function(z, H, G) {
      return z[H] = G;
    };
  }
  function f(I, z, H, G) {
    var Y = z && z.prototype instanceof h ? z : h, ne = Object.create(Y.prototype), J = new B(G || []);
    return r(ne, "_invoke", {
      value: T(I, H, J)
    }), ne;
  }
  function p(I, z, H) {
    try {
      return {
        type: "normal",
        arg: I.call(z, H)
      };
    } catch (G) {
      return {
        type: "throw",
        arg: G
      };
    }
  }
  e.wrap = f;
  var d = {};
  function h() {
  }
  function m() {
  }
  function v() {
  }
  var w = {};
  c(w, o, function() {
    return this;
  });
  var b = Object.getPrototypeOf, E = b && b(b(L([])));
  E && E !== t && n.call(E, o) && (w = E);
  var C = v.prototype = h.prototype = Object.create(w);
  function S(I) {
    ["next", "throw", "return"].forEach(function(z) {
      c(I, z, function(H) {
        return this._invoke(z, H);
      });
    });
  }
  function _(I, z) {
    function H(Y, ne, J, ee) {
      var A = p(I[Y], I, ne);
      if (A.type !== "throw") {
        var X = A.arg, fe = X.value;
        return fe && typeof fe == "object" && n.call(fe, "__await") ? z.resolve(fe.__await).then(function(M) {
          H("next", M, J, ee);
        }, function(M) {
          H("throw", M, J, ee);
        }) : z.resolve(fe).then(function(M) {
          X.value = M, J(X);
        }, function(M) {
          return H("throw", M, J, ee);
        });
      }
      ee(A.arg);
    }
    var G;
    r(this, "_invoke", {
      value: function(Y, ne) {
        function J() {
          return new z(function(ee, A) {
            H(Y, ne, ee, A);
          });
        }
        return G = G ? G.then(J, J) : J();
      }
    });
  }
  function T(I, z, H) {
    var G = "suspendedStart";
    return function(Y, ne) {
      if (G === "executing")
        throw new Error("Generator is already running");
      if (G === "completed") {
        if (Y === "throw")
          throw ne;
        return j();
      }
      for (H.method = Y, H.arg = ne; ; ) {
        var J = H.delegate;
        if (J) {
          var ee = P(J, H);
          if (ee) {
            if (ee === d)
              continue;
            return ee;
          }
        }
        if (H.method === "next")
          H.sent = H._sent = H.arg;
        else if (H.method === "throw") {
          if (G === "suspendedStart")
            throw G = "completed", H.arg;
          H.dispatchException(H.arg);
        } else
          H.method === "return" && H.abrupt("return", H.arg);
        G = "executing";
        var A = p(I, z, H);
        if (A.type === "normal") {
          if (G = H.done ? "completed" : "suspendedYield", A.arg === d)
            continue;
          return {
            value: A.arg,
            done: H.done
          };
        }
        A.type === "throw" && (G = "completed", H.method = "throw", H.arg = A.arg);
      }
    };
  }
  function P(I, z) {
    var H = z.method, G = I.iterator[H];
    if (G === void 0)
      return z.delegate = null, H === "throw" && I.iterator.return && (z.method = "return", z.arg = void 0, P(I, z), z.method === "throw") || H !== "return" && (z.method = "throw", z.arg = new TypeError("The iterator does not provide a '" + H + "' method")), d;
    var Y = p(G, I.iterator, z.arg);
    if (Y.type === "throw")
      return z.method = "throw", z.arg = Y.arg, z.delegate = null, d;
    var ne = Y.arg;
    return ne ? ne.done ? (z[I.resultName] = ne.value, z.next = I.nextLoc, z.method !== "return" && (z.method = "next", z.arg = void 0), z.delegate = null, d) : ne : (z.method = "throw", z.arg = new TypeError("iterator result is not an object"), z.delegate = null, d);
  }
  function R(I) {
    var z = {
      tryLoc: I[0]
    };
    1 in I && (z.catchLoc = I[1]), 2 in I && (z.finallyLoc = I[2], z.afterLoc = I[3]), this.tryEntries.push(z);
  }
  function N(I) {
    var z = I.completion || {};
    z.type = "normal", delete z.arg, I.completion = z;
  }
  function B(I) {
    this.tryEntries = [{
      tryLoc: "root"
    }], I.forEach(R, this), this.reset(!0);
  }
  function L(I) {
    if (I) {
      var z = I[o];
      if (z)
        return z.call(I);
      if (typeof I.next == "function")
        return I;
      if (!isNaN(I.length)) {
        var H = -1, G = function Y() {
          for (; ++H < I.length; )
            if (n.call(I, H))
              return Y.value = I[H], Y.done = !1, Y;
          return Y.value = void 0, Y.done = !0, Y;
        };
        return G.next = G;
      }
    }
    return {
      next: j
    };
  }
  function j() {
    return {
      value: void 0,
      done: !0
    };
  }
  return m.prototype = v, r(C, "constructor", {
    value: v,
    configurable: !0
  }), r(v, "constructor", {
    value: m,
    configurable: !0
  }), m.displayName = c(v, s, "GeneratorFunction"), e.isGeneratorFunction = function(I) {
    var z = typeof I == "function" && I.constructor;
    return !!z && (z === m || (z.displayName || z.name) === "GeneratorFunction");
  }, e.mark = function(I) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(I, v) : (I.__proto__ = v, c(I, s, "GeneratorFunction")), I.prototype = Object.create(C), I;
  }, e.awrap = function(I) {
    return {
      __await: I
    };
  }, S(_.prototype), c(_.prototype, a, function() {
    return this;
  }), e.AsyncIterator = _, e.async = function(I, z, H, G, Y) {
    Y === void 0 && (Y = Promise);
    var ne = new _(f(I, z, H, G), Y);
    return e.isGeneratorFunction(z) ? ne : ne.next().then(function(J) {
      return J.done ? J.value : ne.next();
    });
  }, S(C), c(C, s, "Generator"), c(C, o, function() {
    return this;
  }), c(C, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(I) {
    var z = Object(I), H = [];
    for (var G in z)
      H.push(G);
    return H.reverse(), function Y() {
      for (; H.length; ) {
        var ne = H.pop();
        if (ne in z)
          return Y.value = ne, Y.done = !1, Y;
      }
      return Y.done = !0, Y;
    };
  }, e.values = L, B.prototype = {
    constructor: B,
    reset: function(I) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(N), !I)
        for (var z in this)
          z.charAt(0) === "t" && n.call(this, z) && !isNaN(+z.slice(1)) && (this[z] = void 0);
    },
    stop: function() {
      this.done = !0;
      var I = this.tryEntries[0].completion;
      if (I.type === "throw")
        throw I.arg;
      return this.rval;
    },
    dispatchException: function(I) {
      if (this.done)
        throw I;
      var z = this;
      function H(A, X) {
        return ne.type = "throw", ne.arg = I, z.next = A, X && (z.method = "next", z.arg = void 0), !!X;
      }
      for (var G = this.tryEntries.length - 1; G >= 0; --G) {
        var Y = this.tryEntries[G], ne = Y.completion;
        if (Y.tryLoc === "root")
          return H("end");
        if (Y.tryLoc <= this.prev) {
          var J = n.call(Y, "catchLoc"), ee = n.call(Y, "finallyLoc");
          if (J && ee) {
            if (this.prev < Y.catchLoc)
              return H(Y.catchLoc, !0);
            if (this.prev < Y.finallyLoc)
              return H(Y.finallyLoc);
          } else if (J) {
            if (this.prev < Y.catchLoc)
              return H(Y.catchLoc, !0);
          } else {
            if (!ee)
              throw new Error("try statement without catch or finally");
            if (this.prev < Y.finallyLoc)
              return H(Y.finallyLoc);
          }
        }
      }
    },
    abrupt: function(I, z) {
      for (var H = this.tryEntries.length - 1; H >= 0; --H) {
        var G = this.tryEntries[H];
        if (G.tryLoc <= this.prev && n.call(G, "finallyLoc") && this.prev < G.finallyLoc) {
          var Y = G;
          break;
        }
      }
      Y && (I === "break" || I === "continue") && Y.tryLoc <= z && z <= Y.finallyLoc && (Y = null);
      var ne = Y ? Y.completion : {};
      return ne.type = I, ne.arg = z, Y ? (this.method = "next", this.next = Y.finallyLoc, d) : this.complete(ne);
    },
    complete: function(I, z) {
      if (I.type === "throw")
        throw I.arg;
      return I.type === "break" || I.type === "continue" ? this.next = I.arg : I.type === "return" ? (this.rval = this.arg = I.arg, this.method = "return", this.next = "end") : I.type === "normal" && z && (this.next = z), d;
    },
    finish: function(I) {
      for (var z = this.tryEntries.length - 1; z >= 0; --z) {
        var H = this.tryEntries[z];
        if (H.finallyLoc === I)
          return this.complete(H.completion, H.afterLoc), N(H), d;
      }
    },
    catch: function(I) {
      for (var z = this.tryEntries.length - 1; z >= 0; --z) {
        var H = this.tryEntries[z];
        if (H.tryLoc === I) {
          var G = H.completion;
          if (G.type === "throw") {
            var Y = G.arg;
            N(H);
          }
          return Y;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(I, z, H) {
      return this.delegate = {
        iterator: L(I),
        resultName: z,
        nextLoc: H
      }, this.method === "next" && (this.arg = void 0), d;
    }
  }, e;
}
function o3(e, t, n, r, i, o, a) {
  try {
    var s = e[o](a), c = s.value;
  } catch (f) {
    n(f);
    return;
  }
  s.done ? t(c) : Promise.resolve(c).then(r, i);
}
function Mo(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, i) {
      var o = e.apply(t, n);
      function a(c) {
        o3(o, r, i, a, s, "next", c);
      }
      function s(c) {
        o3(o, r, i, a, s, "throw", c);
      }
      a(void 0);
    });
  };
}
function pS(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function a3(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, gS(r.key), r);
  }
}
function hS(e, t, n) {
  return t && a3(e.prototype, t), n && a3(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Eu(e, t, n) {
  return t = gS(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function QK(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && ml(e, t);
}
function hl(e) {
  return hl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, hl(e);
}
function ml(e, t) {
  return ml = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, ml(e, t);
}
function mS() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Cu(e, t, n) {
  return mS() ? Cu = Reflect.construct.bind() : Cu = function(i, o, a) {
    var s = [null];
    s.push.apply(s, o);
    var c = Function.bind.apply(i, s), f = new c();
    return a && ml(f, a.prototype), f;
  }, Cu.apply(null, arguments);
}
function ZK(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function sg(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return sg = function(r) {
    if (r === null || !ZK(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r))
        return t.get(r);
      t.set(r, i);
    }
    function i() {
      return Cu(r, arguments, hl(this).constructor);
    }
    return i.prototype = Object.create(r.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), ml(i, r);
  }, sg(e);
}
function Su(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function JK(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Su(e);
}
function eX(e) {
  var t = mS();
  return function() {
    var r = hl(e), i;
    if (t) {
      var o = hl(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return JK(this, i);
  };
}
function tX(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function gS(e) {
  var t = tX(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var vS = typeof global < "u" && {}.toString.call(global) === "[object global]";
function s3(e, t) {
  return e.indexOf(t.toLowerCase()) === 0 ? e : "".concat(t.toLowerCase()).concat(e.substr(0, 1).toUpperCase()).concat(e.substr(1));
}
function nX(e) {
  return !!(e && e.nodeType === 1 && "nodeName" in e && e.ownerDocument && e.ownerDocument.defaultView);
}
function rX(e) {
  return !isNaN(parseFloat(e)) && isFinite(e) && Math.floor(e) == e;
}
function qo(e) {
  return /^(https?:)?\/\/((((player|www)\.)?vimeo\.com)|((player\.)?[a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))(?=$|\/)/.test(e);
}
function wS(e) {
  var t = /^https:\/\/player\.((vimeo\.com)|([a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))\/video\/\d+/;
  return t.test(e);
}
function iX(e) {
  for (var t = (e || "").match(/^(?:https?:)?(?:\/\/)?([^/?]+)/), n = (t && t[1] || "").replace("player.", ""), r = [".videoji.hk", ".vimeo.work", ".videoji.cn"], i = 0, o = r; i < o.length; i++) {
    var a = o[i];
    if (n.endsWith(a))
      return n;
  }
  return "vimeo.com";
}
function yS() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.id, n = e.url, r = t || n;
  if (!r)
    throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
  if (rX(r))
    return "https://vimeo.com/".concat(r);
  if (qo(r))
    return r.replace("http:", "https:");
  throw t ? new TypeError("“".concat(t, "” is not a valid video id.")) : new TypeError("“".concat(r, "” is not a vimeo.com url."));
}
var l3 = function(t, n, r) {
  var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "addEventListener", o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "removeEventListener", a = typeof n == "string" ? [n] : n;
  return a.forEach(function(s) {
    t[i](s, r);
  }), {
    cancel: function() {
      return a.forEach(function(c) {
        return t[o](c, r);
      });
    }
  };
}, oX = typeof Array.prototype.indexOf < "u", aX = typeof window < "u" && typeof window.postMessage < "u";
if (!vS && (!oX || !aX))
  throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
var Da = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function sX(e, t) {
  return t = { exports: {} }, e(t, t.exports), t.exports;
}
/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */
(function(e) {
  if (e.WeakMap)
    return;
  var t = Object.prototype.hasOwnProperty, n = Object.defineProperty && function() {
    try {
      return Object.defineProperty({}, "x", {
        value: 1
      }).x === 1;
    } catch {
    }
  }(), r = function(o, a, s) {
    n ? Object.defineProperty(o, a, {
      configurable: !0,
      writable: !0,
      value: s
    }) : o[a] = s;
  };
  e.WeakMap = function() {
    function o() {
      if (this === void 0)
        throw new TypeError("Constructor WeakMap requires 'new'");
      if (r(this, "_id", s("_WeakMap")), arguments.length > 0)
        throw new TypeError("WeakMap iterable is not supported");
    }
    r(o.prototype, "delete", function(f) {
      if (a(this, "delete"), !i(f))
        return !1;
      var p = f[this._id];
      return p && p[0] === f ? (delete f[this._id], !0) : !1;
    }), r(o.prototype, "get", function(f) {
      if (a(this, "get"), !!i(f)) {
        var p = f[this._id];
        if (p && p[0] === f)
          return p[1];
      }
    }), r(o.prototype, "has", function(f) {
      if (a(this, "has"), !i(f))
        return !1;
      var p = f[this._id];
      return !!(p && p[0] === f);
    }), r(o.prototype, "set", function(f, p) {
      if (a(this, "set"), !i(f))
        throw new TypeError("Invalid value used as weak map key");
      var d = f[this._id];
      return d && d[0] === f ? (d[1] = p, this) : (r(f, this._id, [f, p]), this);
    });
    function a(f, p) {
      if (!i(f) || !t.call(f, "_id"))
        throw new TypeError(p + " method called on incompatible receiver " + typeof f);
    }
    function s(f) {
      return f + "_" + c() + "." + c();
    }
    function c() {
      return Math.random().toString().substring(2);
    }
    return r(o, "_polyfill", !0), o;
  }();
  function i(o) {
    return Object(o) === o;
  }
})(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : Da);
var mr = sX(function(e) {
  /*! Native Promise Only
      v0.8.1 (c) Kyle Simpson
      MIT License: http://getify.mit-license.org
  */
  (function(n, r, i) {
    r[n] = r[n] || i(), e.exports && (e.exports = r[n]);
  })("Promise", Da, function() {
    var n, r, i, o = Object.prototype.toString, a = typeof setImmediate < "u" ? function(S) {
      return setImmediate(S);
    } : setTimeout;
    try {
      Object.defineProperty({}, "x", {}), n = function(S, _, T, P) {
        return Object.defineProperty(S, _, {
          value: T,
          writable: !0,
          configurable: P !== !1
        });
      };
    } catch {
      n = function(_, T, P) {
        return _[T] = P, _;
      };
    }
    i = function() {
      var S, _, T;
      function P(R, N) {
        this.fn = R, this.self = N, this.next = void 0;
      }
      return {
        add: function(N, B) {
          T = new P(N, B), _ ? _.next = T : S = T, _ = T, T = void 0;
        },
        drain: function() {
          var N = S;
          for (S = _ = r = void 0; N; )
            N.fn.call(N.self), N = N.next;
        }
      };
    }();
    function s(C, S) {
      i.add(C, S), r || (r = a(i.drain));
    }
    function c(C) {
      var S, _ = typeof C;
      return C != null && (_ == "object" || _ == "function") && (S = C.then), typeof S == "function" ? S : !1;
    }
    function f() {
      for (var C = 0; C < this.chain.length; C++)
        p(this, this.state === 1 ? this.chain[C].success : this.chain[C].failure, this.chain[C]);
      this.chain.length = 0;
    }
    function p(C, S, _) {
      var T, P;
      try {
        S === !1 ? _.reject(C.msg) : (S === !0 ? T = C.msg : T = S.call(void 0, C.msg), T === _.promise ? _.reject(TypeError("Promise-chain cycle")) : (P = c(T)) ? P.call(T, _.resolve, _.reject) : _.resolve(T));
      } catch (R) {
        _.reject(R);
      }
    }
    function d(C) {
      var S, _ = this;
      if (!_.triggered) {
        _.triggered = !0, _.def && (_ = _.def);
        try {
          (S = c(C)) ? s(function() {
            var T = new v(_);
            try {
              S.call(C, function() {
                d.apply(T, arguments);
              }, function() {
                h.apply(T, arguments);
              });
            } catch (P) {
              h.call(T, P);
            }
          }) : (_.msg = C, _.state = 1, _.chain.length > 0 && s(f, _));
        } catch (T) {
          h.call(new v(_), T);
        }
      }
    }
    function h(C) {
      var S = this;
      S.triggered || (S.triggered = !0, S.def && (S = S.def), S.msg = C, S.state = 2, S.chain.length > 0 && s(f, S));
    }
    function m(C, S, _, T) {
      for (var P = 0; P < S.length; P++)
        (function(N) {
          C.resolve(S[N]).then(function(L) {
            _(N, L);
          }, T);
        })(P);
    }
    function v(C) {
      this.def = C, this.triggered = !1;
    }
    function w(C) {
      this.promise = C, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
    }
    function b(C) {
      if (typeof C != "function")
        throw TypeError("Not a function");
      if (this.__NPO__ !== 0)
        throw TypeError("Not a promise");
      this.__NPO__ = 1;
      var S = new w(this);
      this.then = function(T, P) {
        var R = {
          success: typeof T == "function" ? T : !0,
          failure: typeof P == "function" ? P : !1
        };
        return R.promise = new this.constructor(function(B, L) {
          if (typeof B != "function" || typeof L != "function")
            throw TypeError("Not a function");
          R.resolve = B, R.reject = L;
        }), S.chain.push(R), S.state !== 0 && s(f, S), R.promise;
      }, this.catch = function(T) {
        return this.then(void 0, T);
      };
      try {
        C.call(void 0, function(T) {
          d.call(S, T);
        }, function(T) {
          h.call(S, T);
        });
      } catch (_) {
        h.call(S, _);
      }
    }
    var E = n(
      {},
      "constructor",
      b,
      /*configurable=*/
      !1
    );
    return b.prototype = E, n(
      E,
      "__NPO__",
      0,
      /*configurable=*/
      !1
    ), n(b, "resolve", function(S) {
      var _ = this;
      return S && typeof S == "object" && S.__NPO__ === 1 ? S : new _(function(P, R) {
        if (typeof P != "function" || typeof R != "function")
          throw TypeError("Not a function");
        P(S);
      });
    }), n(b, "reject", function(S) {
      return new this(function(T, P) {
        if (typeof T != "function" || typeof P != "function")
          throw TypeError("Not a function");
        P(S);
      });
    }), n(b, "all", function(S) {
      var _ = this;
      return o.call(S) != "[object Array]" ? _.reject(TypeError("Not an array")) : S.length === 0 ? _.resolve([]) : new _(function(P, R) {
        if (typeof P != "function" || typeof R != "function")
          throw TypeError("Not a function");
        var N = S.length, B = Array(N), L = 0;
        m(_, S, function(I, z) {
          B[I] = z, ++L === N && P(B);
        }, R);
      });
    }), n(b, "race", function(S) {
      var _ = this;
      return o.call(S) != "[object Array]" ? _.reject(TypeError("Not an array")) : new _(function(P, R) {
        if (typeof P != "function" || typeof R != "function")
          throw TypeError("Not a function");
        m(_, S, function(B, L) {
          P(L);
        }, R);
      });
    }), b;
  });
}), _i = /* @__PURE__ */ new WeakMap();
function Os(e, t, n) {
  var r = _i.get(e.element) || {};
  t in r || (r[t] = []), r[t].push(n), _i.set(e.element, r);
}
function rf(e, t) {
  var n = _i.get(e.element) || {};
  return n[t] || [];
}
function of(e, t, n) {
  var r = _i.get(e.element) || {};
  if (!r[t])
    return !0;
  if (!n)
    return r[t] = [], _i.set(e.element, r), !0;
  var i = r[t].indexOf(n);
  return i !== -1 && r[t].splice(i, 1), _i.set(e.element, r), r[t] && r[t].length === 0;
}
function lX(e, t) {
  var n = rf(e, t);
  if (n.length < 1)
    return !1;
  var r = n.shift();
  return of(e, t, r), r;
}
function cX(e, t) {
  var n = _i.get(e);
  _i.set(t, n), _i.delete(e);
}
function cd(e) {
  if (typeof e == "string")
    try {
      e = JSON.parse(e);
    } catch (t) {
      return console.warn(t), {};
    }
  return e;
}
function Ao(e, t, n) {
  if (!(!e.element.contentWindow || !e.element.contentWindow.postMessage)) {
    var r = {
      method: t
    };
    n !== void 0 && (r.value = n);
    var i = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
    i >= 8 && i < 10 && (r = JSON.stringify(r)), e.element.contentWindow.postMessage(r, e.origin);
  }
}
function uX(e, t) {
  t = cd(t);
  var n = [], r;
  if (t.event) {
    if (t.event === "error") {
      var i = rf(e, t.data.method);
      i.forEach(function(a) {
        var s = new Error(t.data.message);
        s.name = t.data.name, a.reject(s), of(e, t.data.method, a);
      });
    }
    n = rf(e, "event:".concat(t.event)), r = t.data;
  } else if (t.method) {
    var o = lX(e, t.method);
    o && (n.push(o), r = t.value);
  }
  n.forEach(function(a) {
    try {
      if (typeof a == "function") {
        a.call(e, r);
        return;
      }
      a.resolve(r);
    } catch {
    }
  });
}
var fX = ["airplay", "audio_tracks", "audiotrack", "autopause", "autoplay", "background", "byline", "cc", "chapter_id", "chapters", "chromecast", "color", "colors", "controls", "dnt", "end_time", "fullscreen", "height", "id", "interactive_params", "keyboard", "loop", "maxheight", "maxwidth", "muted", "play_button_position", "playsinline", "portrait", "progress_bar", "quality_selector", "responsive", "skipping_forward", "speed", "start_time", "texttrack", "title", "transcript", "transparent", "unmute_button", "url", "vimeo_logo", "volume", "watch_full_video", "width"];
function bS(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return fX.reduce(function(n, r) {
    var i = e.getAttribute("data-vimeo-".concat(r));
    return (i || i === "") && (n[r] = i === "" ? 1 : i), n;
  }, t);
}
function Pv(e, t) {
  var n = e.html;
  if (!t)
    throw new TypeError("An element must be provided");
  if (t.getAttribute("data-vimeo-initialized") !== null)
    return t.querySelector("iframe");
  var r = document.createElement("div");
  return r.innerHTML = n, t.appendChild(r.firstChild), t.setAttribute("data-vimeo-initialized", "true"), t.querySelector("iframe");
}
function xS(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0;
  return new Promise(function(r, i) {
    if (!qo(e))
      throw new TypeError("“".concat(e, "” is not a vimeo.com url."));
    var o = iX(e), a = "https://".concat(o, "/api/oembed.json?url=").concat(encodeURIComponent(e));
    for (var s in t)
      t.hasOwnProperty(s) && (a += "&".concat(s, "=").concat(encodeURIComponent(t[s])));
    var c = "XDomainRequest" in window ? new XDomainRequest() : new XMLHttpRequest();
    c.open("GET", a, !0), c.onload = function() {
      if (c.status === 404) {
        i(new Error("“".concat(e, "” was not found.")));
        return;
      }
      if (c.status === 403) {
        i(new Error("“".concat(e, "” is not embeddable.")));
        return;
      }
      try {
        var f = JSON.parse(c.responseText);
        if (f.domain_status_code === 403) {
          Pv(f, n), i(new Error("“".concat(e, "” is not embeddable.")));
          return;
        }
        r(f);
      } catch (p) {
        i(p);
      }
    }, c.onerror = function() {
      var f = c.status ? " (".concat(c.status, ")") : "";
      i(new Error("There was an error fetching the embed code from Vimeo".concat(f, ".")));
    }, c.send();
  });
}
function dX() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, t = [].slice.call(e.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")), n = function(i) {
    "console" in window && console.error && console.error("There was an error creating an embed: ".concat(i));
  };
  t.forEach(function(r) {
    try {
      if (r.getAttribute("data-vimeo-defer") !== null)
        return;
      var i = bS(r), o = yS(i);
      xS(o, i, r).then(function(a) {
        return Pv(a, r);
      }).catch(n);
    } catch (a) {
      n(a);
    }
  });
}
function pX() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoPlayerResizeEmbeds_) {
    window.VimeoPlayerResizeEmbeds_ = !0;
    var t = function(r) {
      if (qo(r.origin) && !(!r.data || r.data.event !== "spacechange")) {
        for (var i = e.querySelectorAll("iframe"), o = 0; o < i.length; o++)
          if (i[o].contentWindow === r.source) {
            var a = i[o].parentElement;
            a.style.paddingBottom = "".concat(r.data.data[0].bottom, "px");
            break;
          }
      }
    };
    window.addEventListener("message", t);
  }
}
function hX() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoSeoMetadataAppended) {
    window.VimeoSeoMetadataAppended = !0;
    var t = function(r) {
      if (qo(r.origin)) {
        var i = cd(r.data);
        if (!(!i || i.event !== "ready"))
          for (var o = e.querySelectorAll("iframe"), a = 0; a < o.length; a++) {
            var s = o[a], c = s.contentWindow === r.source;
            if (wS(s.src) && c) {
              var f = new Av(s);
              f.callMethod("appendVideoMetadata", window.location.href);
            }
          }
      }
    };
    window.addEventListener("message", t);
  }
}
function mX() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoCheckedUrlTimeParam) {
    window.VimeoCheckedUrlTimeParam = !0;
    var t = function(i) {
      "console" in window && console.error && console.error("There was an error getting video Id: ".concat(i));
    }, n = function(i) {
      if (qo(i.origin)) {
        var o = cd(i.data);
        if (!(!o || o.event !== "ready"))
          for (var a = e.querySelectorAll("iframe"), s = function() {
            var p = a[c], d = p.contentWindow === i.source;
            if (wS(p.src) && d) {
              var h = new Av(p);
              h.getVideoId().then(function(m) {
                var v = new RegExp("[?&]vimeo_t_".concat(m, "=([^&#]*)")).exec(window.location.href);
                if (v && v[1]) {
                  var w = decodeURI(v[1]);
                  h.setCurrentTime(w);
                }
              }).catch(t);
            }
          }, c = 0; c < a.length; c++)
            s();
      }
    };
    window.addEventListener("message", n);
  }
}
function gX() {
  var e = function() {
    for (var r, i = [
      ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"],
      // New WebKit
      ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"],
      // Old WebKit
      ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
      ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
      ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]
    ], o = 0, a = i.length, s = {}; o < a; o++)
      if (r = i[o], r && r[1] in document) {
        for (o = 0; o < r.length; o++)
          s[i[0][o]] = r[o];
        return s;
      }
    return !1;
  }(), t = {
    fullscreenchange: e.fullscreenchange,
    fullscreenerror: e.fullscreenerror
  }, n = {
    request: function(i) {
      return new Promise(function(o, a) {
        var s = function f() {
          n.off("fullscreenchange", f), o();
        };
        n.on("fullscreenchange", s), i = i || document.documentElement;
        var c = i[e.requestFullscreen]();
        c instanceof Promise && c.then(s).catch(a);
      });
    },
    exit: function() {
      return new Promise(function(i, o) {
        if (!n.isFullscreen) {
          i();
          return;
        }
        var a = function c() {
          n.off("fullscreenchange", c), i();
        };
        n.on("fullscreenchange", a);
        var s = document[e.exitFullscreen]();
        s instanceof Promise && s.then(a).catch(o);
      });
    },
    on: function(i, o) {
      var a = t[i];
      a && document.addEventListener(a, o);
    },
    off: function(i, o) {
      var a = t[i];
      a && document.removeEventListener(a, o);
    }
  };
  return Object.defineProperties(n, {
    isFullscreen: {
      get: function() {
        return !!document[e.fullscreenElement];
      }
    },
    element: {
      enumerable: !0,
      get: function() {
        return document[e.fullscreenElement];
      }
    },
    isEnabled: {
      enumerable: !0,
      get: function() {
        return !!document[e.fullscreenEnabled];
      }
    }
  }), n;
}
var vX = {
  role: "viewer",
  autoPlayMuted: !0,
  allowedDrift: 0.3,
  maxAllowedDrift: 1,
  minCheckInterval: 0.1,
  maxRateAdjustment: 0.2,
  maxTimeToCatchUp: 1
}, wX = /* @__PURE__ */ function(e) {
  QK(n, e);
  var t = eX(n);
  function n(r, i) {
    var o, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
    return pS(this, n), o = t.call(this), Eu(Su(o), "logger", void 0), Eu(Su(o), "speedAdjustment", 0), Eu(Su(o), "adjustSpeed", /* @__PURE__ */ function() {
      var c = Mo(/* @__PURE__ */ kn().mark(function f(p, d) {
        var h;
        return kn().wrap(function(v) {
          for (; ; )
            switch (v.prev = v.next) {
              case 0:
                if (o.speedAdjustment !== d) {
                  v.next = 2;
                  break;
                }
                return v.abrupt("return");
              case 2:
                return v.next = 4, p.getPlaybackRate();
              case 4:
                return v.t0 = v.sent, v.t1 = o.speedAdjustment, v.t2 = v.t0 - v.t1, v.t3 = d, h = v.t2 + v.t3, o.log("New playbackRate:  ".concat(h)), v.next = 12, p.setPlaybackRate(h);
              case 12:
                o.speedAdjustment = d;
              case 13:
              case "end":
                return v.stop();
            }
        }, f);
      }));
      return function(f, p) {
        return c.apply(this, arguments);
      };
    }()), o.logger = s, o.init(i, r, i3(i3({}, vX), a)), o;
  }
  return hS(n, [{
    key: "disconnect",
    value: function() {
      this.dispatchEvent(new Event("disconnect"));
    }
    /**
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "init",
    value: function() {
      var r = Mo(/* @__PURE__ */ kn().mark(function o(a, s, c) {
        var f = this, p, d, h;
        return kn().wrap(function(v) {
          for (; ; )
            switch (v.prev = v.next) {
              case 0:
                return v.next = 2, this.waitForTOReadyState(a, "open");
              case 2:
                if (c.role !== "viewer") {
                  v.next = 10;
                  break;
                }
                return v.next = 5, this.updatePlayer(a, s, c);
              case 5:
                p = l3(a, "change", function() {
                  return f.updatePlayer(a, s, c);
                }), d = this.maintainPlaybackPosition(a, s, c), this.addEventListener("disconnect", function() {
                  d.cancel(), p.cancel();
                }), v.next = 14;
                break;
              case 10:
                return v.next = 12, this.updateTimingObject(a, s);
              case 12:
                h = l3(s, ["seeked", "play", "pause", "ratechange"], function() {
                  return f.updateTimingObject(a, s);
                }, "on", "off"), this.addEventListener("disconnect", function() {
                  return h.cancel();
                });
              case 14:
              case "end":
                return v.stop();
            }
        }, o, this);
      }));
      function i(o, a, s) {
        return r.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Sets the TimingObject's state to reflect that of the player
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @return {Promise<void>}
     */
  }, {
    key: "updateTimingObject",
    value: function() {
      var r = Mo(/* @__PURE__ */ kn().mark(function o(a, s) {
        return kn().wrap(function(f) {
          for (; ; )
            switch (f.prev = f.next) {
              case 0:
                return f.t0 = a, f.next = 3, s.getCurrentTime();
              case 3:
                return f.t1 = f.sent, f.next = 6, s.getPaused();
              case 6:
                if (!f.sent) {
                  f.next = 10;
                  break;
                }
                f.t2 = 0, f.next = 13;
                break;
              case 10:
                return f.next = 12, s.getPlaybackRate();
              case 12:
                f.t2 = f.sent;
              case 13:
                f.t3 = f.t2, f.t4 = {
                  position: f.t1,
                  velocity: f.t3
                }, f.t0.update.call(f.t0, f.t4);
              case 16:
              case "end":
                return f.stop();
            }
        }, o);
      }));
      function i(o, a) {
        return r.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Sets the player's timing state to reflect that of the TimingObject
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "updatePlayer",
    value: function() {
      var r = Mo(/* @__PURE__ */ kn().mark(function o(a, s, c) {
        var f, p, d;
        return kn().wrap(function(m) {
          for (; ; )
            switch (m.prev = m.next) {
              case 0:
                if (f = a.query(), p = f.position, d = f.velocity, typeof p == "number" && s.setCurrentTime(p), typeof d != "number") {
                  m.next = 25;
                  break;
                }
                if (d !== 0) {
                  m.next = 11;
                  break;
                }
                return m.next = 6, s.getPaused();
              case 6:
                if (m.t0 = m.sent, m.t0 !== !1) {
                  m.next = 9;
                  break;
                }
                s.pause();
              case 9:
                m.next = 25;
                break;
              case 11:
                if (!(d > 0)) {
                  m.next = 25;
                  break;
                }
                return m.next = 14, s.getPaused();
              case 14:
                if (m.t1 = m.sent, m.t1 !== !0) {
                  m.next = 19;
                  break;
                }
                return m.next = 18, s.play().catch(/* @__PURE__ */ function() {
                  var v = Mo(/* @__PURE__ */ kn().mark(function w(b) {
                    return kn().wrap(function(C) {
                      for (; ; )
                        switch (C.prev = C.next) {
                          case 0:
                            if (!(b.name === "NotAllowedError" && c.autoPlayMuted)) {
                              C.next = 5;
                              break;
                            }
                            return C.next = 3, s.setMuted(!0);
                          case 3:
                            return C.next = 5, s.play().catch(function(S) {
                              return console.error("Couldn't play the video from TimingSrcConnector. Error:", S);
                            });
                          case 5:
                          case "end":
                            return C.stop();
                        }
                    }, w);
                  }));
                  return function(w) {
                    return v.apply(this, arguments);
                  };
                }());
              case 18:
                this.updatePlayer(a, s, c);
              case 19:
                return m.next = 21, s.getPlaybackRate();
              case 21:
                if (m.t2 = m.sent, m.t3 = d, m.t2 === m.t3) {
                  m.next = 25;
                  break;
                }
                s.setPlaybackRate(d);
              case 25:
              case "end":
                return m.stop();
            }
        }, o, this);
      }));
      function i(o, a, s) {
        return r.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Since video players do not play with 100% time precision, we need to closely monitor
     * our player to be sure it remains in sync with the TimingObject.
     *
     * If out of sync, we use the current conditions and the options provided to determine
     * whether to re-sync via setting currentTime or adjusting the playbackRate
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {{cancel: (function(): void)}}
     */
  }, {
    key: "maintainPlaybackPosition",
    value: function(i, o, a) {
      var s = this, c = a.allowedDrift, f = a.maxAllowedDrift, p = a.minCheckInterval, d = a.maxRateAdjustment, h = a.maxTimeToCatchUp, m = Math.min(h, Math.max(p, f)) * 1e3, v = /* @__PURE__ */ function() {
        var b = Mo(/* @__PURE__ */ kn().mark(function E() {
          var C, S, _, T, P;
          return kn().wrap(function(N) {
            for (; ; )
              switch (N.prev = N.next) {
                case 0:
                  if (N.t0 = i.query().velocity === 0, N.t0) {
                    N.next = 6;
                    break;
                  }
                  return N.next = 4, o.getPaused();
                case 4:
                  N.t1 = N.sent, N.t0 = N.t1 === !0;
                case 6:
                  if (!N.t0) {
                    N.next = 8;
                    break;
                  }
                  return N.abrupt("return");
                case 8:
                  return N.t2 = i.query().position, N.next = 11, o.getCurrentTime();
                case 11:
                  if (N.t3 = N.sent, C = N.t2 - N.t3, S = Math.abs(C), s.log("Drift: ".concat(C)), !(S > f)) {
                    N.next = 22;
                    break;
                  }
                  return N.next = 18, s.adjustSpeed(o, 0);
                case 18:
                  o.setCurrentTime(i.query().position), s.log("Resync by currentTime"), N.next = 29;
                  break;
                case 22:
                  if (!(S > c)) {
                    N.next = 29;
                    break;
                  }
                  return _ = S / h, T = d, P = _ < T ? (T - _) / 2 : T, N.next = 28, s.adjustSpeed(o, P * Math.sign(C));
                case 28:
                  s.log("Resync by playbackRate");
                case 29:
                case "end":
                  return N.stop();
              }
          }, E);
        }));
        return function() {
          return b.apply(this, arguments);
        };
      }(), w = setInterval(function() {
        return v();
      }, m);
      return {
        cancel: function() {
          return clearInterval(w);
        }
      };
    }
    /**
     * @param {string} msg
     */
  }, {
    key: "log",
    value: function(i) {
      var o;
      (o = this.logger) === null || o === void 0 || o.call(this, "TimingSrcConnector: ".concat(i));
    }
  }, {
    key: "waitForTOReadyState",
    value: (
      /**
       * @param {TimingObject} timingObject
       * @param {TConnectionState} state
       * @return {Promise<void>}
       */
      function(i, o) {
        return new Promise(function(a) {
          var s = function c() {
            i.readyState === o ? a() : i.addEventListener("readystatechange", c, {
              once: !0
            });
          };
          s();
        });
      }
    )
  }]), n;
}(/* @__PURE__ */ sg(EventTarget)), ba = /* @__PURE__ */ new WeakMap(), Ch = /* @__PURE__ */ new WeakMap(), Bn = {}, Av = /* @__PURE__ */ function() {
  function e(t) {
    var n = this, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (pS(this, e), window.jQuery && t instanceof jQuery && (t.length > 1 && window.console && console.warn && console.warn("A jQuery object with multiple elements was passed, using the first element."), t = t[0]), typeof document < "u" && typeof t == "string" && (t = document.getElementById(t)), !nX(t))
      throw new TypeError("You must pass either a valid element or a valid id.");
    if (t.nodeName !== "IFRAME") {
      var i = t.querySelector("iframe");
      i && (t = i);
    }
    if (t.nodeName === "IFRAME" && !qo(t.getAttribute("src") || ""))
      throw new Error("The player element passed isn’t a Vimeo embed.");
    if (ba.has(t))
      return ba.get(t);
    this._window = t.ownerDocument.defaultView, this.element = t, this.origin = "*";
    var o = new mr(function(s, c) {
      if (n._onMessage = function(d) {
        if (!(!qo(d.origin) || n.element.contentWindow !== d.source)) {
          n.origin === "*" && (n.origin = d.origin);
          var h = cd(d.data), m = h && h.event === "error", v = m && h.data && h.data.method === "ready";
          if (v) {
            var w = new Error(h.data.message);
            w.name = h.data.name, c(w);
            return;
          }
          var b = h && h.event === "ready", E = h && h.method === "ping";
          if (b || E) {
            n.element.setAttribute("data-ready", "true"), s();
            return;
          }
          uX(n, h);
        }
      }, n._window.addEventListener("message", n._onMessage), n.element.nodeName !== "IFRAME") {
        var f = bS(t, r), p = yS(f);
        xS(p, f, t).then(function(d) {
          var h = Pv(d, t);
          return n.element = h, n._originalElement = t, cX(t, h), ba.set(n.element, n), d;
        }).catch(c);
      }
    });
    if (Ch.set(this, o), ba.set(this.element, this), this.element.nodeName === "IFRAME" && Ao(this, "ping"), Bn.isEnabled) {
      var a = function() {
        return Bn.exit();
      };
      this.fullscreenchangeHandler = function() {
        Bn.isFullscreen ? Os(n, "event:exitFullscreen", a) : of(n, "event:exitFullscreen", a), n.ready().then(function() {
          Ao(n, "fullscreenchange", Bn.isFullscreen);
        });
      }, Bn.on("fullscreenchange", this.fullscreenchangeHandler);
    }
    return this;
  }
  return hS(e, [{
    key: "callMethod",
    value: function(n) {
      var r = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return new mr(function(o, a) {
        return r.ready().then(function() {
          Os(r, n, {
            resolve: o,
            reject: a
          }), Ao(r, n, i);
        }).catch(a);
      });
    }
    /**
     * Get a promise for the value of a player property.
     *
     * @param {string} name The property name
     * @return {Promise}
     */
  }, {
    key: "get",
    value: function(n) {
      var r = this;
      return new mr(function(i, o) {
        return n = s3(n, "get"), r.ready().then(function() {
          Os(r, n, {
            resolve: i,
            reject: o
          }), Ao(r, n);
        }).catch(o);
      });
    }
    /**
     * Get a promise for setting the value of a player property.
     *
     * @param {string} name The API method to call.
     * @param {mixed} value The value to set.
     * @return {Promise}
     */
  }, {
    key: "set",
    value: function(n, r) {
      var i = this;
      return new mr(function(o, a) {
        if (n = s3(n, "set"), r == null)
          throw new TypeError("There must be a value to set.");
        return i.ready().then(function() {
          Os(i, n, {
            resolve: o,
            reject: a
          }), Ao(i, n, r);
        }).catch(a);
      });
    }
    /**
     * Add an event listener for the specified event. Will call the
     * callback with a single parameter, `data`, that contains the data for
     * that event.
     *
     * @param {string} eventName The name of the event.
     * @param {function(*)} callback The function to call when the event fires.
     * @return {void}
     */
  }, {
    key: "on",
    value: function(n, r) {
      if (!n)
        throw new TypeError("You must pass an event name.");
      if (!r)
        throw new TypeError("You must pass a callback function.");
      if (typeof r != "function")
        throw new TypeError("The callback must be a function.");
      var i = rf(this, "event:".concat(n));
      i.length === 0 && this.callMethod("addEventListener", n).catch(function() {
      }), Os(this, "event:".concat(n), r);
    }
    /**
     * Remove an event listener for the specified event. Will remove all
     * listeners for that event if a `callback` isn’t passed, or only that
     * specific callback if it is passed.
     *
     * @param {string} eventName The name of the event.
     * @param {function} [callback] The specific callback to remove.
     * @return {void}
     */
  }, {
    key: "off",
    value: function(n, r) {
      if (!n)
        throw new TypeError("You must pass an event name.");
      if (r && typeof r != "function")
        throw new TypeError("The callback must be a function.");
      var i = of(this, "event:".concat(n), r);
      i && this.callMethod("removeEventListener", n).catch(function(o) {
      });
    }
    /**
     * A promise to load a new video.
     *
     * @promise LoadVideoPromise
     * @fulfill {number} The video with this id or url successfully loaded.
     * @reject {TypeError} The id was not a number.
     */
    /**
     * Load a new video into this embed. The promise will be resolved if
     * the video is successfully loaded, or it will be rejected if it could
     * not be loaded.
     *
     * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
     * @return {LoadVideoPromise}
     */
  }, {
    key: "loadVideo",
    value: function(n) {
      return this.callMethod("loadVideo", n);
    }
    /**
     * A promise to perform an action when the Player is ready.
     *
     * @todo document errors
     * @promise LoadVideoPromise
     * @fulfill {void}
     */
    /**
     * Trigger a function when the player iframe has initialized. You do not
     * need to wait for `ready` to trigger to begin adding event listeners
     * or calling other methods.
     *
     * @return {ReadyPromise}
     */
  }, {
    key: "ready",
    value: function() {
      var n = Ch.get(this) || new mr(function(r, i) {
        i(new Error("Unknown player. Probably unloaded."));
      });
      return mr.resolve(n);
    }
    /**
     * A promise to add a cue point to the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point to use for removeCuePoint.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Add a cue point to the player.
     *
     * @param {number} time The time for the cue point.
     * @param {object} [data] Arbitrary data to be returned with the cue point.
     * @return {AddCuePointPromise}
     */
  }, {
    key: "addCuePoint",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.callMethod("addCuePoint", {
        time: n,
        data: r
      });
    }
    /**
     * A promise to remove a cue point from the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point that was removed.
     * @reject {InvalidCuePoint} The cue point with the specified id was not
     *         found.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Remove a cue point from the video.
     *
     * @param {string} id The id of the cue point to remove.
     * @return {RemoveCuePointPromise}
     */
  }, {
    key: "removeCuePoint",
    value: function(n) {
      return this.callMethod("removeCuePoint", n);
    }
    /**
     * A representation of a text track on a video.
     *
     * @typedef {Object} VimeoTextTrack
     * @property {string} language The ISO language code.
     * @property {string} kind The kind of track it is (captions or subtitles).
     * @property {string} label The human‐readable label for the track.
     */
    /**
     * A promise to enable a text track.
     *
     * @promise EnableTextTrackPromise
     * @fulfill {VimeoTextTrack} The text track that was enabled.
     * @reject {InvalidTrackLanguageError} No track was available with the
     *         specified language.
     * @reject {InvalidTrackError} No track was available with the specified
     *         language and kind.
     */
    /**
     * Enable the text track with the specified language, and optionally the
     * specified kind (captions or subtitles).
     *
     * When set via the API, the track language will not change the viewer’s
     * stored preference.
     *
     * @param {string} language The two‐letter language code.
     * @param {string} [kind] The kind of track to enable (captions or subtitles).
     * @return {EnableTextTrackPromise}
     */
  }, {
    key: "enableTextTrack",
    value: function(n, r) {
      if (!n)
        throw new TypeError("You must pass a language.");
      return this.callMethod("enableTextTrack", {
        language: n,
        kind: r
      });
    }
    /**
     * A promise to disable the active text track.
     *
     * @promise DisableTextTrackPromise
     * @fulfill {void} The track was disabled.
     */
    /**
     * Disable the currently-active text track.
     *
     * @return {DisableTextTrackPromise}
     */
  }, {
    key: "disableTextTrack",
    value: function() {
      return this.callMethod("disableTextTrack");
    }
    /**
     * A promise to pause the video.
     *
     * @promise PausePromise
     * @fulfill {void} The video was paused.
     */
    /**
     * Pause the video if it’s playing.
     *
     * @return {PausePromise}
     */
  }, {
    key: "pause",
    value: function() {
      return this.callMethod("pause");
    }
    /**
     * A promise to play the video.
     *
     * @promise PlayPromise
     * @fulfill {void} The video was played.
     */
    /**
     * Play the video if it’s paused. **Note:** on iOS and some other
     * mobile devices, you cannot programmatically trigger play. Once the
     * viewer has tapped on the play button in the player, however, you
     * will be able to use this function.
     *
     * @return {PlayPromise}
     */
  }, {
    key: "play",
    value: function() {
      return this.callMethod("play");
    }
    /**
     * Request that the player enters fullscreen.
     * @return {Promise}
     */
  }, {
    key: "requestFullscreen",
    value: function() {
      return Bn.isEnabled ? Bn.request(this.element) : this.callMethod("requestFullscreen");
    }
    /**
     * Request that the player exits fullscreen.
     * @return {Promise}
     */
  }, {
    key: "exitFullscreen",
    value: function() {
      return Bn.isEnabled ? Bn.exit() : this.callMethod("exitFullscreen");
    }
    /**
     * Returns true if the player is currently fullscreen.
     * @return {Promise}
     */
  }, {
    key: "getFullscreen",
    value: function() {
      return Bn.isEnabled ? mr.resolve(Bn.isFullscreen) : this.get("fullscreen");
    }
    /**
     * Request that the player enters picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "requestPictureInPicture",
    value: function() {
      return this.callMethod("requestPictureInPicture");
    }
    /**
     * Request that the player exits picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "exitPictureInPicture",
    value: function() {
      return this.callMethod("exitPictureInPicture");
    }
    /**
     * Returns true if the player is currently picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "getPictureInPicture",
    value: function() {
      return this.get("pictureInPicture");
    }
    /**
     * A promise to prompt the viewer to initiate remote playback.
     *
     * @promise RemotePlaybackPromptPromise
     * @fulfill {void}
     * @reject {NotFoundError} No remote playback device is available.
     */
    /**
     * Request to prompt the user to initiate remote playback.
     *
     * @return {RemotePlaybackPromptPromise}
     */
  }, {
    key: "remotePlaybackPrompt",
    value: function() {
      return this.callMethod("remotePlaybackPrompt");
    }
    /**
     * A promise to unload the video.
     *
     * @promise UnloadPromise
     * @fulfill {void} The video was unloaded.
     */
    /**
     * Return the player to its initial state.
     *
     * @return {UnloadPromise}
     */
  }, {
    key: "unload",
    value: function() {
      return this.callMethod("unload");
    }
    /**
     * Cleanup the player and remove it from the DOM
     *
     * It won't be usable and a new one should be constructed
     *  in order to do any operations.
     *
     * @return {Promise}
     */
  }, {
    key: "destroy",
    value: function() {
      var n = this;
      return new mr(function(r) {
        if (Ch.delete(n), ba.delete(n.element), n._originalElement && (ba.delete(n._originalElement), n._originalElement.removeAttribute("data-vimeo-initialized")), n.element && n.element.nodeName === "IFRAME" && n.element.parentNode && (n.element.parentNode.parentNode && n._originalElement && n._originalElement !== n.element.parentNode ? n.element.parentNode.parentNode.removeChild(n.element.parentNode) : n.element.parentNode.removeChild(n.element)), n.element && n.element.nodeName === "DIV" && n.element.parentNode) {
          n.element.removeAttribute("data-vimeo-initialized");
          var i = n.element.querySelector("iframe");
          i && i.parentNode && (i.parentNode.parentNode && n._originalElement && n._originalElement !== i.parentNode ? i.parentNode.parentNode.removeChild(i.parentNode) : i.parentNode.removeChild(i));
        }
        n._window.removeEventListener("message", n._onMessage), Bn.isEnabled && Bn.off("fullscreenchange", n.fullscreenchangeHandler), r();
      });
    }
    /**
     * A promise to get the autopause behavior of the video.
     *
     * @promise GetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Get the autopause behavior for this player.
     *
     * @return {GetAutopausePromise}
     */
  }, {
    key: "getAutopause",
    value: function() {
      return this.get("autopause");
    }
    /**
     * A promise to set the autopause behavior of the video.
     *
     * @promise SetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Enable or disable the autopause behavior of this player.
     *
     * By default, when another video is played in the same browser, this
     * player will automatically pause. Unless you have a specific reason
     * for doing so, we recommend that you leave autopause set to the
     * default (`true`).
     *
     * @param {boolean} autopause
     * @return {SetAutopausePromise}
     */
  }, {
    key: "setAutopause",
    value: function(n) {
      return this.set("autopause", n);
    }
    /**
     * A promise to get the buffered property of the video.
     *
     * @promise GetBufferedPromise
     * @fulfill {Array} Buffered Timeranges converted to an Array.
     */
    /**
     * Get the buffered property of the video.
     *
     * @return {GetBufferedPromise}
     */
  }, {
    key: "getBuffered",
    value: function() {
      return this.get("buffered");
    }
    /**
     * @typedef {Object} CameraProperties
     * @prop {number} props.yaw - Number between 0 and 360.
     * @prop {number} props.pitch - Number between -90 and 90.
     * @prop {number} props.roll - Number between -180 and 180.
     * @prop {number} props.fov - The field of view in degrees.
     */
    /**
     * A promise to get the camera properties of the player.
     *
     * @promise GetCameraPromise
     * @fulfill {CameraProperties} The camera properties.
     */
    /**
     * For 360° videos get the camera properties for this player.
     *
     * @return {GetCameraPromise}
     */
  }, {
    key: "getCameraProps",
    value: function() {
      return this.get("cameraProps");
    }
    /**
     * A promise to set the camera properties of the player.
     *
     * @promise SetCameraPromise
     * @fulfill {Object} The camera was successfully set.
     * @reject {RangeError} The range was out of bounds.
     */
    /**
     * For 360° videos set the camera properties for this player.
     *
     * @param {CameraProperties} camera The camera properties
     * @return {SetCameraPromise}
     */
  }, {
    key: "setCameraProps",
    value: function(n) {
      return this.set("cameraProps", n);
    }
    /**
     * A representation of a chapter.
     *
     * @typedef {Object} VimeoChapter
     * @property {number} startTime The start time of the chapter.
     * @property {object} title The title of the chapter.
     * @property {number} index The place in the order of Chapters. Starts at 1.
     */
    /**
     * A promise to get chapters for the video.
     *
     * @promise GetChaptersPromise
     * @fulfill {VimeoChapter[]} The chapters for the video.
     */
    /**
     * Get an array of all the chapters for the video.
     *
     * @return {GetChaptersPromise}
     */
  }, {
    key: "getChapters",
    value: function() {
      return this.get("chapters");
    }
    /**
     * A promise to get the currently active chapter.
     *
     * @promise GetCurrentChaptersPromise
     * @fulfill {VimeoChapter|undefined} The current chapter for the video.
     */
    /**
     * Get the currently active chapter for the video.
     *
     * @return {GetCurrentChaptersPromise}
     */
  }, {
    key: "getCurrentChapter",
    value: function() {
      return this.get("currentChapter");
    }
    /**
     * A promise to get the accent color of the player.
     *
     * @promise GetColorPromise
     * @fulfill {string} The hex color of the player.
     */
    /**
     * Get the accent color for this player. Note this is deprecated in place of `getColorTwo`.
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColor",
    value: function() {
      return this.get("color");
    }
    /**
     * A promise to get all colors for the player in an array.
     *
     * @promise GetColorsPromise
     * @fulfill {string[]} The hex colors of the player.
     */
    /**
     * Get all the colors for this player in an array: [colorOne, colorTwo, colorThree, colorFour]
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColors",
    value: function() {
      return mr.all([this.get("colorOne"), this.get("colorTwo"), this.get("colorThree"), this.get("colorFour")]);
    }
    /**
     * A promise to set the accent color of the player.
     *
     * @promise SetColorPromise
     * @fulfill {string} The color was successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the accent color of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * Note this is deprecated in place of `setColorTwo`.
     *
     * @param {string} color The hex or rgb color string to set.
     * @return {SetColorPromise}
     */
  }, {
    key: "setColor",
    value: function(n) {
      return this.set("color", n);
    }
    /**
     * A promise to set all colors for the player.
     *
     * @promise SetColorsPromise
     * @fulfill {string[]} The colors were successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the colors of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * The colors should be passed in as an array: [colorOne, colorTwo, colorThree, colorFour].
     * If a color should not be set, the index in the array can be left as null.
     *
     * @param {string[]} colors Array of the hex or rgb color strings to set.
     * @return {SetColorsPromise}
     */
  }, {
    key: "setColors",
    value: function(n) {
      if (!Array.isArray(n))
        return new mr(function(o, a) {
          return a(new TypeError("Argument must be an array."));
        });
      var r = new mr(function(o) {
        return o(null);
      }), i = [n[0] ? this.set("colorOne", n[0]) : r, n[1] ? this.set("colorTwo", n[1]) : r, n[2] ? this.set("colorThree", n[2]) : r, n[3] ? this.set("colorFour", n[3]) : r];
      return mr.all(i);
    }
    /**
     * A representation of a cue point.
     *
     * @typedef {Object} VimeoCuePoint
     * @property {number} time The time of the cue point.
     * @property {object} data The data passed when adding the cue point.
     * @property {string} id The unique id for use with removeCuePoint.
     */
    /**
     * A promise to get the cue points of a video.
     *
     * @promise GetCuePointsPromise
     * @fulfill {VimeoCuePoint[]} The cue points added to the video.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Get an array of the cue points added to the video.
     *
     * @return {GetCuePointsPromise}
     */
  }, {
    key: "getCuePoints",
    value: function() {
      return this.get("cuePoints");
    }
    /**
     * A promise to get the current time of the video.
     *
     * @promise GetCurrentTimePromise
     * @fulfill {number} The current time in seconds.
     */
    /**
     * Get the current playback position in seconds.
     *
     * @return {GetCurrentTimePromise}
     */
  }, {
    key: "getCurrentTime",
    value: function() {
      return this.get("currentTime");
    }
    /**
     * A promise to set the current time of the video.
     *
     * @promise SetCurrentTimePromise
     * @fulfill {number} The actual current time that was set.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     */
    /**
     * Set the current playback position in seconds. If the player was
     * paused, it will remain paused. Likewise, if the player was playing,
     * it will resume playing once the video has buffered.
     *
     * You can provide an accurate time and the player will attempt to seek
     * to as close to that time as possible. The exact time will be the
     * fulfilled value of the promise.
     *
     * @param {number} currentTime
     * @return {SetCurrentTimePromise}
     */
  }, {
    key: "setCurrentTime",
    value: function(n) {
      return this.set("currentTime", n);
    }
    /**
     * A promise to get the duration of the video.
     *
     * @promise GetDurationPromise
     * @fulfill {number} The duration in seconds.
     */
    /**
     * Get the duration of the video in seconds. It will be rounded to the
     * nearest second before playback begins, and to the nearest thousandth
     * of a second after playback begins.
     *
     * @return {GetDurationPromise}
     */
  }, {
    key: "getDuration",
    value: function() {
      return this.get("duration");
    }
    /**
     * A promise to get the ended state of the video.
     *
     * @promise GetEndedPromise
     * @fulfill {boolean} Whether or not the video has ended.
     */
    /**
     * Get the ended state of the video. The video has ended if
     * `currentTime === duration`.
     *
     * @return {GetEndedPromise}
     */
  }, {
    key: "getEnded",
    value: function() {
      return this.get("ended");
    }
    /**
     * A promise to get the loop state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the player is set to loop.
     */
    /**
     * Get the loop state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getLoop",
    value: function() {
      return this.get("loop");
    }
    /**
     * A promise to set the loop state of the player.
     *
     * @promise SetLoopPromise
     * @fulfill {boolean} The loop state that was set.
     */
    /**
     * Set the loop state of the player. When set to `true`, the player
     * will start over immediately once playback ends.
     *
     * @param {boolean} loop
     * @return {SetLoopPromise}
     */
  }, {
    key: "setLoop",
    value: function(n) {
      return this.set("loop", n);
    }
    /**
     * A promise to set the muted state of the player.
     *
     * @promise SetMutedPromise
     * @fulfill {boolean} The muted state that was set.
     */
    /**
     * Set the muted state of the player. When set to `true`, the player
     * volume will be muted.
     *
     * @param {boolean} muted
     * @return {SetMutedPromise}
     */
  }, {
    key: "setMuted",
    value: function(n) {
      return this.set("muted", n);
    }
    /**
     * A promise to get the muted state of the player.
     *
     * @promise GetMutedPromise
     * @fulfill {boolean} Whether or not the player is muted.
     */
    /**
     * Get the muted state of the player.
     *
     * @return {GetMutedPromise}
     */
  }, {
    key: "getMuted",
    value: function() {
      return this.get("muted");
    }
    /**
     * A promise to get the paused state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the video is paused.
     */
    /**
     * Get the paused state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getPaused",
    value: function() {
      return this.get("paused");
    }
    /**
     * A promise to get the playback rate of the player.
     *
     * @promise GetPlaybackRatePromise
     * @fulfill {number} The playback rate of the player on a scale from 0 to 2.
     */
    /**
     * Get the playback rate of the player on a scale from `0` to `2`.
     *
     * @return {GetPlaybackRatePromise}
     */
  }, {
    key: "getPlaybackRate",
    value: function() {
      return this.get("playbackRate");
    }
    /**
     * A promise to set the playbackrate of the player.
     *
     * @promise SetPlaybackRatePromise
     * @fulfill {number} The playback rate was set.
     * @reject {RangeError} The playback rate was less than 0 or greater than 2.
     */
    /**
     * Set the playback rate of the player on a scale from `0` to `2`. When set
     * via the API, the playback rate will not be synchronized to other
     * players or stored as the viewer's preference.
     *
     * @param {number} playbackRate
     * @return {SetPlaybackRatePromise}
     */
  }, {
    key: "setPlaybackRate",
    value: function(n) {
      return this.set("playbackRate", n);
    }
    /**
     * A promise to get the played property of the video.
     *
     * @promise GetPlayedPromise
     * @fulfill {Array} Played Timeranges converted to an Array.
     */
    /**
     * Get the played property of the video.
     *
     * @return {GetPlayedPromise}
     */
  }, {
    key: "getPlayed",
    value: function() {
      return this.get("played");
    }
    /**
     * A promise to get the qualities available of the current video.
     *
     * @promise GetQualitiesPromise
     * @fulfill {Array} The qualities of the video.
     */
    /**
     * Get the qualities of the current video.
     *
     * @return {GetQualitiesPromise}
     */
  }, {
    key: "getQualities",
    value: function() {
      return this.get("qualities");
    }
    /**
     * A promise to get the current set quality of the video.
     *
     * @promise GetQualityPromise
     * @fulfill {string} The current set quality.
     */
    /**
     * Get the current set quality of the video.
     *
     * @return {GetQualityPromise}
     */
  }, {
    key: "getQuality",
    value: function() {
      return this.get("quality");
    }
    /**
     * A promise to set the video quality.
     *
     * @promise SetQualityPromise
     * @fulfill {number} The quality was set.
     * @reject {RangeError} The quality is not available.
     */
    /**
     * Set a video quality.
     *
     * @param {string} quality
     * @return {SetQualityPromise}
     */
  }, {
    key: "setQuality",
    value: function(n) {
      return this.set("quality", n);
    }
    /**
     * A promise to get the remote playback availability.
     *
     * @promise RemotePlaybackAvailabilityPromise
     * @fulfill {boolean} Whether remote playback is available.
     */
    /**
     * Get the availability of remote playback.
     *
     * @return {RemotePlaybackAvailabilityPromise}
     */
  }, {
    key: "getRemotePlaybackAvailability",
    value: function() {
      return this.get("remotePlaybackAvailability");
    }
    /**
     * A promise to get the current remote playback state.
     *
     * @promise RemotePlaybackStatePromise
     * @fulfill {string} The state of the remote playback: connecting, connected, or disconnected.
     */
    /**
     * Get the current remote playback state.
     *
     * @return {RemotePlaybackStatePromise}
     */
  }, {
    key: "getRemotePlaybackState",
    value: function() {
      return this.get("remotePlaybackState");
    }
    /**
     * A promise to get the seekable property of the video.
     *
     * @promise GetSeekablePromise
     * @fulfill {Array} Seekable Timeranges converted to an Array.
     */
    /**
     * Get the seekable property of the video.
     *
     * @return {GetSeekablePromise}
     */
  }, {
    key: "getSeekable",
    value: function() {
      return this.get("seekable");
    }
    /**
     * A promise to get the seeking property of the player.
     *
     * @promise GetSeekingPromise
     * @fulfill {boolean} Whether or not the player is currently seeking.
     */
    /**
     * Get if the player is currently seeking.
     *
     * @return {GetSeekingPromise}
     */
  }, {
    key: "getSeeking",
    value: function() {
      return this.get("seeking");
    }
    /**
     * A promise to get the text tracks of a video.
     *
     * @promise GetTextTracksPromise
     * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
     */
    /**
     * Get an array of the text tracks that exist for the video.
     *
     * @return {GetTextTracksPromise}
     */
  }, {
    key: "getTextTracks",
    value: function() {
      return this.get("textTracks");
    }
    /**
     * A promise to get the embed code for the video.
     *
     * @promise GetVideoEmbedCodePromise
     * @fulfill {string} The `<iframe>` embed code for the video.
     */
    /**
     * Get the `<iframe>` embed code for the video.
     *
     * @return {GetVideoEmbedCodePromise}
     */
  }, {
    key: "getVideoEmbedCode",
    value: function() {
      return this.get("videoEmbedCode");
    }
    /**
     * A promise to get the id of the video.
     *
     * @promise GetVideoIdPromise
     * @fulfill {number} The id of the video.
     */
    /**
     * Get the id of the video.
     *
     * @return {GetVideoIdPromise}
     */
  }, {
    key: "getVideoId",
    value: function() {
      return this.get("videoId");
    }
    /**
     * A promise to get the title of the video.
     *
     * @promise GetVideoTitlePromise
     * @fulfill {number} The title of the video.
     */
    /**
     * Get the title of the video.
     *
     * @return {GetVideoTitlePromise}
     */
  }, {
    key: "getVideoTitle",
    value: function() {
      return this.get("videoTitle");
    }
    /**
     * A promise to get the native width of the video.
     *
     * @promise GetVideoWidthPromise
     * @fulfill {number} The native width of the video.
     */
    /**
     * Get the native width of the currently‐playing video. The width of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoWidthPromise}
     */
  }, {
    key: "getVideoWidth",
    value: function() {
      return this.get("videoWidth");
    }
    /**
     * A promise to get the native height of the video.
     *
     * @promise GetVideoHeightPromise
     * @fulfill {number} The native height of the video.
     */
    /**
     * Get the native height of the currently‐playing video. The height of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoHeightPromise}
     */
  }, {
    key: "getVideoHeight",
    value: function() {
      return this.get("videoHeight");
    }
    /**
     * A promise to get the vimeo.com url for the video.
     *
     * @promise GetVideoUrlPromise
     * @fulfill {number} The vimeo.com url for the video.
     * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
     */
    /**
     * Get the vimeo.com url for the video.
     *
     * @return {GetVideoUrlPromise}
     */
  }, {
    key: "getVideoUrl",
    value: function() {
      return this.get("videoUrl");
    }
    /**
     * A promise to get the volume level of the player.
     *
     * @promise GetVolumePromise
     * @fulfill {number} The volume level of the player on a scale from 0 to 1.
     */
    /**
     * Get the current volume level of the player on a scale from `0` to `1`.
     *
     * Most mobile devices do not support an independent volume from the
     * system volume. In those cases, this method will always return `1`.
     *
     * @return {GetVolumePromise}
     */
  }, {
    key: "getVolume",
    value: function() {
      return this.get("volume");
    }
    /**
     * A promise to set the volume level of the player.
     *
     * @promise SetVolumePromise
     * @fulfill {number} The volume was set.
     * @reject {RangeError} The volume was less than 0 or greater than 1.
     */
    /**
     * Set the volume of the player on a scale from `0` to `1`. When set
     * via the API, the volume level will not be synchronized to other
     * players or stored as the viewer’s preference.
     *
     * Most mobile devices do not support setting the volume. An error will
     * *not* be triggered in that situation.
     *
     * @param {number} volume
     * @return {SetVolumePromise}
     */
  }, {
    key: "setVolume",
    value: function(n) {
      return this.set("volume", n);
    }
    /** @typedef {import('./lib/timing-object.types').TimingObject} TimingObject */
    /** @typedef {import('./lib/timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */
    /** @typedef {import('./lib/timing-src-connector').TimingSrcConnector} TimingSrcConnector */
    /**
     * Connects a TimingObject to the video player (https://webtiming.github.io/timingobject/)
     *
     * @param {TimingObject} timingObject
     * @param {TimingSrcConnectorOptions} options
     *
     * @return {Promise<TimingSrcConnector>}
     */
  }, {
    key: "setTimingSrc",
    value: function() {
      var t = Mo(/* @__PURE__ */ kn().mark(function r(i, o) {
        var a = this, s;
        return kn().wrap(function(f) {
          for (; ; )
            switch (f.prev = f.next) {
              case 0:
                if (i) {
                  f.next = 2;
                  break;
                }
                throw new TypeError("A Timing Object must be provided.");
              case 2:
                return f.next = 4, this.ready();
              case 4:
                return s = new wX(this, i, o), Ao(this, "notifyTimingObjectConnect"), s.addEventListener("disconnect", function() {
                  return Ao(a, "notifyTimingObjectDisconnect");
                }), f.abrupt("return", s);
              case 8:
              case "end":
                return f.stop();
            }
        }, r, this);
      }));
      function n(r, i) {
        return t.apply(this, arguments);
      }
      return n;
    }()
  }]), e;
}();
vS || (Bn = gX(), dX(), pX(), hX(), mX());
function yX(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, lg(e, t);
}
function lg(e, t) {
  return lg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, lg(e, t);
}
var c3 = {
  play: "onPlay",
  playing: "onPlaying",
  pause: "onPause",
  ended: "onEnd",
  timeupdate: "onTimeUpdate",
  progress: "onProgress",
  seeked: "onSeeked",
  texttrackchange: "onTextTrackChange",
  cuechange: "onCueChange",
  cuepoint: "onCuePoint",
  volumechange: "onVolumeChange",
  playbackratechange: "onPlaybackRateChange",
  error: "onError",
  loaded: "onLoaded"
}, Rv = /* @__PURE__ */ function(e) {
  function t(r) {
    var i;
    return i = e.call(this, r) || this, i.refContainer = i.refContainer.bind(i), i;
  }
  yX(t, e);
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.createPlayer();
  }, n.componentDidUpdate = function(i) {
    var o = this, a = Object.keys(this.props).filter(function(s) {
      return o.props[s] !== i[s];
    });
    this.updateProps(a);
  }, n.componentWillUnmount = function() {
    this.player.destroy();
  }, n.getInitialOptions = function() {
    var i, o = this.props.video, a = /^https?:/i.test(o) ? "url" : "id";
    return i = {}, i[a] = o, i.width = this.props.width, i.height = this.props.height, i.autopause = this.props.autopause, i.autoplay = this.props.autoplay, i.byline = this.props.showByline, i.color = this.props.color, i.controls = this.props.controls, i.loop = this.props.loop, i.portrait = this.props.showPortrait, i.title = this.props.showTitle, i.muted = this.props.muted, i.background = this.props.background, i.responsive = this.props.responsive, i.dnt = this.props.dnt, i.speed = this.props.speed, i.keyboard = this.props.keyboard, i.pip = this.props.pip, i.playsinline = this.props.playsInline, i.quality = this.props.quality, i.texttrack = this.props.textTrack, i.transparent = this.props.transparent, i;
  }, n.updateProps = function(i) {
    var o = this, a = this.player;
    i.forEach(function(s) {
      var c = o.props[s];
      switch (s) {
        case "autopause":
          a.setAutopause(c);
          break;
        case "color":
          a.setColor(c);
          break;
        case "loop":
          a.setLoop(c);
          break;
        case "volume":
          a.setVolume(c);
          break;
        case "paused":
          a.getPaused().then(function(d) {
            return c && !d ? a.pause() : !c && d ? a.play() : null;
          });
          break;
        case "width":
        case "height":
          a.element[s] = c;
          break;
        case "video":
          if (c) {
            var f = o.props.start, p = a.loadVideo(c);
            typeof f == "number" && p.then(function() {
              a.setCurrentTime(f);
            });
          } else
            a.unload();
          break;
        case "playbackRate":
          a.setPlaybackRate(c);
          break;
        case "quality":
          a.setQuality(c);
          break;
      }
    });
  }, n.createPlayer = function() {
    var i = this, o = this.props, a = o.start, s = o.volume, c = o.playbackRate;
    this.player = new Av(this.container, this.getInitialOptions()), Object.keys(c3).forEach(function(h) {
      var m = c3[h];
      i.player.on(h, function(v) {
        var w = i.props[m];
        w && w(v);
      });
    });
    var f = this.props, p = f.onError, d = f.onReady;
    this.player.ready().then(function() {
      d && d(i.player);
    }, function(h) {
      if (p)
        p(h);
      else
        throw h;
    }), typeof a == "number" && this.player.setCurrentTime(a), typeof s == "number" && this.updateProps(["volume"]), typeof c == "number" && this.updateProps(["playbackRate"]);
  }, n.refContainer = function(i) {
    this.container = i;
  }, n.render = function() {
    var i = this.props, o = i.id, a = i.className, s = i.style;
    return /* @__PURE__ */ y.createElement("div", {
      id: o,
      className: a,
      style: s,
      ref: this.refContainer
    });
  }, t;
}(y.Component);
process.env.NODE_ENV !== "production" && (Rv.propTypes = {
  /**
   * A Vimeo video ID or URL.
   */
  video: ye.oneOfType([ye.number, ye.string]),
  /**
   * DOM ID for the player element.
   */
  id: ye.string,
  /**
   * CSS className for the player element.
   */
  className: ye.string,
  /**
   * Inline style for container element.
   */
  style: ye.object,
  // eslint-disable-line react/forbid-prop-types
  /**
   * Width of the player element.
   */
  width: ye.oneOfType([ye.number, ye.string]),
  /**
   * Height of the player element.
   */
  height: ye.oneOfType([ye.number, ye.string]),
  /**
   * Pause the video.
   */
  paused: ye.bool,
  // eslint-disable-line react/no-unused-prop-types
  /**
   * The playback volume as a number between 0 and 1.
   */
  volume: ye.number,
  /**
   * The time in seconds at which to start playing the video.
   */
  start: ye.number,
  // Player parameters
  /**
   * Pause this video automatically when another one plays.
   */
  autopause: ye.bool,
  /**
   * Automatically start playback of the video. Note that this won’t work on
   * some devices.
   */
  autoplay: ye.bool,
  /**
   * Show the byline on the video.
   */
  showByline: ye.bool,
  /**
   * Specify the color of the video controls. Colors may be overridden by the
   * embed settings of the video. _(Ex: "ef2f9f")_
   */
  color: ye.string,
  /**
   * Blocks the player from tracking any session data, including all cookies and analytics.
   */
  dnt: ye.bool,
  // Player controls
  /**
   * Hide all elements in the player, such as the progress bar, sharing buttons, etc.
   * (requires Vimeo PRO / Business account)
   */
  controls: ye.bool,
  /**
   * Play the video again when it reaches the end.
   */
  loop: ye.bool,
  /**
   * Show the portrait on the video.
   */
  showPortrait: ye.bool,
  /**
   * Show the title on the video.
   */
  showTitle: ye.bool,
  /**
   * Starts in a muted state to help with autoplay
   */
  muted: ye.bool,
  /**
   * Starts in a background state with no controls to help with autoplay
   */
  background: ye.bool,
  /**
   * Enable responsive mode and resize according to parent element (experimental)
   */
  responsive: ye.bool,
  /**
   * Specify playback rate (requires Vimeo PRO / Business account)
   */
  playbackRate: ye.number,
  /**
   * Enable playback rate controls (requires Vimeo PRO / Business account)
   */
  speed: ye.bool,
  /**
   * Allows for keyboard input to trigger player events.
   */
  keyboard: ye.bool,
  /**
   * Show the picture-in-picture button in the controlbar
   * and enable the picture-in-picture API.
   */
  pip: ye.bool,
  /**
   * Play video inline on mobile devices, to automatically
   * go fullscreen on playback set this parameter to false.
   */
  playsInline: ye.bool,
  /**
   * Vimeo Plus, PRO, and Business members can default
   * an embedded video to a specific quality on desktop.
   */
  quality: ye.string,
  /**
   * Turn captions/subtitles on for a specific language by default.
   */
  textTrack: ye.string,
  /**
   * The responsive player and transparent background are enabled
   * by default, to disable set this parameter to false.
   */
  transparent: ye.bool,
  // Events
  /* eslint-disable react/no-unused-prop-types */
  /**
   * Sent when the Vimeo player API has loaded.
   * Receives the Vimeo player object in the first parameter.
   */
  onReady: ye.func,
  /**
   * Sent when the player triggers an error.
   */
  onError: ye.func,
  /**
   * Triggered when video playback is initiated.
   */
  onPlay: ye.func,
  /**
   * Triggered when the video starts playing.
   */
  onPlaying: ye.func,
  /**
   * Triggered when the video pauses.
   */
  onPause: ye.func,
  /**
   * Triggered any time the video playback reaches the end.
   * Note: when `loop` is turned on, the ended event will not fire.
   */
  onEnd: ye.func,
  /**
   * Triggered as the `currentTime` of the video updates. It generally fires
   * every 250ms, but it may vary depending on the browser.
   */
  onTimeUpdate: ye.func,
  /**
   * Triggered as the video is loaded. Reports back the amount of the video
   * that has been buffered.
   */
  onProgress: ye.func,
  /**
   * Triggered when the player seeks to a specific time. An `onTimeUpdate`
   * event will also be fired at the same time.
   */
  onSeeked: ye.func,
  /**
   * Triggered when the active text track (captions/subtitles) changes. The
   * values will be `null` if text tracks are turned off.
   */
  onTextTrackChange: ye.func,
  /**
   * Triggered when the active cue for the current text track changes. It also
   * fires when the active text track changes. There may be multiple cues
   * active.
   */
  onCueChange: ye.func,
  /**
   * Triggered when the current time hits a registered cue point.
   */
  onCuePoint: ye.func,
  /**
   * Triggered when the volume in the player changes. Some devices do not
   * support setting the volume of the video independently from the system
   * volume, so this event will never fire on those devices.
   */
  onVolumeChange: ye.func,
  /**
   * Triggered when the playback rate changes.
   */
  onPlaybackRateChange: ye.func,
  /**
   * Triggered when a new video is loaded in the player.
   */
  onLoaded: ye.func
  /* eslint-enable react/no-unused-prop-types */
});
Rv.defaultProps = {
  autopause: !0,
  autoplay: !1,
  showByline: !0,
  controls: !0,
  loop: !1,
  showPortrait: !0,
  showTitle: !0,
  muted: !1,
  background: !1,
  responsive: !1,
  dnt: !1,
  speed: !1,
  keyboard: !0,
  pip: !1,
  playsInline: !0,
  transparent: !0
};
function ES({ className: e }) {
  return /* @__PURE__ */ y.createElement(
    "span",
    {
      className: le(
        "ai-tw-absolute ai-tw-inset-0 ai-tw-flex ai-tw-items-center ai-tw-justify-center ai-tw-bg-tinted-grey-50",
        e
      )
    },
    /* @__PURE__ */ y.createElement("span", { className: "ai-tw-mr-2 ai-tw-leading-none ai-tw-text-content-primary" }, "Loading Video Source"),
    /* @__PURE__ */ y.createElement(bn, { size: "small" })
  );
}
function bX({
  width: e,
  height: t,
  src: n,
  start: r,
  onPlayerReady: i
}) {
  const [o, a] = ue(!0), { chatDispatch: s } = Re(kt);
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-relative" }, /* @__PURE__ */ y.createElement(
    "div",
    {
      style: {
        width: `${e}px`,
        height: `${t}px`
      }
    },
    /* @__PURE__ */ y.createElement(
      Rv,
      {
        width: `${e}px`,
        height: `${t}px`,
        video: n,
        start: r,
        onLoaded: () => a(!1),
        onPlay: () => s({ type: "videoStarted" }),
        onPause: () => {
          s({ type: "videoStopped" }), $2();
        },
        onReady: i,
        onEnd: () => {
          s({ type: "videoStopped" }), $2();
        }
      }
    )
  ), o && /* @__PURE__ */ y.createElement(ES, null));
}
function xX({
  src: e,
  start: t,
  width: n,
  height: r,
  onPlayerReady: i
}) {
  const o = he(`yt-${j5()}`), s = new URL(e).searchParams.get("v"), c = he(n), f = he(r), [p, d] = ue(), [h, m] = ue(!0);
  return _e(() => {
    p && p.setSize(n, r);
  }, [n, r, p]), _e(() => {
    var E;
    const v = (C) => {
      i == null || i(C.target), d(C.target), m(!1);
    };
    let w;
    function b() {
      w = new window.YT.Player(o.current, {
        width: c.current,
        height: f.current,
        videoId: s,
        playerVars: {
          playsinline: 1,
          start: t
        },
        events: {
          onReady: v
        }
      });
    }
    if (window.YT)
      b();
    else {
      const C = document.createElement("script");
      C.src = "https://www.youtube.com/iframe_api";
      const S = document.getElementsByTagName("script")[0];
      (E = S.parentNode) == null || E.insertBefore(C, S), C.addEventListener("load", () => {
        if (window.YT.Player)
          b();
        else {
          let _ = 0;
          const T = window.setInterval(() => {
            if (_++, window.YT.Player) {
              window.clearInterval(T), b();
              return;
            }
            _ > 3 && window.clearInterval(T);
          }, 500);
        }
      });
    }
    return () => {
      w && w.destroy();
    };
  }, [s, t, i]), /* @__PURE__ */ y.createElement(
    "div",
    {
      className: "ai-tw-relative",
      style: { width: `${n}px`, height: `${r}px` }
    },
    /* @__PURE__ */ y.createElement("div", { id: o.current, "data-testid": o.current }),
    h && /* @__PURE__ */ y.createElement(ES, null)
  );
}
function EX({
  sourceID: e,
  metadata: t
}) {
  const n = xC(t, e);
  return n ? IK(n) : 0;
}
function CX({ sourceID: e, src: t }) {
  const { sources: n, metadata: r } = Re(Rl) || {}, [i, o] = ue(null), [a, s] = ue(null), [c, f] = ue(), [p, d] = ue(0), [h, m] = ue(0), { width: v } = Re(Ja) || {}, w = EX({
    sourceID: e,
    metadata: r
  });
  function b(T) {
    T || (i && i.pause(), a && a.pauseVideo());
  }
  const E = n ? CC(n, e) : void 0, C = E ? fv(E) : null, S = E && Ua(E) ? ed(E) : null, _ = E && Ua(E) ? pv(E) : null;
  return _e(() => {
    const T = HK(), P = c != null && c.parentElement ? c.parentElement.clientWidth : 0, R = P / T;
    d(P), m(R);
  }, [c, v]), /* @__PURE__ */ y.createElement(q6, { callback: b, threshold: 0.1 }, /* @__PURE__ */ y.createElement(
    "div",
    {
      ref: (T) => f(T || void 0),
      className: "ai-tw-my-6"
    },
    c && p && h ? /* @__PURE__ */ y.createElement(y.Fragment, null, S === "YouTube" ? /* @__PURE__ */ y.createElement(
      xX,
      {
        src: t,
        start: w,
        width: p,
        height: h,
        onPlayerReady: s
      }
    ) : null, S && ["Brivity", "Our Place"].includes(S) ? /* @__PURE__ */ y.createElement(
      bX,
      {
        width: p,
        height: h,
        src: t,
        start: w,
        onPlayerReady: o
      }
    ) : null, /* @__PURE__ */ y.createElement("div", { className: "ai-tw-mt-1 ai-tw-flex ai-tw-justify-between ai-tw-text-content-primary" }, /* @__PURE__ */ y.createElement(
      "p",
      {
        title: C || void 0,
        className: "ai-tw-line-clamp-2 ai-tw-flex-1 ai-tw-pr-4 ai-tw-subtitle-sm"
      },
      C
    ), /* @__PURE__ */ y.createElement("p", { className: "ai-tw-max-w-[50%] ai-tw-shrink-0 ai-tw-body-sm" }, og(S), " ", _ ? id(_) : null))) : null
  ));
}
function SX({
  node: e,
  ...t
}) {
  const n = t.alt && !dh(t.alt) ? Bj(t.alt) : null, r = t.alt && dh(t.alt) ? Hj(t.alt) : null;
  return t != null && t.alt && Wj(t.alt) ? n && t.src ? /* @__PURE__ */ y.createElement(
    LK,
    {
      node: e,
      sourceID: n,
      src: t.src
    }
  ) : null : t.alt && dh(t.alt) ? r && t.src ? /* @__PURE__ */ y.createElement(
    BK,
    {
      node: e,
      citationID: r,
      src: t.src
    }
  ) : null : t.alt && Uj(t.alt) && n && t.src ? /* @__PURE__ */ y.createElement(CX, { sourceID: n, src: t.src }) : null;
}
function _X({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ y.createElement(
    "a",
    {
      className: le(
        "ai-tw-inline-flex ai-tw-h-[100px] ai-tw-w-[200px] ai-tw-shrink-0 ai-tw-flex-col ai-tw-rounded-lg ai-tw-bg-white ai-tw-body-sm hover:ai-tw-bg-stroke-primary active:ai-tw-bg-stroke-primary-dark",
        e
      ),
      ...t
    },
    t.children
  );
}
function TX(e) {
  return e === "video_source" ? "video" : e;
}
function CS({
  id: e,
  title: t,
  url: n,
  className: r,
  modifiedAt: i,
  type: o,
  source: a
}) {
  const s = o === "source" ? og(a) : `${og(a)}: ${TX(o)}`;
  return n ? /* @__PURE__ */ y.createElement(
    _X,
    {
      href: n,
      target: "_blank",
      rel: "noreferrer",
      title: t,
      className: le("ai-tw-px-3 ai-tw-py-2", r)
    },
    /* @__PURE__ */ y.createElement(
      "p",
      {
        className: le(
          "ai-tw-line-clamp-3 ai-tw-text-content-primary ai-tw-body-sm"
        )
      },
      e,
      ": ",
      t
    ),
    /* @__PURE__ */ y.createElement("div", { className: "ai-tw-mt-auto ai-tw-text-[11px] ai-tw-text-content-primary-light ai-tw-body-sm" }, a ? /* @__PURE__ */ y.createElement("p", { className: "ai-tw-truncate ai-tw-uppercase" }, s) : /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-items-center" }, /* @__PURE__ */ y.createElement(Ne, { icon: zR, className: "ai-tw-mr-1" }), /* @__PURE__ */ y.createElement("p", { className: "ai-tw-truncate ai-tw-uppercase" }, n)), i ? /* @__PURE__ */ y.createElement("p", null, id(i)) : null)
  ) : null;
}
const kX = b5, PX = x5, AX = E5, RX = P1;
function $X({
  children: e,
  ...t
}) {
  return /* @__PURE__ */ y.createElement(kX, { delayDuration: 300 }, /* @__PURE__ */ y.createElement(PX, { asChild: !0 }, e), /* @__PURE__ */ y.createElement(AX, null, /* @__PURE__ */ y.createElement(RX, { className: "ai-tw-z-[5001]", side: "bottom" }, /* @__PURE__ */ y.createElement(
    on.div,
    {
      initial: { y: 30, opacity: 0 },
      animate: { y: 0, opacity: 1 },
      transition: { duration: 0.2 }
    },
    /* @__PURE__ */ y.createElement(
      CS,
      {
        className: "ai-tw-box-border ai-tw-border ai-tw-border-stroke-primary ai-tw-no-underline ai-tw-shadow-lg [&_p]:ai-tw-m-0",
        ...t
      }
    )
  ))));
}
const cg = y.forwardRef(
  ({ node: e, className: t, ...n }, r) => /* @__PURE__ */ y.createElement(
    "a",
    {
      ref: r,
      target: "_blank",
      rel: "noreferrer",
      className: le("ai-tw-font-semibold ai-tw-text-blue-50", t),
      ...n
    }
  )
);
cg.displayName = "Link";
const $v = y.forwardRef((e, t) => {
  const { sources: n } = Re(Rl) || {}, r = n && e.href ? R2(n, e.href) || n && e.id && R2(n, e.id) : null;
  return r ? /* @__PURE__ */ y.createElement(
    $X,
    {
      id: eg(r),
      title: fv(r),
      url: dv(r),
      type: bC(r),
      modifiedAt: Ua(r) ? pv(r) : null,
      source: Ua(r) ? ed(r) : null
    },
    /* @__PURE__ */ y.createElement(cg, { ...e, ref: t })
  ) : /* @__PURE__ */ y.createElement(cg, { ...e, ref: t });
});
$v.displayName = "LinkRemarkRenderer";
function OX({
  node: e,
  ...t
}) {
  return (
    // we use div instead of p to prevent DOM validation errors
    // we render videos inside p tags that have div containers around them that is not allowed
    /* @__PURE__ */ y.createElement("div", { className: "ai-tw-mb-2 ai-tw-leading-normal ai-tw-body-md", ...t })
  );
}
function MX({
  chatId: e,
  messageId: t
}) {
  const {
    swr: { data: n }
  } = Jf({
    chatId: e
  }), [r, i] = ue(!1), [o, a] = ue(null);
  if (!n)
    return null;
  const s = aq(n, t);
  if (!s)
    return null;
  async function c() {
    const f = EC(s);
    if (!f || (await navigator.clipboard.writeText(f), o))
      return;
    i(!0);
    const p = setTimeout(() => {
      i(!1), a(null);
    }, 2e3);
    a(p);
  }
  return /* @__PURE__ */ y.createElement(Zo, { icon: Jq, onClick: c }, r ? "Copied!" : "Copy");
}
function DX({
  chatId: e,
  messageId: t
}) {
  const { chatDispatch: n } = Re(kt);
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-mt-4 ai-tw-flex" }, /* @__PURE__ */ y.createElement(MX, { chatId: e, messageId: t }), /* @__PURE__ */ y.createElement(
    Zo,
    {
      className: "ai-tw-ml-2",
      icon: Zq,
      onClick: () => n({ type: "selectChatMessageForFeedback", messageId: t })
    }
  ));
}
function SS({
  children: e,
  icon: t,
  title: n,
  className: r,
  headerClassName: i
}) {
  return /* @__PURE__ */ y.createElement("div", { className: le("ai-tw-my-6", r) }, /* @__PURE__ */ y.createElement(
    "header",
    {
      className: le(
        "ai-tw-mb-6 ai-tw-flex ai-tw-items-center ai-tw-text-content-primary",
        i
      )
    },
    /* @__PURE__ */ y.createElement(Ne, { icon: t, className: "ai-tw-mr-2" }),
    /* @__PURE__ */ y.createElement("p", { className: "ai-tw-subtitle-md" }, n)
  ), e);
}
function NX({
  followUpQuestions: e
}) {
  const { askQuestion: t } = Re(kt);
  return e != null && e.length ? /* @__PURE__ */ y.createElement(nf, null, /* @__PURE__ */ y.createElement(
    SS,
    {
      icon: MR,
      title: "Follow-up Questions",
      className: "ai-tw-mb-0",
      headerClassName: "ai-tw-mb-4"
    },
    /* @__PURE__ */ y.createElement("ul", { className: "ai-tw-list-none" }, rq(e, 3).map((n) => /* @__PURE__ */ y.createElement(
      "li",
      {
        key: n,
        role: "button",
        className: "ai-tw-cursor-pointer ai-tw-rounded-lg ai-tw-px-4 ai-tw-py-3 ai-tw-text-content-primary ai-tw-body-md hover:ai-tw-bg-element-primary-subtle hover:ai-tw-text-content-primary active:ai-tw-bg-element-primary-subtle-dark",
        onClick: () => t(n)
      },
      "“",
      n,
      "”"
    )))
  )) : null;
}
function ug({ children: e, className: t }) {
  return /* @__PURE__ */ y.createElement("span", { className: le("ai-tw-text-content-primary ai-tw-body-md", t) }, e);
}
var IX = Object.prototype;
function LX(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || IX;
  return e === n;
}
var _S = LX;
function FX(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var zX = FX, VX = zX, BX = VX(Object.keys, Object), HX = BX, UX = _S, WX = HX, jX = Object.prototype, qX = jX.hasOwnProperty;
function GX(e) {
  if (!UX(e))
    return WX(e);
  var t = [];
  for (var n in Object(e))
    qX.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var YX = GX, KX = typeof Ci == "object" && Ci && Ci.Object === Object && Ci, TS = KX, XX = TS, QX = typeof self == "object" && self && self.Object === Object && self, ZX = XX || QX || Function("return this")(), ho = ZX, JX = ho, eQ = JX.Symbol, kS = eQ, u3 = kS, PS = Object.prototype, tQ = PS.hasOwnProperty, nQ = PS.toString, Ms = u3 ? u3.toStringTag : void 0;
function rQ(e) {
  var t = tQ.call(e, Ms), n = e[Ms];
  try {
    e[Ms] = void 0;
    var r = !0;
  } catch {
  }
  var i = nQ.call(e);
  return r && (t ? e[Ms] = n : delete e[Ms]), i;
}
var iQ = rQ, oQ = Object.prototype, aQ = oQ.toString;
function sQ(e) {
  return aQ.call(e);
}
var lQ = sQ, f3 = kS, cQ = iQ, uQ = lQ, fQ = "[object Null]", dQ = "[object Undefined]", d3 = f3 ? f3.toStringTag : void 0;
function pQ(e) {
  return e == null ? e === void 0 ? dQ : fQ : d3 && d3 in Object(e) ? cQ(e) : uQ(e);
}
var ud = pQ;
function hQ(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var AS = hQ, mQ = ud, gQ = AS, vQ = "[object AsyncFunction]", wQ = "[object Function]", yQ = "[object GeneratorFunction]", bQ = "[object Proxy]";
function xQ(e) {
  if (!gQ(e))
    return !1;
  var t = mQ(e);
  return t == wQ || t == yQ || t == vQ || t == bQ;
}
var RS = xQ, EQ = ho, CQ = EQ["__core-js_shared__"], SQ = CQ, Sh = SQ, p3 = function() {
  var e = /[^.]+$/.exec(Sh && Sh.keys && Sh.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function _Q(e) {
  return !!p3 && p3 in e;
}
var TQ = _Q, kQ = Function.prototype, PQ = kQ.toString;
function AQ(e) {
  if (e != null) {
    try {
      return PQ.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var $S = AQ, RQ = RS, $Q = TQ, OQ = AS, MQ = $S, DQ = /[\\^$.*+?()[\]{}|]/g, NQ = /^\[object .+?Constructor\]$/, IQ = Function.prototype, LQ = Object.prototype, FQ = IQ.toString, zQ = LQ.hasOwnProperty, VQ = RegExp(
  "^" + FQ.call(zQ).replace(DQ, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function BQ(e) {
  if (!OQ(e) || $Q(e))
    return !1;
  var t = RQ(e) ? VQ : NQ;
  return t.test(MQ(e));
}
var HQ = BQ;
function UQ(e, t) {
  return e == null ? void 0 : e[t];
}
var WQ = UQ, jQ = HQ, qQ = WQ;
function GQ(e, t) {
  var n = qQ(e, t);
  return jQ(n) ? n : void 0;
}
var $l = GQ, YQ = $l, KQ = ho, XQ = YQ(KQ, "DataView"), QQ = XQ, ZQ = $l, JQ = ho, eZ = ZQ(JQ, "Map"), tZ = eZ, nZ = $l, rZ = ho, iZ = nZ(rZ, "Promise"), oZ = iZ, aZ = $l, sZ = ho, lZ = aZ(sZ, "Set"), cZ = lZ, uZ = $l, fZ = ho, dZ = uZ(fZ, "WeakMap"), pZ = dZ, fg = QQ, dg = tZ, pg = oZ, hg = cZ, mg = pZ, OS = ud, es = $S, h3 = "[object Map]", hZ = "[object Object]", m3 = "[object Promise]", g3 = "[object Set]", v3 = "[object WeakMap]", w3 = "[object DataView]", mZ = es(fg), gZ = es(dg), vZ = es(pg), wZ = es(hg), yZ = es(mg), Do = OS;
(fg && Do(new fg(new ArrayBuffer(1))) != w3 || dg && Do(new dg()) != h3 || pg && Do(pg.resolve()) != m3 || hg && Do(new hg()) != g3 || mg && Do(new mg()) != v3) && (Do = function(e) {
  var t = OS(e), n = t == hZ ? e.constructor : void 0, r = n ? es(n) : "";
  if (r)
    switch (r) {
      case mZ:
        return w3;
      case gZ:
        return h3;
      case vZ:
        return m3;
      case wZ:
        return g3;
      case yZ:
        return v3;
    }
  return t;
});
var bZ = Do;
function xZ(e) {
  return e != null && typeof e == "object";
}
var Ov = xZ, EZ = ud, CZ = Ov, SZ = "[object Arguments]";
function _Z(e) {
  return CZ(e) && EZ(e) == SZ;
}
var TZ = _Z, y3 = TZ, kZ = Ov, MS = Object.prototype, PZ = MS.hasOwnProperty, AZ = MS.propertyIsEnumerable, RZ = y3(function() {
  return arguments;
}()) ? y3 : function(e) {
  return kZ(e) && PZ.call(e, "callee") && !AZ.call(e, "callee");
}, $Z = RZ, OZ = Array.isArray, MZ = OZ, DZ = 9007199254740991;
function NZ(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= DZ;
}
var DS = NZ, IZ = RS, LZ = DS;
function FZ(e) {
  return e != null && LZ(e.length) && !IZ(e);
}
var zZ = FZ, af = { exports: {} };
function VZ() {
  return !1;
}
var BZ = VZ;
af.exports;
(function(e, t) {
  var n = ho, r = BZ, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, s = a ? n.Buffer : void 0, c = s ? s.isBuffer : void 0, f = c || r;
  e.exports = f;
})(af, af.exports);
var HZ = af.exports, UZ = ud, WZ = DS, jZ = Ov, qZ = "[object Arguments]", GZ = "[object Array]", YZ = "[object Boolean]", KZ = "[object Date]", XZ = "[object Error]", QZ = "[object Function]", ZZ = "[object Map]", JZ = "[object Number]", eJ = "[object Object]", tJ = "[object RegExp]", nJ = "[object Set]", rJ = "[object String]", iJ = "[object WeakMap]", oJ = "[object ArrayBuffer]", aJ = "[object DataView]", sJ = "[object Float32Array]", lJ = "[object Float64Array]", cJ = "[object Int8Array]", uJ = "[object Int16Array]", fJ = "[object Int32Array]", dJ = "[object Uint8Array]", pJ = "[object Uint8ClampedArray]", hJ = "[object Uint16Array]", mJ = "[object Uint32Array]", Dt = {};
Dt[sJ] = Dt[lJ] = Dt[cJ] = Dt[uJ] = Dt[fJ] = Dt[dJ] = Dt[pJ] = Dt[hJ] = Dt[mJ] = !0;
Dt[qZ] = Dt[GZ] = Dt[oJ] = Dt[YZ] = Dt[aJ] = Dt[KZ] = Dt[XZ] = Dt[QZ] = Dt[ZZ] = Dt[JZ] = Dt[eJ] = Dt[tJ] = Dt[nJ] = Dt[rJ] = Dt[iJ] = !1;
function gJ(e) {
  return jZ(e) && WZ(e.length) && !!Dt[UZ(e)];
}
var vJ = gJ;
function wJ(e) {
  return function(t) {
    return e(t);
  };
}
var yJ = wJ, sf = { exports: {} };
sf.exports;
(function(e, t) {
  var n = TS, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, a = o && n.process, s = function() {
    try {
      var c = i && i.require && i.require("util").types;
      return c || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(sf, sf.exports);
var bJ = sf.exports, xJ = vJ, EJ = yJ, b3 = bJ, x3 = b3 && b3.isTypedArray, CJ = x3 ? EJ(x3) : xJ, SJ = CJ, _J = YX, TJ = bZ, kJ = $Z, PJ = MZ, AJ = zZ, RJ = HZ, $J = _S, OJ = SJ, MJ = "[object Map]", DJ = "[object Set]", NJ = Object.prototype, IJ = NJ.hasOwnProperty;
function LJ(e) {
  if (e == null)
    return !0;
  if (AJ(e) && (PJ(e) || typeof e == "string" || typeof e.splice == "function" || RJ(e) || OJ(e) || kJ(e)))
    return !e.length;
  var t = TJ(e);
  if (t == MJ || t == DJ)
    return !e.size;
  if ($J(e))
    return !_J(e).length;
  for (var n in e)
    if (IJ.call(e, n))
      return !1;
  return !0;
}
var FJ = LJ;
const zJ = /* @__PURE__ */ fo(FJ);
function VJ({ sources: e }) {
  const { chatState: t } = Re(kt), n = Mi(t);
  if (zJ(e) || n)
    return null;
  const r = `${Object.keys(e).length} Sources`;
  return /* @__PURE__ */ y.createElement(nf, null, /* @__PURE__ */ y.createElement(SS, { icon: $4, title: r }, /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-max-w-full ai-tw-gap-x-2 ai-tw-overflow-auto" }, Object.values(e || {}).map((i) => /* @__PURE__ */ y.createElement(
    CS,
    {
      key: eg(i),
      id: eg(i),
      title: fv(i),
      url: dv(i),
      type: bC(i),
      source: Ua(i) ? ed(i) : null,
      modifiedAt: Ua(i) ? pv(i) : null
    }
  )))));
}
function BJ() {
  const [e, t] = ue("");
  return _e(() => {
    const n = setInterval(() => {
      t((r) => r.length < 3 ? r + "." : "");
    }, 250);
    return () => clearInterval(n);
  }, []), /* @__PURE__ */ y.createElement("p", null, "Thinking", e);
}
const E3 = ["http", "https", "mailto", "tel"];
function HJ(e) {
  const t = (e || "").trim(), n = t.charAt(0);
  if (n === "#" || n === "/")
    return t;
  const r = t.indexOf(":");
  if (r === -1)
    return t;
  let i = -1;
  for (; ++i < E3.length; ) {
    const o = E3[i];
    if (r === o.length && t.slice(0, o.length).toLowerCase() === o)
      return t;
  }
  return i = t.indexOf("?"), i !== -1 && r > i || (i = t.indexOf("#"), i !== -1 && r > i) ? t : "javascript:void(0)";
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var UJ = function(t) {
  return t != null && t.constructor != null && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
};
const NS = /* @__PURE__ */ fo(UJ);
function qs(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? C3(e.position) : "start" in e || "end" in e ? C3(e) : "line" in e || "column" in e ? gg(e) : "";
}
function gg(e) {
  return S3(e && e.line) + ":" + S3(e && e.column);
}
function C3(e) {
  return gg(e && e.start) + "-" + gg(e && e.end);
}
function S3(e) {
  return e && typeof e == "number" ? e : 1;
}
class Cr extends Error {
  /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // To do: next major: expose `undefined` everywhere instead of `null`.
  constructor(t, n, r) {
    const i = [null, null];
    let o = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: { line: null, column: null },
      // @ts-expect-error: "
      end: { line: null, column: null }
    };
    if (super(), typeof n == "string" && (r = n, n = void 0), typeof r == "string") {
      const a = r.indexOf(":");
      a === -1 ? i[1] = r : (i[0] = r.slice(0, a), i[1] = r.slice(a + 1));
    }
    n && ("type" in n || "position" in n ? n.position && (o = n.position) : "start" in n || "end" in n ? o = n : ("line" in n || "column" in n) && (o.start = n)), this.name = qs(n) || "1:1", this.message = typeof t == "object" ? t.message : t, this.stack = "", typeof t == "object" && t.stack && (this.stack = t.stack), this.reason = this.message, this.fatal, this.line = o.start.line, this.column = o.start.column, this.position = o, this.source = i[0], this.ruleId = i[1], this.file, this.actual, this.expected, this.url, this.note;
  }
}
Cr.prototype.file = "";
Cr.prototype.name = "";
Cr.prototype.reason = "";
Cr.prototype.message = "";
Cr.prototype.stack = "";
Cr.prototype.fatal = null;
Cr.prototype.column = null;
Cr.prototype.line = null;
Cr.prototype.source = null;
Cr.prototype.ruleId = null;
Cr.prototype.position = null;
const Jr = { basename: WJ, dirname: jJ, extname: qJ, join: GJ, sep: "/" };
function WJ(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Ol(e);
  let n = 0, r = -1, i = e.length, o;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.charCodeAt(i) === 47) {
        if (o) {
          n = i + 1;
          break;
        }
      } else
        r < 0 && (o = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let a = -1, s = t.length - 1;
  for (; i--; )
    if (e.charCodeAt(i) === 47) {
      if (o) {
        n = i + 1;
        break;
      }
    } else
      a < 0 && (o = !0, a = i + 1), s > -1 && (e.charCodeAt(i) === t.charCodeAt(s--) ? s < 0 && (r = i) : (s = -1, r = a));
  return n === r ? r = a : r < 0 && (r = e.length), e.slice(n, r);
}
function jJ(e) {
  if (Ol(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.charCodeAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else
      r || (r = !0);
  return t < 0 ? e.charCodeAt(0) === 47 ? "/" : "." : t === 1 && e.charCodeAt(0) === 47 ? "//" : e.slice(0, t);
}
function qJ(e) {
  Ol(e);
  let t = e.length, n = -1, r = 0, i = -1, o = 0, a;
  for (; t--; ) {
    const s = e.charCodeAt(t);
    if (s === 47) {
      if (a) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (a = !0, n = t + 1), s === 46 ? i < 0 ? i = t : o !== 1 && (o = 1) : i > -1 && (o = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function GJ(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    Ol(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : YJ(n);
}
function YJ(e) {
  Ol(e);
  const t = e.charCodeAt(0) === 47;
  let n = KJ(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.charCodeAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function KJ(e, t) {
  let n = "", r = 0, i = -1, o = 0, a = -1, s, c;
  for (; ++a <= e.length; ) {
    if (a < e.length)
      s = e.charCodeAt(a);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(i === a - 1 || o === 1))
        if (i !== a - 1 && o === 2) {
          if (n.length < 2 || r !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              if (c = n.lastIndexOf("/"), c !== n.length - 1) {
                c < 0 ? (n = "", r = 0) : (n = n.slice(0, c), r = n.length - 1 - n.lastIndexOf("/")), i = a, o = 0;
                continue;
              }
            } else if (n.length > 0) {
              n = "", r = 0, i = a, o = 0;
              continue;
            }
          }
          t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
        } else
          n.length > 0 ? n += "/" + e.slice(i + 1, a) : n = e.slice(i + 1, a), r = a - i - 1;
      i = a, o = 0;
    } else
      s === 46 && o > -1 ? o++ : o = -1;
  }
  return n;
}
function Ol(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const XJ = { cwd: QJ };
function QJ() {
  return "/";
}
function vg(e) {
  return e !== null && typeof e == "object" && // @ts-expect-error: indexable.
  e.href && // @ts-expect-error: indexable.
  e.origin;
}
function ZJ(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!vg(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return JJ(e);
}
function JJ(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.charCodeAt(n) === 37 && t.charCodeAt(n + 1) === 50) {
      const r = t.charCodeAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const _h = ["history", "path", "basename", "stem", "extname", "dirname"];
class IS {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? typeof t == "string" || eee(t) ? n = { value: t } : vg(t) ? n = { path: t } : n = t : n = {}, this.data = {}, this.messages = [], this.history = [], this.cwd = XJ.cwd(), this.value, this.stored, this.result, this.map;
    let r = -1;
    for (; ++r < _h.length; ) {
      const o = _h[r];
      o in n && n[o] !== void 0 && n[o] !== null && (this[o] = o === "history" ? [...n[o]] : n[o]);
    }
    let i;
    for (i in n)
      _h.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */
  set path(t) {
    vg(t) && (t = ZJ(t)), kh(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the parent path (example: `'~'`).
   */
  get dirname() {
    return typeof this.path == "string" ? Jr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */
  set dirname(t) {
    _3(this.basename, "dirname"), this.path = Jr.join(t || "", this.basename);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */
  get basename() {
    return typeof this.path == "string" ? Jr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set basename(t) {
    kh(t, "basename"), Th(t, "basename"), this.path = Jr.join(this.dirname || "", t);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   */
  get extname() {
    return typeof this.path == "string" ? Jr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */
  set extname(t) {
    if (Th(t, "extname"), _3(this.dirname, "extname"), t) {
      if (t.charCodeAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Jr.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */
  get stem() {
    return typeof this.path == "string" ? Jr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set stem(t) {
    kh(t, "stem"), Th(t, "stem"), this.path = Jr.join(this.dirname || "", t + (this.extname || ""));
  }
  /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return (this.value || "").toString(t || void 0);
  }
  /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new Cr(t, n, r);
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = null, i;
  }
  /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
}
function Th(e, t) {
  if (e && e.includes(Jr.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + Jr.sep + "`"
    );
}
function kh(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function _3(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function eee(e) {
  return NS(e);
}
function T3(e) {
  if (e)
    throw e;
}
var _u = Object.prototype.hasOwnProperty, LS = Object.prototype.toString, k3 = Object.defineProperty, P3 = Object.getOwnPropertyDescriptor, A3 = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : LS.call(t) === "[object Array]";
}, R3 = function(t) {
  if (!t || LS.call(t) !== "[object Object]")
    return !1;
  var n = _u.call(t, "constructor"), r = t.constructor && t.constructor.prototype && _u.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !r)
    return !1;
  var i;
  for (i in t)
    ;
  return typeof i > "u" || _u.call(t, i);
}, $3 = function(t, n) {
  k3 && n.name === "__proto__" ? k3(t, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : t[n.name] = n.newValue;
}, O3 = function(t, n) {
  if (n === "__proto__")
    if (_u.call(t, n)) {
      if (P3)
        return P3(t, n).value;
    } else
      return;
  return t[n];
}, tee = function e() {
  var t, n, r, i, o, a, s = arguments[0], c = 1, f = arguments.length, p = !1;
  for (typeof s == "boolean" && (p = s, s = arguments[1] || {}, c = 2), (s == null || typeof s != "object" && typeof s != "function") && (s = {}); c < f; ++c)
    if (t = arguments[c], t != null)
      for (n in t)
        r = O3(s, n), i = O3(t, n), s !== i && (p && i && (R3(i) || (o = A3(i))) ? (o ? (o = !1, a = r && A3(r) ? r : []) : a = r && R3(r) ? r : {}, $3(s, { name: n, newValue: e(p, a, i) })) : typeof i < "u" && $3(s, { name: n, newValue: i }));
  return s;
};
const M3 = /* @__PURE__ */ fo(tee);
function wg(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function nee() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let o = -1;
    const a = i.pop();
    if (typeof a != "function")
      throw new TypeError("Expected function as last argument, not " + a);
    s(null, ...i);
    function s(c, ...f) {
      const p = e[++o];
      let d = -1;
      if (c) {
        a(c);
        return;
      }
      for (; ++d < i.length; )
        (f[d] === null || f[d] === void 0) && (f[d] = i[d]);
      i = f, p ? ree(p, s)(...f) : a(null, ...f);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function ree(e, t) {
  let n;
  return r;
  function r(...a) {
    const s = e.length > a.length;
    let c;
    s && a.push(i);
    try {
      c = e.apply(this, a);
    } catch (f) {
      const p = (
        /** @type {Error} */
        f
      );
      if (s && n)
        throw p;
      return i(p);
    }
    s || (c && c.then && typeof c.then == "function" ? c.then(o, i) : c instanceof Error ? i(c) : o(c));
  }
  function i(a, ...s) {
    n || (n = !0, t(a, ...s));
  }
  function o(a) {
    i(null, a);
  }
}
const iee = zS().freeze(), FS = {}.hasOwnProperty;
function zS() {
  const e = nee(), t = [];
  let n = {}, r, i = -1;
  return o.data = a, o.Parser = void 0, o.Compiler = void 0, o.freeze = s, o.attachers = t, o.use = c, o.parse = f, o.stringify = p, o.run = d, o.runSync = h, o.process = m, o.processSync = v, o;
  function o() {
    const w = zS();
    let b = -1;
    for (; ++b < t.length; )
      w.use(...t[b]);
    return w.data(M3(!0, {}, n)), w;
  }
  function a(w, b) {
    return typeof w == "string" ? arguments.length === 2 ? (Rh("data", r), n[w] = b, o) : FS.call(n, w) && n[w] || null : w ? (Rh("data", r), n = w, o) : n;
  }
  function s() {
    if (r)
      return o;
    for (; ++i < t.length; ) {
      const [w, ...b] = t[i];
      if (b[0] === !1)
        continue;
      b[0] === !0 && (b[0] = void 0);
      const E = w.call(o, ...b);
      typeof E == "function" && e.use(E);
    }
    return r = !0, i = Number.POSITIVE_INFINITY, o;
  }
  function c(w, ...b) {
    let E;
    if (Rh("use", r), w != null)
      if (typeof w == "function")
        T(w, ...b);
      else if (typeof w == "object")
        Array.isArray(w) ? _(w) : S(w);
      else
        throw new TypeError("Expected usable value, not `" + w + "`");
    return E && (n.settings = Object.assign(n.settings || {}, E)), o;
    function C(P) {
      if (typeof P == "function")
        T(P);
      else if (typeof P == "object")
        if (Array.isArray(P)) {
          const [R, ...N] = P;
          T(R, ...N);
        } else
          S(P);
      else
        throw new TypeError("Expected usable value, not `" + P + "`");
    }
    function S(P) {
      _(P.plugins), P.settings && (E = Object.assign(E || {}, P.settings));
    }
    function _(P) {
      let R = -1;
      if (P != null)
        if (Array.isArray(P))
          for (; ++R < P.length; ) {
            const N = P[R];
            C(N);
          }
        else
          throw new TypeError("Expected a list of plugins, not `" + P + "`");
    }
    function T(P, R) {
      let N = -1, B;
      for (; ++N < t.length; )
        if (t[N][0] === P) {
          B = t[N];
          break;
        }
      B ? (wg(B[1]) && wg(R) && (R = M3(!0, B[1], R)), B[1] = R) : t.push([...arguments]);
    }
  }
  function f(w) {
    o.freeze();
    const b = Ds(w), E = o.Parser;
    return Ph("parse", E), D3(E, "parse") ? new E(String(b), b).parse() : E(String(b), b);
  }
  function p(w, b) {
    o.freeze();
    const E = Ds(b), C = o.Compiler;
    return Ah("stringify", C), N3(w), D3(C, "compile") ? new C(w, E).compile() : C(w, E);
  }
  function d(w, b, E) {
    if (N3(w), o.freeze(), !E && typeof b == "function" && (E = b, b = void 0), !E)
      return new Promise(C);
    C(null, E);
    function C(S, _) {
      e.run(w, Ds(b), T);
      function T(P, R, N) {
        R = R || w, P ? _(P) : S ? S(R) : E(null, R, N);
      }
    }
  }
  function h(w, b) {
    let E, C;
    return o.run(w, b, S), I3("runSync", "run", C), E;
    function S(_, T) {
      T3(_), E = T, C = !0;
    }
  }
  function m(w, b) {
    if (o.freeze(), Ph("process", o.Parser), Ah("process", o.Compiler), !b)
      return new Promise(E);
    E(null, b);
    function E(C, S) {
      const _ = Ds(w);
      o.run(o.parse(_), _, (P, R, N) => {
        if (P || !R || !N)
          T(P);
        else {
          const B = o.stringify(R, N);
          B == null || (see(B) ? N.value = B : N.result = B), T(P, N);
        }
      });
      function T(P, R) {
        P || !R ? S(P) : C ? C(R) : b(null, R);
      }
    }
  }
  function v(w) {
    let b;
    o.freeze(), Ph("processSync", o.Parser), Ah("processSync", o.Compiler);
    const E = Ds(w);
    return o.process(E, C), I3("processSync", "process", b), E;
    function C(S) {
      b = !0, T3(S);
    }
  }
}
function D3(e, t) {
  return typeof e == "function" && // Prototypes do exist.
  // type-coverage:ignore-next-line
  e.prototype && // A function with keys in its prototype is probably a constructor.
  // Classes’ prototype methods are not enumerable, so we check if some value
  // exists in the prototype.
  // type-coverage:ignore-next-line
  (oee(e.prototype) || t in e.prototype);
}
function oee(e) {
  let t;
  for (t in e)
    if (FS.call(e, t))
      return !0;
  return !1;
}
function Ph(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Parser`");
}
function Ah(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Compiler`");
}
function Rh(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function N3(e) {
  if (!wg(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function I3(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function Ds(e) {
  return aee(e) ? e : new IS(e);
}
function aee(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function see(e) {
  return typeof e == "string" || NS(e);
}
const lee = {};
function cee(e, t) {
  const n = t || lee, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return VS(e, r, i);
}
function VS(e, t, n) {
  if (uee(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return L3(e.children, t, n);
  }
  return Array.isArray(e) ? L3(e, t, n) : "";
}
function L3(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = VS(e[i], t, n);
  return r.join("");
}
function uee(e) {
  return !!(e && typeof e == "object");
}
function nr(e, t, n, r) {
  const i = e.length;
  let o = 0, a;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    a = Array.from(r), a.unshift(t, n), e.splice(...a);
  else
    for (n && e.splice(t, n); o < r.length; )
      a = r.slice(o, o + 1e4), a.unshift(t, 0), e.splice(...a), o += 1e4, t += 1e4;
}
function wr(e, t) {
  return e.length > 0 ? (nr(e, e.length, 0, t), e) : t;
}
const F3 = {}.hasOwnProperty;
function BS(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    fee(t, e[n]);
  return t;
}
function fee(e, t) {
  let n;
  for (n in t) {
    const i = (F3.call(e, n) ? e[n] : void 0) || (e[n] = {}), o = t[n];
    let a;
    if (o)
      for (a in o) {
        F3.call(i, a) || (i[a] = []);
        const s = o[a];
        dee(
          // @ts-expect-error Looks like a list.
          i[a],
          Array.isArray(s) ? s : s ? [s] : []
        );
      }
  }
}
function dee(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  nr(e, 0, 0, r);
}
const pee = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, Rn = mo(/[A-Za-z]/), wn = mo(/[\dA-Za-z]/), hee = mo(/[#-'*+\--9=?A-Z^-~]/);
function lf(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const yg = mo(/\d/), mee = mo(/[\dA-Fa-f]/), gee = mo(/[!-/:-@[-`{-~]/);
function Ie(e) {
  return e !== null && e < -2;
}
function Tt(e) {
  return e !== null && (e < 0 || e === 32);
}
function Je(e) {
  return e === -2 || e === -1 || e === 32;
}
const fd = mo(pee), Go = mo(/\s/);
function mo(e) {
  return t;
  function t(n) {
    return n !== null && e.test(String.fromCharCode(n));
  }
}
function lt(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return a;
  function a(c) {
    return Je(c) ? (e.enter(n), s(c)) : t(c);
  }
  function s(c) {
    return Je(c) && o++ < i ? (e.consume(c), s) : (e.exit(n), t(c));
  }
}
const vee = {
  tokenize: wee
};
function wee(e) {
  const t = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    i
  );
  let n;
  return t;
  function r(s) {
    if (s === null) {
      e.consume(s);
      return;
    }
    return e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), lt(e, t, "linePrefix");
  }
  function i(s) {
    return e.enter("paragraph"), o(s);
  }
  function o(s) {
    const c = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = c), n = c, a(s);
  }
  function a(s) {
    if (s === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(s);
      return;
    }
    return Ie(s) ? (e.consume(s), e.exit("chunkText"), o) : (e.consume(s), a);
  }
}
const yee = {
  tokenize: bee
}, z3 = {
  tokenize: xee
};
function bee(e) {
  const t = this, n = [];
  let r = 0, i, o, a;
  return s;
  function s(S) {
    if (r < n.length) {
      const _ = n[r];
      return t.containerState = _[1], e.attempt(
        _[0].continuation,
        c,
        f
      )(S);
    }
    return f(S);
  }
  function c(S) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && C();
      const _ = t.events.length;
      let T = _, P;
      for (; T--; )
        if (t.events[T][0] === "exit" && t.events[T][1].type === "chunkFlow") {
          P = t.events[T][1].end;
          break;
        }
      E(r);
      let R = _;
      for (; R < t.events.length; )
        t.events[R][1].end = Object.assign({}, P), R++;
      return nr(
        t.events,
        T + 1,
        0,
        t.events.slice(_)
      ), t.events.length = R, f(S);
    }
    return s(S);
  }
  function f(S) {
    if (r === n.length) {
      if (!i)
        return h(S);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return v(S);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(
      z3,
      p,
      d
    )(S);
  }
  function p(S) {
    return i && C(), E(r), h(S);
  }
  function d(S) {
    return t.parser.lazy[t.now().line] = r !== n.length, a = t.now().offset, v(S);
  }
  function h(S) {
    return t.containerState = {}, e.attempt(
      z3,
      m,
      v
    )(S);
  }
  function m(S) {
    return r++, n.push([t.currentConstruct, t.containerState]), h(S);
  }
  function v(S) {
    if (S === null) {
      i && C(), E(0), e.consume(S);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: o,
      _tokenizer: i
    }), w(S);
  }
  function w(S) {
    if (S === null) {
      b(e.exit("chunkFlow"), !0), E(0), e.consume(S);
      return;
    }
    return Ie(S) ? (e.consume(S), b(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, s) : (e.consume(S), w);
  }
  function b(S, _) {
    const T = t.sliceStream(S);
    if (_ && T.push(null), S.previous = o, o && (o.next = S), o = S, i.defineSkip(S.start), i.write(T), t.parser.lazy[S.start.line]) {
      let P = i.events.length;
      for (; P--; )
        if (
          // The token starts before the line ending…
          i.events[P][1].start.offset < a && // …and either is not ended yet…
          (!i.events[P][1].end || // …or ends after it.
          i.events[P][1].end.offset > a)
        )
          return;
      const R = t.events.length;
      let N = R, B, L;
      for (; N--; )
        if (t.events[N][0] === "exit" && t.events[N][1].type === "chunkFlow") {
          if (B) {
            L = t.events[N][1].end;
            break;
          }
          B = !0;
        }
      for (E(r), P = R; P < t.events.length; )
        t.events[P][1].end = Object.assign({}, L), P++;
      nr(
        t.events,
        N + 1,
        0,
        t.events.slice(R)
      ), t.events.length = P;
    }
  }
  function E(S) {
    let _ = n.length;
    for (; _-- > S; ) {
      const T = n[_];
      t.containerState = T[1], T[0].exit.call(t, e);
    }
    n.length = S;
  }
  function C() {
    i.write([null]), o = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function xee(e, t, n) {
  return lt(
    e,
    e.attempt(this.parser.constructs.document, t, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function cf(e) {
  if (e === null || Tt(e) || Go(e))
    return 1;
  if (fd(e))
    return 2;
}
function dd(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const o = e[i].resolveAll;
    o && !r.includes(o) && (t = o(t, n), r.push(o));
  }
  return t;
}
const bg = {
  name: "attention",
  tokenize: Cee,
  resolveAll: Eee
};
function Eee(e, t) {
  let n = -1, r, i, o, a, s, c, f, p;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          c = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const d = Object.assign({}, e[r][1].end), h = Object.assign({}, e[n][1].start);
          V3(d, -c), V3(h, c), a = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: d,
            end: Object.assign({}, e[r][1].end)
          }, s = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[n][1].start),
            end: h
          }, o = {
            type: c > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[r][1].end),
            end: Object.assign({}, e[n][1].start)
          }, i = {
            type: c > 1 ? "strong" : "emphasis",
            start: Object.assign({}, a.start),
            end: Object.assign({}, s.end)
          }, e[r][1].end = Object.assign({}, a.start), e[n][1].start = Object.assign({}, s.end), f = [], e[r][1].end.offset - e[r][1].start.offset && (f = wr(f, [
            ["enter", e[r][1], t],
            ["exit", e[r][1], t]
          ])), f = wr(f, [
            ["enter", i, t],
            ["enter", a, t],
            ["exit", a, t],
            ["enter", o, t]
          ]), f = wr(
            f,
            dd(
              t.parser.constructs.insideSpan.null,
              e.slice(r + 1, n),
              t
            )
          ), f = wr(f, [
            ["exit", o, t],
            ["enter", s, t],
            ["exit", s, t],
            ["exit", i, t]
          ]), e[n][1].end.offset - e[n][1].start.offset ? (p = 2, f = wr(f, [
            ["enter", e[n][1], t],
            ["exit", e[n][1], t]
          ])) : p = 0, nr(e, r - 1, n - r + 3, f), n = r + f.length - p - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function Cee(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = cf(r);
  let o;
  return a;
  function a(c) {
    return o = c, e.enter("attentionSequence"), s(c);
  }
  function s(c) {
    if (c === o)
      return e.consume(c), s;
    const f = e.exit("attentionSequence"), p = cf(c), d = !p || p === 2 && i || n.includes(c), h = !i || i === 2 && p || n.includes(r);
    return f._open = !!(o === 42 ? d : d && (i || !h)), f._close = !!(o === 42 ? h : h && (p || !d)), t(c);
  }
}
function V3(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const See = {
  name: "autolink",
  tokenize: _ee
};
function _ee(e, t, n) {
  let r = 0;
  return i;
  function i(m) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(m), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(m) {
    return Rn(m) ? (e.consume(m), a) : f(m);
  }
  function a(m) {
    return m === 43 || m === 45 || m === 46 || wn(m) ? (r = 1, s(m)) : f(m);
  }
  function s(m) {
    return m === 58 ? (e.consume(m), r = 0, c) : (m === 43 || m === 45 || m === 46 || wn(m)) && r++ < 32 ? (e.consume(m), s) : (r = 0, f(m));
  }
  function c(m) {
    return m === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(m), e.exit("autolinkMarker"), e.exit("autolink"), t) : m === null || m === 32 || m === 60 || lf(m) ? n(m) : (e.consume(m), c);
  }
  function f(m) {
    return m === 64 ? (e.consume(m), p) : hee(m) ? (e.consume(m), f) : n(m);
  }
  function p(m) {
    return wn(m) ? d(m) : n(m);
  }
  function d(m) {
    return m === 46 ? (e.consume(m), r = 0, p) : m === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(m), e.exit("autolinkMarker"), e.exit("autolink"), t) : h(m);
  }
  function h(m) {
    if ((m === 45 || wn(m)) && r++ < 63) {
      const v = m === 45 ? h : d;
      return e.consume(m), v;
    }
    return n(m);
  }
}
const Ml = {
  tokenize: Tee,
  partial: !0
};
function Tee(e, t, n) {
  return r;
  function r(o) {
    return Je(o) ? lt(e, i, "linePrefix")(o) : i(o);
  }
  function i(o) {
    return o === null || Ie(o) ? t(o) : n(o);
  }
}
const HS = {
  name: "blockQuote",
  tokenize: kee,
  continuation: {
    tokenize: Pee
  },
  exit: Aee
};
function kee(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    if (a === 62) {
      const s = r.containerState;
      return s.open || (e.enter("blockQuote", {
        _container: !0
      }), s.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(a), e.exit("blockQuoteMarker"), o;
    }
    return n(a);
  }
  function o(a) {
    return Je(a) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(a), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(a));
  }
}
function Pee(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return Je(a) ? lt(
      e,
      o,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(a) : o(a);
  }
  function o(a) {
    return e.attempt(HS, t, n)(a);
  }
}
function Aee(e) {
  e.exit("blockQuote");
}
const US = {
  name: "characterEscape",
  tokenize: Ree
};
function Ree(e, t, n) {
  return r;
  function r(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), i;
  }
  function i(o) {
    return gee(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(o);
  }
}
const B3 = document.createElement("i");
function Mv(e) {
  const t = "&" + e + ";";
  B3.innerHTML = t;
  const n = B3.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n
  );
}
const WS = {
  name: "characterReference",
  tokenize: $ee
};
function $ee(e, t, n) {
  const r = this;
  let i = 0, o, a;
  return s;
  function s(d) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), c;
  }
  function c(d) {
    return d === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(d), e.exit("characterReferenceMarkerNumeric"), f) : (e.enter("characterReferenceValue"), o = 31, a = wn, p(d));
  }
  function f(d) {
    return d === 88 || d === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(d), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, a = mee, p) : (e.enter("characterReferenceValue"), o = 7, a = yg, p(d));
  }
  function p(d) {
    if (d === 59 && i) {
      const h = e.exit("characterReferenceValue");
      return a === wn && !Mv(r.sliceSerialize(h)) ? n(d) : (e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return a(d) && i++ < o ? (e.consume(d), p) : n(d);
  }
}
const H3 = {
  tokenize: Mee,
  partial: !0
}, U3 = {
  name: "codeFenced",
  tokenize: Oee,
  concrete: !0
};
function Oee(e, t, n) {
  const r = this, i = {
    tokenize: T,
    partial: !0
  };
  let o = 0, a = 0, s;
  return c;
  function c(P) {
    return f(P);
  }
  function f(P) {
    const R = r.events[r.events.length - 1];
    return o = R && R[1].type === "linePrefix" ? R[2].sliceSerialize(R[1], !0).length : 0, s = P, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), p(P);
  }
  function p(P) {
    return P === s ? (a++, e.consume(P), p) : a < 3 ? n(P) : (e.exit("codeFencedFenceSequence"), Je(P) ? lt(e, d, "whitespace")(P) : d(P));
  }
  function d(P) {
    return P === null || Ie(P) ? (e.exit("codeFencedFence"), r.interrupt ? t(P) : e.check(H3, w, _)(P)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(P));
  }
  function h(P) {
    return P === null || Ie(P) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), d(P)) : Je(P) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), lt(e, m, "whitespace")(P)) : P === 96 && P === s ? n(P) : (e.consume(P), h);
  }
  function m(P) {
    return P === null || Ie(P) ? d(P) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), v(P));
  }
  function v(P) {
    return P === null || Ie(P) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), d(P)) : P === 96 && P === s ? n(P) : (e.consume(P), v);
  }
  function w(P) {
    return e.attempt(i, _, b)(P);
  }
  function b(P) {
    return e.enter("lineEnding"), e.consume(P), e.exit("lineEnding"), E;
  }
  function E(P) {
    return o > 0 && Je(P) ? lt(
      e,
      C,
      "linePrefix",
      o + 1
    )(P) : C(P);
  }
  function C(P) {
    return P === null || Ie(P) ? e.check(H3, w, _)(P) : (e.enter("codeFlowValue"), S(P));
  }
  function S(P) {
    return P === null || Ie(P) ? (e.exit("codeFlowValue"), C(P)) : (e.consume(P), S);
  }
  function _(P) {
    return e.exit("codeFenced"), t(P);
  }
  function T(P, R, N) {
    let B = 0;
    return L;
    function L(G) {
      return P.enter("lineEnding"), P.consume(G), P.exit("lineEnding"), j;
    }
    function j(G) {
      return P.enter("codeFencedFence"), Je(G) ? lt(
        P,
        I,
        "linePrefix",
        r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(G) : I(G);
    }
    function I(G) {
      return G === s ? (P.enter("codeFencedFenceSequence"), z(G)) : N(G);
    }
    function z(G) {
      return G === s ? (B++, P.consume(G), z) : B >= a ? (P.exit("codeFencedFenceSequence"), Je(G) ? lt(P, H, "whitespace")(G) : H(G)) : N(G);
    }
    function H(G) {
      return G === null || Ie(G) ? (P.exit("codeFencedFence"), R(G)) : N(G);
    }
  }
}
function Mee(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return a === null ? n(a) : (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), o);
  }
  function o(a) {
    return r.parser.lazy[r.now().line] ? n(a) : t(a);
  }
}
const $h = {
  name: "codeIndented",
  tokenize: Nee
}, Dee = {
  tokenize: Iee,
  partial: !0
};
function Nee(e, t, n) {
  const r = this;
  return i;
  function i(f) {
    return e.enter("codeIndented"), lt(e, o, "linePrefix", 4 + 1)(f);
  }
  function o(f) {
    const p = r.events[r.events.length - 1];
    return p && p[1].type === "linePrefix" && p[2].sliceSerialize(p[1], !0).length >= 4 ? a(f) : n(f);
  }
  function a(f) {
    return f === null ? c(f) : Ie(f) ? e.attempt(Dee, a, c)(f) : (e.enter("codeFlowValue"), s(f));
  }
  function s(f) {
    return f === null || Ie(f) ? (e.exit("codeFlowValue"), a(f)) : (e.consume(f), s);
  }
  function c(f) {
    return e.exit("codeIndented"), t(f);
  }
}
function Iee(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return r.parser.lazy[r.now().line] ? n(a) : Ie(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), i) : lt(e, o, "linePrefix", 4 + 1)(a);
  }
  function o(a) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(a) : Ie(a) ? i(a) : n(a);
  }
}
const Lee = {
  name: "codeText",
  tokenize: Vee,
  resolve: Fee,
  previous: zee
};
function Fee(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function zee(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Vee(e, t, n) {
  let r = 0, i, o;
  return a;
  function a(d) {
    return e.enter("codeText"), e.enter("codeTextSequence"), s(d);
  }
  function s(d) {
    return d === 96 ? (e.consume(d), r++, s) : (e.exit("codeTextSequence"), c(d));
  }
  function c(d) {
    return d === null ? n(d) : d === 32 ? (e.enter("space"), e.consume(d), e.exit("space"), c) : d === 96 ? (o = e.enter("codeTextSequence"), i = 0, p(d)) : Ie(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), c) : (e.enter("codeTextData"), f(d));
  }
  function f(d) {
    return d === null || d === 32 || d === 96 || Ie(d) ? (e.exit("codeTextData"), c(d)) : (e.consume(d), f);
  }
  function p(d) {
    return d === 96 ? (e.consume(d), i++, p) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(d)) : (o.type = "codeTextData", f(d));
  }
}
function jS(e) {
  const t = {};
  let n = -1, r, i, o, a, s, c, f;
  for (; ++n < e.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = e[n], n && r[1].type === "chunkFlow" && e[n - 1][1].type === "listItemPrefix" && (c = r[1]._tokenizer.events, o = 0, o < c.length && c[o][1].type === "lineEndingBlank" && (o += 2), o < c.length && c[o][1].type === "content"))
      for (; ++o < c.length && c[o][1].type !== "content"; )
        c[o][1].type === "chunkText" && (c[o][1]._isInFirstContentOfListItem = !0, o++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, Bee(e, n)), n = t[n], f = !0);
    else if (r[1]._container) {
      for (o = n, i = void 0; o-- && (a = e[o], a[1].type === "lineEnding" || a[1].type === "lineEndingBlank"); )
        a[0] === "enter" && (i && (e[i][1].type = "lineEndingBlank"), a[1].type = "lineEnding", i = o);
      i && (r[1].end = Object.assign({}, e[i][1].start), s = e.slice(i, n), s.unshift(r), nr(e, i, n - i + 1, s));
    }
  }
  return !f;
}
function Bee(e, t) {
  const n = e[t][1], r = e[t][2];
  let i = t - 1;
  const o = [], a = n._tokenizer || r.parser[n.contentType](n.start), s = a.events, c = [], f = {};
  let p, d, h = -1, m = n, v = 0, w = 0;
  const b = [w];
  for (; m; ) {
    for (; e[++i][1] !== m; )
      ;
    o.push(i), m._tokenizer || (p = r.sliceStream(m), m.next || p.push(null), d && a.defineSkip(m.start), m._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = !0), a.write(p), m._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = void 0)), d = m, m = m.next;
  }
  for (m = n; ++h < s.length; )
    // Find a void token that includes a break.
    s[h][0] === "exit" && s[h - 1][0] === "enter" && s[h][1].type === s[h - 1][1].type && s[h][1].start.line !== s[h][1].end.line && (w = h + 1, b.push(w), m._tokenizer = void 0, m.previous = void 0, m = m.next);
  for (a.events = [], m ? (m._tokenizer = void 0, m.previous = void 0) : b.pop(), h = b.length; h--; ) {
    const E = s.slice(b[h], b[h + 1]), C = o.pop();
    c.unshift([C, C + E.length - 1]), nr(e, C, 2, E);
  }
  for (h = -1; ++h < c.length; )
    f[v + c[h][0]] = v + c[h][1], v += c[h][1] - c[h][0] - 1;
  return f;
}
const Hee = {
  tokenize: jee,
  resolve: Wee
}, Uee = {
  tokenize: qee,
  partial: !0
};
function Wee(e) {
  return jS(e), e;
}
function jee(e, t) {
  let n;
  return r;
  function r(s) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(s);
  }
  function i(s) {
    return s === null ? o(s) : Ie(s) ? e.check(
      Uee,
      a,
      o
    )(s) : (e.consume(s), i);
  }
  function o(s) {
    return e.exit("chunkContent"), e.exit("content"), t(s);
  }
  function a(s) {
    return e.consume(s), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function qee(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), lt(e, o, "linePrefix");
  }
  function o(a) {
    if (a === null || Ie(a))
      return n(a);
    const s = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(a) : e.interrupt(r.parser.constructs.flow, n, t)(a);
  }
}
function qS(e, t, n, r, i, o, a, s, c) {
  const f = c || Number.POSITIVE_INFINITY;
  let p = 0;
  return d;
  function d(E) {
    return E === 60 ? (e.enter(r), e.enter(i), e.enter(o), e.consume(E), e.exit(o), h) : E === null || E === 32 || E === 41 || lf(E) ? n(E) : (e.enter(r), e.enter(a), e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), w(E));
  }
  function h(E) {
    return E === 62 ? (e.enter(o), e.consume(E), e.exit(o), e.exit(i), e.exit(r), t) : (e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), m(E));
  }
  function m(E) {
    return E === 62 ? (e.exit("chunkString"), e.exit(s), h(E)) : E === null || E === 60 || Ie(E) ? n(E) : (e.consume(E), E === 92 ? v : m);
  }
  function v(E) {
    return E === 60 || E === 62 || E === 92 ? (e.consume(E), m) : m(E);
  }
  function w(E) {
    return !p && (E === null || E === 41 || Tt(E)) ? (e.exit("chunkString"), e.exit(s), e.exit(a), e.exit(r), t(E)) : p < f && E === 40 ? (e.consume(E), p++, w) : E === 41 ? (e.consume(E), p--, w) : E === null || E === 32 || E === 40 || lf(E) ? n(E) : (e.consume(E), E === 92 ? b : w);
  }
  function b(E) {
    return E === 40 || E === 41 || E === 92 ? (e.consume(E), w) : w(E);
  }
}
function GS(e, t, n, r, i, o) {
  const a = this;
  let s = 0, c;
  return f;
  function f(m) {
    return e.enter(r), e.enter(i), e.consume(m), e.exit(i), e.enter(o), p;
  }
  function p(m) {
    return s > 999 || m === null || m === 91 || m === 93 && !c || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    m === 94 && !s && "_hiddenFootnoteSupport" in a.parser.constructs ? n(m) : m === 93 ? (e.exit(o), e.enter(i), e.consume(m), e.exit(i), e.exit(r), t) : Ie(m) ? (e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), p) : (e.enter("chunkString", {
      contentType: "string"
    }), d(m));
  }
  function d(m) {
    return m === null || m === 91 || m === 93 || Ie(m) || s++ > 999 ? (e.exit("chunkString"), p(m)) : (e.consume(m), c || (c = !Je(m)), m === 92 ? h : d);
  }
  function h(m) {
    return m === 91 || m === 92 || m === 93 ? (e.consume(m), s++, d) : d(m);
  }
}
function YS(e, t, n, r, i, o) {
  let a;
  return s;
  function s(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(r), e.enter(i), e.consume(h), e.exit(i), a = h === 40 ? 41 : h, c) : n(h);
  }
  function c(h) {
    return h === a ? (e.enter(i), e.consume(h), e.exit(i), e.exit(r), t) : (e.enter(o), f(h));
  }
  function f(h) {
    return h === a ? (e.exit(o), c(a)) : h === null ? n(h) : Ie(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), lt(e, f, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), p(h));
  }
  function p(h) {
    return h === a || h === null || Ie(h) ? (e.exit("chunkString"), f(h)) : (e.consume(h), h === 92 ? d : p);
  }
  function d(h) {
    return h === a || h === 92 ? (e.consume(h), p) : p(h);
  }
}
function Gs(e, t) {
  let n;
  return r;
  function r(i) {
    return Ie(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : Je(i) ? lt(
      e,
      r,
      n ? "linePrefix" : "lineSuffix"
    )(i) : t(i);
  }
}
function Ur(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Gee = {
  name: "definition",
  tokenize: Kee
}, Yee = {
  tokenize: Xee,
  partial: !0
};
function Kee(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(m) {
    return e.enter("definition"), a(m);
  }
  function a(m) {
    return GS.call(
      r,
      e,
      s,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(m);
  }
  function s(m) {
    return i = Ur(
      r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
    ), m === 58 ? (e.enter("definitionMarker"), e.consume(m), e.exit("definitionMarker"), c) : n(m);
  }
  function c(m) {
    return Tt(m) ? Gs(e, f)(m) : f(m);
  }
  function f(m) {
    return qS(
      e,
      p,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(m);
  }
  function p(m) {
    return e.attempt(Yee, d, d)(m);
  }
  function d(m) {
    return Je(m) ? lt(e, h, "whitespace")(m) : h(m);
  }
  function h(m) {
    return m === null || Ie(m) ? (e.exit("definition"), r.parser.defined.push(i), t(m)) : n(m);
  }
}
function Xee(e, t, n) {
  return r;
  function r(s) {
    return Tt(s) ? Gs(e, i)(s) : n(s);
  }
  function i(s) {
    return YS(
      e,
      o,
      n,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(s);
  }
  function o(s) {
    return Je(s) ? lt(e, a, "whitespace")(s) : a(s);
  }
  function a(s) {
    return s === null || Ie(s) ? t(s) : n(s);
  }
}
const Qee = {
  name: "hardBreakEscape",
  tokenize: Zee
};
function Zee(e, t, n) {
  return r;
  function r(o) {
    return e.enter("hardBreakEscape"), e.consume(o), i;
  }
  function i(o) {
    return Ie(o) ? (e.exit("hardBreakEscape"), t(o)) : n(o);
  }
}
const Jee = {
  name: "headingAtx",
  tokenize: tte,
  resolve: ete
};
function ete(e, t) {
  let n = e.length - 2, r = 3, i, o;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, o = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, nr(e, r, n - r + 1, [
    ["enter", i, t],
    ["enter", o, t],
    ["exit", o, t],
    ["exit", i, t]
  ])), e;
}
function tte(e, t, n) {
  let r = 0;
  return i;
  function i(p) {
    return e.enter("atxHeading"), o(p);
  }
  function o(p) {
    return e.enter("atxHeadingSequence"), a(p);
  }
  function a(p) {
    return p === 35 && r++ < 6 ? (e.consume(p), a) : p === null || Tt(p) ? (e.exit("atxHeadingSequence"), s(p)) : n(p);
  }
  function s(p) {
    return p === 35 ? (e.enter("atxHeadingSequence"), c(p)) : p === null || Ie(p) ? (e.exit("atxHeading"), t(p)) : Je(p) ? lt(e, s, "whitespace")(p) : (e.enter("atxHeadingText"), f(p));
  }
  function c(p) {
    return p === 35 ? (e.consume(p), c) : (e.exit("atxHeadingSequence"), s(p));
  }
  function f(p) {
    return p === null || p === 35 || Tt(p) ? (e.exit("atxHeadingText"), s(p)) : (e.consume(p), f);
  }
}
const nte = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], W3 = ["pre", "script", "style", "textarea"], rte = {
  name: "htmlFlow",
  tokenize: ste,
  resolveTo: ate,
  concrete: !0
}, ite = {
  tokenize: cte,
  partial: !0
}, ote = {
  tokenize: lte,
  partial: !0
};
function ate(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function ste(e, t, n) {
  const r = this;
  let i, o, a, s, c;
  return f;
  function f(M) {
    return p(M);
  }
  function p(M) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(M), d;
  }
  function d(M) {
    return M === 33 ? (e.consume(M), h) : M === 47 ? (e.consume(M), o = !0, w) : M === 63 ? (e.consume(M), i = 3, r.interrupt ? t : A) : Rn(M) ? (e.consume(M), a = String.fromCharCode(M), b) : n(M);
  }
  function h(M) {
    return M === 45 ? (e.consume(M), i = 2, m) : M === 91 ? (e.consume(M), i = 5, s = 0, v) : Rn(M) ? (e.consume(M), i = 4, r.interrupt ? t : A) : n(M);
  }
  function m(M) {
    return M === 45 ? (e.consume(M), r.interrupt ? t : A) : n(M);
  }
  function v(M) {
    const Z = "CDATA[";
    return M === Z.charCodeAt(s++) ? (e.consume(M), s === Z.length ? r.interrupt ? t : I : v) : n(M);
  }
  function w(M) {
    return Rn(M) ? (e.consume(M), a = String.fromCharCode(M), b) : n(M);
  }
  function b(M) {
    if (M === null || M === 47 || M === 62 || Tt(M)) {
      const Z = M === 47, ie = a.toLowerCase();
      return !Z && !o && W3.includes(ie) ? (i = 1, r.interrupt ? t(M) : I(M)) : nte.includes(a.toLowerCase()) ? (i = 6, Z ? (e.consume(M), E) : r.interrupt ? t(M) : I(M)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(M) : o ? C(M) : S(M));
    }
    return M === 45 || wn(M) ? (e.consume(M), a += String.fromCharCode(M), b) : n(M);
  }
  function E(M) {
    return M === 62 ? (e.consume(M), r.interrupt ? t : I) : n(M);
  }
  function C(M) {
    return Je(M) ? (e.consume(M), C) : L(M);
  }
  function S(M) {
    return M === 47 ? (e.consume(M), L) : M === 58 || M === 95 || Rn(M) ? (e.consume(M), _) : Je(M) ? (e.consume(M), S) : L(M);
  }
  function _(M) {
    return M === 45 || M === 46 || M === 58 || M === 95 || wn(M) ? (e.consume(M), _) : T(M);
  }
  function T(M) {
    return M === 61 ? (e.consume(M), P) : Je(M) ? (e.consume(M), T) : S(M);
  }
  function P(M) {
    return M === null || M === 60 || M === 61 || M === 62 || M === 96 ? n(M) : M === 34 || M === 39 ? (e.consume(M), c = M, R) : Je(M) ? (e.consume(M), P) : N(M);
  }
  function R(M) {
    return M === c ? (e.consume(M), c = null, B) : M === null || Ie(M) ? n(M) : (e.consume(M), R);
  }
  function N(M) {
    return M === null || M === 34 || M === 39 || M === 47 || M === 60 || M === 61 || M === 62 || M === 96 || Tt(M) ? T(M) : (e.consume(M), N);
  }
  function B(M) {
    return M === 47 || M === 62 || Je(M) ? S(M) : n(M);
  }
  function L(M) {
    return M === 62 ? (e.consume(M), j) : n(M);
  }
  function j(M) {
    return M === null || Ie(M) ? I(M) : Je(M) ? (e.consume(M), j) : n(M);
  }
  function I(M) {
    return M === 45 && i === 2 ? (e.consume(M), Y) : M === 60 && i === 1 ? (e.consume(M), ne) : M === 62 && i === 4 ? (e.consume(M), X) : M === 63 && i === 3 ? (e.consume(M), A) : M === 93 && i === 5 ? (e.consume(M), ee) : Ie(M) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(
      ite,
      fe,
      z
    )(M)) : M === null || Ie(M) ? (e.exit("htmlFlowData"), z(M)) : (e.consume(M), I);
  }
  function z(M) {
    return e.check(
      ote,
      H,
      fe
    )(M);
  }
  function H(M) {
    return e.enter("lineEnding"), e.consume(M), e.exit("lineEnding"), G;
  }
  function G(M) {
    return M === null || Ie(M) ? z(M) : (e.enter("htmlFlowData"), I(M));
  }
  function Y(M) {
    return M === 45 ? (e.consume(M), A) : I(M);
  }
  function ne(M) {
    return M === 47 ? (e.consume(M), a = "", J) : I(M);
  }
  function J(M) {
    if (M === 62) {
      const Z = a.toLowerCase();
      return W3.includes(Z) ? (e.consume(M), X) : I(M);
    }
    return Rn(M) && a.length < 8 ? (e.consume(M), a += String.fromCharCode(M), J) : I(M);
  }
  function ee(M) {
    return M === 93 ? (e.consume(M), A) : I(M);
  }
  function A(M) {
    return M === 62 ? (e.consume(M), X) : M === 45 && i === 2 ? (e.consume(M), A) : I(M);
  }
  function X(M) {
    return M === null || Ie(M) ? (e.exit("htmlFlowData"), fe(M)) : (e.consume(M), X);
  }
  function fe(M) {
    return e.exit("htmlFlow"), t(M);
  }
}
function lte(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return Ie(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), o) : n(a);
  }
  function o(a) {
    return r.parser.lazy[r.now().line] ? n(a) : t(a);
  }
}
function cte(e, t, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(Ml, t, n);
  }
}
const ute = {
  name: "htmlText",
  tokenize: fte
};
function fte(e, t, n) {
  const r = this;
  let i, o, a;
  return s;
  function s(A) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(A), c;
  }
  function c(A) {
    return A === 33 ? (e.consume(A), f) : A === 47 ? (e.consume(A), T) : A === 63 ? (e.consume(A), S) : Rn(A) ? (e.consume(A), N) : n(A);
  }
  function f(A) {
    return A === 45 ? (e.consume(A), p) : A === 91 ? (e.consume(A), o = 0, v) : Rn(A) ? (e.consume(A), C) : n(A);
  }
  function p(A) {
    return A === 45 ? (e.consume(A), m) : n(A);
  }
  function d(A) {
    return A === null ? n(A) : A === 45 ? (e.consume(A), h) : Ie(A) ? (a = d, ne(A)) : (e.consume(A), d);
  }
  function h(A) {
    return A === 45 ? (e.consume(A), m) : d(A);
  }
  function m(A) {
    return A === 62 ? Y(A) : A === 45 ? h(A) : d(A);
  }
  function v(A) {
    const X = "CDATA[";
    return A === X.charCodeAt(o++) ? (e.consume(A), o === X.length ? w : v) : n(A);
  }
  function w(A) {
    return A === null ? n(A) : A === 93 ? (e.consume(A), b) : Ie(A) ? (a = w, ne(A)) : (e.consume(A), w);
  }
  function b(A) {
    return A === 93 ? (e.consume(A), E) : w(A);
  }
  function E(A) {
    return A === 62 ? Y(A) : A === 93 ? (e.consume(A), E) : w(A);
  }
  function C(A) {
    return A === null || A === 62 ? Y(A) : Ie(A) ? (a = C, ne(A)) : (e.consume(A), C);
  }
  function S(A) {
    return A === null ? n(A) : A === 63 ? (e.consume(A), _) : Ie(A) ? (a = S, ne(A)) : (e.consume(A), S);
  }
  function _(A) {
    return A === 62 ? Y(A) : S(A);
  }
  function T(A) {
    return Rn(A) ? (e.consume(A), P) : n(A);
  }
  function P(A) {
    return A === 45 || wn(A) ? (e.consume(A), P) : R(A);
  }
  function R(A) {
    return Ie(A) ? (a = R, ne(A)) : Je(A) ? (e.consume(A), R) : Y(A);
  }
  function N(A) {
    return A === 45 || wn(A) ? (e.consume(A), N) : A === 47 || A === 62 || Tt(A) ? B(A) : n(A);
  }
  function B(A) {
    return A === 47 ? (e.consume(A), Y) : A === 58 || A === 95 || Rn(A) ? (e.consume(A), L) : Ie(A) ? (a = B, ne(A)) : Je(A) ? (e.consume(A), B) : Y(A);
  }
  function L(A) {
    return A === 45 || A === 46 || A === 58 || A === 95 || wn(A) ? (e.consume(A), L) : j(A);
  }
  function j(A) {
    return A === 61 ? (e.consume(A), I) : Ie(A) ? (a = j, ne(A)) : Je(A) ? (e.consume(A), j) : B(A);
  }
  function I(A) {
    return A === null || A === 60 || A === 61 || A === 62 || A === 96 ? n(A) : A === 34 || A === 39 ? (e.consume(A), i = A, z) : Ie(A) ? (a = I, ne(A)) : Je(A) ? (e.consume(A), I) : (e.consume(A), H);
  }
  function z(A) {
    return A === i ? (e.consume(A), i = void 0, G) : A === null ? n(A) : Ie(A) ? (a = z, ne(A)) : (e.consume(A), z);
  }
  function H(A) {
    return A === null || A === 34 || A === 39 || A === 60 || A === 61 || A === 96 ? n(A) : A === 47 || A === 62 || Tt(A) ? B(A) : (e.consume(A), H);
  }
  function G(A) {
    return A === 47 || A === 62 || Tt(A) ? B(A) : n(A);
  }
  function Y(A) {
    return A === 62 ? (e.consume(A), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(A);
  }
  function ne(A) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(A), e.exit("lineEnding"), J;
  }
  function J(A) {
    return Je(A) ? lt(
      e,
      ee,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(A) : ee(A);
  }
  function ee(A) {
    return e.enter("htmlTextData"), a(A);
  }
}
const Dv = {
  name: "labelEnd",
  tokenize: vte,
  resolveTo: gte,
  resolveAll: mte
}, dte = {
  tokenize: wte
}, pte = {
  tokenize: yte
}, hte = {
  tokenize: bte
};
function mte(e) {
  let t = -1;
  for (; ++t < e.length; ) {
    const n = e[t][1];
    (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (e.splice(t + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", t++);
  }
  return e;
}
function gte(e, t) {
  let n = e.length, r = 0, i, o, a, s;
  for (; n--; )
    if (i = e[n][1], o) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (a) {
      if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (o = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else
      i.type === "labelEnd" && (a = n);
  const c = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[o][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, f = {
    type: "label",
    start: Object.assign({}, e[o][1].start),
    end: Object.assign({}, e[a][1].end)
  }, p = {
    type: "labelText",
    start: Object.assign({}, e[o + r + 2][1].end),
    end: Object.assign({}, e[a - 2][1].start)
  };
  return s = [
    ["enter", c, t],
    ["enter", f, t]
  ], s = wr(s, e.slice(o + 1, o + r + 3)), s = wr(s, [["enter", p, t]]), s = wr(
    s,
    dd(
      t.parser.constructs.insideSpan.null,
      e.slice(o + r + 4, a - 3),
      t
    )
  ), s = wr(s, [
    ["exit", p, t],
    e[a - 2],
    e[a - 1],
    ["exit", f, t]
  ]), s = wr(s, e.slice(a + 1)), s = wr(s, [["exit", c, t]]), nr(e, o, e.length, s), e;
}
function vte(e, t, n) {
  const r = this;
  let i = r.events.length, o, a;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      o = r.events[i][1];
      break;
    }
  return s;
  function s(h) {
    return o ? o._inactive ? d(h) : (a = r.parser.defined.includes(
      Ur(
        r.sliceSerialize({
          start: o.end,
          end: r.now()
        })
      )
    ), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), c) : n(h);
  }
  function c(h) {
    return h === 40 ? e.attempt(
      dte,
      p,
      a ? p : d
    )(h) : h === 91 ? e.attempt(
      pte,
      p,
      a ? f : d
    )(h) : a ? p(h) : d(h);
  }
  function f(h) {
    return e.attempt(
      hte,
      p,
      d
    )(h);
  }
  function p(h) {
    return t(h);
  }
  function d(h) {
    return o._balanced = !0, n(h);
  }
}
function wte(e, t, n) {
  return r;
  function r(d) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), i;
  }
  function i(d) {
    return Tt(d) ? Gs(e, o)(d) : o(d);
  }
  function o(d) {
    return d === 41 ? p(d) : qS(
      e,
      a,
      s,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(d);
  }
  function a(d) {
    return Tt(d) ? Gs(e, c)(d) : p(d);
  }
  function s(d) {
    return n(d);
  }
  function c(d) {
    return d === 34 || d === 39 || d === 40 ? YS(
      e,
      f,
      n,
      "resourceTitle",
      "resourceTitleMarker",
      "resourceTitleString"
    )(d) : p(d);
  }
  function f(d) {
    return Tt(d) ? Gs(e, p)(d) : p(d);
  }
  function p(d) {
    return d === 41 ? (e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), e.exit("resource"), t) : n(d);
  }
}
function yte(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return GS.call(
      r,
      e,
      o,
      a,
      "reference",
      "referenceMarker",
      "referenceString"
    )(s);
  }
  function o(s) {
    return r.parser.defined.includes(
      Ur(
        r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
      )
    ) ? t(s) : n(s);
  }
  function a(s) {
    return n(s);
  }
}
function bte(e, t, n) {
  return r;
  function r(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), i;
  }
  function i(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), t) : n(o);
  }
}
const xte = {
  name: "labelStartImage",
  tokenize: Ete,
  resolveAll: Dv.resolveAll
};
function Ete(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(s), e.exit("labelImageMarker"), o;
  }
  function o(s) {
    return s === 91 ? (e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelImage"), a) : n(s);
  }
  function a(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : t(s);
  }
}
const Cte = {
  name: "labelStartLink",
  tokenize: Ste,
  resolveAll: Dv.resolveAll
};
function Ste(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(a), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(a) : t(a);
  }
}
const Oh = {
  name: "lineEnding",
  tokenize: _te
};
function _te(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), lt(e, t, "linePrefix");
  }
}
const Tu = {
  name: "thematicBreak",
  tokenize: Tte
};
function Tte(e, t, n) {
  let r = 0, i;
  return o;
  function o(f) {
    return e.enter("thematicBreak"), a(f);
  }
  function a(f) {
    return i = f, s(f);
  }
  function s(f) {
    return f === i ? (e.enter("thematicBreakSequence"), c(f)) : r >= 3 && (f === null || Ie(f)) ? (e.exit("thematicBreak"), t(f)) : n(f);
  }
  function c(f) {
    return f === i ? (e.consume(f), r++, c) : (e.exit("thematicBreakSequence"), Je(f) ? lt(e, s, "whitespace")(f) : s(f));
  }
}
const Hn = {
  name: "list",
  tokenize: Ate,
  continuation: {
    tokenize: Rte
  },
  exit: Ote
}, kte = {
  tokenize: Mte,
  partial: !0
}, Pte = {
  tokenize: $te,
  partial: !0
};
function Ate(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let o = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, a = 0;
  return s;
  function s(m) {
    const v = r.containerState.type || (m === 42 || m === 43 || m === 45 ? "listUnordered" : "listOrdered");
    if (v === "listUnordered" ? !r.containerState.marker || m === r.containerState.marker : yg(m)) {
      if (r.containerState.type || (r.containerState.type = v, e.enter(v, {
        _container: !0
      })), v === "listUnordered")
        return e.enter("listItemPrefix"), m === 42 || m === 45 ? e.check(Tu, n, f)(m) : f(m);
      if (!r.interrupt || m === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), c(m);
    }
    return n(m);
  }
  function c(m) {
    return yg(m) && ++a < 10 ? (e.consume(m), c) : (!r.interrupt || a < 2) && (r.containerState.marker ? m === r.containerState.marker : m === 41 || m === 46) ? (e.exit("listItemValue"), f(m)) : n(m);
  }
  function f(m) {
    return e.enter("listItemMarker"), e.consume(m), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || m, e.check(
      Ml,
      // Can’t be empty when interrupting.
      r.interrupt ? n : p,
      e.attempt(
        kte,
        h,
        d
      )
    );
  }
  function p(m) {
    return r.containerState.initialBlankLine = !0, o++, h(m);
  }
  function d(m) {
    return Je(m) ? (e.enter("listItemPrefixWhitespace"), e.consume(m), e.exit("listItemPrefixWhitespace"), h) : n(m);
  }
  function h(m) {
    return r.containerState.size = o + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(m);
  }
}
function Rte(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(Ml, i, o);
  function i(s) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, lt(
      e,
      t,
      "listItemIndent",
      r.containerState.size + 1
    )(s);
  }
  function o(s) {
    return r.containerState.furtherBlankLines || !Je(s) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, a(s)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(Pte, t, a)(s));
  }
  function a(s) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, lt(
      e,
      e.attempt(Hn, t, n),
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(s);
  }
}
function $te(e, t, n) {
  const r = this;
  return lt(
    e,
    i,
    "listItemIndent",
    r.containerState.size + 1
  );
  function i(o) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "listItemIndent" && a[2].sliceSerialize(a[1], !0).length === r.containerState.size ? t(o) : n(o);
  }
}
function Ote(e) {
  e.exit(this.containerState.type);
}
function Mte(e, t, n) {
  const r = this;
  return lt(
    e,
    i,
    "listItemPrefixWhitespace",
    r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1
  );
  function i(o) {
    const a = r.events[r.events.length - 1];
    return !Je(o) && a && a[1].type === "listItemPrefixWhitespace" ? t(o) : n(o);
  }
}
const j3 = {
  name: "setextUnderline",
  tokenize: Nte,
  resolveTo: Dte
};
function Dte(e, t) {
  let n = e.length, r, i, o;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !o && e[n][1].type === "definition" && (o = n);
  const a = {
    type: "setextHeading",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[i][1].type = "setextHeadingText", o ? (e.splice(i, 0, ["enter", a, t]), e.splice(o + 1, 0, ["exit", e[r][1], t]), e[r][1].end = Object.assign({}, e[o][1].end)) : e[r][1] = a, e.push(["exit", a, t]), e;
}
function Nte(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(f) {
    let p = r.events.length, d;
    for (; p--; )
      if (r.events[p][1].type !== "lineEnding" && r.events[p][1].type !== "linePrefix" && r.events[p][1].type !== "content") {
        d = r.events[p][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || d) ? (e.enter("setextHeadingLine"), i = f, a(f)) : n(f);
  }
  function a(f) {
    return e.enter("setextHeadingLineSequence"), s(f);
  }
  function s(f) {
    return f === i ? (e.consume(f), s) : (e.exit("setextHeadingLineSequence"), Je(f) ? lt(e, c, "lineSuffix")(f) : c(f));
  }
  function c(f) {
    return f === null || Ie(f) ? (e.exit("setextHeadingLine"), t(f)) : n(f);
  }
}
const Ite = {
  tokenize: Lte
};
function Lte(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    Ml,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      i,
      lt(
        e,
        e.attempt(
          this.parser.constructs.flow,
          i,
          e.attempt(Hee, i)
        ),
        "linePrefix"
      )
    )
  );
  return n;
  function r(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const Fte = {
  resolveAll: XS()
}, zte = KS("string"), Vte = KS("text");
function KS(e) {
  return {
    tokenize: t,
    resolveAll: XS(
      e === "text" ? Bte : void 0
    )
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], o = n.attempt(i, a, s);
    return a;
    function a(p) {
      return f(p) ? o(p) : s(p);
    }
    function s(p) {
      if (p === null) {
        n.consume(p);
        return;
      }
      return n.enter("data"), n.consume(p), c;
    }
    function c(p) {
      return f(p) ? (n.exit("data"), o(p)) : (n.consume(p), c);
    }
    function f(p) {
      if (p === null)
        return !0;
      const d = i[p];
      let h = -1;
      if (d)
        for (; ++h < d.length; ) {
          const m = d[h];
          if (!m.previous || m.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function XS(e) {
  return t;
  function t(n, r) {
    let i = -1, o;
    for (; ++i <= n.length; )
      o === void 0 ? n[i] && n[i][1].type === "data" && (o = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== o + 2 && (n[o][1].end = n[i - 1][1].end, n.splice(o + 2, i - o - 2), i = o + 2), o = void 0);
    return e ? e(n, r) : n;
  }
}
function Bte(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let o = i.length, a = -1, s = 0, c;
      for (; o--; ) {
        const f = i[o];
        if (typeof f == "string") {
          for (a = f.length; f.charCodeAt(a - 1) === 32; )
            s++, a--;
          if (a)
            break;
          a = -1;
        } else if (f === -2)
          c = !0, s++;
        else if (f !== -1) {
          o++;
          break;
        }
      }
      if (s) {
        const f = {
          type: n === e.length || c || s < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - s,
            offset: r.end.offset - s,
            _index: r.start._index + o,
            _bufferIndex: o ? a : r.start._bufferIndex + a
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, f.start), r.start.offset === r.end.offset ? Object.assign(r, f) : (e.splice(
          n,
          0,
          ["enter", f, t],
          ["exit", f, t]
        ), n += 2);
      }
      n++;
    }
  return e;
}
function Hte(e, t, n) {
  let r = Object.assign(
    n ? Object.assign({}, n) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const i = {}, o = [];
  let a = [], s = [];
  const c = {
    consume: C,
    enter: S,
    exit: _,
    attempt: R(T),
    check: R(P),
    interrupt: R(P, {
      interrupt: !0
    })
  }, f = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: m,
    sliceSerialize: h,
    now: v,
    defineSkip: w,
    write: d
  };
  let p = t.tokenize.call(f, c);
  return t.resolveAll && o.push(t), f;
  function d(j) {
    return a = wr(a, j), b(), a[a.length - 1] !== null ? [] : (N(t, 0), f.events = dd(o, f.events, f), f.events);
  }
  function h(j, I) {
    return Wte(m(j), I);
  }
  function m(j) {
    return Ute(a, j);
  }
  function v() {
    const { line: j, column: I, offset: z, _index: H, _bufferIndex: G } = r;
    return {
      line: j,
      column: I,
      offset: z,
      _index: H,
      _bufferIndex: G
    };
  }
  function w(j) {
    i[j.line] = j.column, L();
  }
  function b() {
    let j;
    for (; r._index < a.length; ) {
      const I = a[r._index];
      if (typeof I == "string")
        for (j = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === j && r._bufferIndex < I.length; )
          E(I.charCodeAt(r._bufferIndex));
      else
        E(I);
    }
  }
  function E(j) {
    p = p(j);
  }
  function C(j) {
    Ie(j) ? (r.line++, r.column = 1, r.offset += j === -3 ? 2 : 1, L()) : j !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === a[r._index].length && (r._bufferIndex = -1, r._index++)), f.previous = j;
  }
  function S(j, I) {
    const z = I || {};
    return z.type = j, z.start = v(), f.events.push(["enter", z, f]), s.push(z), z;
  }
  function _(j) {
    const I = s.pop();
    return I.end = v(), f.events.push(["exit", I, f]), I;
  }
  function T(j, I) {
    N(j, I.from);
  }
  function P(j, I) {
    I.restore();
  }
  function R(j, I) {
    return z;
    function z(H, G, Y) {
      let ne, J, ee, A;
      return Array.isArray(H) ? fe(H) : "tokenize" in H ? (
        // @ts-expect-error Looks like a construct.
        fe([H])
      ) : X(H);
      function X(pe) {
        return Te;
        function Te(ke) {
          const me = ke !== null && pe[ke], Pe = ke !== null && pe.null, ct = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(me) ? me : me ? [me] : [],
            ...Array.isArray(Pe) ? Pe : Pe ? [Pe] : []
          ];
          return fe(ct)(ke);
        }
      }
      function fe(pe) {
        return ne = pe, J = 0, pe.length === 0 ? Y : M(pe[J]);
      }
      function M(pe) {
        return Te;
        function Te(ke) {
          return A = B(), ee = pe, pe.partial || (f.currentConstruct = pe), pe.name && f.parser.constructs.disable.null.includes(pe.name) ? ie() : pe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            I ? Object.assign(Object.create(f), I) : f,
            c,
            Z,
            ie
          )(ke);
        }
      }
      function Z(pe) {
        return j(ee, A), G;
      }
      function ie(pe) {
        return A.restore(), ++J < ne.length ? M(ne[J]) : Y;
      }
    }
  }
  function N(j, I) {
    j.resolveAll && !o.includes(j) && o.push(j), j.resolve && nr(
      f.events,
      I,
      f.events.length - I,
      j.resolve(f.events.slice(I), f)
    ), j.resolveTo && (f.events = j.resolveTo(f.events, f));
  }
  function B() {
    const j = v(), I = f.previous, z = f.currentConstruct, H = f.events.length, G = Array.from(s);
    return {
      restore: Y,
      from: H
    };
    function Y() {
      r = j, f.previous = I, f.currentConstruct = z, f.events.length = H, s = G, L();
    }
  }
  function L() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function Ute(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, o = t.end._bufferIndex;
  let a;
  if (n === i)
    a = [e[n].slice(r, o)];
  else {
    if (a = e.slice(n, i), r > -1) {
      const s = a[0];
      typeof s == "string" ? a[0] = s.slice(r) : a.shift();
    }
    o > 0 && a.push(e[i].slice(0, o));
  }
  return a;
}
function Wte(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const o = e[n];
    let a;
    if (typeof o == "string")
      a = o;
    else
      switch (o) {
        case -5: {
          a = "\r";
          break;
        }
        case -4: {
          a = `
`;
          break;
        }
        case -3: {
          a = `\r
`;
          break;
        }
        case -2: {
          a = t ? " " : "	";
          break;
        }
        case -1: {
          if (!t && i)
            continue;
          a = " ";
          break;
        }
        default:
          a = String.fromCharCode(o);
      }
    i = o === -2, r.push(a);
  }
  return r.join("");
}
const jte = {
  [42]: Hn,
  [43]: Hn,
  [45]: Hn,
  [48]: Hn,
  [49]: Hn,
  [50]: Hn,
  [51]: Hn,
  [52]: Hn,
  [53]: Hn,
  [54]: Hn,
  [55]: Hn,
  [56]: Hn,
  [57]: Hn,
  [62]: HS
}, qte = {
  [91]: Gee
}, Gte = {
  [-2]: $h,
  [-1]: $h,
  [32]: $h
}, Yte = {
  [35]: Jee,
  [42]: Tu,
  [45]: [j3, Tu],
  [60]: rte,
  [61]: j3,
  [95]: Tu,
  [96]: U3,
  [126]: U3
}, Kte = {
  [38]: WS,
  [92]: US
}, Xte = {
  [-5]: Oh,
  [-4]: Oh,
  [-3]: Oh,
  [33]: xte,
  [38]: WS,
  [42]: bg,
  [60]: [See, ute],
  [91]: Cte,
  [92]: [Qee, US],
  [93]: Dv,
  [95]: bg,
  [96]: Lee
}, Qte = {
  null: [bg, Fte]
}, Zte = {
  null: [42, 95]
}, Jte = {
  null: []
}, ene = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: Zte,
  contentInitial: qte,
  disable: Jte,
  document: jte,
  flow: Yte,
  flowInitial: Gte,
  insideSpan: Qte,
  string: Kte,
  text: Xte
}, Symbol.toStringTag, { value: "Module" }));
function tne(e) {
  const n = (
    /** @type {FullNormalizedExtension} */
    BS([ene, ...(e || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: n,
    content: i(vee),
    document: i(yee),
    flow: i(Ite),
    string: i(zte),
    text: i(Vte)
  };
  return r;
  function i(o) {
    return a;
    function a(s) {
      return Hte(r, o, s);
    }
  }
}
const q3 = /[\0\t\n\r]/g;
function nne() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(o, a, s) {
    const c = [];
    let f, p, d, h, m;
    for (o = t + o.toString(a), d = 0, t = "", n && (o.charCodeAt(0) === 65279 && d++, n = void 0); d < o.length; ) {
      if (q3.lastIndex = d, f = q3.exec(o), h = f && f.index !== void 0 ? f.index : o.length, m = o.charCodeAt(h), !f) {
        t = o.slice(d);
        break;
      }
      if (m === 10 && d === h && r)
        c.push(-3), r = void 0;
      else
        switch (r && (c.push(-5), r = void 0), d < h && (c.push(o.slice(d, h)), e += h - d), m) {
          case 0: {
            c.push(65533), e++;
            break;
          }
          case 9: {
            for (p = Math.ceil(e / 4) * 4, c.push(-2); e++ < p; )
              c.push(-1);
            break;
          }
          case 10: {
            c.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      d = h + 1;
    }
    return s && (r && c.push(-5), t && c.push(t), c.push(null)), c;
  }
}
function rne(e) {
  for (; !jS(e); )
    ;
  return e;
}
function QS(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || (n & 65535) === 65535 || (n & 65535) === 65534 || // Out of range
    n > 1114111 ? "�" : String.fromCharCode(n)
  );
}
const ine = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function ZS(e) {
  return e.replace(ine, one);
}
function one(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), o = i === 120 || i === 88;
    return QS(n.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return Mv(n) || e;
}
const JS = {}.hasOwnProperty, ane = (
  /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */
  /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */
  function(e, t, n) {
    return typeof t != "string" && (n = t, t = void 0), sne(n)(
      rne(
        tne(n).document().write(nne()(e, t, !0))
      )
    );
  }
);
function sne(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: s(Bt),
      autolinkProtocol: j,
      autolinkEmail: j,
      atxHeading: s(bt),
      blockQuote: s(ct),
      characterEscape: j,
      characterReference: j,
      codeFenced: s(se),
      codeFencedFenceInfo: c,
      codeFencedFenceMeta: c,
      codeIndented: s(se, c),
      codeText: s(Le, c),
      codeTextData: j,
      data: j,
      codeFlowValue: j,
      definition: s(xe),
      definitionDestinationString: c,
      definitionLabelString: c,
      definitionTitleString: c,
      emphasis: s(Ue),
      hardBreakEscape: s(Et),
      hardBreakTrailing: s(Et),
      htmlFlow: s(xt, c),
      htmlFlowData: j,
      htmlText: s(xt, c),
      htmlTextData: j,
      image: s(Pt),
      label: c,
      link: s(Bt),
      listItem: s(On),
      listItemValue: v,
      listOrdered: s(Nt, m),
      listUnordered: s(Nt),
      paragraph: s(_r),
      reference: ie,
      referenceString: c,
      resourceDestinationString: c,
      resourceTitleString: c,
      setextHeading: s(bt),
      strong: s(an),
      thematicBreak: s(Yr)
    },
    exit: {
      atxHeading: p(),
      atxHeadingSequence: R,
      autolink: p(),
      autolinkEmail: Pe,
      autolinkProtocol: me,
      blockQuote: p(),
      characterEscapeValue: I,
      characterReferenceMarkerHexadecimal: Te,
      characterReferenceMarkerNumeric: Te,
      characterReferenceValue: ke,
      codeFenced: p(C),
      codeFencedFence: E,
      codeFencedFenceInfo: w,
      codeFencedFenceMeta: b,
      codeFlowValue: I,
      codeIndented: p(S),
      codeText: p(ne),
      codeTextData: I,
      data: I,
      definition: p(),
      definitionDestinationString: P,
      definitionLabelString: _,
      definitionTitleString: T,
      emphasis: p(),
      hardBreakEscape: p(H),
      hardBreakTrailing: p(H),
      htmlFlow: p(G),
      htmlFlowData: I,
      htmlText: p(Y),
      htmlTextData: I,
      image: p(ee),
      label: X,
      labelText: A,
      lineEnding: z,
      link: p(J),
      listItem: p(),
      listOrdered: p(),
      listUnordered: p(),
      paragraph: p(),
      referenceString: pe,
      resourceDestinationString: fe,
      resourceTitleString: M,
      resource: Z,
      setextHeading: p(L),
      setextHeadingLineSequence: B,
      setextHeadingText: N,
      strong: p(),
      thematicBreak: p()
    }
  };
  e8(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(te) {
    let we = {
      type: "root",
      children: []
    };
    const De = {
      stack: [we],
      tokenStack: [],
      config: t,
      enter: f,
      exit: d,
      buffer: c,
      resume: h,
      setData: o,
      getData: a
    }, rt = [];
    let it = -1;
    for (; ++it < te.length; )
      if (te[it][1].type === "listOrdered" || te[it][1].type === "listUnordered")
        if (te[it][0] === "enter")
          rt.push(it);
        else {
          const cn = rt.pop();
          it = i(te, cn, it);
        }
    for (it = -1; ++it < te.length; ) {
      const cn = t[te[it][0]];
      JS.call(cn, te[it][1].type) && cn[te[it][1].type].call(
        Object.assign(
          {
            sliceSerialize: te[it][2].sliceSerialize
          },
          De
        ),
        te[it][1]
      );
    }
    if (De.tokenStack.length > 0) {
      const cn = De.tokenStack[De.tokenStack.length - 1];
      (cn[1] || G3).call(De, void 0, cn[0]);
    }
    for (we.position = {
      start: qi(
        te.length > 0 ? te[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: qi(
        te.length > 0 ? te[te.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    }, it = -1; ++it < t.transforms.length; )
      we = t.transforms[it](we) || we;
    return we;
  }
  function i(te, we, De) {
    let rt = we - 1, it = -1, cn = !1, Mn, En, Tr, kr;
    for (; ++rt <= De; ) {
      const Ct = te[rt];
      if (Ct[1].type === "listUnordered" || Ct[1].type === "listOrdered" || Ct[1].type === "blockQuote" ? (Ct[0] === "enter" ? it++ : it--, kr = void 0) : Ct[1].type === "lineEndingBlank" ? Ct[0] === "enter" && (Mn && !kr && !it && !Tr && (Tr = rt), kr = void 0) : Ct[1].type === "linePrefix" || Ct[1].type === "listItemValue" || Ct[1].type === "listItemMarker" || Ct[1].type === "listItemPrefix" || Ct[1].type === "listItemPrefixWhitespace" || (kr = void 0), !it && Ct[0] === "enter" && Ct[1].type === "listItemPrefix" || it === -1 && Ct[0] === "exit" && (Ct[1].type === "listUnordered" || Ct[1].type === "listOrdered")) {
        if (Mn) {
          let go = rt;
          for (En = void 0; go--; ) {
            const Cn = te[go];
            if (Cn[1].type === "lineEnding" || Cn[1].type === "lineEndingBlank") {
              if (Cn[0] === "exit")
                continue;
              En && (te[En][1].type = "lineEndingBlank", cn = !0), Cn[1].type = "lineEnding", En = go;
            } else if (!(Cn[1].type === "linePrefix" || Cn[1].type === "blockQuotePrefix" || Cn[1].type === "blockQuotePrefixWhitespace" || Cn[1].type === "blockQuoteMarker" || Cn[1].type === "listItemIndent"))
              break;
          }
          Tr && (!En || Tr < En) && (Mn._spread = !0), Mn.end = Object.assign(
            {},
            En ? te[En][1].start : Ct[1].end
          ), te.splice(En || rt, 0, ["exit", Mn, Ct[2]]), rt++, De++;
        }
        Ct[1].type === "listItemPrefix" && (Mn = {
          type: "listItem",
          _spread: !1,
          start: Object.assign({}, Ct[1].start),
          // @ts-expect-error: we’ll add `end` in a second.
          end: void 0
        }, te.splice(rt, 0, ["enter", Mn, Ct[2]]), rt++, De++, Tr = void 0, kr = !0);
      }
    }
    return te[we][1]._spread = cn, De;
  }
  function o(te, we) {
    n[te] = we;
  }
  function a(te) {
    return n[te];
  }
  function s(te, we) {
    return De;
    function De(rt) {
      f.call(this, te(rt), rt), we && we.call(this, rt);
    }
  }
  function c() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function f(te, we, De) {
    return this.stack[this.stack.length - 1].children.push(te), this.stack.push(te), this.tokenStack.push([we, De]), te.position = {
      start: qi(we.start)
    }, te;
  }
  function p(te) {
    return we;
    function we(De) {
      te && te.call(this, De), d.call(this, De);
    }
  }
  function d(te, we) {
    const De = this.stack.pop(), rt = this.tokenStack.pop();
    if (rt)
      rt[0].type !== te.type && (we ? we.call(this, te, rt[0]) : (rt[1] || G3).call(this, te, rt[0]));
    else
      throw new Error(
        "Cannot close `" + te.type + "` (" + qs({
          start: te.start,
          end: te.end
        }) + "): it’s not open"
      );
    return De.position.end = qi(te.end), De;
  }
  function h() {
    return cee(this.stack.pop());
  }
  function m() {
    o("expectingFirstListItemValue", !0);
  }
  function v(te) {
    if (a("expectingFirstListItemValue")) {
      const we = this.stack[this.stack.length - 2];
      we.start = Number.parseInt(this.sliceSerialize(te), 10), o("expectingFirstListItemValue");
    }
  }
  function w() {
    const te = this.resume(), we = this.stack[this.stack.length - 1];
    we.lang = te;
  }
  function b() {
    const te = this.resume(), we = this.stack[this.stack.length - 1];
    we.meta = te;
  }
  function E() {
    a("flowCodeInside") || (this.buffer(), o("flowCodeInside", !0));
  }
  function C() {
    const te = this.resume(), we = this.stack[this.stack.length - 1];
    we.value = te.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), o("flowCodeInside");
  }
  function S() {
    const te = this.resume(), we = this.stack[this.stack.length - 1];
    we.value = te.replace(/(\r?\n|\r)$/g, "");
  }
  function _(te) {
    const we = this.resume(), De = this.stack[this.stack.length - 1];
    De.label = we, De.identifier = Ur(
      this.sliceSerialize(te)
    ).toLowerCase();
  }
  function T() {
    const te = this.resume(), we = this.stack[this.stack.length - 1];
    we.title = te;
  }
  function P() {
    const te = this.resume(), we = this.stack[this.stack.length - 1];
    we.url = te;
  }
  function R(te) {
    const we = this.stack[this.stack.length - 1];
    if (!we.depth) {
      const De = this.sliceSerialize(te).length;
      we.depth = De;
    }
  }
  function N() {
    o("setextHeadingSlurpLineEnding", !0);
  }
  function B(te) {
    const we = this.stack[this.stack.length - 1];
    we.depth = this.sliceSerialize(te).charCodeAt(0) === 61 ? 1 : 2;
  }
  function L() {
    o("setextHeadingSlurpLineEnding");
  }
  function j(te) {
    const we = this.stack[this.stack.length - 1];
    let De = we.children[we.children.length - 1];
    (!De || De.type !== "text") && (De = Kt(), De.position = {
      start: qi(te.start)
    }, we.children.push(De)), this.stack.push(De);
  }
  function I(te) {
    const we = this.stack.pop();
    we.value += this.sliceSerialize(te), we.position.end = qi(te.end);
  }
  function z(te) {
    const we = this.stack[this.stack.length - 1];
    if (a("atHardBreak")) {
      const De = we.children[we.children.length - 1];
      De.position.end = qi(te.end), o("atHardBreak");
      return;
    }
    !a("setextHeadingSlurpLineEnding") && t.canContainEols.includes(we.type) && (j.call(this, te), I.call(this, te));
  }
  function H() {
    o("atHardBreak", !0);
  }
  function G() {
    const te = this.resume(), we = this.stack[this.stack.length - 1];
    we.value = te;
  }
  function Y() {
    const te = this.resume(), we = this.stack[this.stack.length - 1];
    we.value = te;
  }
  function ne() {
    const te = this.resume(), we = this.stack[this.stack.length - 1];
    we.value = te;
  }
  function J() {
    const te = this.stack[this.stack.length - 1];
    if (a("inReference")) {
      const we = a("referenceType") || "shortcut";
      te.type += "Reference", te.referenceType = we, delete te.url, delete te.title;
    } else
      delete te.identifier, delete te.label;
    o("referenceType");
  }
  function ee() {
    const te = this.stack[this.stack.length - 1];
    if (a("inReference")) {
      const we = a("referenceType") || "shortcut";
      te.type += "Reference", te.referenceType = we, delete te.url, delete te.title;
    } else
      delete te.identifier, delete te.label;
    o("referenceType");
  }
  function A(te) {
    const we = this.sliceSerialize(te), De = this.stack[this.stack.length - 2];
    De.label = ZS(we), De.identifier = Ur(we).toLowerCase();
  }
  function X() {
    const te = this.stack[this.stack.length - 1], we = this.resume(), De = this.stack[this.stack.length - 1];
    if (o("inReference", !0), De.type === "link") {
      const rt = te.children;
      De.children = rt;
    } else
      De.alt = we;
  }
  function fe() {
    const te = this.resume(), we = this.stack[this.stack.length - 1];
    we.url = te;
  }
  function M() {
    const te = this.resume(), we = this.stack[this.stack.length - 1];
    we.title = te;
  }
  function Z() {
    o("inReference");
  }
  function ie() {
    o("referenceType", "collapsed");
  }
  function pe(te) {
    const we = this.resume(), De = this.stack[this.stack.length - 1];
    De.label = we, De.identifier = Ur(
      this.sliceSerialize(te)
    ).toLowerCase(), o("referenceType", "full");
  }
  function Te(te) {
    o("characterReferenceType", te.type);
  }
  function ke(te) {
    const we = this.sliceSerialize(te), De = a("characterReferenceType");
    let rt;
    De ? (rt = QS(
      we,
      De === "characterReferenceMarkerNumeric" ? 10 : 16
    ), o("characterReferenceType")) : rt = Mv(we);
    const it = this.stack.pop();
    it.value += rt, it.position.end = qi(te.end);
  }
  function me(te) {
    I.call(this, te);
    const we = this.stack[this.stack.length - 1];
    we.url = this.sliceSerialize(te);
  }
  function Pe(te) {
    I.call(this, te);
    const we = this.stack[this.stack.length - 1];
    we.url = "mailto:" + this.sliceSerialize(te);
  }
  function ct() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function se() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Le() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function xe() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Ue() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function bt() {
    return {
      type: "heading",
      depth: void 0,
      children: []
    };
  }
  function Et() {
    return {
      type: "break"
    };
  }
  function xt() {
    return {
      type: "html",
      value: ""
    };
  }
  function Pt() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Bt() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Nt(te) {
    return {
      type: "list",
      ordered: te.type === "listOrdered",
      start: null,
      spread: te._spread,
      children: []
    };
  }
  function On(te) {
    return {
      type: "listItem",
      spread: te._spread,
      checked: null,
      children: []
    };
  }
  function _r() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function an() {
    return {
      type: "strong",
      children: []
    };
  }
  function Kt() {
    return {
      type: "text",
      value: ""
    };
  }
  function Yr() {
    return {
      type: "thematicBreak"
    };
  }
}
function qi(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function e8(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? e8(e, r) : lne(e, r);
  }
}
function lne(e, t) {
  let n;
  for (n in t)
    if (JS.call(t, n)) {
      if (n === "canContainEols") {
        const r = t[n];
        r && e[n].push(...r);
      } else if (n === "transforms") {
        const r = t[n];
        r && e[n].push(...r);
      } else if (n === "enter" || n === "exit") {
        const r = t[n];
        r && Object.assign(e[n], r);
      }
    }
}
function G3(e, t) {
  throw e ? new Error(
    "Cannot close `" + e.type + "` (" + qs({
      start: e.start,
      end: e.end
    }) + "): a different token (`" + t.type + "`, " + qs({
      start: t.start,
      end: t.end
    }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + t.type + "`, " + qs({
      start: t.start,
      end: t.end
    }) + ") is still open"
  );
}
function cne(e) {
  Object.assign(this, { Parser: (n) => {
    const r = (
      /** @type {Options} */
      this.data("settings")
    );
    return ane(
      n,
      Object.assign({}, r, e, {
        // Note: these options are not in the readme.
        // The goal is for them to be set by plugins on `data` instead of being
        // passed by users.
        extensions: this.data("micromarkExtensions") || [],
        mdastExtensions: this.data("fromMarkdownExtensions") || []
      })
    );
  } });
}
function une(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function fne(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function dne(e, t) {
  const n = t.value ? t.value + `
` : "", r = t.lang ? t.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null, i = {};
  r && (i.className = ["language-" + r]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (o.data = { meta: t.meta }), e.patch(t, o), o = e.applyData(t, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(t, o), o;
}
function pne(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function hne(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function ts(e) {
  const t = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < e.length; ) {
    const o = e.charCodeAt(n);
    let a = "";
    if (o === 37 && wn(e.charCodeAt(n + 1)) && wn(e.charCodeAt(n + 2)))
      i = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (a = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const s = e.charCodeAt(n + 1);
      o < 56320 && s > 56319 && s < 57344 ? (a = String.fromCharCode(o, s), i = 1) : a = "�";
    } else
      a = String.fromCharCode(o);
    a && (t.push(e.slice(r, n), encodeURIComponent(a)), r = n + i + 1, a = ""), i && (n += i, i = 0);
  }
  return t.join("") + e.slice(r);
}
function t8(e, t) {
  const n = String(t.identifier).toUpperCase(), r = ts(n.toLowerCase()), i = e.footnoteOrder.indexOf(n);
  let o;
  i === -1 ? (e.footnoteOrder.push(n), e.footnoteCounts[n] = 1, o = e.footnoteOrder.length) : (e.footnoteCounts[n]++, o = i + 1);
  const a = e.footnoteCounts[n], s = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + e.clobberPrefix + "fn-" + r,
      id: e.clobberPrefix + "fnref-" + r + (a > 1 ? "-" + a : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  e.patch(t, s);
  const c = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [s]
  };
  return e.patch(t, c), e.applyData(t, c);
}
function mne(e, t) {
  const n = e.footnoteById;
  let r = 1;
  for (; r in n; )
    r++;
  const i = String(r);
  return n[i] = {
    type: "footnoteDefinition",
    identifier: i,
    children: [{ type: "paragraph", children: t.children }],
    position: t.position
  }, t8(e, {
    type: "footnoteReference",
    identifier: i,
    position: t.position
  });
}
function gne(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function vne(e, t) {
  if (e.dangerous) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
  return null;
}
function n8(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return { type: "text", value: "![" + t.alt + r };
  const i = e.all(t), o = i[0];
  o && o.type === "text" ? o.value = "[" + o.value : i.unshift({ type: "text", value: "[" });
  const a = i[i.length - 1];
  return a && a.type === "text" ? a.value += r : i.push({ type: "text", value: r }), i;
}
function wne(e, t) {
  const n = e.definition(t.identifier);
  if (!n)
    return n8(e, t);
  const r = { src: ts(n.url || ""), alt: t.alt };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(t, i), e.applyData(t, i);
}
function yne(e, t) {
  const n = { src: ts(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function bne(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function xne(e, t) {
  const n = e.definition(t.identifier);
  if (!n)
    return n8(e, t);
  const r = { href: ts(n.url || "") };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function Ene(e, t) {
  const n = { href: ts(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function Cne(e, t, n) {
  const r = e.all(t), i = n ? Sne(n) : r8(t), o = {}, a = [];
  if (typeof t.checked == "boolean") {
    const p = r[0];
    let d;
    p && p.type === "element" && p.tagName === "p" ? d = p : (d = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(d)), d.children.length > 0 && d.children.unshift({ type: "text", value: " " }), d.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let s = -1;
  for (; ++s < r.length; ) {
    const p = r[s];
    (i || s !== 0 || p.type !== "element" || p.tagName !== "p") && a.push({ type: "text", value: `
` }), p.type === "element" && p.tagName === "p" && !i ? a.push(...p.children) : a.push(p);
  }
  const c = r[r.length - 1];
  c && (i || c.type !== "element" || c.tagName !== "p") && a.push({ type: "text", value: `
` });
  const f = { type: "element", tagName: "li", properties: o, children: a };
  return e.patch(t, f), e.applyData(t, f);
}
function Sne(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = r8(n[r]);
  }
  return t;
}
function r8(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function _ne(e, t) {
  const n = {}, r = e.all(t);
  let i = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length; ) {
    const a = r[i];
    if (a.type === "element" && a.tagName === "li" && a.properties && Array.isArray(a.properties.className) && a.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function Tne(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function kne(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function Pne(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Nv = i8("start"), Iv = i8("end");
function Ane(e) {
  return { start: Nv(e), end: Iv(e) };
}
function i8(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    return {
      // @ts-expect-error: in practice, null is allowed.
      line: r.line || null,
      // @ts-expect-error: in practice, null is allowed.
      column: r.column || null,
      // @ts-expect-error: in practice, null is allowed.
      offset: r.offset > -1 ? r.offset : null
    };
  }
}
function Rne(e, t) {
  const n = e.all(t), r = n.shift(), i = [];
  if (r) {
    const a = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], a), i.push(a);
  }
  if (n.length > 0) {
    const a = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, s = Nv(t.children[1]), c = Iv(t.children[t.children.length - 1]);
    s.line && c.line && (a.position = { start: s, end: c }), i.push(a);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function $ne(e, t, n) {
  const r = n ? n.children : void 0, o = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", a = n && n.type === "table" ? n.align : void 0, s = a ? a.length : t.children.length;
  let c = -1;
  const f = [];
  for (; ++c < s; ) {
    const d = t.children[c], h = {}, m = a ? a[c] : void 0;
    m && (h.align = m);
    let v = { type: "element", tagName: o, properties: h, children: [] };
    d && (v.children = e.all(d), e.patch(d, v), v = e.applyData(t, v)), f.push(v);
  }
  const p = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(f, !0)
  };
  return e.patch(t, p), e.applyData(t, p);
}
function One(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Y3 = 9, K3 = 32;
function Mne(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), i = 0;
  const o = [];
  for (; r; )
    o.push(
      X3(t.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = n.exec(t);
  return o.push(X3(t.slice(i), i > 0, !1)), o.join("");
}
function X3(e, t, n) {
  let r = 0, i = e.length;
  if (t) {
    let o = e.codePointAt(r);
    for (; o === Y3 || o === K3; )
      r++, o = e.codePointAt(r);
  }
  if (n) {
    let o = e.codePointAt(i - 1);
    for (; o === Y3 || o === K3; )
      i--, o = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function Dne(e, t) {
  const n = { type: "text", value: Mne(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function Nne(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Ine = {
  blockquote: une,
  break: fne,
  code: dne,
  delete: pne,
  emphasis: hne,
  footnoteReference: t8,
  footnote: mne,
  heading: gne,
  html: vne,
  imageReference: wne,
  image: yne,
  inlineCode: bne,
  linkReference: xne,
  link: Ene,
  listItem: Cne,
  list: _ne,
  paragraph: Tne,
  root: kne,
  strong: Pne,
  table: Rne,
  tableCell: One,
  tableRow: $ne,
  text: Dne,
  thematicBreak: Nne,
  toml: tu,
  yaml: tu,
  definition: tu,
  footnoteDefinition: tu
};
function tu() {
  return null;
}
const Lv = (
  /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {AssertAnything}
   */
  function(e) {
    if (e == null)
      return Vne;
    if (typeof e == "string")
      return zne(e);
    if (typeof e == "object")
      return Array.isArray(e) ? Lne(e) : Fne(e);
    if (typeof e == "function")
      return pd(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function Lne(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = Lv(e[n]);
  return pd(r);
  function r(...i) {
    let o = -1;
    for (; ++o < t.length; )
      if (t[o].call(this, ...i))
        return !0;
    return !1;
  }
}
function Fne(e) {
  return pd(t);
  function t(n) {
    let r;
    for (r in e)
      if (n[r] !== e[r])
        return !1;
    return !0;
  }
}
function zne(e) {
  return pd(t);
  function t(n) {
    return n && n.type === e;
  }
}
function pd(e) {
  return t;
  function t(n, ...r) {
    return !!(n && typeof n == "object" && "type" in n && e.call(this, n, ...r));
  }
}
function Vne() {
  return !0;
}
const Bne = !0, Q3 = !1, Hne = "skip", o8 = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor<Node>} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null);
    const i = Lv(t), o = r ? -1 : 1;
    a(e, void 0, [])();
    function a(s, c, f) {
      const p = s && typeof s == "object" ? s : {};
      if (typeof p.type == "string") {
        const h = (
          // `hast`
          typeof p.tagName == "string" ? p.tagName : (
            // `xast`
            typeof p.name == "string" ? p.name : void 0
          )
        );
        Object.defineProperty(d, "name", {
          value: "node (" + (s.type + (h ? "<" + h + ">" : "")) + ")"
        });
      }
      return d;
      function d() {
        let h = [], m, v, w;
        if ((!t || i(s, c, f[f.length - 1] || null)) && (h = Une(n(s, f)), h[0] === Q3))
          return h;
        if (s.children && h[0] !== Hne)
          for (v = (r ? s.children.length : -1) + o, w = f.concat(s); v > -1 && v < s.children.length; ) {
            if (m = a(s.children[v], v, w)(), m[0] === Q3)
              return m;
            v = typeof m[1] == "number" ? m[1] : v + o;
          }
        return h;
      }
    }
  }
);
function Une(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [Bne, e] : [e];
}
const Fv = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null), o8(e, t, i, r);
    function i(o, a) {
      const s = a[a.length - 1];
      return n(
        o,
        s ? s.children.indexOf(o) : null,
        s
      );
    }
  }
);
function Wne(e) {
  return !e || !e.position || !e.position.start || !e.position.start.line || !e.position.start.column || !e.position.end || !e.position.end.line || !e.position.end.column;
}
const Z3 = {}.hasOwnProperty;
function jne(e) {
  const t = /* @__PURE__ */ Object.create(null);
  if (!e || !e.type)
    throw new Error("mdast-util-definitions expected node");
  return Fv(e, "definition", (r) => {
    const i = J3(r.identifier);
    i && !Z3.call(t, i) && (t[i] = r);
  }), n;
  function n(r) {
    const i = J3(r);
    return i && Z3.call(t, i) ? t[i] : null;
  }
}
function J3(e) {
  return String(e || "").toUpperCase();
}
const uf = {}.hasOwnProperty;
function qne(e, t) {
  const n = t || {}, r = n.allowDangerousHtml || !1, i = {};
  return a.dangerous = r, a.clobberPrefix = n.clobberPrefix === void 0 || n.clobberPrefix === null ? "user-content-" : n.clobberPrefix, a.footnoteLabel = n.footnoteLabel || "Footnotes", a.footnoteLabelTagName = n.footnoteLabelTagName || "h2", a.footnoteLabelProperties = n.footnoteLabelProperties || {
    className: ["sr-only"]
  }, a.footnoteBackLabel = n.footnoteBackLabel || "Back to content", a.unknownHandler = n.unknownHandler, a.passThrough = n.passThrough, a.handlers = { ...Ine, ...n.handlers }, a.definition = jne(e), a.footnoteById = i, a.footnoteOrder = [], a.footnoteCounts = {}, a.patch = Gne, a.applyData = Yne, a.one = s, a.all = c, a.wrap = Xne, a.augment = o, Fv(e, "footnoteDefinition", (f) => {
    const p = String(f.identifier).toUpperCase();
    uf.call(i, p) || (i[p] = f);
  }), a;
  function o(f, p) {
    if (f && "data" in f && f.data) {
      const d = f.data;
      d.hName && (p.type !== "element" && (p = {
        type: "element",
        tagName: "",
        properties: {},
        children: []
      }), p.tagName = d.hName), p.type === "element" && d.hProperties && (p.properties = { ...p.properties, ...d.hProperties }), "children" in p && p.children && d.hChildren && (p.children = d.hChildren);
    }
    if (f) {
      const d = "type" in f ? f : { position: f };
      Wne(d) || (p.position = { start: Nv(d), end: Iv(d) });
    }
    return p;
  }
  function a(f, p, d, h) {
    return Array.isArray(d) && (h = d, d = {}), o(f, {
      type: "element",
      tagName: p,
      properties: d || {},
      children: h || []
    });
  }
  function s(f, p) {
    return a8(a, f, p);
  }
  function c(f) {
    return zv(a, f);
  }
}
function Gne(e, t) {
  e.position && (t.position = Ane(e));
}
function Yne(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, o = e.data.hProperties;
    typeof r == "string" && (n.type === "element" ? n.tagName = r : n = {
      type: "element",
      tagName: r,
      properties: {},
      children: []
    }), n.type === "element" && o && (n.properties = { ...n.properties, ...o }), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function a8(e, t, n) {
  const r = t && t.type;
  if (!r)
    throw new Error("Expected node, got `" + t + "`");
  return uf.call(e.handlers, r) ? e.handlers[r](e, t, n) : e.passThrough && e.passThrough.includes(r) ? "children" in t ? { ...t, children: zv(e, t) } : t : e.unknownHandler ? e.unknownHandler(e, t, n) : Kne(e, t);
}
function zv(e, t) {
  const n = [];
  if ("children" in t) {
    const r = t.children;
    let i = -1;
    for (; ++i < r.length; ) {
      const o = a8(e, r[i], t);
      if (o) {
        if (i && r[i - 1].type === "break" && (!Array.isArray(o) && o.type === "text" && (o.value = o.value.replace(/^\s+/, "")), !Array.isArray(o) && o.type === "element")) {
          const a = o.children[0];
          a && a.type === "text" && (a.value = a.value.replace(/^\s+/, ""));
        }
        Array.isArray(o) ? n.push(...o) : n.push(o);
      }
    }
  }
  return n;
}
function Kne(e, t) {
  const n = t.data || {}, r = "value" in t && !(uf.call(n, "hProperties") || uf.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: zv(e, t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function Xne(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function Qne(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.footnoteOrder.length; ) {
    const r = e.footnoteById[e.footnoteOrder[n]];
    if (!r)
      continue;
    const i = e.all(r), o = String(r.identifier).toUpperCase(), a = ts(o.toLowerCase());
    let s = 0;
    const c = [];
    for (; ++s <= e.footnoteCounts[o]; ) {
      const d = {
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + e.clobberPrefix + "fnref-" + a + (s > 1 ? "-" + s : ""),
          dataFootnoteBackref: !0,
          className: ["data-footnote-backref"],
          ariaLabel: e.footnoteBackLabel
        },
        children: [{ type: "text", value: "↩" }]
      };
      s > 1 && d.children.push({
        type: "element",
        tagName: "sup",
        children: [{ type: "text", value: String(s) }]
      }), c.length > 0 && c.push({ type: "text", value: " " }), c.push(d);
    }
    const f = i[i.length - 1];
    if (f && f.type === "element" && f.tagName === "p") {
      const d = f.children[f.children.length - 1];
      d && d.type === "text" ? d.value += " " : f.children.push({ type: "text", value: " " }), f.children.push(...c);
    } else
      i.push(...c);
    const p = {
      type: "element",
      tagName: "li",
      properties: { id: e.clobberPrefix + "fn-" + a },
      children: e.wrap(i, !0)
    };
    e.patch(r, p), t.push(p);
  }
  if (t.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: e.footnoteLabelTagName,
          properties: {
            // To do: use structured clone.
            ...JSON.parse(JSON.stringify(e.footnoteLabelProperties)),
            id: "footnote-label"
          },
          children: [{ type: "text", value: e.footnoteLabel }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(t, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
function s8(e, t) {
  const n = qne(e, t), r = n.one(e, null), i = Qne(n);
  return i && r.children.push({ type: "text", value: `
` }, i), Array.isArray(r) ? { type: "root", children: r } : r;
}
const Zne = (
  /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */
  function(e, t) {
    return e && "run" in e ? ere(e, t) : tre(e || t);
  }
), Jne = Zne;
function ere(e, t) {
  return (n, r, i) => {
    e.run(s8(n, t), r, (o) => {
      i(o);
    });
  };
}
function tre(e) {
  return (t) => s8(t, e);
}
class Dl {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, r) {
    this.property = t, this.normal = n, r && (this.space = r);
  }
}
Dl.prototype.property = {};
Dl.prototype.normal = {};
Dl.prototype.space = null;
function l8(e, t) {
  const n = {}, r = {};
  let i = -1;
  for (; ++i < e.length; )
    Object.assign(n, e[i].property), Object.assign(r, e[i].normal);
  return new Dl(n, r, t);
}
function xg(e) {
  return e.toLowerCase();
}
class Sr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
}
Sr.prototype.space = null;
Sr.prototype.boolean = !1;
Sr.prototype.booleanish = !1;
Sr.prototype.overloadedBoolean = !1;
Sr.prototype.number = !1;
Sr.prototype.commaSeparated = !1;
Sr.prototype.spaceSeparated = !1;
Sr.prototype.commaOrSpaceSeparated = !1;
Sr.prototype.mustUseProperty = !1;
Sr.prototype.defined = !1;
let nre = 0;
const qe = Jo(), Qt = Jo(), c8 = Jo(), be = Jo(), Rt = Jo(), Na = Jo(), Zn = Jo();
function Jo() {
  return 2 ** ++nre;
}
const Eg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: qe,
  booleanish: Qt,
  commaOrSpaceSeparated: Zn,
  commaSeparated: Na,
  number: be,
  overloadedBoolean: c8,
  spaceSeparated: Rt
}, Symbol.toStringTag, { value: "Module" })), Mh = Object.keys(Eg);
class Vv extends Sr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, r, i) {
    let o = -1;
    if (super(t, n), e4(this, "space", i), typeof r == "number")
      for (; ++o < Mh.length; ) {
        const a = Mh[o];
        e4(this, Mh[o], (r & Eg[a]) === Eg[a]);
      }
  }
}
Vv.prototype.defined = !0;
function e4(e, t, n) {
  n && (e[t] = n);
}
const rre = {}.hasOwnProperty;
function ns(e) {
  const t = {}, n = {};
  let r;
  for (r in e.properties)
    if (rre.call(e.properties, r)) {
      const i = e.properties[r], o = new Vv(
        r,
        e.transform(e.attributes || {}, r),
        i,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (o.mustUseProperty = !0), t[r] = o, n[xg(r)] = r, n[xg(o.attribute)] = r;
    }
  return new Dl(t, n, e.space);
}
const u8 = ns({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), f8 = ns({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function d8(e, t) {
  return t in e ? e[t] : t;
}
function p8(e, t) {
  return d8(e, t.toLowerCase());
}
const h8 = ns({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: p8,
  properties: { xmlns: null, xmlnsXLink: null }
}), m8 = ns({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Qt,
    ariaAutoComplete: null,
    ariaBusy: Qt,
    ariaChecked: Qt,
    ariaColCount: be,
    ariaColIndex: be,
    ariaColSpan: be,
    ariaControls: Rt,
    ariaCurrent: null,
    ariaDescribedBy: Rt,
    ariaDetails: null,
    ariaDisabled: Qt,
    ariaDropEffect: Rt,
    ariaErrorMessage: null,
    ariaExpanded: Qt,
    ariaFlowTo: Rt,
    ariaGrabbed: Qt,
    ariaHasPopup: null,
    ariaHidden: Qt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Rt,
    ariaLevel: be,
    ariaLive: null,
    ariaModal: Qt,
    ariaMultiLine: Qt,
    ariaMultiSelectable: Qt,
    ariaOrientation: null,
    ariaOwns: Rt,
    ariaPlaceholder: null,
    ariaPosInSet: be,
    ariaPressed: Qt,
    ariaReadOnly: Qt,
    ariaRelevant: null,
    ariaRequired: Qt,
    ariaRoleDescription: Rt,
    ariaRowCount: be,
    ariaRowIndex: be,
    ariaRowSpan: be,
    ariaSelected: Qt,
    ariaSetSize: be,
    ariaSort: null,
    ariaValueMax: be,
    ariaValueMin: be,
    ariaValueNow: be,
    ariaValueText: null,
    role: null
  }
}), ire = ns({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: p8,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Na,
    acceptCharset: Rt,
    accessKey: Rt,
    action: null,
    allow: null,
    allowFullScreen: qe,
    allowPaymentRequest: qe,
    allowUserMedia: qe,
    alt: null,
    as: null,
    async: qe,
    autoCapitalize: null,
    autoComplete: Rt,
    autoFocus: qe,
    autoPlay: qe,
    blocking: Rt,
    capture: null,
    charSet: null,
    checked: qe,
    cite: null,
    className: Rt,
    cols: be,
    colSpan: null,
    content: null,
    contentEditable: Qt,
    controls: qe,
    controlsList: Rt,
    coords: be | Na,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: qe,
    defer: qe,
    dir: null,
    dirName: null,
    disabled: qe,
    download: c8,
    draggable: Qt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: qe,
    formTarget: null,
    headers: Rt,
    height: be,
    hidden: qe,
    high: be,
    href: null,
    hrefLang: null,
    htmlFor: Rt,
    httpEquiv: Rt,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: qe,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: qe,
    itemId: null,
    itemProp: Rt,
    itemRef: Rt,
    itemScope: qe,
    itemType: Rt,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: qe,
    low: be,
    manifest: null,
    max: null,
    maxLength: be,
    media: null,
    method: null,
    min: null,
    minLength: be,
    multiple: qe,
    muted: qe,
    name: null,
    nonce: null,
    noModule: qe,
    noValidate: qe,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: qe,
    optimum: be,
    pattern: null,
    ping: Rt,
    placeholder: null,
    playsInline: qe,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: qe,
    referrerPolicy: null,
    rel: Rt,
    required: qe,
    reversed: qe,
    rows: be,
    rowSpan: be,
    sandbox: Rt,
    scope: null,
    scoped: qe,
    seamless: qe,
    selected: qe,
    shadowRootClonable: qe,
    shadowRootDelegatesFocus: qe,
    shadowRootMode: null,
    shape: null,
    size: be,
    sizes: null,
    slot: null,
    span: be,
    spellCheck: Qt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: be,
    step: null,
    style: null,
    tabIndex: be,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: qe,
    useMap: null,
    value: Qt,
    width: be,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Rt,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: be,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: be,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: qe,
    // Lists. Use CSS to reduce space between items instead
    declare: qe,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: be,
    // `<img>` and `<object>`
    leftMargin: be,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: be,
    // `<body>`
    marginWidth: be,
    // `<body>`
    noResize: qe,
    // `<frame>`
    noHref: qe,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: qe,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: qe,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: be,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Qt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: be,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: be,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: qe,
    disableRemotePlayback: qe,
    prefix: null,
    property: null,
    results: be,
    security: null,
    unselectable: null
  }
}), ore = ns({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: d8,
  properties: {
    about: Zn,
    accentHeight: be,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: be,
    amplitude: be,
    arabicForm: null,
    ascent: be,
    attributeName: null,
    attributeType: null,
    azimuth: be,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: be,
    by: null,
    calcMode: null,
    capHeight: be,
    className: Rt,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: be,
    diffuseConstant: be,
    direction: null,
    display: null,
    dur: null,
    divisor: be,
    dominantBaseline: null,
    download: qe,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: be,
    enableBackground: null,
    end: null,
    event: null,
    exponent: be,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: be,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Na,
    g2: Na,
    glyphName: Na,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: be,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: be,
    horizOriginX: be,
    horizOriginY: be,
    id: null,
    ideographic: be,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: be,
    k: be,
    k1: be,
    k2: be,
    k3: be,
    k4: be,
    kernelMatrix: Zn,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: be,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: be,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: be,
    overlineThickness: be,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: be,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Rt,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: be,
    pointsAtY: be,
    pointsAtZ: be,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Zn,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Zn,
    rev: Zn,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Zn,
    requiredFeatures: Zn,
    requiredFonts: Zn,
    requiredFormats: Zn,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: be,
    specularExponent: be,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: be,
    strikethroughThickness: be,
    string: null,
    stroke: null,
    strokeDashArray: Zn,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: be,
    strokeOpacity: be,
    strokeWidth: null,
    style: null,
    surfaceScale: be,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Zn,
    tabIndex: be,
    tableValues: null,
    target: null,
    targetX: be,
    targetY: be,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Zn,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: be,
    underlineThickness: be,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: be,
    values: null,
    vAlphabetic: be,
    vMathematical: be,
    vectorEffect: null,
    vHanging: be,
    vIdeographic: be,
    version: null,
    vertAdvY: be,
    vertOriginX: be,
    vertOriginY: be,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: be,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), are = /^data[-\w.:]+$/i, t4 = /-[a-z]/g, sre = /[A-Z]/g;
function lre(e, t) {
  const n = xg(t);
  let r = t, i = Sr;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && are.test(t)) {
    if (t.charAt(4) === "-") {
      const o = t.slice(5).replace(t4, ure);
      r = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = t.slice(4);
      if (!t4.test(o)) {
        let a = o.replace(sre, cre);
        a.charAt(0) !== "-" && (a = "-" + a), t = "data" + a;
      }
    }
    i = Vv;
  }
  return new i(r, t);
}
function cre(e) {
  return "-" + e.toLowerCase();
}
function ure(e) {
  return e.charAt(1).toUpperCase();
}
const n4 = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, fre = l8([f8, u8, h8, m8, ire], "html"), dre = l8([f8, u8, h8, m8, ore], "svg");
function pre(e) {
  if (e.allowedElements && e.disallowedElements)
    throw new TypeError(
      "Only one of `allowedElements` and `disallowedElements` should be defined"
    );
  if (e.allowedElements || e.disallowedElements || e.allowElement)
    return (t) => {
      Fv(t, "element", (n, r, i) => {
        const o = (
          /** @type {Element|Root} */
          i
        );
        let a;
        if (e.allowedElements ? a = !e.allowedElements.includes(n.tagName) : e.disallowedElements && (a = e.disallowedElements.includes(n.tagName)), !a && e.allowElement && typeof r == "number" && (a = !e.allowElement(n, r, o)), a && typeof r == "number")
          return e.unwrapDisallowed && n.children ? o.children.splice(r, 1, ...n.children) : o.children.splice(r, 1), r;
      });
    };
}
var Cg = { exports: {} }, gt = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var r4;
function hre() {
  if (r4)
    return gt;
  r4 = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), v;
  v = Symbol.for("react.module.reference");
  function w(b) {
    if (typeof b == "object" && b !== null) {
      var E = b.$$typeof;
      switch (E) {
        case e:
          switch (b = b.type, b) {
            case n:
            case i:
            case r:
            case f:
            case p:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case a:
                case c:
                case h:
                case d:
                case o:
                  return b;
                default:
                  return E;
              }
          }
        case t:
          return E;
      }
    }
  }
  return gt.ContextConsumer = a, gt.ContextProvider = o, gt.Element = e, gt.ForwardRef = c, gt.Fragment = n, gt.Lazy = h, gt.Memo = d, gt.Portal = t, gt.Profiler = i, gt.StrictMode = r, gt.Suspense = f, gt.SuspenseList = p, gt.isAsyncMode = function() {
    return !1;
  }, gt.isConcurrentMode = function() {
    return !1;
  }, gt.isContextConsumer = function(b) {
    return w(b) === a;
  }, gt.isContextProvider = function(b) {
    return w(b) === o;
  }, gt.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === e;
  }, gt.isForwardRef = function(b) {
    return w(b) === c;
  }, gt.isFragment = function(b) {
    return w(b) === n;
  }, gt.isLazy = function(b) {
    return w(b) === h;
  }, gt.isMemo = function(b) {
    return w(b) === d;
  }, gt.isPortal = function(b) {
    return w(b) === t;
  }, gt.isProfiler = function(b) {
    return w(b) === i;
  }, gt.isStrictMode = function(b) {
    return w(b) === r;
  }, gt.isSuspense = function(b) {
    return w(b) === f;
  }, gt.isSuspenseList = function(b) {
    return w(b) === p;
  }, gt.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === n || b === i || b === r || b === f || b === p || b === m || typeof b == "object" && b !== null && (b.$$typeof === h || b.$$typeof === d || b.$$typeof === o || b.$$typeof === a || b.$$typeof === c || b.$$typeof === v || b.getModuleId !== void 0);
  }, gt.typeOf = w, gt;
}
var vt = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var i4;
function mre() {
  return i4 || (i4 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), v = !1, w = !1, b = !1, E = !1, C = !1, S;
    S = Symbol.for("react.module.reference");
    function _(xe) {
      return !!(typeof xe == "string" || typeof xe == "function" || xe === n || xe === i || C || xe === r || xe === f || xe === p || E || xe === m || v || w || b || typeof xe == "object" && xe !== null && (xe.$$typeof === h || xe.$$typeof === d || xe.$$typeof === o || xe.$$typeof === a || xe.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      xe.$$typeof === S || xe.getModuleId !== void 0));
    }
    function T(xe) {
      if (typeof xe == "object" && xe !== null) {
        var Ue = xe.$$typeof;
        switch (Ue) {
          case e:
            var bt = xe.type;
            switch (bt) {
              case n:
              case i:
              case r:
              case f:
              case p:
                return bt;
              default:
                var Et = bt && bt.$$typeof;
                switch (Et) {
                  case s:
                  case a:
                  case c:
                  case h:
                  case d:
                  case o:
                    return Et;
                  default:
                    return Ue;
                }
            }
          case t:
            return Ue;
        }
      }
    }
    var P = a, R = o, N = e, B = c, L = n, j = h, I = d, z = t, H = i, G = r, Y = f, ne = p, J = !1, ee = !1;
    function A(xe) {
      return J || (J = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function X(xe) {
      return ee || (ee = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function fe(xe) {
      return T(xe) === a;
    }
    function M(xe) {
      return T(xe) === o;
    }
    function Z(xe) {
      return typeof xe == "object" && xe !== null && xe.$$typeof === e;
    }
    function ie(xe) {
      return T(xe) === c;
    }
    function pe(xe) {
      return T(xe) === n;
    }
    function Te(xe) {
      return T(xe) === h;
    }
    function ke(xe) {
      return T(xe) === d;
    }
    function me(xe) {
      return T(xe) === t;
    }
    function Pe(xe) {
      return T(xe) === i;
    }
    function ct(xe) {
      return T(xe) === r;
    }
    function se(xe) {
      return T(xe) === f;
    }
    function Le(xe) {
      return T(xe) === p;
    }
    vt.ContextConsumer = P, vt.ContextProvider = R, vt.Element = N, vt.ForwardRef = B, vt.Fragment = L, vt.Lazy = j, vt.Memo = I, vt.Portal = z, vt.Profiler = H, vt.StrictMode = G, vt.Suspense = Y, vt.SuspenseList = ne, vt.isAsyncMode = A, vt.isConcurrentMode = X, vt.isContextConsumer = fe, vt.isContextProvider = M, vt.isElement = Z, vt.isForwardRef = ie, vt.isFragment = pe, vt.isLazy = Te, vt.isMemo = ke, vt.isPortal = me, vt.isProfiler = Pe, vt.isStrictMode = ct, vt.isSuspense = se, vt.isSuspenseList = Le, vt.isValidElementType = _, vt.typeOf = T;
  }()), vt;
}
process.env.NODE_ENV === "production" ? Cg.exports = hre() : Cg.exports = mre();
var gre = Cg.exports;
const vre = /* @__PURE__ */ fo(gre);
function wre(e) {
  const t = (
    // @ts-expect-error looks like a node.
    e && typeof e == "object" && e.type === "text" ? (
      // @ts-expect-error looks like a text.
      e.value || ""
    ) : e
  );
  return typeof t == "string" && t.replace(/[ \t\n\f\r]/g, "") === "";
}
function yre(e) {
  return e.join(" ").trim();
}
function bre(e, t) {
  const n = t || {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
var Bv = { exports: {} }, o4 = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, xre = /\n/g, Ere = /^\s*/, Cre = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, Sre = /^:\s*/, _re = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, Tre = /^[;\s]*/, kre = /^\s+|\s+$/g, Pre = `
`, a4 = "/", s4 = "*", No = "", Are = "comment", Rre = "declaration", $re = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e)
    return [];
  t = t || {};
  var n = 1, r = 1;
  function i(v) {
    var w = v.match(xre);
    w && (n += w.length);
    var b = v.lastIndexOf(Pre);
    r = ~b ? v.length - b : r + v.length;
  }
  function o() {
    var v = { line: n, column: r };
    return function(w) {
      return w.position = new a(v), f(), w;
    };
  }
  function a(v) {
    this.start = v, this.end = { line: n, column: r }, this.source = t.source;
  }
  a.prototype.content = e;
  function s(v) {
    var w = new Error(
      t.source + ":" + n + ":" + r + ": " + v
    );
    if (w.reason = v, w.filename = t.source, w.line = n, w.column = r, w.source = e, !t.silent)
      throw w;
  }
  function c(v) {
    var w = v.exec(e);
    if (w) {
      var b = w[0];
      return i(b), e = e.slice(b.length), w;
    }
  }
  function f() {
    c(Ere);
  }
  function p(v) {
    var w;
    for (v = v || []; w = d(); )
      w !== !1 && v.push(w);
    return v;
  }
  function d() {
    var v = o();
    if (!(a4 != e.charAt(0) || s4 != e.charAt(1))) {
      for (var w = 2; No != e.charAt(w) && (s4 != e.charAt(w) || a4 != e.charAt(w + 1)); )
        ++w;
      if (w += 2, No === e.charAt(w - 1))
        return s("End of comment missing");
      var b = e.slice(2, w - 2);
      return r += 2, i(b), e = e.slice(w), r += 2, v({
        type: Are,
        comment: b
      });
    }
  }
  function h() {
    var v = o(), w = c(Cre);
    if (w) {
      if (d(), !c(Sre))
        return s("property missing ':'");
      var b = c(_re), E = v({
        type: Rre,
        property: l4(w[0].replace(o4, No)),
        value: b ? l4(b[0].replace(o4, No)) : No
      });
      return c(Tre), E;
    }
  }
  function m() {
    var v = [];
    p(v);
    for (var w; w = h(); )
      w !== !1 && (v.push(w), p(v));
    return v;
  }
  return f(), m();
};
function l4(e) {
  return e ? e.replace(kre, No) : No;
}
var Ore = $re;
function g8(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  for (var r, i = Ore(e), o = typeof t == "function", a, s, c = 0, f = i.length; c < f; c++)
    r = i[c], a = r.property, s = r.value, o ? t(a, s, r) : s && (n || (n = {}), n[a] = s);
  return n;
}
Bv.exports = g8;
Bv.exports.default = g8;
var Mre = Bv.exports;
const Dre = /* @__PURE__ */ fo(Mre), Sg = {}.hasOwnProperty, Nre = /* @__PURE__ */ new Set(["table", "thead", "tbody", "tfoot", "tr"]);
function v8(e, t) {
  const n = [];
  let r = -1, i;
  for (; ++r < t.children.length; )
    i = t.children[r], i.type === "element" ? n.push(Ire(e, i, r, t)) : i.type === "text" ? (t.type !== "element" || !Nre.has(t.tagName) || !wre(i)) && n.push(i.value) : i.type === "raw" && !e.options.skipHtml && n.push(i.value);
  return n;
}
function Ire(e, t, n, r) {
  const i = e.options, o = i.transformLinkUri === void 0 ? HJ : i.transformLinkUri, a = e.schema, s = t.tagName, c = {};
  let f = a, p;
  if (a.space === "html" && s === "svg" && (f = dre, e.schema = f), t.properties)
    for (p in t.properties)
      Sg.call(t.properties, p) && Fre(c, p, t.properties[p], e);
  (s === "ol" || s === "ul") && e.listDepth++;
  const d = v8(e, t);
  (s === "ol" || s === "ul") && e.listDepth--, e.schema = a;
  const h = t.position || {
    start: { line: null, column: null, offset: null },
    end: { line: null, column: null, offset: null }
  }, m = i.components && Sg.call(i.components, s) ? i.components[s] : s, v = typeof m == "string" || m === y.Fragment;
  if (!vre.isValidElementType(m))
    throw new TypeError(
      `Component for name \`${s}\` not defined or is not renderable`
    );
  if (c.key = n, s === "a" && i.linkTarget && (c.target = typeof i.linkTarget == "function" ? i.linkTarget(
    String(c.href || ""),
    t.children,
    typeof c.title == "string" ? c.title : null
  ) : i.linkTarget), s === "a" && o && (c.href = o(
    String(c.href || ""),
    t.children,
    typeof c.title == "string" ? c.title : null
  )), !v && s === "code" && r.type === "element" && r.tagName !== "pre" && (c.inline = !0), !v && (s === "h1" || s === "h2" || s === "h3" || s === "h4" || s === "h5" || s === "h6") && (c.level = Number.parseInt(s.charAt(1), 10)), s === "img" && i.transformImageUri && (c.src = i.transformImageUri(
    String(c.src || ""),
    String(c.alt || ""),
    typeof c.title == "string" ? c.title : null
  )), !v && s === "li" && r.type === "element") {
    const w = Lre(t);
    c.checked = w && w.properties ? !!w.properties.checked : null, c.index = Dh(r, t), c.ordered = r.tagName === "ol";
  }
  return !v && (s === "ol" || s === "ul") && (c.ordered = s === "ol", c.depth = e.listDepth), (s === "td" || s === "th") && (c.align && (c.style || (c.style = {}), c.style.textAlign = c.align, delete c.align), v || (c.isHeader = s === "th")), !v && s === "tr" && r.type === "element" && (c.isHeader = r.tagName === "thead"), i.sourcePos && (c["data-sourcepos"] = Bre(h)), !v && i.rawSourcePos && (c.sourcePosition = t.position), !v && i.includeElementIndex && (c.index = Dh(r, t), c.siblingCount = Dh(r)), v || (c.node = t), d.length > 0 ? y.createElement(m, c, d) : y.createElement(m, c);
}
function Lre(e) {
  let t = -1;
  for (; ++t < e.children.length; ) {
    const n = e.children[t];
    if (n.type === "element" && n.tagName === "input")
      return n;
  }
  return null;
}
function Dh(e, t) {
  let n = -1, r = 0;
  for (; ++n < e.children.length && e.children[n] !== t; )
    e.children[n].type === "element" && r++;
  return r;
}
function Fre(e, t, n, r) {
  const i = lre(r.schema, t);
  let o = n;
  o == null || o !== o || (Array.isArray(o) && (o = i.commaSeparated ? bre(o) : yre(o)), i.property === "style" && typeof o == "string" && (o = zre(o)), i.space && i.property ? e[Sg.call(n4, i.property) ? n4[i.property] : i.property] = o : i.attribute && (e[i.attribute] = o));
}
function zre(e) {
  const t = {};
  try {
    Dre(e, n);
  } catch {
  }
  return t;
  function n(r, i) {
    const o = r.slice(0, 4) === "-ms-" ? `ms-${r.slice(4)}` : r;
    t[o.replace(/-([a-z])/g, Vre)] = i;
  }
}
function Vre(e, t) {
  return t.toUpperCase();
}
function Bre(e) {
  return [
    e.start.line,
    ":",
    e.start.column,
    "-",
    e.end.line,
    ":",
    e.end.column
  ].map(String).join("");
}
const c4 = {}.hasOwnProperty, Hre = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", nu = {
  plugins: { to: "remarkPlugins", id: "change-plugins-to-remarkplugins" },
  renderers: { to: "components", id: "change-renderers-to-components" },
  astPlugins: { id: "remove-buggy-html-in-markdown-parser" },
  allowDangerousHtml: { id: "remove-buggy-html-in-markdown-parser" },
  escapeHtml: { id: "remove-buggy-html-in-markdown-parser" },
  source: { to: "children", id: "change-source-to-children" },
  allowNode: {
    to: "allowElement",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  allowedTypes: {
    to: "allowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  disallowedTypes: {
    to: "disallowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  includeNodeIndex: {
    to: "includeElementIndex",
    id: "change-includenodeindex-to-includeelementindex"
  }
};
function w8(e) {
  for (const o in nu)
    if (c4.call(nu, o) && c4.call(e, o)) {
      const a = nu[o];
      console.warn(
        `[react-markdown] Warning: please ${a.to ? `use \`${a.to}\` instead of` : "remove"} \`${o}\` (see <${Hre}#${a.id}> for more info)`
      ), delete nu[o];
    }
  const t = iee().use(cne).use(e.remarkPlugins || []).use(Jne, {
    ...e.remarkRehypeOptions,
    allowDangerousHtml: !0
  }).use(e.rehypePlugins || []).use(pre, e), n = new IS();
  typeof e.children == "string" ? n.value = e.children : e.children !== void 0 && e.children !== null && console.warn(
    `[react-markdown] Warning: please pass a string as \`children\` (not: \`${e.children}\`)`
  );
  const r = t.runSync(t.parse(n), n);
  if (r.type !== "root")
    throw new TypeError("Expected a `root` node");
  let i = y.createElement(
    y.Fragment,
    {},
    v8({ options: e, schema: fre, listDepth: 0 }, r)
  );
  return e.className && (i = y.createElement("div", { className: e.className }, i)), i;
}
w8.propTypes = {
  // Core options:
  children: ye.string,
  // Layout options:
  className: ye.string,
  // Filter options:
  allowElement: ye.func,
  allowedElements: ye.arrayOf(ye.string),
  disallowedElements: ye.arrayOf(ye.string),
  unwrapDisallowed: ye.bool,
  // Plugin options:
  remarkPlugins: ye.arrayOf(
    ye.oneOfType([
      ye.object,
      ye.func,
      ye.arrayOf(
        ye.oneOfType([
          ye.bool,
          ye.string,
          ye.object,
          ye.func,
          ye.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            ye.any
          )
        ])
      )
    ])
  ),
  rehypePlugins: ye.arrayOf(
    ye.oneOfType([
      ye.object,
      ye.func,
      ye.arrayOf(
        ye.oneOfType([
          ye.bool,
          ye.string,
          ye.object,
          ye.func,
          ye.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            ye.any
          )
        ])
      )
    ])
  ),
  // Transform options:
  sourcePos: ye.bool,
  rawSourcePos: ye.bool,
  skipHtml: ye.bool,
  includeElementIndex: ye.bool,
  transformLinkUri: ye.oneOfType([ye.func, ye.bool]),
  linkTarget: ye.oneOfType([ye.func, ye.string]),
  transformImageUri: ye.func,
  components: ye.object
};
const Ure = {
  tokenize: Kre,
  partial: !0
}, y8 = {
  tokenize: Xre,
  partial: !0
}, b8 = {
  tokenize: Qre,
  partial: !0
}, x8 = {
  tokenize: Zre,
  partial: !0
}, Wre = {
  tokenize: Jre,
  partial: !0
}, E8 = {
  tokenize: Gre,
  previous: S8
}, C8 = {
  tokenize: Yre,
  previous: _8
}, Di = {
  tokenize: qre,
  previous: T8
}, ci = {}, jre = {
  text: ci
};
let Ro = 48;
for (; Ro < 123; )
  ci[Ro] = Di, Ro++, Ro === 58 ? Ro = 65 : Ro === 91 && (Ro = 97);
ci[43] = Di;
ci[45] = Di;
ci[46] = Di;
ci[95] = Di;
ci[72] = [Di, C8];
ci[104] = [Di, C8];
ci[87] = [Di, E8];
ci[119] = [Di, E8];
function qre(e, t, n) {
  const r = this;
  let i, o;
  return a;
  function a(d) {
    return !_g(d) || !T8.call(r, r.previous) || Hv(r.events) ? n(d) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), s(d));
  }
  function s(d) {
    return _g(d) ? (e.consume(d), s) : d === 64 ? (e.consume(d), c) : n(d);
  }
  function c(d) {
    return d === 46 ? e.check(
      Wre,
      p,
      f
    )(d) : d === 45 || d === 95 || wn(d) ? (o = !0, e.consume(d), c) : p(d);
  }
  function f(d) {
    return e.consume(d), i = !0, c;
  }
  function p(d) {
    return o && i && Rn(r.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), t(d)) : n(d);
  }
}
function Gre(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return a !== 87 && a !== 119 || !S8.call(r, r.previous) || Hv(r.events) ? n(a) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(
      Ure,
      e.attempt(y8, e.attempt(b8, o), n),
      n
    )(a));
  }
  function o(a) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), t(a);
  }
}
function Yre(e, t, n) {
  const r = this;
  let i = "", o = !1;
  return a;
  function a(d) {
    return (d === 72 || d === 104) && _8.call(r, r.previous) && !Hv(r.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), i += String.fromCodePoint(d), e.consume(d), s) : n(d);
  }
  function s(d) {
    if (Rn(d) && i.length < 5)
      return i += String.fromCodePoint(d), e.consume(d), s;
    if (d === 58) {
      const h = i.toLowerCase();
      if (h === "http" || h === "https")
        return e.consume(d), c;
    }
    return n(d);
  }
  function c(d) {
    return d === 47 ? (e.consume(d), o ? f : (o = !0, c)) : n(d);
  }
  function f(d) {
    return d === null || lf(d) || Tt(d) || Go(d) || fd(d) ? n(d) : e.attempt(y8, e.attempt(b8, p), n)(d);
  }
  function p(d) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), t(d);
  }
}
function Kre(e, t, n) {
  let r = 0;
  return i;
  function i(a) {
    return (a === 87 || a === 119) && r < 3 ? (r++, e.consume(a), i) : a === 46 && r === 3 ? (e.consume(a), o) : n(a);
  }
  function o(a) {
    return a === null ? n(a) : t(a);
  }
}
function Xre(e, t, n) {
  let r, i, o;
  return a;
  function a(f) {
    return f === 46 || f === 95 ? e.check(x8, c, s)(f) : f === null || Tt(f) || Go(f) || f !== 45 && fd(f) ? c(f) : (o = !0, e.consume(f), a);
  }
  function s(f) {
    return f === 95 ? r = !0 : (i = r, r = void 0), e.consume(f), a;
  }
  function c(f) {
    return i || r || !o ? n(f) : t(f);
  }
}
function Qre(e, t) {
  let n = 0, r = 0;
  return i;
  function i(a) {
    return a === 40 ? (n++, e.consume(a), i) : a === 41 && r < n ? o(a) : a === 33 || a === 34 || a === 38 || a === 39 || a === 41 || a === 42 || a === 44 || a === 46 || a === 58 || a === 59 || a === 60 || a === 63 || a === 93 || a === 95 || a === 126 ? e.check(x8, t, o)(a) : a === null || Tt(a) || Go(a) ? t(a) : (e.consume(a), i);
  }
  function o(a) {
    return a === 41 && r++, e.consume(a), i;
  }
}
function Zre(e, t, n) {
  return r;
  function r(s) {
    return s === 33 || s === 34 || s === 39 || s === 41 || s === 42 || s === 44 || s === 46 || s === 58 || s === 59 || s === 63 || s === 95 || s === 126 ? (e.consume(s), r) : s === 38 ? (e.consume(s), o) : s === 93 ? (e.consume(s), i) : (
      // `<` is an end.
      s === 60 || // So is whitespace.
      s === null || Tt(s) || Go(s) ? t(s) : n(s)
    );
  }
  function i(s) {
    return s === null || s === 40 || s === 91 || Tt(s) || Go(s) ? t(s) : r(s);
  }
  function o(s) {
    return Rn(s) ? a(s) : n(s);
  }
  function a(s) {
    return s === 59 ? (e.consume(s), r) : Rn(s) ? (e.consume(s), a) : n(s);
  }
}
function Jre(e, t, n) {
  return r;
  function r(o) {
    return e.consume(o), i;
  }
  function i(o) {
    return wn(o) ? n(o) : t(o);
  }
}
function S8(e) {
  return e === null || e === 40 || e === 42 || e === 95 || e === 91 || e === 93 || e === 126 || Tt(e);
}
function _8(e) {
  return !Rn(e);
}
function T8(e) {
  return !(e === 47 || _g(e));
}
function _g(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || wn(e);
}
function Hv(e) {
  let t = e.length, n = !1;
  for (; t--; ) {
    const r = e[t][1];
    if ((r.type === "labelLink" || r.type === "labelImage") && !r._balanced) {
      n = !0;
      break;
    }
    if (r._gfmAutolinkLiteralWalkedInto) {
      n = !1;
      break;
    }
  }
  return e.length > 0 && !n && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), n;
}
const eie = {
  tokenize: lie,
  partial: !0
};
function tie() {
  return {
    document: {
      [91]: {
        tokenize: oie,
        continuation: {
          tokenize: aie
        },
        exit: sie
      }
    },
    text: {
      [91]: {
        tokenize: iie
      },
      [93]: {
        add: "after",
        tokenize: nie,
        resolveTo: rie
      }
    }
  };
}
function nie(e, t, n) {
  const r = this;
  let i = r.events.length;
  const o = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let a;
  for (; i--; ) {
    const c = r.events[i][1];
    if (c.type === "labelImage") {
      a = c;
      break;
    }
    if (c.type === "gfmFootnoteCall" || c.type === "labelLink" || c.type === "label" || c.type === "image" || c.type === "link")
      break;
  }
  return s;
  function s(c) {
    if (!a || !a._balanced)
      return n(c);
    const f = Ur(
      r.sliceSerialize({
        start: a.end,
        end: r.now()
      })
    );
    return f.codePointAt(0) !== 94 || !o.includes(f.slice(1)) ? n(c) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(c), e.exit("gfmFootnoteCallLabelMarker"), t(c));
  }
}
function rie(e, t) {
  let n = e.length;
  for (; n--; )
    if (e[n][1].type === "labelImage" && e[n][0] === "enter") {
      e[n][1];
      break;
    }
  e[n + 1][1].type = "data", e[n + 3][1].type = "gfmFootnoteCallLabelMarker";
  const r = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, e[n + 3][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, i = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, e[n + 3][1].end),
    end: Object.assign({}, e[n + 3][1].end)
  };
  i.end.column++, i.end.offset++, i.end._bufferIndex++;
  const o = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, i.end),
    end: Object.assign({}, e[e.length - 1][1].start)
  }, a = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, o.start),
    end: Object.assign({}, o.end)
  }, s = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    e[n + 1],
    e[n + 2],
    ["enter", r, t],
    // The `[`
    e[n + 3],
    e[n + 4],
    // The `^`.
    ["enter", i, t],
    ["exit", i, t],
    // Everything in between.
    ["enter", o, t],
    ["enter", a, t],
    ["exit", a, t],
    ["exit", o, t],
    // The ending (`]`, properly parsed and labelled).
    e[e.length - 2],
    e[e.length - 1],
    ["exit", r, t]
  ];
  return e.splice(n, e.length - n + 1, ...s), e;
}
function iie(e, t, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let o = 0, a;
  return s;
  function s(d) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(d), e.exit("gfmFootnoteCallLabelMarker"), c;
  }
  function c(d) {
    return d !== 94 ? n(d) : (e.enter("gfmFootnoteCallMarker"), e.consume(d), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", f);
  }
  function f(d) {
    if (
      // Too long.
      o > 999 || // Closing brace with nothing.
      d === 93 && !a || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      d === null || d === 91 || Tt(d)
    )
      return n(d);
    if (d === 93) {
      e.exit("chunkString");
      const h = e.exit("gfmFootnoteCallString");
      return i.includes(Ur(r.sliceSerialize(h))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(d), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), t) : n(d);
    }
    return Tt(d) || (a = !0), o++, e.consume(d), d === 92 ? p : f;
  }
  function p(d) {
    return d === 91 || d === 92 || d === 93 ? (e.consume(d), o++, f) : f(d);
  }
}
function oie(e, t, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let o, a = 0, s;
  return c;
  function c(v) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(v), e.exit("gfmFootnoteDefinitionLabelMarker"), f;
  }
  function f(v) {
    return v === 94 ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(v), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", p) : n(v);
  }
  function p(v) {
    if (
      // Too long.
      a > 999 || // Closing brace with nothing.
      v === 93 && !s || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      v === null || v === 91 || Tt(v)
    )
      return n(v);
    if (v === 93) {
      e.exit("chunkString");
      const w = e.exit("gfmFootnoteDefinitionLabelString");
      return o = Ur(r.sliceSerialize(w)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(v), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), h;
    }
    return Tt(v) || (s = !0), a++, e.consume(v), v === 92 ? d : p;
  }
  function d(v) {
    return v === 91 || v === 92 || v === 93 ? (e.consume(v), a++, p) : p(v);
  }
  function h(v) {
    return v === 58 ? (e.enter("definitionMarker"), e.consume(v), e.exit("definitionMarker"), i.includes(o) || i.push(o), lt(
      e,
      m,
      "gfmFootnoteDefinitionWhitespace"
    )) : n(v);
  }
  function m(v) {
    return t(v);
  }
}
function aie(e, t, n) {
  return e.check(Ml, t, e.attempt(eie, t, n));
}
function sie(e) {
  e.exit("gfmFootnoteDefinition");
}
function lie(e, t, n) {
  const r = this;
  return lt(
    e,
    i,
    "gfmFootnoteDefinitionIndent",
    4 + 1
  );
  function i(o) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "gfmFootnoteDefinitionIndent" && a[2].sliceSerialize(a[1], !0).length === 4 ? t(o) : n(o);
  }
}
function cie(e) {
  let n = (e || {}).singleTilde;
  const r = {
    tokenize: o,
    resolveAll: i
  };
  return n == null && (n = !0), {
    text: {
      [126]: r
    },
    insideSpan: {
      null: [r]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function i(a, s) {
    let c = -1;
    for (; ++c < a.length; )
      if (a[c][0] === "enter" && a[c][1].type === "strikethroughSequenceTemporary" && a[c][1]._close) {
        let f = c;
        for (; f--; )
          if (a[f][0] === "exit" && a[f][1].type === "strikethroughSequenceTemporary" && a[f][1]._open && // If the sizes are the same:
          a[c][1].end.offset - a[c][1].start.offset === a[f][1].end.offset - a[f][1].start.offset) {
            a[c][1].type = "strikethroughSequence", a[f][1].type = "strikethroughSequence";
            const p = {
              type: "strikethrough",
              start: Object.assign({}, a[f][1].start),
              end: Object.assign({}, a[c][1].end)
            }, d = {
              type: "strikethroughText",
              start: Object.assign({}, a[f][1].end),
              end: Object.assign({}, a[c][1].start)
            }, h = [
              ["enter", p, s],
              ["enter", a[f][1], s],
              ["exit", a[f][1], s],
              ["enter", d, s]
            ], m = s.parser.constructs.insideSpan.null;
            m && nr(
              h,
              h.length,
              0,
              dd(m, a.slice(f + 1, c), s)
            ), nr(h, h.length, 0, [
              ["exit", d, s],
              ["enter", a[c][1], s],
              ["exit", a[c][1], s],
              ["exit", p, s]
            ]), nr(a, f - 1, c - f + 3, h), c = f + h.length - 2;
            break;
          }
      }
    for (c = -1; ++c < a.length; )
      a[c][1].type === "strikethroughSequenceTemporary" && (a[c][1].type = "data");
    return a;
  }
  function o(a, s, c) {
    const f = this.previous, p = this.events;
    let d = 0;
    return h;
    function h(v) {
      return f === 126 && p[p.length - 1][1].type !== "characterEscape" ? c(v) : (a.enter("strikethroughSequenceTemporary"), m(v));
    }
    function m(v) {
      const w = cf(f);
      if (v === 126)
        return d > 1 ? c(v) : (a.consume(v), d++, m);
      if (d < 2 && !n)
        return c(v);
      const b = a.exit("strikethroughSequenceTemporary"), E = cf(v);
      return b._open = !E || E === 2 && !!w, b._close = !w || w === 2 && !!E, s(v);
    }
  }
}
class uie {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {void}
   */
  add(t, n, r) {
    fie(this, t, n, r);
  }
  // To do: not used here.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {void}
  //  */
  // addBefore(index, remove, add) {
  //   addImpl(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {void}
   */
  consume(t) {
    if (this.map.sort((o, a) => o[0] - a[0]), this.map.length === 0)
      return;
    let n = this.map.length;
    const r = [];
    for (; n > 0; )
      n -= 1, r.push(t.slice(this.map[n][0] + this.map[n][1])), r.push(this.map[n][2]), t.length = this.map[n][0];
    r.push([...t]), t.length = 0;
    let i = r.pop();
    for (; i; )
      t.push(...i), i = r.pop();
    this.map.length = 0;
  }
}
function fie(e, t, n, r) {
  let i = 0;
  if (!(n === 0 && r.length === 0)) {
    for (; i < e.map.length; ) {
      if (e.map[i][0] === t) {
        e.map[i][1] += n, e.map[i][2].push(...r);
        return;
      }
      i += 1;
    }
    e.map.push([t, n, r]);
  }
}
function die(e, t) {
  let n = !1;
  const r = [];
  for (; t < e.length; ) {
    const i = e[t];
    if (n) {
      if (i[0] === "enter")
        i[1].type === "tableContent" && r.push(
          e[t + 1][1].type === "tableDelimiterMarker" ? "left" : "none"
        );
      else if (i[1].type === "tableContent") {
        if (e[t - 1][1].type === "tableDelimiterMarker") {
          const o = r.length - 1;
          r[o] = r[o] === "left" ? "center" : "right";
        }
      } else if (i[1].type === "tableDelimiterRow")
        break;
    } else
      i[0] === "enter" && i[1].type === "tableDelimiterRow" && (n = !0);
    t += 1;
  }
  return r;
}
const pie = {
  flow: {
    null: {
      tokenize: hie,
      resolveAll: mie
    }
  }
};
function hie(e, t, n) {
  const r = this;
  let i = 0, o = 0, a;
  return s;
  function s(L) {
    let j = r.events.length - 1;
    for (; j > -1; ) {
      const H = r.events[j][1].type;
      if (H === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      H === "linePrefix")
        j--;
      else
        break;
    }
    const I = j > -1 ? r.events[j][1].type : null, z = I === "tableHead" || I === "tableRow" ? P : c;
    return z === P && r.parser.lazy[r.now().line] ? n(L) : z(L);
  }
  function c(L) {
    return e.enter("tableHead"), e.enter("tableRow"), f(L);
  }
  function f(L) {
    return L === 124 || (a = !0, o += 1), p(L);
  }
  function p(L) {
    return L === null ? n(L) : Ie(L) ? o > 1 ? (o = 0, r.interrupt = !0, e.exit("tableRow"), e.enter("lineEnding"), e.consume(L), e.exit("lineEnding"), m) : n(L) : Je(L) ? lt(e, p, "whitespace")(L) : (o += 1, a && (a = !1, i += 1), L === 124 ? (e.enter("tableCellDivider"), e.consume(L), e.exit("tableCellDivider"), a = !0, p) : (e.enter("data"), d(L)));
  }
  function d(L) {
    return L === null || L === 124 || Tt(L) ? (e.exit("data"), p(L)) : (e.consume(L), L === 92 ? h : d);
  }
  function h(L) {
    return L === 92 || L === 124 ? (e.consume(L), d) : d(L);
  }
  function m(L) {
    return r.interrupt = !1, r.parser.lazy[r.now().line] ? n(L) : (e.enter("tableDelimiterRow"), a = !1, Je(L) ? lt(
      e,
      v,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(L) : v(L));
  }
  function v(L) {
    return L === 45 || L === 58 ? b(L) : L === 124 ? (a = !0, e.enter("tableCellDivider"), e.consume(L), e.exit("tableCellDivider"), w) : T(L);
  }
  function w(L) {
    return Je(L) ? lt(e, b, "whitespace")(L) : b(L);
  }
  function b(L) {
    return L === 58 ? (o += 1, a = !0, e.enter("tableDelimiterMarker"), e.consume(L), e.exit("tableDelimiterMarker"), E) : L === 45 ? (o += 1, E(L)) : L === null || Ie(L) ? _(L) : T(L);
  }
  function E(L) {
    return L === 45 ? (e.enter("tableDelimiterFiller"), C(L)) : T(L);
  }
  function C(L) {
    return L === 45 ? (e.consume(L), C) : L === 58 ? (a = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(L), e.exit("tableDelimiterMarker"), S) : (e.exit("tableDelimiterFiller"), S(L));
  }
  function S(L) {
    return Je(L) ? lt(e, _, "whitespace")(L) : _(L);
  }
  function _(L) {
    return L === 124 ? v(L) : L === null || Ie(L) ? !a || i !== o ? T(L) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), t(L)) : T(L);
  }
  function T(L) {
    return n(L);
  }
  function P(L) {
    return e.enter("tableRow"), R(L);
  }
  function R(L) {
    return L === 124 ? (e.enter("tableCellDivider"), e.consume(L), e.exit("tableCellDivider"), R) : L === null || Ie(L) ? (e.exit("tableRow"), t(L)) : Je(L) ? lt(e, R, "whitespace")(L) : (e.enter("data"), N(L));
  }
  function N(L) {
    return L === null || L === 124 || Tt(L) ? (e.exit("data"), R(L)) : (e.consume(L), L === 92 ? B : N);
  }
  function B(L) {
    return L === 92 || L === 124 ? (e.consume(L), N) : N(L);
  }
}
function mie(e, t) {
  let n = -1, r = !0, i = 0, o = [0, 0, 0, 0], a = [0, 0, 0, 0], s = !1, c = 0, f, p, d;
  const h = new uie();
  for (; ++n < e.length; ) {
    const m = e[n], v = m[1];
    m[0] === "enter" ? v.type === "tableHead" ? (s = !1, c !== 0 && (u4(h, t, c, f, p), p = void 0, c = 0), f = {
      type: "table",
      start: Object.assign({}, v.start),
      // Note: correct end is set later.
      end: Object.assign({}, v.end)
    }, h.add(n, 0, [["enter", f, t]])) : v.type === "tableRow" || v.type === "tableDelimiterRow" ? (r = !0, d = void 0, o = [0, 0, 0, 0], a = [0, n + 1, 0, 0], s && (s = !1, p = {
      type: "tableBody",
      start: Object.assign({}, v.start),
      // Note: correct end is set later.
      end: Object.assign({}, v.end)
    }, h.add(n, 0, [["enter", p, t]])), i = v.type === "tableDelimiterRow" ? 2 : p ? 3 : 1) : i && (v.type === "data" || v.type === "tableDelimiterMarker" || v.type === "tableDelimiterFiller") ? (r = !1, a[2] === 0 && (o[1] !== 0 && (a[0] = a[1], d = ru(
      h,
      t,
      o,
      i,
      void 0,
      d
    ), o = [0, 0, 0, 0]), a[2] = n)) : v.type === "tableCellDivider" && (r ? r = !1 : (o[1] !== 0 && (a[0] = a[1], d = ru(
      h,
      t,
      o,
      i,
      void 0,
      d
    )), o = a, a = [o[1], n, 0, 0])) : v.type === "tableHead" ? (s = !0, c = n) : v.type === "tableRow" || v.type === "tableDelimiterRow" ? (c = n, o[1] !== 0 ? (a[0] = a[1], d = ru(
      h,
      t,
      o,
      i,
      n,
      d
    )) : a[1] !== 0 && (d = ru(h, t, a, i, n, d)), i = 0) : i && (v.type === "data" || v.type === "tableDelimiterMarker" || v.type === "tableDelimiterFiller") && (a[3] = n);
  }
  for (c !== 0 && u4(h, t, c, f, p), h.consume(t.events), n = -1; ++n < t.events.length; ) {
    const m = t.events[n];
    m[0] === "enter" && m[1].type === "table" && (m[1]._align = die(t.events, n));
  }
  return e;
}
function ru(e, t, n, r, i, o) {
  const a = r === 1 ? "tableHeader" : r === 2 ? "tableDelimiter" : "tableData", s = "tableContent";
  n[0] !== 0 && (o.end = Object.assign({}, Sa(t.events, n[0])), e.add(n[0], 0, [["exit", o, t]]));
  const c = Sa(t.events, n[1]);
  if (o = {
    type: a,
    start: Object.assign({}, c),
    // Note: correct end is set later.
    end: Object.assign({}, c)
  }, e.add(n[1], 0, [["enter", o, t]]), n[2] !== 0) {
    const f = Sa(t.events, n[2]), p = Sa(t.events, n[3]), d = {
      type: s,
      start: Object.assign({}, f),
      end: Object.assign({}, p)
    };
    if (e.add(n[2], 0, [["enter", d, t]]), r !== 2) {
      const h = t.events[n[2]], m = t.events[n[3]];
      if (h[1].end = Object.assign({}, m[1].end), h[1].type = "chunkText", h[1].contentType = "text", n[3] > n[2] + 1) {
        const v = n[2] + 1, w = n[3] - n[2] - 1;
        e.add(v, w, []);
      }
    }
    e.add(n[3] + 1, 0, [["exit", d, t]]);
  }
  return i !== void 0 && (o.end = Object.assign({}, Sa(t.events, i)), e.add(i, 0, [["exit", o, t]]), o = void 0), o;
}
function u4(e, t, n, r, i) {
  const o = [], a = Sa(t.events, n);
  i && (i.end = Object.assign({}, a), o.push(["exit", i, t])), r.end = Object.assign({}, a), o.push(["exit", r, t]), e.add(n + 1, 0, o);
}
function Sa(e, t) {
  const n = e[t], r = n[0] === "enter" ? "start" : "end";
  return n[1][r];
}
const gie = {
  tokenize: wie
}, vie = {
  text: {
    [91]: gie
  }
};
function wie(e, t, n) {
  const r = this;
  return i;
  function i(c) {
    return (
      // Exit if there’s stuff before.
      r.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !r._gfmTasklistFirstContentOfListItem ? n(c) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(c), e.exit("taskListCheckMarker"), o)
    );
  }
  function o(c) {
    return Tt(c) ? (e.enter("taskListCheckValueUnchecked"), e.consume(c), e.exit("taskListCheckValueUnchecked"), a) : c === 88 || c === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(c), e.exit("taskListCheckValueChecked"), a) : n(c);
  }
  function a(c) {
    return c === 93 ? (e.enter("taskListCheckMarker"), e.consume(c), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), s) : n(c);
  }
  function s(c) {
    return Ie(c) ? t(c) : Je(c) ? e.check(
      {
        tokenize: yie
      },
      t,
      n
    )(c) : n(c);
  }
}
function yie(e, t, n) {
  return lt(e, r, "whitespace");
  function r(i) {
    return i === null ? n(i) : t(i);
  }
}
function bie(e) {
  return BS([
    jre,
    tie(),
    cie(e),
    pie,
    vie
  ]);
}
function f4(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let r = 0, i = n.indexOf(t);
  for (; i !== -1; )
    r++, i = n.indexOf(t, i + t.length);
  return r;
}
function xie(e) {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const Eie = {}.hasOwnProperty, Cie = (
  /**
   * @type {(
   *   (<Tree extends Node>(tree: Tree, find: Find, replace?: Replace | null | undefined, options?: Options | null | undefined) => Tree) &
   *   (<Tree extends Node>(tree: Tree, schema: FindAndReplaceSchema | FindAndReplaceList, options?: Options | null | undefined) => Tree)
   * )}
   **/
  /**
   * @template {Node} Tree
   * @param {Tree} tree
   * @param {Find | FindAndReplaceSchema | FindAndReplaceList} find
   * @param {Replace | Options | null | undefined} [replace]
   * @param {Options | null | undefined} [options]
   * @returns {Tree}
   */
  function(e, t, n, r) {
    let i, o;
    typeof t == "string" || t instanceof RegExp ? (o = [[t, n]], i = r) : (o = t, i = n), i || (i = {});
    const a = Lv(i.ignore || []), s = Sie(o);
    let c = -1;
    for (; ++c < s.length; )
      o8(e, "text", f);
    return e;
    function f(d, h) {
      let m = -1, v;
      for (; ++m < h.length; ) {
        const w = h[m];
        if (a(
          w,
          // @ts-expect-error: TS doesn’t understand but it’s perfect.
          v ? v.children.indexOf(w) : void 0,
          v
        ))
          return;
        v = w;
      }
      if (v)
        return p(d, h);
    }
    function p(d, h) {
      const m = h[h.length - 1], v = s[c][0], w = s[c][1];
      let b = 0;
      const E = m.children.indexOf(d);
      let C = !1, S = [];
      v.lastIndex = 0;
      let _ = v.exec(d.value);
      for (; _; ) {
        const T = _.index, P = {
          index: _.index,
          input: _.input,
          // @ts-expect-error: stack is fine.
          stack: [...h, d]
        };
        let R = w(..._, P);
        if (typeof R == "string" && (R = R.length > 0 ? { type: "text", value: R } : void 0), R !== !1 && (b !== T && S.push({
          type: "text",
          value: d.value.slice(b, T)
        }), Array.isArray(R) ? S.push(...R) : R && S.push(R), b = T + _[0].length, C = !0), !v.global)
          break;
        _ = v.exec(d.value);
      }
      return C ? (b < d.value.length && S.push({ type: "text", value: d.value.slice(b) }), m.children.splice(E, 1, ...S)) : S = [d], E + S.length;
    }
  }
);
function Sie(e) {
  const t = [];
  if (typeof e != "object")
    throw new TypeError("Expected array or object as schema");
  if (Array.isArray(e)) {
    let n = -1;
    for (; ++n < e.length; )
      t.push([
        d4(e[n][0]),
        p4(e[n][1])
      ]);
  } else {
    let n;
    for (n in e)
      Eie.call(e, n) && t.push([d4(n), p4(e[n])]);
  }
  return t;
}
function d4(e) {
  return typeof e == "string" ? new RegExp(xie(e), "g") : e;
}
function p4(e) {
  return typeof e == "function" ? e : () => e;
}
const Nh = "phrasing", Ih = ["autolink", "link", "image", "label"], _ie = {
  transforms: [Oie],
  enter: {
    literalAutolink: kie,
    literalAutolinkEmail: Lh,
    literalAutolinkHttp: Lh,
    literalAutolinkWww: Lh
  },
  exit: {
    literalAutolink: $ie,
    literalAutolinkEmail: Rie,
    literalAutolinkHttp: Pie,
    literalAutolinkWww: Aie
  }
}, Tie = {
  unsafe: [
    {
      character: "@",
      before: "[+\\-.\\w]",
      after: "[\\-.\\w]",
      inConstruct: Nh,
      notInConstruct: Ih
    },
    {
      character: ".",
      before: "[Ww]",
      after: "[\\-.\\w]",
      inConstruct: Nh,
      notInConstruct: Ih
    },
    { character: ":", before: "[ps]", after: "\\/", inConstruct: Nh, notInConstruct: Ih }
  ]
};
function kie(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function Lh(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function Pie(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function Aie(e) {
  this.config.exit.data.call(this, e);
  const t = (
    /** @type {Link} */
    this.stack[this.stack.length - 1]
  );
  t.url = "http://" + this.sliceSerialize(e);
}
function Rie(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function $ie(e) {
  this.exit(e);
}
function Oie(e) {
  Cie(
    e,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, Mie],
      [/([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g, Die]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function Mie(e, t, n, r, i) {
  let o = "";
  if (!k8(i) || (/^w/i.test(t) && (n = t + n, t = "", o = "http://"), !Nie(n)))
    return !1;
  const a = Iie(n + r);
  if (!a[0])
    return !1;
  const s = {
    type: "link",
    title: null,
    url: o + t + a[0],
    children: [{ type: "text", value: t + a[0] }]
  };
  return a[1] ? [s, { type: "text", value: a[1] }] : s;
}
function Die(e, t, n, r) {
  return (
    // Not an expected previous character.
    !k8(r, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(n) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + t + "@" + n,
      children: [{ type: "text", value: t + "@" + n }]
    }
  );
}
function Nie(e) {
  const t = e.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function Iie(e) {
  const t = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!t)
    return [e, void 0];
  e = e.slice(0, t.index);
  let n = t[0], r = n.indexOf(")");
  const i = f4(e, "(");
  let o = f4(e, ")");
  for (; r !== -1 && i > o; )
    e += n.slice(0, r + 1), n = n.slice(r + 1), r = n.indexOf(")"), o++;
  return [e, n];
}
function k8(e, t) {
  const n = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || Go(n) || fd(n)) && (!t || n !== 47);
}
function P8(e) {
  return e.label || !e.identifier ? e.label || "" : ZS(e.identifier);
}
function Lie(e, t, n) {
  const r = t.indexStack, i = e.children || [], o = t.createTracker(n), a = [];
  let s = -1;
  for (r.push(-1); ++s < i.length; ) {
    const c = i[s];
    r[r.length - 1] = s, a.push(
      o.move(
        t.handle(c, e, t, {
          before: `
`,
          after: `
`,
          ...o.current()
        })
      )
    ), c.type !== "list" && (t.bulletLastUsed = void 0), s < i.length - 1 && a.push(
      o.move(Fie(c, i[s + 1], e, t))
    );
  }
  return r.pop(), a.join("");
}
function Fie(e, t, n, r) {
  let i = r.join.length;
  for (; i--; ) {
    const o = r.join[i](e, t, n, r);
    if (o === !0 || o === 1)
      break;
    if (typeof o == "number")
      return `
`.repeat(1 + o);
    if (o === !1)
      return `

<!---->

`;
  }
  return `

`;
}
const zie = /\r?\n|\r/g;
function Vie(e, t) {
  const n = [];
  let r = 0, i = 0, o;
  for (; o = zie.exec(e); )
    a(e.slice(r, o.index)), n.push(o[0]), r = o.index + o[0].length, i++;
  return a(e.slice(r)), n.join("");
  function a(s) {
    n.push(t(s, i, !s));
  }
}
function A8(e) {
  if (!e._compiled) {
    const t = (e.atBreak ? "[\\r\\n][\\t ]*" : "") + (e.before ? "(?:" + e.before + ")" : "");
    e._compiled = new RegExp(
      (t ? "(" + t + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(e.character) ? "\\" : "") + e.character + (e.after ? "(?:" + e.after + ")" : ""),
      "g"
    );
  }
  return e._compiled;
}
function Bie(e, t) {
  return h4(e, t.inConstruct, !0) && !h4(e, t.notInConstruct, !1);
}
function h4(e, t, n) {
  if (typeof t == "string" && (t = [t]), !t || t.length === 0)
    return n;
  let r = -1;
  for (; ++r < t.length; )
    if (e.includes(t[r]))
      return !0;
  return !1;
}
function R8(e, t, n) {
  const r = (n.before || "") + (t || "") + (n.after || ""), i = [], o = [], a = {};
  let s = -1;
  for (; ++s < e.unsafe.length; ) {
    const p = e.unsafe[s];
    if (!Bie(e.stack, p))
      continue;
    const d = A8(p);
    let h;
    for (; h = d.exec(r); ) {
      const m = "before" in p || !!p.atBreak, v = "after" in p, w = h.index + (m ? h[1].length : 0);
      i.includes(w) ? (a[w].before && !m && (a[w].before = !1), a[w].after && !v && (a[w].after = !1)) : (i.push(w), a[w] = { before: m, after: v });
    }
  }
  i.sort(Hie);
  let c = n.before ? n.before.length : 0;
  const f = r.length - (n.after ? n.after.length : 0);
  for (s = -1; ++s < i.length; ) {
    const p = i[s];
    p < c || p >= f || p + 1 < f && i[s + 1] === p + 1 && a[p].after && !a[p + 1].before && !a[p + 1].after || i[s - 1] === p - 1 && a[p].before && !a[p - 1].before && !a[p - 1].after || (c !== p && o.push(m4(r.slice(c, p), "\\")), c = p, /[!-/:-@[-`{-~]/.test(r.charAt(p)) && (!n.encode || !n.encode.includes(r.charAt(p))) ? o.push("\\") : (o.push(
      "&#x" + r.charCodeAt(p).toString(16).toUpperCase() + ";"
    ), c++));
  }
  return o.push(m4(r.slice(c, f), n.after)), o.join("");
}
function Hie(e, t) {
  return e - t;
}
function m4(e, t) {
  const n = /\\(?=[!-/:-@[-`{-~])/g, r = [], i = [], o = e + t;
  let a = -1, s = 0, c;
  for (; c = n.exec(o); )
    r.push(c.index);
  for (; ++a < r.length; )
    s !== r[a] && i.push(e.slice(s, r[a])), i.push("\\"), s = r[a];
  return i.push(e.slice(s)), i.join("");
}
function hd(e) {
  const t = e || {}, n = t.now || {};
  let r = t.lineShift || 0, i = n.line || 1, o = n.column || 1;
  return { move: c, current: a, shift: s };
  function a() {
    return { now: { line: i, column: o }, lineShift: r };
  }
  function s(f) {
    r += f;
  }
  function c(f) {
    const p = f || "", d = p.split(/\r?\n|\r/g), h = d[d.length - 1];
    return i += d.length - 1, o = d.length === 1 ? o + h.length : 1 + h.length + r, p;
  }
}
$8.peek = Jie;
function Uie() {
  return {
    enter: {
      gfmFootnoteDefinition: jie,
      gfmFootnoteDefinitionLabelString: qie,
      gfmFootnoteCall: Kie,
      gfmFootnoteCallString: Xie
    },
    exit: {
      gfmFootnoteDefinition: Yie,
      gfmFootnoteDefinitionLabelString: Gie,
      gfmFootnoteCall: Zie,
      gfmFootnoteCallString: Qie
    }
  };
}
function Wie() {
  return {
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["phrasing", "label", "reference"] }],
    handlers: { footnoteDefinition: eoe, footnoteReference: $8 }
  };
}
function jie(e) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    e
  );
}
function qie() {
  this.buffer();
}
function Gie(e) {
  const t = this.resume(), n = (
    /** @type {FootnoteDefinition} */
    this.stack[this.stack.length - 1]
  );
  n.label = t, n.identifier = Ur(
    this.sliceSerialize(e)
  ).toLowerCase();
}
function Yie(e) {
  this.exit(e);
}
function Kie(e) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, e);
}
function Xie() {
  this.buffer();
}
function Qie(e) {
  const t = this.resume(), n = (
    /** @type {FootnoteDefinition} */
    this.stack[this.stack.length - 1]
  );
  n.label = t, n.identifier = Ur(
    this.sliceSerialize(e)
  ).toLowerCase();
}
function Zie(e) {
  this.exit(e);
}
function $8(e, t, n, r) {
  const i = hd(r);
  let o = i.move("[^");
  const a = n.enter("footnoteReference"), s = n.enter("reference");
  return o += i.move(
    R8(n, P8(e), {
      ...i.current(),
      before: o,
      after: "]"
    })
  ), s(), a(), o += i.move("]"), o;
}
function Jie() {
  return "[";
}
function eoe(e, t, n, r) {
  const i = hd(r);
  let o = i.move("[^");
  const a = n.enter("footnoteDefinition"), s = n.enter("label");
  return o += i.move(
    R8(n, P8(e), {
      ...i.current(),
      before: o,
      after: "]"
    })
  ), s(), o += i.move(
    "]:" + (e.children && e.children.length > 0 ? " " : "")
  ), i.shift(4), o += i.move(
    Vie(Lie(e, n, i.current()), toe)
  ), a(), o;
}
function toe(e, t, n) {
  return t === 0 ? e : (n ? "" : "    ") + e;
}
function O8(e, t, n) {
  const r = t.indexStack, i = e.children || [], o = [];
  let a = -1, s = n.before;
  r.push(-1);
  let c = t.createTracker(n);
  for (; ++a < i.length; ) {
    const f = i[a];
    let p;
    if (r[r.length - 1] = a, a + 1 < i.length) {
      let d = t.handle.handlers[i[a + 1].type];
      d && d.peek && (d = d.peek), p = d ? d(i[a + 1], e, t, {
        before: "",
        after: "",
        ...c.current()
      }).charAt(0) : "";
    } else
      p = n.after;
    o.length > 0 && (s === "\r" || s === `
`) && f.type === "html" && (o[o.length - 1] = o[o.length - 1].replace(
      /(\r?\n|\r)$/,
      " "
    ), s = " ", c = t.createTracker(n), c.move(o.join(""))), o.push(
      c.move(
        t.handle(f, e, t, {
          ...c.current(),
          before: s,
          after: p
        })
      )
    ), s = o[o.length - 1].slice(-1);
  }
  return r.pop(), o.join("");
}
const noe = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
M8.peek = soe;
const roe = {
  canContainEols: ["delete"],
  enter: { strikethrough: ooe },
  exit: { strikethrough: aoe }
}, ioe = {
  unsafe: [
    {
      character: "~",
      inConstruct: "phrasing",
      notInConstruct: noe
    }
  ],
  handlers: { delete: M8 }
};
function ooe(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function aoe(e) {
  this.exit(e);
}
function M8(e, t, n, r) {
  const i = hd(r), o = n.enter("strikethrough");
  let a = i.move("~~");
  return a += O8(e, n, {
    ...i.current(),
    before: a,
    after: "~"
  }), a += i.move("~~"), o(), a;
}
function soe() {
  return "~";
}
D8.peek = loe;
function D8(e, t, n) {
  let r = e.value || "", i = "`", o = -1;
  for (; new RegExp("(^|[^`])" + i + "([^`]|$)").test(r); )
    i += "`";
  for (/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++o < n.unsafe.length; ) {
    const a = n.unsafe[o], s = A8(a);
    let c;
    if (a.atBreak)
      for (; c = s.exec(r); ) {
        let f = c.index;
        r.charCodeAt(f) === 10 && r.charCodeAt(f - 1) === 13 && f--, r = r.slice(0, f) + " " + r.slice(c.index + 1);
      }
  }
  return i + r + i;
}
function loe() {
  return "`";
}
function coe(e) {
  return e.length;
}
function uoe(e, t) {
  const n = t || {}, r = (n.align || []).concat(), i = n.stringLength || coe, o = [], a = [], s = [], c = [];
  let f = 0, p = -1;
  for (; ++p < e.length; ) {
    const w = [], b = [];
    let E = -1;
    for (e[p].length > f && (f = e[p].length); ++E < e[p].length; ) {
      const C = foe(e[p][E]);
      if (n.alignDelimiters !== !1) {
        const S = i(C);
        b[E] = S, (c[E] === void 0 || S > c[E]) && (c[E] = S);
      }
      w.push(C);
    }
    a[p] = w, s[p] = b;
  }
  let d = -1;
  if (typeof r == "object" && "length" in r)
    for (; ++d < f; )
      o[d] = g4(r[d]);
  else {
    const w = g4(r);
    for (; ++d < f; )
      o[d] = w;
  }
  d = -1;
  const h = [], m = [];
  for (; ++d < f; ) {
    const w = o[d];
    let b = "", E = "";
    w === 99 ? (b = ":", E = ":") : w === 108 ? b = ":" : w === 114 && (E = ":");
    let C = n.alignDelimiters === !1 ? 1 : Math.max(
      1,
      c[d] - b.length - E.length
    );
    const S = b + "-".repeat(C) + E;
    n.alignDelimiters !== !1 && (C = b.length + C + E.length, C > c[d] && (c[d] = C), m[d] = C), h[d] = S;
  }
  a.splice(1, 0, h), s.splice(1, 0, m), p = -1;
  const v = [];
  for (; ++p < a.length; ) {
    const w = a[p], b = s[p];
    d = -1;
    const E = [];
    for (; ++d < f; ) {
      const C = w[d] || "";
      let S = "", _ = "";
      if (n.alignDelimiters !== !1) {
        const T = c[d] - (b[d] || 0), P = o[d];
        P === 114 ? S = " ".repeat(T) : P === 99 ? T % 2 ? (S = " ".repeat(T / 2 + 0.5), _ = " ".repeat(T / 2 - 0.5)) : (S = " ".repeat(T / 2), _ = S) : _ = " ".repeat(T);
      }
      n.delimiterStart !== !1 && !d && E.push("|"), n.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(n.alignDelimiters === !1 && C === "") && (n.delimiterStart !== !1 || d) && E.push(" "), n.alignDelimiters !== !1 && E.push(S), E.push(C), n.alignDelimiters !== !1 && E.push(_), n.padding !== !1 && E.push(" "), (n.delimiterEnd !== !1 || d !== f - 1) && E.push("|");
    }
    v.push(
      n.delimiterEnd === !1 ? E.join("").replace(/ +$/, "") : E.join("")
    );
  }
  return v.join(`
`);
}
function foe(e) {
  return e == null ? "" : String(e);
}
function g4(e) {
  const t = typeof e == "string" ? e.codePointAt(0) : 0;
  return t === 67 || t === 99 ? 99 : t === 76 || t === 108 ? 108 : t === 82 || t === 114 ? 114 : 0;
}
const doe = {
  enter: {
    table: poe,
    tableData: v4,
    tableHeader: v4,
    tableRow: moe
  },
  exit: {
    codeText: goe,
    table: hoe,
    tableData: Fh,
    tableHeader: Fh,
    tableRow: Fh
  }
};
function poe(e) {
  const t = e._align;
  this.enter(
    {
      type: "table",
      align: t.map((n) => n === "none" ? null : n),
      children: []
    },
    e
  ), this.setData("inTable", !0);
}
function hoe(e) {
  this.exit(e), this.setData("inTable");
}
function moe(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function Fh(e) {
  this.exit(e);
}
function v4(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function goe(e) {
  let t = this.resume();
  this.getData("inTable") && (t = t.replace(/\\([\\|])/g, voe));
  const n = (
    /** @type {InlineCode} */
    this.stack[this.stack.length - 1]
  );
  n.value = t, this.exit(e);
}
function voe(e, t) {
  return t === "|" ? t : e;
}
function woe(e) {
  const t = e || {}, n = t.tableCellPadding, r = t.tablePipeAlign, i = t.stringLength, o = n ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      table: a,
      tableRow: s,
      tableCell: c,
      inlineCode: h
    }
  };
  function a(m, v, w, b) {
    return f(
      p(m, w, b),
      m.align
    );
  }
  function s(m, v, w, b) {
    const E = d(m, w, b), C = f([E]);
    return C.slice(0, C.indexOf(`
`));
  }
  function c(m, v, w, b) {
    const E = w.enter("tableCell"), C = w.enter("phrasing"), S = O8(m, w, {
      ...b,
      before: o,
      after: o
    });
    return C(), E(), S;
  }
  function f(m, v) {
    return uoe(m, {
      align: v,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: r,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: n,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: i
    });
  }
  function p(m, v, w) {
    const b = m.children;
    let E = -1;
    const C = [], S = v.enter("table");
    for (; ++E < b.length; )
      C[E] = d(
        b[E],
        v,
        w
      );
    return S(), C;
  }
  function d(m, v, w) {
    const b = m.children;
    let E = -1;
    const C = [], S = v.enter("tableRow");
    for (; ++E < b.length; )
      C[E] = c(
        b[E],
        m,
        v,
        w
      );
    return S(), C;
  }
  function h(m, v, w) {
    let b = D8(m, v, w);
    return w.stack.includes("tableCell") && (b = b.replace(/\|/g, "\\$&")), b;
  }
}
function yoe(e) {
  const t = e.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return t;
}
function boe(e) {
  const t = e.options.listItemIndent || "tab";
  if (t === 1 || t === "1")
    return "one";
  if (t !== "tab" && t !== "one" && t !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return t;
}
function xoe(e, t, n, r) {
  const i = boe(n);
  let o = n.bulletCurrent || yoe(n);
  t && t.type === "list" && t.ordered && (o = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (n.options.incrementListMarker === !1 ? 0 : t.children.indexOf(e)) + o);
  let a = o.length + 1;
  (i === "tab" || i === "mixed" && (t && t.type === "list" && t.spread || e.spread)) && (a = Math.ceil(a / 4) * 4);
  const s = n.createTracker(r);
  s.move(o + " ".repeat(a - o.length)), s.shift(a);
  const c = n.enter("listItem"), f = n.indentLines(
    n.containerFlow(e, s.current()),
    p
  );
  return c(), f;
  function p(d, h, m) {
    return h ? (m ? "" : " ".repeat(a)) + d : (m ? o : o + " ".repeat(a - o.length)) + d;
  }
}
const Eoe = {
  exit: {
    taskListCheckValueChecked: w4,
    taskListCheckValueUnchecked: w4,
    paragraph: Soe
  }
}, Coe = {
  unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
  handlers: { listItem: _oe }
};
function w4(e) {
  const t = (
    /** @type {ListItem} */
    this.stack[this.stack.length - 2]
  );
  t.checked = e.type === "taskListCheckValueChecked";
}
function Soe(e) {
  const t = (
    /** @type {Parents} */
    this.stack[this.stack.length - 2]
  );
  if (t && t.type === "listItem" && typeof t.checked == "boolean") {
    const n = (
      /** @type {Paragraph} */
      this.stack[this.stack.length - 1]
    ), r = n.children[0];
    if (r && r.type === "text") {
      const i = t.children;
      let o = -1, a;
      for (; ++o < i.length; ) {
        const s = i[o];
        if (s.type === "paragraph") {
          a = s;
          break;
        }
      }
      a === n && (r.value = r.value.slice(1), r.value.length === 0 ? n.children.shift() : n.position && r.position && typeof r.position.start.offset == "number" && (r.position.start.column++, r.position.start.offset++, n.position.start = Object.assign({}, r.position.start)));
    }
  }
  this.exit(e);
}
function _oe(e, t, n, r) {
  const i = e.children[0], o = typeof e.checked == "boolean" && i && i.type === "paragraph", a = "[" + (e.checked ? "x" : " ") + "] ", s = hd(r);
  o && s.move(a);
  let c = xoe(e, t, n, {
    ...r,
    ...s.current()
  });
  return o && (c = c.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, f)), c;
  function f(p) {
    return p + a;
  }
}
function Toe() {
  return [
    _ie,
    Uie(),
    roe,
    doe,
    Eoe
  ];
}
function koe(e) {
  return {
    extensions: [
      Tie,
      Wie(),
      ioe,
      woe(e),
      Coe
    ]
  };
}
function Poe(e = {}) {
  const t = this.data();
  n("micromarkExtensions", bie(e)), n("fromMarkdownExtensions", Toe()), n("toMarkdownExtensions", koe(e));
  function n(r, i) {
    /** @type {unknown[]} */
    // Other extensions
    /* c8 ignore next 2 */
    (t[r] ? t[r] : t[r] = []).push(i);
  }
}
function N8({
  remarkPlugins: e = [],
  components: t = {},
  ...n
}) {
  const r = yn(
    () => ({
      h1: (i) => /* @__PURE__ */ y.createElement("h1", { className: "ai-tw-heading-1", ...i }),
      h2: (i) => /* @__PURE__ */ y.createElement("h2", { className: "ai-tw-heading-2", ...i }),
      h3: (i) => /* @__PURE__ */ y.createElement("h3", { className: "ai-tw-heading-3", ...i }),
      h4: (i) => /* @__PURE__ */ y.createElement("h4", { className: "ai-tw-subtitle-md-bold", ...i }),
      h5: (i) => /* @__PURE__ */ y.createElement("h5", { className: "ai-tw-subtitle-md", ...i }),
      h6: (i) => /* @__PURE__ */ y.createElement("h6", { className: "ai-tw-subtitle-sm", ...i }),
      p: (i) => /* @__PURE__ */ y.createElement("p", { className: "ai-tw-my-2 ai-tw-body-md", ...i }),
      hr: (i) => /* @__PURE__ */ y.createElement(
        "hr",
        {
          className: "ai-tw-my-4 ai-tw-border-stroke-primary ai-tw-bg-stroke-primary",
          ...i
        }
      ),
      a: (i) => /* @__PURE__ */ y.createElement(
        "a",
        {
          className: "ai-tw-text-element-brand ai-tw-underline hover:ai-tw-text-element-brand-dark",
          target: "_blank",
          ...i
        }
      ),
      br: (i) => /* @__PURE__ */ y.createElement("br", { className: "ai-tw-my-2", ...i }),
      blockquote: (i) => /* @__PURE__ */ y.createElement(
        "blockquote",
        {
          className: "ai-tw-my-4 ai-tw-rounded ai-tw-border-l-4 ai-tw-border-stroke-primary ai-tw-bg-container-backdrop ai-tw-p-2 ai-tw-body-md",
          ...i
        }
      ),
      code: ({ inline: i, ...o }) => /* @__PURE__ */ y.createElement(
        "code",
        {
          className: "ai-tw-rounded-sm ai-tw-px-1.5 ai-tw-py-0.5 ai-tw-body-sm",
          ...o
        }
      ),
      em: (i) => /* @__PURE__ */ y.createElement("em", { className: "ai-tw-italic ai-tw-body-md", ...i }),
      img: (i) => /* @__PURE__ */ y.createElement(
        "img",
        {
          className: "ai-tw-mx-auto ai-tw-my-4 ai-tw-rounded-lg ai-tw-shadow-base",
          ...i
        }
      ),
      li: ({ ordered: i, ...o }) => /* @__PURE__ */ y.createElement(
        "li",
        {
          className: le(
            "ai-tw-ml-4 ai-tw-body-md",
            i ? "ai-tw-list-decimal" : "ai-tw-list-disc"
          ),
          ...o
        }
      ),
      ol: ({ ordered: i, ...o }) => /* @__PURE__ */ y.createElement(
        "ol",
        {
          className: "ai-tw-my-2 ai-tw-list-decimal ai-tw-space-y-1 ai-tw-pl-2",
          ...o
        }
      ),
      ul: ({ ordered: i, ...o }) => /* @__PURE__ */ y.createElement(
        "ul",
        {
          className: "ai-tw-my-2 ai-tw-list-disc ai-tw-space-y-1 ai-tw-pl-2",
          ...o
        }
      ),
      pre: (i) => /* @__PURE__ */ y.createElement(
        "pre",
        {
          className: "ai-tw-my-4 ai-tw-overflow-x-auto ai-tw-whitespace-pre-wrap ai-tw-rounded-lg ai-tw-bg-container-backdrop ai-tw-p-4 ai-tw-body-sm",
          ...i
        }
      ),
      strong: (i) => /* @__PURE__ */ y.createElement("strong", { className: "ai-tw-subtitle-md-bold", ...i }),
      del: (i) => /* @__PURE__ */ y.createElement(
        "del",
        {
          className: "ai-tw-text-content-primary-light ai-tw-line-through ai-tw-body-md",
          ...i
        }
      ),
      input: (i) => /* @__PURE__ */ y.createElement("input", { className: "ai-tw-mr-2 ai-tw-accent-element-brand", ...i }),
      table: (i) => /* @__PURE__ */ y.createElement(
        "table",
        {
          className: "ai-tw-my-4 ai-tw-w-full ai-tw-border-collapse ai-tw-border ai-tw-border-stroke-primary",
          ...i
        }
      ),
      tbody: (i) => /* @__PURE__ */ y.createElement(
        "tbody",
        {
          className: "ai-tw-divide-y ai-tw-border-stroke-primary",
          ...i
        }
      ),
      td: ({ isHeader: i, ...o }) => /* @__PURE__ */ y.createElement(
        "td",
        {
          className: "ai-tw-border ai-tw-border-stroke-primary ai-tw-p-2 ai-tw-body-md",
          ...o
        }
      ),
      th: ({ isHeader: i, ...o }) => /* @__PURE__ */ y.createElement(
        "th",
        {
          className: "ai-tw-border ai-tw-border-stroke-primary ai-tw-p-2 ai-tw-text-left ai-tw-subtitle-md-bold",
          ...o
        }
      ),
      thead: (i) => /* @__PURE__ */ y.createElement(
        "thead",
        {
          className: "ai-tw-border-b-2 ai-tw-border-stroke-primary",
          ...i
        }
      ),
      tr: ({ isHeader: i, ...o }) => /* @__PURE__ */ y.createElement(
        "tr",
        {
          className: "ai-tw-border-stroke-primary even:ai-tw-bg-container-backdrop/50",
          ...o
        }
      ),
      ...t
    }),
    [t]
  );
  return /* @__PURE__ */ y.createElement(
    w8,
    {
      remarkPlugins: [Poe, ...e],
      components: r,
      ...n
    }
  );
}
const Aoe = {
  a: $v,
  p: OX,
  img: SX
};
function Tg({
  id: e,
  chatId: t,
  message: n,
  answerLoading: r,
  followUpQuestions: i,
  sources: o,
  metadata: a
}) {
  return /* @__PURE__ */ y.createElement(
    "div",
    {
      className: le(
        "ai-tw-mt-2 ai-tw-rounded-lg ai-tw-bg-container-backdrop ai-tw-p-5"
      )
    },
    /* @__PURE__ */ y.createElement("div", { className: "ai-tw-mb-6" }, /* @__PURE__ */ y.createElement(Sv, { width: 53, height: 10 })),
    r ? /* @__PURE__ */ y.createElement("div", { className: "ai-tw-ml-1 ai-tw-mt-2" }, /* @__PURE__ */ y.createElement(ug, null, /* @__PURE__ */ y.createElement(BJ, null))) : /* @__PURE__ */ y.createElement(ug, null, /* @__PURE__ */ y.createElement(Rl.Provider, { value: { metadata: a, sources: o } }, /* @__PURE__ */ y.createElement(N8, { components: Aoe }, n || ""))),
    e && t ? /* @__PURE__ */ y.createElement(DX, { messageId: e, chatId: t }) : null,
    !r && n ? /* @__PURE__ */ y.createElement(VJ, { sources: o }) : null,
    i ? /* @__PURE__ */ y.createElement(NX, { followUpQuestions: i }) : null
  );
}
function Roe({ children: e }) {
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-my-2 ai-tw-flex ai-tw-items-center ai-tw-rounded-lg ai-tw-bg-red-10 ai-tw-p-4" }, /* @__PURE__ */ y.createElement(
    Ne,
    {
      icon: GR,
      className: "ai-tw-mr-4 ai-tw-grow-0 ai-tw-text-red-60"
    }
  ), /* @__PURE__ */ y.createElement("span", { className: "ai-tw-flex-1 ai-tw-text-sm ai-tw-text-red-60" }, e));
}
function $oe() {
  const { chatState: e } = Re(kt), t = $C(e);
  return t != null && t.length ? /* @__PURE__ */ y.createElement("div", null, t.map((n) => /* @__PURE__ */ y.createElement(Roe, { key: n }, n))) : null;
}
function Ooe() {
  const { chatState: e, isGenerationInProgress: t } = Re(kt);
  if (!Mi(e))
    return t ? /* @__PURE__ */ y.createElement(Tg, { answerLoading: !0 }) : null;
  const r = Tq(e);
  return /* @__PURE__ */ y.createElement(y.Fragment, null, r && /* @__PURE__ */ y.createElement(
    Tg,
    {
      message: r,
      followUpQuestions: _q(e),
      sources: kq(e),
      metadata: Aq(e)
    }
  ), /* @__PURE__ */ y.createElement($oe, null));
}
function I8({ message: e }) {
  return /* @__PURE__ */ y.createElement("div", { className: "ai-tw-ml-auto ai-tw-mt-2 ai-tw-w-max ai-tw-max-w-[75%] ai-tw-rounded-lg ai-tw-bg-element-primary-subtle ai-tw-p-4" }, /* @__PURE__ */ y.createElement(ug, null, e));
}
function Moe() {
  const { chatState: e } = Re(kt), t = Pq(e);
  return t ? /* @__PURE__ */ y.createElement(I8, { message: t }) : null;
}
function Doe({
  transcript: e = [],
  transcriptRef: t,
  generation: n
}) {
  const { disableStreamingAutoScroll: r, isStreamingAutoScrollEnabled: i } = Re(kt), o = oS(n);
  return n !== o && i && NC(t), /* @__PURE__ */ y.createElement(
    "div",
    {
      ref: t,
      onWheel: r,
      className: "ai-tw-flex ai-tw-h-full ai-tw-flex-col ai-tw-overflow-auto ai-tw-px-4 ai-tw-py-2"
    },
    /* @__PURE__ */ y.createElement("div", { className: "ai-tw-mt-auto" }, qj(e).map((a, s) => {
      if (eq(a) === "human") {
        const f = a;
        return /* @__PURE__ */ y.createElement(
          I8,
          {
            key: s,
            message: Jj(f)
          }
        );
      }
      const c = a;
      return /* @__PURE__ */ y.createElement(
        Tg,
        {
          key: s,
          id: Xj(c),
          chatId: Qj(c),
          message: EC(c),
          followUpQuestions: Yj(c),
          sources: Gj(c),
          metadata: Kj(c)
        }
      );
    }), /* @__PURE__ */ y.createElement(Moe, null), /* @__PURE__ */ y.createElement(Ooe, null))
  );
}
function Noe({ children: e, className: t }) {
  return /* @__PURE__ */ y.createElement(
    "div",
    {
      className: le(
        "ai-tw-w-fit ai-tw-rounded ai-tw-bg-element-brand-lightest ai-tw-px-2 ai-tw-py-1 ai-tw-text-content-brand-dark",
        t
      )
    },
    /* @__PURE__ */ y.createElement("p", { className: "ai-tw-capitalize ai-tw-subtitle-sm" }, e)
  );
}
function Ioe({
  releaseNote: e,
  selected: t
}) {
  const n = xK(e);
  return /* @__PURE__ */ y.createElement(
    "div",
    {
      className: le(
        "ai-tw-rounded-lg ai-tw-border ai-tw-border-transparent ai-tw-p-6",
        {
          "ai-tw-border-stroke-brand": t,
          "ai-tw-shadow-md": !t
        }
      )
    },
    /* @__PURE__ */ y.createElement("p", { className: "ai-tw-text-content-primary ai-tw-heading-2" }, aS(e)),
    /* @__PURE__ */ y.createElement("p", { className: "ai-tw-mt-1 ai-tw-text-content-primary-light ai-tw-body-sm" }, id(sS(e))),
    n != null && n.length ? /* @__PURE__ */ y.createElement("ul", { className: "ai-tw-mt-4 ai-tw-flex ai-tw-flex-wrap ai-tw-gap-1" }, n.map((r) => /* @__PURE__ */ y.createElement("li", { key: r }, /* @__PURE__ */ y.createElement(Noe, null, r)))) : null,
    /* @__PURE__ */ y.createElement(N8, { className: "ai-tw-mt-4 ai-tw-text-content-primary" }, EK(e))
  );
}
function Loe({
  className: e,
  selectedReleaseNoteId: t,
  onClose: n
}) {
  const { data: r, isLoading: i } = sd(), o = i || !r ? null : ld(r);
  return /* @__PURE__ */ y.createElement(
    on.div,
    {
      className: le("ai-tw-flex ai-tw-flex-col ai-tw-bg-white", e),
      initial: { opacity: 0, y: 10 },
      animate: { opacity: 1, y: 0 },
      exit: { opacity: 0, y: 10 },
      transition: { duration: 0.2 }
    },
    /* @__PURE__ */ y.createElement("div", { className: "ai-tw-relative ai-tw-border-b ai-tw-border-stroke-primary ai-tw-px-6 ai-tw-py-4" }, /* @__PURE__ */ y.createElement(
      Zo,
      {
        icon: uR,
        className: "ai-tw-absolute ai-tw-left-3 ai-tw-top-1/2 -ai-tw-translate-y-1/2 ai-tw-text-xs ai-tw-text-content-primary-light",
        onClick: n
      }
    ), /* @__PURE__ */ y.createElement("p", { className: "ai-tw-px-4 ai-tw-text-center ai-tw-text-content-primary ai-tw-subtitle-md" }, "What’s New with Gabbi")),
    /* @__PURE__ */ y.createElement("div", { className: "ai-tw-min-h-0 ai-tw-flex-1 ai-tw-overflow-auto ai-tw-px-6 ai-tw-py-2" }, /* @__PURE__ */ y.createElement("p", { className: "ai-tw-text-content-primary-light ai-tw-subtitle-sm" }, "Latest Updates"), i ? /* @__PURE__ */ y.createElement(bn, { size: "small" }) : /* @__PURE__ */ y.createElement("ul", { className: "ai-tw-mt-2 ai-tw-flex ai-tw-flex-col ai-tw-gap-y-2" }, o == null ? void 0 : o.map((a) => /* @__PURE__ */ y.createElement("li", { key: rg(a) }, /* @__PURE__ */ y.createElement(
      Ioe,
      {
        selected: t === rg(a),
        releaseNote: a
      }
    )))))
  );
}
function Foe(e) {
  return /* @__PURE__ */ y.createElement(
    uo,
    {
      fallback: /* @__PURE__ */ y.createElement(
        "div",
        {
          className: le(
            "ai-tw-flex ai-tw-items-center ai-tw-justify-center ai-tw-bg-white",
            e.className
          )
        },
        /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement("p", { className: "ai-tw-text-center ai-tw-text-red-50 ai-tw-subtitle-md" }, "Release notes are currently unavailable. Please try again later."), /* @__PURE__ */ y.createElement(
          Jt,
          {
            size: "sm",
            variant: "tertiary",
            className: "ai-tw-mx-auto ai-tw-mt-4 ai-tw-block ai-tw-w-fit",
            onClick: e.onClose
          },
          "Go Back"
        ))
      )
    },
    /* @__PURE__ */ y.createElement(Loe, { ...e })
  );
}
function y4({ transcriptRef: e }) {
  const [t, n] = ue(), {
    chatState: r,
    chatDispatch: i,
    navigationState: o,
    isGenerationInProgress: a,
    isReleaseNotesOpen: s,
    setIsReleaseNotesOpen: c
  } = Re(kt), f = Al(r), p = Mi(r), d = OC(r), {
    swr: { data: h }
  } = Jf({
    chatId: f,
    enabled: !!f
  }), m = nq(h) || [], v = Eq(o);
  return /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement(wv, null), /* @__PURE__ */ y.createElement(
    "div",
    {
      id: mv,
      className: "ai-tw-relative ai-tw-mx-auto ai-tw-flex ai-tw-w-full ai-tw-max-w-[600px] ai-tw-grow ai-tw-cursor-default ai-tw-flex-col ai-tw-overflow-auto"
    },
    m.length || a || p || f ? /* @__PURE__ */ y.createElement(
      Doe,
      {
        transcript: m,
        generation: p,
        transcriptRef: e
      }
    ) : /* @__PURE__ */ y.createElement(
      NK,
      {
        setSelectedReleaseNoteId: n
      }
    ),
    /* @__PURE__ */ y.createElement(nG, null),
    /* @__PURE__ */ y.createElement(
      Yq,
      {
        isOpen: !!MC(r),
        onClose: () => i({ type: "unselectChatMessageForFeedback" })
      }
    ),
    /* @__PURE__ */ y.createElement(Br, null, s ? /* @__PURE__ */ y.createElement(
      Foe,
      {
        className: "ai-tw-absolute ai-tw-inset-0",
        selectedReleaseNoteId: t,
        onClose: () => {
          c(!1), n(void 0);
        }
      }
    ) : null),
    /* @__PURE__ */ y.createElement(Br, null, !d && v ? /* @__PURE__ */ y.createElement(gK, { className: "ai-tw-inset-x-0 ai-tw-bottom-[41px] ai-tw-top-2 ai-tw-z-10 ai-tw-mx-3" }) : null)
  ), /* @__PURE__ */ y.createElement(Hq, null));
}
var md = { exports: {} }, L8 = {};
const zoe = /* @__PURE__ */ WF(pF);
var qt = {}, ui = {};
Object.defineProperty(ui, "__esModule", {
  value: !0
});
ui.dontSetMe = Woe;
ui.findInArray = Voe;
ui.int = Uoe;
ui.isFunction = Boe;
ui.isNum = Hoe;
function Voe(e, t) {
  for (let n = 0, r = e.length; n < r; n++)
    if (t.apply(t, [e[n], n, e]))
      return e[n];
}
function Boe(e) {
  return typeof e == "function" || Object.prototype.toString.call(e) === "[object Function]";
}
function Hoe(e) {
  return typeof e == "number" && !isNaN(e);
}
function Uoe(e) {
  return parseInt(e, 10);
}
function Woe(e, t, n) {
  if (e[t])
    return new Error("Invalid prop ".concat(t, " passed to ").concat(n, " - do not set this, set it on the child."));
}
var ea = {};
Object.defineProperty(ea, "__esModule", {
  value: !0
});
ea.browserPrefixToKey = z8;
ea.browserPrefixToStyle = joe;
ea.default = void 0;
ea.getPrefix = F8;
const zh = ["Moz", "Webkit", "O", "ms"];
function F8() {
  var e;
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
  if (typeof window > "u")
    return "";
  const n = (e = window.document) === null || e === void 0 || (e = e.documentElement) === null || e === void 0 ? void 0 : e.style;
  if (!n || t in n)
    return "";
  for (let r = 0; r < zh.length; r++)
    if (z8(t, zh[r]) in n)
      return zh[r];
  return "";
}
function z8(e, t) {
  return t ? "".concat(t).concat(qoe(e)) : e;
}
function joe(e, t) {
  return t ? "-".concat(t.toLowerCase(), "-").concat(e) : e;
}
function qoe(e) {
  let t = "", n = !0;
  for (let r = 0; r < e.length; r++)
    n ? (t += e[r].toUpperCase(), n = !1) : e[r] === "-" ? n = !0 : t += e[r];
  return t;
}
ea.default = F8();
Object.defineProperty(qt, "__esModule", {
  value: !0
});
qt.addClassName = H8;
qt.addEvent = Koe;
qt.addUserSelectStyles = aae;
qt.createCSSTransform = nae;
qt.createSVGTransform = rae;
qt.getTouch = iae;
qt.getTouchIdentifier = oae;
qt.getTranslation = Uv;
qt.innerHeight = Joe;
qt.innerWidth = eae;
qt.matchesSelector = B8;
qt.matchesSelectorAndParentsTo = Yoe;
qt.offsetXYFromParent = tae;
qt.outerHeight = Qoe;
qt.outerWidth = Zoe;
qt.removeClassName = U8;
qt.removeEvent = Xoe;
qt.removeUserSelectStyles = sae;
var rr = ui, b4 = Goe(ea);
function V8(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (V8 = function(r) {
    return r ? n : t;
  })(e);
}
function Goe(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = V8(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in e)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
      var a = i ? Object.getOwnPropertyDescriptor(e, o) : null;
      a && (a.get || a.set) ? Object.defineProperty(r, o, a) : r[o] = e[o];
    }
  return r.default = e, n && n.set(e, r), r;
}
let iu = "";
function B8(e, t) {
  return iu || (iu = (0, rr.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(n) {
    return (0, rr.isFunction)(e[n]);
  })), (0, rr.isFunction)(e[iu]) ? e[iu](t) : !1;
}
function Yoe(e, t, n) {
  let r = e;
  do {
    if (B8(r, t))
      return !0;
    if (r === n)
      return !1;
    r = r.parentNode;
  } while (r);
  return !1;
}
function Koe(e, t, n, r) {
  if (!e)
    return;
  const i = {
    capture: !0,
    ...r
  };
  e.addEventListener ? e.addEventListener(t, n, i) : e.attachEvent ? e.attachEvent("on" + t, n) : e["on" + t] = n;
}
function Xoe(e, t, n, r) {
  if (!e)
    return;
  const i = {
    capture: !0,
    ...r
  };
  e.removeEventListener ? e.removeEventListener(t, n, i) : e.detachEvent ? e.detachEvent("on" + t, n) : e["on" + t] = null;
}
function Qoe(e) {
  let t = e.clientHeight;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t += (0, rr.int)(n.borderTopWidth), t += (0, rr.int)(n.borderBottomWidth), t;
}
function Zoe(e) {
  let t = e.clientWidth;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t += (0, rr.int)(n.borderLeftWidth), t += (0, rr.int)(n.borderRightWidth), t;
}
function Joe(e) {
  let t = e.clientHeight;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t -= (0, rr.int)(n.paddingTop), t -= (0, rr.int)(n.paddingBottom), t;
}
function eae(e) {
  let t = e.clientWidth;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t -= (0, rr.int)(n.paddingLeft), t -= (0, rr.int)(n.paddingRight), t;
}
function tae(e, t, n) {
  const i = t === t.ownerDocument.body ? {
    left: 0,
    top: 0
  } : t.getBoundingClientRect(), o = (e.clientX + t.scrollLeft - i.left) / n, a = (e.clientY + t.scrollTop - i.top) / n;
  return {
    x: o,
    y: a
  };
}
function nae(e, t) {
  const n = Uv(e, t, "px");
  return {
    [(0, b4.browserPrefixToKey)("transform", b4.default)]: n
  };
}
function rae(e, t) {
  return Uv(e, t, "");
}
function Uv(e, t, n) {
  let {
    x: r,
    y: i
  } = e, o = "translate(".concat(r).concat(n, ",").concat(i).concat(n, ")");
  if (t) {
    const a = "".concat(typeof t.x == "string" ? t.x : t.x + n), s = "".concat(typeof t.y == "string" ? t.y : t.y + n);
    o = "translate(".concat(a, ", ").concat(s, ")") + o;
  }
  return o;
}
function iae(e, t) {
  return e.targetTouches && (0, rr.findInArray)(e.targetTouches, (n) => t === n.identifier) || e.changedTouches && (0, rr.findInArray)(e.changedTouches, (n) => t === n.identifier);
}
function oae(e) {
  if (e.targetTouches && e.targetTouches[0])
    return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0])
    return e.changedTouches[0].identifier;
}
function aae(e) {
  if (!e)
    return;
  let t = e.getElementById("react-draggable-style-el");
  t || (t = e.createElement("style"), t.type = "text/css", t.id = "react-draggable-style-el", t.innerHTML = `.react-draggable-transparent-selection *::-moz-selection {all: inherit;}
`, t.innerHTML += `.react-draggable-transparent-selection *::selection {all: inherit;}
`, e.getElementsByTagName("head")[0].appendChild(t)), e.body && H8(e.body, "react-draggable-transparent-selection");
}
function sae(e) {
  if (e)
    try {
      if (e.body && U8(e.body, "react-draggable-transparent-selection"), e.selection)
        e.selection.empty();
      else {
        const t = (e.defaultView || window).getSelection();
        t && t.type !== "Caret" && t.removeAllRanges();
      }
    } catch {
    }
}
function H8(e, t) {
  e.classList ? e.classList.add(t) : e.className.match(new RegExp("(?:^|\\s)".concat(t, "(?!\\S)"))) || (e.className += " ".concat(t));
}
function U8(e, t) {
  e.classList ? e.classList.remove(t) : e.className = e.className.replace(new RegExp("(?:^|\\s)".concat(t, "(?!\\S)"), "g"), "");
}
var fi = {};
Object.defineProperty(fi, "__esModule", {
  value: !0
});
fi.canDragX = uae;
fi.canDragY = fae;
fi.createCoreData = pae;
fi.createDraggableData = hae;
fi.getBoundPosition = lae;
fi.getControlPosition = dae;
fi.snapToGrid = cae;
var Jn = ui, Pa = qt;
function lae(e, t, n) {
  if (!e.props.bounds)
    return [t, n];
  let {
    bounds: r
  } = e.props;
  r = typeof r == "string" ? r : mae(r);
  const i = Wv(e);
  if (typeof r == "string") {
    const {
      ownerDocument: o
    } = i, a = o.defaultView;
    let s;
    if (r === "parent" ? s = i.parentNode : s = o.querySelector(r), !(s instanceof a.HTMLElement))
      throw new Error('Bounds selector "' + r + '" could not find an element.');
    const c = s, f = a.getComputedStyle(i), p = a.getComputedStyle(c);
    r = {
      left: -i.offsetLeft + (0, Jn.int)(p.paddingLeft) + (0, Jn.int)(f.marginLeft),
      top: -i.offsetTop + (0, Jn.int)(p.paddingTop) + (0, Jn.int)(f.marginTop),
      right: (0, Pa.innerWidth)(c) - (0, Pa.outerWidth)(i) - i.offsetLeft + (0, Jn.int)(p.paddingRight) - (0, Jn.int)(f.marginRight),
      bottom: (0, Pa.innerHeight)(c) - (0, Pa.outerHeight)(i) - i.offsetTop + (0, Jn.int)(p.paddingBottom) - (0, Jn.int)(f.marginBottom)
    };
  }
  return (0, Jn.isNum)(r.right) && (t = Math.min(t, r.right)), (0, Jn.isNum)(r.bottom) && (n = Math.min(n, r.bottom)), (0, Jn.isNum)(r.left) && (t = Math.max(t, r.left)), (0, Jn.isNum)(r.top) && (n = Math.max(n, r.top)), [t, n];
}
function cae(e, t, n) {
  const r = Math.round(t / e[0]) * e[0], i = Math.round(n / e[1]) * e[1];
  return [r, i];
}
function uae(e) {
  return e.props.axis === "both" || e.props.axis === "x";
}
function fae(e) {
  return e.props.axis === "both" || e.props.axis === "y";
}
function dae(e, t, n) {
  const r = typeof t == "number" ? (0, Pa.getTouch)(e, t) : null;
  if (typeof t == "number" && !r)
    return null;
  const i = Wv(n), o = n.props.offsetParent || i.offsetParent || i.ownerDocument.body;
  return (0, Pa.offsetXYFromParent)(r || e, o, n.props.scale);
}
function pae(e, t, n) {
  const r = !(0, Jn.isNum)(e.lastX), i = Wv(e);
  return r ? {
    node: i,
    deltaX: 0,
    deltaY: 0,
    lastX: t,
    lastY: n,
    x: t,
    y: n
  } : {
    node: i,
    deltaX: t - e.lastX,
    deltaY: n - e.lastY,
    lastX: e.lastX,
    lastY: e.lastY,
    x: t,
    y: n
  };
}
function hae(e, t) {
  const n = e.props.scale;
  return {
    node: t.node,
    x: e.state.x + t.deltaX / n,
    y: e.state.y + t.deltaY / n,
    deltaX: t.deltaX / n,
    deltaY: t.deltaY / n,
    lastX: e.state.x,
    lastY: e.state.y
  };
}
function mae(e) {
  return {
    left: e.left,
    top: e.top,
    right: e.right,
    bottom: e.bottom
  };
}
function Wv(e) {
  const t = e.findDOMNode();
  if (!t)
    throw new Error("<DraggableCore>: Unmounted during event!");
  return t;
}
var gd = {}, vd = {};
Object.defineProperty(vd, "__esModule", {
  value: !0
});
vd.default = gae;
function gae() {
}
Object.defineProperty(gd, "__esModule", {
  value: !0
});
gd.default = void 0;
var Vh = wae(y), Vn = jv(kv), vae = jv(Ag), gn = qt, Gi = fi, Bh = ui, Ns = jv(vd);
function jv(e) {
  return e && e.__esModule ? e : { default: e };
}
function W8(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (W8 = function(r) {
    return r ? n : t;
  })(e);
}
function wae(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = W8(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in e)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
      var a = i ? Object.getOwnPropertyDescriptor(e, o) : null;
      a && (a.get || a.set) ? Object.defineProperty(r, o, a) : r[o] = e[o];
    }
  return r.default = e, n && n.set(e, r), r;
}
function Pn(e, t, n) {
  return t = yae(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function yae(e) {
  var t = bae(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function bae(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const Nr = {
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend"
  },
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  }
};
let Yi = Nr.mouse, wd = class extends Vh.Component {
  constructor() {
    super(...arguments), Pn(this, "dragging", !1), Pn(this, "lastX", NaN), Pn(this, "lastY", NaN), Pn(this, "touchIdentifier", null), Pn(this, "mounted", !1), Pn(this, "handleDragStart", (t) => {
      if (this.props.onMouseDown(t), !this.props.allowAnyClick && typeof t.button == "number" && t.button !== 0)
        return !1;
      const n = this.findDOMNode();
      if (!n || !n.ownerDocument || !n.ownerDocument.body)
        throw new Error("<DraggableCore> not mounted on DragStart!");
      const {
        ownerDocument: r
      } = n;
      if (this.props.disabled || !(t.target instanceof r.defaultView.Node) || this.props.handle && !(0, gn.matchesSelectorAndParentsTo)(t.target, this.props.handle, n) || this.props.cancel && (0, gn.matchesSelectorAndParentsTo)(t.target, this.props.cancel, n))
        return;
      t.type === "touchstart" && t.preventDefault();
      const i = (0, gn.getTouchIdentifier)(t);
      this.touchIdentifier = i;
      const o = (0, Gi.getControlPosition)(t, i, this);
      if (o == null)
        return;
      const {
        x: a,
        y: s
      } = o, c = (0, Gi.createCoreData)(this, a, s);
      (0, Ns.default)("DraggableCore: handleDragStart: %j", c), (0, Ns.default)("calling", this.props.onStart), !(this.props.onStart(t, c) === !1 || this.mounted === !1) && (this.props.enableUserSelectHack && (0, gn.addUserSelectStyles)(r), this.dragging = !0, this.lastX = a, this.lastY = s, (0, gn.addEvent)(r, Yi.move, this.handleDrag), (0, gn.addEvent)(r, Yi.stop, this.handleDragStop));
    }), Pn(this, "handleDrag", (t) => {
      const n = (0, Gi.getControlPosition)(t, this.touchIdentifier, this);
      if (n == null)
        return;
      let {
        x: r,
        y: i
      } = n;
      if (Array.isArray(this.props.grid)) {
        let s = r - this.lastX, c = i - this.lastY;
        if ([s, c] = (0, Gi.snapToGrid)(this.props.grid, s, c), !s && !c)
          return;
        r = this.lastX + s, i = this.lastY + c;
      }
      const o = (0, Gi.createCoreData)(this, r, i);
      if ((0, Ns.default)("DraggableCore: handleDrag: %j", o), this.props.onDrag(t, o) === !1 || this.mounted === !1) {
        try {
          this.handleDragStop(new MouseEvent("mouseup"));
        } catch {
          const c = document.createEvent("MouseEvents");
          c.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), this.handleDragStop(c);
        }
        return;
      }
      this.lastX = r, this.lastY = i;
    }), Pn(this, "handleDragStop", (t) => {
      if (!this.dragging)
        return;
      const n = (0, Gi.getControlPosition)(t, this.touchIdentifier, this);
      if (n == null)
        return;
      let {
        x: r,
        y: i
      } = n;
      if (Array.isArray(this.props.grid)) {
        let c = r - this.lastX || 0, f = i - this.lastY || 0;
        [c, f] = (0, Gi.snapToGrid)(this.props.grid, c, f), r = this.lastX + c, i = this.lastY + f;
      }
      const o = (0, Gi.createCoreData)(this, r, i);
      if (this.props.onStop(t, o) === !1 || this.mounted === !1)
        return !1;
      const s = this.findDOMNode();
      s && this.props.enableUserSelectHack && (0, gn.removeUserSelectStyles)(s.ownerDocument), (0, Ns.default)("DraggableCore: handleDragStop: %j", o), this.dragging = !1, this.lastX = NaN, this.lastY = NaN, s && ((0, Ns.default)("DraggableCore: Removing handlers"), (0, gn.removeEvent)(s.ownerDocument, Yi.move, this.handleDrag), (0, gn.removeEvent)(s.ownerDocument, Yi.stop, this.handleDragStop));
    }), Pn(this, "onMouseDown", (t) => (Yi = Nr.mouse, this.handleDragStart(t))), Pn(this, "onMouseUp", (t) => (Yi = Nr.mouse, this.handleDragStop(t))), Pn(this, "onTouchStart", (t) => (Yi = Nr.touch, this.handleDragStart(t))), Pn(this, "onTouchEnd", (t) => (Yi = Nr.touch, this.handleDragStop(t)));
  }
  componentDidMount() {
    this.mounted = !0;
    const t = this.findDOMNode();
    t && (0, gn.addEvent)(t, Nr.touch.start, this.onTouchStart, {
      passive: !1
    });
  }
  componentWillUnmount() {
    this.mounted = !1;
    const t = this.findDOMNode();
    if (t) {
      const {
        ownerDocument: n
      } = t;
      (0, gn.removeEvent)(n, Nr.mouse.move, this.handleDrag), (0, gn.removeEvent)(n, Nr.touch.move, this.handleDrag), (0, gn.removeEvent)(n, Nr.mouse.stop, this.handleDragStop), (0, gn.removeEvent)(n, Nr.touch.stop, this.handleDragStop), (0, gn.removeEvent)(t, Nr.touch.start, this.onTouchStart, {
        passive: !1
      }), this.props.enableUserSelectHack && (0, gn.removeUserSelectStyles)(n);
    }
  }
  // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
  // the underlying DOM node ourselves. See the README for more information.
  findDOMNode() {
    var t, n;
    return (t = this.props) !== null && t !== void 0 && t.nodeRef ? (n = this.props) === null || n === void 0 || (n = n.nodeRef) === null || n === void 0 ? void 0 : n.current : vae.default.findDOMNode(this);
  }
  render() {
    return /* @__PURE__ */ Vh.cloneElement(Vh.Children.only(this.props.children), {
      // Note: mouseMove handler is attached to document so it will still function
      // when the user drags quickly and leaves the bounds of the element.
      onMouseDown: this.onMouseDown,
      onMouseUp: this.onMouseUp,
      // onTouchStart is added on `componentDidMount` so they can be added with
      // {passive: false}, which allows it to cancel. See
      // https://developers.google.com/web/updates/2017/01/scrolling-intervention
      onTouchEnd: this.onTouchEnd
    });
  }
};
gd.default = wd;
Pn(wd, "displayName", "DraggableCore");
Pn(wd, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: Vn.default.bool,
  children: Vn.default.node.isRequired,
  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: Vn.default.bool,
  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: Vn.default.bool,
  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function(e, t) {
    if (e[t] && e[t].nodeType !== 1)
      throw new Error("Draggable's offsetParent must be a DOM Node.");
  },
  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: Vn.default.arrayOf(Vn.default.number),
  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: Vn.default.string,
  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: Vn.default.string,
  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: Vn.default.object,
  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: Vn.default.func,
  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: Vn.default.func,
  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: Vn.default.func,
  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: Vn.default.func,
  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: Vn.default.number,
  /**
   * These properties should be defined on the child, not here.
   */
  className: Bh.dontSetMe,
  style: Bh.dontSetMe,
  transform: Bh.dontSetMe
});
Pn(wd, "defaultProps", {
  allowAnyClick: !1,
  // by default only accept left click
  disabled: !1,
  enableUserSelectHack: !0,
  onStart: function() {
  },
  onDrag: function() {
  },
  onStop: function() {
  },
  onMouseDown: function() {
  },
  scale: 1
});
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "DraggableCore", {
    enumerable: !0,
    get: function() {
      return c.default;
    }
  }), e.default = void 0;
  var t = h(y), n = p(kv), r = p(Ag), i = p(zoe), o = qt, a = fi, s = ui, c = p(gd), f = p(vd);
  function p(C) {
    return C && C.__esModule ? C : { default: C };
  }
  function d(C) {
    if (typeof WeakMap != "function")
      return null;
    var S = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap();
    return (d = function(T) {
      return T ? _ : S;
    })(C);
  }
  function h(C, S) {
    if (!S && C && C.__esModule)
      return C;
    if (C === null || typeof C != "object" && typeof C != "function")
      return { default: C };
    var _ = d(S);
    if (_ && _.has(C))
      return _.get(C);
    var T = {}, P = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var R in C)
      if (R !== "default" && Object.prototype.hasOwnProperty.call(C, R)) {
        var N = P ? Object.getOwnPropertyDescriptor(C, R) : null;
        N && (N.get || N.set) ? Object.defineProperty(T, R, N) : T[R] = C[R];
      }
    return T.default = C, _ && _.set(C, T), T;
  }
  function m() {
    return m = Object.assign ? Object.assign.bind() : function(C) {
      for (var S = 1; S < arguments.length; S++) {
        var _ = arguments[S];
        for (var T in _)
          Object.prototype.hasOwnProperty.call(_, T) && (C[T] = _[T]);
      }
      return C;
    }, m.apply(this, arguments);
  }
  function v(C, S, _) {
    return S = w(S), S in C ? Object.defineProperty(C, S, { value: _, enumerable: !0, configurable: !0, writable: !0 }) : C[S] = _, C;
  }
  function w(C) {
    var S = b(C, "string");
    return typeof S == "symbol" ? S : String(S);
  }
  function b(C, S) {
    if (typeof C != "object" || C === null)
      return C;
    var _ = C[Symbol.toPrimitive];
    if (_ !== void 0) {
      var T = _.call(C, S || "default");
      if (typeof T != "object")
        return T;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (S === "string" ? String : Number)(C);
  }
  class E extends t.Component {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(S, _) {
      let {
        position: T
      } = S, {
        prevPropsPosition: P
      } = _;
      return T && (!P || T.x !== P.x || T.y !== P.y) ? ((0, f.default)("Draggable: getDerivedStateFromProps %j", {
        position: T,
        prevPropsPosition: P
      }), {
        x: T.x,
        y: T.y,
        prevPropsPosition: {
          ...T
        }
      }) : null;
    }
    constructor(S) {
      super(S), v(this, "onDragStart", (_, T) => {
        if ((0, f.default)("Draggable: onDragStart: %j", T), this.props.onStart(_, (0, a.createDraggableData)(this, T)) === !1)
          return !1;
        this.setState({
          dragging: !0,
          dragged: !0
        });
      }), v(this, "onDrag", (_, T) => {
        if (!this.state.dragging)
          return !1;
        (0, f.default)("Draggable: onDrag: %j", T);
        const P = (0, a.createDraggableData)(this, T), R = {
          x: P.x,
          y: P.y,
          slackX: 0,
          slackY: 0
        };
        if (this.props.bounds) {
          const {
            x: B,
            y: L
          } = R;
          R.x += this.state.slackX, R.y += this.state.slackY;
          const [j, I] = (0, a.getBoundPosition)(this, R.x, R.y);
          R.x = j, R.y = I, R.slackX = this.state.slackX + (B - R.x), R.slackY = this.state.slackY + (L - R.y), P.x = R.x, P.y = R.y, P.deltaX = R.x - this.state.x, P.deltaY = R.y - this.state.y;
        }
        if (this.props.onDrag(_, P) === !1)
          return !1;
        this.setState(R);
      }), v(this, "onDragStop", (_, T) => {
        if (!this.state.dragging || this.props.onStop(_, (0, a.createDraggableData)(this, T)) === !1)
          return !1;
        (0, f.default)("Draggable: onDragStop: %j", T);
        const R = {
          dragging: !1,
          slackX: 0,
          slackY: 0
        };
        if (!!this.props.position) {
          const {
            x: B,
            y: L
          } = this.props.position;
          R.x = B, R.y = L;
        }
        this.setState(R);
      }), this.state = {
        // Whether or not we are currently dragging.
        dragging: !1,
        // Whether or not we have been dragged before.
        dragged: !1,
        // Current transform x and y.
        x: S.position ? S.position.x : S.defaultPosition.x,
        y: S.position ? S.position.y : S.defaultPosition.y,
        prevPropsPosition: {
          ...S.position
        },
        // Used for compensating for out-of-bounds drags
        slackX: 0,
        slackY: 0,
        // Can only determine if SVG after mounting
        isElementSVG: !1
      }, S.position && !(S.onDrag || S.onStop) && console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    componentDidMount() {
      typeof window.SVGElement < "u" && this.findDOMNode() instanceof window.SVGElement && this.setState({
        isElementSVG: !0
      });
    }
    componentWillUnmount() {
      this.setState({
        dragging: !1
      });
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() {
      var S, _;
      return (S = (_ = this.props) === null || _ === void 0 || (_ = _.nodeRef) === null || _ === void 0 ? void 0 : _.current) !== null && S !== void 0 ? S : r.default.findDOMNode(this);
    }
    render() {
      const {
        axis: S,
        bounds: _,
        children: T,
        defaultPosition: P,
        defaultClassName: R,
        defaultClassNameDragging: N,
        defaultClassNameDragged: B,
        position: L,
        positionOffset: j,
        scale: I,
        ...z
      } = this.props;
      let H = {}, G = null;
      const ne = !!!L || this.state.dragging, J = L || P, ee = {
        // Set left if horizontal drag is enabled
        x: (0, a.canDragX)(this) && ne ? this.state.x : J.x,
        // Set top if vertical drag is enabled
        y: (0, a.canDragY)(this) && ne ? this.state.y : J.y
      };
      this.state.isElementSVG ? G = (0, o.createSVGTransform)(ee, j) : H = (0, o.createCSSTransform)(ee, j);
      const A = (0, i.default)(T.props.className || "", R, {
        [N]: this.state.dragging,
        [B]: this.state.dragged
      });
      return /* @__PURE__ */ t.createElement(c.default, m({}, z, {
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop
      }), /* @__PURE__ */ t.cloneElement(t.Children.only(T), {
        className: A,
        style: {
          ...T.props.style,
          ...H
        },
        transform: G
      }));
    }
  }
  e.default = E, v(E, "displayName", "Draggable"), v(E, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ...c.default.propTypes,
    /**
     * `axis` determines which axis the draggable can move.
     *
     *  Note that all callbacks will still return data as normal. This only
     *  controls flushing to the DOM.
     *
     * 'both' allows movement horizontally and vertically.
     * 'x' limits movement to horizontal axis.
     * 'y' limits movement to vertical axis.
     * 'none' limits all movement.
     *
     * Defaults to 'both'.
     */
    axis: n.default.oneOf(["both", "x", "y", "none"]),
    /**
     * `bounds` determines the range of movement available to the element.
     * Available values are:
     *
     * 'parent' restricts movement within the Draggable's parent node.
     *
     * Alternatively, pass an object with the following properties, all of which are optional:
     *
     * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
     *
     * All values are in px.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *         return (
     *            <Draggable bounds={{right: 300, bottom: 300}}>
     *              <div>Content</div>
     *           </Draggable>
     *         );
     *       }
     *   });
     * ```
     */
    bounds: n.default.oneOfType([n.default.shape({
      left: n.default.number,
      right: n.default.number,
      top: n.default.number,
      bottom: n.default.number
    }), n.default.string, n.default.oneOf([!1])]),
    defaultClassName: n.default.string,
    defaultClassNameDragging: n.default.string,
    defaultClassNameDragged: n.default.string,
    /**
     * `defaultPosition` specifies the x and y that the dragged item should start at
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable defaultPosition={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    defaultPosition: n.default.shape({
      x: n.default.number,
      y: n.default.number
    }),
    positionOffset: n.default.shape({
      x: n.default.oneOfType([n.default.number, n.default.string]),
      y: n.default.oneOfType([n.default.number, n.default.string])
    }),
    /**
     * `position`, if present, defines the current position of the element.
     *
     *  This is similar to how form elements in React work - if no `position` is supplied, the component
     *  is uncontrolled.
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable position={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    position: n.default.shape({
      x: n.default.number,
      y: n.default.number
    }),
    /**
     * These properties should be defined on the child, not here.
     */
    className: s.dontSetMe,
    style: s.dontSetMe,
    transform: s.dontSetMe
  }), v(E, "defaultProps", {
    ...c.default.defaultProps,
    axis: "both",
    bounds: !1,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
      x: 0,
      y: 0
    },
    scale: 1
  });
})(L8);
const {
  default: j8,
  DraggableCore: xae
} = L8;
md.exports = j8;
md.exports.default = j8;
md.exports.DraggableCore = xae;
var Eae = md.exports;
const Cae = /* @__PURE__ */ fo(Eae);
var Sae = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Xt = globalThis && globalThis.__assign || function() {
  return Xt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Xt.apply(this, arguments);
}, x4 = {
  width: "100%",
  height: "10px",
  top: "0px",
  left: "0px",
  cursor: "row-resize"
}, E4 = {
  width: "10px",
  height: "100%",
  top: "0px",
  left: "0px",
  cursor: "col-resize"
}, ou = {
  width: "20px",
  height: "20px",
  position: "absolute"
}, _ae = {
  top: Xt(Xt({}, x4), { top: "-5px" }),
  right: Xt(Xt({}, E4), { left: void 0, right: "-5px" }),
  bottom: Xt(Xt({}, x4), { top: void 0, bottom: "-5px" }),
  left: Xt(Xt({}, E4), { left: "-5px" }),
  topRight: Xt(Xt({}, ou), { right: "-10px", top: "-10px", cursor: "ne-resize" }),
  bottomRight: Xt(Xt({}, ou), { right: "-10px", bottom: "-10px", cursor: "se-resize" }),
  bottomLeft: Xt(Xt({}, ou), { left: "-10px", bottom: "-10px", cursor: "sw-resize" }),
  topLeft: Xt(Xt({}, ou), { left: "-10px", top: "-10px", cursor: "nw-resize" })
}, Tae = (
  /** @class */
  function(e) {
    Sae(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.onMouseDown = function(r) {
        n.props.onResizeStart(r, n.props.direction);
      }, n.onTouchStart = function(r) {
        n.props.onResizeStart(r, n.props.direction);
      }, n;
    }
    return t.prototype.render = function() {
      return D.createElement("div", { className: this.props.className || "", style: Xt(Xt({ position: "absolute", userSelect: "none" }, _ae[this.props.direction]), this.props.replaceStyles || {}), onMouseDown: this.onMouseDown, onTouchStart: this.onTouchStart }, this.props.children);
    }, t;
  }(D.PureComponent)
), kae = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), ei = globalThis && globalThis.__assign || function() {
  return ei = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, ei.apply(this, arguments);
}, Pae = {
  width: "auto",
  height: "auto"
}, au = function(e, t, n) {
  return Math.max(Math.min(e, n), t);
}, C4 = function(e, t, n) {
  var r = Math.round(e / t);
  return r * t + n * (r - 1);
}, xa = function(e, t) {
  return new RegExp(e, "i").test(t);
}, su = function(e) {
  return !!(e.touches && e.touches.length);
}, Aae = function(e) {
  return !!((e.clientX || e.clientX === 0) && (e.clientY || e.clientY === 0));
}, S4 = function(e, t, n) {
  n === void 0 && (n = 0);
  var r = t.reduce(function(o, a, s) {
    return Math.abs(a - e) < Math.abs(t[o] - e) ? s : o;
  }, 0), i = Math.abs(t[r] - e);
  return n === 0 || i < n ? t[r] : e;
}, Hh = function(e) {
  return e = e.toString(), e === "auto" || e.endsWith("px") || e.endsWith("%") || e.endsWith("vh") || e.endsWith("vw") || e.endsWith("vmax") || e.endsWith("vmin") ? e : e + "px";
}, lu = function(e, t, n, r) {
  if (e && typeof e == "string") {
    if (e.endsWith("px"))
      return Number(e.replace("px", ""));
    if (e.endsWith("%")) {
      var i = Number(e.replace("%", "")) / 100;
      return t * i;
    }
    if (e.endsWith("vw")) {
      var i = Number(e.replace("vw", "")) / 100;
      return n * i;
    }
    if (e.endsWith("vh")) {
      var i = Number(e.replace("vh", "")) / 100;
      return r * i;
    }
  }
  return e;
}, Rae = function(e, t, n, r, i, o, a) {
  return r = lu(r, e.width, t, n), i = lu(i, e.height, t, n), o = lu(o, e.width, t, n), a = lu(a, e.height, t, n), {
    maxWidth: typeof r > "u" ? void 0 : Number(r),
    maxHeight: typeof i > "u" ? void 0 : Number(i),
    minWidth: typeof o > "u" ? void 0 : Number(o),
    minHeight: typeof a > "u" ? void 0 : Number(a)
  };
}, $ae = function(e) {
  return Array.isArray(e) ? e : [e, e];
}, Oae = [
  "as",
  "ref",
  "style",
  "className",
  "grid",
  "gridGap",
  "snap",
  "bounds",
  "boundsByDirection",
  "size",
  "defaultSize",
  "minWidth",
  "minHeight",
  "maxWidth",
  "maxHeight",
  "lockAspectRatio",
  "lockAspectRatioExtraWidth",
  "lockAspectRatioExtraHeight",
  "enable",
  "handleStyles",
  "handleClasses",
  "handleWrapperStyle",
  "handleWrapperClass",
  "children",
  "onResizeStart",
  "onResize",
  "onResizeStop",
  "handleComponent",
  "scale",
  "resizeRatio",
  "snapGap"
], _4 = "__resizable_base__", Mae = (
  /** @class */
  function(e) {
    kae(t, e);
    function t(n) {
      var r, i, o, a, s = e.call(this, n) || this;
      return s.ratio = 1, s.resizable = null, s.parentLeft = 0, s.parentTop = 0, s.resizableLeft = 0, s.resizableRight = 0, s.resizableTop = 0, s.resizableBottom = 0, s.targetLeft = 0, s.targetTop = 0, s.appendBase = function() {
        if (!s.resizable || !s.window)
          return null;
        var c = s.parentNode;
        if (!c)
          return null;
        var f = s.window.document.createElement("div");
        return f.style.width = "100%", f.style.height = "100%", f.style.position = "absolute", f.style.transform = "scale(0, 0)", f.style.left = "0", f.style.flex = "0 0 100%", f.classList ? f.classList.add(_4) : f.className += _4, c.appendChild(f), f;
      }, s.removeBase = function(c) {
        var f = s.parentNode;
        f && f.removeChild(c);
      }, s.state = {
        isResizing: !1,
        width: (i = (r = s.propsSize) === null || r === void 0 ? void 0 : r.width) !== null && i !== void 0 ? i : "auto",
        height: (a = (o = s.propsSize) === null || o === void 0 ? void 0 : o.height) !== null && a !== void 0 ? a : "auto",
        direction: "right",
        original: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        },
        backgroundStyle: {
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0,0,0,0)",
          cursor: "auto",
          opacity: 0,
          position: "fixed",
          zIndex: 9999,
          top: "0",
          left: "0",
          bottom: "0",
          right: "0"
        },
        flexBasis: void 0
      }, s.onResizeStart = s.onResizeStart.bind(s), s.onMouseMove = s.onMouseMove.bind(s), s.onMouseUp = s.onMouseUp.bind(s), s;
    }
    return Object.defineProperty(t.prototype, "parentNode", {
      get: function() {
        return this.resizable ? this.resizable.parentNode : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "window", {
      get: function() {
        return !this.resizable || !this.resizable.ownerDocument ? null : this.resizable.ownerDocument.defaultView;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "propsSize", {
      get: function() {
        return this.props.size || this.props.defaultSize || Pae;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "size", {
      get: function() {
        var n = 0, r = 0;
        if (this.resizable && this.window) {
          var i = this.resizable.offsetWidth, o = this.resizable.offsetHeight, a = this.resizable.style.position;
          a !== "relative" && (this.resizable.style.position = "relative"), n = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : i, r = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : o, this.resizable.style.position = a;
        }
        return { width: n, height: r };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "sizeStyle", {
      get: function() {
        var n = this, r = this.props.size, i = function(s) {
          var c;
          if (typeof n.state[s] > "u" || n.state[s] === "auto")
            return "auto";
          if (n.propsSize && n.propsSize[s] && (!((c = n.propsSize[s]) === null || c === void 0) && c.toString().endsWith("%"))) {
            if (n.state[s].toString().endsWith("%"))
              return n.state[s].toString();
            var f = n.getParentSize(), p = Number(n.state[s].toString().replace("px", "")), d = p / f[s] * 100;
            return d + "%";
          }
          return Hh(n.state[s]);
        }, o = r && typeof r.width < "u" && !this.state.isResizing ? Hh(r.width) : i("width"), a = r && typeof r.height < "u" && !this.state.isResizing ? Hh(r.height) : i("height");
        return { width: o, height: a };
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getParentSize = function() {
      if (!this.parentNode)
        return this.window ? { width: this.window.innerWidth, height: this.window.innerHeight } : { width: 0, height: 0 };
      var n = this.appendBase();
      if (!n)
        return { width: 0, height: 0 };
      var r = !1, i = this.parentNode.style.flexWrap;
      i !== "wrap" && (r = !0, this.parentNode.style.flexWrap = "wrap"), n.style.position = "relative", n.style.minWidth = "100%", n.style.minHeight = "100%";
      var o = {
        width: n.offsetWidth,
        height: n.offsetHeight
      };
      return r && (this.parentNode.style.flexWrap = i), this.removeBase(n), o;
    }, t.prototype.bindEvents = function() {
      this.window && (this.window.addEventListener("mouseup", this.onMouseUp), this.window.addEventListener("mousemove", this.onMouseMove), this.window.addEventListener("mouseleave", this.onMouseUp), this.window.addEventListener("touchmove", this.onMouseMove, {
        capture: !0,
        passive: !1
      }), this.window.addEventListener("touchend", this.onMouseUp));
    }, t.prototype.unbindEvents = function() {
      this.window && (this.window.removeEventListener("mouseup", this.onMouseUp), this.window.removeEventListener("mousemove", this.onMouseMove), this.window.removeEventListener("mouseleave", this.onMouseUp), this.window.removeEventListener("touchmove", this.onMouseMove, !0), this.window.removeEventListener("touchend", this.onMouseUp));
    }, t.prototype.componentDidMount = function() {
      if (!(!this.resizable || !this.window)) {
        var n = this.window.getComputedStyle(this.resizable);
        this.setState({
          width: this.state.width || this.size.width,
          height: this.state.height || this.size.height,
          flexBasis: n.flexBasis !== "auto" ? n.flexBasis : void 0
        });
      }
    }, t.prototype.componentWillUnmount = function() {
      this.window && this.unbindEvents();
    }, t.prototype.createSizeForCssProperty = function(n, r) {
      var i = this.propsSize && this.propsSize[r];
      return this.state[r] === "auto" && this.state.original[r] === n && (typeof i > "u" || i === "auto") ? "auto" : n;
    }, t.prototype.calculateNewMaxFromBoundary = function(n, r) {
      var i = this.props.boundsByDirection, o = this.state.direction, a = i && xa("left", o), s = i && xa("top", o), c, f;
      if (this.props.bounds === "parent") {
        var p = this.parentNode;
        p && (c = a ? this.resizableRight - this.parentLeft : p.offsetWidth + (this.parentLeft - this.resizableLeft), f = s ? this.resizableBottom - this.parentTop : p.offsetHeight + (this.parentTop - this.resizableTop));
      } else
        this.props.bounds === "window" ? this.window && (c = a ? this.resizableRight : this.window.innerWidth - this.resizableLeft, f = s ? this.resizableBottom : this.window.innerHeight - this.resizableTop) : this.props.bounds && (c = a ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft), f = s ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop));
      return c && Number.isFinite(c) && (n = n && n < c ? n : c), f && Number.isFinite(f) && (r = r && r < f ? r : f), { maxWidth: n, maxHeight: r };
    }, t.prototype.calculateNewSizeFromDirection = function(n, r) {
      var i = this.props.scale || 1, o = $ae(this.props.resizeRatio || 1), a = o[0], s = o[1], c = this.state, f = c.direction, p = c.original, d = this.props, h = d.lockAspectRatio, m = d.lockAspectRatioExtraHeight, v = d.lockAspectRatioExtraWidth, w = p.width, b = p.height, E = m || 0, C = v || 0;
      return xa("right", f) && (w = p.width + (n - p.x) * a / i, h && (b = (w - C) / this.ratio + E)), xa("left", f) && (w = p.width - (n - p.x) * a / i, h && (b = (w - C) / this.ratio + E)), xa("bottom", f) && (b = p.height + (r - p.y) * s / i, h && (w = (b - E) * this.ratio + C)), xa("top", f) && (b = p.height - (r - p.y) * s / i, h && (w = (b - E) * this.ratio + C)), { newWidth: w, newHeight: b };
    }, t.prototype.calculateNewSizeFromAspectRatio = function(n, r, i, o) {
      var a = this.props, s = a.lockAspectRatio, c = a.lockAspectRatioExtraHeight, f = a.lockAspectRatioExtraWidth, p = typeof o.width > "u" ? 10 : o.width, d = typeof i.width > "u" || i.width < 0 ? n : i.width, h = typeof o.height > "u" ? 10 : o.height, m = typeof i.height > "u" || i.height < 0 ? r : i.height, v = c || 0, w = f || 0;
      if (s) {
        var b = (h - v) * this.ratio + w, E = (m - v) * this.ratio + w, C = (p - w) / this.ratio + v, S = (d - w) / this.ratio + v, _ = Math.max(p, b), T = Math.min(d, E), P = Math.max(h, C), R = Math.min(m, S);
        n = au(n, _, T), r = au(r, P, R);
      } else
        n = au(n, p, d), r = au(r, h, m);
      return { newWidth: n, newHeight: r };
    }, t.prototype.setBoundingClientRect = function() {
      var n = 1 / (this.props.scale || 1);
      if (this.props.bounds === "parent") {
        var r = this.parentNode;
        if (r) {
          var i = r.getBoundingClientRect();
          this.parentLeft = i.left * n, this.parentTop = i.top * n;
        }
      }
      if (this.props.bounds && typeof this.props.bounds != "string") {
        var o = this.props.bounds.getBoundingClientRect();
        this.targetLeft = o.left * n, this.targetTop = o.top * n;
      }
      if (this.resizable) {
        var a = this.resizable.getBoundingClientRect(), s = a.left, c = a.top, f = a.right, p = a.bottom;
        this.resizableLeft = s * n, this.resizableRight = f * n, this.resizableTop = c * n, this.resizableBottom = p * n;
      }
    }, t.prototype.onResizeStart = function(n, r) {
      if (!(!this.resizable || !this.window)) {
        var i = 0, o = 0;
        if (n.nativeEvent && Aae(n.nativeEvent) ? (i = n.nativeEvent.clientX, o = n.nativeEvent.clientY) : n.nativeEvent && su(n.nativeEvent) && (i = n.nativeEvent.touches[0].clientX, o = n.nativeEvent.touches[0].clientY), this.props.onResizeStart && this.resizable) {
          var a = this.props.onResizeStart(n, r, this.resizable);
          if (a === !1)
            return;
        }
        this.props.size && (typeof this.props.size.height < "u" && this.props.size.height !== this.state.height && this.setState({ height: this.props.size.height }), typeof this.props.size.width < "u" && this.props.size.width !== this.state.width && this.setState({ width: this.props.size.width })), this.ratio = typeof this.props.lockAspectRatio == "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var s, c = this.window.getComputedStyle(this.resizable);
        if (c.flexBasis !== "auto") {
          var f = this.parentNode;
          if (f) {
            var p = this.window.getComputedStyle(f).flexDirection;
            this.flexDir = p.startsWith("row") ? "row" : "column", s = c.flexBasis;
          }
        }
        this.setBoundingClientRect(), this.bindEvents();
        var d = {
          original: {
            x: i,
            y: o,
            width: this.size.width,
            height: this.size.height
          },
          isResizing: !0,
          backgroundStyle: ei(ei({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(n.target).cursor || "auto" }),
          direction: r,
          flexBasis: s
        };
        this.setState(d);
      }
    }, t.prototype.onMouseMove = function(n) {
      var r = this;
      if (!(!this.state.isResizing || !this.resizable || !this.window)) {
        if (this.window.TouchEvent && su(n))
          try {
            n.preventDefault(), n.stopPropagation();
          } catch {
          }
        var i = this.props, o = i.maxWidth, a = i.maxHeight, s = i.minWidth, c = i.minHeight, f = su(n) ? n.touches[0].clientX : n.clientX, p = su(n) ? n.touches[0].clientY : n.clientY, d = this.state, h = d.direction, m = d.original, v = d.width, w = d.height, b = this.getParentSize(), E = Rae(b, this.window.innerWidth, this.window.innerHeight, o, a, s, c);
        o = E.maxWidth, a = E.maxHeight, s = E.minWidth, c = E.minHeight;
        var C = this.calculateNewSizeFromDirection(f, p), S = C.newHeight, _ = C.newWidth, T = this.calculateNewMaxFromBoundary(o, a);
        this.props.snap && this.props.snap.x && (_ = S4(_, this.props.snap.x, this.props.snapGap)), this.props.snap && this.props.snap.y && (S = S4(S, this.props.snap.y, this.props.snapGap));
        var P = this.calculateNewSizeFromAspectRatio(_, S, { width: T.maxWidth, height: T.maxHeight }, { width: s, height: c });
        if (_ = P.newWidth, S = P.newHeight, this.props.grid) {
          var R = C4(_, this.props.grid[0], this.props.gridGap ? this.props.gridGap[0] : 0), N = C4(S, this.props.grid[1], this.props.gridGap ? this.props.gridGap[1] : 0), B = this.props.snapGap || 0, L = B === 0 || Math.abs(R - _) <= B ? R : _, j = B === 0 || Math.abs(N - S) <= B ? N : S;
          _ = L, S = j;
        }
        var I = {
          width: _ - m.width,
          height: S - m.height
        };
        if (v && typeof v == "string") {
          if (v.endsWith("%")) {
            var z = _ / b.width * 100;
            _ = z + "%";
          } else if (v.endsWith("vw")) {
            var H = _ / this.window.innerWidth * 100;
            _ = H + "vw";
          } else if (v.endsWith("vh")) {
            var G = _ / this.window.innerHeight * 100;
            _ = G + "vh";
          }
        }
        if (w && typeof w == "string") {
          if (w.endsWith("%")) {
            var z = S / b.height * 100;
            S = z + "%";
          } else if (w.endsWith("vw")) {
            var H = S / this.window.innerWidth * 100;
            S = H + "vw";
          } else if (w.endsWith("vh")) {
            var G = S / this.window.innerHeight * 100;
            S = G + "vh";
          }
        }
        var Y = {
          width: this.createSizeForCssProperty(_, "width"),
          height: this.createSizeForCssProperty(S, "height")
        };
        this.flexDir === "row" ? Y.flexBasis = Y.width : this.flexDir === "column" && (Y.flexBasis = Y.height);
        var ne = this.state.width !== Y.width, J = this.state.height !== Y.height, ee = this.state.flexBasis !== Y.flexBasis, A = ne || J || ee;
        A && pf(function() {
          r.setState(Y);
        }), this.props.onResize && A && this.props.onResize(n, h, this.resizable, I);
      }
    }, t.prototype.onMouseUp = function(n) {
      var r, i, o = this.state, a = o.isResizing, s = o.direction, c = o.original;
      if (!(!a || !this.resizable)) {
        var f = {
          width: this.size.width - c.width,
          height: this.size.height - c.height
        };
        this.props.onResizeStop && this.props.onResizeStop(n, s, this.resizable, f), this.props.size && this.setState({ width: (r = this.props.size.width) !== null && r !== void 0 ? r : "auto", height: (i = this.props.size.height) !== null && i !== void 0 ? i : "auto" }), this.unbindEvents(), this.setState({
          isResizing: !1,
          backgroundStyle: ei(ei({}, this.state.backgroundStyle), { cursor: "auto" })
        });
      }
    }, t.prototype.updateSize = function(n) {
      var r, i;
      this.setState({ width: (r = n.width) !== null && r !== void 0 ? r : "auto", height: (i = n.height) !== null && i !== void 0 ? i : "auto" });
    }, t.prototype.renderResizer = function() {
      var n = this, r = this.props, i = r.enable, o = r.handleStyles, a = r.handleClasses, s = r.handleWrapperStyle, c = r.handleWrapperClass, f = r.handleComponent;
      if (!i)
        return null;
      var p = Object.keys(i).map(function(d) {
        return i[d] !== !1 ? D.createElement(Tae, { key: d, direction: d, onResizeStart: n.onResizeStart, replaceStyles: o && o[d], className: a && a[d] }, f && f[d] ? f[d] : null) : null;
      });
      return D.createElement("div", { className: c, style: s }, p);
    }, t.prototype.render = function() {
      var n = this, r = Object.keys(this.props).reduce(function(a, s) {
        return Oae.indexOf(s) !== -1 || (a[s] = n.props[s]), a;
      }, {}), i = ei(ei(ei({ position: "relative", userSelect: this.state.isResizing ? "none" : "auto" }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: "border-box", flexShrink: 0 });
      this.state.flexBasis && (i.flexBasis = this.state.flexBasis);
      var o = this.props.as || "div";
      return D.createElement(
        o,
        ei({ style: i, className: this.props.className }, r, {
          // `ref` is after `extendsProps` to ensure this one wins over a version
          // passed in
          ref: function(a) {
            a && (n.resizable = a);
          }
        }),
        this.state.isResizing && D.createElement("div", { style: this.state.backgroundStyle }),
        this.props.children,
        this.renderResizer()
      );
    }, t.defaultProps = {
      as: "div",
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      enable: {
        top: !0,
        right: !0,
        bottom: !0,
        left: !0,
        topRight: !0,
        bottomRight: !0,
        bottomLeft: !0,
        topLeft: !0
      },
      style: {},
      grid: [1, 1],
      gridGap: [0, 0],
      lockAspectRatio: !1,
      lockAspectRatioExtraWidth: 0,
      lockAspectRatioExtraHeight: 0,
      scale: 1,
      resizeRatio: 1,
      snapGap: 0
    }, t;
  }(D.PureComponent)
);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var kg = function(e, t) {
  return kg = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r)
      r.hasOwnProperty(i) && (n[i] = r[i]);
  }, kg(e, t);
};
function Dae(e, t) {
  kg(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var nn = function() {
  return nn = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, nn.apply(this, arguments);
};
function Nae(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
var Iae = {
  width: "auto",
  height: "auto",
  display: "inline-block",
  position: "absolute",
  top: 0,
  left: 0
}, Lae = function(e) {
  return {
    bottom: e,
    bottomLeft: e,
    bottomRight: e,
    left: e,
    right: e,
    top: e,
    topLeft: e,
    topRight: e
  };
}, Fae = (
  /** @class */
  function(e) {
    Dae(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.resizingPosition = { x: 0, y: 0 }, r.offsetFromParent = { left: 0, top: 0 }, r.resizableElement = { current: null }, r.originalPosition = { x: 0, y: 0 }, r.state = {
        resizing: !1,
        bounds: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
        maxWidth: n.maxWidth,
        maxHeight: n.maxHeight
      }, r.onResizeStart = r.onResizeStart.bind(r), r.onResize = r.onResize.bind(r), r.onResizeStop = r.onResizeStop.bind(r), r.onDragStart = r.onDragStart.bind(r), r.onDrag = r.onDrag.bind(r), r.onDragStop = r.onDragStop.bind(r), r.getMaxSizesFromProps = r.getMaxSizesFromProps.bind(r), r;
    }
    return t.prototype.componentDidMount = function() {
      this.updateOffsetFromParent();
      var n = this.offsetFromParent, r = n.left, i = n.top, o = this.getDraggablePosition(), a = o.x, s = o.y;
      this.draggable.setState({
        x: a - r,
        y: s - i
      }), this.forceUpdate();
    }, t.prototype.getDraggablePosition = function() {
      var n = this.draggable.state, r = n.x, i = n.y;
      return { x: r, y: i };
    }, t.prototype.getParent = function() {
      return this.resizable && this.resizable.parentNode;
    }, t.prototype.getParentSize = function() {
      return this.resizable.getParentSize();
    }, t.prototype.getMaxSizesFromProps = function() {
      var n = typeof this.props.maxWidth > "u" ? Number.MAX_SAFE_INTEGER : this.props.maxWidth, r = typeof this.props.maxHeight > "u" ? Number.MAX_SAFE_INTEGER : this.props.maxHeight;
      return { maxWidth: n, maxHeight: r };
    }, t.prototype.getSelfElement = function() {
      return this.resizable && this.resizable.resizable;
    }, t.prototype.getOffsetHeight = function(n) {
      var r = this.props.scale;
      switch (this.props.bounds) {
        case "window":
          return window.innerHeight / r;
        case "body":
          return document.body.offsetHeight / r;
        default:
          return n.offsetHeight;
      }
    }, t.prototype.getOffsetWidth = function(n) {
      var r = this.props.scale;
      switch (this.props.bounds) {
        case "window":
          return window.innerWidth / r;
        case "body":
          return document.body.offsetWidth / r;
        default:
          return n.offsetWidth;
      }
    }, t.prototype.onDragStart = function(n, r) {
      this.props.onDragStart && this.props.onDragStart(n, r);
      var i = this.getDraggablePosition();
      if (this.originalPosition = i, !!this.props.bounds) {
        var o = this.getParent(), a = this.props.scale, s;
        if (this.props.bounds === "parent")
          s = o;
        else if (this.props.bounds === "body") {
          var c = o.getBoundingClientRect(), f = c.left, p = c.top, d = document.body.getBoundingClientRect(), h = -(f - o.offsetLeft * a - d.left) / a, m = -(p - o.offsetTop * a - d.top) / a, v = (document.body.offsetWidth - this.resizable.size.width * a) / a + h, w = (document.body.offsetHeight - this.resizable.size.height * a) / a + m;
          return this.setState({ bounds: { top: m, right: v, bottom: w, left: h } });
        } else if (this.props.bounds === "window") {
          if (!this.resizable)
            return;
          var b = o.getBoundingClientRect(), E = b.left, C = b.top, S = -(E - o.offsetLeft * a) / a, _ = -(C - o.offsetTop * a) / a, v = (window.innerWidth - this.resizable.size.width * a) / a + S, w = (window.innerHeight - this.resizable.size.height * a) / a + _;
          return this.setState({ bounds: { top: _, right: v, bottom: w, left: S } });
        } else
          typeof this.props.bounds == "string" ? s = document.querySelector(this.props.bounds) : this.props.bounds instanceof HTMLElement && (s = this.props.bounds);
        if (!(!(s instanceof HTMLElement) || !(o instanceof HTMLElement))) {
          var T = s.getBoundingClientRect(), P = T.left, R = T.top, N = o.getBoundingClientRect(), B = N.left, L = N.top, j = (P - B) / a, I = R - L;
          if (this.resizable) {
            this.updateOffsetFromParent();
            var z = this.offsetFromParent;
            this.setState({
              bounds: {
                top: I - z.top,
                right: j + (s.offsetWidth - this.resizable.size.width) - z.left / a,
                bottom: I + (s.offsetHeight - this.resizable.size.height) - z.top,
                left: j - z.left / a
              }
            });
          }
        }
      }
    }, t.prototype.onDrag = function(n, r) {
      if (this.props.onDrag) {
        var i = this.offsetFromParent, o = i.left, a = i.top;
        if (!this.props.dragAxis || this.props.dragAxis === "both")
          return this.props.onDrag(n, nn(nn({}, r), { x: r.x + o, y: r.y + a }));
        if (this.props.dragAxis === "x")
          return this.props.onDrag(n, nn(nn({}, r), { x: r.x + o, y: this.originalPosition.y + a, deltaY: 0 }));
        if (this.props.dragAxis === "y")
          return this.props.onDrag(n, nn(nn({}, r), { x: this.originalPosition.x + o, y: r.y + a, deltaX: 0 }));
      }
    }, t.prototype.onDragStop = function(n, r) {
      if (this.props.onDragStop) {
        var i = this.offsetFromParent, o = i.left, a = i.top;
        if (!this.props.dragAxis || this.props.dragAxis === "both")
          return this.props.onDragStop(n, nn(nn({}, r), { x: r.x + o, y: r.y + a }));
        if (this.props.dragAxis === "x")
          return this.props.onDragStop(n, nn(nn({}, r), { x: r.x + o, y: this.originalPosition.y + a, deltaY: 0 }));
        if (this.props.dragAxis === "y")
          return this.props.onDragStop(n, nn(nn({}, r), { x: this.originalPosition.x + o, y: r.y + a, deltaX: 0 }));
      }
    }, t.prototype.onResizeStart = function(n, r, i) {
      n.stopPropagation(), this.setState({
        resizing: !0
      });
      var o = this.props.scale, a = this.offsetFromParent, s = this.getDraggablePosition();
      if (this.resizingPosition = { x: s.x + a.left, y: s.y + a.top }, this.originalPosition = s, this.props.bounds) {
        var c = this.getParent(), f = void 0;
        this.props.bounds === "parent" ? f = c : this.props.bounds === "body" ? f = document.body : this.props.bounds === "window" ? f = window : typeof this.props.bounds == "string" ? f = document.querySelector(this.props.bounds) : this.props.bounds instanceof HTMLElement && (f = this.props.bounds);
        var p = this.getSelfElement();
        if (p instanceof Element && (f instanceof HTMLElement || f === window) && c instanceof HTMLElement) {
          var d = this.getMaxSizesFromProps(), h = d.maxWidth, m = d.maxHeight, v = this.getParentSize();
          if (h && typeof h == "string")
            if (h.endsWith("%")) {
              var w = Number(h.replace("%", "")) / 100;
              h = v.width * w;
            } else
              h.endsWith("px") && (h = Number(h.replace("px", "")));
          if (m && typeof m == "string")
            if (m.endsWith("%")) {
              var w = Number(m.replace("%", "")) / 100;
              m = v.height * w;
            } else
              m.endsWith("px") && (m = Number(m.replace("px", "")));
          var b = p.getBoundingClientRect(), E = b.left, C = b.top, S = this.props.bounds === "window" ? { left: 0, top: 0 } : f.getBoundingClientRect(), _ = S.left, T = S.top, P = this.getOffsetWidth(f), R = this.getOffsetHeight(f), N = r.toLowerCase().endsWith("left"), B = r.toLowerCase().endsWith("right"), L = r.startsWith("top"), j = r.startsWith("bottom");
          if ((N || L) && this.resizable) {
            var I = (E - _) / o + this.resizable.size.width;
            this.setState({ maxWidth: I > Number(h) ? h : I });
          }
          if (B || this.props.lockAspectRatio && !N && !L) {
            var I = P + (_ - E) / o;
            this.setState({ maxWidth: I > Number(h) ? h : I });
          }
          if ((L || N) && this.resizable) {
            var I = (C - T) / o + this.resizable.size.height;
            this.setState({
              maxHeight: I > Number(m) ? m : I
            });
          }
          if (j || this.props.lockAspectRatio && !L && !N) {
            var I = R + (T - C) / o;
            this.setState({
              maxHeight: I > Number(m) ? m : I
            });
          }
        }
      } else
        this.setState({
          maxWidth: this.props.maxWidth,
          maxHeight: this.props.maxHeight
        });
      this.props.onResizeStart && this.props.onResizeStart(n, r, i);
    }, t.prototype.onResize = function(n, r, i, o) {
      var a = this, s = { x: this.originalPosition.x, y: this.originalPosition.y }, c = -o.width, f = -o.height, p = ["top", "left", "topLeft", "bottomLeft", "topRight"];
      p.includes(r) && (r === "bottomLeft" ? s.x += c : (r === "topRight" || (s.x += c), s.y += f));
      var d = this.draggable.state;
      (s.x !== d.x || s.y !== d.y) && pf(function() {
        a.draggable.setState(s);
      }), this.updateOffsetFromParent();
      var h = this.offsetFromParent, m = this.getDraggablePosition().x + h.left, v = this.getDraggablePosition().y + h.top;
      this.resizingPosition = { x: m, y: v }, this.props.onResize && this.props.onResize(n, r, i, o, {
        x: m,
        y: v
      });
    }, t.prototype.onResizeStop = function(n, r, i, o) {
      this.setState({
        resizing: !1
      });
      var a = this.getMaxSizesFromProps(), s = a.maxWidth, c = a.maxHeight;
      this.setState({ maxWidth: s, maxHeight: c }), this.props.onResizeStop && this.props.onResizeStop(n, r, i, o, this.resizingPosition);
    }, t.prototype.updateSize = function(n) {
      this.resizable && this.resizable.updateSize({ width: n.width, height: n.height });
    }, t.prototype.updatePosition = function(n) {
      this.draggable.setState(n);
    }, t.prototype.updateOffsetFromParent = function() {
      var n = this.props.scale, r = this.getParent(), i = this.getSelfElement();
      if (!r || i === null)
        return {
          top: 0,
          left: 0
        };
      var o = r.getBoundingClientRect(), a = o.left, s = o.top, c = i.getBoundingClientRect(), f = this.getDraggablePosition(), p = r.scrollLeft, d = r.scrollTop;
      this.offsetFromParent = {
        left: c.left - a + p - f.x * n,
        top: c.top - s + d - f.y * n
      };
    }, t.prototype.render = function() {
      var n = this, r = this.props, i = r.disableDragging, o = r.style, a = r.dragHandleClassName, s = r.position, c = r.onMouseDown, f = r.onMouseUp, p = r.dragAxis, d = r.dragGrid, h = r.bounds, m = r.enableUserSelectHack, v = r.cancel, w = r.children;
      r.onResizeStart, r.onResize, r.onResizeStop, r.onDragStart, r.onDrag, r.onDragStop;
      var b = r.resizeHandleStyles, E = r.resizeHandleClasses, C = r.resizeHandleComponent, S = r.enableResizing, _ = r.resizeGrid, T = r.resizeHandleWrapperClass, P = r.resizeHandleWrapperStyle, R = r.scale, N = r.allowAnyClick, B = Nae(r, ["disableDragging", "style", "dragHandleClassName", "position", "onMouseDown", "onMouseUp", "dragAxis", "dragGrid", "bounds", "enableUserSelectHack", "cancel", "children", "onResizeStart", "onResize", "onResizeStop", "onDragStart", "onDrag", "onDragStop", "resizeHandleStyles", "resizeHandleClasses", "resizeHandleComponent", "enableResizing", "resizeGrid", "resizeHandleWrapperClass", "resizeHandleWrapperStyle", "scale", "allowAnyClick"]), L = this.props.default ? nn({}, this.props.default) : void 0;
      delete B.default;
      var j = i || a ? { cursor: "auto" } : { cursor: "move" }, I = nn(nn(nn({}, Iae), j), o), z = this.offsetFromParent, H = z.left, G = z.top, Y;
      s && (Y = {
        x: s.x - H,
        y: s.y - G
      });
      var ne = this.state.resizing ? void 0 : Y, J = this.state.resizing ? "both" : p;
      return K(
        Cae,
        {
          ref: function(ee) {
            ee && (n.draggable = ee);
          },
          handle: a ? ".".concat(a) : void 0,
          defaultPosition: L,
          onMouseDown: c,
          // @ts-expect-error
          onMouseUp: f,
          onStart: this.onDragStart,
          onDrag: this.onDrag,
          onStop: this.onDragStop,
          axis: J,
          disabled: i,
          grid: d,
          bounds: h ? this.state.bounds : void 0,
          position: ne,
          enableUserSelectHack: m,
          cancel: v,
          scale: R,
          allowAnyClick: N,
          nodeRef: this.resizableElement
        },
        K(Mae, nn({}, B, { ref: function(ee) {
          ee && (n.resizable = ee, n.resizableElement.current = ee.resizable);
        }, defaultSize: L, size: this.props.size, enable: typeof S == "boolean" ? Lae(S) : S, onResizeStart: this.onResizeStart, onResize: this.onResize, onResizeStop: this.onResizeStop, style: I, minWidth: this.props.minWidth, minHeight: this.props.minHeight, maxWidth: this.state.resizing ? this.state.maxWidth : this.props.maxWidth, maxHeight: this.state.resizing ? this.state.maxHeight : this.props.maxHeight, grid: _, handleWrapperClass: T, handleWrapperStyle: P, lockAspectRatio: this.props.lockAspectRatio, lockAspectRatioExtraWidth: this.props.lockAspectRatioExtraWidth, lockAspectRatioExtraHeight: this.props.lockAspectRatioExtraHeight, handleStyles: b, handleClasses: E, handleComponent: C, scale: this.props.scale }), w)
      );
    }, t.defaultProps = {
      maxWidth: Number.MAX_SAFE_INTEGER,
      maxHeight: Number.MAX_SAFE_INTEGER,
      scale: 1,
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      onDragStart: function() {
      },
      onDrag: function() {
      },
      onDragStop: function() {
      }
    }, t;
  }(sR)
);
function q8({
  x: e,
  y: t,
  children: n,
  enableResizing: r = !0,
  maxWidth: i,
  minWidth: o,
  minHeight: a,
  size: s,
  setDraggableElement: c,
  handleDragStop: f,
  handleResizeStop: p,
  handleResize: d,
  onClipped: h
}) {
  const { setIsResizing: m } = Re(Ja) || {}, [v, w] = ue(
    null
  );
  _e(() => {
    if (!v || !h)
      return;
    const C = new IntersectionObserver(
      (S) => {
        S.forEach((_) => {
          _.isIntersecting || h == null || h();
        });
      },
      {
        threshold: 1
      }
    );
    return C.observe(v), () => {
      C && C.disconnect();
    };
  }, [v, h]);
  const b = () => {
    m && m(!0);
  }, E = (...C) => {
    p == null || p(...C), m && m(!1);
  };
  return hf(
    // the fixed container allows the draggable element to follow the scroll
    // https://github.com/bokuweb/react-rnd/issues/395#issuecomment-1039422876
    /* @__PURE__ */ y.createElement("div", { className: "ai-tw-pointer-events-none ai-tw-fixed ai-tw-inset-0 ai-tw-z-[5000]" }, /* @__PURE__ */ y.createElement(
      Fae,
      {
        ref: (C) => {
          if (!C)
            return;
          const S = C.resizableElement.current;
          c && c(S), w(S);
        },
        enableResizing: r,
        bounds: "window",
        cancel: Nq,
        maxWidth: i,
        minWidth: o,
        minHeight: a,
        position: {
          x: e,
          y: t
        },
        size: s,
        onDragStop: f,
        onResizeStart: b,
        onResize: d,
        onResizeStop: E,
        className: "ai-tw-pointer-events-auto"
      },
      n
    )),
    document.body
  );
}
function G8({ children: e, className: t }) {
  const { x: n, y: r, width: i, height: o, setX: a, setY: s, setWidth: c, setHeight: f } = Re(Ja) || {}, [p, d] = ue(
    null
  ), h = (b, E) => {
    a && a(E.x), s && s(E.y), window.localStorage.setItem("askPlaceX", String(E.x)), window.localStorage.setItem("askPlaceY", String(E.y));
  }, m = (b, E, C, S, _) => {
    const T = C.getBoundingClientRect();
    window.localStorage.setItem("askPlaceWidth", String(T.width)), window.localStorage.setItem("askPlaceHeight", String(T.height)), window.localStorage.setItem("askPlaceX", String(_.x)), window.localStorage.setItem("askPlaceY", String(_.y));
  }, v = (b, E, C, S, _) => {
    const T = C.getBoundingClientRect();
    a && a(_.x), s && s(_.y), c && c(T.width), f && f(T.height);
  }, w = Me(() => {
    p && (window.innerHeight < p.clientHeight || window.innerWidth < p.clientWidth || (n && n < 0 && a && a(0), r && r < 0 && s && s(0), n && n + p.clientWidth > window.innerWidth && a && a(window.innerWidth - p.clientWidth), r && r + p.clientHeight > window.innerHeight && s && s(window.innerHeight - p.clientHeight)));
  }, [p, a, s, n, r]);
  return /* @__PURE__ */ y.createElement(
    q8,
    {
      x: n,
      y: r,
      maxWidth: Dq,
      minWidth: Mq,
      minHeight: IC,
      size: i && o ? { width: i, height: o } : void 0,
      setDraggableElement: d,
      handleDragStop: h,
      handleResizeStop: m,
      handleResize: v,
      onClipped: w
    },
    /* @__PURE__ */ y.createElement(
      on.div,
      {
        initial: { opacity: 0, scale: 0.5 },
        animate: { opacity: 1, scale: 1 },
        className: t,
        id: nd
      },
      e
    )
  );
}
function zae(e) {
  return e && typeof e == "object" && "message" in e ? e.message : "";
}
function Vae({
  error: e,
  resetErrorBoundary: t,
  onMinimize: n
}) {
  return /* @__PURE__ */ y.createElement(LC, null, /* @__PURE__ */ y.createElement(
    kt.Provider,
    {
      value: {
        ...DC,
        onMinimize: n
      }
    },
    /* @__PURE__ */ y.createElement(G8, { className: "ai-tw-preflight ai-tw-relative ai-tw-mx-auto ai-tw-flex ai-tw-flex-col ai-tw-overflow-hidden ai-tw-rounded-lg ai-tw-bg-container-primary ai-tw-shadow-modal ai-tw-shadow-purple-20" }, /* @__PURE__ */ y.createElement(wv, null), /* @__PURE__ */ y.createElement("div", { className: "ai-tw-flex ai-tw-h-full ai-tw-flex-col ai-tw-items-center ai-tw-justify-center ai-tw-p-8 ai-tw-text-center" }, /* @__PURE__ */ y.createElement("p", { className: "ai-tw-font-semibold ai-tw-text-red-40" }, "Unexpected Error Occurred. Please press Retry or reach out to the support team: ", zae(e), "."), /* @__PURE__ */ y.createElement(
      Jt,
      {
        className: "ai-tw-mt-4",
        variant: "tertiary",
        onClick: t
      },
      "Retry"
    )))
  ));
}
function cu(e) {
  return typeof e == "number" ? Math.max(e, 0) : 0;
}
function Bae({
  children: e,
  className: t,
  offset: n = {}
}) {
  const r = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...n,
    width: n ? `calc(100vw - ${cu(n.left) + cu(n.right)}px)` : "100vw",
    height: n ? `calc(100vh - ${cu(n.top) + cu(n.bottom)}px)` : "100vh"
  };
  return hf(
    /* @__PURE__ */ y.createElement(
      on.div,
      {
        id: nd,
        initial: { opacity: 0, scale: 0.5 },
        animate: { opacity: 1, scale: 1 },
        className: le("ai-tw-fixed ai-tw-bg-white", t),
        style: r
      },
      e
    ),
    document.body
  );
}
const T4 = 12;
function Hae({
  children: e,
  className: t,
  offset: n = {}
}) {
  const [r, i] = ue(
    null
  ), o = window.localStorage.getItem("askPlaceMinimizedX"), a = o ? Number(o) : window.innerWidth, [s, c] = ue(a), f = window.localStorage.getItem("askPlaceMinimizedY"), p = f ? Number(f) : window.innerHeight, [d, h] = ue(p), m = he(n.x || 0), v = he(n.y || 0);
  _e(() => {
    if (!r)
      return;
    const E = window.innerWidth - r.clientWidth - T4 + m.current, C = window.innerHeight - r.clientHeight - T4 + v.current;
    !window.localStorage.getItem("askPlaceMinimizedX") && !window.localStorage.getItem("askPlaceMinimizedY") && (c(E), h(C));
  }, [r]);
  const w = (E, C) => {
    c(C.x), h(C.y), window.localStorage.setItem("askPlaceMinimizedX", String(C.x)), window.localStorage.setItem("askPlaceMinimizedY", String(C.y));
  }, b = Me(() => {
    r && (window.innerHeight < r.clientHeight || window.innerWidth < r.clientWidth || (s < 0 && c(0), d < 0 && h(0), s + r.clientWidth > window.innerWidth && c(window.innerWidth - r.clientWidth), d + r.clientHeight > window.innerHeight && h(window.innerHeight - r.clientHeight)));
  }, [r, c, h, s, d]);
  return /* @__PURE__ */ y.createElement(
    q8,
    {
      x: s,
      y: d,
      setDraggableElement: i,
      enableResizing: !1,
      handleDragStop: w,
      onClipped: b
    },
    /* @__PURE__ */ y.createElement(
      on.div,
      {
        initial: { opacity: 0, scale: 0.5 },
        animate: { opacity: 1, scale: 1 },
        className: t,
        id: nd
      },
      e
    )
  );
}
function Uae() {
  const { setAskPlaceSize: e } = Re(kt);
  return /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement(wv, null), /* @__PURE__ */ y.createElement(
    "div",
    {
      id: mv,
      className: "ai-tw-cursor-default ai-tw-p-4"
    },
    /* @__PURE__ */ y.createElement(
      zC,
      {
        onSubmit: () => {
          e("midsize");
        }
      }
    )
  ));
}
function Wae({
  onMinimize: e,
  defaultX: t,
  defaultY: n,
  leadUuid: r,
  maximized: i = {},
  minimized: o = {},
  notForProduction_accountEmail: a
}) {
  const [s, c] = E2(
    Sq,
    RC
  ), [f, p] = E2(
    xq,
    PC
  ), d = Jm(s), h = Al(s), [
    m,
    v
  ] = ue(null), w = Jm(
    m
  ), { fetchChatById: b } = Jf({
    chatId: h,
    enabled: !!h
  }), { mutate: E } = Pl();
  function C(me) {
    c({
      type: "citationReceived",
      citation: me
    });
  }
  function S(me) {
    c({
      type: "errorMessageReceived",
      message: me
    });
  }
  function _(me) {
    c({ type: "generationTokenReceived", word: me });
  }
  function T(me) {
    c({
      type: "sourceReceived",
      source: me
    });
  }
  function P(me) {
    c({
      type: "followUpQuestionsReceived",
      questions: me
    });
  }
  function R(me) {
    c({
      type: "sourceMetadataReceived",
      metadata: me
    });
  }
  function N(me) {
    c({
      type: "citationMetadataReceived",
      metadata: me
    });
  }
  function B({ chatId: me }) {
    async function Pe() {
      await E(), !h ? await Em(Xu(me), b(me), !1) : await Em(Xu(me));
      const se = $C(d.current);
      if (se != null && se.length)
        return;
      c({
        type: "cleanOptimisticChatState"
      });
      const Le = w.current;
      c({
        type: "selectChat",
        chatId: Le ?? me
      }), v(null);
    }
    if (Rq(d.current)) {
      Iq(() => {
        Lq(), Pe();
      });
      return;
    }
    Pe();
  }
  const {
    isGenerationInProgress: L,
    createSocket: j,
    sendPayload: I,
    startListening: z,
    stopGenerating: H
  } = Lj({
    leadUuid: r,
    notifyCitationReceived: C,
    notifyCitationMetadataReceived: N,
    notifyErrorMessageReceived: S,
    notifyFollowUpQuestionsReceived: P,
    notifyGenerationReceived: B,
    notifyGenerationTokenReceived: _,
    notifySourceReceived: T,
    notifySourceMetadataReceived: R,
    notForProduction_accountEmail: a
  });
  _e(() => () => {
    Nj();
  }, []);
  const [G, Y] = ue(!0);
  function ne() {
    if (L) {
      H(), v(null);
      return;
    }
    c({ type: "createChat" });
  }
  function J(me) {
    if (!(!me || L)) {
      X(), c({
        type: "askQuestion",
        question: me
      }), window.setTimeout(() => NC(fe), 0);
      try {
        const Pe = j();
        Pe.on("connect", () => {
          I({ socket: Pe, question: me, selectedChat: h }), z(Pe);
        });
      } catch (Pe) {
        console.error(Pe, "error occurred");
      }
    }
  }
  function ee(me) {
    if (L) {
      H(), v(me);
      return;
    }
    c({ type: "selectChat", chatId: me });
  }
  function A() {
    Y(!1);
  }
  function X() {
    Y(!0);
  }
  const fe = he(null), M = window.localStorage.getItem(
    "askPlaceSize"
  ), [Z, ie] = ue(
    M || "midsize"
  );
  function pe(me) {
    window.localStorage.setItem("askPlaceSize", me), ie(me);
  }
  const [Te, ke] = ue(!1);
  return /* @__PURE__ */ y.createElement(LC, { defaultX: t, defaultY: n }, /* @__PURE__ */ y.createElement(
    kt.Provider,
    {
      value: {
        askQuestion: J,
        disableStreamingAutoScroll: A,
        allowStreamingAutoScroll: X,
        isStreamingAutoScrollEnabled: G,
        chatState: s,
        chatDispatch: c,
        stopGenerating: H,
        isGenerationInProgress: L,
        selectChat: ee,
        navigationState: f,
        navigationDispatch: p,
        onMinimize: e,
        createNewChat: ne,
        askPlaceSize: Z,
        setAskPlaceSize: pe,
        leadUuid: r,
        isReleaseNotesOpen: Te,
        setIsReleaseNotesOpen: ke
      }
    },
    /* @__PURE__ */ y.createElement(Br, null, Z === "midsize" ? /* @__PURE__ */ y.createElement(G8, { className: "ai-tw-preflight ai-tw-mx-auto ai-tw-flex ai-tw-h-full ai-tw-flex-col ai-tw-overflow-hidden ai-tw-rounded-lg ai-tw-bg-container-primary ai-tw-shadow-modal ai-tw-shadow-purple-20" }, /* @__PURE__ */ y.createElement(y4, { transcriptRef: fe })) : null),
    /* @__PURE__ */ y.createElement(Br, null, Z === "maximized" ? /* @__PURE__ */ y.createElement(
      Bae,
      {
        offset: i.offset,
        className: "ai-tw-preflight ai-tw-z-[999] ai-tw-flex ai-tw-h-full ai-tw-flex-col"
      },
      /* @__PURE__ */ y.createElement(y4, { transcriptRef: fe })
    ) : null),
    /* @__PURE__ */ y.createElement(Br, null, Z === "minimized" ? /* @__PURE__ */ y.createElement(
      Hae,
      {
        offset: o.offset,
        className: "ai-tw-preflight ai-tw-flex ai-tw-w-[340px] ai-tw-flex-col ai-tw-overflow-hidden ai-tw-rounded-xl ai-tw-bg-white ai-tw-shadow-modal ai-tw-shadow-purple-20"
      },
      /* @__PURE__ */ y.createElement(Uae, null)
    ) : null)
  ));
}
function Zse(e) {
  return /* @__PURE__ */ y.createElement(
    uo,
    {
      FallbackComponent: (t) => /* @__PURE__ */ y.createElement(Vae, { ...t, onMinimize: e.onMinimize })
    },
    /* @__PURE__ */ y.createElement(Wae, { ...e })
  );
}
const zo = {
  windows: "Windows",
  macOS: "macOS",
  unknown: "Unknown OS"
};
function jae() {
  if (navigator.userAgentData) {
    const e = navigator.userAgentData.platform;
    return Object.values(zo).includes(e) ? e : zo.unknown;
  } else
    return qae();
}
function qae() {
  const e = navigator.userAgent;
  return /Windows NT/.test(e) ? zo.windows : /Mac OS X/.test(e) ? zo.macOS : zo.unknown;
}
function Gae() {
  const e = jae(), t = e === zo.macOS ? /* @__PURE__ */ y.createElement(GH, { className: "ai-tw-h-3 ai-tw-w-3" }) : e === zo.windows ? "Alt" : "";
  return /* @__PURE__ */ y.createElement("div", null, td, t ? /* @__PURE__ */ y.createElement("div", { className: "ai-tw-ml-1 ai-tw-inline-flex ai-tw-items-center" }, "(", t, " ", /* @__PURE__ */ y.createElement("span", { className: "ai-tw-ml-1" }, "+ P"), ")") : null);
}
function Jse({
  onClick: e,
  isAskPlaceOpen: t,
  showKeyboardShortcutTooltip: n
}) {
  return /* @__PURE__ */ y.createElement(S5, null, /* @__PURE__ */ y.createElement(_5, { asChild: !0 }, /* @__PURE__ */ y.createElement(
    Jt,
    {
      onClick: e,
      variant: "transparent-secondary",
      className: le(
        "ai-tw-rounded-sm !ai-tw-border-[1.5px] ai-tw-border-content-primary !ai-tw-bg-white/10 !ai-tw-px-[14px] !ai-tw-py-[8.5px]",
        {
          "ai-tw-border-purple-20": t,
          "active:ai-tw-border-purple-20 active:!ai-tw-px-[12.5px] active:!ai-tw-py-[7px] active:!ai-tw-border-[3px] hover:ai-tw-border-content-primary-light hover:ai-tw-shadow-md hover:ai-tw-shadow-white/40 hover:!ai-tw-bg-white/20 active:!ai-tw-bg-white/30": !t
        }
      ),
      contentClassName: "ai-tw-flex ai-tw-items-center"
    },
    /* @__PURE__ */ y.createElement("div", { className: "ai-tw-mr-2 ai-tw-flex ai-tw-h-4 ai-tw-w-4 ai-tw-items-center ai-tw-justify-center" }, /* @__PURE__ */ y.createElement(
      Ne,
      {
        icon: t ? $R : Wa,
        className: le({
          "ai-tw-text-[8px] ai-tw-text-purple-20": t
        })
      }
    )),
    /* @__PURE__ */ y.createElement(
      Sv,
      {
        width: 48,
        height: 9,
        pathClassName: le("ai-tw-fill-white", {
          "ai-tw-fill-purple-20": t
        })
      }
    )
  )), /* @__PURE__ */ y.createElement(nV, null, n && !t && /* @__PURE__ */ y.createElement(
    A1,
    {
      side: "bottom",
      className: "ai-tw-w-auto ai-tw-bg-place-black ai-tw-shadow-md ai-tw-shadow-white/40",
      tooltipArrowClassName: "ai-tw-fill-place-black"
    },
    /* @__PURE__ */ y.createElement("span", { className: "ai-tw-body-md" }, /* @__PURE__ */ y.createElement(Gae, null))
  )));
}
function ele({
  setIsAskPlaceOpen: e
}) {
  return _e(() => {
    function t(n) {
      n.code === "KeyP" && n.altKey && e((r) => !r);
    }
    return document.addEventListener("keydown", t), () => document.removeEventListener("keydown", t);
  }, [e]), null;
}
function Ia(e) {
  return !!(e != null && e.insightId);
}
const k4 = "/areapro-external/insights";
function Y8({ addresses: e, mlsIds: t }) {
  const n = xn(), r = Me(async () => n(k4, {
    json: { addresses: e, mlsIds: t },
    method: "POST"
  }), [e, t, n]);
  return jf(k4, r);
}
const qv = ({ className: e }) => /* @__PURE__ */ D.createElement(
  "svg",
  {
    className: le("ai-tw-h-4 ai-tw-w-4 ai-tw-fill-current", e),
    viewBox: "0 0 48 50",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ D.createElement("path", { d: "M35.4712 8.87053C32.7969 7.41478 29.8367 6.56126 26.7979 6.36976C26.3919 3.60419 26.1212 1.80952 26.1212 1.80952C26.0792 1.5007 25.9267 1.21757 25.6919 1.01258C25.4571 0.807596 25.156 0.694641 24.8444 0.694641C24.5327 0.694641 24.2316 0.807596 23.9968 1.01258C23.762 1.21757 23.6095 1.5007 23.5675 1.80952L22.9791 6.43448C14.1528 7.42303 6.11501 13.7485 4.02025 23.0926C3.67667 24.5155 3.48923 25.9716 3.46125 27.4351L0.966357 27.5293C0.734838 27.5478 0.518791 27.6528 0.361244 27.8235C0.203697 27.9941 0.116211 28.2179 0.116211 28.4501C0.116211 28.6824 0.203697 28.9061 0.361244 29.0768C0.518791 29.2474 0.734838 29.3525 0.966357 29.371L3.50244 29.4652C3.73567 32.7786 4.72517 35.9944 6.39496 38.8658C8.06475 41.7372 10.3704 44.1877 13.1348 46.0291C13.3336 46.1406 13.567 46.1731 13.7887 46.1202C14.0103 46.0673 14.2039 45.9328 14.3308 45.7435C14.4577 45.5542 14.5087 45.3241 14.4735 45.099C14.4383 44.8738 14.3196 44.6702 14.141 44.5287C11.6818 42.8379 9.63717 40.6123 8.16056 38.0188C6.68394 35.4253 5.81362 32.5312 5.61486 29.5534L10.2928 29.7182L11.6285 32.7662C11.7027 32.9325 11.8105 33.0816 11.9452 33.2041C12.0799 33.3267 12.2385 33.42 12.4111 33.4782C12.7373 33.5823 13.0914 33.5536 13.3965 33.3983C13.7017 33.243 13.9333 32.9735 14.041 32.6485L14.7118 30.5714L17.8186 48.0592C17.8762 48.3605 18.039 48.6317 18.2778 48.8242C18.5167 49.0167 18.8163 49.1182 19.123 49.1104C19.4297 49.1026 19.7237 48.9862 19.9525 48.7818C20.1814 48.5774 20.3302 48.2983 20.3724 47.9944L24.9503 11.5125L28.5337 35.7789C28.5752 36.0565 28.7058 36.3131 28.9058 36.51C29.1058 36.707 29.3644 36.8336 29.6426 36.8708C29.9208 36.9079 30.2035 36.8537 30.4482 36.7162C30.6929 36.5787 30.8863 36.3654 30.9992 36.1084L32.6527 32.2896C33.7707 35.926 35.1534 39.4977 37.8366 42.4162L37.9014 42.4692L39.0782 43.493C39.4102 43.7662 39.8342 43.902 40.2631 43.8724C40.692 43.8429 41.0934 43.6503 41.3848 43.3342C51.1702 32.8368 48.1928 15.5314 35.4712 8.87053ZM18.8719 39.2329C17.748 32.8074 16.3535 25.0403 16.3535 25.0403C16.304 24.757 16.1617 24.4984 15.9489 24.305C15.7362 24.1116 15.4651 23.9946 15.1785 23.9723C14.8918 23.9501 14.606 24.0239 14.3659 24.1821C14.1259 24.3403 13.9453 24.5739 13.8527 24.8461L12.6288 28.612L12.3346 27.9294V27.8882C12.2357 27.6615 12.0702 27.4702 11.8599 27.3399C11.6497 27.2096 11.4048 27.1463 11.1578 27.1586L5.61486 27.3586C5.67906 26.092 5.87628 24.8357 6.20328 23.6104C7.13307 19.7973 9.21219 16.3621 12.1591 13.7698C15.1061 11.1776 18.7784 9.55354 22.679 9.11767L18.8719 39.2329ZM39.9432 39.8743C38.5524 38.3234 37.4163 36.5618 36.5774 34.655C35.6482 32.53 34.8312 30.3577 34.1296 28.1471C34.0539 27.8935 33.902 27.6694 33.6946 27.5052C33.4871 27.3409 33.234 27.2445 32.9699 27.2291C32.7057 27.2137 32.4432 27.28 32.218 27.4189C31.9928 27.5579 31.8159 27.7628 31.7112 28.0059L30.4284 30.948L27.2039 9.12944C30.5755 9.51834 33.7818 10.8013 36.491 12.8455C39.2002 14.8898 41.3137 17.621 42.6129 20.7564C43.9121 23.8918 44.3496 27.3174 43.8802 30.6787C43.4108 34.04 42.0516 37.2147 39.9432 39.8743Z" })
), K8 = () => /* @__PURE__ */ D.createElement("div", { className: "ai-tw-flex ai-tw-w-max ai-tw-items-center ai-tw-gap-2 ai-tw-p-1 ai-tw-text-stroke-critical-dark" }, /* @__PURE__ */ D.createElement(Ne, { icon: lo }), /* @__PURE__ */ D.createElement("span", null, "Error Loading AreaPro")), ff = ({
  className: e,
  ...t
}) => /* @__PURE__ */ D.createElement(
  Jt,
  {
    variant: "secondary-alt",
    className: le("ai-tw-w-full ai-tw-rounded-lg ai-tw-button-sm", e),
    ...t
  }
), Yae = {
  SMALL: "ai-tw-w-full ai-tw-max-w-xl ai-tw-h-[80vh] sm:ai-tw-h-1/2",
  MEDIUM: "ai-tw-w-full ai-tw-max-w-3xl ai-tw-h-[80vh] sm:ai-tw-h-[60vh]",
  LARGE: "ai-tw-w-full ai-tw-max-w-5xl ai-tw-h-[80vh] sm:ai-tw-h-3/4",
  XLARGE: "ai-tw-w-full ai-tw-max-w-7xl ai-tw-h-[90vh]"
};
function X8({
  show: e,
  onClose: t,
  url: n,
  containerStyle: r
}) {
  const [i, o] = ue("XLARGE");
  return _e(() => {
    const a = (s) => {
      s.data.type === "CLOSE_MODAL" && t && t(), s.data.type === "SET_MODAL_SIZE" && o(s.data.value || "XLARGE");
    };
    return window.addEventListener("message", a), () => {
      window.removeEventListener("message", a);
    };
  }, [t]), e ? /* @__PURE__ */ y.createElement(
    W1,
    {
      onOpenChange: (a) => {
        !a && t && t();
      },
      defaultOpen: !0
    },
    /* @__PURE__ */ y.createElement(
      Wf,
      {
        className: le(
          "ai-tw-z-[1200] ai-tw-flex ai-tw-flex-col ai-tw-p-0 ai-tw-font-lato",
          Yae[i]
        ),
        style: r
      },
      /* @__PURE__ */ y.createElement("div", { className: le("ai-tw-flex-1 ai-tw-overflow-hidden") }, /* @__PURE__ */ y.createElement("iframe", { src: n, className: "ai-tw-h-full ai-tw-w-full" }))
    )
  ) : null;
}
const Q8 = ({
  remoUrl: e,
  activeTabKey: t
}) => {
  try {
    const n = new URL(e);
    return t && n.searchParams.set("activeTab", `${t}`), n;
  } catch {
    return null;
  }
}, Kae = {
  overview: 0,
  insights: 1,
  ai: 2
};
function tle({
  addresses: e,
  children: t,
  style: n,
  tab: r,
  dialogStyle: i
}) {
  var m, v, w, b, E, C, S, _;
  const { trigger: o, data: a, isMutating: s, reset: c } = Y8({
    addresses: e
  }), f = !!(Ia(a) ? ((m = a == null ? void 0 : a.addresses) == null ? void 0 : m.length) > 0 : a != null && a.url), p = Ia(a) ? (b = Object.keys(((w = (v = a == null ? void 0 : a.addresses) == null ? void 0 : v[0]) == null ? void 0 : w.remo) || {})) == null ? void 0 : b[0] : "", d = (Ia(a) ? (_ = (S = (C = (E = a == null ? void 0 : a.addresses) == null ? void 0 : E[0]) == null ? void 0 : C.remo) == null ? void 0 : S[p]) == null ? void 0 : _.url : a == null ? void 0 : a.url) || "", h = Q8({
    remoUrl: d,
    activeTabKey: r ? `${Kae[r] || ""}` : void 0
  });
  return /* @__PURE__ */ D.createElement(uo, { fallback: /* @__PURE__ */ D.createElement(K8, null) }, e != null && e.length ? /* @__PURE__ */ D.createElement(D.Fragment, null, /* @__PURE__ */ D.createElement(
    X8,
    {
      show: f,
      onClose: () => c(),
      url: h == null ? void 0 : h.href,
      containerStyle: i
    }
  ), /* @__PURE__ */ D.createElement(
    ff,
    {
      onClick: () => o(),
      status: s ? "loading" : "default",
      disabled: s,
      style: n
    },
    t
  )) : /* @__PURE__ */ D.createElement("a", { href: "https://app.areapro.com", target: "_blank", rel: "noreferrer" }, /* @__PURE__ */ D.createElement(ff, { style: n }, /* @__PURE__ */ D.createElement("span", { className: "ai-tw-flex ai-tw-items-center ai-tw-justify-center ai-tw-gap-1 ai-tw-uppercase" }, /* @__PURE__ */ D.createElement(qv, null), " Go To AreaPro"))));
}
const Uh = {
  overview: {
    key: "0",
    icon: /* @__PURE__ */ D.createElement(qv, null),
    label: "Area Insights"
  },
  insights: {
    key: "1",
    icon: /* @__PURE__ */ D.createElement(Ne, { icon: wR }),
    label: "Price Range Graphs"
  },
  ai: {
    key: "2",
    icon: /* @__PURE__ */ D.createElement(Ne, { icon: Wa }),
    label: "Rapid AI Insights"
  }
};
function nle({
  addresses: e,
  tabs: t = ["overview", "ai"],
  options: n,
  containerStyle: r,
  buttonStyle: i,
  dialogStyle: o
}) {
  var b, E, C, S, _, T, P, R, N;
  const [a, s] = D.useState("overview"), { trigger: c, data: f, isMutating: p, reset: d } = Y8({
    addresses: e
  }), h = !!(Ia(f) ? ((b = f == null ? void 0 : f.addresses) == null ? void 0 : b.length) > 0 : f != null && f.url), m = Ia(f) ? (S = Object.keys(((C = (E = f == null ? void 0 : f.addresses) == null ? void 0 : E[0]) == null ? void 0 : C.remo) || {})) == null ? void 0 : S[0] : "", v = (Ia(f) ? (R = (P = (T = (_ = f == null ? void 0 : f.addresses) == null ? void 0 : _[0]) == null ? void 0 : T.remo) == null ? void 0 : P[m]) == null ? void 0 : R.url : f == null ? void 0 : f.url) || "";
  let w = null;
  return w = Q8({ remoUrl: v, activeTabKey: (N = Uh[a]) == null ? void 0 : N.key }), /* @__PURE__ */ D.createElement(uo, { fallback: /* @__PURE__ */ D.createElement(K8, null) }, e != null && e.length ? /* @__PURE__ */ D.createElement(D.Fragment, null, /* @__PURE__ */ D.createElement(
    X8,
    {
      show: h,
      onClose: () => {
        d(), s("overview");
      },
      url: w == null ? void 0 : w.href,
      containerStyle: o
    }
  ), /* @__PURE__ */ D.createElement(
    "div",
    {
      className: le("ai-tw-flex ai-tw-flex-col ai-tw-gap-2"),
      style: r
    },
    t.map((B) => {
      var I, z;
      const L = (n == null ? void 0 : n[B]) || ((I = Uh[B]) == null ? void 0 : I.label), j = (z = Uh[B]) == null ? void 0 : z.icon;
      return L ? /* @__PURE__ */ D.createElement(
        ff,
        {
          key: B,
          onClick: () => {
            c(), s(B);
          },
          status: a === B && p ? "loading" : "default",
          disabled: p,
          style: i
        },
        /* @__PURE__ */ D.createElement("span", { className: "ai-tw-flex ai-tw-items-center ai-tw-justify-center ai-tw-gap-1 ai-tw-uppercase" }, j, " ", L)
      ) : null;
    })
  )) : /* @__PURE__ */ D.createElement("a", { href: "https://app.areapro.com", target: "_blank", rel: "noreferrer" }, /* @__PURE__ */ D.createElement(ff, { style: i }, /* @__PURE__ */ D.createElement("span", { className: "ai-tw-flex ai-tw-items-center ai-tw-justify-center ai-tw-gap-1 ai-tw-uppercase" }, /* @__PURE__ */ D.createElement(qv, null), " Go To AreaPro"))));
}
export {
  PM as $,
  Gq as A,
  Jt as B,
  $B as C,
  jq as D,
  K1 as E,
  X1 as F,
  Og as G,
  ose as H,
  Wa as I,
  pR as J,
  SB as K,
  TB as L,
  Ff as M,
  sV as N,
  dK as O,
  yse as P,
  cV as Q,
  Br as R,
  bn as S,
  nK as T,
  rK as U,
  iK as V,
  oK as W,
  L4 as X,
  aK as Y,
  vM as Z,
  de as _,
  iG as a,
  NB as a$,
  gse as a0,
  CM as a1,
  SM as a2,
  cse as a3,
  ase as a4,
  cB as a5,
  $1 as a6,
  If as a7,
  Rg as a8,
  D4 as a9,
  A1 as aA,
  _5 as aB,
  Bm as aC,
  Wse as aD,
  W1 as aE,
  Cse as aF,
  Wf as aG,
  j1 as aH,
  q1 as aI,
  rH as aJ,
  zm as aK,
  Hse as aL,
  N8 as aM,
  dse as aN,
  nse as aO,
  ise as aP,
  tse as aQ,
  Fse as aR,
  lse as aS,
  rv as aT,
  sse as aU,
  $g as aV,
  bW as aW,
  iv as aX,
  RR as aY,
  FY as aZ,
  NY as a_,
  VR as aa,
  Jae as ab,
  pse as ac,
  hse as ad,
  Bse as ae,
  uo as af,
  Mf as ag,
  _l as ah,
  xY as ai,
  ese as aj,
  zse as ak,
  fse as al,
  Gse as am,
  rse as an,
  Vse as ao,
  jse as ap,
  use as aq,
  Yse as ar,
  li as as,
  Lt as at,
  $n as au,
  bH as av,
  J4 as aw,
  WR as ax,
  _t as ay,
  S5 as az,
  jf as b,
  yj as b0,
  gC as b1,
  fC as b2,
  Zm as b3,
  bse as b4,
  xse as b5,
  ju as b6,
  y1 as b7,
  Rse as b8,
  $se as b9,
  Ose as ba,
  Mse as bb,
  Dse as bc,
  Ise as bd,
  Dj as be,
  Lse as bf,
  Nse as bg,
  Zse as bh,
  Jse as bi,
  ele as bj,
  tle as bk,
  nle as bl,
  wse as bm,
  le as c,
  qr as d,
  qq as e,
  HR as f,
  O4 as g,
  F4 as h,
  yR as i,
  C2 as j,
  lo as k,
  Use as l,
  on as m,
  qse as n,
  Kse as o,
  Q1 as p,
  qu as q,
  Vt as r,
  si as s,
  Oi as t,
  xn as u,
  st as v,
  Oe as w,
  ar as x,
  Qa as y,
  Tl as z
};
